/*!
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */
(function (e) {
  const t = (e['en'] = e['en'] || {});
  t.dictionary = Object.assign(t.dictionary || {}, {
    '%0 of %1': '%0 of %1',
    'Align center': 'Align center',
    'Align left': 'Align left',
    'Align right': 'Align right',
    Aquamarine: 'Aquamarine',
    'Austral sign': 'Austral sign',
    Big: 'Big',
    'Bitcoin sign': 'Bitcoin sign',
    Black: 'Black',
    'Block quote': 'Block quote',
    Blue: 'Blue',
    'Blue marker': 'Blue marker',
    Bold: 'Bold',
    'Bulleted List': 'Bulleted List',
    'Bulleted list styles toolbar': 'Bulleted list styles toolbar',
    Cancel: 'Cancel',
    'Cannot upload file:': 'Cannot upload file:',
    'Cedi sign': 'Cedi sign',
    'Cent sign': 'Cent sign',
    'Centered image': 'Centered image',
    'Change image text alternative': 'Change image text alternative',
    'Character categories': 'Character categories',
    'Characters: %0': 'Characters: %0',
    'Choose heading': 'Choose heading',
    Circle: 'Circle',
    Code: 'Code',
    'Colon sign': 'Colon sign',
    'Could not insert image at the current position.':
      'Could not insert image at the current position.',
    'Could not obtain resized image URL.':
      'Could not obtain resized image URL.',
    'Cruzeiro sign': 'Cruzeiro sign',
    'Currency sign': 'Currency sign',
    Decimal: 'Decimal',
    'Decimal with leading zero': 'Decimal with leading zero',
    'Decrease indent': 'Decrease indent',
    Default: 'Default',
    'Dim grey': 'Dim grey',
    Disc: 'Disc',
    'Document colors': 'Document colors',
    'Dollar sign': 'Dollar sign',
    'Dong sign': 'Dong sign',
    Downloadable: 'Downloadable',
    'Drachma sign': 'Drachma sign',
    'Dropdown toolbar': 'Dropdown toolbar',
    'Edit link': 'Edit link',
    'Editor toolbar': 'Editor toolbar',
    'Enter image caption': 'Enter image caption',
    'Euro sign': 'Euro sign',
    'Euro-currency sign': 'Euro-currency sign',
    'Font Background Color': 'Font Background Color',
    'Font Color': 'Font Color',
    'Font Size': 'Font Size',
    'French franc sign': 'French franc sign',
    'Full size image': 'Full size image',
    'German penny sign': 'German penny sign',
    Green: 'Green',
    'Green marker': 'Green marker',
    'Green pen': 'Green pen',
    Grey: 'Grey',
    'Guarani sign': 'Guarani sign',
    Heading: 'Heading',
    'Heading 1': 'Heading 1',
    'Heading 2': 'Heading 2',
    'Heading 3': 'Heading 3',
    'Heading 4': 'Heading 4',
    'Heading 5': 'Heading 5',
    'Heading 6': 'Heading 6',
    Highlight: 'Highlight',
    'Horizontal line': 'Horizontal line',
    'Hryvnia sign': 'Hryvnia sign',
    Huge: 'Huge',
    'Image resize list': 'Image resize list',
    'Image toolbar': 'Image toolbar',
    'image widget': 'image widget',
    'Increase indent': 'Increase indent',
    'Indian rupee sign': 'Indian rupee sign',
    Insert: 'Insert',
    'Insert image': 'Insert image',
    'Insert image or file': 'Insert image or file',
    'Insert image via URL': 'Insert image via URL',
    'Insert media': 'Insert media',
    'Insert paragraph after block': 'Insert paragraph after block',
    'Insert paragraph before block': 'Insert paragraph before block',
    'Inserting image failed': 'Inserting image failed',
    Italic: 'Italic',
    Justify: 'Justify',
    'Kip sign': 'Kip sign',
    'Left aligned image': 'Left aligned image',
    'Light blue': 'Light blue',
    'Light green': 'Light green',
    'Light grey': 'Light grey',
    Link: 'Link',
    'Link URL': 'Link URL',
    'Lira sign': 'Lira sign',
    'Livre tournois sign': 'Livre tournois sign',
    'Lower-latin': 'Lower-latin',
    'Lower–roman': 'Lower–roman',
    'Manat sign': 'Manat sign',
    'Media toolbar': 'Media toolbar',
    'Media URL': 'Media URL',
    'media widget': 'media widget',
    'Mill sign': 'Mill sign',
    'Naira sign': 'Naira sign',
    'New sheqel sign': 'New sheqel sign',
    Next: 'Next',
    'Nordic mark sign': 'Nordic mark sign',
    'Numbered List': 'Numbered List',
    'Numbered list styles toolbar': 'Numbered list styles toolbar',
    'Open in a new tab': 'Open in a new tab',
    'Open link in new tab': 'Open link in new tab',
    Orange: 'Orange',
    Original: 'Original',
    Paragraph: 'Paragraph',
    'Paste the image source URL.': 'Paste the image source URL.',
    'Paste the media URL in the input.': 'Paste the media URL in the input.',
    'Peseta sign': 'Peseta sign',
    'Peso sign': 'Peso sign',
    'Pink marker': 'Pink marker',
    'Pound sign': 'Pound sign',
    Previous: 'Previous',
    Purple: 'Purple',
    Red: 'Red',
    'Red pen': 'Red pen',
    Redo: 'Redo',
    'Remove color': 'Remove color',
    'Remove highlight': 'Remove highlight',
    'Resize image': 'Resize image',
    'Resize image to %0': 'Resize image to %0',
    'Resize image to the original size': 'Resize image to the original size',
    'Rich Text Editor': 'Rich Text Editor',
    'Rich Text Editor, %0': 'Rich Text Editor, %0',
    'Right aligned image': 'Right aligned image',
    'Ruble sign': 'Ruble sign',
    'Rupee sign': 'Rupee sign',
    Save: 'Save',
    'Saving changes': 'Saving changes',
    'Select all': 'Select all',
    'Selecting resized image failed': 'Selecting resized image failed',
    'Show more items': 'Show more items',
    'Side image': 'Side image',
    Small: 'Small',
    'Special characters': 'Special characters',
    'Spesmilo sign': 'Spesmilo sign',
    Square: 'Square',
    Strikethrough: 'Strikethrough',
    Subscript: 'Subscript',
    Superscript: 'Superscript',
    'Tenge sign': 'Tenge sign',
    'Text alignment': 'Text alignment',
    'Text alignment toolbar': 'Text alignment toolbar',
    'Text alternative': 'Text alternative',
    'Text highlight toolbar': 'Text highlight toolbar',
    'The URL must not be empty.': 'The URL must not be empty.',
    'This link has no URL': 'This link has no URL',
    'This media URL is not supported.': 'This media URL is not supported.',
    Tiny: 'Tiny',
    'Tip: Paste the URL into the content to embed faster.':
      'Tip: Paste the URL into the content to embed faster.',
    'Toggle the circle list style': 'Toggle the circle list style',
    'Toggle the decimal list style': 'Toggle the decimal list style',
    'Toggle the decimal with leading zero list style':
      'Toggle the decimal with leading zero list style',
    'Toggle the disc list style': 'Toggle the disc list style',
    'Toggle the lower–latin list style': 'Toggle the lower–latin list style',
    'Toggle the lower–roman list style': 'Toggle the lower–roman list style',
    'Toggle the square list style': 'Toggle the square list style',
    'Toggle the upper–latin list style': 'Toggle the upper–latin list style',
    'Toggle the upper–roman list style': 'Toggle the upper–roman list style',
    'Tugrik sign': 'Tugrik sign',
    'Turkish lira sign': 'Turkish lira sign',
    Turquoise: 'Turquoise',
    Underline: 'Underline',
    Undo: 'Undo',
    Unlink: 'Unlink',
    Update: 'Update',
    'Upload failed': 'Upload failed',
    'Upload in progress': 'Upload in progress',
    'Upper-latin': 'Upper-latin',
    'Upper-roman': 'Upper-roman',
    White: 'White',
    'Widget toolbar': 'Widget toolbar',
    'Won sign': 'Won sign',
    'Words: %0': 'Words: %0',
    Yellow: 'Yellow',
    'Yellow marker': 'Yellow marker',
    'Yen sign': 'Yen sign',
  });
})(window.CKEDITOR_TRANSLATIONS || (window.CKEDITOR_TRANSLATIONS = {}));
(function e(t, i) {
  if (typeof exports === 'object' && typeof module === 'object')
    module.exports = i();
  else if (typeof define === 'function' && define.amd) define([], i);
  else if (typeof exports === 'object') exports['CKSource'] = i();
  else t['CKSource'] = i();
})(window, function () {
  return (function (e) {
    var t = {};
    function i(n) {
      if (t[n]) {
        return t[n].exports;
      }
      var o = (t[n] = { i: n, l: false, exports: {} });
      e[n].call(o.exports, o, o.exports, i);
      o.l = true;
      return o.exports;
    }
    i.m = e;
    i.c = t;
    i.d = function (e, t, n) {
      if (!i.o(e, t)) {
        Object.defineProperty(e, t, { enumerable: true, get: n });
      }
    };
    i.r = function (e) {
      if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
        Object.defineProperty(e, Symbol.toStringTag, { value: 'Module' });
      }
      Object.defineProperty(e, '__esModule', { value: true });
    };
    i.t = function (e, t) {
      if (t & 1) e = i(e);
      if (t & 8) return e;
      if (t & 4 && typeof e === 'object' && e && e.__esModule) return e;
      var n = Object.create(null);
      i.r(n);
      Object.defineProperty(n, 'default', { enumerable: true, value: e });
      if (t & 2 && typeof e != 'string')
        for (var o in e)
          i.d(
            n,
            o,
            function (t) {
              return e[t];
            }.bind(null, o)
          );
      return n;
    };
    i.n = function (e) {
      var t =
        e && e.__esModule
          ? function t() {
              return e['default'];
            }
          : function t() {
              return e;
            };
      i.d(t, 'a', t);
      return t;
    };
    i.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    };
    i.p = '';
    return i((i.s = 122));
  })([
    function (e, t, i) {
      'use strict';
      i.d(t, 'b', function () {
        return o;
      });
      i.d(t, 'a', function () {
        return r;
      });
      const n =
        'https://ckeditor.com/docs/ckeditor5/latest/framework/guides/support/error-codes.html';
      class o extends Error {
        constructor(e, t, i) {
          e = r(e);
          if (i) {
            e += ' ' + JSON.stringify(i);
          }
          super(e);
          this.name = 'CKEditorError';
          this.context = t;
          this.data = i;
        }
        is(e) {
          return e === 'CKEditorError';
        }
        static rethrowUnexpectedError(e, t) {
          if (e.is && e.is('CKEditorError')) {
            throw e;
          }
          const i = new o(e.message, t);
          i.stack = e.stack;
          throw i;
        }
      }
      function r(e) {
        const t = e.match(/^([^:]+):/);
        if (!t) {
          return e;
        }
        return e + ` Read more: ${n}#error-${t[1]}\n`;
      }
    },
    function (e, t, i) {
      'use strict';
      var n = (function e() {
        var t;
        return function e() {
          if (typeof t === 'undefined') {
            t = Boolean(window && document && document.all && !window.atob);
          }
          return t;
        };
      })();
      var o = (function e() {
        var t = {};
        return function e(i) {
          if (typeof t[i] === 'undefined') {
            var n = document.querySelector(i);
            if (
              window.HTMLIFrameElement &&
              n instanceof window.HTMLIFrameElement
            ) {
              try {
                n = n.contentDocument.head;
              } catch (e) {
                n = null;
              }
            }
            t[i] = n;
          }
          return t[i];
        };
      })();
      var r = [];
      function s(e) {
        var t = -1;
        for (var i = 0; i < r.length; i++) {
          if (r[i].identifier === e) {
            t = i;
            break;
          }
        }
        return t;
      }
      function a(e, t) {
        var i = {};
        var n = [];
        for (var o = 0; o < e.length; o++) {
          var a = e[o];
          var c = t.base ? a[0] + t.base : a[0];
          var l = i[c] || 0;
          var d = ''.concat(c, ' ').concat(l);
          i[c] = l + 1;
          var u = s(d);
          var h = { css: a[1], media: a[2], sourceMap: a[3] };
          if (u !== -1) {
            r[u].references++;
            r[u].updater(h);
          } else {
            r.push({ identifier: d, updater: m(h, t), references: 1 });
          }
          n.push(d);
        }
        return n;
      }
      function c(e) {
        var t = document.createElement('style');
        var n = e.attributes || {};
        if (typeof n.nonce === 'undefined') {
          var r = true ? i.nc : undefined;
          if (r) {
            n.nonce = r;
          }
        }
        Object.keys(n).forEach(function (e) {
          t.setAttribute(e, n[e]);
        });
        if (typeof e.insert === 'function') {
          e.insert(t);
        } else {
          var s = o(e.insert || 'head');
          if (!s) {
            throw new Error(
              "Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid."
            );
          }
          s.appendChild(t);
        }
        return t;
      }
      function l(e) {
        if (e.parentNode === null) {
          return false;
        }
        e.parentNode.removeChild(e);
      }
      var d = (function e() {
        var t = [];
        return function e(i, n) {
          t[i] = n;
          return t.filter(Boolean).join('\n');
        };
      })();
      function u(e, t, i, n) {
        var o = i
          ? ''
          : n.media
          ? '@media '.concat(n.media, ' {').concat(n.css, '}')
          : n.css;
        if (e.styleSheet) {
          e.styleSheet.cssText = d(t, o);
        } else {
          var r = document.createTextNode(o);
          var s = e.childNodes;
          if (s[t]) {
            e.removeChild(s[t]);
          }
          if (s.length) {
            e.insertBefore(r, s[t]);
          } else {
            e.appendChild(r);
          }
        }
      }
      function h(e, t, i) {
        var n = i.css;
        var o = i.media;
        var r = i.sourceMap;
        if (o) {
          e.setAttribute('media', o);
        } else {
          e.removeAttribute('media');
        }
        if (r && btoa) {
          n += '\n/*# sourceMappingURL=data:application/json;base64,'.concat(
            btoa(unescape(encodeURIComponent(JSON.stringify(r)))),
            ' */'
          );
        }
        if (e.styleSheet) {
          e.styleSheet.cssText = n;
        } else {
          while (e.firstChild) {
            e.removeChild(e.firstChild);
          }
          e.appendChild(document.createTextNode(n));
        }
      }
      var f = null;
      var g = 0;
      function m(e, t) {
        var i;
        var n;
        var o;
        if (t.singleton) {
          var r = g++;
          i = f || (f = c(t));
          n = u.bind(null, i, r, false);
          o = u.bind(null, i, r, true);
        } else {
          i = c(t);
          n = h.bind(null, i, t);
          o = function e() {
            l(i);
          };
        }
        n(e);
        return function t(i) {
          if (i) {
            if (
              i.css === e.css &&
              i.media === e.media &&
              i.sourceMap === e.sourceMap
            ) {
              return;
            }
            n((e = i));
          } else {
            o();
          }
        };
      }
      e.exports = function (e, t) {
        t = t || {};
        if (!t.singleton && typeof t.singleton !== 'boolean') {
          t.singleton = n();
        }
        e = e || [];
        var i = a(e, t);
        return function e(n) {
          n = n || [];
          if (Object.prototype.toString.call(n) !== '[object Array]') {
            return;
          }
          for (var o = 0; o < i.length; o++) {
            var c = i[o];
            var l = s(c);
            r[l].references--;
          }
          var d = a(n, t);
          for (var u = 0; u < i.length; u++) {
            var h = i[u];
            var f = s(h);
            if (r[f].references === 0) {
              r[f].updater();
              r.splice(f, 1);
            }
          }
          i = d;
        };
      };
    },
    ,
    function (e, t, i) {
      'use strict';
      var n = i(7);
      var o = typeof self == 'object' && self && self.Object === Object && self;
      var r = n['a'] || o || Function('return this')();
      t['a'] = r;
    },
    function (e, t, i) {
      'use strict';
      (function (e) {
        var n = i(3);
        var o = i(13);
        var r =
          typeof exports == 'object' && exports && !exports.nodeType && exports;
        var s = r && typeof e == 'object' && e && !e.nodeType && e;
        var a = s && s.exports === r;
        var c = a ? n['a'].Buffer : undefined;
        var l = c ? c.isBuffer : undefined;
        var d = l || o['a'];
        t['a'] = d;
      }).call(this, i(9)(e));
    },
    function (e, t, i) {
      'use strict';
      (function (e) {
        var n = i(7);
        var o =
          typeof exports == 'object' && exports && !exports.nodeType && exports;
        var r = o && typeof e == 'object' && e && !e.nodeType && e;
        var s = r && r.exports === o;
        var a = s && n['a'].process;
        var c = (function () {
          try {
            var e = r && r.require && r.require('util').types;
            if (e) {
              return e;
            }
            return a && a.binding && a.binding('util');
          } catch (e) {}
        })();
        t['a'] = c;
      }).call(this, i(9)(e));
    },
    function (e, t, i) {
      'use strict';
      (function (e) {
        var t = i(0);
        const n = '22.0.0';
        const o = typeof window === 'object' ? window : e;
        if (o.CKEDITOR_VERSION) {
          throw new t['b'](
            'ckeditor-duplicated-modules: Some CKEditor 5 modules are duplicated.',
            null
          );
        } else {
          o.CKEDITOR_VERSION = n;
        }
      }).call(this, i(10));
    },
    function (e, t, i) {
      'use strict';
      (function (e) {
        var i = typeof e == 'object' && e && e.Object === Object && e;
        t['a'] = i;
      }).call(this, i(10));
    },
    function (e, t, i) {
      'use strict';
      (function (e) {
        var n = i(3);
        var o =
          typeof exports == 'object' && exports && !exports.nodeType && exports;
        var r = o && typeof e == 'object' && e && !e.nodeType && e;
        var s = r && r.exports === o;
        var a = s ? n['a'].Buffer : undefined,
          c = a ? a.allocUnsafe : undefined;
        function l(e, t) {
          if (t) {
            return e.slice();
          }
          var i = e.length,
            n = c ? c(i) : new e.constructor(i);
          e.copy(n);
          return n;
        }
        t['a'] = l;
      }).call(this, i(9)(e));
    },
    function (e, t) {
      e.exports = function (e) {
        if (!e.webpackPolyfill) {
          var t = Object.create(e);
          if (!t.children) t.children = [];
          Object.defineProperty(t, 'loaded', {
            enumerable: true,
            get: function () {
              return t.l;
            },
          });
          Object.defineProperty(t, 'id', {
            enumerable: true,
            get: function () {
              return t.i;
            },
          });
          Object.defineProperty(t, 'exports', { enumerable: true });
          t.webpackPolyfill = 1;
        }
        return t;
      };
    },
    function (e, t) {
      var i;
      i = (function () {
        return this;
      })();
      try {
        i = i || new Function('return this')();
      } catch (e) {
        if (typeof window === 'object') i = window;
      }
      e.exports = i;
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(50);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(57);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t, i) {
      'use strict';
      function n() {
        return false;
      }
      t['a'] = n;
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(15);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck.ck-placeholder:before,.ck .ck-placeholder:before{content:attr(data-placeholder);pointer-events:none}.ck.ck-read-only .ck-placeholder:before{display:none}.ck.ck-placeholder:before,.ck .ck-placeholder:before{cursor:text;color:var(--ck-color-engine-placeholder-text)}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(17);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck-hidden{display:none!important}.ck.ck-reset,.ck.ck-reset_all,.ck.ck-reset_all *{box-sizing:border-box;width:auto;height:auto;position:static}:root{--ck-z-default:1;--ck-z-modal:calc(var(--ck-z-default) + 999);--ck-color-base-foreground:#fafafa;--ck-color-base-background:#fff;--ck-color-base-border:#c4c4c4;--ck-color-base-action:#61b045;--ck-color-base-focus:#6cb5f9;--ck-color-base-text:#333;--ck-color-base-active:#198cf0;--ck-color-base-active-focus:#0e7fe1;--ck-color-base-error:#db3700;--ck-color-focus-border-coordinates:208,79%,51%;--ck-color-focus-border:hsl(var(--ck-color-focus-border-coordinates));--ck-color-focus-outer-shadow:#bcdefb;--ck-color-focus-disabled-shadow:rgba(119,186,248,0.3);--ck-color-focus-error-shadow:rgba(255,64,31,0.3);--ck-color-text:var(--ck-color-base-text);--ck-color-shadow-drop:rgba(0,0,0,0.15);--ck-color-shadow-drop-active:rgba(0,0,0,0.2);--ck-color-shadow-inner:rgba(0,0,0,0.1);--ck-color-button-default-background:transparent;--ck-color-button-default-hover-background:#e6e6e6;--ck-color-button-default-active-background:#d9d9d9;--ck-color-button-default-active-shadow:#bfbfbf;--ck-color-button-default-disabled-background:transparent;--ck-color-button-on-background:#dedede;--ck-color-button-on-hover-background:#c4c4c4;--ck-color-button-on-active-background:#bababa;--ck-color-button-on-active-shadow:#a1a1a1;--ck-color-button-on-disabled-background:#dedede;--ck-color-button-action-background:var(--ck-color-base-action);--ck-color-button-action-hover-background:#579e3d;--ck-color-button-action-active-background:#53973b;--ck-color-button-action-active-shadow:#498433;--ck-color-button-action-disabled-background:#7ec365;--ck-color-button-action-text:var(--ck-color-base-background);--ck-color-button-save:#008a00;--ck-color-button-cancel:#db3700;--ck-color-switch-button-off-background:#b0b0b0;--ck-color-switch-button-off-hover-background:#a3a3a3;--ck-color-switch-button-on-background:var(--ck-color-button-action-background);--ck-color-switch-button-on-hover-background:#579e3d;--ck-color-switch-button-inner-background:var(--ck-color-base-background);--ck-color-switch-button-inner-shadow:rgba(0,0,0,0.1);--ck-color-dropdown-panel-background:var(--ck-color-base-background);--ck-color-dropdown-panel-border:var(--ck-color-base-border);--ck-color-input-background:var(--ck-color-base-background);--ck-color-input-border:#c7c7c7;--ck-color-input-error-border:var(--ck-color-base-error);--ck-color-input-text:var(--ck-color-base-text);--ck-color-input-disabled-background:#f2f2f2;--ck-color-input-disabled-border:#c7c7c7;--ck-color-input-disabled-text:#5c5c5c;--ck-color-list-background:var(--ck-color-base-background);--ck-color-list-button-hover-background:var(--ck-color-button-default-hover-background);--ck-color-list-button-on-background:var(--ck-color-base-active);--ck-color-list-button-on-background-focus:var(--ck-color-base-active-focus);--ck-color-list-button-on-text:var(--ck-color-base-background);--ck-color-panel-background:var(--ck-color-base-background);--ck-color-panel-border:var(--ck-color-base-border);--ck-color-toolbar-background:var(--ck-color-base-foreground);--ck-color-toolbar-border:var(--ck-color-base-border);--ck-color-tooltip-background:var(--ck-color-base-text);--ck-color-tooltip-text:var(--ck-color-base-background);--ck-color-engine-placeholder-text:#707070;--ck-color-upload-bar-background:#6cb5f9;--ck-color-link-default:#0000f0;--ck-color-link-selected-background:rgba(31,177,255,0.1);--ck-color-link-fake-selection:rgba(31,177,255,0.3);--ck-disabled-opacity:.5;--ck-focus-outer-shadow-geometry:0 0 0 3px;--ck-focus-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-outer-shadow);--ck-focus-disabled-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-disabled-shadow);--ck-focus-error-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-error-shadow);--ck-focus-ring:1px solid var(--ck-color-focus-border);--ck-font-size-base:13px;--ck-line-height-base:1.84615;--ck-font-face:Helvetica,Arial,Tahoma,Verdana,Sans-Serif;--ck-font-size-tiny:0.7em;--ck-font-size-small:0.75em;--ck-font-size-normal:1em;--ck-font-size-big:1.4em;--ck-font-size-large:1.8em;--ck-ui-component-min-height:2.3em}.ck.ck-reset,.ck.ck-reset_all,.ck.ck-reset_all *{margin:0;padding:0;border:0;background:transparent;text-decoration:none;vertical-align:middle;transition:none;word-wrap:break-word}.ck.ck-reset_all,.ck.ck-reset_all *{border-collapse:collapse;font:normal normal normal var(--ck-font-size-base)/var(--ck-line-height-base) var(--ck-font-face);color:var(--ck-color-text);text-align:left;white-space:nowrap;cursor:auto;float:none}.ck.ck-reset_all .ck-rtl *{text-align:right}.ck.ck-reset_all iframe{vertical-align:inherit}.ck.ck-reset_all textarea{white-space:pre-wrap}.ck.ck-reset_all input[type=password],.ck.ck-reset_all input[type=text],.ck.ck-reset_all textarea{cursor:text}.ck.ck-reset_all input[type=password][disabled],.ck.ck-reset_all input[type=text][disabled],.ck.ck-reset_all textarea[disabled]{cursor:default}.ck.ck-reset_all fieldset{padding:10px;border:2px groove #dfdee3}.ck.ck-reset_all button::-moz-focus-inner{padding:0;border:0}.ck[dir=rtl],.ck[dir=rtl] .ck{text-align:right}:root{--ck-border-radius:2px;--ck-inner-shadow:2px 2px 3px var(--ck-color-shadow-inner) inset;--ck-drop-shadow:0 1px 2px 1px var(--ck-color-shadow-drop);--ck-drop-shadow-active:0 3px 6px 1px var(--ck-color-shadow-drop-active);--ck-spacing-unit:0.6em;--ck-spacing-large:calc(var(--ck-spacing-unit)*1.5);--ck-spacing-standard:var(--ck-spacing-unit);--ck-spacing-medium:calc(var(--ck-spacing-unit)*0.8);--ck-spacing-small:calc(var(--ck-spacing-unit)*0.5);--ck-spacing-tiny:calc(var(--ck-spacing-unit)*0.3);--ck-spacing-extra-tiny:calc(var(--ck-spacing-unit)*0.16)}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(19);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        ':root{--ck-color-editable-blur-selection:#d9d9d9}.ck.ck-editor__editable:not(.ck-editor__nested-editable){border-radius:0}.ck-rounded-corners .ck.ck-editor__editable:not(.ck-editor__nested-editable),.ck.ck-editor__editable:not(.ck-editor__nested-editable).ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-editor__editable:not(.ck-editor__nested-editable).ck-focused{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0}.ck.ck-editor__editable_inline{overflow:auto;padding:0 var(--ck-spacing-standard);border:1px solid transparent}.ck.ck-editor__editable_inline[dir=ltr]{text-align:left}.ck.ck-editor__editable_inline[dir=rtl]{text-align:right}.ck.ck-editor__editable_inline>:first-child{margin-top:var(--ck-spacing-large)}.ck.ck-editor__editable_inline>:last-child{margin-bottom:var(--ck-spacing-large)}.ck.ck-editor__editable_inline.ck-blurred ::selection{background:var(--ck-color-editable-blur-selection)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_n]:after{border-bottom-color:var(--ck-color-base-foreground)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_s]:after{border-top-color:var(--ck-color-base-foreground)}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(21);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck.ck-label{display:block}.ck.ck-voice-label{display:none}.ck.ck-label{font-weight:700}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(23);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck.ck-sticky-panel .ck-sticky-panel__content_sticky{z-index:var(--ck-z-modal);position:fixed;top:0}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky_bottom-limit{top:auto;position:absolute}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky{box-shadow:var(--ck-drop-shadow),0 0;border-width:0 1px 1px;border-top-left-radius:0;border-top-right-radius:0}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(25);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck.ck-dropdown{display:inline-block;position:relative}.ck.ck-dropdown .ck-dropdown__arrow{pointer-events:none;z-index:var(--ck-z-default)}.ck.ck-dropdown .ck-button.ck-dropdown__button{width:100%}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on .ck-tooltip{display:none}.ck.ck-dropdown .ck-dropdown__panel{-webkit-backface-visibility:hidden;display:none;z-index:var(--ck-z-modal);position:absolute}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel-visible{display:inline-block}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw{bottom:100%}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{top:100%;bottom:auto}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se{left:0}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{right:0}.ck.ck-toolbar .ck-dropdown__panel{z-index:calc(var(--ck-z-modal) + 1)}:root{--ck-dropdown-arrow-size:calc(0.5*var(--ck-icon-size))}.ck.ck-dropdown{font-size:inherit}.ck.ck-dropdown .ck-dropdown__arrow{width:var(--ck-dropdown-arrow-size)}[dir=ltr] .ck.ck-dropdown .ck-dropdown__arrow{right:var(--ck-spacing-standard);margin-left:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-dropdown .ck-dropdown__arrow{left:var(--ck-spacing-standard);margin-right:var(--ck-spacing-small)}.ck.ck-dropdown.ck-disabled .ck-dropdown__arrow{opacity:var(--ck-disabled-opacity)}[dir=ltr] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-left:var(--ck-spacing-small)}[dir=rtl] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-right:var(--ck-spacing-small)}.ck.ck-dropdown .ck-button.ck-dropdown__button .ck-button__label{width:7em;overflow:hidden;text-overflow:ellipsis}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on{border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-dropdown__button_label-width_auto .ck-button__label{width:auto}.ck.ck-dropdown__panel{border-radius:0}.ck-rounded-corners .ck.ck-dropdown__panel,.ck.ck-dropdown__panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-dropdown__panel{box-shadow:var(--ck-drop-shadow),0 0;background:var(--ck-color-dropdown-panel-background);border:1px solid var(--ck-color-dropdown-panel-border);bottom:0;min-width:100%}.ck.ck-dropdown__panel.ck-dropdown__panel_se{border-top-left-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_sw{border-top-right-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_ne{border-bottom-left-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_nw{border-bottom-right-radius:0}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(27);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck.ck-icon{vertical-align:middle}:root{--ck-icon-size:calc(var(--ck-line-height-base)*var(--ck-font-size-normal))}.ck.ck-icon{width:var(--ck-icon-size);height:var(--ck-icon-size);font-size:.8333350694em;will-change:transform}.ck.ck-icon,.ck.ck-icon *{color:inherit;cursor:inherit}.ck.ck-icon :not([fill]){fill:currentColor}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(29);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck.ck-tooltip,.ck.ck-tooltip .ck-tooltip__text:after{position:absolute;pointer-events:none;-webkit-backface-visibility:hidden}.ck.ck-tooltip{visibility:hidden;opacity:0;display:none;z-index:var(--ck-z-modal)}.ck.ck-tooltip .ck-tooltip__text{display:inline-block}.ck.ck-tooltip .ck-tooltip__text:after{content:"";width:0;height:0}:root{--ck-tooltip-arrow-size:5px}.ck.ck-tooltip{left:50%;top:0;transition:opacity .2s ease-in-out .2s}.ck.ck-tooltip .ck-tooltip__text{border-radius:0}.ck-rounded-corners .ck.ck-tooltip .ck-tooltip__text,.ck.ck-tooltip .ck-tooltip__text.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-tooltip .ck-tooltip__text{font-size:.9em;line-height:1.5;color:var(--ck-color-tooltip-text);padding:var(--ck-spacing-small) var(--ck-spacing-medium);background:var(--ck-color-tooltip-background);position:relative;left:-50%}.ck.ck-tooltip .ck-tooltip__text:after{transition:opacity .2s ease-in-out .2s;border-style:solid;left:50%}.ck.ck-tooltip.ck-tooltip_s{bottom:calc(-1*var(--ck-tooltip-arrow-size));transform:translateY(100%)}.ck.ck-tooltip.ck-tooltip_s .ck-tooltip__text:after{top:calc(-1*var(--ck-tooltip-arrow-size));transform:translateX(-50%);border-left-color:transparent;border-bottom-color:var(--ck-color-tooltip-background);border-right-color:transparent;border-top-color:transparent;border-left-width:var(--ck-tooltip-arrow-size);border-bottom-width:var(--ck-tooltip-arrow-size);border-right-width:var(--ck-tooltip-arrow-size);border-top-width:0}.ck.ck-tooltip.ck-tooltip_n{top:calc(-1*var(--ck-tooltip-arrow-size));transform:translateY(-100%)}.ck.ck-tooltip.ck-tooltip_n .ck-tooltip__text:after{bottom:calc(-1*var(--ck-tooltip-arrow-size));transform:translateX(-50%);border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent;border-top-color:var(--ck-color-tooltip-background);border-left-width:var(--ck-tooltip-arrow-size);border-bottom-width:0;border-right-width:var(--ck-tooltip-arrow-size);border-top-width:var(--ck-tooltip-arrow-size)}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(31);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck.ck-button,a.ck.ck-button{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ck.ck-button .ck-tooltip,a.ck.ck-button .ck-tooltip{display:block}@media (hover:none){.ck.ck-button .ck-tooltip,a.ck.ck-button .ck-tooltip{display:none}}.ck.ck-button,a.ck.ck-button{position:relative;display:inline-flex;align-items:center;justify-content:left}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{display:none}.ck.ck-button.ck-button_with-text .ck-button__label,a.ck.ck-button.ck-button_with-text .ck-button__label{display:inline-block}.ck.ck-button:not(.ck-button_with-text),a.ck.ck-button:not(.ck-button_with-text){justify-content:center}.ck.ck-button:hover .ck-tooltip,a.ck.ck-button:hover .ck-tooltip{visibility:visible;opacity:1}.ck.ck-button:focus:not(:hover) .ck-tooltip,a.ck.ck-button:focus:not(:hover) .ck-tooltip{display:none}.ck.ck-button,a.ck.ck-button{background:var(--ck-color-button-default-background)}.ck.ck-button:not(.ck-disabled):hover,a.ck.ck-button:not(.ck-disabled):hover{background:var(--ck-color-button-default-hover-background)}.ck.ck-button:not(.ck-disabled):active,a.ck.ck-button:not(.ck-disabled):active{background:var(--ck-color-button-default-active-background);box-shadow:inset 0 2px 2px var(--ck-color-button-default-active-shadow)}.ck.ck-button.ck-disabled,a.ck.ck-button.ck-disabled{background:var(--ck-color-button-default-disabled-background)}.ck.ck-button,a.ck.ck-button{border-radius:0}.ck-rounded-corners .ck.ck-button,.ck-rounded-corners a.ck.ck-button,.ck.ck-button.ck-rounded-corners,a.ck.ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-button,a.ck.ck-button{white-space:nowrap;cursor:default;vertical-align:middle;padding:var(--ck-spacing-tiny);text-align:center;min-width:var(--ck-ui-component-min-height);min-height:var(--ck-ui-component-min-height);line-height:1;font-size:inherit;border:1px solid transparent;transition:box-shadow .2s ease-in-out,border .2s ease-in-out;-webkit-appearance:none}.ck.ck-button:active,.ck.ck-button:focus,a.ck.ck-button:active,a.ck.ck-button:focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0}.ck.ck-button .ck-button__icon use,.ck.ck-button .ck-button__icon use *,a.ck.ck-button .ck-button__icon use,a.ck.ck-button .ck-button__icon use *{color:inherit}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{font-size:inherit;font-weight:inherit;color:inherit;cursor:inherit;vertical-align:middle}[dir=ltr] .ck.ck-button .ck-button__label,[dir=ltr] a.ck.ck-button .ck-button__label{text-align:left}[dir=rtl] .ck.ck-button .ck-button__label,[dir=rtl] a.ck.ck-button .ck-button__label{text-align:right}.ck.ck-button .ck-button__keystroke,a.ck.ck-button .ck-button__keystroke{color:inherit}[dir=ltr] .ck.ck-button .ck-button__keystroke,[dir=ltr] a.ck.ck-button .ck-button__keystroke{margin-left:var(--ck-spacing-large)}[dir=rtl] .ck.ck-button .ck-button__keystroke,[dir=rtl] a.ck.ck-button .ck-button__keystroke{margin-right:var(--ck-spacing-large)}.ck.ck-button .ck-button__keystroke,a.ck.ck-button .ck-button__keystroke{font-weight:700;opacity:.7}.ck.ck-button.ck-disabled:active,.ck.ck-button.ck-disabled:focus,a.ck.ck-button.ck-disabled:active,a.ck.ck-button.ck-disabled:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),0 0}.ck.ck-button.ck-disabled .ck-button__icon,a.ck.ck-button.ck-disabled .ck-button__icon{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-disabled .ck-button__label,a.ck.ck-button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-disabled .ck-button__keystroke,a.ck.ck-button.ck-disabled .ck-button__keystroke{opacity:.3}.ck.ck-button.ck-button_with-text,a.ck.ck-button.ck-button_with-text{padding:var(--ck-spacing-tiny) var(--ck-spacing-standard)}[dir=ltr] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=ltr] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-left:calc(-1*var(--ck-spacing-small));margin-right:var(--ck-spacing-small)}[dir=rtl] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=rtl] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-right:calc(-1*var(--ck-spacing-small));margin-left:var(--ck-spacing-small)}.ck.ck-button.ck-button_with-keystroke .ck-button__label,a.ck.ck-button.ck-button_with-keystroke .ck-button__label{flex-grow:1}.ck.ck-button.ck-on,a.ck.ck-button.ck-on{background:var(--ck-color-button-on-background)}.ck.ck-button.ck-on:not(.ck-disabled):hover,a.ck.ck-button.ck-on:not(.ck-disabled):hover{background:var(--ck-color-button-on-hover-background)}.ck.ck-button.ck-on:not(.ck-disabled):active,a.ck.ck-button.ck-on:not(.ck-disabled):active{background:var(--ck-color-button-on-active-background);box-shadow:inset 0 2px 2px var(--ck-color-button-on-active-shadow)}.ck.ck-button.ck-on.ck-disabled,a.ck.ck-button.ck-on.ck-disabled{background:var(--ck-color-button-on-disabled-background)}.ck.ck-button.ck-button-save,a.ck.ck-button.ck-button-save{color:var(--ck-color-button-save)}.ck.ck-button.ck-button-cancel,a.ck.ck-button.ck-button-cancel{color:var(--ck-color-button-cancel)}.ck.ck-button-action,a.ck.ck-button-action{background:var(--ck-color-button-action-background)}.ck.ck-button-action:not(.ck-disabled):hover,a.ck.ck-button-action:not(.ck-disabled):hover{background:var(--ck-color-button-action-hover-background)}.ck.ck-button-action:not(.ck-disabled):active,a.ck.ck-button-action:not(.ck-disabled):active{background:var(--ck-color-button-action-active-background);box-shadow:inset 0 2px 2px var(--ck-color-button-action-active-shadow)}.ck.ck-button-action.ck-disabled,a.ck.ck-button-action.ck-disabled{background:var(--ck-color-button-action-disabled-background)}.ck.ck-button-action,a.ck.ck-button-action{color:var(--ck-color-button-action-text)}.ck.ck-button-bold,a.ck.ck-button-bold{font-weight:700}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(33);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck.ck-list{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;display:flex;flex-direction:column}.ck.ck-list .ck-list__item,.ck.ck-list .ck-list__separator{display:block}.ck.ck-list .ck-list__item>:focus{position:relative;z-index:var(--ck-z-default)}.ck.ck-list{border-radius:0}.ck-rounded-corners .ck.ck-list,.ck.ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-list{list-style-type:none;background:var(--ck-color-list-background)}.ck.ck-list__item{cursor:default;min-width:12em}.ck.ck-list__item .ck-button{min-height:unset;width:100%;text-align:left;border-radius:0;padding:calc(0.2*var(--ck-line-height-base)*var(--ck-font-size-base)) calc(0.4*var(--ck-line-height-base)*var(--ck-font-size-base))}.ck.ck-list__item .ck-button .ck-button__label{line-height:calc(1.2*var(--ck-line-height-base)*var(--ck-font-size-base))}.ck.ck-list__item .ck-button:active{box-shadow:none}.ck.ck-list__item .ck-button.ck-on{background:var(--ck-color-list-button-on-background);color:var(--ck-color-list-button-on-text)}.ck.ck-list__item .ck-button.ck-on:active{box-shadow:none}.ck.ck-list__item .ck-button.ck-on:hover:not(.ck-disabled){background:var(--ck-color-list-button-on-background-focus)}.ck.ck-list__item .ck-button.ck-on:focus:not(.ck-disabled){border-color:var(--ck-color-base-background)}.ck.ck-list__item .ck-button:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background)}.ck.ck-list__item .ck-switchbutton.ck-on{background:var(--ck-color-list-background);color:inherit}.ck.ck-list__item .ck-switchbutton.ck-on:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background);color:inherit}.ck.ck-list__separator{height:1px;width:100%;background:var(--ck-color-base-border)}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(35);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{display:block}:root{--ck-switch-button-toggle-width:2.6153846154em;--ck-switch-button-toggle-inner-size:1.0769230769em;--ck-switch-button-toggle-spacing:1px;--ck-switch-button-translation:calc(var(--ck-switch-button-toggle-width) - var(--ck-switch-button-toggle-inner-size) - 2*var(--ck-switch-button-toggle-spacing))}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__label{margin-right:calc(2*var(--ck-spacing-large))}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__label{margin-left:calc(2*var(--ck-spacing-large))}.ck.ck-button.ck-switchbutton .ck-button__toggle{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle.ck-rounded-corners{border-radius:var(--ck-border-radius)}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-left:auto}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-right:auto}.ck.ck-button.ck-switchbutton .ck-button__toggle{transition:background .4s ease;width:var(--ck-switch-button-toggle-width);background:var(--ck-color-switch-button-off-background)}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:calc(0.5*var(--ck-border-radius))}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{margin:var(--ck-switch-button-toggle-spacing);width:var(--ck-switch-button-toggle-inner-size);height:var(--ck-switch-button-toggle-inner-size);background:var(--ck-color-switch-button-inner-background);transition:all .3s ease}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover{background:var(--ck-color-switch-button-off-hover-background)}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover .ck-button__toggle__inner{box-shadow:0 0 0 5px var(--ck-color-switch-button-inner-shadow)}.ck.ck-button.ck-switchbutton.ck-disabled .ck-button__toggle{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle{background:var(--ck-color-switch-button-on-background)}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle:hover{background:var(--ck-color-switch-button-on-hover-background)}[dir=ltr] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(var(--ck-switch-button-translation))}[dir=rtl] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(calc(-1*var(--ck-switch-button-translation)))}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(37);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck.ck-toolbar-dropdown .ck.ck-toolbar .ck.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar-dropdown .ck-dropdown__panel .ck-button:focus{z-index:calc(var(--ck-z-default) + 1)}.ck.ck-toolbar-dropdown .ck-toolbar{border:0}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(39);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck.ck-dropdown .ck-dropdown__panel .ck-list{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list,.ck.ck-dropdown .ck-dropdown__panel .ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0}.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button,.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button,.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(41);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck.ck-toolbar{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;display:flex;flex-flow:row nowrap;align-items:center}.ck.ck-toolbar>.ck-toolbar__items{display:flex;flex-flow:row wrap;align-items:center;flex-grow:1}.ck.ck-toolbar .ck.ck-toolbar__separator{display:inline-block}.ck.ck-toolbar .ck.ck-toolbar__separator:first-child,.ck.ck-toolbar .ck.ck-toolbar__separator:last-child{display:none}.ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar.ck-toolbar_vertical>.ck-toolbar__items{flex-direction:column}.ck.ck-toolbar.ck-toolbar_floating>.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown>.ck-dropdown__button .ck-dropdown__arrow{display:none}.ck.ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-toolbar,.ck.ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-toolbar{background:var(--ck-color-toolbar-background);padding:0 var(--ck-spacing-small);border:1px solid var(--ck-color-toolbar-border)}.ck.ck-toolbar .ck.ck-toolbar__separator{align-self:stretch;width:1px;min-width:1px;background:var(--ck-color-toolbar-border);margin-top:var(--ck-spacing-small);margin-bottom:var(--ck-spacing-small)}.ck.ck-toolbar>.ck-toolbar__items>*{margin-top:var(--ck-spacing-small);margin-bottom:var(--ck-spacing-small);margin-right:var(--ck-spacing-small)}.ck.ck-toolbar>.ck-toolbar__items:empty+.ck.ck-toolbar__separator{display:none}.ck.ck-toolbar>.ck-toolbar__items>*,.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown{margin-top:var(--ck-spacing-small);margin-bottom:var(--ck-spacing-small)}.ck.ck-toolbar.ck-toolbar_vertical{padding:0}.ck.ck-toolbar.ck-toolbar_vertical>.ck-toolbar__items>.ck{width:100%;margin:0;border-radius:0;border:0}.ck.ck-toolbar.ck-toolbar_compact{padding:0}.ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>*{margin:0}.ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>:not(:first-child):not(:last-child){border-radius:0}.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown>.ck.ck-button.ck-dropdown__button{padding-left:var(--ck-spacing-tiny)}.ck-toolbar-container .ck.ck-toolbar{border:0}.ck.ck-toolbar[dir=rtl]>.ck-toolbar__items>.ck,[dir=rtl] .ck.ck-toolbar>.ck-toolbar__items>.ck{margin-right:0}.ck.ck-toolbar[dir=rtl]:not(.ck-toolbar_compact)>.ck-toolbar__items>.ck,[dir=rtl] .ck.ck-toolbar:not(.ck-toolbar_compact)>.ck-toolbar__items>.ck{margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=rtl]>.ck-toolbar__items>.ck:last-child,[dir=rtl] .ck.ck-toolbar>.ck-toolbar__items>.ck:last-child{margin-left:0}.ck.ck-toolbar[dir=rtl].ck-toolbar_compact>.ck-toolbar__items>.ck:first-child,[dir=rtl] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:first-child{border-top-left-radius:0;border-bottom-left-radius:0}.ck.ck-toolbar[dir=rtl].ck-toolbar_compact>.ck-toolbar__items>.ck:last-child,[dir=rtl] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:last-child{border-top-right-radius:0;border-bottom-right-radius:0}.ck.ck-toolbar[dir=rtl]>.ck.ck-toolbar__separator,[dir=rtl] .ck.ck-toolbar>.ck.ck-toolbar__separator{margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=rtl].ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child),[dir=rtl] .ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child){margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=ltr]>.ck-toolbar__items>.ck:last-child,[dir=ltr] .ck.ck-toolbar>.ck-toolbar__items>.ck:last-child{margin-right:0}.ck.ck-toolbar[dir=ltr].ck-toolbar_compact>.ck-toolbar__items>.ck:first-child,[dir=ltr] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.ck.ck-toolbar[dir=ltr].ck-toolbar_compact>.ck-toolbar__items>.ck:last-child,[dir=ltr] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.ck.ck-toolbar[dir=ltr]>.ck.ck-toolbar__separator,[dir=ltr] .ck.ck-toolbar>.ck.ck-toolbar__separator{margin-right:var(--ck-spacing-small)}.ck.ck-toolbar[dir=ltr].ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child),[dir=ltr] .ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child){margin-right:var(--ck-spacing-small)}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(43);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck.ck-editor{position:relative}.ck.ck-editor .ck-editor__top .ck-sticky-panel .ck-toolbar{z-index:var(--ck-z-modal)}.ck.ck-editor__top .ck-sticky-panel .ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius);border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-editor__top .ck-sticky-panel .ck-toolbar{border-bottom-width:0}.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar{border-bottom-width:1px;border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar,.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:0}.ck.ck-editor__main>.ck-editor__editable{background:var(--ck-color-base-background);border-radius:0}.ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable,.ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}.ck.ck-editor__main>.ck-editor__editable:not(.ck-focused){border-color:var(--ck-color-base-border)}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(45);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck-content blockquote{overflow:hidden;padding-right:1.5em;padding-left:1.5em;margin-left:0;margin-right:0;font-style:italic;border-left:5px solid #ccc}.ck-content[dir=rtl] blockquote{border-left:0;border-right:5px solid #ccc}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(47);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        ':root{--ck-balloon-panel-arrow-z-index:calc(var(--ck-z-default) - 3)}.ck.ck-balloon-panel{display:none;position:absolute;z-index:var(--ck-z-modal)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{content:"";position:absolute}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_n]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_n]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_s]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_s]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel.ck-balloon-panel_visible{display:block}:root{--ck-balloon-arrow-offset:2px;--ck-balloon-arrow-height:10px;--ck-balloon-arrow-half-width:8px}.ck.ck-balloon-panel{border-radius:0}.ck-rounded-corners .ck.ck-balloon-panel,.ck.ck-balloon-panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-balloon-panel{box-shadow:var(--ck-drop-shadow),0 0;min-height:15px;background:var(--ck-color-panel-background);border:1px solid var(--ck-color-panel-border)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{width:0;height:0;border-style:solid}.ck.ck-balloon-panel[class*=arrow_n]:after,.ck.ck-balloon-panel[class*=arrow_n]:before{border-left-width:var(--ck-balloon-arrow-half-width);border-bottom-width:var(--ck-balloon-arrow-height);border-right-width:var(--ck-balloon-arrow-half-width);border-top-width:0}.ck.ck-balloon-panel[class*=arrow_n]:before{border-bottom-color:var(--ck-color-panel-border)}.ck.ck-balloon-panel[class*=arrow_n]:after,.ck.ck-balloon-panel[class*=arrow_n]:before{border-left-color:transparent;border-right-color:transparent;border-top-color:transparent}.ck.ck-balloon-panel[class*=arrow_n]:after{border-bottom-color:var(--ck-color-panel-background);margin-top:var(--ck-balloon-arrow-offset)}.ck.ck-balloon-panel[class*=arrow_s]:after,.ck.ck-balloon-panel[class*=arrow_s]:before{border-left-width:var(--ck-balloon-arrow-half-width);border-bottom-width:0;border-right-width:var(--ck-balloon-arrow-half-width);border-top-width:var(--ck-balloon-arrow-height)}.ck.ck-balloon-panel[class*=arrow_s]:before{border-top-color:var(--ck-color-panel-border)}.ck.ck-balloon-panel[class*=arrow_s]:after,.ck.ck-balloon-panel[class*=arrow_s]:before{border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent}.ck.ck-balloon-panel[class*=arrow_s]:after{border-top-color:var(--ck-color-panel-background);margin-bottom:var(--ck-balloon-arrow-offset)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:before{left:50%;margin-left:calc(-1*var(--ck-balloon-arrow-half-width));top:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:before{left:calc(2*var(--ck-balloon-arrow-half-width));top:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:before{right:calc(2*var(--ck-balloon-arrow-half-width));top:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:before{left:50%;margin-left:calc(-1*var(--ck-balloon-arrow-half-width));bottom:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:before{left:calc(2*var(--ck-balloon-arrow-half-width));bottom:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:before{right:calc(2*var(--ck-balloon-arrow-half-width));bottom:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sme:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sme:before{right:25%;margin-right:calc(2*var(--ck-balloon-arrow-half-width));bottom:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_smw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_smw:before{left:25%;margin-left:calc(2*var(--ck-balloon-arrow-half-width));bottom:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nme:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nme:before{right:25%;margin-right:calc(2*var(--ck-balloon-arrow-half-width));top:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nmw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nmw:before{left:25%;margin-left:calc(2*var(--ck-balloon-arrow-half-width));top:calc(-1*var(--ck-balloon-arrow-height))}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(49);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck .ck-link_selected{background:var(--ck-color-link-selected-background)}.ck .ck-fake-link-selection{background:var(--ck-color-link-fake-selection)}.ck .ck-fake-link-selection_collapsed{height:100%;border-right:1px solid var(--ck-color-base-text);margin-right:-1px;outline:1px solid hsla(0,0%,100%,.5)}';
    },
    function (e, t) {
      e.exports =
        '.ck-content code{background-color:hsla(0,0%,78%,.3);padding:.15em;border-radius:2px}.ck.ck-editor__editable .ck-code_selected{background-color:hsla(0,0%,78%,.5)}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(52);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck.ck-color-grid{display:grid}:root{--ck-color-grid-tile-size:24px;--ck-color-color-grid-check-icon:#000}.ck.ck-color-grid{grid-gap:5px;padding:8px}.ck.ck-color-grid__tile{width:var(--ck-color-grid-tile-size);height:var(--ck-color-grid-tile-size);min-width:var(--ck-color-grid-tile-size);min-height:var(--ck-color-grid-tile-size);padding:0;transition:box-shadow .2s ease;border:0}.ck.ck-color-grid__tile.ck-disabled{cursor:unset;transition:unset}.ck.ck-color-grid__tile.ck-color-table__color-tile_bordered{box-shadow:0 0 0 1px var(--ck-color-base-border)}.ck.ck-color-grid__tile .ck.ck-icon{display:none;color:var(--ck-color-color-grid-check-icon)}.ck.ck-color-grid__tile.ck-on{box-shadow:inset 0 0 0 1px var(--ck-color-base-background),0 0 0 2px var(--ck-color-base-text)}.ck.ck-color-grid__tile.ck-on .ck.ck-icon{display:block}.ck.ck-color-grid__tile.ck-on,.ck.ck-color-grid__tile:focus:not(.ck-disabled),.ck.ck-color-grid__tile:hover:not(.ck-disabled){border:0}.ck.ck-color-grid__tile:focus:not(.ck-disabled),.ck.ck-color-grid__tile:hover:not(.ck-disabled){box-shadow:inset 0 0 0 1px var(--ck-color-base-background),0 0 0 2px var(--ck-color-focus-border)}.ck.ck-color-grid__label{padding:0 var(--ck-spacing-standard)}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(54);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck .ck-button.ck-color-table__remove-color{display:flex;align-items:center;width:100%}label.ck.ck-color-grid__label{font-weight:unset}.ck .ck-button.ck-color-table__remove-color{padding:calc(var(--ck-spacing-standard)/2) var(--ck-spacing-standard);border-bottom-left-radius:0;border-bottom-right-radius:0}.ck .ck-button.ck-color-table__remove-color:not(:focus){border-bottom:1px solid var(--ck-color-base-border)}[dir=ltr] .ck .ck-button.ck-color-table__remove-color .ck.ck-icon{margin-right:var(--ck-spacing-standard)}[dir=rtl] .ck .ck-button.ck-color-table__remove-color .ck.ck-icon{margin-left:var(--ck-spacing-standard)}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(56);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck-content .text-tiny{font-size:.7em}.ck-content .text-small{font-size:.85em}.ck-content .text-big{font-size:1.4em}.ck-content .text-huge{font-size:1.8em}';
    },
    function (e, t) {
      e.exports =
        '.ck.ck-heading_heading1{font-size:20px}.ck.ck-heading_heading2{font-size:17px}.ck.ck-heading_heading3{font-size:14px}.ck[class*=ck-heading_heading]{font-weight:700}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__button .ck-button__label{width:8em}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__panel .ck-list__item{min-width:18em}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(59);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck.ck-splitbutton{font-size:inherit}.ck.ck-splitbutton .ck-splitbutton__action:focus{z-index:calc(var(--ck-z-default) + 1)}.ck.ck-splitbutton.ck-splitbutton_open>.ck-button .ck-tooltip{display:none}:root{--ck-color-split-button-hover-background:#ebebeb;--ck-color-split-button-hover-border:#b3b3b3}[dir=ltr] .ck.ck-splitbutton>.ck-splitbutton__action{border-top-right-radius:unset;border-bottom-right-radius:unset}[dir=rtl] .ck.ck-splitbutton>.ck-splitbutton__action{border-top-left-radius:unset;border-bottom-left-radius:unset}.ck.ck-splitbutton>.ck-splitbutton__arrow{min-width:unset}[dir=ltr] .ck.ck-splitbutton>.ck-splitbutton__arrow{border-radius:0}.ck-rounded-corners [dir=ltr] .ck.ck-splitbutton>.ck-splitbutton__arrow,[dir=ltr] .ck.ck-splitbutton>.ck-splitbutton__arrow.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:unset;border-bottom-left-radius:unset}[dir=rtl] .ck.ck-splitbutton>.ck-splitbutton__arrow{border-top-right-radius:unset;border-bottom-right-radius:unset}.ck.ck-splitbutton>.ck-splitbutton__arrow svg{width:var(--ck-dropdown-arrow-size)}.ck.ck-splitbutton.ck-splitbutton_open>.ck-button:not(.ck-on):not(.ck-disabled):not(:hover),.ck.ck-splitbutton:hover>.ck-button:not(.ck-on):not(.ck-disabled):not(:hover){background:var(--ck-color-split-button-hover-background)}[dir=ltr] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled),[dir=ltr] .ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled){border-left-color:var(--ck-color-split-button-hover-border)}[dir=rtl] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled),[dir=rtl] .ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled){border-right-color:var(--ck-color-split-button-hover-border)}.ck.ck-splitbutton.ck-splitbutton_open{border-radius:0}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners>.ck-splitbutton__action{border-bottom-left-radius:0}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners>.ck-splitbutton__arrow{border-bottom-right-radius:0}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(61);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        ':root{--ck-highlight-marker-yellow:#fdfd77;--ck-highlight-marker-green:#62f962;--ck-highlight-marker-pink:#fc7899;--ck-highlight-marker-blue:#72ccfd;--ck-highlight-pen-red:#e71313;--ck-highlight-pen-green:#128a00}.ck-content .marker-yellow{background-color:var(--ck-highlight-marker-yellow)}.ck-content .marker-green{background-color:var(--ck-highlight-marker-green)}.ck-content .marker-pink{background-color:var(--ck-highlight-marker-pink)}.ck-content .marker-blue{background-color:var(--ck-highlight-marker-blue)}.ck-content .pen-red{color:var(--ck-highlight-pen-red);background-color:transparent}.ck-content .pen-green{color:var(--ck-highlight-pen-green);background-color:transparent}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(63);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck-editor__editable .ck-horizontal-line{display:flow-root}.ck-content hr{margin:15px 0;height:4px;background:#dedede;border:0}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(65);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck .ck-widget .ck-widget__type-around__button{display:block;position:absolute;overflow:hidden;z-index:var(--ck-z-default)}.ck .ck-widget .ck-widget__type-around__button svg{position:absolute;top:50%;left:50%;z-index:calc(var(--ck-z-default) + 2)}.ck .ck-widget .ck-widget__type-around__button.ck-widget__type-around__button_before{top:calc(-0.5*var(--ck-widget-outline-thickness));left:min(10%,30px);transform:translateY(-50%)}.ck .ck-widget .ck-widget__type-around__button.ck-widget__type-around__button_after{bottom:calc(-0.5*var(--ck-widget-outline-thickness));right:min(10%,30px);transform:translateY(50%)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:after,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover:after{content:"";display:block;position:absolute;top:1px;left:1px;z-index:calc(var(--ck-z-default) + 1)}.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__fake-caret{display:none;position:absolute;left:0;right:0}.ck .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__fake-caret{left:calc(-1*var(--ck-widget-outline-thickness));right:calc(-1*var(--ck-widget-outline-thickness))}.ck .ck-widget.ck-widget_type-around_show-fake-caret_before>.ck-widget__type-around>.ck-widget__type-around__fake-caret{top:calc(-1*var(--ck-widget-outline-thickness) - 1px);display:block}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after>.ck-widget__type-around>.ck-widget__type-around__fake-caret{bottom:calc(-1*var(--ck-widget-outline-thickness) - 1px);display:block}.ck.ck-editor__editable.ck-read-only .ck-widget__type-around,.ck.ck-editor__editable.ck-restricted-editing_mode_restricted .ck-widget__type-around,.ck.ck-editor__editable.ck-widget__type-around_disabled .ck-widget__type-around{display:none}:root{--ck-widget-type-around-button-size:20px;--ck-color-widget-type-around-button-active:var(--ck-color-focus-border);--ck-color-widget-type-around-button-hover:var(--ck-color-widget-hover-border);--ck-color-widget-type-around-button-blurred-editable:var(--ck-color-widget-blurred-border);--ck-color-widget-type-around-button-radar-start-alpha:0;--ck-color-widget-type-around-button-radar-end-alpha:.3;--ck-color-widget-type-around-button-icon:var(--ck-color-base-background)}.ck .ck-widget .ck-widget__type-around__button{width:var(--ck-widget-type-around-button-size);height:var(--ck-widget-type-around-button-size);background:var(--ck-color-widget-type-around-button);border-radius:100px;transition:opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);opacity:0;pointer-events:none}.ck .ck-widget .ck-widget__type-around__button svg{width:10px;height:8px;transform:translate(-50%,-50%);transition:transform .5s ease;margin-top:1px}.ck .ck-widget .ck-widget__type-around__button svg *{stroke-dasharray:10;stroke-dashoffset:0;fill:none;stroke:var(--ck-color-widget-type-around-button-icon);stroke-width:1.5px;stroke-linecap:round;stroke-linejoin:round}.ck .ck-widget .ck-widget__type-around__button svg line{stroke-dasharray:7}.ck .ck-widget .ck-widget__type-around__button:hover{animation:ck-widget-type-around-button-sonar 1s ease infinite}.ck .ck-widget .ck-widget__type-around__button:hover svg polyline{animation:ck-widget-type-around-arrow-dash 2s linear}.ck .ck-widget .ck-widget__type-around__button:hover svg line{animation:ck-widget-type-around-arrow-tip-dash 2s linear}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__button{opacity:1;pointer-events:auto}.ck .ck-widget:not(.ck-widget_selected)>.ck-widget__type-around>.ck-widget__type-around__button{background:var(--ck-color-widget-type-around-button-hover)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover{background:var(--ck-color-widget-type-around-button-active)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:after,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover:after{width:calc(var(--ck-widget-type-around-button-size) - 2px);height:calc(var(--ck-widget-type-around-button-size) - 2px);border-radius:100px;background:linear-gradient(135deg,hsla(0,0%,100%,0),hsla(0,0%,100%,.3))}.ck .ck-widget.ck-widget_with-selection-handle>.ck-widget__type-around>.ck-widget__type-around__button_before{margin-left:20px}.ck .ck-widget .ck-widget__type-around__fake-caret{pointer-events:none;height:1px;animation:ck-widget-type-around-fake-caret-pulse 1s linear infinite normal forwards;outline:1px solid hsla(0,0%,100%,.5);background:var(--ck-color-base-text)}.ck .ck-widget.ck-widget_selected.ck-widget_type-around_show-fake-caret_after,.ck .ck-widget.ck-widget_selected.ck-widget_type-around_show-fake-caret_before{outline-color:transparent}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_selected:hover,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_selected:hover{outline-color:var(--ck-color-widget-hover-border)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before>.ck-widget__type-around>.ck-widget__type-around__button{opacity:0;pointer-events:none}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle{opacity:0}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_selected.ck-widget_with-resizer>.ck-widget__resizer,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_selected.ck-widget_with-resizer>.ck-widget__resizer{opacity:0}.ck-editor__nested-editable.ck-editor__editable_selected .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck-editor__nested-editable.ck-editor__editable_selected .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__button{opacity:0;pointer-events:none}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:not(:hover){background:var(--ck-color-widget-type-around-button-blurred-editable)}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:not(:hover) svg *{stroke:#999}@keyframes ck-widget-type-around-arrow-dash{0%{stroke-dashoffset:10}20%,to{stroke-dashoffset:0}}@keyframes ck-widget-type-around-arrow-tip-dash{0%,20%{stroke-dashoffset:7}40%,to{stroke-dashoffset:0}}@keyframes ck-widget-type-around-button-sonar{0%{box-shadow:0 0 0 0 hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-start-alpha))}50%{box-shadow:0 0 0 5px hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-end-alpha))}to{box-shadow:0 0 0 5px hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-start-alpha))}}@keyframes ck-widget-type-around-fake-caret-pulse{0%{opacity:1}49%{opacity:1}50%{opacity:0}99%{opacity:0}to{opacity:1}}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(67);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        ':root{--ck-color-resizer:var(--ck-color-focus-border);--ck-resizer-size:10px;--ck-resizer-border-width:1px;--ck-resizer-border-radius:2px;--ck-resizer-offset:calc(var(--ck-resizer-size)/-2 - 2px);--ck-resizer-tooltip-offset:10px;--ck-color-resizer-tooltip-background:#262626;--ck-color-resizer-tooltip-text:#f2f2f2}.ck .ck-widget,.ck .ck-widget.ck-widget_with-selection-handle{position:relative}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{position:absolute}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon{display:block}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected .ck-widget__selection-handle,.ck .ck-widget.ck-widget_with-selection-handle:hover .ck-widget__selection-handle{visibility:visible}.ck .ck-size-view{background:var(--ck-color-resizer-tooltip-background);color:var(--ck-color-resizer-tooltip-text);border:1px solid var(--ck-color-resizer-tooltip-text);border-radius:var(--ck-resizer-border-radius);font-size:var(--ck-font-size-tiny);display:block;padding:var(--ck-spacing-small)}.ck .ck-size-view.ck-orientation-bottom-left,.ck .ck-size-view.ck-orientation-bottom-right,.ck .ck-size-view.ck-orientation-top-left,.ck .ck-size-view.ck-orientation-top-right{position:absolute}.ck .ck-size-view.ck-orientation-top-left{top:var(--ck-resizer-tooltip-offset);left:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-top-right{top:var(--ck-resizer-tooltip-offset);right:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-right{bottom:var(--ck-resizer-tooltip-offset);right:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-left{bottom:var(--ck-resizer-tooltip-offset);left:var(--ck-resizer-tooltip-offset)}:root{--ck-widget-outline-thickness:3px;--ck-widget-handler-icon-size:16px;--ck-widget-handler-animation-duration:200ms;--ck-widget-handler-animation-curve:ease;--ck-color-widget-blurred-border:#dedede;--ck-color-widget-hover-border:#ffc83d;--ck-color-widget-editable-focus-background:var(--ck-color-base-background);--ck-color-widget-drag-handler-icon-color:var(--ck-color-base-background)}.ck .ck-widget{outline-width:var(--ck-widget-outline-thickness);outline-style:solid;outline-color:transparent;transition:outline-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_selected,.ck .ck-widget.ck-widget_selected:hover{outline:var(--ck-widget-outline-thickness) solid var(--ck-color-focus-border)}.ck .ck-widget:hover{outline-color:var(--ck-color-widget-hover-border)}.ck .ck-editor__nested-editable{border:1px solid transparent}.ck .ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck .ck-editor__nested-editable:focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0;background-color:var(--ck-color-widget-editable-focus-background)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{padding:4px;box-sizing:border-box;background-color:transparent;opacity:0;transition:background-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),visibility var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);border-radius:var(--ck-border-radius) var(--ck-border-radius) 0 0;transform:translateY(-100%);left:calc(0px - var(--ck-widget-outline-thickness))}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon{width:var(--ck-widget-handler-icon-size);height:var(--ck-widget-handler-icon-size);color:var(--ck-color-widget-drag-handler-icon-color)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{opacity:0;transition:opacity .3s var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle:hover .ck-icon .ck-icon__selected-indicator{opacity:1}.ck .ck-widget.ck-widget_with-selection-handle:hover .ck-widget__selection-handle{opacity:1;background-color:var(--ck-color-widget-hover-border)}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected .ck-widget__selection-handle,.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected:hover .ck-widget__selection-handle{opacity:1;background-color:var(--ck-color-focus-border)}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected .ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator,.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected:hover .ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{opacity:1}.ck[dir=rtl] .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{left:auto;right:calc(0px - var(--ck-widget-outline-thickness))}.ck.ck-editor__editable.ck-read-only .ck-widget{transition:none}.ck.ck-editor__editable.ck-read-only .ck-widget:not(.ck-widget_selected){--ck-widget-outline-thickness:0px}.ck.ck-editor__editable.ck-read-only .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle,.ck.ck-editor__editable.ck-read-only .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle:hover{background:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover{outline-color:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle .ck-widget__selection-handle,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle .ck-widget__selection-handle:hover,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover.ck-widget_with-selection-handle .ck-widget__selection-handle,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover.ck-widget_with-selection-handle .ck-widget__selection-handle:hover{background:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable>.ck-widget.ck-widget_with-selection-handle:first-child,.ck.ck-editor__editable blockquote>.ck-widget.ck-widget_with-selection-handle:first-child{margin-top:calc(1em + var(--ck-widget-handler-icon-size))}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(69);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck.ck-labeled-field-view .ck-labeled-field-view__status{font-size:var(--ck-font-size-small);margin-top:var(--ck-spacing-small);white-space:normal}.ck.ck-labeled-field-view .ck-labeled-field-view__status_error{color:var(--ck-color-base-error)}.ck.ck-labeled-field-view>.ck.ck-label{width:100%;text-overflow:ellipsis;overflow:hidden}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(71);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        ':root{--ck-input-text-width:18em}.ck.ck-input-text{border-radius:0}.ck-rounded-corners .ck.ck-input-text,.ck.ck-input-text.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-input-text{box-shadow:var(--ck-inner-shadow),0 0;background:var(--ck-color-input-background);border:1px solid var(--ck-color-input-border);padding:var(--ck-spacing-extra-tiny) var(--ck-spacing-medium);min-width:var(--ck-input-text-width);min-height:var(--ck-ui-component-min-height);transition:box-shadow .2s ease-in-out,border .2s ease-in-out}.ck.ck-input-text:focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),var(--ck-inner-shadow)}.ck.ck-input-text[readonly]{border:1px solid var(--ck-color-input-disabled-border);background:var(--ck-color-input-disabled-background);color:var(--ck-color-input-disabled-text)}.ck.ck-input-text[readonly]:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),var(--ck-inner-shadow)}.ck.ck-input-text.ck-error{border-color:var(--ck-color-input-error-border);animation:ck-text-input-shake .3s ease both}.ck.ck-input-text.ck-error:focus{box-shadow:var(--ck-focus-error-outer-shadow),var(--ck-inner-shadow)}@keyframes ck-text-input-shake{20%{transform:translateX(-2px)}40%{transform:translateX(2px)}60%{transform:translateX(-1px)}80%{transform:translateX(1px)}}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(73);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck.ck-text-alternative-form{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-text-alternative-form .ck-labeled-field-view{display:inline-block}.ck.ck-text-alternative-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-text-alternative-form{flex-wrap:wrap}.ck.ck-text-alternative-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-text-alternative-form .ck-button{flex-basis:50%}}.ck.ck-text-alternative-form{padding:var(--ck-spacing-standard)}.ck.ck-text-alternative-form:focus{outline:none}[dir=ltr] .ck.ck-text-alternative-form>:not(:first-child),[dir=rtl] .ck.ck-text-alternative-form>:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-text-alternative-form{padding:0;width:calc(0.8*var(--ck-input-text-width))}.ck.ck-text-alternative-form .ck-labeled-field-view{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-text-alternative-form .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-text-alternative-form .ck-button{padding:var(--ck-spacing-standard);margin-top:var(--ck-spacing-standard);border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-text-alternative-form .ck-button{margin-left:0}[dir=ltr] .ck.ck-text-alternative-form .ck-button:first-of-type{border-right:1px solid var(--ck-color-base-border)}[dir=rtl] .ck.ck-text-alternative-form .ck-button{margin-left:0}[dir=rtl] .ck.ck-text-alternative-form .ck-button:last-of-type{border-right:1px solid var(--ck-color-base-border)}}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(75);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck .ck-balloon-rotator__navigation{display:flex;align-items:center;justify-content:center}.ck .ck-balloon-rotator__content .ck-toolbar{justify-content:center}.ck .ck-balloon-rotator__navigation{background:var(--ck-color-toolbar-background);border-bottom:1px solid var(--ck-color-toolbar-border);padding:0 var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation>*{margin-right:var(--ck-spacing-small);margin-top:var(--ck-spacing-small);margin-bottom:var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation .ck-balloon-rotator__counter{margin-right:var(--ck-spacing-standard);margin-left:var(--ck-spacing-small)}.ck .ck-balloon-rotator__content .ck.ck-annotation-wrapper{box-shadow:none}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(77);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck .ck-fake-panel{position:absolute;z-index:calc(var(--ck-z-modal) - 1)}.ck .ck-fake-panel div{position:absolute}.ck .ck-fake-panel div:first-child{z-index:2}.ck .ck-fake-panel div:nth-child(2){z-index:1}:root{--ck-balloon-fake-panel-offset-horizontal:6px;--ck-balloon-fake-panel-offset-vertical:6px}.ck .ck-fake-panel div{box-shadow:var(--ck-drop-shadow),0 0;min-height:15px;background:var(--ck-color-panel-background);border:1px solid var(--ck-color-panel-border);border-radius:var(--ck-border-radius);width:100%;height:100%}.ck .ck-fake-panel div:first-child{margin-left:var(--ck-balloon-fake-panel-offset-horizontal);margin-top:var(--ck-balloon-fake-panel-offset-vertical)}.ck .ck-fake-panel div:nth-child(2){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*2);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*2)}.ck .ck-fake-panel div:nth-child(3){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*3);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*3)}.ck .ck-balloon-panel_arrow_s+.ck-fake-panel,.ck .ck-balloon-panel_arrow_se+.ck-fake-panel,.ck .ck-balloon-panel_arrow_sw+.ck-fake-panel{--ck-balloon-fake-panel-offset-vertical:-6px}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(79);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck-content .image{display:table;clear:both;text-align:center;margin:1em auto}.ck-content .image img{display:block;margin:0 auto;max-width:100%;min-width:50px}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(81);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck-content .image>figcaption{display:table-caption;caption-side:bottom;word-break:break-word;color:#333;background-color:#f7f7f7;padding:.6em;font-size:.75em;outline-offset:-1px}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(83);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck .ck-widget_with-resizer{position:relative}.ck .ck-widget__resizer{display:none;position:absolute;pointer-events:none;left:0;top:0;outline:1px solid var(--ck-color-resizer)}.ck-focused .ck-widget_with-resizer.ck-widget_selected>.ck-widget__resizer{display:block}.ck .ck-widget__resizer__handle{position:absolute;pointer-events:all;width:var(--ck-resizer-size);height:var(--ck-resizer-size);background:var(--ck-color-focus-border);border:var(--ck-resizer-border-width) solid #fff;border-radius:var(--ck-resizer-border-radius)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-left{top:var(--ck-resizer-offset);left:var(--ck-resizer-offset);cursor:nwse-resize}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-right{top:var(--ck-resizer-offset);right:var(--ck-resizer-offset);cursor:nesw-resize}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-right{bottom:var(--ck-resizer-offset);right:var(--ck-resizer-offset);cursor:nwse-resize}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-left{bottom:var(--ck-resizer-offset);left:var(--ck-resizer-offset);cursor:nesw-resize}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(85);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck-content .image.image_resized{max-width:100%;display:block;box-sizing:border-box}.ck-content .image.image_resized img{width:100%}.ck-content .image.image_resized>figcaption{display:block}[dir=ltr] .ck.ck-button.ck-button_with-text.ck-resize-image-button .ck-button__icon{margin-right:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-button.ck-button_with-text.ck-resize-image-button .ck-button__icon{margin-left:var(--ck-spacing-standard)}.ck.ck-dropdown .ck-button.ck-resize-image-button .ck-button__label{width:4em}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(87);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        ':root{--ck-image-style-spacing:1.5em}.ck-content .image-style-side{float:right;margin-left:var(--ck-image-style-spacing);max-width:50%}.ck-content .image-style-align-left{float:left;margin-right:var(--ck-image-style-spacing)}.ck-content .image-style-align-center{margin-left:auto;margin-right:auto}.ck-content .image-style-align-right{float:right;margin-left:var(--ck-image-style-spacing)}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(89);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck.ck-form__row{display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-between}.ck.ck-form__row>:not(.ck-label){flex-grow:1}.ck.ck-form__row.ck-image-upload-form__action-row{margin-top:var(--ck-spacing-standard)}.ck.ck-form__row.ck-image-upload-form__action-row .ck-button-cancel,.ck.ck-form__row.ck-image-upload-form__action-row .ck-button-save{justify-content:center}.ck.ck-form__row.ck-image-upload-form__action-row .ck-button .ck-button__label{color:var(--ck-color-text)}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(91);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck.ck-image-upload__panel{padding:var(--ck-spacing-standard)}.ck.ck-image-upload__ck-finder-button{display:block;width:100%;margin:var(--ck-spacing-standard) auto;border:1px solid #ccc;border-radius:var(--ck-border-radius)}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(93);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck.ck-editor__editable .image{position:relative}.ck.ck-editor__editable .image .ck-progress-bar{position:absolute;top:0;left:0}.ck.ck-editor__editable .image.ck-appear{animation:fadeIn .7s}.ck.ck-editor__editable .image .ck-progress-bar{height:2px;width:0;background:var(--ck-color-upload-bar-background);transition:width .1s}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(95);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck-image-upload-complete-icon{display:block;position:absolute;top:10px;right:10px;border-radius:50%}.ck-image-upload-complete-icon:after{content:"";position:absolute}:root{--ck-color-image-upload-icon:#fff;--ck-color-image-upload-icon-background:#008a00;--ck-image-upload-icon-size:20px;--ck-image-upload-icon-width:2px}.ck-image-upload-complete-icon{width:var(--ck-image-upload-icon-size);height:var(--ck-image-upload-icon-size);opacity:0;background:var(--ck-color-image-upload-icon-background);animation-name:ck-upload-complete-icon-show,ck-upload-complete-icon-hide;animation-fill-mode:forwards,forwards;animation-duration:.5s,.5s;font-size:var(--ck-image-upload-icon-size);animation-delay:0ms,3s}.ck-image-upload-complete-icon:after{left:25%;top:50%;opacity:0;height:0;width:0;transform:scaleX(-1) rotate(135deg);transform-origin:left top;border-top:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);border-right:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);animation-name:ck-upload-complete-icon-check;animation-duration:.5s;animation-delay:.5s;animation-fill-mode:forwards;box-sizing:border-box}@keyframes ck-upload-complete-icon-show{0%{opacity:0}to{opacity:1}}@keyframes ck-upload-complete-icon-hide{0%{opacity:1}to{opacity:0}}@keyframes ck-upload-complete-icon-check{0%{opacity:1;width:0;height:0}33%{width:.3em;height:0}to{opacity:1;width:.3em;height:.45em}}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(97);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck .ck-upload-placeholder-loader{position:absolute;display:flex;align-items:center;justify-content:center;top:0;left:0}.ck .ck-upload-placeholder-loader:before{content:"";position:relative}:root{--ck-color-upload-placeholder-loader:#b3b3b3;--ck-upload-placeholder-loader-size:32px}.ck .ck-image-upload-placeholder{width:100%;margin:0}.ck .ck-upload-placeholder-loader{width:100%;height:100%}.ck .ck-upload-placeholder-loader:before{width:var(--ck-upload-placeholder-loader-size);height:var(--ck-upload-placeholder-loader-size);border-radius:50%;border-top:3px solid var(--ck-color-upload-placeholder-loader);border-right:2px solid transparent;animation:ck-upload-placeholder-loader 1s linear infinite}@keyframes ck-upload-placeholder-loader{to{transform:rotate(1turn)}}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(99);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck.ck-link-form{display:flex}.ck.ck-link-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-link-form{flex-wrap:wrap}.ck.ck-link-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-link-form .ck-button{flex-basis:50%}}.ck.ck-link-form_layout-vertical{display:block}.ck.ck-link-form{padding:var(--ck-spacing-standard)}.ck.ck-link-form:focus{outline:none}[dir=ltr] .ck.ck-link-form>:not(:first-child),[dir=rtl] .ck.ck-link-form>:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-link-form{padding:0;width:calc(0.8*var(--ck-input-text-width))}.ck.ck-link-form .ck-labeled-field-view{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-link-form .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-link-form .ck-button{padding:var(--ck-spacing-standard);margin-top:var(--ck-spacing-standard);border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-link-form .ck-button{margin-left:0}[dir=ltr] .ck.ck-link-form .ck-button:first-of-type{border-right:1px solid var(--ck-color-base-border)}[dir=rtl] .ck.ck-link-form .ck-button{margin-left:0}[dir=rtl] .ck.ck-link-form .ck-button:last-of-type{border-right:1px solid var(--ck-color-base-border)}}.ck.ck-link-form_layout-vertical{padding:0;min-width:var(--ck-input-text-width)}.ck.ck-link-form_layout-vertical .ck-labeled-field-view{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) var(--ck-spacing-small)}.ck.ck-link-form_layout-vertical .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-link-form_layout-vertical .ck-button{padding:var(--ck-spacing-standard);margin:0;border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border);width:50%}[dir=ltr] .ck.ck-link-form_layout-vertical .ck-button{margin-left:0}[dir=ltr] .ck.ck-link-form_layout-vertical .ck-button:first-of-type{border-right:1px solid var(--ck-color-base-border)}[dir=rtl] .ck.ck-link-form_layout-vertical .ck-button{margin-left:0}[dir=rtl] .ck.ck-link-form_layout-vertical .ck-button:last-of-type{border-right:1px solid var(--ck-color-base-border)}.ck.ck-link-form_layout-vertical .ck.ck-list{margin-left:0}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton{border:0;width:100%}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton:hover{background:none}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(101);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck.ck-link-actions{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-link-actions .ck-link-actions__preview{display:inline-block}.ck.ck-link-actions .ck-link-actions__preview .ck-button__label{overflow:hidden}@media screen and (max-width:600px){.ck.ck-link-actions{flex-wrap:wrap}.ck.ck-link-actions .ck-link-actions__preview{flex-basis:100%}.ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){flex-basis:50%}}.ck.ck-link-actions{padding:var(--ck-spacing-standard)}.ck.ck-link-actions .ck-button.ck-link-actions__preview{padding-left:0;padding-right:0}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{padding:0 var(--ck-spacing-medium);color:var(--ck-color-link-default);text-overflow:ellipsis;cursor:pointer;max-width:var(--ck-input-text-width);min-width:3em;text-align:center}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label:hover{text-decoration:underline}.ck.ck-link-actions .ck-button.ck-link-actions__preview,.ck.ck-link-actions .ck-button.ck-link-actions__preview:active,.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus,.ck.ck-link-actions .ck-button.ck-link-actions__preview:hover{background:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:active{box-shadow:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus .ck-button__label{text-decoration:underline}.ck.ck-link-actions:focus{outline:none}[dir=ltr] .ck.ck-link-actions .ck-button:not(:first-child),[dir=rtl] .ck.ck-link-actions .ck-button:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-link-actions{padding:0;width:calc(0.8*var(--ck-input-text-width))}.ck.ck-link-actions .ck-button.ck-link-actions__preview{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{min-width:0;max-width:100%}.ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){padding:var(--ck-spacing-standard);margin-top:var(--ck-spacing-standard);border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){margin-left:0}[dir=ltr] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview):first-of-type{border-right:1px solid var(--ck-color-base-border)}[dir=rtl] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){margin-left:0}[dir=rtl] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview):last-of-type{border-right:1px solid var(--ck-color-base-border)}}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(103);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck.ck-list-styles-dropdown>.ck-dropdown__panel>.ck-toolbar>.ck-toolbar__items{display:grid}:root{--ck-list-style-button-size:44px}.ck.ck-list-styles-dropdown>.ck-dropdown__panel>.ck-toolbar{background:none;padding:0}.ck.ck-list-styles-dropdown>.ck-dropdown__panel>.ck-toolbar>.ck-toolbar__items{grid-template-columns:repeat(3,auto);row-gap:var(--ck-spacing-medium);column-gap:var(--ck-spacing-medium);padding:var(--ck-spacing-medium)}.ck.ck-list-styles-dropdown>.ck-dropdown__panel>.ck-toolbar>.ck-toolbar__items .ck-button{width:var(--ck-list-style-button-size);height:var(--ck-list-style-button-size);padding:0;margin:0;box-sizing:content-box}.ck.ck-list-styles-dropdown>.ck-dropdown__panel>.ck-toolbar>.ck-toolbar__items .ck-button .ck-icon{width:var(--ck-list-style-button-size);height:var(--ck-list-style-button-size)}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(105);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck-media__wrapper .ck-media__placeholder{display:flex;flex-direction:column;align-items:center}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-tooltip{display:block}@media (hover:none){.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-tooltip{display:none}}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url{max-width:100%;position:relative}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url:hover .ck-tooltip{visibility:visible;opacity:1}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-media__placeholder__url__text{overflow:hidden;display:block}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck-media__placeholder__icon *{display:none}.ck-editor__editable:not(.ck-read-only) .ck-media__wrapper>:not(.ck-media__placeholder),.ck-editor__editable:not(.ck-read-only) .ck-widget:not(.ck-widget_selected) .ck-media__placeholder{pointer-events:none}:root{--ck-media-embed-placeholder-icon-size:3em;--ck-color-media-embed-placeholder-url-text:#757575;--ck-color-media-embed-placeholder-url-text-hover:var(--ck-color-base-text)}.ck-media__wrapper{margin:0 auto}.ck-media__wrapper .ck-media__placeholder{padding:calc(3*var(--ck-spacing-standard));background:var(--ck-color-base-foreground)}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon{min-width:var(--ck-media-embed-placeholder-icon-size);height:var(--ck-media-embed-placeholder-icon-size);margin-bottom:var(--ck-spacing-large);background-position:50%;background-size:cover}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon .ck-icon{width:100%;height:100%}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url__text{color:var(--ck-color-media-embed-placeholder-url-text);white-space:nowrap;text-align:center;font-style:italic;text-overflow:ellipsis}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:var(--ck-color-media-embed-placeholder-url-text-hover);cursor:pointer;text-decoration:underline}.ck-media__wrapper[data-oembed-url*="open.spotify.com"]{max-width:300px;max-height:380px}.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,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)}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder{background:#4268b3}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAyNCIgaGVpZ2h0PSIxMDI0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik05NjcuNDg0IDBINTYuNTE3QzI1LjMwNCAwIDAgMjUuMzA0IDAgNTYuNTE3djkxMC45NjZDMCA5OTguNjk0IDI1LjI5NyAxMDI0IDU2LjUyMiAxMDI0SDU0N1Y2MjhINDE0VjQ3M2gxMzNWMzU5LjAyOWMwLTEzMi4yNjIgODAuNzczLTIwNC4yODIgMTk4Ljc1Ni0yMDQuMjgyIDU2LjUxMyAwIDEwNS4wODYgNC4yMDggMTE5LjI0NCA2LjA4OVYyOTlsLTgxLjYxNi4wMzdjLTYzLjk5MyAwLTc2LjM4NCAzMC40OTItNzYuMzg0IDc1LjIzNlY0NzNoMTUzLjQ4N2wtMTkuOTg2IDE1NUg3MDd2Mzk2aDI2MC40ODRjMzEuMjEzIDAgNTYuNTE2LTI1LjMwMyA1Ni41MTYtNTYuNTE2VjU2LjUxNUMxMDI0IDI1LjMwMyA5OTguNjk3IDAgOTY3LjQ4NCAwIiBmaWxsPSIjRkZGRkZFIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#cdf}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder{background:linear-gradient(-135deg,#1400c7,#b800b1,#f50000)}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,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)}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#ffe0fe}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder{background:linear-gradient(90deg,#71c6f4,#0d70a5)}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MDAgNDAwIj48cGF0aCBkPSJNNDAwIDIwMGMwIDExMC41LTg5LjUgMjAwLTIwMCAyMDBTMCAzMTAuNSAwIDIwMCA4OS41IDAgMjAwIDBzMjAwIDg5LjUgMjAwIDIwMHpNMTYzLjQgMzA1LjVjODguNyAwIDEzNy4yLTczLjUgMTM3LjItMTM3LjIgMC0yLjEgMC00LjItLjEtNi4yIDkuNC02LjggMTcuNi0xNS4zIDI0LjEtMjUtOC42IDMuOC0xNy45IDYuNC0yNy43IDcuNiAxMC02IDE3LjYtMTUuNCAyMS4yLTI2LjctOS4zIDUuNS0xOS42IDkuNS0zMC42IDExLjctOC44LTkuNC0yMS4zLTE1LjItMzUuMi0xNS4yLTI2LjYgMC00OC4yIDIxLjYtNDguMiA0OC4yIDAgMy44LjQgNy41IDEuMyAxMS00MC4xLTItNzUuNi0yMS4yLTk5LjQtNTAuNC00LjEgNy4xLTYuNSAxNS40LTYuNSAyNC4yIDAgMTYuNyA4LjUgMzEuNSAyMS41IDQwLjEtNy45LS4yLTE1LjMtMi40LTIxLjgtNnYuNmMwIDIzLjQgMTYuNiA0Mi44IDM4LjcgNDcuMy00IDEuMS04LjMgMS43LTEyLjcgMS43LTMuMSAwLTYuMS0uMy05LjEtLjkgNi4xIDE5LjIgMjMuOSAzMy4xIDQ1IDMzLjUtMTYuNSAxMi45LTM3LjMgMjAuNi01OS45IDIwLjYtMy45IDAtNy43LS4yLTExLjUtLjcgMjEuMSAxMy44IDQ2LjUgMjEuOCA3My43IDIxLjgiIGZpbGw9IiNmZmYiLz48L3N2Zz4=)}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text{color:#b8e6ff}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(107);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck.ck-media-form{display:flex;align-items:flex-start;flex-direction:row;flex-wrap:nowrap}.ck.ck-media-form .ck-labeled-field-view{display:inline-block}.ck.ck-media-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-media-form{flex-wrap:wrap}.ck.ck-media-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-media-form .ck-button{flex-basis:50%}}.ck.ck-media-form{padding:var(--ck-spacing-standard)}.ck.ck-media-form:focus{outline:none}[dir=ltr] .ck.ck-media-form>:not(:first-child),[dir=rtl] .ck.ck-media-form>:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-media-form{padding:0;width:calc(0.8*var(--ck-input-text-width))}.ck.ck-media-form .ck-labeled-field-view{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-media-form .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-media-form .ck-labeled-field-view .ck-labeled-field-view__error{white-space:normal}.ck.ck-media-form .ck-button{padding:var(--ck-spacing-standard);margin-top:var(--ck-spacing-standard);border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-media-form .ck-button{margin-left:0}[dir=ltr] .ck.ck-media-form .ck-button:first-of-type{border-right:1px solid var(--ck-color-base-border)}[dir=rtl] .ck.ck-media-form .ck-button{margin-left:0}[dir=rtl] .ck.ck-media-form .ck-button:last-of-type{border-right:1px solid var(--ck-color-base-border)}}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(109);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck-content .media{clear:both;margin:1em 0;display:block;min-width:15em}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(111);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        ':root{--ck-mention-list-max-height:300px}.ck.ck-mentions{max-height:var(--ck-mention-list-max-height);overflow-y:auto;overflow-x:hidden;overscroll-behavior:contain}.ck.ck-mentions>.ck-list__item{overflow:hidden;flex-shrink:0}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(113);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        ':root{--ck-color-mention-background:rgba(153,0,48,0.1);--ck-color-mention-text:#990030}.ck-content .mention{background:var(--ck-color-mention-background);color:var(--ck-color-mention-text)}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(115);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck.ck-form__header{display:flex;flex-direction:row;flex-wrap:nowrap;align-items:center;justify-content:space-between}:root{--ck-form-header-height:38px}.ck.ck-form__header{padding:var(--ck-spacing-small) var(--ck-spacing-large);height:var(--ck-form-header-height);line-height:var(--ck-form-header-height);border-bottom:1px solid var(--ck-color-base-border)}.ck.ck-form__header .ck-form__header__label{font-weight:700}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(117);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck.ck-character-grid .ck-character-grid__tiles{display:grid;grid-template-columns:repeat(10,1fr)}:root{--ck-character-grid-tile-size:24px}.ck.ck-character-grid{overflow-y:auto;overflow-x:hidden;width:350px;max-height:200px}.ck.ck-character-grid .ck-character-grid__tiles{margin:var(--ck-spacing-standard) var(--ck-spacing-large);grid-gap:var(--ck-spacing-standard)}.ck.ck-character-grid .ck-character-grid__tile{width:var(--ck-character-grid-tile-size);height:var(--ck-character-grid-tile-size);min-width:var(--ck-character-grid-tile-size);min-height:var(--ck-character-grid-tile-size);font-size:1.2em;padding:0;transition:box-shadow .2s ease;border:0}.ck.ck-character-grid .ck-character-grid__tile:focus:not(.ck-disabled),.ck.ck-character-grid .ck-character-grid__tile:hover:not(.ck-disabled){border:0;box-shadow:inset 0 0 0 1px var(--ck-color-base-background),0 0 0 2px var(--ck-color-focus-border)}.ck.ck-character-grid .ck-character-grid__tile .ck-button__label{line-height:var(--ck-character-grid-tile-size);width:100%;text-align:center}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(119);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck.ck-character-info{display:flex;justify-content:space-between;padding:var(--ck-spacing-small) var(--ck-spacing-large);border-top:1px solid var(--ck-color-base-border)}.ck.ck-character-info>*{text-transform:uppercase;font-size:var(--ck-font-size-small)}.ck.ck-character-info .ck-character-info__name{max-width:280px;text-overflow:ellipsis;overflow:hidden}.ck.ck-character-info .ck-character-info__code{opacity:.6}';
    },
    function (e, t, i) {
      var n = i(1);
      var o = i(121);
      o = o.__esModule ? o.default : o;
      if (typeof o === 'string') {
        o = [[e.i, o, '']];
      }
      var r = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true },
      };
      r.insert = 'head';
      r.singleton = true;
      var s = n(o, r);
      e.exports = o.locals || {};
    },
    function (e, t) {
      e.exports =
        '.ck.ck-special-characters-navigation>.ck-label{max-width:160px;text-overflow:ellipsis;overflow:hidden}.ck.ck-special-characters-navigation>.ck-dropdown .ck-dropdown__panel{max-height:250px;overflow-y:auto;overflow-x:hidden}';
    },
    function (e, t, i) {
      'use strict';
      i.r(t);
      var n = i(3);
      var o = n['a'].Symbol;
      var r = o;
      var s = Object.prototype;
      var a = s.hasOwnProperty;
      var c = s.toString;
      var l = r ? r.toStringTag : undefined;
      function d(e) {
        var t = a.call(e, l),
          i = e[l];
        try {
          e[l] = undefined;
          var n = true;
        } catch (e) {}
        var o = c.call(e);
        if (n) {
          if (t) {
            e[l] = i;
          } else {
            delete e[l];
          }
        }
        return o;
      }
      var u = d;
      var h = Object.prototype;
      var f = h.toString;
      function g(e) {
        return f.call(e);
      }
      var m = g;
      var p = '[object Null]',
        b = '[object Undefined]';
      var w = r ? r.toStringTag : undefined;
      function k(e) {
        if (e == null) {
          return e === undefined ? b : p;
        }
        return w && w in Object(e) ? u(e) : m(e);
      }
      var _ = k;
      function v(e, t) {
        return function (i) {
          return e(t(i));
        };
      }
      var y = v;
      var x = y(Object.getPrototypeOf, Object);
      var A = x;
      function T(e) {
        return e != null && typeof e == 'object';
      }
      var C = T;
      var P = '[object Object]';
      var E = Function.prototype,
        S = Object.prototype;
      var M = E.toString;
      var I = S.hasOwnProperty;
      var N = M.call(Object);
      function O(e) {
        if (!C(e) || _(e) != P) {
          return false;
        }
        var t = A(e);
        if (t === null) {
          return true;
        }
        var i = I.call(t, 'constructor') && t.constructor;
        return typeof i == 'function' && i instanceof i && M.call(i) == N;
      }
      var z = O;
      function R() {
        this.__data__ = [];
        this.size = 0;
      }
      var L = R;
      function V(e, t) {
        return e === t || (e !== e && t !== t);
      }
      var D = V;
      function j(e, t) {
        var i = e.length;
        while (i--) {
          if (D(e[i][0], t)) {
            return i;
          }
        }
        return -1;
      }
      var B = j;
      var F = Array.prototype;
      var H = F.splice;
      function U(e) {
        var t = this.__data__,
          i = B(t, e);
        if (i < 0) {
          return false;
        }
        var n = t.length - 1;
        if (i == n) {
          t.pop();
        } else {
          H.call(t, i, 1);
        }
        --this.size;
        return true;
      }
      var q = U;
      function W(e) {
        var t = this.__data__,
          i = B(t, e);
        return i < 0 ? undefined : t[i][1];
      }
      var $ = W;
      function G(e) {
        return B(this.__data__, e) > -1;
      }
      var Y = G;
      function K(e, t) {
        var i = this.__data__,
          n = B(i, e);
        if (n < 0) {
          ++this.size;
          i.push([e, t]);
        } else {
          i[n][1] = t;
        }
        return this;
      }
      var Q = K;
      function J(e) {
        var t = -1,
          i = e == null ? 0 : e.length;
        this.clear();
        while (++t < i) {
          var n = e[t];
          this.set(n[0], n[1]);
        }
      }
      J.prototype.clear = L;
      J.prototype['delete'] = q;
      J.prototype.get = $;
      J.prototype.has = Y;
      J.prototype.set = Q;
      var Z = J;
      function X() {
        this.__data__ = new Z();
        this.size = 0;
      }
      var ee = X;
      function te(e) {
        var t = this.__data__,
          i = t['delete'](e);
        this.size = t.size;
        return i;
      }
      var ie = te;
      function ne(e) {
        return this.__data__.get(e);
      }
      var oe = ne;
      function re(e) {
        return this.__data__.has(e);
      }
      var se = re;
      function ae(e) {
        var t = typeof e;
        return e != null && (t == 'object' || t == 'function');
      }
      var ce = ae;
      var le = '[object AsyncFunction]',
        de = '[object Function]',
        ue = '[object GeneratorFunction]',
        he = '[object Proxy]';
      function fe(e) {
        if (!ce(e)) {
          return false;
        }
        var t = _(e);
        return t == de || t == ue || t == le || t == he;
      }
      var ge = fe;
      var me = n['a']['__core-js_shared__'];
      var pe = me;
      var be = (function () {
        var e = /[^.]+$/.exec((pe && pe.keys && pe.keys.IE_PROTO) || '');
        return e ? 'Symbol(src)_1.' + e : '';
      })();
      function we(e) {
        return !!be && be in e;
      }
      var ke = we;
      var _e = Function.prototype;
      var ve = _e.toString;
      function ye(e) {
        if (e != null) {
          try {
            return ve.call(e);
          } catch (e) {}
          try {
            return e + '';
          } catch (e) {}
        }
        return '';
      }
      var xe = ye;
      var Ae = /[\\^$.*+?()[\]{}|]/g;
      var Te = /^\[object .+?Constructor\]$/;
      var Ce = Function.prototype,
        Pe = Object.prototype;
      var Ee = Ce.toString;
      var Se = Pe.hasOwnProperty;
      var Me = RegExp(
        '^' +
          Ee.call(Se)
            .replace(Ae, '\\$&')
            .replace(
              /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
              '$1.*?'
            ) +
          '$'
      );
      function Ie(e) {
        if (!ce(e) || ke(e)) {
          return false;
        }
        var t = ge(e) ? Me : Te;
        return t.test(xe(e));
      }
      var Ne = Ie;
      function Oe(e, t) {
        return e == null ? undefined : e[t];
      }
      var ze = Oe;
      function Re(e, t) {
        var i = ze(e, t);
        return Ne(i) ? i : undefined;
      }
      var Le = Re;
      var Ve = Le(n['a'], 'Map');
      var De = Ve;
      var je = Le(Object, 'create');
      var Be = je;
      function Fe() {
        this.__data__ = Be ? Be(null) : {};
        this.size = 0;
      }
      var He = Fe;
      function Ue(e) {
        var t = this.has(e) && delete this.__data__[e];
        this.size -= t ? 1 : 0;
        return t;
      }
      var qe = Ue;
      var We = '__lodash_hash_undefined__';
      var $e = Object.prototype;
      var Ge = $e.hasOwnProperty;
      function Ye(e) {
        var t = this.__data__;
        if (Be) {
          var i = t[e];
          return i === We ? undefined : i;
        }
        return Ge.call(t, e) ? t[e] : undefined;
      }
      var Ke = Ye;
      var Qe = Object.prototype;
      var Je = Qe.hasOwnProperty;
      function Ze(e) {
        var t = this.__data__;
        return Be ? t[e] !== undefined : Je.call(t, e);
      }
      var Xe = Ze;
      var et = '__lodash_hash_undefined__';
      function tt(e, t) {
        var i = this.__data__;
        this.size += this.has(e) ? 0 : 1;
        i[e] = Be && t === undefined ? et : t;
        return this;
      }
      var it = tt;
      function nt(e) {
        var t = -1,
          i = e == null ? 0 : e.length;
        this.clear();
        while (++t < i) {
          var n = e[t];
          this.set(n[0], n[1]);
        }
      }
      nt.prototype.clear = He;
      nt.prototype['delete'] = qe;
      nt.prototype.get = Ke;
      nt.prototype.has = Xe;
      nt.prototype.set = it;
      var ot = nt;
      function rt() {
        this.size = 0;
        this.__data__ = {
          hash: new ot(),
          map: new (De || Z)(),
          string: new ot(),
        };
      }
      var st = rt;
      function at(e) {
        var t = typeof e;
        return t == 'string' || t == 'number' || t == 'symbol' || t == 'boolean'
          ? e !== '__proto__'
          : e === null;
      }
      var ct = at;
      function lt(e, t) {
        var i = e.__data__;
        return ct(t) ? i[typeof t == 'string' ? 'string' : 'hash'] : i.map;
      }
      var dt = lt;
      function ut(e) {
        var t = dt(this, e)['delete'](e);
        this.size -= t ? 1 : 0;
        return t;
      }
      var ht = ut;
      function ft(e) {
        return dt(this, e).get(e);
      }
      var gt = ft;
      function mt(e) {
        return dt(this, e).has(e);
      }
      var pt = mt;
      function bt(e, t) {
        var i = dt(this, e),
          n = i.size;
        i.set(e, t);
        this.size += i.size == n ? 0 : 1;
        return this;
      }
      var wt = bt;
      function kt(e) {
        var t = -1,
          i = e == null ? 0 : e.length;
        this.clear();
        while (++t < i) {
          var n = e[t];
          this.set(n[0], n[1]);
        }
      }
      kt.prototype.clear = st;
      kt.prototype['delete'] = ht;
      kt.prototype.get = gt;
      kt.prototype.has = pt;
      kt.prototype.set = wt;
      var _t = kt;
      var vt = 200;
      function yt(e, t) {
        var i = this.__data__;
        if (i instanceof Z) {
          var n = i.__data__;
          if (!De || n.length < vt - 1) {
            n.push([e, t]);
            this.size = ++i.size;
            return this;
          }
          i = this.__data__ = new _t(n);
        }
        i.set(e, t);
        this.size = i.size;
        return this;
      }
      var xt = yt;
      function At(e) {
        var t = (this.__data__ = new Z(e));
        this.size = t.size;
      }
      At.prototype.clear = ee;
      At.prototype['delete'] = ie;
      At.prototype.get = oe;
      At.prototype.has = se;
      At.prototype.set = xt;
      var Tt = At;
      function Ct(e, t) {
        var i = -1,
          n = e == null ? 0 : e.length;
        while (++i < n) {
          if (t(e[i], i, e) === false) {
            break;
          }
        }
        return e;
      }
      var Pt = Ct;
      var Et = (function () {
        try {
          var e = Le(Object, 'defineProperty');
          e({}, '', {});
          return e;
        } catch (e) {}
      })();
      var St = Et;
      function Mt(e, t, i) {
        if (t == '__proto__' && St) {
          St(e, t, {
            configurable: true,
            enumerable: true,
            value: i,
            writable: true,
          });
        } else {
          e[t] = i;
        }
      }
      var It = Mt;
      var Nt = Object.prototype;
      var Ot = Nt.hasOwnProperty;
      function zt(e, t, i) {
        var n = e[t];
        if (!(Ot.call(e, t) && D(n, i)) || (i === undefined && !(t in e))) {
          It(e, t, i);
        }
      }
      var Rt = zt;
      function Lt(e, t, i, n) {
        var o = !i;
        i || (i = {});
        var r = -1,
          s = t.length;
        while (++r < s) {
          var a = t[r];
          var c = n ? n(i[a], e[a], a, i, e) : undefined;
          if (c === undefined) {
            c = e[a];
          }
          if (o) {
            It(i, a, c);
          } else {
            Rt(i, a, c);
          }
        }
        return i;
      }
      var Vt = Lt;
      function Dt(e, t) {
        var i = -1,
          n = Array(e);
        while (++i < e) {
          n[i] = t(i);
        }
        return n;
      }
      var jt = Dt;
      var Bt = '[object Arguments]';
      function Ft(e) {
        return C(e) && _(e) == Bt;
      }
      var Ht = Ft;
      var Ut = Object.prototype;
      var qt = Ut.hasOwnProperty;
      var Wt = Ut.propertyIsEnumerable;
      var $t = Ht(
        (function () {
          return arguments;
        })()
      )
        ? Ht
        : function (e) {
            return C(e) && qt.call(e, 'callee') && !Wt.call(e, 'callee');
          };
      var Gt = $t;
      var Yt = Array.isArray;
      var Kt = Yt;
      var Qt = i(4);
      var Jt = 9007199254740991;
      var Zt = /^(?:0|[1-9]\d*)$/;
      function Xt(e, t) {
        var i = typeof e;
        t = t == null ? Jt : t;
        return (
          !!t &&
          (i == 'number' || (i != 'symbol' && Zt.test(e))) &&
          e > -1 &&
          e % 1 == 0 &&
          e < t
        );
      }
      var ei = Xt;
      var ti = 9007199254740991;
      function ii(e) {
        return typeof e == 'number' && e > -1 && e % 1 == 0 && e <= ti;
      }
      var ni = ii;
      var oi = '[object Arguments]',
        ri = '[object Array]',
        si = '[object Boolean]',
        ai = '[object Date]',
        ci = '[object Error]',
        li = '[object Function]',
        di = '[object Map]',
        ui = '[object Number]',
        hi = '[object Object]',
        fi = '[object RegExp]',
        gi = '[object Set]',
        mi = '[object String]',
        pi = '[object WeakMap]';
      var bi = '[object ArrayBuffer]',
        wi = '[object DataView]',
        ki = '[object Float32Array]',
        _i = '[object Float64Array]',
        vi = '[object Int8Array]',
        yi = '[object Int16Array]',
        xi = '[object Int32Array]',
        Ai = '[object Uint8Array]',
        Ti = '[object Uint8ClampedArray]',
        Ci = '[object Uint16Array]',
        Pi = '[object Uint32Array]';
      var Ei = {};
      Ei[ki] =
        Ei[_i] =
        Ei[vi] =
        Ei[yi] =
        Ei[xi] =
        Ei[Ai] =
        Ei[Ti] =
        Ei[Ci] =
        Ei[Pi] =
          true;
      Ei[oi] =
        Ei[ri] =
        Ei[bi] =
        Ei[si] =
        Ei[wi] =
        Ei[ai] =
        Ei[ci] =
        Ei[li] =
        Ei[di] =
        Ei[ui] =
        Ei[hi] =
        Ei[fi] =
        Ei[gi] =
        Ei[mi] =
        Ei[pi] =
          false;
      function Si(e) {
        return C(e) && ni(e.length) && !!Ei[_(e)];
      }
      var Mi = Si;
      function Ii(e) {
        return function (t) {
          return e(t);
        };
      }
      var Ni = Ii;
      var Oi = i(5);
      var zi = Oi['a'] && Oi['a'].isTypedArray;
      var Ri = zi ? Ni(zi) : Mi;
      var Li = Ri;
      var Vi = Object.prototype;
      var Di = Vi.hasOwnProperty;
      function ji(e, t) {
        var i = Kt(e),
          n = !i && Gt(e),
          o = !i && !n && Object(Qt['a'])(e),
          r = !i && !n && !o && Li(e),
          s = i || n || o || r,
          a = s ? jt(e.length, String) : [],
          c = a.length;
        for (var l in e) {
          if (
            (t || Di.call(e, l)) &&
            !(
              s &&
              (l == 'length' ||
                (o && (l == 'offset' || l == 'parent')) ||
                (r &&
                  (l == 'buffer' || l == 'byteLength' || l == 'byteOffset')) ||
                ei(l, c))
            )
          ) {
            a.push(l);
          }
        }
        return a;
      }
      var Bi = ji;
      var Fi = Object.prototype;
      function Hi(e) {
        var t = e && e.constructor,
          i = (typeof t == 'function' && t.prototype) || Fi;
        return e === i;
      }
      var Ui = Hi;
      var qi = y(Object.keys, Object);
      var Wi = qi;
      var $i = Object.prototype;
      var Gi = $i.hasOwnProperty;
      function Yi(e) {
        if (!Ui(e)) {
          return Wi(e);
        }
        var t = [];
        for (var i in Object(e)) {
          if (Gi.call(e, i) && i != 'constructor') {
            t.push(i);
          }
        }
        return t;
      }
      var Ki = Yi;
      function Qi(e) {
        return e != null && ni(e.length) && !ge(e);
      }
      var Ji = Qi;
      function Zi(e) {
        return Ji(e) ? Bi(e) : Ki(e);
      }
      var Xi = Zi;
      function en(e, t) {
        return e && Vt(t, Xi(t), e);
      }
      var tn = en;
      function nn(e) {
        var t = [];
        if (e != null) {
          for (var i in Object(e)) {
            t.push(i);
          }
        }
        return t;
      }
      var on = nn;
      var rn = Object.prototype;
      var sn = rn.hasOwnProperty;
      function an(e) {
        if (!ce(e)) {
          return on(e);
        }
        var t = Ui(e),
          i = [];
        for (var n in e) {
          if (!(n == 'constructor' && (t || !sn.call(e, n)))) {
            i.push(n);
          }
        }
        return i;
      }
      var cn = an;
      function ln(e) {
        return Ji(e) ? Bi(e, true) : cn(e);
      }
      var dn = ln;
      function un(e, t) {
        return e && Vt(t, dn(t), e);
      }
      var hn = un;
      var fn = i(8);
      function gn(e, t) {
        var i = -1,
          n = e.length;
        t || (t = Array(n));
        while (++i < n) {
          t[i] = e[i];
        }
        return t;
      }
      var mn = gn;
      function pn(e, t) {
        var i = -1,
          n = e == null ? 0 : e.length,
          o = 0,
          r = [];
        while (++i < n) {
          var s = e[i];
          if (t(s, i, e)) {
            r[o++] = s;
          }
        }
        return r;
      }
      var bn = pn;
      function wn() {
        return [];
      }
      var kn = wn;
      var _n = Object.prototype;
      var vn = _n.propertyIsEnumerable;
      var yn = Object.getOwnPropertySymbols;
      var xn = !yn
        ? kn
        : function (e) {
            if (e == null) {
              return [];
            }
            e = Object(e);
            return bn(yn(e), function (t) {
              return vn.call(e, t);
            });
          };
      var An = xn;
      function Tn(e, t) {
        return Vt(e, An(e), t);
      }
      var Cn = Tn;
      function Pn(e, t) {
        var i = -1,
          n = t.length,
          o = e.length;
        while (++i < n) {
          e[o + i] = t[i];
        }
        return e;
      }
      var En = Pn;
      var Sn = Object.getOwnPropertySymbols;
      var Mn = !Sn
        ? kn
        : function (e) {
            var t = [];
            while (e) {
              En(t, An(e));
              e = A(e);
            }
            return t;
          };
      var In = Mn;
      function Nn(e, t) {
        return Vt(e, In(e), t);
      }
      var On = Nn;
      function zn(e, t, i) {
        var n = t(e);
        return Kt(e) ? n : En(n, i(e));
      }
      var Rn = zn;
      function Ln(e) {
        return Rn(e, Xi, An);
      }
      var Vn = Ln;
      function Dn(e) {
        return Rn(e, dn, In);
      }
      var jn = Dn;
      var Bn = Le(n['a'], 'DataView');
      var Fn = Bn;
      var Hn = Le(n['a'], 'Promise');
      var Un = Hn;
      var qn = Le(n['a'], 'Set');
      var Wn = qn;
      var $n = Le(n['a'], 'WeakMap');
      var Gn = $n;
      var Yn = '[object Map]',
        Kn = '[object Object]',
        Qn = '[object Promise]',
        Jn = '[object Set]',
        Zn = '[object WeakMap]';
      var Xn = '[object DataView]';
      var eo = xe(Fn),
        to = xe(De),
        io = xe(Un),
        no = xe(Wn),
        oo = xe(Gn);
      var ro = _;
      if (
        (Fn && ro(new Fn(new ArrayBuffer(1))) != Xn) ||
        (De && ro(new De()) != Yn) ||
        (Un && ro(Un.resolve()) != Qn) ||
        (Wn && ro(new Wn()) != Jn) ||
        (Gn && ro(new Gn()) != Zn)
      ) {
        ro = function (e) {
          var t = _(e),
            i = t == Kn ? e.constructor : undefined,
            n = i ? xe(i) : '';
          if (n) {
            switch (n) {
              case eo:
                return Xn;
              case to:
                return Yn;
              case io:
                return Qn;
              case no:
                return Jn;
              case oo:
                return Zn;
            }
          }
          return t;
        };
      }
      var so = ro;
      var ao = Object.prototype;
      var co = ao.hasOwnProperty;
      function lo(e) {
        var t = e.length,
          i = new e.constructor(t);
        if (t && typeof e[0] == 'string' && co.call(e, 'index')) {
          i.index = e.index;
          i.input = e.input;
        }
        return i;
      }
      var uo = lo;
      var ho = n['a'].Uint8Array;
      var fo = ho;
      function go(e) {
        var t = new e.constructor(e.byteLength);
        new fo(t).set(new fo(e));
        return t;
      }
      var mo = go;
      function po(e, t) {
        var i = t ? mo(e.buffer) : e.buffer;
        return new e.constructor(i, e.byteOffset, e.byteLength);
      }
      var bo = po;
      var wo = /\w*$/;
      function ko(e) {
        var t = new e.constructor(e.source, wo.exec(e));
        t.lastIndex = e.lastIndex;
        return t;
      }
      var _o = ko;
      var vo = r ? r.prototype : undefined,
        yo = vo ? vo.valueOf : undefined;
      function xo(e) {
        return yo ? Object(yo.call(e)) : {};
      }
      var Ao = xo;
      function To(e, t) {
        var i = t ? mo(e.buffer) : e.buffer;
        return new e.constructor(i, e.byteOffset, e.length);
      }
      var Co = To;
      var Po = '[object Boolean]',
        Eo = '[object Date]',
        So = '[object Map]',
        Mo = '[object Number]',
        Io = '[object RegExp]',
        No = '[object Set]',
        Oo = '[object String]',
        zo = '[object Symbol]';
      var Ro = '[object ArrayBuffer]',
        Lo = '[object DataView]',
        Vo = '[object Float32Array]',
        Do = '[object Float64Array]',
        jo = '[object Int8Array]',
        Bo = '[object Int16Array]',
        Fo = '[object Int32Array]',
        Ho = '[object Uint8Array]',
        Uo = '[object Uint8ClampedArray]',
        qo = '[object Uint16Array]',
        Wo = '[object Uint32Array]';
      function $o(e, t, i) {
        var n = e.constructor;
        switch (t) {
          case Ro:
            return mo(e);
          case Po:
          case Eo:
            return new n(+e);
          case Lo:
            return bo(e, i);
          case Vo:
          case Do:
          case jo:
          case Bo:
          case Fo:
          case Ho:
          case Uo:
          case qo:
          case Wo:
            return Co(e, i);
          case So:
            return new n();
          case Mo:
          case Oo:
            return new n(e);
          case Io:
            return _o(e);
          case No:
            return new n();
          case zo:
            return Ao(e);
        }
      }
      var Go = $o;
      var Yo = Object.create;
      var Ko = (function () {
        function e() {}
        return function (t) {
          if (!ce(t)) {
            return {};
          }
          if (Yo) {
            return Yo(t);
          }
          e.prototype = t;
          var i = new e();
          e.prototype = undefined;
          return i;
        };
      })();
      var Qo = Ko;
      function Jo(e) {
        return typeof e.constructor == 'function' && !Ui(e) ? Qo(A(e)) : {};
      }
      var Zo = Jo;
      var Xo = '[object Map]';
      function er(e) {
        return C(e) && so(e) == Xo;
      }
      var tr = er;
      var ir = Oi['a'] && Oi['a'].isMap;
      var nr = ir ? Ni(ir) : tr;
      var or = nr;
      var rr = '[object Set]';
      function sr(e) {
        return C(e) && so(e) == rr;
      }
      var ar = sr;
      var cr = Oi['a'] && Oi['a'].isSet;
      var lr = cr ? Ni(cr) : ar;
      var dr = lr;
      var ur = 1,
        hr = 2,
        fr = 4;
      var gr = '[object Arguments]',
        mr = '[object Array]',
        pr = '[object Boolean]',
        br = '[object Date]',
        wr = '[object Error]',
        kr = '[object Function]',
        _r = '[object GeneratorFunction]',
        vr = '[object Map]',
        yr = '[object Number]',
        xr = '[object Object]',
        Ar = '[object RegExp]',
        Tr = '[object Set]',
        Cr = '[object String]',
        Pr = '[object Symbol]',
        Er = '[object WeakMap]';
      var Sr = '[object ArrayBuffer]',
        Mr = '[object DataView]',
        Ir = '[object Float32Array]',
        Nr = '[object Float64Array]',
        Or = '[object Int8Array]',
        zr = '[object Int16Array]',
        Rr = '[object Int32Array]',
        Lr = '[object Uint8Array]',
        Vr = '[object Uint8ClampedArray]',
        Dr = '[object Uint16Array]',
        jr = '[object Uint32Array]';
      var Br = {};
      Br[gr] =
        Br[mr] =
        Br[Sr] =
        Br[Mr] =
        Br[pr] =
        Br[br] =
        Br[Ir] =
        Br[Nr] =
        Br[Or] =
        Br[zr] =
        Br[Rr] =
        Br[vr] =
        Br[yr] =
        Br[xr] =
        Br[Ar] =
        Br[Tr] =
        Br[Cr] =
        Br[Pr] =
        Br[Lr] =
        Br[Vr] =
        Br[Dr] =
        Br[jr] =
          true;
      Br[wr] = Br[kr] = Br[Er] = false;
      function Fr(e, t, i, n, o, r) {
        var s,
          a = t & ur,
          c = t & hr,
          l = t & fr;
        if (i) {
          s = o ? i(e, n, o, r) : i(e);
        }
        if (s !== undefined) {
          return s;
        }
        if (!ce(e)) {
          return e;
        }
        var d = Kt(e);
        if (d) {
          s = uo(e);
          if (!a) {
            return mn(e, s);
          }
        } else {
          var u = so(e),
            h = u == kr || u == _r;
          if (Object(Qt['a'])(e)) {
            return Object(fn['a'])(e, a);
          }
          if (u == xr || u == gr || (h && !o)) {
            s = c || h ? {} : Zo(e);
            if (!a) {
              return c ? On(e, hn(s, e)) : Cn(e, tn(s, e));
            }
          } else {
            if (!Br[u]) {
              return o ? e : {};
            }
            s = Go(e, u, a);
          }
        }
        r || (r = new Tt());
        var f = r.get(e);
        if (f) {
          return f;
        }
        r.set(e, s);
        if (dr(e)) {
          e.forEach(function (n) {
            s.add(Fr(n, t, i, n, e, r));
          });
        } else if (or(e)) {
          e.forEach(function (n, o) {
            s.set(o, Fr(n, t, i, o, e, r));
          });
        }
        var g = l ? (c ? jn : Vn) : c ? keysIn : Xi;
        var m = d ? undefined : g(e);
        Pt(m || e, function (n, o) {
          if (m) {
            o = n;
            n = e[o];
          }
          Rt(s, o, Fr(n, t, i, o, e, r));
        });
        return s;
      }
      var Hr = Fr;
      var Ur = 1,
        qr = 4;
      function Wr(e, t) {
        t = typeof t == 'function' ? t : undefined;
        return Hr(e, Ur | qr, t);
      }
      var $r = Wr;
      function Gr(e) {
        return C(e) && e.nodeType === 1 && !z(e);
      }
      var Yr = Gr;
      class Kr {
        constructor(e, t) {
          this._config = {};
          if (t) {
            this.define(Qr(t));
          }
          if (e) {
            this._setObjectToTarget(this._config, e);
          }
        }
        set(e, t) {
          this._setToTarget(this._config, e, t);
        }
        define(e, t) {
          const i = true;
          this._setToTarget(this._config, e, t, i);
        }
        get(e) {
          return this._getFromSource(this._config, e);
        }
        *names() {
          for (const e of Object.keys(this._config)) {
            yield e;
          }
        }
        _setToTarget(e, t, i, n = false) {
          if (z(t)) {
            this._setObjectToTarget(e, t, n);
            return;
          }
          const o = t.split('.');
          t = o.pop();
          for (const t of o) {
            if (!z(e[t])) {
              e[t] = {};
            }
            e = e[t];
          }
          if (z(i)) {
            if (!z(e[t])) {
              e[t] = {};
            }
            e = e[t];
            this._setObjectToTarget(e, i, n);
            return;
          }
          if (n && typeof e[t] != 'undefined') {
            return;
          }
          e[t] = i;
        }
        _getFromSource(e, t) {
          const i = t.split('.');
          t = i.pop();
          for (const t of i) {
            if (!z(e[t])) {
              e = null;
              break;
            }
            e = e[t];
          }
          return e ? Qr(e[t]) : undefined;
        }
        _setObjectToTarget(e, t, i) {
          Object.keys(t).forEach((n) => {
            this._setToTarget(e, n, t[n], i);
          });
        }
      }
      function Qr(e) {
        return $r(e, Jr);
      }
      function Jr(e) {
        return Yr(e) ? e : undefined;
      }
      function Zr() {
        return function e() {
          e.called = true;
        };
      }
      var Xr = Zr;
      class es {
        constructor(e, t) {
          this.source = e;
          this.name = t;
          this.path = [];
          this.stop = Xr();
          this.off = Xr();
        }
      }
      const ts = new Array(256)
        .fill()
        .map((e, t) => ('0' + t.toString(16)).slice(-2));
      function is() {
        const e = (Math.random() * 4294967296) >>> 0;
        const t = (Math.random() * 4294967296) >>> 0;
        const i = (Math.random() * 4294967296) >>> 0;
        const n = (Math.random() * 4294967296) >>> 0;
        return (
          'e' +
          ts[(e >> 0) & 255] +
          ts[(e >> 8) & 255] +
          ts[(e >> 16) & 255] +
          ts[(e >> 24) & 255] +
          ts[(t >> 0) & 255] +
          ts[(t >> 8) & 255] +
          ts[(t >> 16) & 255] +
          ts[(t >> 24) & 255] +
          ts[(i >> 0) & 255] +
          ts[(i >> 8) & 255] +
          ts[(i >> 16) & 255] +
          ts[(i >> 24) & 255] +
          ts[(n >> 0) & 255] +
          ts[(n >> 8) & 255] +
          ts[(n >> 16) & 255] +
          ts[(n >> 24) & 255]
        );
      }
      const ns = {
        get(e) {
          if (typeof e != 'number') {
            return this[e] || this.normal;
          } else {
            return e;
          }
        },
        highest: 1e5,
        high: 1e3,
        normal: 0,
        low: -1e3,
        lowest: -1e5,
      };
      var os = ns;
      var rs = i(6);
      var ss = i(0);
      const as = Symbol('listeningTo');
      const cs = Symbol('emitterId');
      const ls = {
        on(e, t, i = {}) {
          this.listenTo(this, e, t, i);
        },
        once(e, t, i) {
          let n = false;
          const o = function (e, ...i) {
            if (!n) {
              n = true;
              e.off();
              t.call(this, e, ...i);
            }
          };
          this.listenTo(this, e, o, i);
        },
        off(e, t) {
          this.stopListening(this, e, t);
        },
        listenTo(e, t, i, n = {}) {
          let o, r;
          if (!this[as]) {
            this[as] = {};
          }
          const s = this[as];
          if (!fs(e)) {
            hs(e);
          }
          const a = fs(e);
          if (!(o = s[a])) {
            o = s[a] = { emitter: e, callbacks: {} };
          }
          if (!(r = o.callbacks[t])) {
            r = o.callbacks[t] = [];
          }
          r.push(i);
          ps(e, t);
          const c = bs(e, t);
          const l = os.get(n.priority);
          const d = { callback: i, priority: l };
          for (const e of c) {
            let t = false;
            for (let i = 0; i < e.length; i++) {
              if (e[i].priority < l) {
                e.splice(i, 0, d);
                t = true;
                break;
              }
            }
            if (!t) {
              e.push(d);
            }
          }
        },
        stopListening(e, t, i) {
          const n = this[as];
          let o = e && fs(e);
          const r = n && o && n[o];
          const s = r && t && r.callbacks[t];
          if (!n || (e && !r) || (t && !s)) {
            return;
          }
          if (i) {
            _s(e, t, i);
          } else if (s) {
            while ((i = s.pop())) {
              _s(e, t, i);
            }
            delete r.callbacks[t];
          } else if (r) {
            for (t in r.callbacks) {
              this.stopListening(e, t);
            }
            delete n[o];
          } else {
            for (o in n) {
              this.stopListening(n[o].emitter);
            }
            delete this[as];
          }
        },
        fire(e, ...t) {
          try {
            const i = e instanceof es ? e : new es(this, e);
            const n = i.name;
            let o = ws(this, n);
            i.path.push(this);
            if (o) {
              const e = [i, ...t];
              o = Array.from(o);
              for (let t = 0; t < o.length; t++) {
                o[t].callback.apply(this, e);
                if (i.off.called) {
                  delete i.off.called;
                  _s(this, n, o[t].callback);
                }
                if (i.stop.called) {
                  break;
                }
              }
            }
            if (this._delegations) {
              const e = this._delegations.get(n);
              const o = this._delegations.get('*');
              if (e) {
                ks(e, i, t);
              }
              if (o) {
                ks(o, i, t);
              }
            }
            return i.return;
          } catch (e) {
            ss['b'].rethrowUnexpectedError(e, this);
          }
        },
        delegate(...e) {
          return {
            to: (t, i) => {
              if (!this._delegations) {
                this._delegations = new Map();
              }
              e.forEach((e) => {
                const n = this._delegations.get(e);
                if (!n) {
                  this._delegations.set(e, new Map([[t, i]]));
                } else {
                  n.set(t, i);
                }
              });
            },
          };
        },
        stopDelegating(e, t) {
          if (!this._delegations) {
            return;
          }
          if (!e) {
            this._delegations.clear();
          } else if (!t) {
            this._delegations.delete(e);
          } else {
            const i = this._delegations.get(e);
            if (i) {
              i.delete(t);
            }
          }
        },
      };
      var ds = ls;
      function us(e, t) {
        if (e[as] && e[as][t]) {
          return e[as][t].emitter;
        }
        return null;
      }
      function hs(e, t) {
        if (!e[cs]) {
          e[cs] = t || is();
        }
      }
      function fs(e) {
        return e[cs];
      }
      function gs(e) {
        if (!e._events) {
          Object.defineProperty(e, '_events', { value: {} });
        }
        return e._events;
      }
      function ms() {
        return { callbacks: [], childEvents: [] };
      }
      function ps(e, t) {
        const i = gs(e);
        if (i[t]) {
          return;
        }
        let n = t;
        let o = null;
        const r = [];
        while (n !== '') {
          if (i[n]) {
            break;
          }
          i[n] = ms();
          r.push(i[n]);
          if (o) {
            i[n].childEvents.push(o);
          }
          o = n;
          n = n.substr(0, n.lastIndexOf(':'));
        }
        if (n !== '') {
          for (const e of r) {
            e.callbacks = i[n].callbacks.slice();
          }
          i[n].childEvents.push(o);
        }
      }
      function bs(e, t) {
        const i = gs(e)[t];
        if (!i) {
          return [];
        }
        let n = [i.callbacks];
        for (let t = 0; t < i.childEvents.length; t++) {
          const o = bs(e, i.childEvents[t]);
          n = n.concat(o);
        }
        return n;
      }
      function ws(e, t) {
        let i;
        if (!e._events || !(i = e._events[t]) || !i.callbacks.length) {
          if (t.indexOf(':') > -1) {
            return ws(e, t.substr(0, t.lastIndexOf(':')));
          } else {
            return null;
          }
        }
        return i.callbacks;
      }
      function ks(e, t, i) {
        for (let [n, o] of e) {
          if (!o) {
            o = t.name;
          } else if (typeof o == 'function') {
            o = o(t.name);
          }
          const e = new es(t.source, o);
          e.path = [...t.path];
          n.fire(e, ...i);
        }
      }
      function _s(e, t, i) {
        const n = bs(e, t);
        for (const e of n) {
          for (let t = 0; t < e.length; t++) {
            if (e[t].callback == i) {
              e.splice(t, 1);
              t--;
            }
          }
        }
      }
      function vs(e) {
        return !!(e && e[Symbol.iterator]);
      }
      function ys(e, ...t) {
        t.forEach((t) => {
          Object.getOwnPropertyNames(t)
            .concat(Object.getOwnPropertySymbols(t))
            .forEach((i) => {
              if (i in e.prototype) {
                return;
              }
              const n = Object.getOwnPropertyDescriptor(t, i);
              n.enumerable = false;
              Object.defineProperty(e.prototype, i, n);
            });
        });
      }
      class xs {
        constructor(e = {}, t = {}) {
          const i = vs(e);
          if (!i) {
            t = e;
          }
          this._items = [];
          this._itemMap = new Map();
          this._idProperty = t.idProperty || 'id';
          this._bindToExternalToInternalMap = new WeakMap();
          this._bindToInternalToExternalMap = new WeakMap();
          this._skippedIndexesFromExternal = [];
          if (i) {
            for (const t of e) {
              this._items.push(t);
              this._itemMap.set(this._getItemIdBeforeAdding(t), t);
            }
          }
        }
        get length() {
          return this._items.length;
        }
        get first() {
          return this._items[0] || null;
        }
        get last() {
          return this._items[this.length - 1] || null;
        }
        add(e, t) {
          return this.addMany([e], t);
        }
        addMany(e, t) {
          if (t === undefined) {
            t = this._items.length;
          } else if (t > this._items.length || t < 0) {
            throw new ss['b'](
              'collection-add-item-invalid-index: The index passed to Collection#addMany() is invalid.',
              this
            );
          }
          for (let i = 0; i < e.length; i++) {
            const n = e[i];
            const o = this._getItemIdBeforeAdding(n);
            const r = t + i;
            this._items.splice(r, 0, n);
            this._itemMap.set(o, n);
            this.fire('add', n, r);
          }
          this.fire('change', { added: e, removed: [], index: t });
          return this;
        }
        get(e) {
          let t;
          if (typeof e == 'string') {
            t = this._itemMap.get(e);
          } else if (typeof e == 'number') {
            t = this._items[e];
          } else {
            throw new ss['b'](
              'collection-get-invalid-arg: Index or id must be given.',
              this
            );
          }
          return t || null;
        }
        has(e) {
          if (typeof e == 'string') {
            return this._itemMap.has(e);
          } else {
            const t = this._idProperty;
            const i = e[t];
            return this._itemMap.has(i);
          }
        }
        getIndex(e) {
          let t;
          if (typeof e == 'string') {
            t = this._itemMap.get(e);
          } else {
            t = e;
          }
          return this._items.indexOf(t);
        }
        remove(e) {
          const [t, i] = this._remove(e);
          this.fire('change', { added: [], removed: [t], index: i });
          return t;
        }
        map(e, t) {
          return this._items.map(e, t);
        }
        find(e, t) {
          return this._items.find(e, t);
        }
        filter(e, t) {
          return this._items.filter(e, t);
        }
        clear() {
          if (this._bindToCollection) {
            this.stopListening(this._bindToCollection);
            this._bindToCollection = null;
          }
          const e = Array.from(this._items);
          while (this.length) {
            this._remove(0);
          }
          this.fire('change', { added: [], removed: e, index: 0 });
        }
        bindTo(e) {
          if (this._bindToCollection) {
            throw new ss['b'](
              'collection-bind-to-rebind: The collection cannot be bound more than once.',
              this
            );
          }
          this._bindToCollection = e;
          return {
            as: (e) => {
              this._setUpBindToBinding((t) => new e(t));
            },
            using: (e) => {
              if (typeof e == 'function') {
                this._setUpBindToBinding((t) => e(t));
              } else {
                this._setUpBindToBinding((t) => t[e]);
              }
            },
          };
        }
        _setUpBindToBinding(e) {
          const t = this._bindToCollection;
          const i = (i, n, o) => {
            const r = t._bindToCollection == this;
            const s = t._bindToInternalToExternalMap.get(n);
            if (r && s) {
              this._bindToExternalToInternalMap.set(n, s);
              this._bindToInternalToExternalMap.set(s, n);
            } else {
              const i = e(n);
              if (!i) {
                this._skippedIndexesFromExternal.push(o);
                return;
              }
              let r = o;
              for (const e of this._skippedIndexesFromExternal) {
                if (o > e) {
                  r--;
                }
              }
              for (const e of t._skippedIndexesFromExternal) {
                if (r >= e) {
                  r++;
                }
              }
              this._bindToExternalToInternalMap.set(n, i);
              this._bindToInternalToExternalMap.set(i, n);
              this.add(i, r);
              for (let e = 0; e < t._skippedIndexesFromExternal.length; e++) {
                if (r <= t._skippedIndexesFromExternal[e]) {
                  t._skippedIndexesFromExternal[e]++;
                }
              }
            }
          };
          for (const e of t) {
            i(null, e, t.getIndex(e));
          }
          this.listenTo(t, 'add', i);
          this.listenTo(t, 'remove', (e, t, i) => {
            const n = this._bindToExternalToInternalMap.get(t);
            if (n) {
              this.remove(n);
            }
            this._skippedIndexesFromExternal =
              this._skippedIndexesFromExternal.reduce((e, t) => {
                if (i < t) {
                  e.push(t - 1);
                }
                if (i > t) {
                  e.push(t);
                }
                return e;
              }, []);
          });
        }
        _getItemIdBeforeAdding(e) {
          const t = this._idProperty;
          let i;
          if (t in e) {
            i = e[t];
            if (typeof i != 'string') {
              throw new ss['b'](
                "collection-add-invalid-id: This item's id should be a string.",
                this
              );
            }
            if (this.get(i)) {
              throw new ss['b'](
                'collection-add-item-already-exists: This item already exists in the collection.',
                this
              );
            }
          } else {
            e[t] = i = is();
          }
          return i;
        }
        _remove(e) {
          let t, i, n;
          let o = false;
          const r = this._idProperty;
          if (typeof e == 'string') {
            i = e;
            n = this._itemMap.get(i);
            o = !n;
            if (n) {
              t = this._items.indexOf(n);
            }
          } else if (typeof e == 'number') {
            t = e;
            n = this._items[t];
            o = !n;
            if (n) {
              i = n[r];
            }
          } else {
            n = e;
            i = n[r];
            t = this._items.indexOf(n);
            o = t == -1 || !this._itemMap.get(i);
          }
          if (o) {
            throw new ss['b']('collection-remove-404: Item not found.', this);
          }
          this._items.splice(t, 1);
          this._itemMap.delete(i);
          const s = this._bindToInternalToExternalMap.get(n);
          this._bindToInternalToExternalMap.delete(n);
          this._bindToExternalToInternalMap.delete(s);
          this.fire('remove', n, t);
          return [n, t];
        }
        [Symbol.iterator]() {
          return this._items[Symbol.iterator]();
        }
      }
      ys(xs, ds);
      class As {
        constructor(e, t = [], i = []) {
          this._context = e;
          this._plugins = new Map();
          this._availablePlugins = new Map();
          for (const e of t) {
            if (e.pluginName) {
              this._availablePlugins.set(e.pluginName, e);
            }
          }
          this._contextPlugins = new Map();
          for (const [e, t] of i) {
            this._contextPlugins.set(e, t);
            this._contextPlugins.set(t, e);
            if (e.pluginName) {
              this._availablePlugins.set(e.pluginName, e);
            }
          }
        }
        *[Symbol.iterator]() {
          for (const e of this._plugins) {
            if (typeof e[0] == 'function') {
              yield e;
            }
          }
        }
        get(e) {
          const t = this._plugins.get(e);
          if (!t) {
            const t =
              'plugincollection-plugin-not-loaded: The requested plugin is not loaded.';
            let i = e;
            if (typeof e == 'function') {
              i = e.pluginName || e.name;
            }
            throw new ss['b'](t, this._context, { plugin: i });
          }
          return t;
        }
        has(e) {
          return this._plugins.has(e);
        }
        init(e, t = []) {
          const i = this;
          const n = this._context;
          const o = new Set();
          const r = [];
          const s = g(e);
          const a = g(t);
          const c = f(e);
          if (c) {
            const e =
              'plugincollection-plugin-not-found: Some plugins are not available and could not be loaded.';
            console.error(Object(ss['a'])(e), { plugins: c });
            return Promise.reject(new ss['b'](e, n, { plugins: c }));
          }
          return Promise.all(s.map(l))
            .then(() => d(r, 'init'))
            .then(() => d(r, 'afterInit'))
            .then(() => r);
          function l(e) {
            if (a.includes(e)) {
              return;
            }
            if (i._plugins.has(e) || o.has(e)) {
              return;
            }
            return u(e).catch((t) => {
              console.error(
                Object(ss['a'])(
                  'plugincollection-load: It was not possible to load the plugin.'
                ),
                { plugin: e }
              );
              throw t;
            });
          }
          function d(e, t) {
            return e.reduce((e, n) => {
              if (!n[t]) {
                return e;
              }
              if (i._contextPlugins.has(n)) {
                return e;
              }
              return e.then(n[t].bind(n));
            }, Promise.resolve());
          }
          function u(e) {
            return new Promise((s) => {
              o.add(e);
              if (e.requires) {
                e.requires.forEach((i) => {
                  const o = h(i);
                  if (e.isContextPlugin && !o.isContextPlugin) {
                    throw new ss['b'](
                      'plugincollection-context-required: Context plugin can not require plugin which is not a context plugin',
                      null,
                      { plugin: o.name, requiredBy: e.name }
                    );
                  }
                  if (t.includes(o)) {
                    throw new ss['b'](
                      'plugincollection-required: Cannot load a plugin because one of its dependencies is listed in' +
                        'the `removePlugins` option.',
                      n,
                      { plugin: o.name, requiredBy: e.name }
                    );
                  }
                  l(o);
                });
              }
              const a = i._contextPlugins.get(e) || new e(n);
              i._add(e, a);
              r.push(a);
              s();
            });
          }
          function h(e) {
            if (typeof e == 'function') {
              return e;
            }
            return i._availablePlugins.get(e);
          }
          function f(e) {
            const t = [];
            for (const i of e) {
              if (!h(i)) {
                t.push(i);
              }
            }
            return t.length ? t : null;
          }
          function g(e) {
            return e.map((e) => h(e)).filter((e) => !!e);
          }
        }
        destroy() {
          const e = [];
          for (const [, t] of this) {
            if (
              typeof t.destroy == 'function' &&
              !this._contextPlugins.has(t)
            ) {
              e.push(t.destroy());
            }
          }
          return Promise.all(e);
        }
        _add(e, t) {
          this._plugins.set(e, t);
          const i = e.pluginName;
          if (!i) {
            return;
          }
          if (this._plugins.has(i)) {
            throw new ss['b'](
              'plugincollection-plugin-name-conflict: Two plugins with the same name were loaded.',
              null,
              {
                pluginName: i,
                plugin1: this._plugins.get(i).constructor,
                plugin2: e,
              }
            );
          }
          this._plugins.set(i, t);
        }
      }
      ys(As, ds);
      if (!window.CKEDITOR_TRANSLATIONS) {
        window.CKEDITOR_TRANSLATIONS = {};
      }
      function Ts(e, t, i) {
        if (!window.CKEDITOR_TRANSLATIONS[e]) {
          window.CKEDITOR_TRANSLATIONS[e] = {};
        }
        const n = window.CKEDITOR_TRANSLATIONS[e];
        n.dictionary = n.dictionary || {};
        n.getPluralForm = i || n.getPluralForm;
        Object.assign(n.dictionary, t);
      }
      function Cs(e, t, i = 1) {
        if (typeof i !== 'number') {
          throw new ss['b'](
            'translation-service-quantity-not-a-number: Expecting `quantity` to be a number.',
            null,
            { quantity: i }
          );
        }
        const n = Ss();
        if (n === 1) {
          e = Object.keys(window.CKEDITOR_TRANSLATIONS)[0];
        }
        const o = t.id || t.string;
        if (n === 0 || !Es(e, o)) {
          if (i !== 1) {
            return t.plural;
          }
          return t.string;
        }
        const r = window.CKEDITOR_TRANSLATIONS[e].dictionary;
        const s =
          window.CKEDITOR_TRANSLATIONS[e].getPluralForm ||
          ((e) => (e === 1 ? 0 : 1));
        if (typeof r[o] === 'string') {
          return r[o];
        }
        const a = Number(s(i));
        return r[o][a];
      }
      function Ps() {
        window.CKEDITOR_TRANSLATIONS = {};
      }
      function Es(e, t) {
        return (
          !!window.CKEDITOR_TRANSLATIONS[e] &&
          !!window.CKEDITOR_TRANSLATIONS[e].dictionary[t]
        );
      }
      function Ss() {
        return Object.keys(window.CKEDITOR_TRANSLATIONS).length;
      }
      const Ms = ['ar', 'fa', 'he', 'ku', 'ug'];
      class Is {
        constructor(e = {}) {
          this.uiLanguage = e.uiLanguage || 'en';
          this.contentLanguage = e.contentLanguage || this.uiLanguage;
          this.uiLanguageDirection = Os(this.uiLanguage);
          this.contentLanguageDirection = Os(this.contentLanguage);
          this.t = (e, t) => this._t(e, t);
        }
        get language() {
          console.warn(
            'locale-deprecated-language-property: ' +
              'The Locale#language property has been deprecated and will be removed in the near future. ' +
              'Please use #uiLanguage and #contentLanguage properties instead.'
          );
          return this.uiLanguage;
        }
        _t(e, t = []) {
          if (!Array.isArray(t)) {
            t = [t];
          }
          if (typeof e === 'string') {
            e = { string: e };
          }
          const i = !!e.plural;
          const n = i ? t[0] : 1;
          const o = Cs(this.uiLanguage, e, n);
          return Ns(o, t);
        }
      }
      function Ns(e, t) {
        return e.replace(/%(\d+)/g, (e, i) => (i < t.length ? t[i] : e));
      }
      function Os(e) {
        return Ms.includes(e) ? 'rtl' : 'ltr';
      }
      class zs {
        constructor(e) {
          this.config = new Kr(e, this.constructor.defaultConfig);
          const t = this.constructor.builtinPlugins;
          this.config.define('plugins', t);
          this.plugins = new As(this, t);
          const i = this.config.get('language') || {};
          this.locale = new Is({
            uiLanguage: typeof i === 'string' ? i : i.ui,
            contentLanguage: this.config.get('language.content'),
          });
          this.t = this.locale.t;
          this.editors = new xs();
          this._contextOwner = null;
        }
        initPlugins() {
          const e = this.config.get('plugins') || [];
          for (const t of e) {
            if (typeof t != 'function') {
              throw new ss['b'](
                'context-initplugins-constructor-only: Only a constructor function is allowed as a context plugin.',
                null,
                { Plugin: t }
              );
            }
            if (t.isContextPlugin !== true) {
              throw new ss['b'](
                'context-initplugins-invalid-plugin: Only a plugin marked as a context plugin is allowed to be used with a context.',
                null,
                { Plugin: t }
              );
            }
          }
          return this.plugins.init(e);
        }
        destroy() {
          return Promise.all(Array.from(this.editors, (e) => e.destroy())).then(
            () => this.plugins.destroy()
          );
        }
        _addEditor(e, t) {
          if (this._contextOwner) {
            throw new ss['b'](
              'context-addEditor-private-context: Cannot add multiple editors to the context which is created by the editor.'
            );
          }
          this.editors.add(e);
          if (t) {
            this._contextOwner = e;
          }
        }
        _removeEditor(e) {
          if (this.editors.has(e)) {
            this.editors.remove(e);
          }
          if (this._contextOwner === e) {
            return this.destroy();
          }
          return Promise.resolve();
        }
        _getEditorConfig() {
          const e = {};
          for (const t of this.config.names()) {
            if (!['plugins', 'removePlugins', 'extraPlugins'].includes(t)) {
              e[t] = this.config.get(t);
            }
          }
          return e;
        }
        static create(e) {
          return new Promise((t) => {
            const i = new this(e);
            t(i.initPlugins().then(() => i));
          });
        }
      }
      function Rs(e, t) {
        const i = Math.min(e.length, t.length);
        for (let n = 0; n < i; n++) {
          if (e[n] != t[n]) {
            return n;
          }
        }
        if (e.length == t.length) {
          return 'same';
        } else if (e.length < t.length) {
          return 'prefix';
        } else {
          return 'extension';
        }
      }
      var Ls = 4;
      function Vs(e) {
        return Hr(e, Ls);
      }
      var Ds = Vs;
      class js {
        constructor(e) {
          this.document = e;
          this.parent = null;
        }
        get index() {
          let e;
          if (!this.parent) {
            return null;
          }
          if ((e = this.parent.getChildIndex(this)) == -1) {
            throw new ss['b'](
              "view-node-not-found-in-parent: The node's parent does not contain this node.",
              this
            );
          }
          return e;
        }
        get nextSibling() {
          const e = this.index;
          return (e !== null && this.parent.getChild(e + 1)) || null;
        }
        get previousSibling() {
          const e = this.index;
          return (e !== null && this.parent.getChild(e - 1)) || null;
        }
        get root() {
          let e = this;
          while (e.parent) {
            e = e.parent;
          }
          return e;
        }
        isAttached() {
          return this.root.is('rootElement');
        }
        getPath() {
          const e = [];
          let t = this;
          while (t.parent) {
            e.unshift(t.index);
            t = t.parent;
          }
          return e;
        }
        getAncestors(e = { includeSelf: false, parentFirst: false }) {
          const t = [];
          let i = e.includeSelf ? this : this.parent;
          while (i) {
            t[e.parentFirst ? 'push' : 'unshift'](i);
            i = i.parent;
          }
          return t;
        }
        getCommonAncestor(e, t = {}) {
          const i = this.getAncestors(t);
          const n = e.getAncestors(t);
          let o = 0;
          while (i[o] == n[o] && i[o]) {
            o++;
          }
          return o === 0 ? null : i[o - 1];
        }
        isBefore(e) {
          if (this == e) {
            return false;
          }
          if (this.root !== e.root) {
            return false;
          }
          const t = this.getPath();
          const i = e.getPath();
          const n = Rs(t, i);
          switch (n) {
            case 'prefix':
              return true;
            case 'extension':
              return false;
            default:
              return t[n] < i[n];
          }
        }
        isAfter(e) {
          if (this == e) {
            return false;
          }
          if (this.root !== e.root) {
            return false;
          }
          return !this.isBefore(e);
        }
        _remove() {
          this.parent._removeChildren(this.index);
        }
        _fireChange(e, t) {
          this.fire('change:' + e, t);
          if (this.parent) {
            this.parent._fireChange(e, t);
          }
        }
        toJSON() {
          const e = Ds(this);
          delete e.parent;
          return e;
        }
        is(e) {
          return e === 'node' || e === 'view:node';
        }
      }
      ys(js, ds);
      class Bs extends js {
        constructor(e, t) {
          super(e);
          this._textData = t;
        }
        is(e) {
          return (
            e === '$text' ||
            e === 'view:$text' ||
            e === 'text' ||
            e === 'view:text' ||
            e === 'node' ||
            e === 'view:node'
          );
        }
        get data() {
          return this._textData;
        }
        get _data() {
          return this.data;
        }
        set _data(e) {
          this._fireChange('text', this);
          this._textData = e;
        }
        isSimilar(e) {
          if (!(e instanceof Bs)) {
            return false;
          }
          return this === e || this.data === e.data;
        }
        _clone() {
          return new Bs(this.document, this.data);
        }
      }
      class Fs {
        constructor(e, t, i) {
          this.textNode = e;
          if (t < 0 || t > e.data.length) {
            throw new ss['b'](
              'view-textproxy-wrong-offsetintext: Given offsetInText value is incorrect.',
              this
            );
          }
          if (i < 0 || t + i > e.data.length) {
            throw new ss['b'](
              'view-textproxy-wrong-length: Given length value is incorrect.',
              this
            );
          }
          this.data = e.data.substring(t, t + i);
          this.offsetInText = t;
        }
        get offsetSize() {
          return this.data.length;
        }
        get isPartial() {
          return this.data.length !== this.textNode.data.length;
        }
        get parent() {
          return this.textNode.parent;
        }
        get root() {
          return this.textNode.root;
        }
        get document() {
          return this.textNode.document;
        }
        is(e) {
          return (
            e === '$textProxy' ||
            e === 'view:$textProxy' ||
            e === 'textProxy' ||
            e === 'view:textProxy'
          );
        }
        getAncestors(e = { includeSelf: false, parentFirst: false }) {
          const t = [];
          let i = e.includeSelf ? this.textNode : this.parent;
          while (i !== null) {
            t[e.parentFirst ? 'push' : 'unshift'](i);
            i = i.parent;
          }
          return t;
        }
      }
      function Hs(e) {
        const t = new Map();
        for (const i in e) {
          t.set(i, e[i]);
        }
        return t;
      }
      function Us(e) {
        if (vs(e)) {
          return new Map(e);
        } else {
          return Hs(e);
        }
      }
      class qs {
        constructor(...e) {
          this._patterns = [];
          this.add(...e);
        }
        add(...e) {
          for (let t of e) {
            if (typeof t == 'string' || t instanceof RegExp) {
              t = { name: t };
            }
            if (
              t.classes &&
              (typeof t.classes == 'string' || t.classes instanceof RegExp)
            ) {
              t.classes = [t.classes];
            }
            this._patterns.push(t);
          }
        }
        match(...e) {
          for (const t of e) {
            for (const e of this._patterns) {
              const i = Ws(t, e);
              if (i) {
                return { element: t, pattern: e, match: i };
              }
            }
          }
          return null;
        }
        matchAll(...e) {
          const t = [];
          for (const i of e) {
            for (const e of this._patterns) {
              const n = Ws(i, e);
              if (n) {
                t.push({ element: i, pattern: e, match: n });
              }
            }
          }
          return t.length > 0 ? t : null;
        }
        getElementName() {
          if (this._patterns.length !== 1) {
            return null;
          }
          const e = this._patterns[0];
          const t = e.name;
          return typeof e != 'function' && t && !(t instanceof RegExp)
            ? t
            : null;
        }
      }
      function Ws(e, t) {
        if (typeof t == 'function') {
          return t(e);
        }
        const i = {};
        if (t.name) {
          i.name = $s(t.name, e.name);
          if (!i.name) {
            return null;
          }
        }
        if (t.attributes) {
          i.attributes = Gs(t.attributes, e);
          if (!i.attributes) {
            return null;
          }
        }
        if (t.classes) {
          i.classes = Ys(t.classes, e);
          if (!i.classes) {
            return false;
          }
        }
        if (t.styles) {
          i.styles = Ks(t.styles, e);
          if (!i.styles) {
            return false;
          }
        }
        return i;
      }
      function $s(e, t) {
        if (e instanceof RegExp) {
          return e.test(t);
        }
        return e === t;
      }
      function Gs(e, t) {
        const i = [];
        for (const n in e) {
          const o = e[n];
          if (t.hasAttribute(n)) {
            const e = t.getAttribute(n);
            if (o === true) {
              i.push(n);
            } else if (o instanceof RegExp) {
              if (o.test(e)) {
                i.push(n);
              } else {
                return null;
              }
            } else if (e === o) {
              i.push(n);
            } else {
              return null;
            }
          } else {
            return null;
          }
        }
        return i;
      }
      function Ys(e, t) {
        const i = [];
        for (const n of e) {
          if (n instanceof RegExp) {
            const e = t.getClassNames();
            for (const t of e) {
              if (n.test(t)) {
                i.push(t);
              }
            }
            if (i.length === 0) {
              return null;
            }
          } else if (t.hasClass(n)) {
            i.push(n);
          } else {
            return null;
          }
        }
        return i;
      }
      function Ks(e, t) {
        const i = [];
        for (const n in e) {
          const o = e[n];
          if (t.hasStyle(n)) {
            const e = t.getStyle(n);
            if (o instanceof RegExp) {
              if (o.test(e)) {
                i.push(n);
              } else {
                return null;
              }
            } else if (e === o) {
              i.push(n);
            } else {
              return null;
            }
          } else {
            return null;
          }
        }
        return i;
      }
      var Qs = '[object Symbol]';
      function Js(e) {
        return typeof e == 'symbol' || (C(e) && _(e) == Qs);
      }
      var Zs = Js;
      var Xs = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
        ea = /^\w*$/;
      function ta(e, t) {
        if (Kt(e)) {
          return false;
        }
        var i = typeof e;
        if (
          i == 'number' ||
          i == 'symbol' ||
          i == 'boolean' ||
          e == null ||
          Zs(e)
        ) {
          return true;
        }
        return ea.test(e) || !Xs.test(e) || (t != null && e in Object(t));
      }
      var ia = ta;
      var na = 'Expected a function';
      function oa(e, t) {
        if (typeof e != 'function' || (t != null && typeof t != 'function')) {
          throw new TypeError(na);
        }
        var i = function () {
          var n = arguments,
            o = t ? t.apply(this, n) : n[0],
            r = i.cache;
          if (r.has(o)) {
            return r.get(o);
          }
          var s = e.apply(this, n);
          i.cache = r.set(o, s) || r;
          return s;
        };
        i.cache = new (oa.Cache || _t)();
        return i;
      }
      oa.Cache = _t;
      var ra = oa;
      var sa = 500;
      function aa(e) {
        var t = ra(e, function (e) {
          if (i.size === sa) {
            i.clear();
          }
          return e;
        });
        var i = t.cache;
        return t;
      }
      var ca = aa;
      var la =
        /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
      var da = /\\(\\)?/g;
      var ua = ca(function (e) {
        var t = [];
        if (e.charCodeAt(0) === 46) {
          t.push('');
        }
        e.replace(la, function (e, i, n, o) {
          t.push(n ? o.replace(da, '$1') : i || e);
        });
        return t;
      });
      var ha = ua;
      function fa(e, t) {
        var i = -1,
          n = e == null ? 0 : e.length,
          o = Array(n);
        while (++i < n) {
          o[i] = t(e[i], i, e);
        }
        return o;
      }
      var ga = fa;
      var ma = 1 / 0;
      var pa = r ? r.prototype : undefined,
        ba = pa ? pa.toString : undefined;
      function wa(e) {
        if (typeof e == 'string') {
          return e;
        }
        if (Kt(e)) {
          return ga(e, wa) + '';
        }
        if (Zs(e)) {
          return ba ? ba.call(e) : '';
        }
        var t = e + '';
        return t == '0' && 1 / e == -ma ? '-0' : t;
      }
      var ka = wa;
      function _a(e) {
        return e == null ? '' : ka(e);
      }
      var va = _a;
      function ya(e, t) {
        if (Kt(e)) {
          return e;
        }
        return ia(e, t) ? [e] : ha(va(e));
      }
      var xa = ya;
      function Aa(e) {
        var t = e == null ? 0 : e.length;
        return t ? e[t - 1] : undefined;
      }
      var Ta = Aa;
      var Ca = 1 / 0;
      function Pa(e) {
        if (typeof e == 'string' || Zs(e)) {
          return e;
        }
        var t = e + '';
        return t == '0' && 1 / e == -Ca ? '-0' : t;
      }
      var Ea = Pa;
      function Sa(e, t) {
        t = xa(t, e);
        var i = 0,
          n = t.length;
        while (e != null && i < n) {
          e = e[Ea(t[i++])];
        }
        return i && i == n ? e : undefined;
      }
      var Ma = Sa;
      function Ia(e, t, i) {
        var n = -1,
          o = e.length;
        if (t < 0) {
          t = -t > o ? 0 : o + t;
        }
        i = i > o ? o : i;
        if (i < 0) {
          i += o;
        }
        o = t > i ? 0 : (i - t) >>> 0;
        t >>>= 0;
        var r = Array(o);
        while (++n < o) {
          r[n] = e[n + t];
        }
        return r;
      }
      var Na = Ia;
      function Oa(e, t) {
        return t.length < 2 ? e : Ma(e, Na(t, 0, -1));
      }
      var za = Oa;
      function Ra(e, t) {
        t = xa(t, e);
        e = za(e, t);
        return e == null || delete e[Ea(Ta(t))];
      }
      var La = Ra;
      function Va(e, t) {
        return e == null ? true : La(e, t);
      }
      var Da = Va;
      function ja(e, t, i) {
        var n = e == null ? undefined : Ma(e, t);
        return n === undefined ? i : n;
      }
      var Ba = ja;
      function Fa(e, t, i) {
        if (
          (i !== undefined && !D(e[t], i)) ||
          (i === undefined && !(t in e))
        ) {
          It(e, t, i);
        }
      }
      var Ha = Fa;
      function Ua(e) {
        return function (t, i, n) {
          var o = -1,
            r = Object(t),
            s = n(t),
            a = s.length;
          while (a--) {
            var c = s[e ? a : ++o];
            if (i(r[c], c, r) === false) {
              break;
            }
          }
          return t;
        };
      }
      var qa = Ua;
      var Wa = qa();
      var $a = Wa;
      function Ga(e) {
        return C(e) && Ji(e);
      }
      var Ya = Ga;
      function Ka(e, t) {
        if (t === 'constructor' && typeof e[t] === 'function') {
          return;
        }
        if (t == '__proto__') {
          return;
        }
        return e[t];
      }
      var Qa = Ka;
      function Ja(e) {
        return Vt(e, dn(e));
      }
      var Za = Ja;
      function Xa(e, t, i, n, o, r, s) {
        var a = Qa(e, i),
          c = Qa(t, i),
          l = s.get(c);
        if (l) {
          Ha(e, i, l);
          return;
        }
        var d = r ? r(a, c, i + '', e, t, s) : undefined;
        var u = d === undefined;
        if (u) {
          var h = Kt(c),
            f = !h && Object(Qt['a'])(c),
            g = !h && !f && Li(c);
          d = c;
          if (h || f || g) {
            if (Kt(a)) {
              d = a;
            } else if (Ya(a)) {
              d = mn(a);
            } else if (f) {
              u = false;
              d = Object(fn['a'])(c, true);
            } else if (g) {
              u = false;
              d = Co(c, true);
            } else {
              d = [];
            }
          } else if (z(c) || Gt(c)) {
            d = a;
            if (Gt(a)) {
              d = Za(a);
            } else if (!ce(a) || ge(a)) {
              d = Zo(c);
            }
          } else {
            u = false;
          }
        }
        if (u) {
          s.set(c, d);
          o(d, c, n, r, s);
          s['delete'](c);
        }
        Ha(e, i, d);
      }
      var ec = Xa;
      function tc(e, t, i, n, o) {
        if (e === t) {
          return;
        }
        $a(
          t,
          function (r, s) {
            o || (o = new Tt());
            if (ce(r)) {
              ec(e, t, s, i, tc, n, o);
            } else {
              var a = n ? n(Qa(e, s), r, s + '', e, t, o) : undefined;
              if (a === undefined) {
                a = r;
              }
              Ha(e, s, a);
            }
          },
          dn
        );
      }
      var ic = tc;
      function nc(e) {
        return e;
      }
      var oc = nc;
      function rc(e, t, i) {
        switch (i.length) {
          case 0:
            return e.call(t);
          case 1:
            return e.call(t, i[0]);
          case 2:
            return e.call(t, i[0], i[1]);
          case 3:
            return e.call(t, i[0], i[1], i[2]);
        }
        return e.apply(t, i);
      }
      var sc = rc;
      var ac = Math.max;
      function cc(e, t, i) {
        t = ac(t === undefined ? e.length - 1 : t, 0);
        return function () {
          var n = arguments,
            o = -1,
            r = ac(n.length - t, 0),
            s = Array(r);
          while (++o < r) {
            s[o] = n[t + o];
          }
          o = -1;
          var a = Array(t + 1);
          while (++o < t) {
            a[o] = n[o];
          }
          a[t] = i(s);
          return sc(e, this, a);
        };
      }
      var lc = cc;
      function dc(e) {
        return function () {
          return e;
        };
      }
      var uc = dc;
      var hc = !St
        ? oc
        : function (e, t) {
            return St(e, 'toString', {
              configurable: true,
              enumerable: false,
              value: uc(t),
              writable: true,
            });
          };
      var fc = hc;
      var gc = 800,
        mc = 16;
      var pc = Date.now;
      function bc(e) {
        var t = 0,
          i = 0;
        return function () {
          var n = pc(),
            o = mc - (n - i);
          i = n;
          if (o > 0) {
            if (++t >= gc) {
              return arguments[0];
            }
          } else {
            t = 0;
          }
          return e.apply(undefined, arguments);
        };
      }
      var wc = bc;
      var kc = wc(fc);
      var _c = kc;
      function vc(e, t) {
        return _c(lc(e, t, oc), e + '');
      }
      var yc = vc;
      function xc(e, t, i) {
        if (!ce(i)) {
          return false;
        }
        var n = typeof t;
        if (
          n == 'number' ? Ji(i) && ei(t, i.length) : n == 'string' && t in i
        ) {
          return D(i[t], e);
        }
        return false;
      }
      var Ac = xc;
      function Tc(e) {
        return yc(function (t, i) {
          var n = -1,
            o = i.length,
            r = o > 1 ? i[o - 1] : undefined,
            s = o > 2 ? i[2] : undefined;
          r = e.length > 3 && typeof r == 'function' ? (o--, r) : undefined;
          if (s && Ac(i[0], i[1], s)) {
            r = o < 3 ? undefined : r;
            o = 1;
          }
          t = Object(t);
          while (++n < o) {
            var a = i[n];
            if (a) {
              e(t, a, n, r);
            }
          }
          return t;
        });
      }
      var Cc = Tc;
      var Pc = Cc(function (e, t, i) {
        ic(e, t, i);
      });
      var Ec = Pc;
      function Sc(e, t, i, n) {
        if (!ce(e)) {
          return e;
        }
        t = xa(t, e);
        var o = -1,
          r = t.length,
          s = r - 1,
          a = e;
        while (a != null && ++o < r) {
          var c = Ea(t[o]),
            l = i;
          if (o != s) {
            var d = a[c];
            l = n ? n(d, c, a) : undefined;
            if (l === undefined) {
              l = ce(d) ? d : ei(t[o + 1]) ? [] : {};
            }
          }
          Rt(a, c, l);
          a = a[c];
        }
        return e;
      }
      var Mc = Sc;
      function Ic(e, t, i) {
        return e == null ? e : Mc(e, t, i);
      }
      var Nc = Ic;
      class Oc {
        constructor(e) {
          this._styles = {};
          this._styleProcessor = e;
        }
        get isEmpty() {
          const e = Object.entries(this._styles);
          const t = Array.from(e);
          return !t.length;
        }
        get size() {
          if (this.isEmpty) {
            return 0;
          }
          return this.getStyleNames().length;
        }
        setTo(e) {
          this.clear();
          const t = Array.from(Rc(e).entries());
          for (const [e, i] of t) {
            this._styleProcessor.toNormalizedForm(e, i, this._styles);
          }
        }
        has(e) {
          if (this.isEmpty) {
            return false;
          }
          const t = this._styleProcessor.getReducedForm(e, this._styles);
          const i = t.find(([t]) => t === e);
          return Array.isArray(i);
        }
        set(e, t) {
          if (ce(e)) {
            for (const [t, i] of Object.entries(e)) {
              this._styleProcessor.toNormalizedForm(t, i, this._styles);
            }
          } else {
            this._styleProcessor.toNormalizedForm(e, t, this._styles);
          }
        }
        remove(e) {
          const t = Lc(e);
          Da(this._styles, t);
          delete this._styles[e];
          this._cleanEmptyObjectsOnPath(t);
        }
        getNormalized(e) {
          return this._styleProcessor.getNormalized(e, this._styles);
        }
        toString() {
          if (this.isEmpty) {
            return '';
          }
          return (
            this._getStylesEntries()
              .map((e) => e.join(':'))
              .sort()
              .join(';') + ';'
          );
        }
        getAsString(e) {
          if (this.isEmpty) {
            return;
          }
          if (this._styles[e] && !ce(this._styles[e])) {
            return this._styles[e];
          }
          const t = this._styleProcessor.getReducedForm(e, this._styles);
          const i = t.find(([t]) => t === e);
          if (Array.isArray(i)) {
            return i[1];
          }
        }
        getStyleNames() {
          if (this.isEmpty) {
            return [];
          }
          const e = this._getStylesEntries();
          return e.map(([e]) => e);
        }
        clear() {
          this._styles = {};
        }
        _getStylesEntries() {
          const e = [];
          const t = Object.keys(this._styles);
          for (const i of t) {
            e.push(...this._styleProcessor.getReducedForm(i, this._styles));
          }
          return e;
        }
        _cleanEmptyObjectsOnPath(e) {
          const t = e.split('.');
          const i = t.length > 1;
          if (!i) {
            return;
          }
          const n = t.splice(0, t.length - 1).join('.');
          const o = Ba(this._styles, n);
          if (!o) {
            return;
          }
          const r = !Array.from(Object.keys(o)).length;
          if (r) {
            this.remove(n);
          }
        }
      }
      class zc {
        constructor() {
          this._normalizers = new Map();
          this._extractors = new Map();
          this._reducers = new Map();
          this._consumables = new Map();
        }
        toNormalizedForm(e, t, i) {
          if (ce(t)) {
            Vc(i, Lc(e), t);
            return;
          }
          if (this._normalizers.has(e)) {
            const n = this._normalizers.get(e);
            const { path: o, value: r } = n(t);
            Vc(i, o, r);
          } else {
            Vc(i, e, t);
          }
        }
        getNormalized(e, t) {
          if (!e) {
            return Ec({}, t);
          }
          if (t[e] !== undefined) {
            return t[e];
          }
          if (this._extractors.has(e)) {
            const i = this._extractors.get(e);
            if (typeof i === 'string') {
              return Ba(t, i);
            }
            const n = i(e, t);
            if (n) {
              return n;
            }
          }
          return Ba(t, Lc(e));
        }
        getReducedForm(e, t) {
          const i = this.getNormalized(e, t);
          if (i === undefined) {
            return [];
          }
          if (this._reducers.has(e)) {
            const t = this._reducers.get(e);
            return t(i);
          }
          return [[e, i]];
        }
        getRelatedStyles(e) {
          return this._consumables.get(e) || [];
        }
        setNormalizer(e, t) {
          this._normalizers.set(e, t);
        }
        setExtractor(e, t) {
          this._extractors.set(e, t);
        }
        setReducer(e, t) {
          this._reducers.set(e, t);
        }
        setStyleRelation(e, t) {
          this._mapStyleNames(e, t);
          for (const i of t) {
            this._mapStyleNames(i, [e]);
          }
        }
        _mapStyleNames(e, t) {
          if (!this._consumables.has(e)) {
            this._consumables.set(e, []);
          }
          this._consumables.get(e).push(...t);
        }
      }
      function Rc(e) {
        let t = null;
        let i = 0;
        let n = 0;
        let o = null;
        const r = new Map();
        if (e === '') {
          return r;
        }
        if (e.charAt(e.length - 1) != ';') {
          e = e + ';';
        }
        for (let s = 0; s < e.length; s++) {
          const a = e.charAt(s);
          if (t === null) {
            switch (a) {
              case ':':
                if (!o) {
                  o = e.substr(i, s - i);
                  n = s + 1;
                }
                break;
              case '"':
              case "'":
                t = a;
                break;
              case ';': {
                const t = e.substr(n, s - n);
                if (o) {
                  r.set(o.trim(), t.trim());
                }
                o = null;
                i = s + 1;
                break;
              }
            }
          } else if (a === t) {
            t = null;
          }
        }
        return r;
      }
      function Lc(e) {
        return e.replace('-', '.');
      }
      function Vc(e, t, i) {
        let n = i;
        if (ce(i)) {
          n = Ec({}, Ba(e, t), i);
        }
        Nc(e, t, n);
      }
      class Dc extends js {
        constructor(e, t, i, n) {
          super(e);
          this.name = t;
          this._attrs = jc(i);
          this._children = [];
          if (n) {
            this._insertChild(0, n);
          }
          this._classes = new Set();
          if (this._attrs.has('class')) {
            const e = this._attrs.get('class');
            Bc(this._classes, e);
            this._attrs.delete('class');
          }
          this._styles = new Oc(this.document.stylesProcessor);
          if (this._attrs.has('style')) {
            this._styles.setTo(this._attrs.get('style'));
            this._attrs.delete('style');
          }
          this._customProperties = new Map();
        }
        get childCount() {
          return this._children.length;
        }
        get isEmpty() {
          return this._children.length === 0;
        }
        is(e, t = null) {
          if (!t) {
            return (
              e === 'element' ||
              e === 'view:element' ||
              e === 'node' ||
              e === 'view:node'
            );
          } else {
            return t === this.name && (e === 'element' || e === 'view:element');
          }
        }
        getChild(e) {
          return this._children[e];
        }
        getChildIndex(e) {
          return this._children.indexOf(e);
        }
        getChildren() {
          return this._children[Symbol.iterator]();
        }
        *getAttributeKeys() {
          if (this._classes.size > 0) {
            yield 'class';
          }
          if (!this._styles.isEmpty) {
            yield 'style';
          }
          yield* this._attrs.keys();
        }
        *getAttributes() {
          yield* this._attrs.entries();
          if (this._classes.size > 0) {
            yield ['class', this.getAttribute('class')];
          }
          if (!this._styles.isEmpty) {
            yield ['style', this.getAttribute('style')];
          }
        }
        getAttribute(e) {
          if (e == 'class') {
            if (this._classes.size > 0) {
              return [...this._classes].join(' ');
            }
            return undefined;
          }
          if (e == 'style') {
            const e = this._styles.toString();
            return e == '' ? undefined : e;
          }
          return this._attrs.get(e);
        }
        hasAttribute(e) {
          if (e == 'class') {
            return this._classes.size > 0;
          }
          if (e == 'style') {
            return !this._styles.isEmpty;
          }
          return this._attrs.has(e);
        }
        isSimilar(e) {
          if (!(e instanceof Dc)) {
            return false;
          }
          if (this === e) {
            return true;
          }
          if (this.name != e.name) {
            return false;
          }
          if (
            this._attrs.size !== e._attrs.size ||
            this._classes.size !== e._classes.size ||
            this._styles.size !== e._styles.size
          ) {
            return false;
          }
          for (const [t, i] of this._attrs) {
            if (!e._attrs.has(t) || e._attrs.get(t) !== i) {
              return false;
            }
          }
          for (const t of this._classes) {
            if (!e._classes.has(t)) {
              return false;
            }
          }
          for (const t of this._styles.getStyleNames()) {
            if (
              !e._styles.has(t) ||
              e._styles.getAsString(t) !== this._styles.getAsString(t)
            ) {
              return false;
            }
          }
          return true;
        }
        hasClass(...e) {
          for (const t of e) {
            if (!this._classes.has(t)) {
              return false;
            }
          }
          return true;
        }
        getClassNames() {
          return this._classes.keys();
        }
        getStyle(e) {
          return this._styles.getAsString(e);
        }
        getNormalizedStyle(e) {
          return this._styles.getNormalized(e);
        }
        getStyleNames() {
          return this._styles.getStyleNames();
        }
        hasStyle(...e) {
          for (const t of e) {
            if (!this._styles.has(t)) {
              return false;
            }
          }
          return true;
        }
        findAncestor(...e) {
          const t = new qs(...e);
          let i = this.parent;
          while (i) {
            if (t.match(i)) {
              return i;
            }
            i = i.parent;
          }
          return null;
        }
        getCustomProperty(e) {
          return this._customProperties.get(e);
        }
        *getCustomProperties() {
          yield* this._customProperties.entries();
        }
        getIdentity() {
          const e = Array.from(this._classes).sort().join(',');
          const t = this._styles.toString();
          const i = Array.from(this._attrs)
            .map((e) => `${e[0]}="${e[1]}"`)
            .sort()
            .join(' ');
          return (
            this.name +
            (e == '' ? '' : ` class="${e}"`) +
            (!t ? '' : ` style="${t}"`) +
            (i == '' ? '' : ` ${i}`)
          );
        }
        _clone(e = false) {
          const t = [];
          if (e) {
            for (const i of this.getChildren()) {
              t.push(i._clone(e));
            }
          }
          const i = new this.constructor(
            this.document,
            this.name,
            this._attrs,
            t
          );
          i._classes = new Set(this._classes);
          i._styles.set(this._styles.getNormalized());
          i._customProperties = new Map(this._customProperties);
          i.getFillerOffset = this.getFillerOffset;
          return i;
        }
        _appendChild(e) {
          return this._insertChild(this.childCount, e);
        }
        _insertChild(e, t) {
          this._fireChange('children', this);
          let i = 0;
          const n = Fc(this.document, t);
          for (const t of n) {
            if (t.parent !== null) {
              t._remove();
            }
            t.parent = this;
            t.document = this.document;
            this._children.splice(e, 0, t);
            e++;
            i++;
          }
          return i;
        }
        _removeChildren(e, t = 1) {
          this._fireChange('children', this);
          for (let i = e; i < e + t; i++) {
            this._children[i].parent = null;
          }
          return this._children.splice(e, t);
        }
        _setAttribute(e, t) {
          t = String(t);
          this._fireChange('attributes', this);
          if (e == 'class') {
            Bc(this._classes, t);
          } else if (e == 'style') {
            this._styles.setTo(t);
          } else {
            this._attrs.set(e, t);
          }
        }
        _removeAttribute(e) {
          this._fireChange('attributes', this);
          if (e == 'class') {
            if (this._classes.size > 0) {
              this._classes.clear();
              return true;
            }
            return false;
          }
          if (e == 'style') {
            if (!this._styles.isEmpty) {
              this._styles.clear();
              return true;
            }
            return false;
          }
          return this._attrs.delete(e);
        }
        _addClass(e) {
          this._fireChange('attributes', this);
          e = Array.isArray(e) ? e : [e];
          e.forEach((e) => this._classes.add(e));
        }
        _removeClass(e) {
          this._fireChange('attributes', this);
          e = Array.isArray(e) ? e : [e];
          e.forEach((e) => this._classes.delete(e));
        }
        _setStyle(e, t) {
          this._fireChange('attributes', this);
          this._styles.set(e, t);
        }
        _removeStyle(e) {
          this._fireChange('attributes', this);
          e = Array.isArray(e) ? e : [e];
          e.forEach((e) => this._styles.remove(e));
        }
        _setCustomProperty(e, t) {
          this._customProperties.set(e, t);
        }
        _removeCustomProperty(e) {
          return this._customProperties.delete(e);
        }
      }
      function jc(e) {
        e = Us(e);
        for (const [t, i] of e) {
          if (i === null) {
            e.delete(t);
          } else if (typeof i != 'string') {
            e.set(t, String(i));
          }
        }
        return e;
      }
      function Bc(e, t) {
        const i = t.split(/\s+/);
        e.clear();
        i.forEach((t) => e.add(t));
      }
      function Fc(e, t) {
        if (typeof t == 'string') {
          return [new Bs(e, t)];
        }
        if (!vs(t)) {
          t = [t];
        }
        return Array.from(t).map((t) => {
          if (typeof t == 'string') {
            return new Bs(e, t);
          }
          if (t instanceof Fs) {
            return new Bs(e, t.data);
          }
          return t;
        });
      }
      class Hc extends Dc {
        constructor(e, t, i, n) {
          super(e, t, i, n);
          this.getFillerOffset = Uc;
        }
        is(e, t = null) {
          if (!t) {
            return (
              e === 'containerElement' ||
              e === 'view:containerElement' ||
              e === 'element' ||
              e === 'view:element' ||
              e === 'node' ||
              e === 'view:node'
            );
          } else {
            return (
              t === this.name &&
              (e === 'containerElement' ||
                e === 'view:containerElement' ||
                e === 'element' ||
                e === 'view:element')
            );
          }
        }
      }
      function Uc() {
        const e = [...this.getChildren()];
        const t = e[this.childCount - 1];
        if (t && t.is('element', 'br')) {
          return this.childCount;
        }
        for (const t of e) {
          if (!t.is('uiElement')) {
            return null;
          }
        }
        return this.childCount;
      }
      var qc = Cc(function (e, t) {
        Vt(t, dn(t), e);
      });
      var Wc = qc;
      const $c = Symbol('observableProperties');
      const Gc = Symbol('boundObservables');
      const Yc = Symbol('boundProperties');
      const Kc = {
        set(e, t) {
          if (ce(e)) {
            Object.keys(e).forEach((t) => {
              this.set(t, e[t]);
            }, this);
            return;
          }
          Jc(this);
          const i = this[$c];
          if (e in this && !i.has(e)) {
            throw new ss['b'](
              'observable-set-cannot-override: Cannot override an existing property.',
              this
            );
          }
          Object.defineProperty(this, e, {
            enumerable: true,
            configurable: true,
            get() {
              return i.get(e);
            },
            set(t) {
              const n = i.get(e);
              let o = this.fire('set:' + e, e, t, n);
              if (o === undefined) {
                o = t;
              }
              if (n !== o || !i.has(e)) {
                i.set(e, o);
                this.fire('change:' + e, e, o, n);
              }
            },
          });
          this[e] = t;
        },
        bind(...e) {
          if (!e.length || !tl(e)) {
            throw new ss['b'](
              'observable-bind-wrong-properties: All properties must be strings.',
              this
            );
          }
          if (new Set(e).size !== e.length) {
            throw new ss['b'](
              'observable-bind-duplicate-properties: Properties must be unique.',
              this
            );
          }
          Jc(this);
          const t = this[Yc];
          e.forEach((e) => {
            if (t.has(e)) {
              throw new ss['b'](
                'observable-bind-rebind: Cannot bind the same property more than once.',
                this
              );
            }
          });
          const i = new Map();
          e.forEach((e) => {
            const n = { property: e, to: [] };
            t.set(e, n);
            i.set(e, n);
          });
          return {
            to: Zc,
            toMany: Xc,
            _observable: this,
            _bindProperties: e,
            _to: [],
            _bindings: i,
          };
        },
        unbind(...e) {
          if (!this[$c]) {
            return;
          }
          const t = this[Yc];
          const i = this[Gc];
          if (e.length) {
            if (!tl(e)) {
              throw new ss['b'](
                'observable-unbind-wrong-properties: Properties must be strings.',
                this
              );
            }
            e.forEach((e) => {
              const n = t.get(e);
              if (!n) {
                return;
              }
              let o, r, s, a;
              n.to.forEach((e) => {
                o = e[0];
                r = e[1];
                s = i.get(o);
                a = s[r];
                a.delete(n);
                if (!a.size) {
                  delete s[r];
                }
                if (!Object.keys(s).length) {
                  i.delete(o);
                  this.stopListening(o, 'change');
                }
              });
              t.delete(e);
            });
          } else {
            i.forEach((e, t) => {
              this.stopListening(t, 'change');
            });
            i.clear();
            t.clear();
          }
        },
        decorate(e) {
          const t = this[e];
          if (!t) {
            throw new ss['b'](
              'observablemixin-cannot-decorate-undefined: Cannot decorate an undefined method.',
              this,
              { object: this, methodName: e }
            );
          }
          this.on(e, (e, i) => {
            e.return = t.apply(this, i);
          });
          this[e] = function (...t) {
            return this.fire(e, t);
          };
        },
      };
      Wc(Kc, ds);
      var Qc = Kc;
      function Jc(e) {
        if (e[$c]) {
          return;
        }
        Object.defineProperty(e, $c, { value: new Map() });
        Object.defineProperty(e, Gc, { value: new Map() });
        Object.defineProperty(e, Yc, { value: new Map() });
      }
      function Zc(...e) {
        const t = il(...e);
        const i = Array.from(this._bindings.keys());
        const n = i.length;
        if (!t.callback && t.to.length > 1) {
          throw new ss['b'](
            'observable-bind-to-no-callback: Binding multiple observables only possible with callback.',
            this
          );
        }
        if (n > 1 && t.callback) {
          throw new ss['b'](
            'observable-bind-to-extra-callback: Cannot bind multiple properties and use a callback in one binding.',
            this
          );
        }
        t.to.forEach((e) => {
          if (e.properties.length && e.properties.length !== n) {
            throw new ss['b'](
              'observable-bind-to-properties-length: The number of properties must match.',
              this
            );
          }
          if (!e.properties.length) {
            e.properties = this._bindProperties;
          }
        });
        this._to = t.to;
        if (t.callback) {
          this._bindings.get(i[0]).callback = t.callback;
        }
        sl(this._observable, this._to);
        ol(this);
        this._bindProperties.forEach((e) => {
          rl(this._observable, e);
        });
      }
      function Xc(e, t, i) {
        if (this._bindings.size > 1) {
          throw new ss['b'](
            'observable-bind-to-many-not-one-binding: Cannot bind multiple properties with toMany().',
            this
          );
        }
        this.to(...el(e, t), i);
      }
      function el(e, t) {
        const i = e.map((e) => [e, t]);
        return Array.prototype.concat.apply([], i);
      }
      function tl(e) {
        return e.every((e) => typeof e == 'string');
      }
      function il(...e) {
        if (!e.length) {
          throw new ss['b'](
            'observable-bind-to-parse-error: Invalid argument syntax in `to()`.',
            null
          );
        }
        const t = { to: [] };
        let i;
        if (typeof e[e.length - 1] == 'function') {
          t.callback = e.pop();
        }
        e.forEach((e) => {
          if (typeof e == 'string') {
            i.properties.push(e);
          } else if (typeof e == 'object') {
            i = { observable: e, properties: [] };
            t.to.push(i);
          } else {
            throw new ss['b'](
              'observable-bind-to-parse-error: Invalid argument syntax in `to()`.',
              null
            );
          }
        });
        return t;
      }
      function nl(e, t, i, n) {
        const o = e[Gc];
        const r = o.get(i);
        const s = r || {};
        if (!s[n]) {
          s[n] = new Set();
        }
        s[n].add(t);
        if (!r) {
          o.set(i, s);
        }
      }
      function ol(e) {
        let t;
        e._bindings.forEach((i, n) => {
          e._to.forEach((o) => {
            t = o.properties[i.callback ? 0 : e._bindProperties.indexOf(n)];
            i.to.push([o.observable, t]);
            nl(e._observable, i, o.observable, t);
          });
        });
      }
      function rl(e, t) {
        const i = e[Yc];
        const n = i.get(t);
        let o;
        if (n.callback) {
          o = n.callback.apply(
            e,
            n.to.map((e) => e[0][e[1]])
          );
        } else {
          o = n.to[0];
          o = o[0][o[1]];
        }
        if (Object.prototype.hasOwnProperty.call(e, t)) {
          e[t] = o;
        } else {
          e.set(t, o);
        }
      }
      function sl(e, t) {
        t.forEach((t) => {
          const i = e[Gc];
          let n;
          if (!i.get(t.observable)) {
            e.listenTo(t.observable, 'change', (o, r) => {
              n = i.get(t.observable)[r];
              if (n) {
                n.forEach((t) => {
                  rl(e, t.property);
                });
              }
            });
          }
        });
      }
      class al extends Hc {
        constructor(e, t, i, n) {
          super(e, t, i, n);
          this.set('isReadOnly', false);
          this.set('isFocused', false);
          this.bind('isReadOnly').to(e);
          this.bind('isFocused').to(
            e,
            'isFocused',
            (t) => t && e.selection.editableElement == this
          );
          this.listenTo(e.selection, 'change', () => {
            this.isFocused = e.isFocused && e.selection.editableElement == this;
          });
        }
        is(e, t = null) {
          if (!t) {
            return (
              e === 'editableElement' ||
              e === 'view:editableElement' ||
              e === 'containerElement' ||
              e === 'view:containerElement' ||
              e === 'element' ||
              e === 'view:element' ||
              e === 'node' ||
              e === 'view:node'
            );
          } else {
            return (
              t === this.name &&
              (e === 'editableElement' ||
                e === 'view:editableElement' ||
                e === 'containerElement' ||
                e === 'view:containerElement' ||
                e === 'element' ||
                e === 'view:element')
            );
          }
        }
        destroy() {
          this.stopListening();
        }
      }
      ys(al, Qc);
      const cl = Symbol('rootName');
      class ll extends al {
        constructor(e, t) {
          super(e, t);
          this.rootName = 'main';
        }
        is(e, t = null) {
          if (!t) {
            return (
              e === 'rootElement' ||
              e === 'view:rootElement' ||
              e === 'editableElement' ||
              e === 'view:editableElement' ||
              e === 'containerElement' ||
              e === 'view:containerElement' ||
              e === 'element' ||
              e === 'view:element' ||
              e === 'node' ||
              e === 'view:node'
            );
          } else {
            return (
              t === this.name &&
              (e === 'rootElement' ||
                e === 'view:rootElement' ||
                e === 'editableElement' ||
                e === 'view:editableElement' ||
                e === 'containerElement' ||
                e === 'view:containerElement' ||
                e === 'element' ||
                e === 'view:element')
            );
          }
        }
        get rootName() {
          return this.getCustomProperty(cl);
        }
        set rootName(e) {
          this._setCustomProperty(cl, e);
        }
        set _name(e) {
          this.name = e;
        }
      }
      class dl {
        constructor(e = {}) {
          if (!e.boundaries && !e.startPosition) {
            throw new ss['b'](
              'view-tree-walker-no-start-position: Neither boundaries nor starting position have been defined.',
              null
            );
          }
          if (
            e.direction &&
            e.direction != 'forward' &&
            e.direction != 'backward'
          ) {
            throw new ss['b'](
              'view-tree-walker-unknown-direction: Only `backward` and `forward` direction allowed.',
              e.startPosition,
              { direction: e.direction }
            );
          }
          this.boundaries = e.boundaries || null;
          if (e.startPosition) {
            this.position = ul._createAt(e.startPosition);
          } else {
            this.position = ul._createAt(
              e.boundaries[e.direction == 'backward' ? 'end' : 'start']
            );
          }
          this.direction = e.direction || 'forward';
          this.singleCharacters = !!e.singleCharacters;
          this.shallow = !!e.shallow;
          this.ignoreElementEnd = !!e.ignoreElementEnd;
          this._boundaryStartParent = this.boundaries
            ? this.boundaries.start.parent
            : null;
          this._boundaryEndParent = this.boundaries
            ? this.boundaries.end.parent
            : null;
        }
        [Symbol.iterator]() {
          return this;
        }
        skip(e) {
          let t, i, n;
          do {
            n = this.position;
            ({ done: t, value: i } = this.next());
          } while (!t && e(i));
          if (!t) {
            this.position = n;
          }
        }
        next() {
          if (this.direction == 'forward') {
            return this._next();
          } else {
            return this._previous();
          }
        }
        _next() {
          let e = this.position.clone();
          const t = this.position;
          const i = e.parent;
          if (i.parent === null && e.offset === i.childCount) {
            return { done: true };
          }
          if (
            i === this._boundaryEndParent &&
            e.offset == this.boundaries.end.offset
          ) {
            return { done: true };
          }
          let n;
          if (i instanceof Bs) {
            if (e.isAtEnd) {
              this.position = ul._createAfter(i);
              return this._next();
            }
            n = i.data[e.offset];
          } else {
            n = i.getChild(e.offset);
          }
          if (n instanceof Dc) {
            if (!this.shallow) {
              e = new ul(n, 0);
            } else {
              e.offset++;
            }
            this.position = e;
            return this._formatReturnValue('elementStart', n, t, e, 1);
          } else if (n instanceof Bs) {
            if (this.singleCharacters) {
              e = new ul(n, 0);
              this.position = e;
              return this._next();
            } else {
              let i = n.data.length;
              let o;
              if (n == this._boundaryEndParent) {
                i = this.boundaries.end.offset;
                o = new Fs(n, 0, i);
                e = ul._createAfter(o);
              } else {
                o = new Fs(n, 0, n.data.length);
                e.offset++;
              }
              this.position = e;
              return this._formatReturnValue('text', o, t, e, i);
            }
          } else if (typeof n == 'string') {
            let n;
            if (this.singleCharacters) {
              n = 1;
            } else {
              const t =
                i === this._boundaryEndParent
                  ? this.boundaries.end.offset
                  : i.data.length;
              n = t - e.offset;
            }
            const o = new Fs(i, e.offset, n);
            e.offset += n;
            this.position = e;
            return this._formatReturnValue('text', o, t, e, n);
          } else {
            e = ul._createAfter(i);
            this.position = e;
            if (this.ignoreElementEnd) {
              return this._next();
            } else {
              return this._formatReturnValue('elementEnd', i, t, e);
            }
          }
        }
        _previous() {
          let e = this.position.clone();
          const t = this.position;
          const i = e.parent;
          if (i.parent === null && e.offset === 0) {
            return { done: true };
          }
          if (
            i == this._boundaryStartParent &&
            e.offset == this.boundaries.start.offset
          ) {
            return { done: true };
          }
          let n;
          if (i instanceof Bs) {
            if (e.isAtStart) {
              this.position = ul._createBefore(i);
              return this._previous();
            }
            n = i.data[e.offset - 1];
          } else {
            n = i.getChild(e.offset - 1);
          }
          if (n instanceof Dc) {
            if (!this.shallow) {
              e = new ul(n, n.childCount);
              this.position = e;
              if (this.ignoreElementEnd) {
                return this._previous();
              } else {
                return this._formatReturnValue('elementEnd', n, t, e);
              }
            } else {
              e.offset--;
              this.position = e;
              return this._formatReturnValue('elementStart', n, t, e, 1);
            }
          } else if (n instanceof Bs) {
            if (this.singleCharacters) {
              e = new ul(n, n.data.length);
              this.position = e;
              return this._previous();
            } else {
              let i = n.data.length;
              let o;
              if (n == this._boundaryStartParent) {
                const t = this.boundaries.start.offset;
                o = new Fs(n, t, n.data.length - t);
                i = o.data.length;
                e = ul._createBefore(o);
              } else {
                o = new Fs(n, 0, n.data.length);
                e.offset--;
              }
              this.position = e;
              return this._formatReturnValue('text', o, t, e, i);
            }
          } else if (typeof n == 'string') {
            let n;
            if (!this.singleCharacters) {
              const t =
                i === this._boundaryStartParent
                  ? this.boundaries.start.offset
                  : 0;
              n = e.offset - t;
            } else {
              n = 1;
            }
            e.offset -= n;
            const o = new Fs(i, e.offset, n);
            this.position = e;
            return this._formatReturnValue('text', o, t, e, n);
          } else {
            e = ul._createBefore(i);
            this.position = e;
            return this._formatReturnValue('elementStart', i, t, e, 1);
          }
        }
        _formatReturnValue(e, t, i, n, o) {
          if (t instanceof Fs) {
            if (t.offsetInText + t.data.length == t.textNode.data.length) {
              if (
                this.direction == 'forward' &&
                !(this.boundaries && this.boundaries.end.isEqual(this.position))
              ) {
                n = ul._createAfter(t.textNode);
                this.position = n;
              } else {
                i = ul._createAfter(t.textNode);
              }
            }
            if (t.offsetInText === 0) {
              if (
                this.direction == 'backward' &&
                !(
                  this.boundaries &&
                  this.boundaries.start.isEqual(this.position)
                )
              ) {
                n = ul._createBefore(t.textNode);
                this.position = n;
              } else {
                i = ul._createBefore(t.textNode);
              }
            }
          }
          return {
            done: false,
            value: {
              type: e,
              item: t,
              previousPosition: i,
              nextPosition: n,
              length: o,
            },
          };
        }
      }
      class ul {
        constructor(e, t) {
          this.parent = e;
          this.offset = t;
        }
        get nodeAfter() {
          if (this.parent.is('$text')) {
            return null;
          }
          return this.parent.getChild(this.offset) || null;
        }
        get nodeBefore() {
          if (this.parent.is('$text')) {
            return null;
          }
          return this.parent.getChild(this.offset - 1) || null;
        }
        get isAtStart() {
          return this.offset === 0;
        }
        get isAtEnd() {
          const e = this.parent.is('$text')
            ? this.parent.data.length
            : this.parent.childCount;
          return this.offset === e;
        }
        get root() {
          return this.parent.root;
        }
        get editableElement() {
          let e = this.parent;
          while (!(e instanceof al)) {
            if (e.parent) {
              e = e.parent;
            } else {
              return null;
            }
          }
          return e;
        }
        getShiftedBy(e) {
          const t = ul._createAt(this);
          const i = t.offset + e;
          t.offset = i < 0 ? 0 : i;
          return t;
        }
        getLastMatchingPosition(e, t = {}) {
          t.startPosition = this;
          const i = new dl(t);
          i.skip(e);
          return i.position;
        }
        getAncestors() {
          if (this.parent.is('documentFragment')) {
            return [this.parent];
          } else {
            return this.parent.getAncestors({ includeSelf: true });
          }
        }
        getCommonAncestor(e) {
          const t = this.getAncestors();
          const i = e.getAncestors();
          let n = 0;
          while (t[n] == i[n] && t[n]) {
            n++;
          }
          return n === 0 ? null : t[n - 1];
        }
        is(e) {
          return e === 'position' || e === 'view:position';
        }
        isEqual(e) {
          return this.parent == e.parent && this.offset == e.offset;
        }
        isBefore(e) {
          return this.compareWith(e) == 'before';
        }
        isAfter(e) {
          return this.compareWith(e) == 'after';
        }
        compareWith(e) {
          if (this.root !== e.root) {
            return 'different';
          }
          if (this.isEqual(e)) {
            return 'same';
          }
          const t = this.parent.is('node') ? this.parent.getPath() : [];
          const i = e.parent.is('node') ? e.parent.getPath() : [];
          t.push(this.offset);
          i.push(e.offset);
          const n = Rs(t, i);
          switch (n) {
            case 'prefix':
              return 'before';
            case 'extension':
              return 'after';
            default:
              return t[n] < i[n] ? 'before' : 'after';
          }
        }
        getWalker(e = {}) {
          e.startPosition = this;
          return new dl(e);
        }
        clone() {
          return new ul(this.parent, this.offset);
        }
        static _createAt(e, t) {
          if (e instanceof ul) {
            return new this(e.parent, e.offset);
          } else {
            const i = e;
            if (t == 'end') {
              t = i.is('$text') ? i.data.length : i.childCount;
            } else if (t == 'before') {
              return this._createBefore(i);
            } else if (t == 'after') {
              return this._createAfter(i);
            } else if (t !== 0 && !t) {
              throw new ss['b'](
                'view-createPositionAt-offset-required: ' +
                  'View#createPositionAt() requires the offset when the first parameter is a view item.',
                i
              );
            }
            return new ul(i, t);
          }
        }
        static _createAfter(e) {
          if (e.is('$textProxy')) {
            return new ul(e.textNode, e.offsetInText + e.data.length);
          }
          if (!e.parent) {
            throw new ss['b'](
              'view-position-after-root: You can not make position after root.',
              e,
              { root: e }
            );
          }
          return new ul(e.parent, e.index + 1);
        }
        static _createBefore(e) {
          if (e.is('$textProxy')) {
            return new ul(e.textNode, e.offsetInText);
          }
          if (!e.parent) {
            throw new ss['b'](
              'view-position-before-root: You can not make position before root.',
              e,
              { root: e }
            );
          }
          return new ul(e.parent, e.index);
        }
      }
      class hl {
        constructor(e, t = null) {
          this.start = e.clone();
          this.end = t ? t.clone() : e.clone();
        }
        *[Symbol.iterator]() {
          yield* new dl({ boundaries: this, ignoreElementEnd: true });
        }
        get isCollapsed() {
          return this.start.isEqual(this.end);
        }
        get isFlat() {
          return this.start.parent === this.end.parent;
        }
        get root() {
          return this.start.root;
        }
        getEnlarged() {
          let e = this.start.getLastMatchingPosition(fl, {
            direction: 'backward',
          });
          let t = this.end.getLastMatchingPosition(fl);
          if (e.parent.is('$text') && e.isAtStart) {
            e = ul._createBefore(e.parent);
          }
          if (t.parent.is('$text') && t.isAtEnd) {
            t = ul._createAfter(t.parent);
          }
          return new hl(e, t);
        }
        getTrimmed() {
          let e = this.start.getLastMatchingPosition(fl);
          if (e.isAfter(this.end) || e.isEqual(this.end)) {
            return new hl(e, e);
          }
          let t = this.end.getLastMatchingPosition(fl, {
            direction: 'backward',
          });
          const i = e.nodeAfter;
          const n = t.nodeBefore;
          if (i && i.is('$text')) {
            e = new ul(i, 0);
          }
          if (n && n.is('$text')) {
            t = new ul(n, n.data.length);
          }
          return new hl(e, t);
        }
        isEqual(e) {
          return (
            this == e ||
            (this.start.isEqual(e.start) && this.end.isEqual(e.end))
          );
        }
        containsPosition(e) {
          return e.isAfter(this.start) && e.isBefore(this.end);
        }
        containsRange(e, t = false) {
          if (e.isCollapsed) {
            t = false;
          }
          const i =
            this.containsPosition(e.start) ||
            (t && this.start.isEqual(e.start));
          const n =
            this.containsPosition(e.end) || (t && this.end.isEqual(e.end));
          return i && n;
        }
        getDifference(e) {
          const t = [];
          if (this.isIntersecting(e)) {
            if (this.containsPosition(e.start)) {
              t.push(new hl(this.start, e.start));
            }
            if (this.containsPosition(e.end)) {
              t.push(new hl(e.end, this.end));
            }
          } else {
            t.push(this.clone());
          }
          return t;
        }
        getIntersection(e) {
          if (this.isIntersecting(e)) {
            let t = this.start;
            let i = this.end;
            if (this.containsPosition(e.start)) {
              t = e.start;
            }
            if (this.containsPosition(e.end)) {
              i = e.end;
            }
            return new hl(t, i);
          }
          return null;
        }
        getWalker(e = {}) {
          e.boundaries = this;
          return new dl(e);
        }
        getCommonAncestor() {
          return this.start.getCommonAncestor(this.end);
        }
        getContainedElement() {
          if (this.isCollapsed) {
            return null;
          }
          let e = this.start.nodeAfter;
          let t = this.end.nodeBefore;
          if (
            this.start.parent.is('$text') &&
            this.start.isAtEnd &&
            this.start.parent.nextSibling
          ) {
            e = this.start.parent.nextSibling;
          }
          if (
            this.end.parent.is('$text') &&
            this.end.isAtStart &&
            this.end.parent.previousSibling
          ) {
            t = this.end.parent.previousSibling;
          }
          if (e && e.is('element') && e === t) {
            return e;
          }
          return null;
        }
        clone() {
          return new hl(this.start, this.end);
        }
        *getItems(e = {}) {
          e.boundaries = this;
          e.ignoreElementEnd = true;
          const t = new dl(e);
          for (const e of t) {
            yield e.item;
          }
        }
        *getPositions(e = {}) {
          e.boundaries = this;
          const t = new dl(e);
          yield t.position;
          for (const e of t) {
            yield e.nextPosition;
          }
        }
        is(e) {
          return e === 'range' || e === 'view:range';
        }
        isIntersecting(e) {
          return this.start.isBefore(e.end) && this.end.isAfter(e.start);
        }
        static _createFromParentsAndOffsets(e, t, i, n) {
          return new this(new ul(e, t), new ul(i, n));
        }
        static _createFromPositionAndShift(e, t) {
          const i = e;
          const n = e.getShiftedBy(t);
          return t > 0 ? new this(i, n) : new this(n, i);
        }
        static _createIn(e) {
          return this._createFromParentsAndOffsets(e, 0, e, e.childCount);
        }
        static _createOn(e) {
          const t = e.is('$textProxy') ? e.offsetSize : 1;
          return this._createFromPositionAndShift(ul._createBefore(e), t);
        }
      }
      function fl(e) {
        if (e.item.is('attributeElement') || e.item.is('uiElement')) {
          return true;
        }
        return false;
      }
      function gl(e) {
        let t = 0;
        for (const i of e) {
          t++;
        }
        return t;
      }
      class ml {
        constructor(e = null, t, i) {
          this._ranges = [];
          this._lastRangeBackward = false;
          this._isFake = false;
          this._fakeSelectionLabel = '';
          this.setTo(e, t, i);
        }
        get isFake() {
          return this._isFake;
        }
        get fakeSelectionLabel() {
          return this._fakeSelectionLabel;
        }
        get anchor() {
          if (!this._ranges.length) {
            return null;
          }
          const e = this._ranges[this._ranges.length - 1];
          const t = this._lastRangeBackward ? e.end : e.start;
          return t.clone();
        }
        get focus() {
          if (!this._ranges.length) {
            return null;
          }
          const e = this._ranges[this._ranges.length - 1];
          const t = this._lastRangeBackward ? e.start : e.end;
          return t.clone();
        }
        get isCollapsed() {
          return this.rangeCount === 1 && this._ranges[0].isCollapsed;
        }
        get rangeCount() {
          return this._ranges.length;
        }
        get isBackward() {
          return !this.isCollapsed && this._lastRangeBackward;
        }
        get editableElement() {
          if (this.anchor) {
            return this.anchor.editableElement;
          }
          return null;
        }
        *getRanges() {
          for (const e of this._ranges) {
            yield e.clone();
          }
        }
        getFirstRange() {
          let e = null;
          for (const t of this._ranges) {
            if (!e || t.start.isBefore(e.start)) {
              e = t;
            }
          }
          return e ? e.clone() : null;
        }
        getLastRange() {
          let e = null;
          for (const t of this._ranges) {
            if (!e || t.end.isAfter(e.end)) {
              e = t;
            }
          }
          return e ? e.clone() : null;
        }
        getFirstPosition() {
          const e = this.getFirstRange();
          return e ? e.start.clone() : null;
        }
        getLastPosition() {
          const e = this.getLastRange();
          return e ? e.end.clone() : null;
        }
        isEqual(e) {
          if (this.isFake != e.isFake) {
            return false;
          }
          if (this.isFake && this.fakeSelectionLabel != e.fakeSelectionLabel) {
            return false;
          }
          if (this.rangeCount != e.rangeCount) {
            return false;
          } else if (this.rangeCount === 0) {
            return true;
          }
          if (!this.anchor.isEqual(e.anchor) || !this.focus.isEqual(e.focus)) {
            return false;
          }
          for (const t of this._ranges) {
            let i = false;
            for (const n of e._ranges) {
              if (t.isEqual(n)) {
                i = true;
                break;
              }
            }
            if (!i) {
              return false;
            }
          }
          return true;
        }
        isSimilar(e) {
          if (this.isBackward != e.isBackward) {
            return false;
          }
          const t = gl(this.getRanges());
          const i = gl(e.getRanges());
          if (t != i) {
            return false;
          }
          if (t == 0) {
            return true;
          }
          for (let t of this.getRanges()) {
            t = t.getTrimmed();
            let i = false;
            for (let n of e.getRanges()) {
              n = n.getTrimmed();
              if (t.start.isEqual(n.start) && t.end.isEqual(n.end)) {
                i = true;
                break;
              }
            }
            if (!i) {
              return false;
            }
          }
          return true;
        }
        getSelectedElement() {
          if (this.rangeCount !== 1) {
            return null;
          }
          return this.getFirstRange().getContainedElement();
        }
        setTo(e, t, i) {
          if (e === null) {
            this._setRanges([]);
            this._setFakeOptions(t);
          } else if (e instanceof ml || e instanceof pl) {
            this._setRanges(e.getRanges(), e.isBackward);
            this._setFakeOptions({
              fake: e.isFake,
              label: e.fakeSelectionLabel,
            });
          } else if (e instanceof hl) {
            this._setRanges([e], t && t.backward);
            this._setFakeOptions(t);
          } else if (e instanceof ul) {
            this._setRanges([new hl(e)]);
            this._setFakeOptions(t);
          } else if (e instanceof js) {
            const n = !!i && !!i.backward;
            let o;
            if (t === undefined) {
              throw new ss['b'](
                'view-selection-setTo-required-second-parameter: ' +
                  'selection.setTo requires the second parameter when the first parameter is a node.',
                this
              );
            } else if (t == 'in') {
              o = hl._createIn(e);
            } else if (t == 'on') {
              o = hl._createOn(e);
            } else {
              o = new hl(ul._createAt(e, t));
            }
            this._setRanges([o], n);
            this._setFakeOptions(i);
          } else if (vs(e)) {
            this._setRanges(e, t && t.backward);
            this._setFakeOptions(t);
          } else {
            throw new ss['b'](
              'view-selection-setTo-not-selectable: Cannot set selection to given place.',
              this
            );
          }
          this.fire('change');
        }
        setFocus(e, t) {
          if (this.anchor === null) {
            throw new ss['b'](
              'view-selection-setFocus-no-ranges: Cannot set selection focus if there are no ranges in selection.',
              this
            );
          }
          const i = ul._createAt(e, t);
          if (i.compareWith(this.focus) == 'same') {
            return;
          }
          const n = this.anchor;
          this._ranges.pop();
          if (i.compareWith(n) == 'before') {
            this._addRange(new hl(i, n), true);
          } else {
            this._addRange(new hl(n, i));
          }
          this.fire('change');
        }
        is(e) {
          return e === 'selection' || e === 'view:selection';
        }
        _setRanges(e, t = false) {
          e = Array.from(e);
          this._ranges = [];
          for (const t of e) {
            this._addRange(t);
          }
          this._lastRangeBackward = !!t;
        }
        _setFakeOptions(e = {}) {
          this._isFake = !!e.fake;
          this._fakeSelectionLabel = e.fake ? e.label || '' : '';
        }
        _addRange(e, t = false) {
          if (!(e instanceof hl)) {
            throw new ss['b'](
              'view-selection-add-range-not-range: ' +
                'Selection range set to an object that is not an instance of view.Range',
              this
            );
          }
          this._pushRange(e);
          this._lastRangeBackward = !!t;
        }
        _pushRange(e) {
          for (const t of this._ranges) {
            if (e.isIntersecting(t)) {
              throw new ss['b'](
                'view-selection-range-intersects: Trying to add a range that intersects with another range from selection.',
                this,
                { addedRange: e, intersectingRange: t }
              );
            }
          }
          this._ranges.push(new hl(e.start, e.end));
        }
      }
      ys(ml, ds);
      class pl {
        constructor(e = null, t, i) {
          this._selection = new ml();
          this._selection.delegate('change').to(this);
          this._selection.setTo(e, t, i);
        }
        get isFake() {
          return this._selection.isFake;
        }
        get fakeSelectionLabel() {
          return this._selection.fakeSelectionLabel;
        }
        get anchor() {
          return this._selection.anchor;
        }
        get focus() {
          return this._selection.focus;
        }
        get isCollapsed() {
          return this._selection.isCollapsed;
        }
        get rangeCount() {
          return this._selection.rangeCount;
        }
        get isBackward() {
          return this._selection.isBackward;
        }
        get editableElement() {
          return this._selection.editableElement;
        }
        get _ranges() {
          return this._selection._ranges;
        }
        *getRanges() {
          yield* this._selection.getRanges();
        }
        getFirstRange() {
          return this._selection.getFirstRange();
        }
        getLastRange() {
          return this._selection.getLastRange();
        }
        getFirstPosition() {
          return this._selection.getFirstPosition();
        }
        getLastPosition() {
          return this._selection.getLastPosition();
        }
        getSelectedElement() {
          return this._selection.getSelectedElement();
        }
        isEqual(e) {
          return this._selection.isEqual(e);
        }
        isSimilar(e) {
          return this._selection.isSimilar(e);
        }
        is(e) {
          return (
            e === 'selection' ||
            e == 'documentSelection' ||
            e == 'view:selection' ||
            e == 'view:documentSelection'
          );
        }
        _setTo(e, t, i) {
          this._selection.setTo(e, t, i);
        }
        _setFocus(e, t) {
          this._selection.setFocus(e, t);
        }
      }
      ys(pl, ds);
      class bl {
        constructor(e) {
          this.selection = new pl();
          this.roots = new xs({ idProperty: 'rootName' });
          this.stylesProcessor = e;
          this.set('isReadOnly', false);
          this.set('isFocused', false);
          this.set('isComposing', false);
          this._postFixers = new Set();
        }
        getRoot(e = 'main') {
          return this.roots.get(e);
        }
        registerPostFixer(e) {
          this._postFixers.add(e);
        }
        destroy() {
          this.roots.map((e) => e.destroy());
          this.stopListening();
        }
        _callPostFixers(e) {
          let t = false;
          do {
            for (const i of this._postFixers) {
              t = i(e);
              if (t) {
                break;
              }
            }
          } while (t);
        }
      }
      ys(bl, Qc);
      const wl = 10;
      class kl extends Dc {
        constructor(e, t, i, n) {
          super(e, t, i, n);
          this.getFillerOffset = _l;
          this._priority = wl;
          this._id = null;
          this._clonesGroup = null;
        }
        get priority() {
          return this._priority;
        }
        get id() {
          return this._id;
        }
        getElementsWithSameId() {
          if (this.id === null) {
            throw new ss['b'](
              'attribute-element-get-elements-with-same-id-no-id: ' +
                'Cannot get elements with the same id for an attribute element without id.',
              this
            );
          }
          return new Set(this._clonesGroup);
        }
        is(e, t = null) {
          if (!t) {
            return (
              e === 'attributeElement' ||
              e === 'view:attributeElement' ||
              e === 'element' ||
              e === 'view:element' ||
              e === 'node' ||
              e === 'view:node'
            );
          } else {
            return (
              t === this.name &&
              (e === 'attributeElement' ||
                e === 'view:attributeElement' ||
                e === 'element' ||
                e === 'view:element')
            );
          }
        }
        isSimilar(e) {
          if (this.id !== null || e.id !== null) {
            return this.id === e.id;
          }
          return super.isSimilar(e) && this.priority == e.priority;
        }
        _clone(e) {
          const t = super._clone(e);
          t._priority = this._priority;
          t._id = this._id;
          return t;
        }
      }
      kl.DEFAULT_PRIORITY = wl;
      function _l() {
        if (vl(this)) {
          return null;
        }
        let e = this.parent;
        while (e && e.is('attributeElement')) {
          if (vl(e) > 1) {
            return null;
          }
          e = e.parent;
        }
        if (!e || vl(e) > 1) {
          return null;
        }
        return this.childCount;
      }
      function vl(e) {
        return Array.from(e.getChildren()).filter((e) => !e.is('uiElement'))
          .length;
      }
      class yl extends Dc {
        constructor(e, t, i, n) {
          super(e, t, i, n);
          this.getFillerOffset = xl;
        }
        is(e, t = null) {
          if (!t) {
            return (
              e === 'emptyElement' ||
              e === 'view:emptyElement' ||
              e === 'element' ||
              e === 'view:element' ||
              e === 'node' ||
              e === 'view:node'
            );
          } else {
            return (
              t === this.name &&
              (e === 'emptyElement' ||
                e === 'view:emptyElement' ||
                e === 'element' ||
                e === 'view:element')
            );
          }
        }
        _insertChild(e, t) {
          if (t && (t instanceof js || Array.from(t).length > 0)) {
            throw new ss['b'](
              'view-emptyelement-cannot-add: Cannot add child nodes to EmptyElement instance.',
              [this, t]
            );
          }
        }
      }
      function xl() {
        return null;
      }
      const Al = navigator.userAgent.toLowerCase();
      const Tl = {
        isMac: Pl(Al),
        isGecko: El(Al),
        isSafari: Sl(Al),
        isAndroid: Ml(Al),
        features: { isRegExpUnicodePropertySupported: Il() },
      };
      var Cl = Tl;
      function Pl(e) {
        return e.indexOf('macintosh') > -1;
      }
      function El(e) {
        return !!e.match(/gecko\/\d+/);
      }
      function Sl(e) {
        return e.indexOf(' applewebkit/') > -1 && e.indexOf('chrome') === -1;
      }
      function Ml(e) {
        return e.indexOf('android') > -1;
      }
      function Il() {
        let e = false;
        try {
          e = 'ć'.search(new RegExp('[\\p{L}]', 'u')) === 0;
        } catch (e) {}
        return e;
      }
      const Nl = { '⌘': 'ctrl', '⇧': 'shift', '⌥': 'alt' };
      const Ol = { ctrl: '⌘', shift: '⇧', alt: '⌥' };
      const zl = Fl();
      function Rl(e) {
        let t;
        if (typeof e == 'string') {
          t = zl[e.toLowerCase()];
          if (!t) {
            throw new ss['b']('keyboard-unknown-key: Unknown key name.', null, {
              key: e,
            });
          }
        } else {
          t =
            e.keyCode +
            (e.altKey ? zl.alt : 0) +
            (e.ctrlKey ? zl.ctrl : 0) +
            (e.shiftKey ? zl.shift : 0);
        }
        return t;
      }
      function Ll(e) {
        if (typeof e == 'string') {
          e = Hl(e);
        }
        return e
          .map((e) => (typeof e == 'string' ? Rl(e) : e))
          .reduce((e, t) => t + e, 0);
      }
      function Vl(e) {
        if (!Cl.isMac) {
          return e;
        }
        return Hl(e)
          .map((e) => Ol[e.toLowerCase()] || e)
          .reduce((e, t) => {
            if (e.slice(-1) in Nl) {
              return e + t;
            } else {
              return e + '+' + t;
            }
          });
      }
      function Dl(e) {
        return (
          e == zl.arrowright ||
          e == zl.arrowleft ||
          e == zl.arrowup ||
          e == zl.arrowdown
        );
      }
      function jl(e, t) {
        const i = t === 'ltr';
        switch (e) {
          case zl.arrowleft:
            return i ? 'left' : 'right';
          case zl.arrowright:
            return i ? 'right' : 'left';
          case zl.arrowup:
            return 'up';
          case zl.arrowdown:
            return 'down';
        }
      }
      function Bl(e, t) {
        const i = jl(e, t);
        return i === 'down' || i === 'right';
      }
      function Fl() {
        const e = {
          arrowleft: 37,
          arrowup: 38,
          arrowright: 39,
          arrowdown: 40,
          backspace: 8,
          delete: 46,
          enter: 13,
          space: 32,
          esc: 27,
          tab: 9,
          ctrl: 1114112,
          cmd: 1114112,
          shift: 2228224,
          alt: 4456448,
        };
        for (let t = 65; t <= 90; t++) {
          const i = String.fromCharCode(t);
          e[i.toLowerCase()] = t;
        }
        for (let t = 48; t <= 57; t++) {
          e[t - 48] = t;
        }
        for (let t = 112; t <= 123; t++) {
          e['f' + (t - 111)] = t;
        }
        return e;
      }
      function Hl(e) {
        return e.split(/\s*\+\s*/);
      }
      class Ul extends Dc {
        constructor(e, t, i, n) {
          super(e, t, i, n);
          this.getFillerOffset = Wl;
        }
        is(e, t = null) {
          if (!t) {
            return (
              e === 'uiElement' ||
              e === 'view:uiElement' ||
              e === 'element' ||
              e === 'view:element' ||
              e === 'node' ||
              e === 'view:node'
            );
          } else {
            return (
              t === this.name &&
              (e === 'uiElement' ||
                e === 'view:uiElement' ||
                e === 'element' ||
                e === 'view:element')
            );
          }
        }
        _insertChild(e, t) {
          if (t && (t instanceof js || Array.from(t).length > 0)) {
            throw new ss['b'](
              'view-uielement-cannot-add: Cannot add child nodes to UIElement instance.',
              this
            );
          }
        }
        render(e) {
          return this.toDomElement(e);
        }
        toDomElement(e) {
          const t = e.createElement(this.name);
          for (const e of this.getAttributeKeys()) {
            t.setAttribute(e, this.getAttribute(e));
          }
          return t;
        }
      }
      function ql(e) {
        e.document.on('keydown', (t, i) => $l(t, i, e.domConverter));
      }
      function Wl() {
        return null;
      }
      function $l(e, t, i) {
        if (t.keyCode == zl.arrowright) {
          const e = t.domTarget.ownerDocument.defaultView.getSelection();
          const n = e.rangeCount == 1 && e.getRangeAt(0).collapsed;
          if (n || t.shiftKey) {
            const t = e.focusNode;
            const o = e.focusOffset;
            const r = i.domPositionToView(t, o);
            if (r === null) {
              return;
            }
            let s = false;
            const a = r.getLastMatchingPosition((e) => {
              if (e.item.is('uiElement')) {
                s = true;
              }
              if (e.item.is('uiElement') || e.item.is('attributeElement')) {
                return true;
              }
              return false;
            });
            if (s) {
              const t = i.viewPositionToDom(a);
              if (n) {
                e.collapse(t.parent, t.offset);
              } else {
                e.extend(t.parent, t.offset);
              }
            }
          }
        }
      }
      class Gl extends Dc {
        constructor(e, t, i, n) {
          super(e, t, i, n);
          this.getFillerOffset = Yl;
        }
        is(e, t = null) {
          if (!t) {
            return (
              e === 'rawElement' ||
              e === 'view:rawElement' ||
              e === this.name ||
              e === 'view:' + this.name ||
              e === 'element' ||
              e === 'view:element' ||
              e === 'node' ||
              e === 'view:node'
            );
          } else {
            return (
              t === this.name &&
              (e === 'rawElement' ||
                e === 'view:rawElement' ||
                e === 'element' ||
                e === 'view:element')
            );
          }
        }
        _insertChild(e, t) {
          if (t && (t instanceof js || Array.from(t).length > 0)) {
            throw new ss['b'](
              'view-rawelement-cannot-add: Cannot add child nodes to a RawElement instance.',
              [this, t]
            );
          }
        }
      }
      function Yl() {
        return null;
      }
      class Kl {
        constructor(e, t) {
          this.document = e;
          this._children = [];
          if (t) {
            this._insertChild(0, t);
          }
        }
        [Symbol.iterator]() {
          return this._children[Symbol.iterator]();
        }
        get childCount() {
          return this._children.length;
        }
        get isEmpty() {
          return this.childCount === 0;
        }
        get root() {
          return this;
        }
        get parent() {
          return null;
        }
        is(e) {
          return e === 'documentFragment' || e === 'view:documentFragment';
        }
        _appendChild(e) {
          return this._insertChild(this.childCount, e);
        }
        getChild(e) {
          return this._children[e];
        }
        getChildIndex(e) {
          return this._children.indexOf(e);
        }
        getChildren() {
          return this._children[Symbol.iterator]();
        }
        _insertChild(e, t) {
          this._fireChange('children', this);
          let i = 0;
          const n = Ql(this.document, t);
          for (const t of n) {
            if (t.parent !== null) {
              t._remove();
            }
            t.parent = this;
            this._children.splice(e, 0, t);
            e++;
            i++;
          }
          return i;
        }
        _removeChildren(e, t = 1) {
          this._fireChange('children', this);
          for (let i = e; i < e + t; i++) {
            this._children[i].parent = null;
          }
          return this._children.splice(e, t);
        }
        _fireChange(e, t) {
          this.fire('change:' + e, t);
        }
      }
      ys(Kl, ds);
      function Ql(e, t) {
        if (typeof t == 'string') {
          return [new Bs(e, t)];
        }
        if (!vs(t)) {
          t = [t];
        }
        return Array.from(t).map((t) => {
          if (typeof t == 'string') {
            return new Bs(e, t);
          }
          if (t instanceof Fs) {
            return new Bs(e, t.data);
          }
          return t;
        });
      }
      class Jl {
        constructor(e) {
          this.document = e;
          this._cloneGroups = new Map();
        }
        setSelection(e, t, i) {
          this.document.selection._setTo(e, t, i);
        }
        setSelectionFocus(e, t) {
          this.document.selection._setFocus(e, t);
        }
        createText(e) {
          return new Bs(this.document, e);
        }
        createAttributeElement(e, t, i = {}) {
          const n = new kl(this.document, e, t);
          if (i.priority) {
            n._priority = i.priority;
          }
          if (i.id) {
            n._id = i.id;
          }
          return n;
        }
        createContainerElement(e, t) {
          return new Hc(this.document, e, t);
        }
        createEditableElement(e, t) {
          const i = new al(this.document, e, t);
          i._document = this.document;
          return i;
        }
        createEmptyElement(e, t) {
          return new yl(this.document, e, t);
        }
        createUIElement(e, t, i) {
          const n = new Ul(this.document, e, t);
          if (i) {
            n.render = i;
          }
          return n;
        }
        createRawElement(e, t, i) {
          const n = new Gl(this.document, e, t);
          n.render = i || (() => {});
          return n;
        }
        setAttribute(e, t, i) {
          i._setAttribute(e, t);
        }
        removeAttribute(e, t) {
          t._removeAttribute(e);
        }
        addClass(e, t) {
          t._addClass(e);
        }
        removeClass(e, t) {
          t._removeClass(e);
        }
        setStyle(e, t, i) {
          if (z(e) && i === undefined) {
            i = t;
          }
          i._setStyle(e, t);
        }
        removeStyle(e, t) {
          t._removeStyle(e);
        }
        setCustomProperty(e, t, i) {
          i._setCustomProperty(e, t);
        }
        removeCustomProperty(e, t) {
          return t._removeCustomProperty(e);
        }
        breakAttributes(e) {
          if (e instanceof ul) {
            return this._breakAttributes(e);
          } else {
            return this._breakAttributesRange(e);
          }
        }
        breakContainer(e) {
          const t = e.parent;
          if (!t.is('containerElement')) {
            throw new ss['b'](
              'view-writer-break-non-container-element: Trying to break an element which is not a container element.',
              this.document
            );
          }
          if (!t.parent) {
            throw new ss['b'](
              'view-writer-break-root: Trying to break root element.',
              this.document
            );
          }
          if (e.isAtStart) {
            return ul._createBefore(t);
          } else if (!e.isAtEnd) {
            const i = t._clone(false);
            this.insert(ul._createAfter(t), i);
            const n = new hl(e, ul._createAt(t, 'end'));
            const o = new ul(i, 0);
            this.move(n, o);
          }
          return ul._createAfter(t);
        }
        mergeAttributes(e) {
          const t = e.offset;
          const i = e.parent;
          if (i.is('$text')) {
            return e;
          }
          if (i.is('attributeElement') && i.childCount === 0) {
            const e = i.parent;
            const t = i.index;
            i._remove();
            this._removeFromClonedElementsGroup(i);
            return this.mergeAttributes(new ul(e, t));
          }
          const n = i.getChild(t - 1);
          const o = i.getChild(t);
          if (!n || !o) {
            return e;
          }
          if (n.is('$text') && o.is('$text')) {
            return nd(n, o);
          } else if (
            n.is('attributeElement') &&
            o.is('attributeElement') &&
            n.isSimilar(o)
          ) {
            const e = n.childCount;
            n._appendChild(o.getChildren());
            o._remove();
            this._removeFromClonedElementsGroup(o);
            return this.mergeAttributes(new ul(n, e));
          }
          return e;
        }
        mergeContainers(e) {
          const t = e.nodeBefore;
          const i = e.nodeAfter;
          if (
            !t ||
            !i ||
            !t.is('containerElement') ||
            !i.is('containerElement')
          ) {
            throw new ss['b'](
              'view-writer-merge-containers-invalid-position: ' +
                'Element before and after given position cannot be merged.',
              this.document
            );
          }
          const n = t.getChild(t.childCount - 1);
          const o =
            n instanceof Bs ? ul._createAt(n, 'end') : ul._createAt(t, 'end');
          this.move(hl._createIn(i), ul._createAt(t, 'end'));
          this.remove(hl._createOn(i));
          return o;
        }
        insert(e, t) {
          t = vs(t) ? [...t] : [t];
          od(t, this.document);
          const i = Xl(e);
          if (!i) {
            throw new ss['b'](
              "view-writer-invalid-position-container: Position's parent container cannot be found.",
              this.document
            );
          }
          const n = this._breakAttributes(e, true);
          const o = i._insertChild(n.offset, t);
          for (const e of t) {
            this._addToClonedElementsGroup(e);
          }
          const r = n.getShiftedBy(o);
          const s = this.mergeAttributes(n);
          if (o === 0) {
            return new hl(s, s);
          } else {
            if (!s.isEqual(n)) {
              r.offset--;
            }
            const e = this.mergeAttributes(r);
            return new hl(s, e);
          }
        }
        remove(e) {
          const t = e instanceof hl ? e : hl._createOn(e);
          ad(t, this.document);
          if (t.isCollapsed) {
            return new Kl(this.document);
          }
          const { start: i, end: n } = this._breakAttributesRange(t, true);
          const o = i.parent;
          const r = n.offset - i.offset;
          const s = o._removeChildren(i.offset, r);
          for (const e of s) {
            this._removeFromClonedElementsGroup(e);
          }
          const a = this.mergeAttributes(i);
          t.start = a;
          t.end = a.clone();
          return new Kl(this.document, s);
        }
        clear(e, t) {
          ad(e, this.document);
          const i = e.getWalker({
            direction: 'backward',
            ignoreElementEnd: true,
          });
          for (const n of i) {
            const i = n.item;
            let o;
            if (i.is('element') && t.isSimilar(i)) {
              o = hl._createOn(i);
            } else if (!n.nextPosition.isAfter(e.start) && i.is('$textProxy')) {
              const e = i
                .getAncestors()
                .find((e) => e.is('element') && t.isSimilar(e));
              if (e) {
                o = hl._createIn(e);
              }
            }
            if (o) {
              if (o.end.isAfter(e.end)) {
                o.end = e.end;
              }
              if (o.start.isBefore(e.start)) {
                o.start = e.start;
              }
              this.remove(o);
            }
          }
        }
        move(e, t) {
          let i;
          if (t.isAfter(e.end)) {
            t = this._breakAttributes(t, true);
            const n = t.parent;
            const o = n.childCount;
            e = this._breakAttributesRange(e, true);
            i = this.remove(e);
            t.offset += n.childCount - o;
          } else {
            i = this.remove(e);
          }
          return this.insert(t, i);
        }
        wrap(e, t) {
          if (!(t instanceof kl)) {
            throw new ss['b'](
              'view-writer-wrap-invalid-attribute: DowncastWriter#wrap() must be called with an attribute element.',
              this.document
            );
          }
          ad(e, this.document);
          if (!e.isCollapsed) {
            return this._wrapRange(e, t);
          } else {
            let i = e.start;
            if (i.parent.is('element') && !Zl(i.parent)) {
              i = i.getLastMatchingPosition((e) => e.item.is('uiElement'));
            }
            i = this._wrapPosition(i, t);
            const n = this.document.selection;
            if (n.isCollapsed && n.getFirstPosition().isEqual(e.start)) {
              this.setSelection(i);
            }
            return new hl(i);
          }
        }
        unwrap(e, t) {
          if (!(t instanceof kl)) {
            throw new ss['b'](
              'view-writer-unwrap-invalid-attribute: DowncastWriter#unwrap() must be called with an attribute element.',
              this.document
            );
          }
          ad(e, this.document);
          if (e.isCollapsed) {
            return e;
          }
          const { start: i, end: n } = this._breakAttributesRange(e, true);
          const o = i.parent;
          const r = this._unwrapChildren(o, i.offset, n.offset, t);
          const s = this.mergeAttributes(r.start);
          if (!s.isEqual(r.start)) {
            r.end.offset--;
          }
          const a = this.mergeAttributes(r.end);
          return new hl(s, a);
        }
        rename(e, t) {
          const i = new Hc(this.document, e, t.getAttributes());
          this.insert(ul._createAfter(t), i);
          this.move(hl._createIn(t), ul._createAt(i, 0));
          this.remove(hl._createOn(t));
          return i;
        }
        clearClonedElementsGroup(e) {
          this._cloneGroups.delete(e);
        }
        createPositionAt(e, t) {
          return ul._createAt(e, t);
        }
        createPositionAfter(e) {
          return ul._createAfter(e);
        }
        createPositionBefore(e) {
          return ul._createBefore(e);
        }
        createRange(e, t) {
          return new hl(e, t);
        }
        createRangeOn(e) {
          return hl._createOn(e);
        }
        createRangeIn(e) {
          return hl._createIn(e);
        }
        createSelection(e, t, i) {
          return new ml(e, t, i);
        }
        _wrapChildren(e, t, i, n) {
          let o = t;
          const r = [];
          while (o < i) {
            const t = e.getChild(o);
            const i = t.is('$text');
            const s = t.is('attributeElement');
            const a = t.is('emptyElement');
            const c = t.is('uiElement');
            const l = t.is('rawElement');
            if (s && this._wrapAttributeElement(n, t)) {
              r.push(new ul(e, o));
            } else if (i || a || c || l || (s && ed(n, t))) {
              const i = n._clone();
              t._remove();
              i._appendChild(t);
              e._insertChild(o, i);
              this._addToClonedElementsGroup(i);
              r.push(new ul(e, o));
            } else if (s) {
              this._wrapChildren(t, 0, t.childCount, n);
            }
            o++;
          }
          let s = 0;
          for (const e of r) {
            e.offset -= s;
            if (e.offset == t) {
              continue;
            }
            const n = this.mergeAttributes(e);
            if (!n.isEqual(e)) {
              s++;
              i--;
            }
          }
          return hl._createFromParentsAndOffsets(e, t, e, i);
        }
        _unwrapChildren(e, t, i, n) {
          let o = t;
          const r = [];
          while (o < i) {
            const t = e.getChild(o);
            if (!t.is('attributeElement')) {
              o++;
              continue;
            }
            if (t.isSimilar(n)) {
              const n = t.getChildren();
              const s = t.childCount;
              t._remove();
              e._insertChild(o, n);
              this._removeFromClonedElementsGroup(t);
              r.push(new ul(e, o), new ul(e, o + s));
              o += s;
              i += s - 1;
              continue;
            }
            if (this._unwrapAttributeElement(n, t)) {
              r.push(new ul(e, o), new ul(e, o + 1));
              o++;
              continue;
            }
            this._unwrapChildren(t, 0, t.childCount, n);
            o++;
          }
          let s = 0;
          for (const e of r) {
            e.offset -= s;
            if (e.offset == t || e.offset == i) {
              continue;
            }
            const n = this.mergeAttributes(e);
            if (!n.isEqual(e)) {
              s++;
              i--;
            }
          }
          return hl._createFromParentsAndOffsets(e, t, e, i);
        }
        _wrapRange(e, t) {
          const { start: i, end: n } = this._breakAttributesRange(e, true);
          const o = i.parent;
          const r = this._wrapChildren(o, i.offset, n.offset, t);
          const s = this.mergeAttributes(r.start);
          if (!s.isEqual(r.start)) {
            r.end.offset--;
          }
          const a = this.mergeAttributes(r.end);
          return new hl(s, a);
        }
        _wrapPosition(e, t) {
          if (t.isSimilar(e.parent)) {
            return td(e.clone());
          }
          if (e.parent.is('$text')) {
            e = id(e);
          }
          const i = this.createAttributeElement();
          i._priority = Number.POSITIVE_INFINITY;
          i.isSimilar = () => false;
          e.parent._insertChild(e.offset, i);
          const n = new hl(e, e.getShiftedBy(1));
          this.wrap(n, t);
          const o = new ul(i.parent, i.index);
          i._remove();
          const r = o.nodeBefore;
          const s = o.nodeAfter;
          if (r instanceof Bs && s instanceof Bs) {
            return nd(r, s);
          }
          return td(o);
        }
        _wrapAttributeElement(e, t) {
          if (!cd(e, t)) {
            return false;
          }
          if (e.name !== t.name || e.priority !== t.priority) {
            return false;
          }
          for (const i of e.getAttributeKeys()) {
            if (i === 'class' || i === 'style') {
              continue;
            }
            if (t.hasAttribute(i) && t.getAttribute(i) !== e.getAttribute(i)) {
              return false;
            }
          }
          for (const i of e.getStyleNames()) {
            if (t.hasStyle(i) && t.getStyle(i) !== e.getStyle(i)) {
              return false;
            }
          }
          for (const i of e.getAttributeKeys()) {
            if (i === 'class' || i === 'style') {
              continue;
            }
            if (!t.hasAttribute(i)) {
              this.setAttribute(i, e.getAttribute(i), t);
            }
          }
          for (const i of e.getStyleNames()) {
            if (!t.hasStyle(i)) {
              this.setStyle(i, e.getStyle(i), t);
            }
          }
          for (const i of e.getClassNames()) {
            if (!t.hasClass(i)) {
              this.addClass(i, t);
            }
          }
          return true;
        }
        _unwrapAttributeElement(e, t) {
          if (!cd(e, t)) {
            return false;
          }
          if (e.name !== t.name || e.priority !== t.priority) {
            return false;
          }
          for (const i of e.getAttributeKeys()) {
            if (i === 'class' || i === 'style') {
              continue;
            }
            if (!t.hasAttribute(i) || t.getAttribute(i) !== e.getAttribute(i)) {
              return false;
            }
          }
          if (!t.hasClass(...e.getClassNames())) {
            return false;
          }
          for (const i of e.getStyleNames()) {
            if (!t.hasStyle(i) || t.getStyle(i) !== e.getStyle(i)) {
              return false;
            }
          }
          for (const i of e.getAttributeKeys()) {
            if (i === 'class' || i === 'style') {
              continue;
            }
            this.removeAttribute(i, t);
          }
          this.removeClass(Array.from(e.getClassNames()), t);
          this.removeStyle(Array.from(e.getStyleNames()), t);
          return true;
        }
        _breakAttributesRange(e, t = false) {
          const i = e.start;
          const n = e.end;
          ad(e, this.document);
          if (e.isCollapsed) {
            const i = this._breakAttributes(e.start, t);
            return new hl(i, i);
          }
          const o = this._breakAttributes(n, t);
          const r = o.parent.childCount;
          const s = this._breakAttributes(i, t);
          o.offset += o.parent.childCount - r;
          return new hl(s, o);
        }
        _breakAttributes(e, t = false) {
          const i = e.offset;
          const n = e.parent;
          if (e.parent.is('emptyElement')) {
            throw new ss['b'](
              'view-writer-cannot-break-empty-element: Cannot break an EmptyElement instance.',
              this.document
            );
          }
          if (e.parent.is('uiElement')) {
            throw new ss['b'](
              'view-writer-cannot-break-ui-element: Cannot break a UIElement instance.',
              this.document
            );
          }
          if (e.parent.is('rawElement')) {
            throw new ss['b'](
              'view-writer-cannot-break-raw-element: Cannot break a RawElement instance.',
              this.document
            );
          }
          if (!t && n.is('$text') && sd(n.parent)) {
            return e.clone();
          }
          if (sd(n)) {
            return e.clone();
          }
          if (n.is('$text')) {
            return this._breakAttributes(id(e), t);
          }
          const o = n.childCount;
          if (i == o) {
            const e = new ul(n.parent, n.index + 1);
            return this._breakAttributes(e, t);
          } else {
            if (i === 0) {
              const e = new ul(n.parent, n.index);
              return this._breakAttributes(e, t);
            } else {
              const e = n.index + 1;
              const o = n._clone();
              n.parent._insertChild(e, o);
              this._addToClonedElementsGroup(o);
              const r = n.childCount - i;
              const s = n._removeChildren(i, r);
              o._appendChild(s);
              const a = new ul(n.parent, e);
              return this._breakAttributes(a, t);
            }
          }
        }
        _addToClonedElementsGroup(e) {
          if (!e.root.is('rootElement')) {
            return;
          }
          if (e.is('element')) {
            for (const t of e.getChildren()) {
              this._addToClonedElementsGroup(t);
            }
          }
          const t = e.id;
          if (!t) {
            return;
          }
          let i = this._cloneGroups.get(t);
          if (!i) {
            i = new Set();
            this._cloneGroups.set(t, i);
          }
          i.add(e);
          e._clonesGroup = i;
        }
        _removeFromClonedElementsGroup(e) {
          if (e.is('element')) {
            for (const t of e.getChildren()) {
              this._removeFromClonedElementsGroup(t);
            }
          }
          const t = e.id;
          if (!t) {
            return;
          }
          const i = this._cloneGroups.get(t);
          if (!i) {
            return;
          }
          i.delete(e);
        }
      }
      function Zl(e) {
        return Array.from(e.getChildren()).some((e) => !e.is('uiElement'));
      }
      function Xl(e) {
        let t = e.parent;
        while (!sd(t)) {
          if (!t) {
            return undefined;
          }
          t = t.parent;
        }
        return t;
      }
      function ed(e, t) {
        if (e.priority < t.priority) {
          return true;
        } else if (e.priority > t.priority) {
          return false;
        }
        return e.getIdentity() < t.getIdentity();
      }
      function td(e) {
        const t = e.nodeBefore;
        if (t && t.is('$text')) {
          return new ul(t, t.data.length);
        }
        const i = e.nodeAfter;
        if (i && i.is('$text')) {
          return new ul(i, 0);
        }
        return e;
      }
      function id(e) {
        if (e.offset == e.parent.data.length) {
          return new ul(e.parent.parent, e.parent.index + 1);
        }
        if (e.offset === 0) {
          return new ul(e.parent.parent, e.parent.index);
        }
        const t = e.parent.data.slice(e.offset);
        e.parent._data = e.parent.data.slice(0, e.offset);
        e.parent.parent._insertChild(
          e.parent.index + 1,
          new Bs(e.root.document, t)
        );
        return new ul(e.parent.parent, e.parent.index + 1);
      }
      function nd(e, t) {
        const i = e.data.length;
        e._data += t.data;
        t._remove();
        return new ul(e, i);
      }
      function od(e, t) {
        for (const i of e) {
          if (!rd.some((e) => i instanceof e)) {
            throw new ss['b'](
              'view-writer-insert-invalid-node-type: One of the nodes to be inserted is of invalid type.',
              t
            );
          }
          if (!i.is('$text')) {
            od(i.getChildren(), t);
          }
        }
      }
      const rd = [Bs, kl, Hc, yl, Gl, Ul];
      function sd(e) {
        return e && (e.is('containerElement') || e.is('documentFragment'));
      }
      function ad(e, t) {
        const i = Xl(e.start);
        const n = Xl(e.end);
        if (!i || !n || i !== n) {
          throw new ss['b'](
            'view-writer-invalid-range-container: The container of the given range is invalid.',
            t
          );
        }
      }
      function cd(e, t) {
        return e.id === null && t.id === null;
      }
      function ld(e) {
        return Object.prototype.toString.call(e) == '[object Text]';
      }
      const dd = (e) => e.createTextNode(' ');
      const ud = (e) => {
        const t = e.createElement('br');
        t.dataset.ckeFiller = true;
        return t;
      };
      const hd = 7;
      const fd = (() => {
        let e = '';
        for (let t = 0; t < hd; t++) {
          e += '​';
        }
        return e;
      })();
      function gd(e) {
        return ld(e) && e.data.substr(0, hd) === fd;
      }
      function md(e) {
        return e.data.length == hd && gd(e);
      }
      function pd(e) {
        if (gd(e)) {
          return e.data.slice(hd);
        } else {
          return e.data;
        }
      }
      function bd(e) {
        e.document.on('keydown', wd);
      }
      function wd(e, t) {
        if (t.keyCode == zl.arrowleft) {
          const e = t.domTarget.ownerDocument.defaultView.getSelection();
          if (e.rangeCount == 1 && e.getRangeAt(0).collapsed) {
            const t = e.getRangeAt(0).startContainer;
            const i = e.getRangeAt(0).startOffset;
            if (gd(t) && i <= hd) {
              e.collapse(t, 0);
            }
          }
        }
      }
      function kd(e, t, i, n = false) {
        i =
          i ||
          function (e, t) {
            return e === t;
          };
        if (!Array.isArray(e)) {
          e = Array.prototype.slice.call(e);
        }
        if (!Array.isArray(t)) {
          t = Array.prototype.slice.call(t);
        }
        const o = _d(e, t, i);
        return n ? Ad(o, t.length) : xd(t, o);
      }
      function _d(e, t, i) {
        const n = vd(e, t, i);
        if (n === -1) {
          return { firstIndex: -1, lastIndexOld: -1, lastIndexNew: -1 };
        }
        const o = yd(e, n);
        const r = yd(t, n);
        const s = vd(o, r, i);
        const a = e.length - s;
        const c = t.length - s;
        return { firstIndex: n, lastIndexOld: a, lastIndexNew: c };
      }
      function vd(e, t, i) {
        for (let n = 0; n < Math.max(e.length, t.length); n++) {
          if (e[n] === undefined || t[n] === undefined || !i(e[n], t[n])) {
            return n;
          }
        }
        return -1;
      }
      function yd(e, t) {
        return e.slice(t).reverse();
      }
      function xd(e, t) {
        const i = [];
        const { firstIndex: n, lastIndexOld: o, lastIndexNew: r } = t;
        if (r - n > 0) {
          i.push({ index: n, type: 'insert', values: e.slice(n, r) });
        }
        if (o - n > 0) {
          i.push({ index: n + (r - n), type: 'delete', howMany: o - n });
        }
        return i;
      }
      function Ad(e, t) {
        const { firstIndex: i, lastIndexOld: n, lastIndexNew: o } = e;
        if (i === -1) {
          return Array(t).fill('equal');
        }
        let r = [];
        if (i > 0) {
          r = r.concat(Array(i).fill('equal'));
        }
        if (o - i > 0) {
          r = r.concat(Array(o - i).fill('insert'));
        }
        if (n - i > 0) {
          r = r.concat(Array(n - i).fill('delete'));
        }
        if (o < t) {
          r = r.concat(Array(t - o).fill('equal'));
        }
        return r;
      }
      function Td(e, t, i) {
        i =
          i ||
          function (e, t) {
            return e === t;
          };
        const n = e.length;
        const o = t.length;
        if (n > 200 || o > 200 || n + o > 300) {
          return Td.fastDiff(e, t, i, true);
        }
        let r, s;
        if (o < n) {
          const i = e;
          e = t;
          t = i;
          r = 'delete';
          s = 'insert';
        } else {
          r = 'insert';
          s = 'delete';
        }
        const a = e.length;
        const c = t.length;
        const l = c - a;
        const d = {};
        const u = {};
        function h(n) {
          const o = (u[n - 1] !== undefined ? u[n - 1] : -1) + 1;
          const l = u[n + 1] !== undefined ? u[n + 1] : -1;
          const h = o > l ? -1 : 1;
          if (d[n + h]) {
            d[n] = d[n + h].slice(0);
          }
          if (!d[n]) {
            d[n] = [];
          }
          d[n].push(o > l ? r : s);
          let f = Math.max(o, l);
          let g = f - n;
          while (g < a && f < c && i(e[g], t[f])) {
            g++;
            f++;
            d[n].push('equal');
          }
          return f;
        }
        let f = 0;
        let g;
        do {
          for (g = -f; g < l; g++) {
            u[g] = h(g);
          }
          for (g = l + f; g > l; g--) {
            u[g] = h(g);
          }
          u[l] = h(l);
          f++;
        } while (u[l] !== c);
        return d[l].slice(1);
      }
      Td.fastDiff = kd;
      function Cd(e, t, i) {
        e.insertBefore(i, e.childNodes[t] || null);
      }
      function Pd(e) {
        const t = e.parentNode;
        if (t) {
          t.removeChild(e);
        }
      }
      function Ed(e) {
        if (e) {
          if (e.defaultView) {
            return e instanceof e.defaultView.Document;
          } else if (e.ownerDocument && e.ownerDocument.defaultView) {
            return e instanceof e.ownerDocument.defaultView.Node;
          }
        }
        return false;
      }
      class Sd {
        constructor(e, t) {
          this.domDocuments = new Set();
          this.domConverter = e;
          this.markedAttributes = new Set();
          this.markedChildren = new Set();
          this.markedTexts = new Set();
          this.selection = t;
          this.isFocused = false;
          this._inlineFiller = null;
          this._fakeSelectionContainer = null;
        }
        markToSync(e, t) {
          if (e === 'text') {
            if (this.domConverter.mapViewToDom(t.parent)) {
              this.markedTexts.add(t);
            }
          } else {
            if (!this.domConverter.mapViewToDom(t)) {
              return;
            }
            if (e === 'attributes') {
              this.markedAttributes.add(t);
            } else if (e === 'children') {
              this.markedChildren.add(t);
            } else {
              throw new ss['b'](
                'view-renderer-unknown-type: Unknown type passed to Renderer.markToSync.',
                this
              );
            }
          }
        }
        render() {
          let e;
          for (const e of this.markedChildren) {
            this._updateChildrenMappings(e);
          }
          if (this._inlineFiller && !this._isSelectionInInlineFiller()) {
            this._removeInlineFiller();
          }
          if (this._inlineFiller) {
            e = this._getInlineFillerPosition();
          } else if (this._needsInlineFillerAtSelection()) {
            e = this.selection.getFirstPosition();
            this.markedChildren.add(e.parent);
          }
          for (const e of this.markedAttributes) {
            this._updateAttrs(e);
          }
          for (const t of this.markedChildren) {
            this._updateChildren(t, { inlineFillerPosition: e });
          }
          for (const t of this.markedTexts) {
            if (
              !this.markedChildren.has(t.parent) &&
              this.domConverter.mapViewToDom(t.parent)
            ) {
              this._updateText(t, { inlineFillerPosition: e });
            }
          }
          if (e) {
            const t = this.domConverter.viewPositionToDom(e);
            const i = t.parent.ownerDocument;
            if (!gd(t.parent)) {
              this._inlineFiller = Id(i, t.parent, t.offset);
            } else {
              this._inlineFiller = t.parent;
            }
          } else {
            this._inlineFiller = null;
          }
          this._updateSelection();
          this._updateFocus();
          this.markedTexts.clear();
          this.markedAttributes.clear();
          this.markedChildren.clear();
        }
        _updateChildrenMappings(e) {
          const t = this.domConverter.mapViewToDom(e);
          if (!t) {
            return;
          }
          const i = this.domConverter.mapViewToDom(e).childNodes;
          const n = Array.from(
            this.domConverter.viewChildrenToDom(e, t.ownerDocument, {
              withChildren: false,
            })
          );
          const o = this._diffNodeLists(i, n);
          const r = this._findReplaceActions(o, i, n);
          if (r.indexOf('replace') !== -1) {
            const t = { equal: 0, insert: 0, delete: 0 };
            for (const o of r) {
              if (o === 'replace') {
                const o = t.equal + t.insert;
                const r = t.equal + t.delete;
                const s = e.getChild(o);
                if (s && !(s.is('uiElement') || s.is('rawElement'))) {
                  this._updateElementMappings(s, i[r]);
                }
                Pd(n[o]);
                t.equal++;
              } else {
                t[o]++;
              }
            }
          }
        }
        _updateElementMappings(e, t) {
          this.domConverter.unbindDomElement(t);
          this.domConverter.bindElements(t, e);
          this.markedChildren.add(e);
          this.markedAttributes.add(e);
        }
        _getInlineFillerPosition() {
          const e = this.selection.getFirstPosition();
          if (e.parent.is('$text')) {
            return ul._createBefore(this.selection.getFirstPosition().parent);
          } else {
            return e;
          }
        }
        _isSelectionInInlineFiller() {
          if (this.selection.rangeCount != 1 || !this.selection.isCollapsed) {
            return false;
          }
          const e = this.selection.getFirstPosition();
          const t = this.domConverter.viewPositionToDom(e);
          if (t && ld(t.parent) && gd(t.parent)) {
            return true;
          }
          return false;
        }
        _removeInlineFiller() {
          const e = this._inlineFiller;
          if (!gd(e)) {
            throw new ss['b'](
              'view-renderer-filler-was-lost: The inline filler node was lost.',
              this
            );
          }
          if (md(e)) {
            e.parentNode.removeChild(e);
          } else {
            e.data = e.data.substr(hd);
          }
          this._inlineFiller = null;
        }
        _needsInlineFillerAtSelection() {
          if (this.selection.rangeCount != 1 || !this.selection.isCollapsed) {
            return false;
          }
          const e = this.selection.getFirstPosition();
          const t = e.parent;
          const i = e.offset;
          if (!this.domConverter.mapViewToDom(t.root)) {
            return false;
          }
          if (!t.is('element')) {
            return false;
          }
          if (!Md(t)) {
            return false;
          }
          if (i === t.getFillerOffset()) {
            return false;
          }
          const n = e.nodeBefore;
          const o = e.nodeAfter;
          if (n instanceof Bs || o instanceof Bs) {
            return false;
          }
          return true;
        }
        _updateText(e, t) {
          const i = this.domConverter.findCorrespondingDomText(e);
          const n = this.domConverter.viewToDom(e, i.ownerDocument);
          const o = i.data;
          let r = n.data;
          const s = t.inlineFillerPosition;
          if (s && s.parent == e.parent && s.offset == e.index) {
            r = fd + r;
          }
          if (o != r) {
            const e = kd(o, r);
            for (const t of e) {
              if (t.type === 'insert') {
                i.insertData(t.index, t.values.join(''));
              } else {
                i.deleteData(t.index, t.howMany);
              }
            }
          }
        }
        _updateAttrs(e) {
          const t = this.domConverter.mapViewToDom(e);
          if (!t) {
            return;
          }
          const i = Array.from(t.attributes).map((e) => e.name);
          const n = e.getAttributeKeys();
          for (const i of n) {
            t.setAttribute(i, e.getAttribute(i));
          }
          for (const n of i) {
            if (!e.hasAttribute(n)) {
              t.removeAttribute(n);
            }
          }
        }
        _updateChildren(e, t) {
          const i = this.domConverter.mapViewToDom(e);
          if (!i) {
            return;
          }
          const n = t.inlineFillerPosition;
          const o = this.domConverter.mapViewToDom(e).childNodes;
          const r = Array.from(
            this.domConverter.viewChildrenToDom(e, i.ownerDocument, {
              bind: true,
              inlineFillerPosition: n,
            })
          );
          if (n && n.parent === e) {
            Id(i.ownerDocument, r, n.offset);
          }
          const s = this._diffNodeLists(o, r);
          let a = 0;
          const c = new Set();
          for (const e of s) {
            if (e === 'delete') {
              c.add(o[a]);
              Pd(o[a]);
            } else if (e === 'equal') {
              a++;
            }
          }
          a = 0;
          for (const e of s) {
            if (e === 'insert') {
              Cd(i, a, r[a]);
              a++;
            } else if (e === 'equal') {
              this._markDescendantTextToSync(this.domConverter.domToView(r[a]));
              a++;
            }
          }
          for (const e of c) {
            if (!e.parentNode) {
              this.domConverter.unbindDomElement(e);
            }
          }
        }
        _diffNodeLists(e, t) {
          e = Rd(e, this._fakeSelectionContainer);
          return Td(e, t, Od.bind(null, this.domConverter));
        }
        _findReplaceActions(e, t, i) {
          if (e.indexOf('insert') === -1 || e.indexOf('delete') === -1) {
            return e;
          }
          let n = [];
          let o = [];
          let r = [];
          const s = { equal: 0, insert: 0, delete: 0 };
          for (const a of e) {
            if (a === 'insert') {
              r.push(i[s.equal + s.insert]);
            } else if (a === 'delete') {
              o.push(t[s.equal + s.delete]);
            } else {
              n = n.concat(
                Td(o, r, Nd).map((e) => (e === 'equal' ? 'replace' : e))
              );
              n.push('equal');
              o = [];
              r = [];
            }
            s[a]++;
          }
          return n.concat(
            Td(o, r, Nd).map((e) => (e === 'equal' ? 'replace' : e))
          );
        }
        _markDescendantTextToSync(e) {
          if (!e) {
            return;
          }
          if (e.is('$text')) {
            this.markedTexts.add(e);
          } else if (e.is('element')) {
            for (const t of e.getChildren()) {
              this._markDescendantTextToSync(t);
            }
          }
        }
        _updateSelection() {
          if (this.selection.rangeCount === 0) {
            this._removeDomSelection();
            this._removeFakeSelection();
            return;
          }
          const e = this.domConverter.mapViewToDom(
            this.selection.editableElement
          );
          if (!this.isFocused || !e) {
            return;
          }
          if (this.selection.isFake) {
            this._updateFakeSelection(e);
          } else {
            this._removeFakeSelection();
            this._updateDomSelection(e);
          }
        }
        _updateFakeSelection(e) {
          const t = e.ownerDocument;
          if (!this._fakeSelectionContainer) {
            this._fakeSelectionContainer = Ld(t);
          }
          const i = this._fakeSelectionContainer;
          this.domConverter.bindFakeSelection(i, this.selection);
          if (!this._fakeSelectionNeedsUpdate(e)) {
            return;
          }
          if (!i.parentElement || i.parentElement != e) {
            e.appendChild(i);
          }
          i.textContent = this.selection.fakeSelectionLabel || ' ';
          const n = t.getSelection();
          const o = t.createRange();
          n.removeAllRanges();
          o.selectNodeContents(i);
          n.addRange(o);
        }
        _updateDomSelection(e) {
          const t = e.ownerDocument.defaultView.getSelection();
          if (!this._domSelectionNeedsUpdate(t)) {
            return;
          }
          const i = this.domConverter.viewPositionToDom(this.selection.anchor);
          const n = this.domConverter.viewPositionToDom(this.selection.focus);
          e.focus();
          t.collapse(i.parent, i.offset);
          t.extend(n.parent, n.offset);
          if (Cl.isGecko) {
            zd(n, t);
          }
        }
        _domSelectionNeedsUpdate(e) {
          if (!this.domConverter.isDomSelectionCorrect(e)) {
            return true;
          }
          const t = e && this.domConverter.domSelectionToView(e);
          if (t && this.selection.isEqual(t)) {
            return false;
          }
          if (!this.selection.isCollapsed && this.selection.isSimilar(t)) {
            return false;
          }
          return true;
        }
        _fakeSelectionNeedsUpdate(e) {
          const t = this._fakeSelectionContainer;
          const i = e.ownerDocument.getSelection();
          if (!t || t.parentElement !== e) {
            return true;
          }
          if (i.anchorNode !== t && !t.contains(i.anchorNode)) {
            return true;
          }
          return t.textContent !== this.selection.fakeSelectionLabel;
        }
        _removeDomSelection() {
          for (const e of this.domDocuments) {
            const t = e.getSelection();
            if (t.rangeCount) {
              const t = e.activeElement;
              const i = this.domConverter.mapDomToView(t);
              if (t && i) {
                e.getSelection().removeAllRanges();
              }
            }
          }
        }
        _removeFakeSelection() {
          const e = this._fakeSelectionContainer;
          if (e) {
            e.remove();
          }
        }
        _updateFocus() {
          if (this.isFocused) {
            const e = this.selection.editableElement;
            if (e) {
              this.domConverter.focus(e);
            }
          }
        }
      }
      ys(Sd, Qc);
      function Md(e) {
        if (e.getAttribute('contenteditable') == 'false') {
          return false;
        }
        const t = e.findAncestor((e) => e.hasAttribute('contenteditable'));
        return !t || t.getAttribute('contenteditable') == 'true';
      }
      function Id(e, t, i) {
        const n = t instanceof Array ? t : t.childNodes;
        const o = n[i];
        if (ld(o)) {
          o.data = fd + o.data;
          return o;
        } else {
          const o = e.createTextNode(fd);
          if (Array.isArray(t)) {
            n.splice(i, 0, o);
          } else {
            Cd(t, i, o);
          }
          return o;
        }
      }
      function Nd(e, t) {
        return (
          Ed(e) &&
          Ed(t) &&
          !ld(e) &&
          !ld(t) &&
          e.nodeType !== Node.COMMENT_NODE &&
          t.nodeType !== Node.COMMENT_NODE &&
          e.tagName.toLowerCase() === t.tagName.toLowerCase()
        );
      }
      function Od(e, t, i) {
        if (t === i) {
          return true;
        } else if (ld(t) && ld(i)) {
          return t.data === i.data;
        } else if (e.isBlockFiller(t) && e.isBlockFiller(i)) {
          return true;
        }
        return false;
      }
      function zd(e, t) {
        const i = e.parent;
        if (
          i.nodeType != Node.ELEMENT_NODE ||
          e.offset != i.childNodes.length - 1
        ) {
          return;
        }
        const n = i.childNodes[e.offset];
        if (n && n.tagName == 'BR') {
          t.addRange(t.getRangeAt(0));
        }
      }
      function Rd(e, t) {
        const i = Array.from(e);
        if (i.length == 0 || !t) {
          return i;
        }
        const n = i[i.length - 1];
        if (n == t) {
          i.pop();
        }
        return i;
      }
      function Ld(e) {
        const t = e.createElement('div');
        Object.assign(t.style, {
          position: 'fixed',
          top: 0,
          left: '-9999px',
          width: '42px',
        });
        t.textContent = ' ';
        return t;
      }
      var Vd = { window: window, document: document };
      function Dd(e) {
        let t = 0;
        while (e.previousSibling) {
          e = e.previousSibling;
          t++;
        }
        return t;
      }
      function jd(e) {
        const t = [];
        while (e && e.nodeType != Node.DOCUMENT_NODE) {
          t.unshift(e);
          e = e.parentNode;
        }
        return t;
      }
      function Bd(e, t) {
        const i = jd(e);
        const n = jd(t);
        let o = 0;
        while (i[o] == n[o] && i[o]) {
          o++;
        }
        return o === 0 ? null : i[o - 1];
      }
      const Fd = ud(document);
      class Hd {
        constructor(e, t = {}) {
          this.document = e;
          this.blockFillerMode = t.blockFillerMode || 'br';
          this.preElements = ['pre'];
          this.blockElements = [
            'p',
            'div',
            'h1',
            'h2',
            'h3',
            'h4',
            'h5',
            'h6',
            'li',
            'dd',
            'dt',
            'figcaption',
            'td',
            'th',
          ];
          this._blockFiller = this.blockFillerMode == 'br' ? ud : dd;
          this._domToViewMapping = new WeakMap();
          this._viewToDomMapping = new WeakMap();
          this._fakeSelectionMapping = new WeakMap();
        }
        bindFakeSelection(e, t) {
          this._fakeSelectionMapping.set(e, new ml(t));
        }
        fakeSelectionToView(e) {
          return this._fakeSelectionMapping.get(e);
        }
        bindElements(e, t) {
          this._domToViewMapping.set(e, t);
          this._viewToDomMapping.set(t, e);
        }
        unbindDomElement(e) {
          const t = this._domToViewMapping.get(e);
          if (t) {
            this._domToViewMapping.delete(e);
            this._viewToDomMapping.delete(t);
            for (const t of e.childNodes) {
              this.unbindDomElement(t);
            }
          }
        }
        bindDocumentFragments(e, t) {
          this._domToViewMapping.set(e, t);
          this._viewToDomMapping.set(t, e);
        }
        viewToDom(e, t, i = {}) {
          if (e.is('$text')) {
            const i = this._processDataFromViewText(e);
            return t.createTextNode(i);
          } else {
            if (this.mapViewToDom(e)) {
              return this.mapViewToDom(e);
            }
            let n;
            if (e.is('documentFragment')) {
              n = t.createDocumentFragment();
              if (i.bind) {
                this.bindDocumentFragments(n, e);
              }
            } else if (e.is('uiElement')) {
              n = e.render(t);
              if (i.bind) {
                this.bindElements(n, e);
              }
              return n;
            } else {
              if (e.hasAttribute('xmlns')) {
                n = t.createElementNS(e.getAttribute('xmlns'), e.name);
              } else {
                n = t.createElement(e.name);
              }
              if (e.is('rawElement')) {
                e.render(n);
              }
              if (i.bind) {
                this.bindElements(n, e);
              }
              for (const t of e.getAttributeKeys()) {
                n.setAttribute(t, e.getAttribute(t));
              }
            }
            if (i.withChildren || i.withChildren === undefined) {
              for (const o of this.viewChildrenToDom(e, t, i)) {
                n.appendChild(o);
              }
            }
            return n;
          }
        }
        *viewChildrenToDom(e, t, i = {}) {
          const n = e.getFillerOffset && e.getFillerOffset();
          let o = 0;
          for (const r of e.getChildren()) {
            if (n === o) {
              yield this._blockFiller(t);
            }
            yield this.viewToDom(r, t, i);
            o++;
          }
          if (n === o) {
            yield this._blockFiller(t);
          }
        }
        viewRangeToDom(e) {
          const t = this.viewPositionToDom(e.start);
          const i = this.viewPositionToDom(e.end);
          const n = document.createRange();
          n.setStart(t.parent, t.offset);
          n.setEnd(i.parent, i.offset);
          return n;
        }
        viewPositionToDom(e) {
          const t = e.parent;
          if (t.is('$text')) {
            const i = this.findCorrespondingDomText(t);
            if (!i) {
              return null;
            }
            let n = e.offset;
            if (gd(i)) {
              n += hd;
            }
            return { parent: i, offset: n };
          } else {
            let i, n, o;
            if (e.offset === 0) {
              i = this.mapViewToDom(t);
              if (!i) {
                return null;
              }
              o = i.childNodes[0];
            } else {
              const t = e.nodeBefore;
              n = t.is('$text')
                ? this.findCorrespondingDomText(t)
                : this.mapViewToDom(e.nodeBefore);
              if (!n) {
                return null;
              }
              i = n.parentNode;
              o = n.nextSibling;
            }
            if (ld(o) && gd(o)) {
              return { parent: o, offset: hd };
            }
            const r = n ? Dd(n) + 1 : 0;
            return { parent: i, offset: r };
          }
        }
        domToView(e, t = {}) {
          if (this.isBlockFiller(e, this.blockFillerMode)) {
            return null;
          }
          const i = this.getHostViewElement(e, this._domToViewMapping);
          if (i) {
            return i;
          }
          if (ld(e)) {
            if (md(e)) {
              return null;
            } else {
              const t = this._processDataFromDomText(e);
              return t === '' ? null : new Bs(this.document, t);
            }
          } else if (this.isComment(e)) {
            return null;
          } else {
            if (this.mapDomToView(e)) {
              return this.mapDomToView(e);
            }
            let i;
            if (this.isDocumentFragment(e)) {
              i = new Kl(this.document);
              if (t.bind) {
                this.bindDocumentFragments(e, i);
              }
            } else {
              const n = t.keepOriginalCase
                ? e.tagName
                : e.tagName.toLowerCase();
              i = new Dc(this.document, n);
              if (t.bind) {
                this.bindElements(e, i);
              }
              const o = e.attributes;
              for (let e = o.length - 1; e >= 0; e--) {
                i._setAttribute(o[e].name, o[e].value);
              }
            }
            if (t.withChildren || t.withChildren === undefined) {
              for (const n of this.domChildrenToView(e, t)) {
                i._appendChild(n);
              }
            }
            return i;
          }
        }
        *domChildrenToView(e, t = {}) {
          for (let i = 0; i < e.childNodes.length; i++) {
            const n = e.childNodes[i];
            const o = this.domToView(n, t);
            if (o !== null) {
              yield o;
            }
          }
        }
        domSelectionToView(e) {
          if (e.rangeCount === 1) {
            let t = e.getRangeAt(0).startContainer;
            if (ld(t)) {
              t = t.parentNode;
            }
            const i = this.fakeSelectionToView(t);
            if (i) {
              return i;
            }
          }
          const t = this.isDomSelectionBackward(e);
          const i = [];
          for (let t = 0; t < e.rangeCount; t++) {
            const n = e.getRangeAt(t);
            const o = this.domRangeToView(n);
            if (o) {
              i.push(o);
            }
          }
          return new ml(i, { backward: t });
        }
        domRangeToView(e) {
          const t = this.domPositionToView(e.startContainer, e.startOffset);
          const i = this.domPositionToView(e.endContainer, e.endOffset);
          if (t && i) {
            return new hl(t, i);
          }
          return null;
        }
        domPositionToView(e, t) {
          if (this.isBlockFiller(e, this.blockFillerMode)) {
            return this.domPositionToView(e.parentNode, Dd(e));
          }
          const i = this.mapDomToView(e);
          if (i && (i.is('uiElement') || i.is('rawElement'))) {
            return ul._createBefore(i);
          }
          if (ld(e)) {
            if (md(e)) {
              return this.domPositionToView(e.parentNode, Dd(e));
            }
            const i = this.findCorrespondingViewText(e);
            let n = t;
            if (!i) {
              return null;
            }
            if (gd(e)) {
              n -= hd;
              n = n < 0 ? 0 : n;
            }
            return new ul(i, n);
          } else {
            if (t === 0) {
              const t = this.mapDomToView(e);
              if (t) {
                return new ul(t, 0);
              }
            } else {
              const i = e.childNodes[t - 1];
              const n = ld(i)
                ? this.findCorrespondingViewText(i)
                : this.mapDomToView(i);
              if (n && n.parent) {
                return new ul(n.parent, n.index + 1);
              }
            }
            return null;
          }
        }
        mapDomToView(e) {
          const t = this.getHostViewElement(e);
          return t || this._domToViewMapping.get(e);
        }
        findCorrespondingViewText(e) {
          if (md(e)) {
            return null;
          }
          const t = this.getHostViewElement(e);
          if (t) {
            return t;
          }
          const i = e.previousSibling;
          if (i) {
            if (!this.isElement(i)) {
              return null;
            }
            const e = this.mapDomToView(i);
            if (e) {
              const t = e.nextSibling;
              if (t instanceof Bs) {
                return e.nextSibling;
              } else {
                return null;
              }
            }
          } else {
            const t = this.mapDomToView(e.parentNode);
            if (t) {
              const e = t.getChild(0);
              if (e instanceof Bs) {
                return e;
              } else {
                return null;
              }
            }
          }
          return null;
        }
        mapViewToDom(e) {
          return this._viewToDomMapping.get(e);
        }
        findCorrespondingDomText(e) {
          const t = e.previousSibling;
          if (t && this.mapViewToDom(t)) {
            return this.mapViewToDom(t).nextSibling;
          }
          if (!t && e.parent && this.mapViewToDom(e.parent)) {
            return this.mapViewToDom(e.parent).childNodes[0];
          }
          return null;
        }
        focus(e) {
          const t = this.mapViewToDom(e);
          if (t && t.ownerDocument.activeElement !== t) {
            const { scrollX: e, scrollY: i } = Vd.window;
            const n = [];
            qd(t, (e) => {
              const { scrollLeft: t, scrollTop: i } = e;
              n.push([t, i]);
            });
            t.focus();
            qd(t, (e) => {
              const [t, i] = n.shift();
              e.scrollLeft = t;
              e.scrollTop = i;
            });
            Vd.window.scrollTo(e, i);
          }
        }
        isElement(e) {
          return e && e.nodeType == Node.ELEMENT_NODE;
        }
        isDocumentFragment(e) {
          return e && e.nodeType == Node.DOCUMENT_FRAGMENT_NODE;
        }
        isComment(e) {
          return e && e.nodeType == Node.COMMENT_NODE;
        }
        isBlockFiller(e) {
          if (this.blockFillerMode == 'br') {
            return e.isEqualNode(Fd);
          }
          if (
            e.tagName === 'BR' &&
            $d(e, this.blockElements) &&
            e.parentNode.childNodes.length === 1
          ) {
            return true;
          }
          return Wd(e, this.blockElements);
        }
        isDomSelectionBackward(e) {
          if (e.isCollapsed) {
            return false;
          }
          const t = document.createRange();
          t.setStart(e.anchorNode, e.anchorOffset);
          t.setEnd(e.focusNode, e.focusOffset);
          const i = t.collapsed;
          t.detach();
          return i;
        }
        getHostViewElement(e) {
          const t = jd(e);
          t.pop();
          while (t.length) {
            const e = t.pop();
            const i = this._domToViewMapping.get(e);
            if (i && (i.is('uiElement') || i.is('rawElement'))) {
              return i;
            }
          }
          return null;
        }
        isDomSelectionCorrect(e) {
          return (
            this._isDomSelectionPositionCorrect(e.anchorNode, e.anchorOffset) &&
            this._isDomSelectionPositionCorrect(e.focusNode, e.focusOffset)
          );
        }
        _isDomSelectionPositionCorrect(e, t) {
          if (ld(e) && gd(e) && t < hd) {
            return false;
          }
          if (this.isElement(e) && gd(e.childNodes[t])) {
            return false;
          }
          const i = this.mapDomToView(e);
          if (i && (i.is('uiElement') || i.is('rawElement'))) {
            return false;
          }
          return true;
        }
        _processDataFromViewText(e) {
          let t = e.data;
          if (e.getAncestors().some((e) => this.preElements.includes(e.name))) {
            return t;
          }
          if (t.charAt(0) == ' ') {
            const i = this._getTouchingViewTextNode(e, false);
            const n = i && this._nodeEndsWithSpace(i);
            if (n || !i) {
              t = ' ' + t.substr(1);
            }
          }
          if (t.charAt(t.length - 1) == ' ') {
            const i = this._getTouchingViewTextNode(e, true);
            if (
              t.charAt(t.length - 2) == ' ' ||
              !i ||
              i.data.charAt(0) == ' '
            ) {
              t = t.substr(0, t.length - 1) + ' ';
            }
          }
          return t.replace(/ {2}/g, '  ');
        }
        _nodeEndsWithSpace(e) {
          if (e.getAncestors().some((e) => this.preElements.includes(e.name))) {
            return false;
          }
          const t = this._processDataFromViewText(e);
          return t.charAt(t.length - 1) == ' ';
        }
        _processDataFromDomText(e) {
          let t = e.data;
          if (Ud(e, this.preElements)) {
            return pd(e);
          }
          t = t.replace(/[ \n\t\r]{1,}/g, ' ');
          const i = this._getTouchingInlineDomNode(e, false);
          const n = this._getTouchingInlineDomNode(e, true);
          const o = this._checkShouldLeftTrimDomText(i);
          const r = this._checkShouldRightTrimDomText(e, n);
          if (o) {
            t = t.replace(/^ /, '');
          }
          if (r) {
            t = t.replace(/ $/, '');
          }
          t = pd(new Text(t));
          t = t.replace(/ \u00A0/g, '  ');
          if (
            /( |\u00A0)\u00A0$/.test(t) ||
            !n ||
            (n.data && n.data.charAt(0) == ' ')
          ) {
            t = t.replace(/\u00A0$/, ' ');
          }
          if (o) {
            t = t.replace(/^\u00A0/, ' ');
          }
          return t;
        }
        _checkShouldLeftTrimDomText(e) {
          if (!e) {
            return true;
          }
          if (Yr(e)) {
            return true;
          }
          return /[^\S\u00A0]/.test(e.data.charAt(e.data.length - 1));
        }
        _checkShouldRightTrimDomText(e, t) {
          if (t) {
            return false;
          }
          return !gd(e);
        }
        _getTouchingViewTextNode(e, t) {
          const i = new dl({
            startPosition: t ? ul._createAfter(e) : ul._createBefore(e),
            direction: t ? 'forward' : 'backward',
          });
          for (const e of i) {
            if (e.item.is('containerElement')) {
              return null;
            } else if (e.item.is('element', 'br')) {
              return null;
            } else if (e.item.is('$textProxy')) {
              return e.item;
            }
          }
          return null;
        }
        _getTouchingInlineDomNode(e, t) {
          if (!e.parentNode) {
            return null;
          }
          const i = t ? 'nextNode' : 'previousNode';
          const n = e.ownerDocument;
          const o = jd(e)[0];
          const r = n.createTreeWalker(
            o,
            NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT,
            {
              acceptNode(e) {
                if (ld(e)) {
                  return NodeFilter.FILTER_ACCEPT;
                }
                if (e.tagName == 'BR') {
                  return NodeFilter.FILTER_ACCEPT;
                }
                return NodeFilter.FILTER_SKIP;
              },
            }
          );
          r.currentNode = e;
          const s = r[i]();
          if (s !== null) {
            const t = Bd(e, s);
            if (
              t &&
              !Ud(e, this.blockElements, t) &&
              !Ud(s, this.blockElements, t)
            ) {
              return s;
            }
          }
          return null;
        }
      }
      function Ud(e, t, i) {
        let n = jd(e);
        if (i) {
          n = n.slice(n.indexOf(i) + 1);
        }
        return n.some((e) => e.tagName && t.includes(e.tagName.toLowerCase()));
      }
      function qd(e, t) {
        while (e && e != Vd.document) {
          t(e);
          e = e.parentNode;
        }
      }
      function Wd(e, t) {
        const i = ld(e) && e.data == ' ';
        return i && $d(e, t) && e.parentNode.childNodes.length === 1;
      }
      function $d(e, t) {
        const i = e.parentNode;
        return i && i.tagName && t.includes(i.tagName.toLowerCase());
      }
      function Gd(e) {
        const t = Object.prototype.toString.apply(e);
        if (t == '[object Window]') {
          return true;
        }
        if (t == '[object global]') {
          return true;
        }
        return false;
      }
      const Yd = Wc({}, ds, {
        listenTo(e, ...t) {
          if (Ed(e) || Gd(e)) {
            const i = this._getProxyEmitter(e) || new Qd(e);
            i.attach(...t);
            e = i;
          }
          ds.listenTo.call(this, e, ...t);
        },
        stopListening(e, t, i) {
          if (Ed(e) || Gd(e)) {
            const t = this._getProxyEmitter(e);
            if (!t) {
              return;
            }
            e = t;
          }
          ds.stopListening.call(this, e, t, i);
          if (e instanceof Qd) {
            e.detach(t);
          }
        },
        _getProxyEmitter(e) {
          return us(this, Jd(e));
        },
      });
      var Kd = Yd;
      class Qd {
        constructor(e) {
          hs(this, Jd(e));
          this._domNode = e;
        }
      }
      Wc(Qd.prototype, ds, {
        attach(e, t, i = {}) {
          if (this._domListeners && this._domListeners[e]) {
            return;
          }
          const n = { capture: !!i.useCapture, passive: !!i.usePassive };
          const o = this._createDomListener(e, n);
          this._domNode.addEventListener(e, o, n);
          if (!this._domListeners) {
            this._domListeners = {};
          }
          this._domListeners[e] = o;
        },
        detach(e) {
          let t;
          if (
            this._domListeners[e] &&
            (!(t = this._events[e]) || !t.callbacks.length)
          ) {
            this._domListeners[e].removeListener();
          }
        },
        _createDomListener(e, t) {
          const i = (t) => {
            this.fire(e, t);
          };
          i.removeListener = () => {
            this._domNode.removeEventListener(e, i, t);
            delete this._domListeners[e];
          };
          return i;
        },
      });
      function Jd(e) {
        return e['data-ck-expando'] || (e['data-ck-expando'] = is());
      }
      class Zd {
        constructor(e) {
          this.view = e;
          this.document = e.document;
          this.isEnabled = false;
        }
        enable() {
          this.isEnabled = true;
        }
        disable() {
          this.isEnabled = false;
        }
        destroy() {
          this.disable();
          this.stopListening();
        }
      }
      ys(Zd, Kd);
      var Xd = '__lodash_hash_undefined__';
      function eu(e) {
        this.__data__.set(e, Xd);
        return this;
      }
      var tu = eu;
      function iu(e) {
        return this.__data__.has(e);
      }
      var nu = iu;
      function ou(e) {
        var t = -1,
          i = e == null ? 0 : e.length;
        this.__data__ = new _t();
        while (++t < i) {
          this.add(e[t]);
        }
      }
      ou.prototype.add = ou.prototype.push = tu;
      ou.prototype.has = nu;
      var ru = ou;
      function su(e, t) {
        var i = -1,
          n = e == null ? 0 : e.length;
        while (++i < n) {
          if (t(e[i], i, e)) {
            return true;
          }
        }
        return false;
      }
      var au = su;
      function cu(e, t) {
        return e.has(t);
      }
      var lu = cu;
      var du = 1,
        uu = 2;
      function hu(e, t, i, n, o, r) {
        var s = i & du,
          a = e.length,
          c = t.length;
        if (a != c && !(s && c > a)) {
          return false;
        }
        var l = r.get(e);
        if (l && r.get(t)) {
          return l == t;
        }
        var d = -1,
          u = true,
          h = i & uu ? new ru() : undefined;
        r.set(e, t);
        r.set(t, e);
        while (++d < a) {
          var f = e[d],
            g = t[d];
          if (n) {
            var m = s ? n(g, f, d, t, e, r) : n(f, g, d, e, t, r);
          }
          if (m !== undefined) {
            if (m) {
              continue;
            }
            u = false;
            break;
          }
          if (h) {
            if (
              !au(t, function (e, t) {
                if (!lu(h, t) && (f === e || o(f, e, i, n, r))) {
                  return h.push(t);
                }
              })
            ) {
              u = false;
              break;
            }
          } else if (!(f === g || o(f, g, i, n, r))) {
            u = false;
            break;
          }
        }
        r['delete'](e);
        r['delete'](t);
        return u;
      }
      var fu = hu;
      function gu(e) {
        var t = -1,
          i = Array(e.size);
        e.forEach(function (e, n) {
          i[++t] = [n, e];
        });
        return i;
      }
      var mu = gu;
      function pu(e) {
        var t = -1,
          i = Array(e.size);
        e.forEach(function (e) {
          i[++t] = e;
        });
        return i;
      }
      var bu = pu;
      var wu = 1,
        ku = 2;
      var _u = '[object Boolean]',
        vu = '[object Date]',
        yu = '[object Error]',
        xu = '[object Map]',
        Au = '[object Number]',
        Tu = '[object RegExp]',
        Cu = '[object Set]',
        Pu = '[object String]',
        Eu = '[object Symbol]';
      var Su = '[object ArrayBuffer]',
        Mu = '[object DataView]';
      var Iu = r ? r.prototype : undefined,
        Nu = Iu ? Iu.valueOf : undefined;
      function Ou(e, t, i, n, o, r, s) {
        switch (i) {
          case Mu:
            if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) {
              return false;
            }
            e = e.buffer;
            t = t.buffer;
          case Su:
            if (e.byteLength != t.byteLength || !r(new fo(e), new fo(t))) {
              return false;
            }
            return true;
          case _u:
          case vu:
          case Au:
            return D(+e, +t);
          case yu:
            return e.name == t.name && e.message == t.message;
          case Tu:
          case Pu:
            return e == t + '';
          case xu:
            var a = mu;
          case Cu:
            var c = n & wu;
            a || (a = bu);
            if (e.size != t.size && !c) {
              return false;
            }
            var l = s.get(e);
            if (l) {
              return l == t;
            }
            n |= ku;
            s.set(e, t);
            var d = fu(a(e), a(t), n, o, r, s);
            s['delete'](e);
            return d;
          case Eu:
            if (Nu) {
              return Nu.call(e) == Nu.call(t);
            }
        }
        return false;
      }
      var zu = Ou;
      var Ru = 1;
      var Lu = Object.prototype;
      var Vu = Lu.hasOwnProperty;
      function Du(e, t, i, n, o, r) {
        var s = i & Ru,
          a = Vn(e),
          c = a.length,
          l = Vn(t),
          d = l.length;
        if (c != d && !s) {
          return false;
        }
        var u = c;
        while (u--) {
          var h = a[u];
          if (!(s ? h in t : Vu.call(t, h))) {
            return false;
          }
        }
        var f = r.get(e);
        if (f && r.get(t)) {
          return f == t;
        }
        var g = true;
        r.set(e, t);
        r.set(t, e);
        var m = s;
        while (++u < c) {
          h = a[u];
          var p = e[h],
            b = t[h];
          if (n) {
            var w = s ? n(b, p, h, t, e, r) : n(p, b, h, e, t, r);
          }
          if (!(w === undefined ? p === b || o(p, b, i, n, r) : w)) {
            g = false;
            break;
          }
          m || (m = h == 'constructor');
        }
        if (g && !m) {
          var k = e.constructor,
            _ = t.constructor;
          if (
            k != _ &&
            'constructor' in e &&
            'constructor' in t &&
            !(
              typeof k == 'function' &&
              k instanceof k &&
              typeof _ == 'function' &&
              _ instanceof _
            )
          ) {
            g = false;
          }
        }
        r['delete'](e);
        r['delete'](t);
        return g;
      }
      var ju = Du;
      var Bu = 1;
      var Fu = '[object Arguments]',
        Hu = '[object Array]',
        Uu = '[object Object]';
      var qu = Object.prototype;
      var Wu = qu.hasOwnProperty;
      function $u(e, t, i, n, o, r) {
        var s = Kt(e),
          a = Kt(t),
          c = s ? Hu : so(e),
          l = a ? Hu : so(t);
        c = c == Fu ? Uu : c;
        l = l == Fu ? Uu : l;
        var d = c == Uu,
          u = l == Uu,
          h = c == l;
        if (h && Object(Qt['a'])(e)) {
          if (!Object(Qt['a'])(t)) {
            return false;
          }
          s = true;
          d = false;
        }
        if (h && !d) {
          r || (r = new Tt());
          return s || Li(e) ? fu(e, t, i, n, o, r) : zu(e, t, c, i, n, o, r);
        }
        if (!(i & Bu)) {
          var f = d && Wu.call(e, '__wrapped__'),
            g = u && Wu.call(t, '__wrapped__');
          if (f || g) {
            var m = f ? e.value() : e,
              p = g ? t.value() : t;
            r || (r = new Tt());
            return o(m, p, i, n, r);
          }
        }
        if (!h) {
          return false;
        }
        r || (r = new Tt());
        return ju(e, t, i, n, o, r);
      }
      var Gu = $u;
      function Yu(e, t, i, n, o) {
        if (e === t) {
          return true;
        }
        if (e == null || t == null || (!C(e) && !C(t))) {
          return e !== e && t !== t;
        }
        return Gu(e, t, i, n, Yu, o);
      }
      var Ku = Yu;
      function Qu(e, t, i) {
        i = typeof i == 'function' ? i : undefined;
        var n = i ? i(e, t) : undefined;
        return n === undefined ? Ku(e, t, undefined, i) : !!n;
      }
      var Ju = Qu;
      class Zu extends Zd {
        constructor(e) {
          super(e);
          this._config = {
            childList: true,
            characterData: true,
            characterDataOldValue: true,
            subtree: true,
          };
          this.domConverter = e.domConverter;
          this.renderer = e._renderer;
          this._domElements = [];
          this._mutationObserver = new window.MutationObserver(
            this._onMutations.bind(this)
          );
        }
        flush() {
          this._onMutations(this._mutationObserver.takeRecords());
        }
        observe(e) {
          this._domElements.push(e);
          if (this.isEnabled) {
            this._mutationObserver.observe(e, this._config);
          }
        }
        enable() {
          super.enable();
          for (const e of this._domElements) {
            this._mutationObserver.observe(e, this._config);
          }
        }
        disable() {
          super.disable();
          this._mutationObserver.disconnect();
        }
        destroy() {
          super.destroy();
          this._mutationObserver.disconnect();
        }
        _onMutations(e) {
          if (e.length === 0) {
            return;
          }
          const t = this.domConverter;
          const i = new Map();
          const n = new Set();
          for (const i of e) {
            if (i.type === 'childList') {
              const e = t.mapDomToView(i.target);
              if (e && (e.is('uiElement') || e.is('rawElement'))) {
                continue;
              }
              if (e && !this._isBogusBrMutation(i)) {
                n.add(e);
              }
            }
          }
          for (const o of e) {
            const e = t.mapDomToView(o.target);
            if (e && (e.is('uiElement') || e.is('rawElement'))) {
              continue;
            }
            if (o.type === 'characterData') {
              const e = t.findCorrespondingViewText(o.target);
              if (e && !n.has(e.parent)) {
                i.set(e, {
                  type: 'text',
                  oldText: e.data,
                  newText: pd(o.target),
                  node: e,
                });
              } else if (!e && gd(o.target)) {
                n.add(t.mapDomToView(o.target.parentNode));
              }
            }
          }
          const o = [];
          for (const e of i.values()) {
            this.renderer.markToSync('text', e.node);
            o.push(e);
          }
          for (const e of n) {
            const i = t.mapViewToDom(e);
            const n = Array.from(e.getChildren());
            const r = Array.from(
              t.domChildrenToView(i, { withChildren: false })
            );
            if (!Ju(n, r, a)) {
              this.renderer.markToSync('children', e);
              o.push({
                type: 'children',
                oldChildren: n,
                newChildren: r,
                node: e,
              });
            }
          }
          const r = e[0].target.ownerDocument.getSelection();
          let s = null;
          if (r && r.anchorNode) {
            const e = t.domPositionToView(r.anchorNode, r.anchorOffset);
            const i = t.domPositionToView(r.focusNode, r.focusOffset);
            if (e && i) {
              s = new ml(e);
              s.setFocus(i);
            }
          }
          if (o.length) {
            this.document.fire('mutations', o, s);
            this.view.forceRender();
          }
          function a(e, t) {
            if (Array.isArray(e)) {
              return;
            }
            if (e === t) {
              return true;
            } else if (e.is('$text') && t.is('$text')) {
              return e.data === t.data;
            }
            return false;
          }
        }
        _isBogusBrMutation(e) {
          let t = null;
          if (
            e.nextSibling === null &&
            e.removedNodes.length === 0 &&
            e.addedNodes.length == 1
          ) {
            t = this.domConverter.domToView(e.addedNodes[0], {
              withChildren: false,
            });
          }
          return t && t.is('element', 'br');
        }
      }
      class Xu {
        constructor(e, t, i) {
          this.view = e;
          this.document = e.document;
          this.domEvent = t;
          this.domTarget = t.target;
          Wc(this, i);
        }
        get target() {
          return this.view.domConverter.mapDomToView(this.domTarget);
        }
        preventDefault() {
          this.domEvent.preventDefault();
        }
        stopPropagation() {
          this.domEvent.stopPropagation();
        }
      }
      class eh extends Zd {
        constructor(e) {
          super(e);
          this.useCapture = false;
        }
        observe(e) {
          const t =
            typeof this.domEventType == 'string'
              ? [this.domEventType]
              : this.domEventType;
          t.forEach((t) => {
            this.listenTo(
              e,
              t,
              (e, t) => {
                if (this.isEnabled) {
                  this.onDomEvent(t);
                }
              },
              { useCapture: this.useCapture }
            );
          });
        }
        fire(e, t, i) {
          if (this.isEnabled) {
            this.document.fire(e, new Xu(this.view, t, i));
          }
        }
      }
      class th extends eh {
        constructor(e) {
          super(e);
          this.domEventType = ['keydown', 'keyup'];
        }
        onDomEvent(e) {
          this.fire(e.type, e, {
            keyCode: e.keyCode,
            altKey: e.altKey,
            ctrlKey: e.ctrlKey || e.metaKey,
            shiftKey: e.shiftKey,
            get keystroke() {
              return Rl(this);
            },
          });
        }
      }
      var ih = function () {
        return n['a'].Date.now();
      };
      var nh = ih;
      var oh = 0 / 0;
      var rh = /^\s+|\s+$/g;
      var sh = /^[-+]0x[0-9a-f]+$/i;
      var ah = /^0b[01]+$/i;
      var ch = /^0o[0-7]+$/i;
      var lh = parseInt;
      function dh(e) {
        if (typeof e == 'number') {
          return e;
        }
        if (Zs(e)) {
          return oh;
        }
        if (ce(e)) {
          var t = typeof e.valueOf == 'function' ? e.valueOf() : e;
          e = ce(t) ? t + '' : t;
        }
        if (typeof e != 'string') {
          return e === 0 ? e : +e;
        }
        e = e.replace(rh, '');
        var i = ah.test(e);
        return i || ch.test(e)
          ? lh(e.slice(2), i ? 2 : 8)
          : sh.test(e)
          ? oh
          : +e;
      }
      var uh = dh;
      var hh = 'Expected a function';
      var fh = Math.max,
        gh = Math.min;
      function mh(e, t, i) {
        var n,
          o,
          r,
          s,
          a,
          c,
          l = 0,
          d = false,
          u = false,
          h = true;
        if (typeof e != 'function') {
          throw new TypeError(hh);
        }
        t = uh(t) || 0;
        if (ce(i)) {
          d = !!i.leading;
          u = 'maxWait' in i;
          r = u ? fh(uh(i.maxWait) || 0, t) : r;
          h = 'trailing' in i ? !!i.trailing : h;
        }
        function f(t) {
          var i = n,
            r = o;
          n = o = undefined;
          l = t;
          s = e.apply(r, i);
          return s;
        }
        function g(e) {
          l = e;
          a = setTimeout(b, t);
          return d ? f(e) : s;
        }
        function m(e) {
          var i = e - c,
            n = e - l,
            o = t - i;
          return u ? gh(o, r - n) : o;
        }
        function p(e) {
          var i = e - c,
            n = e - l;
          return c === undefined || i >= t || i < 0 || (u && n >= r);
        }
        function b() {
          var e = nh();
          if (p(e)) {
            return w(e);
          }
          a = setTimeout(b, m(e));
        }
        function w(e) {
          a = undefined;
          if (h && n) {
            return f(e);
          }
          n = o = undefined;
          return s;
        }
        function k() {
          if (a !== undefined) {
            clearTimeout(a);
          }
          l = 0;
          n = c = o = a = undefined;
        }
        function _() {
          return a === undefined ? s : w(nh());
        }
        function v() {
          var e = nh(),
            i = p(e);
          n = arguments;
          o = this;
          c = e;
          if (i) {
            if (a === undefined) {
              return g(c);
            }
            if (u) {
              clearTimeout(a);
              a = setTimeout(b, t);
              return f(c);
            }
          }
          if (a === undefined) {
            a = setTimeout(b, t);
          }
          return s;
        }
        v.cancel = k;
        v.flush = _;
        return v;
      }
      var ph = mh;
      class bh extends Zd {
        constructor(e) {
          super(e);
          this._fireSelectionChangeDoneDebounced = ph(
            (e) => this.document.fire('selectionChangeDone', e),
            200
          );
        }
        observe() {
          const e = this.document;
          e.on(
            'keydown',
            (t, i) => {
              const n = e.selection;
              if (n.isFake && wh(i.keyCode) && this.isEnabled) {
                i.preventDefault();
                this._handleSelectionMove(i.keyCode);
              }
            },
            { priority: 'lowest' }
          );
        }
        destroy() {
          super.destroy();
          this._fireSelectionChangeDoneDebounced.cancel();
        }
        _handleSelectionMove(e) {
          const t = this.document.selection;
          const i = new ml(t.getRanges(), {
            backward: t.isBackward,
            fake: false,
          });
          if (e == zl.arrowleft || e == zl.arrowup) {
            i.setTo(i.getFirstPosition());
          }
          if (e == zl.arrowright || e == zl.arrowdown) {
            i.setTo(i.getLastPosition());
          }
          const n = { oldSelection: t, newSelection: i, domSelection: null };
          this.document.fire('selectionChange', n);
          this._fireSelectionChangeDoneDebounced(n);
        }
      }
      function wh(e) {
        return (
          e == zl.arrowright ||
          e == zl.arrowleft ||
          e == zl.arrowup ||
          e == zl.arrowdown
        );
      }
      class kh extends Zd {
        constructor(e) {
          super(e);
          this.mutationObserver = e.getObserver(Zu);
          this.selection = this.document.selection;
          this.domConverter = e.domConverter;
          this._documents = new WeakSet();
          this._fireSelectionChangeDoneDebounced = ph(
            (e) => this.document.fire('selectionChangeDone', e),
            200
          );
          this._clearInfiniteLoopInterval = setInterval(
            () => this._clearInfiniteLoop(),
            1e3
          );
          this._loopbackCounter = 0;
        }
        observe(e) {
          const t = e.ownerDocument;
          if (this._documents.has(t)) {
            return;
          }
          this.listenTo(t, 'selectionchange', () => {
            this._handleSelectionChange(t);
          });
          this._documents.add(t);
        }
        destroy() {
          super.destroy();
          clearInterval(this._clearInfiniteLoopInterval);
          this._fireSelectionChangeDoneDebounced.cancel();
        }
        _handleSelectionChange(e) {
          if (!this.isEnabled) {
            return;
          }
          this.mutationObserver.flush();
          const t = e.defaultView.getSelection();
          const i = this.domConverter.domSelectionToView(t);
          if (i.rangeCount == 0) {
            this.view.hasDomSelection = false;
            return;
          }
          this.view.hasDomSelection = true;
          if (
            this.selection.isEqual(i) &&
            this.domConverter.isDomSelectionCorrect(t)
          ) {
            return;
          }
          if (++this._loopbackCounter > 60) {
            return;
          }
          if (this.selection.isSimilar(i)) {
            this.view.forceRender();
          } else {
            const e = {
              oldSelection: this.selection,
              newSelection: i,
              domSelection: t,
            };
            this.document.fire('selectionChange', e);
            this._fireSelectionChangeDoneDebounced(e);
          }
        }
        _clearInfiniteLoop() {
          this._loopbackCounter = 0;
        }
      }
      class _h extends eh {
        constructor(e) {
          super(e);
          this.domEventType = ['focus', 'blur'];
          this.useCapture = true;
          const t = this.document;
          t.on('focus', () => {
            t.isFocused = true;
            this._renderTimeoutId = setTimeout(() => e.forceRender(), 50);
          });
          t.on('blur', (i, n) => {
            const o = t.selection.editableElement;
            if (o === null || o === n.target) {
              t.isFocused = false;
              e.forceRender();
            }
          });
        }
        onDomEvent(e) {
          this.fire(e.type, e);
        }
        destroy() {
          if (this._renderTimeoutId) {
            clearTimeout(this._renderTimeoutId);
          }
          super.destroy();
        }
      }
      class vh extends eh {
        constructor(e) {
          super(e);
          this.domEventType = [
            'compositionstart',
            'compositionupdate',
            'compositionend',
          ];
          const t = this.document;
          t.on('compositionstart', () => {
            t.isComposing = true;
          });
          t.on('compositionend', () => {
            t.isComposing = false;
          });
        }
        onDomEvent(e) {
          this.fire(e.type, e);
        }
      }
      class yh extends eh {
        constructor(e) {
          super(e);
          this.domEventType = ['beforeinput'];
        }
        onDomEvent(e) {
          this.fire(e.type, e);
        }
      }
      function xh(e) {
        return Object.prototype.toString.apply(e) == '[object Range]';
      }
      function Ah(e) {
        const t = e.ownerDocument.defaultView.getComputedStyle(e);
        return {
          top: parseInt(t.borderTopWidth, 10),
          right: parseInt(t.borderRightWidth, 10),
          bottom: parseInt(t.borderBottomWidth, 10),
          left: parseInt(t.borderLeftWidth, 10),
        };
      }
      const Th = ['top', 'right', 'bottom', 'left', 'width', 'height'];
      class Ch {
        constructor(e) {
          const t = xh(e);
          Object.defineProperty(this, '_source', {
            value: e._source || e,
            writable: true,
            enumerable: false,
          });
          if (Yr(e) || t) {
            if (t) {
              const t = Ch.getDomRangeRects(e);
              Ph(this, Ch.getBoundingRect(t));
            } else {
              Ph(this, e.getBoundingClientRect());
            }
          } else if (Gd(e)) {
            const { innerWidth: t, innerHeight: i } = e;
            Ph(this, {
              top: 0,
              right: t,
              bottom: i,
              left: 0,
              width: t,
              height: i,
            });
          } else {
            Ph(this, e);
          }
        }
        clone() {
          return new Ch(this);
        }
        moveTo(e, t) {
          this.top = t;
          this.right = e + this.width;
          this.bottom = t + this.height;
          this.left = e;
          return this;
        }
        moveBy(e, t) {
          this.top += t;
          this.right += e;
          this.left += e;
          this.bottom += t;
          return this;
        }
        getIntersection(e) {
          const t = {
            top: Math.max(this.top, e.top),
            right: Math.min(this.right, e.right),
            bottom: Math.min(this.bottom, e.bottom),
            left: Math.max(this.left, e.left),
          };
          t.width = t.right - t.left;
          t.height = t.bottom - t.top;
          if (t.width < 0 || t.height < 0) {
            return null;
          } else {
            return new Ch(t);
          }
        }
        getIntersectionArea(e) {
          const t = this.getIntersection(e);
          if (t) {
            return t.getArea();
          } else {
            return 0;
          }
        }
        getArea() {
          return this.width * this.height;
        }
        getVisible() {
          const e = this._source;
          let t = this.clone();
          if (!Eh(e)) {
            let i = e.parentNode || e.commonAncestorContainer;
            while (i && !Eh(i)) {
              const e = new Ch(i);
              const n = t.getIntersection(e);
              if (n) {
                if (n.getArea() < t.getArea()) {
                  t = n;
                }
              } else {
                return null;
              }
              i = i.parentNode;
            }
          }
          return t;
        }
        isEqual(e) {
          for (const t of Th) {
            if (this[t] !== e[t]) {
              return false;
            }
          }
          return true;
        }
        contains(e) {
          const t = this.getIntersection(e);
          return !!(t && t.isEqual(e));
        }
        excludeScrollbarsAndBorders() {
          const e = this._source;
          let t, i, n;
          if (Gd(e)) {
            t = e.innerWidth - e.document.documentElement.clientWidth;
            i = e.innerHeight - e.document.documentElement.clientHeight;
            n = e.getComputedStyle(e.document.documentElement).direction;
          } else {
            const o = Ah(this._source);
            t = e.offsetWidth - e.clientWidth - o.left - o.right;
            i = e.offsetHeight - e.clientHeight - o.top - o.bottom;
            n = e.ownerDocument.defaultView.getComputedStyle(e).direction;
            this.left += o.left;
            this.top += o.top;
            this.right -= o.right;
            this.bottom -= o.bottom;
            this.width = this.right - this.left;
            this.height = this.bottom - this.top;
          }
          this.width -= t;
          if (n === 'ltr') {
            this.right -= t;
          } else {
            this.left += t;
          }
          this.height -= i;
          this.bottom -= i;
          return this;
        }
        static getDomRangeRects(e) {
          const t = [];
          const i = Array.from(e.getClientRects());
          if (i.length) {
            for (const e of i) {
              t.push(new Ch(e));
            }
          } else {
            let i = e.startContainer;
            if (ld(i)) {
              i = i.parentNode;
            }
            const n = new Ch(i.getBoundingClientRect());
            n.right = n.left;
            n.width = 0;
            t.push(n);
          }
          return t;
        }
        static getBoundingRect(e) {
          const t = {
            left: Number.POSITIVE_INFINITY,
            top: Number.POSITIVE_INFINITY,
            right: Number.NEGATIVE_INFINITY,
            bottom: Number.NEGATIVE_INFINITY,
          };
          let i = 0;
          for (const n of e) {
            i++;
            t.left = Math.min(t.left, n.left);
            t.top = Math.min(t.top, n.top);
            t.right = Math.max(t.right, n.right);
            t.bottom = Math.max(t.bottom, n.bottom);
          }
          if (i == 0) {
            return null;
          }
          t.width = t.right - t.left;
          t.height = t.bottom - t.top;
          return new Ch(t);
        }
      }
      function Ph(e, t) {
        for (const i of Th) {
          e[i] = t[i];
        }
      }
      function Eh(e) {
        if (!Yr(e)) {
          return false;
        }
        return e === e.ownerDocument.body;
      }
      const Sh = {};
      function Mh({ target: e, viewportOffset: t = 0 }) {
        const i = Dh(e);
        let n = i;
        let o = null;
        while (n) {
          let r;
          if (n == i) {
            r = jh(e);
          } else {
            r = jh(o);
          }
          Oh(r, () => Bh(e, n));
          const s = Bh(e, n);
          Nh(n, s, t);
          if (n.parent != n) {
            o = n.frameElement;
            n = n.parent;
            if (!o) {
              return;
            }
          } else {
            n = null;
          }
        }
      }
      function Ih(e) {
        const t = jh(e);
        Oh(t, () => new Ch(e));
      }
      Object.assign(Sh, {
        scrollViewportToShowTarget: Mh,
        scrollAncestorsToShowTarget: Ih,
      });
      function Nh(e, t, i) {
        const n = t.clone().moveBy(0, i);
        const o = t.clone().moveBy(0, -i);
        const r = new Ch(e).excludeScrollbarsAndBorders();
        const s = [o, n];
        if (!s.every((e) => r.contains(e))) {
          let { scrollX: s, scrollY: a } = e;
          if (Rh(o, r)) {
            a -= r.top - t.top + i;
          } else if (zh(n, r)) {
            a += t.bottom - r.bottom + i;
          }
          if (Lh(t, r)) {
            s -= r.left - t.left + i;
          } else if (Vh(t, r)) {
            s += t.right - r.right + i;
          }
          e.scrollTo(s, a);
        }
      }
      function Oh(e, t) {
        const i = Dh(e);
        let n, o;
        while (e != i.document.body) {
          o = t();
          n = new Ch(e).excludeScrollbarsAndBorders();
          if (!n.contains(o)) {
            if (Rh(o, n)) {
              e.scrollTop -= n.top - o.top;
            } else if (zh(o, n)) {
              e.scrollTop += o.bottom - n.bottom;
            }
            if (Lh(o, n)) {
              e.scrollLeft -= n.left - o.left;
            } else if (Vh(o, n)) {
              e.scrollLeft += o.right - n.right;
            }
          }
          e = e.parentNode;
        }
      }
      function zh(e, t) {
        return e.bottom > t.bottom;
      }
      function Rh(e, t) {
        return e.top < t.top;
      }
      function Lh(e, t) {
        return e.left < t.left;
      }
      function Vh(e, t) {
        return e.right > t.right;
      }
      function Dh(e) {
        if (xh(e)) {
          return e.startContainer.ownerDocument.defaultView;
        } else {
          return e.ownerDocument.defaultView;
        }
      }
      function jh(e) {
        if (xh(e)) {
          let t = e.commonAncestorContainer;
          if (ld(t)) {
            t = t.parentNode;
          }
          return t;
        } else {
          return e.parentNode;
        }
      }
      function Bh(e, t) {
        const i = Dh(e);
        const n = new Ch(e);
        if (i === t) {
          return n;
        } else {
          let e = i;
          while (e != t) {
            const t = e.frameElement;
            const i = new Ch(t).excludeScrollbarsAndBorders();
            n.moveBy(i.left, i.top);
            e = e.parent;
          }
        }
        return n;
      }
      class Fh {
        constructor(e) {
          this.document = new bl(e);
          this.domConverter = new Hd(this.document);
          this.domRoots = new Map();
          this.set('isRenderingInProgress', false);
          this.set('hasDomSelection', false);
          this._renderer = new Sd(this.domConverter, this.document.selection);
          this._renderer.bind('isFocused').to(this.document);
          this._initialDomRootAttributes = new WeakMap();
          this._observers = new Map();
          this._ongoingChange = false;
          this._postFixersInProgress = false;
          this._renderingDisabled = false;
          this._hasChangedSinceTheLastRendering = false;
          this._writer = new Jl(this.document);
          this.addObserver(Zu);
          this.addObserver(kh);
          this.addObserver(_h);
          this.addObserver(th);
          this.addObserver(bh);
          this.addObserver(vh);
          if (Cl.isAndroid) {
            this.addObserver(yh);
          }
          bd(this);
          ql(this);
          this.on('render', () => {
            this._render();
            this.document.fire('layoutChanged');
            this._hasChangedSinceTheLastRendering = false;
          });
          this.listenTo(this.document.selection, 'change', () => {
            this._hasChangedSinceTheLastRendering = true;
          });
        }
        attachDomRoot(e, t = 'main') {
          const i = this.document.getRoot(t);
          i._name = e.tagName.toLowerCase();
          const n = {};
          for (const { name: t, value: o } of Array.from(e.attributes)) {
            n[t] = o;
            if (t === 'class') {
              this._writer.addClass(o.split(' '), i);
            } else {
              this._writer.setAttribute(t, o, i);
            }
          }
          this._initialDomRootAttributes.set(e, n);
          const o = () => {
            this._writer.setAttribute('contenteditable', !i.isReadOnly, i);
            if (i.isReadOnly) {
              this._writer.addClass('ck-read-only', i);
            } else {
              this._writer.removeClass('ck-read-only', i);
            }
          };
          o();
          this.domRoots.set(t, e);
          this.domConverter.bindElements(e, i);
          this._renderer.markToSync('children', i);
          this._renderer.markToSync('attributes', i);
          this._renderer.domDocuments.add(e.ownerDocument);
          i.on('change:children', (e, t) =>
            this._renderer.markToSync('children', t)
          );
          i.on('change:attributes', (e, t) =>
            this._renderer.markToSync('attributes', t)
          );
          i.on('change:text', (e, t) => this._renderer.markToSync('text', t));
          i.on('change:isReadOnly', () => this.change(o));
          i.on('change', () => {
            this._hasChangedSinceTheLastRendering = true;
          });
          for (const i of this._observers.values()) {
            i.observe(e, t);
          }
        }
        detachDomRoot(e) {
          const t = this.domRoots.get(e);
          Array.from(t.attributes).forEach(({ name: e }) =>
            t.removeAttribute(e)
          );
          const i = this._initialDomRootAttributes.get(t);
          for (const e in i) {
            t.setAttribute(e, i[e]);
          }
          this.domRoots.delete(e);
          this.domConverter.unbindDomElement(t);
        }
        getDomRoot(e = 'main') {
          return this.domRoots.get(e);
        }
        addObserver(e) {
          let t = this._observers.get(e);
          if (t) {
            return t;
          }
          t = new e(this);
          this._observers.set(e, t);
          for (const [e, i] of this.domRoots) {
            t.observe(i, e);
          }
          t.enable();
          return t;
        }
        getObserver(e) {
          return this._observers.get(e);
        }
        disableObservers() {
          for (const e of this._observers.values()) {
            e.disable();
          }
        }
        enableObservers() {
          for (const e of this._observers.values()) {
            e.enable();
          }
        }
        scrollToTheSelection() {
          const e = this.document.selection.getFirstRange();
          if (e) {
            Mh({
              target: this.domConverter.viewRangeToDom(e),
              viewportOffset: 20,
            });
          }
        }
        focus() {
          if (!this.document.isFocused) {
            const e = this.document.selection.editableElement;
            if (e) {
              this.domConverter.focus(e);
              this.forceRender();
            } else {
            }
          }
        }
        change(e) {
          if (this.isRenderingInProgress || this._postFixersInProgress) {
            throw new ss['b'](
              'cannot-change-view-tree: ' +
                'Attempting to make changes to the view when it is in an incorrect state: rendering or post-fixers are in progress. ' +
                'This may cause some unexpected behavior and inconsistency between the DOM and the view.',
              this
            );
          }
          try {
            if (this._ongoingChange) {
              return e(this._writer);
            }
            this._ongoingChange = true;
            const t = e(this._writer);
            this._ongoingChange = false;
            if (
              !this._renderingDisabled &&
              this._hasChangedSinceTheLastRendering
            ) {
              this._postFixersInProgress = true;
              this.document._callPostFixers(this._writer);
              this._postFixersInProgress = false;
              this.fire('render');
            }
            return t;
          } catch (e) {
            ss['b'].rethrowUnexpectedError(e, this);
          }
        }
        forceRender() {
          this._hasChangedSinceTheLastRendering = true;
          this.change(() => {});
        }
        destroy() {
          for (const e of this._observers.values()) {
            e.destroy();
          }
          this.document.destroy();
          this.stopListening();
        }
        createPositionAt(e, t) {
          return ul._createAt(e, t);
        }
        createPositionAfter(e) {
          return ul._createAfter(e);
        }
        createPositionBefore(e) {
          return ul._createBefore(e);
        }
        createRange(e, t) {
          return new hl(e, t);
        }
        createRangeOn(e) {
          return hl._createOn(e);
        }
        createRangeIn(e) {
          return hl._createIn(e);
        }
        createSelection(e, t, i) {
          return new ml(e, t, i);
        }
        _disableRendering(e) {
          this._renderingDisabled = e;
          if (e == false) {
            this.change(() => {});
          }
        }
        _render() {
          this.isRenderingInProgress = true;
          this.disableObservers();
          this._renderer.render();
          this.enableObservers();
          this.isRenderingInProgress = false;
        }
      }
      ys(Fh, Qc);
      class Hh {
        constructor(e) {
          this.parent = null;
          this._attrs = Us(e);
        }
        get index() {
          let e;
          if (!this.parent) {
            return null;
          }
          if ((e = this.parent.getChildIndex(this)) === null) {
            throw new ss['b'](
              "model-node-not-found-in-parent: The node's parent does not contain this node.",
              this
            );
          }
          return e;
        }
        get startOffset() {
          let e;
          if (!this.parent) {
            return null;
          }
          if ((e = this.parent.getChildStartOffset(this)) === null) {
            throw new ss['b'](
              "model-node-not-found-in-parent: The node's parent does not contain this node.",
              this
            );
          }
          return e;
        }
        get offsetSize() {
          return 1;
        }
        get endOffset() {
          if (!this.parent) {
            return null;
          }
          return this.startOffset + this.offsetSize;
        }
        get nextSibling() {
          const e = this.index;
          return (e !== null && this.parent.getChild(e + 1)) || null;
        }
        get previousSibling() {
          const e = this.index;
          return (e !== null && this.parent.getChild(e - 1)) || null;
        }
        get root() {
          let e = this;
          while (e.parent) {
            e = e.parent;
          }
          return e;
        }
        isAttached() {
          return this.root.is('rootElement');
        }
        getPath() {
          const e = [];
          let t = this;
          while (t.parent) {
            e.unshift(t.startOffset);
            t = t.parent;
          }
          return e;
        }
        getAncestors(e = { includeSelf: false, parentFirst: false }) {
          const t = [];
          let i = e.includeSelf ? this : this.parent;
          while (i) {
            t[e.parentFirst ? 'push' : 'unshift'](i);
            i = i.parent;
          }
          return t;
        }
        getCommonAncestor(e, t = {}) {
          const i = this.getAncestors(t);
          const n = e.getAncestors(t);
          let o = 0;
          while (i[o] == n[o] && i[o]) {
            o++;
          }
          return o === 0 ? null : i[o - 1];
        }
        isBefore(e) {
          if (this == e) {
            return false;
          }
          if (this.root !== e.root) {
            return false;
          }
          const t = this.getPath();
          const i = e.getPath();
          const n = Rs(t, i);
          switch (n) {
            case 'prefix':
              return true;
            case 'extension':
              return false;
            default:
              return t[n] < i[n];
          }
        }
        isAfter(e) {
          if (this == e) {
            return false;
          }
          if (this.root !== e.root) {
            return false;
          }
          return !this.isBefore(e);
        }
        hasAttribute(e) {
          return this._attrs.has(e);
        }
        getAttribute(e) {
          return this._attrs.get(e);
        }
        getAttributes() {
          return this._attrs.entries();
        }
        getAttributeKeys() {
          return this._attrs.keys();
        }
        toJSON() {
          const e = {};
          if (this._attrs.size) {
            e.attributes = Array.from(this._attrs).reduce((e, t) => {
              e[t[0]] = t[1];
              return e;
            }, {});
          }
          return e;
        }
        is(e) {
          return e === 'node' || e === 'model:node';
        }
        _clone() {
          return new Hh(this._attrs);
        }
        _remove() {
          this.parent._removeChildren(this.index);
        }
        _setAttribute(e, t) {
          this._attrs.set(e, t);
        }
        _setAttributesTo(e) {
          this._attrs = Us(e);
        }
        _removeAttribute(e) {
          return this._attrs.delete(e);
        }
        _clearAttributes() {
          this._attrs.clear();
        }
      }
      class Uh extends Hh {
        constructor(e, t) {
          super(t);
          this._data = e || '';
        }
        get offsetSize() {
          return this.data.length;
        }
        get data() {
          return this._data;
        }
        is(e) {
          return (
            e === '$text' ||
            e === 'model:$text' ||
            e === 'text' ||
            e === 'model:text' ||
            e === 'node' ||
            e === 'model:node'
          );
        }
        toJSON() {
          const e = super.toJSON();
          e.data = this.data;
          return e;
        }
        _clone() {
          return new Uh(this.data, this.getAttributes());
        }
        static fromJSON(e) {
          return new Uh(e.data, e.attributes);
        }
      }
      class qh {
        constructor(e, t, i) {
          this.textNode = e;
          if (t < 0 || t > e.offsetSize) {
            throw new ss['b'](
              'model-textproxy-wrong-offsetintext: Given offsetInText value is incorrect.',
              this
            );
          }
          if (i < 0 || t + i > e.offsetSize) {
            throw new ss['b'](
              'model-textproxy-wrong-length: Given length value is incorrect.',
              this
            );
          }
          this.data = e.data.substring(t, t + i);
          this.offsetInText = t;
        }
        get startOffset() {
          return this.textNode.startOffset !== null
            ? this.textNode.startOffset + this.offsetInText
            : null;
        }
        get offsetSize() {
          return this.data.length;
        }
        get endOffset() {
          return this.startOffset !== null
            ? this.startOffset + this.offsetSize
            : null;
        }
        get isPartial() {
          return this.offsetSize !== this.textNode.offsetSize;
        }
        get parent() {
          return this.textNode.parent;
        }
        get root() {
          return this.textNode.root;
        }
        is(e) {
          return (
            e === '$textProxy' ||
            e === 'model:$textProxy' ||
            e === 'textProxy' ||
            e === 'model:textProxy'
          );
        }
        getPath() {
          const e = this.textNode.getPath();
          if (e.length > 0) {
            e[e.length - 1] += this.offsetInText;
          }
          return e;
        }
        getAncestors(e = { includeSelf: false, parentFirst: false }) {
          const t = [];
          let i = e.includeSelf ? this : this.parent;
          while (i) {
            t[e.parentFirst ? 'push' : 'unshift'](i);
            i = i.parent;
          }
          return t;
        }
        hasAttribute(e) {
          return this.textNode.hasAttribute(e);
        }
        getAttribute(e) {
          return this.textNode.getAttribute(e);
        }
        getAttributes() {
          return this.textNode.getAttributes();
        }
        getAttributeKeys() {
          return this.textNode.getAttributeKeys();
        }
      }
      class Wh {
        constructor(e) {
          this._nodes = [];
          if (e) {
            this._insertNodes(0, e);
          }
        }
        [Symbol.iterator]() {
          return this._nodes[Symbol.iterator]();
        }
        get length() {
          return this._nodes.length;
        }
        get maxOffset() {
          return this._nodes.reduce((e, t) => e + t.offsetSize, 0);
        }
        getNode(e) {
          return this._nodes[e] || null;
        }
        getNodeIndex(e) {
          const t = this._nodes.indexOf(e);
          return t == -1 ? null : t;
        }
        getNodeStartOffset(e) {
          const t = this.getNodeIndex(e);
          return t === null
            ? null
            : this._nodes.slice(0, t).reduce((e, t) => e + t.offsetSize, 0);
        }
        indexToOffset(e) {
          if (e == this._nodes.length) {
            return this.maxOffset;
          }
          const t = this._nodes[e];
          if (!t) {
            throw new ss['b'](
              'model-nodelist-index-out-of-bounds: Given index cannot be found in the node list.',
              this
            );
          }
          return this.getNodeStartOffset(t);
        }
        offsetToIndex(e) {
          let t = 0;
          for (const i of this._nodes) {
            if (e >= t && e < t + i.offsetSize) {
              return this.getNodeIndex(i);
            }
            t += i.offsetSize;
          }
          if (t != e) {
            throw new ss['b'](
              'model-nodelist-offset-out-of-bounds: Given offset cannot be found in the node list.',
              this,
              { offset: e, nodeList: this }
            );
          }
          return this.length;
        }
        _insertNodes(e, t) {
          for (const e of t) {
            if (!(e instanceof Hh)) {
              throw new ss['b'](
                'model-nodelist-insertNodes-not-node: Trying to insert an object which is not a Node instance.',
                this
              );
            }
          }
          this._nodes.splice(e, 0, ...t);
        }
        _removeNodes(e, t = 1) {
          return this._nodes.splice(e, t);
        }
        toJSON() {
          return this._nodes.map((e) => e.toJSON());
        }
      }
      class $h extends Hh {
        constructor(e, t, i) {
          super(t);
          this.name = e;
          this._children = new Wh();
          if (i) {
            this._insertChild(0, i);
          }
        }
        get childCount() {
          return this._children.length;
        }
        get maxOffset() {
          return this._children.maxOffset;
        }
        get isEmpty() {
          return this.childCount === 0;
        }
        is(e, t = null) {
          if (!t) {
            return (
              e === 'element' ||
              e === 'model:element' ||
              e === 'node' ||
              e === 'model:node'
            );
          }
          return t === this.name && (e === 'element' || e === 'model:element');
        }
        getChild(e) {
          return this._children.getNode(e);
        }
        getChildren() {
          return this._children[Symbol.iterator]();
        }
        getChildIndex(e) {
          return this._children.getNodeIndex(e);
        }
        getChildStartOffset(e) {
          return this._children.getNodeStartOffset(e);
        }
        offsetToIndex(e) {
          return this._children.offsetToIndex(e);
        }
        getNodeByPath(e) {
          let t = this;
          for (const i of e) {
            t = t.getChild(t.offsetToIndex(i));
          }
          return t;
        }
        findAncestor(e, t = { includeSelf: false }) {
          let i = t.includeSelf ? this : this.parent;
          while (i) {
            if (i.name === e) {
              return i;
            }
            i = i.parent;
          }
          return null;
        }
        toJSON() {
          const e = super.toJSON();
          e.name = this.name;
          if (this._children.length > 0) {
            e.children = [];
            for (const t of this._children) {
              e.children.push(t.toJSON());
            }
          }
          return e;
        }
        _clone(e = false) {
          const t = e
            ? Array.from(this._children).map((e) => e._clone(true))
            : null;
          return new $h(this.name, this.getAttributes(), t);
        }
        _appendChild(e) {
          this._insertChild(this.childCount, e);
        }
        _insertChild(e, t) {
          const i = Gh(t);
          for (const e of i) {
            if (e.parent !== null) {
              e._remove();
            }
            e.parent = this;
          }
          this._children._insertNodes(e, i);
        }
        _removeChildren(e, t = 1) {
          const i = this._children._removeNodes(e, t);
          for (const e of i) {
            e.parent = null;
          }
          return i;
        }
        static fromJSON(e) {
          let t = null;
          if (e.children) {
            t = [];
            for (const i of e.children) {
              if (i.name) {
                t.push($h.fromJSON(i));
              } else {
                t.push(Uh.fromJSON(i));
              }
            }
          }
          return new $h(e.name, e.attributes, t);
        }
      }
      function Gh(e) {
        if (typeof e == 'string') {
          return [new Uh(e)];
        }
        if (!vs(e)) {
          e = [e];
        }
        return Array.from(e).map((e) => {
          if (typeof e == 'string') {
            return new Uh(e);
          }
          if (e instanceof qh) {
            return new Uh(e.data, e.getAttributes());
          }
          return e;
        });
      }
      class Yh {
        constructor(e = {}) {
          if (!e.boundaries && !e.startPosition) {
            throw new ss['b'](
              'model-tree-walker-no-start-position: Neither boundaries nor starting position have been defined.',
              null
            );
          }
          const t = e.direction || 'forward';
          if (t != 'forward' && t != 'backward') {
            throw new ss['b'](
              'model-tree-walker-unknown-direction: Only `backward` and `forward` direction allowed.',
              e,
              { direction: t }
            );
          }
          this.direction = t;
          this.boundaries = e.boundaries || null;
          if (e.startPosition) {
            this.position = e.startPosition.clone();
          } else {
            this.position = Qh._createAt(
              this.boundaries[this.direction == 'backward' ? 'end' : 'start']
            );
          }
          this.position.stickiness = 'toNone';
          this.singleCharacters = !!e.singleCharacters;
          this.shallow = !!e.shallow;
          this.ignoreElementEnd = !!e.ignoreElementEnd;
          this._boundaryStartParent = this.boundaries
            ? this.boundaries.start.parent
            : null;
          this._boundaryEndParent = this.boundaries
            ? this.boundaries.end.parent
            : null;
          this._visitedParent = this.position.parent;
        }
        [Symbol.iterator]() {
          return this;
        }
        skip(e) {
          let t, i, n, o;
          do {
            n = this.position;
            o = this._visitedParent;
            ({ done: t, value: i } = this.next());
          } while (!t && e(i));
          if (!t) {
            this.position = n;
            this._visitedParent = o;
          }
        }
        next() {
          if (this.direction == 'forward') {
            return this._next();
          } else {
            return this._previous();
          }
        }
        _next() {
          const e = this.position;
          const t = this.position.clone();
          const i = this._visitedParent;
          if (i.parent === null && t.offset === i.maxOffset) {
            return { done: true };
          }
          if (
            i === this._boundaryEndParent &&
            t.offset == this.boundaries.end.offset
          ) {
            return { done: true };
          }
          const n = t.parent;
          const o = Jh(t, n);
          const r = o ? o : Zh(t, n, o);
          if (r instanceof $h) {
            if (!this.shallow) {
              t.path.push(0);
              this._visitedParent = r;
            } else {
              t.offset++;
            }
            this.position = t;
            return Kh('elementStart', r, e, t, 1);
          } else if (r instanceof Uh) {
            let n;
            if (this.singleCharacters) {
              n = 1;
            } else {
              let e = r.endOffset;
              if (
                this._boundaryEndParent == i &&
                this.boundaries.end.offset < e
              ) {
                e = this.boundaries.end.offset;
              }
              n = e - t.offset;
            }
            const o = t.offset - r.startOffset;
            const s = new qh(r, o, n);
            t.offset += n;
            this.position = t;
            return Kh('text', s, e, t, n);
          } else {
            t.path.pop();
            t.offset++;
            this.position = t;
            this._visitedParent = i.parent;
            if (this.ignoreElementEnd) {
              return this._next();
            } else {
              return Kh('elementEnd', i, e, t);
            }
          }
        }
        _previous() {
          const e = this.position;
          const t = this.position.clone();
          const i = this._visitedParent;
          if (i.parent === null && t.offset === 0) {
            return { done: true };
          }
          if (
            i == this._boundaryStartParent &&
            t.offset == this.boundaries.start.offset
          ) {
            return { done: true };
          }
          const n = t.parent;
          const o = Jh(t, n);
          const r = o ? o : Xh(t, n, o);
          if (r instanceof $h) {
            t.offset--;
            if (!this.shallow) {
              t.path.push(r.maxOffset);
              this.position = t;
              this._visitedParent = r;
              if (this.ignoreElementEnd) {
                return this._previous();
              } else {
                return Kh('elementEnd', r, e, t);
              }
            } else {
              this.position = t;
              return Kh('elementStart', r, e, t, 1);
            }
          } else if (r instanceof Uh) {
            let n;
            if (this.singleCharacters) {
              n = 1;
            } else {
              let e = r.startOffset;
              if (
                this._boundaryStartParent == i &&
                this.boundaries.start.offset > e
              ) {
                e = this.boundaries.start.offset;
              }
              n = t.offset - e;
            }
            const o = t.offset - r.startOffset;
            const s = new qh(r, o - n, n);
            t.offset -= n;
            this.position = t;
            return Kh('text', s, e, t, n);
          } else {
            t.path.pop();
            this.position = t;
            this._visitedParent = i.parent;
            return Kh('elementStart', i, e, t, 1);
          }
        }
      }
      function Kh(e, t, i, n, o) {
        return {
          done: false,
          value: {
            type: e,
            item: t,
            previousPosition: i,
            nextPosition: n,
            length: o,
          },
        };
      }
      class Qh {
        constructor(e, t, i = 'toNone') {
          if (!e.is('element') && !e.is('documentFragment')) {
            throw new ss['b'](
              'model-position-root-invalid: Position root invalid.',
              e
            );
          }
          if (!(t instanceof Array) || t.length === 0) {
            throw new ss['b'](
              'model-position-path-incorrect-format: Position path must be an array with at least one item.',
              e,
              { path: t }
            );
          }
          if (e.is('rootElement')) {
            t = t.slice();
          } else {
            t = [...e.getPath(), ...t];
            e = e.root;
          }
          this.root = e;
          this.path = t;
          this.stickiness = i;
        }
        get offset() {
          return this.path[this.path.length - 1];
        }
        set offset(e) {
          this.path[this.path.length - 1] = e;
        }
        get parent() {
          let e = this.root;
          for (let t = 0; t < this.path.length - 1; t++) {
            e = e.getChild(e.offsetToIndex(this.path[t]));
            if (!e) {
              throw new ss['b'](
                "model-position-path-incorrect: The position's path is incorrect.",
                this,
                { position: this }
              );
            }
          }
          if (e.is('$text')) {
            throw new ss['b'](
              "model-position-path-incorrect: The position's path is incorrect.",
              this,
              { position: this }
            );
          }
          return e;
        }
        get index() {
          return this.parent.offsetToIndex(this.offset);
        }
        get textNode() {
          return Jh(this, this.parent);
        }
        get nodeAfter() {
          const e = this.parent;
          return Zh(this, e, Jh(this, e));
        }
        get nodeBefore() {
          const e = this.parent;
          return Xh(this, e, Jh(this, e));
        }
        get isAtStart() {
          return this.offset === 0;
        }
        get isAtEnd() {
          return this.offset == this.parent.maxOffset;
        }
        compareWith(e) {
          if (this.root != e.root) {
            return 'different';
          }
          const t = Rs(this.path, e.path);
          switch (t) {
            case 'same':
              return 'same';
            case 'prefix':
              return 'before';
            case 'extension':
              return 'after';
            default:
              return this.path[t] < e.path[t] ? 'before' : 'after';
          }
        }
        getLastMatchingPosition(e, t = {}) {
          t.startPosition = this;
          const i = new Yh(t);
          i.skip(e);
          return i.position;
        }
        getParentPath() {
          return this.path.slice(0, -1);
        }
        getAncestors() {
          const e = this.parent;
          if (e.is('documentFragment')) {
            return [e];
          } else {
            return e.getAncestors({ includeSelf: true });
          }
        }
        findAncestor(e) {
          const t = this.parent;
          if (t.is('element')) {
            return t.findAncestor(e, { includeSelf: true });
          }
          return null;
        }
        getCommonPath(e) {
          if (this.root != e.root) {
            return [];
          }
          const t = Rs(this.path, e.path);
          const i =
            typeof t == 'string'
              ? Math.min(this.path.length, e.path.length)
              : t;
          return this.path.slice(0, i);
        }
        getCommonAncestor(e) {
          const t = this.getAncestors();
          const i = e.getAncestors();
          let n = 0;
          while (t[n] == i[n] && t[n]) {
            n++;
          }
          return n === 0 ? null : t[n - 1];
        }
        getShiftedBy(e) {
          const t = this.clone();
          const i = t.offset + e;
          t.offset = i < 0 ? 0 : i;
          return t;
        }
        isAfter(e) {
          return this.compareWith(e) == 'after';
        }
        isBefore(e) {
          return this.compareWith(e) == 'before';
        }
        isEqual(e) {
          return this.compareWith(e) == 'same';
        }
        isTouching(e) {
          let t = null;
          let i = null;
          const n = this.compareWith(e);
          switch (n) {
            case 'same':
              return true;
            case 'before':
              t = Qh._createAt(this);
              i = Qh._createAt(e);
              break;
            case 'after':
              t = Qh._createAt(e);
              i = Qh._createAt(this);
              break;
            default:
              return false;
          }
          let o = t.parent;
          while (t.path.length + i.path.length) {
            if (t.isEqual(i)) {
              return true;
            }
            if (t.path.length > i.path.length) {
              if (t.offset !== o.maxOffset) {
                return false;
              }
              t.path = t.path.slice(0, -1);
              o = o.parent;
              t.offset++;
            } else {
              if (i.offset !== 0) {
                return false;
              }
              i.path = i.path.slice(0, -1);
            }
          }
        }
        is(e) {
          return e === 'position' || e === 'model:position';
        }
        hasSameParentAs(e) {
          if (this.root !== e.root) {
            return false;
          }
          const t = this.getParentPath();
          const i = e.getParentPath();
          return Rs(t, i) == 'same';
        }
        getTransformedByOperation(e) {
          let t;
          switch (e.type) {
            case 'insert':
              t = this._getTransformedByInsertOperation(e);
              break;
            case 'move':
            case 'remove':
            case 'reinsert':
              t = this._getTransformedByMoveOperation(e);
              break;
            case 'split':
              t = this._getTransformedBySplitOperation(e);
              break;
            case 'merge':
              t = this._getTransformedByMergeOperation(e);
              break;
            default:
              t = Qh._createAt(this);
              break;
          }
          return t;
        }
        _getTransformedByInsertOperation(e) {
          return this._getTransformedByInsertion(e.position, e.howMany);
        }
        _getTransformedByMoveOperation(e) {
          return this._getTransformedByMove(
            e.sourcePosition,
            e.targetPosition,
            e.howMany
          );
        }
        _getTransformedBySplitOperation(e) {
          const t = e.movedRange;
          const i =
            t.containsPosition(this) ||
            (t.start.isEqual(this) && this.stickiness == 'toNext');
          if (i) {
            return this._getCombined(e.splitPosition, e.moveTargetPosition);
          } else {
            if (e.graveyardPosition) {
              return this._getTransformedByMove(
                e.graveyardPosition,
                e.insertionPosition,
                1
              );
            } else {
              return this._getTransformedByInsertion(e.insertionPosition, 1);
            }
          }
        }
        _getTransformedByMergeOperation(e) {
          const t = e.movedRange;
          const i = t.containsPosition(this) || t.start.isEqual(this);
          let n;
          if (i) {
            n = this._getCombined(e.sourcePosition, e.targetPosition);
            if (e.sourcePosition.isBefore(e.targetPosition)) {
              n = n._getTransformedByDeletion(e.deletionPosition, 1);
            }
          } else if (this.isEqual(e.deletionPosition)) {
            n = Qh._createAt(e.deletionPosition);
          } else {
            n = this._getTransformedByMove(
              e.deletionPosition,
              e.graveyardPosition,
              1
            );
          }
          return n;
        }
        _getTransformedByDeletion(e, t) {
          const i = Qh._createAt(this);
          if (this.root != e.root) {
            return i;
          }
          if (Rs(e.getParentPath(), this.getParentPath()) == 'same') {
            if (e.offset < this.offset) {
              if (e.offset + t > this.offset) {
                return null;
              } else {
                i.offset -= t;
              }
            }
          } else if (Rs(e.getParentPath(), this.getParentPath()) == 'prefix') {
            const n = e.path.length - 1;
            if (e.offset <= this.path[n]) {
              if (e.offset + t > this.path[n]) {
                return null;
              } else {
                i.path[n] -= t;
              }
            }
          }
          return i;
        }
        _getTransformedByInsertion(e, t) {
          const i = Qh._createAt(this);
          if (this.root != e.root) {
            return i;
          }
          if (Rs(e.getParentPath(), this.getParentPath()) == 'same') {
            if (
              e.offset < this.offset ||
              (e.offset == this.offset && this.stickiness != 'toPrevious')
            ) {
              i.offset += t;
            }
          } else if (Rs(e.getParentPath(), this.getParentPath()) == 'prefix') {
            const n = e.path.length - 1;
            if (e.offset <= this.path[n]) {
              i.path[n] += t;
            }
          }
          return i;
        }
        _getTransformedByMove(e, t, i) {
          t = t._getTransformedByDeletion(e, i);
          if (e.isEqual(t)) {
            return Qh._createAt(this);
          }
          const n = this._getTransformedByDeletion(e, i);
          const o =
            n === null ||
            (e.isEqual(this) && this.stickiness == 'toNext') ||
            (e.getShiftedBy(i).isEqual(this) &&
              this.stickiness == 'toPrevious');
          if (o) {
            return this._getCombined(e, t);
          } else {
            return n._getTransformedByInsertion(t, i);
          }
        }
        _getCombined(e, t) {
          const i = e.path.length - 1;
          const n = Qh._createAt(t);
          n.stickiness = this.stickiness;
          n.offset = n.offset + this.path[i] - e.offset;
          n.path = [...n.path, ...this.path.slice(i + 1)];
          return n;
        }
        toJSON() {
          return {
            root: this.root.toJSON(),
            path: Array.from(this.path),
            stickiness: this.stickiness,
          };
        }
        clone() {
          return new this.constructor(this.root, this.path, this.stickiness);
        }
        static _createAt(e, t, i = 'toNone') {
          if (e instanceof Qh) {
            return new Qh(e.root, e.path, e.stickiness);
          } else {
            const n = e;
            if (t == 'end') {
              t = n.maxOffset;
            } else if (t == 'before') {
              return this._createBefore(n, i);
            } else if (t == 'after') {
              return this._createAfter(n, i);
            } else if (t !== 0 && !t) {
              throw new ss['b'](
                'model-createPositionAt-offset-required: ' +
                  'Model#createPositionAt() requires the offset when the first parameter is a model item.',
                [this, e]
              );
            }
            if (!n.is('element') && !n.is('documentFragment')) {
              throw new ss['b'](
                'model-position-parent-incorrect: Position parent have to be a element or document fragment.',
                [this, e]
              );
            }
            const o = n.getPath();
            o.push(t);
            return new this(n.root, o, i);
          }
        }
        static _createAfter(e, t) {
          if (!e.parent) {
            throw new ss['b'](
              'model-position-after-root: You cannot make a position after root.',
              [this, e],
              { root: e }
            );
          }
          return this._createAt(e.parent, e.endOffset, t);
        }
        static _createBefore(e, t) {
          if (!e.parent) {
            throw new ss['b'](
              'model-position-before-root: You cannot make a position before root.',
              e,
              { root: e }
            );
          }
          return this._createAt(e.parent, e.startOffset, t);
        }
        static fromJSON(e, t) {
          if (e.root === '$graveyard') {
            const i = new Qh(t.graveyard, e.path);
            i.stickiness = e.stickiness;
            return i;
          }
          if (!t.getRoot(e.root)) {
            throw new ss['b'](
              'model-position-fromjson-no-root: Cannot create position for document. Root with specified name does not exist.',
              t,
              { rootName: e.root }
            );
          }
          return new Qh(t.getRoot(e.root), e.path, e.stickiness);
        }
      }
      function Jh(e, t) {
        const i = t.getChild(t.offsetToIndex(e.offset));
        if (i && i.is('$text') && i.startOffset < e.offset) {
          return i;
        }
        return null;
      }
      function Zh(e, t, i) {
        if (i !== null) {
          return null;
        }
        return t.getChild(t.offsetToIndex(e.offset));
      }
      function Xh(e, t, i) {
        if (i !== null) {
          return null;
        }
        return t.getChild(t.offsetToIndex(e.offset) - 1);
      }
      class ef {
        constructor(e, t = null) {
          this.start = Qh._createAt(e);
          this.end = t ? Qh._createAt(t) : Qh._createAt(e);
          this.start.stickiness = this.isCollapsed ? 'toNone' : 'toNext';
          this.end.stickiness = this.isCollapsed ? 'toNone' : 'toPrevious';
        }
        *[Symbol.iterator]() {
          yield* new Yh({ boundaries: this, ignoreElementEnd: true });
        }
        get isCollapsed() {
          return this.start.isEqual(this.end);
        }
        get isFlat() {
          const e = this.start.getParentPath();
          const t = this.end.getParentPath();
          return Rs(e, t) == 'same';
        }
        get root() {
          return this.start.root;
        }
        containsPosition(e) {
          return e.isAfter(this.start) && e.isBefore(this.end);
        }
        containsRange(e, t = false) {
          if (e.isCollapsed) {
            t = false;
          }
          const i =
            this.containsPosition(e.start) ||
            (t && this.start.isEqual(e.start));
          const n =
            this.containsPosition(e.end) || (t && this.end.isEqual(e.end));
          return i && n;
        }
        containsItem(e) {
          const t = Qh._createBefore(e);
          return this.containsPosition(t) || this.start.isEqual(t);
        }
        is(e) {
          return e === 'range' || e === 'model:range';
        }
        isEqual(e) {
          return this.start.isEqual(e.start) && this.end.isEqual(e.end);
        }
        isIntersecting(e) {
          return this.start.isBefore(e.end) && this.end.isAfter(e.start);
        }
        getDifference(e) {
          const t = [];
          if (this.isIntersecting(e)) {
            if (this.containsPosition(e.start)) {
              t.push(new ef(this.start, e.start));
            }
            if (this.containsPosition(e.end)) {
              t.push(new ef(e.end, this.end));
            }
          } else {
            t.push(new ef(this.start, this.end));
          }
          return t;
        }
        getIntersection(e) {
          if (this.isIntersecting(e)) {
            let t = this.start;
            let i = this.end;
            if (this.containsPosition(e.start)) {
              t = e.start;
            }
            if (this.containsPosition(e.end)) {
              i = e.end;
            }
            return new ef(t, i);
          }
          return null;
        }
        getJoined(e, t = false) {
          let i = this.isIntersecting(e);
          if (!i) {
            if (this.start.isBefore(e.start)) {
              i = t ? this.end.isTouching(e.start) : this.end.isEqual(e.start);
            } else {
              i = t ? e.end.isTouching(this.start) : e.end.isEqual(this.start);
            }
          }
          if (!i) {
            return null;
          }
          let n = this.start;
          let o = this.end;
          if (e.start.isBefore(n)) {
            n = e.start;
          }
          if (e.end.isAfter(o)) {
            o = e.end;
          }
          return new ef(n, o);
        }
        getMinimalFlatRanges() {
          const e = [];
          const t = this.start.getCommonPath(this.end).length;
          const i = Qh._createAt(this.start);
          let n = i.parent;
          while (i.path.length > t + 1) {
            const t = n.maxOffset - i.offset;
            if (t !== 0) {
              e.push(new ef(i, i.getShiftedBy(t)));
            }
            i.path = i.path.slice(0, -1);
            i.offset++;
            n = n.parent;
          }
          while (i.path.length <= this.end.path.length) {
            const t = this.end.path[i.path.length - 1];
            const n = t - i.offset;
            if (n !== 0) {
              e.push(new ef(i, i.getShiftedBy(n)));
            }
            i.offset = t;
            i.path.push(0);
          }
          return e;
        }
        getWalker(e = {}) {
          e.boundaries = this;
          return new Yh(e);
        }
        *getItems(e = {}) {
          e.boundaries = this;
          e.ignoreElementEnd = true;
          const t = new Yh(e);
          for (const e of t) {
            yield e.item;
          }
        }
        *getPositions(e = {}) {
          e.boundaries = this;
          const t = new Yh(e);
          yield t.position;
          for (const e of t) {
            yield e.nextPosition;
          }
        }
        getTransformedByOperation(e) {
          switch (e.type) {
            case 'insert':
              return this._getTransformedByInsertOperation(e);
            case 'move':
            case 'remove':
            case 'reinsert':
              return this._getTransformedByMoveOperation(e);
            case 'split':
              return [this._getTransformedBySplitOperation(e)];
            case 'merge':
              return [this._getTransformedByMergeOperation(e)];
          }
          return [new ef(this.start, this.end)];
        }
        getTransformedByOperations(e) {
          const t = [new ef(this.start, this.end)];
          for (const i of e) {
            for (let e = 0; e < t.length; e++) {
              const n = t[e].getTransformedByOperation(i);
              t.splice(e, 1, ...n);
              e += n.length - 1;
            }
          }
          for (let e = 0; e < t.length; e++) {
            const i = t[e];
            for (let n = e + 1; n < t.length; n++) {
              const e = t[n];
              if (i.containsRange(e) || e.containsRange(i) || i.isEqual(e)) {
                t.splice(n, 1);
              }
            }
          }
          return t;
        }
        getCommonAncestor() {
          return this.start.getCommonAncestor(this.end);
        }
        getContainedElement() {
          if (this.isCollapsed) {
            return null;
          }
          const e = this.start.nodeAfter;
          const t = this.end.nodeBefore;
          if (e && e.is('element') && e === t) {
            return e;
          }
          return null;
        }
        toJSON() {
          return { start: this.start.toJSON(), end: this.end.toJSON() };
        }
        clone() {
          return new this.constructor(this.start, this.end);
        }
        _getTransformedByInsertOperation(e, t = false) {
          return this._getTransformedByInsertion(e.position, e.howMany, t);
        }
        _getTransformedByMoveOperation(e, t = false) {
          const i = e.sourcePosition;
          const n = e.howMany;
          const o = e.targetPosition;
          return this._getTransformedByMove(i, o, n, t);
        }
        _getTransformedBySplitOperation(e) {
          const t = this.start._getTransformedBySplitOperation(e);
          let i = this.end._getTransformedBySplitOperation(e);
          if (this.end.isEqual(e.insertionPosition)) {
            i = this.end.getShiftedBy(1);
          }
          if (t.root != i.root) {
            i = this.end.getShiftedBy(-1);
          }
          return new ef(t, i);
        }
        _getTransformedByMergeOperation(e) {
          if (
            this.start.isEqual(e.targetPosition) &&
            this.end.isEqual(e.deletionPosition)
          ) {
            return new ef(this.start);
          }
          let t = this.start._getTransformedByMergeOperation(e);
          let i = this.end._getTransformedByMergeOperation(e);
          if (t.root != i.root) {
            i = this.end.getShiftedBy(-1);
          }
          if (t.isAfter(i)) {
            if (e.sourcePosition.isBefore(e.targetPosition)) {
              t = Qh._createAt(i);
              t.offset = 0;
            } else {
              if (!e.deletionPosition.isEqual(t)) {
                i = e.deletionPosition;
              }
              t = e.targetPosition;
            }
            return new ef(t, i);
          }
          return new ef(t, i);
        }
        _getTransformedByInsertion(e, t, i = false) {
          if (i && this.containsPosition(e)) {
            return [
              new ef(this.start, e),
              new ef(
                e.getShiftedBy(t),
                this.end._getTransformedByInsertion(e, t)
              ),
            ];
          } else {
            const i = new ef(this.start, this.end);
            i.start = i.start._getTransformedByInsertion(e, t);
            i.end = i.end._getTransformedByInsertion(e, t);
            return [i];
          }
        }
        _getTransformedByMove(e, t, i, n = false) {
          if (this.isCollapsed) {
            const n = this.start._getTransformedByMove(e, t, i);
            return [new ef(n)];
          }
          const o = ef._createFromPositionAndShift(e, i);
          const r = t._getTransformedByDeletion(e, i);
          if (this.containsPosition(t) && !n) {
            if (
              o.containsPosition(this.start) ||
              o.containsPosition(this.end)
            ) {
              const n = this.start._getTransformedByMove(e, t, i);
              const o = this.end._getTransformedByMove(e, t, i);
              return [new ef(n, o)];
            }
          }
          let s;
          const a = this.getDifference(o);
          let c = null;
          const l = this.getIntersection(o);
          if (a.length == 1) {
            c = new ef(
              a[0].start._getTransformedByDeletion(e, i),
              a[0].end._getTransformedByDeletion(e, i)
            );
          } else if (a.length == 2) {
            c = new ef(this.start, this.end._getTransformedByDeletion(e, i));
          }
          if (c) {
            s = c._getTransformedByInsertion(r, i, l !== null || n);
          } else {
            s = [];
          }
          if (l) {
            const e = new ef(
              l.start._getCombined(o.start, r),
              l.end._getCombined(o.start, r)
            );
            if (s.length == 2) {
              s.splice(1, 0, e);
            } else {
              s.push(e);
            }
          }
          return s;
        }
        _getTransformedByDeletion(e, t) {
          let i = this.start._getTransformedByDeletion(e, t);
          let n = this.end._getTransformedByDeletion(e, t);
          if (i == null && n == null) {
            return null;
          }
          if (i == null) {
            i = e;
          }
          if (n == null) {
            n = e;
          }
          return new ef(i, n);
        }
        static _createFromPositionAndShift(e, t) {
          const i = e;
          const n = e.getShiftedBy(t);
          return t > 0 ? new this(i, n) : new this(n, i);
        }
        static _createIn(e) {
          return new this(Qh._createAt(e, 0), Qh._createAt(e, e.maxOffset));
        }
        static _createOn(e) {
          return this._createFromPositionAndShift(
            Qh._createBefore(e),
            e.offsetSize
          );
        }
        static _createFromRanges(e) {
          if (e.length === 0) {
            throw new ss['b'](
              'range-create-from-ranges-empty-array: At least one range has to be passed.',
              null
            );
          } else if (e.length == 1) {
            return e[0].clone();
          }
          const t = e[0];
          e.sort((e, t) => (e.start.isAfter(t.start) ? 1 : -1));
          const i = e.indexOf(t);
          const n = new this(t.start, t.end);
          if (i > 0) {
            for (let t = i - 1; true; t++) {
              if (e[t].end.isEqual(n.start)) {
                n.start = Qh._createAt(e[t].start);
              } else {
                break;
              }
            }
          }
          for (let t = i + 1; t < e.length; t++) {
            if (e[t].start.isEqual(n.end)) {
              n.end = Qh._createAt(e[t].end);
            } else {
              break;
            }
          }
          return n;
        }
        static fromJSON(e, t) {
          return new this(Qh.fromJSON(e.start, t), Qh.fromJSON(e.end, t));
        }
      }
      class tf {
        constructor() {
          this._modelToViewMapping = new WeakMap();
          this._viewToModelMapping = new WeakMap();
          this._viewToModelLengthCallbacks = new Map();
          this._markerNameToElements = new Map();
          this._elementToMarkerNames = new Map();
          this._unboundMarkerNames = new Set();
          this.on(
            'modelToViewPosition',
            (e, t) => {
              if (t.viewPosition) {
                return;
              }
              const i = this._modelToViewMapping.get(t.modelPosition.parent);
              t.viewPosition = this.findPositionIn(i, t.modelPosition.offset);
            },
            { priority: 'low' }
          );
          this.on(
            'viewToModelPosition',
            (e, t) => {
              if (t.modelPosition) {
                return;
              }
              const i = this.findMappedViewAncestor(t.viewPosition);
              const n = this._viewToModelMapping.get(i);
              const o = this._toModelOffset(
                t.viewPosition.parent,
                t.viewPosition.offset,
                i
              );
              t.modelPosition = Qh._createAt(n, o);
            },
            { priority: 'low' }
          );
        }
        bindElements(e, t) {
          this._modelToViewMapping.set(e, t);
          this._viewToModelMapping.set(t, e);
        }
        unbindViewElement(e) {
          const t = this.toModelElement(e);
          this._viewToModelMapping.delete(e);
          if (this._elementToMarkerNames.has(e)) {
            for (const t of this._elementToMarkerNames.get(e)) {
              this._unboundMarkerNames.add(t);
            }
          }
          if (this._modelToViewMapping.get(t) == e) {
            this._modelToViewMapping.delete(t);
          }
        }
        unbindModelElement(e) {
          const t = this.toViewElement(e);
          this._modelToViewMapping.delete(e);
          if (this._viewToModelMapping.get(t) == e) {
            this._viewToModelMapping.delete(t);
          }
        }
        bindElementToMarker(e, t) {
          const i = this._markerNameToElements.get(t) || new Set();
          i.add(e);
          const n = this._elementToMarkerNames.get(e) || new Set();
          n.add(t);
          this._markerNameToElements.set(t, i);
          this._elementToMarkerNames.set(e, n);
        }
        unbindElementFromMarkerName(e, t) {
          const i = this._markerNameToElements.get(t);
          if (i) {
            i.delete(e);
            if (i.size == 0) {
              this._markerNameToElements.delete(t);
            }
          }
          const n = this._elementToMarkerNames.get(e);
          if (n) {
            n.delete(t);
            if (n.size == 0) {
              this._elementToMarkerNames.delete(e);
            }
          }
        }
        flushUnboundMarkerNames() {
          const e = Array.from(this._unboundMarkerNames);
          this._unboundMarkerNames.clear();
          return e;
        }
        clearBindings() {
          this._modelToViewMapping = new WeakMap();
          this._viewToModelMapping = new WeakMap();
          this._markerNameToElements = new Map();
          this._elementToMarkerNames = new Map();
          this._unboundMarkerNames = new Set();
        }
        toModelElement(e) {
          return this._viewToModelMapping.get(e);
        }
        toViewElement(e) {
          return this._modelToViewMapping.get(e);
        }
        toModelRange(e) {
          return new ef(
            this.toModelPosition(e.start),
            this.toModelPosition(e.end)
          );
        }
        toViewRange(e) {
          return new hl(
            this.toViewPosition(e.start),
            this.toViewPosition(e.end)
          );
        }
        toModelPosition(e) {
          const t = { viewPosition: e, mapper: this };
          this.fire('viewToModelPosition', t);
          return t.modelPosition;
        }
        toViewPosition(e, t = { isPhantom: false }) {
          const i = { modelPosition: e, mapper: this, isPhantom: t.isPhantom };
          this.fire('modelToViewPosition', i);
          return i.viewPosition;
        }
        markerNameToElements(e) {
          const t = this._markerNameToElements.get(e);
          if (!t) {
            return null;
          }
          const i = new Set();
          for (const e of t) {
            if (e.is('attributeElement')) {
              for (const t of e.getElementsWithSameId()) {
                i.add(t);
              }
            } else {
              i.add(e);
            }
          }
          return i;
        }
        registerViewToModelLength(e, t) {
          this._viewToModelLengthCallbacks.set(e, t);
        }
        findMappedViewAncestor(e) {
          let t = e.parent;
          while (!this._viewToModelMapping.has(t)) {
            t = t.parent;
          }
          return t;
        }
        _toModelOffset(e, t, i) {
          if (i != e) {
            const n = this._toModelOffset(e.parent, e.index, i);
            const o = this._toModelOffset(e, t, e);
            return n + o;
          }
          if (e.is('$text')) {
            return t;
          }
          let n = 0;
          for (let i = 0; i < t; i++) {
            n += this.getModelLength(e.getChild(i));
          }
          return n;
        }
        getModelLength(e) {
          if (this._viewToModelLengthCallbacks.get(e.name)) {
            const t = this._viewToModelLengthCallbacks.get(e.name);
            return t(e);
          } else if (this._viewToModelMapping.has(e)) {
            return 1;
          } else if (e.is('$text')) {
            return e.data.length;
          } else if (e.is('uiElement')) {
            return 0;
          } else {
            let t = 0;
            for (const i of e.getChildren()) {
              t += this.getModelLength(i);
            }
            return t;
          }
        }
        findPositionIn(e, t) {
          let i;
          let n = 0;
          let o = 0;
          let r = 0;
          if (e.is('$text')) {
            return new ul(e, t);
          }
          while (o < t) {
            i = e.getChild(r);
            n = this.getModelLength(i);
            o += n;
            r++;
          }
          if (o == t) {
            return this._moveViewPositionToTextNode(new ul(e, r));
          } else {
            return this.findPositionIn(i, t - (o - n));
          }
        }
        _moveViewPositionToTextNode(e) {
          const t = e.nodeBefore;
          const i = e.nodeAfter;
          if (t instanceof Bs) {
            return new ul(t, t.data.length);
          } else if (i instanceof Bs) {
            return new ul(i, 0);
          }
          return e;
        }
      }
      ys(tf, ds);
      class nf {
        constructor() {
          this._consumable = new Map();
          this._textProxyRegistry = new Map();
        }
        add(e, t) {
          t = of(t);
          if (e instanceof qh) {
            e = this._getSymbolForTextProxy(e);
          }
          if (!this._consumable.has(e)) {
            this._consumable.set(e, new Map());
          }
          this._consumable.get(e).set(t, true);
        }
        consume(e, t) {
          t = of(t);
          if (e instanceof qh) {
            e = this._getSymbolForTextProxy(e);
          }
          if (this.test(e, t)) {
            this._consumable.get(e).set(t, false);
            return true;
          } else {
            return false;
          }
        }
        test(e, t) {
          t = of(t);
          if (e instanceof qh) {
            e = this._getSymbolForTextProxy(e);
          }
          const i = this._consumable.get(e);
          if (i === undefined) {
            return null;
          }
          const n = i.get(t);
          if (n === undefined) {
            return null;
          }
          return n;
        }
        revert(e, t) {
          t = of(t);
          if (e instanceof qh) {
            e = this._getSymbolForTextProxy(e);
          }
          const i = this.test(e, t);
          if (i === false) {
            this._consumable.get(e).set(t, true);
            return true;
          } else if (i === true) {
            return false;
          }
          return null;
        }
        _getSymbolForTextProxy(e) {
          let t = null;
          const i = this._textProxyRegistry.get(e.startOffset);
          if (i) {
            const n = i.get(e.endOffset);
            if (n) {
              t = n.get(e.parent);
            }
          }
          if (!t) {
            t = this._addSymbolForTextProxy(
              e.startOffset,
              e.endOffset,
              e.parent
            );
          }
          return t;
        }
        _addSymbolForTextProxy(e, t, i) {
          const n = Symbol('textProxySymbol');
          let o, r;
          o = this._textProxyRegistry.get(e);
          if (!o) {
            o = new Map();
            this._textProxyRegistry.set(e, o);
          }
          r = o.get(t);
          if (!r) {
            r = new Map();
            o.set(t, r);
          }
          r.set(i, n);
          return n;
        }
      }
      function of(e) {
        const t = e.split(':');
        return t.length > 1 ? t[0] + ':' + t[1] : t[0];
      }
      class rf {
        constructor(e) {
          this.conversionApi = Object.assign({ dispatcher: this }, e);
        }
        convertChanges(e, t, i) {
          for (const t of e.getMarkersToRemove()) {
            this.convertMarkerRemove(t.name, t.range, i);
          }
          for (const t of e.getChanges()) {
            if (t.type == 'insert') {
              this.convertInsert(
                ef._createFromPositionAndShift(t.position, t.length),
                i
              );
            } else if (t.type == 'remove') {
              this.convertRemove(t.position, t.length, t.name, i);
            } else {
              this.convertAttribute(
                t.range,
                t.attributeKey,
                t.attributeOldValue,
                t.attributeNewValue,
                i
              );
            }
          }
          for (const e of this.conversionApi.mapper.flushUnboundMarkerNames()) {
            const n = t.get(e).getRange();
            this.convertMarkerRemove(e, n, i);
            this.convertMarkerAdd(e, n, i);
          }
          for (const t of e.getMarkersToAdd()) {
            this.convertMarkerAdd(t.name, t.range, i);
          }
        }
        convertInsert(e, t) {
          this.conversionApi.writer = t;
          this.conversionApi.consumable = this._createInsertConsumable(e);
          for (const t of e) {
            const e = t.item;
            const i = ef._createFromPositionAndShift(
              t.previousPosition,
              t.length
            );
            const n = { item: e, range: i };
            this._testAndFire('insert', n);
            for (const t of e.getAttributeKeys()) {
              n.attributeKey = t;
              n.attributeOldValue = null;
              n.attributeNewValue = e.getAttribute(t);
              this._testAndFire(`attribute:${t}`, n);
            }
          }
          this._clearConversionApi();
        }
        convertRemove(e, t, i, n) {
          this.conversionApi.writer = n;
          this.fire(
            'remove:' + i,
            { position: e, length: t },
            this.conversionApi
          );
          this._clearConversionApi();
        }
        convertAttribute(e, t, i, n, o) {
          this.conversionApi.writer = o;
          this.conversionApi.consumable = this._createConsumableForRange(
            e,
            `attribute:${t}`
          );
          for (const o of e) {
            const e = o.item;
            const r = ef._createFromPositionAndShift(
              o.previousPosition,
              o.length
            );
            const s = {
              item: e,
              range: r,
              attributeKey: t,
              attributeOldValue: i,
              attributeNewValue: n,
            };
            this._testAndFire(`attribute:${t}`, s);
          }
          this._clearConversionApi();
        }
        convertSelection(e, t, i) {
          const n = Array.from(t.getMarkersAtPosition(e.getFirstPosition()));
          this.conversionApi.writer = i;
          this.conversionApi.consumable = this._createSelectionConsumable(e, n);
          this.fire('selection', { selection: e }, this.conversionApi);
          if (!e.isCollapsed) {
            return;
          }
          for (const t of n) {
            const i = t.getRange();
            if (!sf(e.getFirstPosition(), t, this.conversionApi.mapper)) {
              continue;
            }
            const n = { item: e, markerName: t.name, markerRange: i };
            if (this.conversionApi.consumable.test(e, 'addMarker:' + t.name)) {
              this.fire('addMarker:' + t.name, n, this.conversionApi);
            }
          }
          for (const t of e.getAttributeKeys()) {
            const i = {
              item: e,
              range: e.getFirstRange(),
              attributeKey: t,
              attributeOldValue: null,
              attributeNewValue: e.getAttribute(t),
            };
            if (
              this.conversionApi.consumable.test(
                e,
                'attribute:' + i.attributeKey
              )
            ) {
              this.fire(
                'attribute:' + i.attributeKey + ':$text',
                i,
                this.conversionApi
              );
            }
          }
          this._clearConversionApi();
        }
        convertMarkerAdd(e, t, i) {
          if (!t.root.document || t.root.rootName == '$graveyard') {
            return;
          }
          this.conversionApi.writer = i;
          const n = 'addMarker:' + e;
          const o = new nf();
          o.add(t, n);
          this.conversionApi.consumable = o;
          this.fire(n, { markerName: e, markerRange: t }, this.conversionApi);
          if (!o.test(t, n)) {
            return;
          }
          this.conversionApi.consumable = this._createConsumableForRange(t, n);
          for (const i of t.getItems()) {
            if (!this.conversionApi.consumable.test(i, n)) {
              continue;
            }
            const o = {
              item: i,
              range: ef._createOn(i),
              markerName: e,
              markerRange: t,
            };
            this.fire(n, o, this.conversionApi);
          }
          this._clearConversionApi();
        }
        convertMarkerRemove(e, t, i) {
          if (!t.root.document || t.root.rootName == '$graveyard') {
            return;
          }
          this.conversionApi.writer = i;
          this.fire(
            'removeMarker:' + e,
            { markerName: e, markerRange: t },
            this.conversionApi
          );
          this._clearConversionApi();
        }
        _createInsertConsumable(e) {
          const t = new nf();
          for (const i of e) {
            const e = i.item;
            t.add(e, 'insert');
            for (const i of e.getAttributeKeys()) {
              t.add(e, 'attribute:' + i);
            }
          }
          return t;
        }
        _createConsumableForRange(e, t) {
          const i = new nf();
          for (const n of e.getItems()) {
            i.add(n, t);
          }
          return i;
        }
        _createSelectionConsumable(e, t) {
          const i = new nf();
          i.add(e, 'selection');
          for (const n of t) {
            i.add(e, 'addMarker:' + n.name);
          }
          for (const t of e.getAttributeKeys()) {
            i.add(e, 'attribute:' + t);
          }
          return i;
        }
        _testAndFire(e, t) {
          if (!this.conversionApi.consumable.test(t.item, e)) {
            return;
          }
          const i = t.item.name || '$text';
          this.fire(e + ':' + i, t, this.conversionApi);
        }
        _clearConversionApi() {
          delete this.conversionApi.writer;
          delete this.conversionApi.consumable;
        }
      }
      ys(rf, ds);
      function sf(e, t, i) {
        const n = t.getRange();
        const o = Array.from(e.getAncestors());
        o.shift();
        o.reverse();
        const r = o.some((e) => {
          if (n.containsItem(e)) {
            const t = i.toViewElement(e);
            return !!t.getCustomProperty('addHighlight');
          }
        });
        return !r;
      }
      class af {
        constructor(e, t, i) {
          this._lastRangeBackward = false;
          this._ranges = [];
          this._attrs = new Map();
          if (e) {
            this.setTo(e, t, i);
          }
        }
        get anchor() {
          if (this._ranges.length > 0) {
            const e = this._ranges[this._ranges.length - 1];
            return this._lastRangeBackward ? e.end : e.start;
          }
          return null;
        }
        get focus() {
          if (this._ranges.length > 0) {
            const e = this._ranges[this._ranges.length - 1];
            return this._lastRangeBackward ? e.start : e.end;
          }
          return null;
        }
        get isCollapsed() {
          const e = this._ranges.length;
          if (e === 1) {
            return this._ranges[0].isCollapsed;
          } else {
            return false;
          }
        }
        get rangeCount() {
          return this._ranges.length;
        }
        get isBackward() {
          return !this.isCollapsed && this._lastRangeBackward;
        }
        isEqual(e) {
          if (this.rangeCount != e.rangeCount) {
            return false;
          } else if (this.rangeCount === 0) {
            return true;
          }
          if (!this.anchor.isEqual(e.anchor) || !this.focus.isEqual(e.focus)) {
            return false;
          }
          for (const t of this._ranges) {
            let i = false;
            for (const n of e._ranges) {
              if (t.isEqual(n)) {
                i = true;
                break;
              }
            }
            if (!i) {
              return false;
            }
          }
          return true;
        }
        *getRanges() {
          for (const e of this._ranges) {
            yield new ef(e.start, e.end);
          }
        }
        getFirstRange() {
          let e = null;
          for (const t of this._ranges) {
            if (!e || t.start.isBefore(e.start)) {
              e = t;
            }
          }
          return e ? new ef(e.start, e.end) : null;
        }
        getLastRange() {
          let e = null;
          for (const t of this._ranges) {
            if (!e || t.end.isAfter(e.end)) {
              e = t;
            }
          }
          return e ? new ef(e.start, e.end) : null;
        }
        getFirstPosition() {
          const e = this.getFirstRange();
          return e ? e.start.clone() : null;
        }
        getLastPosition() {
          const e = this.getLastRange();
          return e ? e.end.clone() : null;
        }
        setTo(e, t, i) {
          if (e === null) {
            this._setRanges([]);
          } else if (e instanceof af) {
            this._setRanges(e.getRanges(), e.isBackward);
          } else if (e && typeof e.getRanges == 'function') {
            this._setRanges(e.getRanges(), e.isBackward);
          } else if (e instanceof ef) {
            this._setRanges([e], !!t && !!t.backward);
          } else if (e instanceof Qh) {
            this._setRanges([new ef(e)]);
          } else if (e instanceof Hh) {
            const n = !!i && !!i.backward;
            let o;
            if (t == 'in') {
              o = ef._createIn(e);
            } else if (t == 'on') {
              o = ef._createOn(e);
            } else if (t !== undefined) {
              o = new ef(Qh._createAt(e, t));
            } else {
              throw new ss['b'](
                'model-selection-setTo-required-second-parameter: ' +
                  'selection.setTo requires the second parameter when the first parameter is a node.',
                [this, e]
              );
            }
            this._setRanges([o], n);
          } else if (vs(e)) {
            this._setRanges(e, t && !!t.backward);
          } else {
            throw new ss['b'](
              'model-selection-setTo-not-selectable: Cannot set the selection to the given place.',
              [this, e]
            );
          }
        }
        _setRanges(e, t = false) {
          e = Array.from(e);
          const i = e.some((t) => {
            if (!(t instanceof ef)) {
              throw new ss['b'](
                'model-selection-set-ranges-not-range: ' +
                  'Selection range set to an object that is not an instance of model.Range.',
                [this, e]
              );
            }
            return this._ranges.every((e) => !e.isEqual(t));
          });
          if (e.length === this._ranges.length && !i) {
            return;
          }
          this._removeAllRanges();
          for (const t of e) {
            this._pushRange(t);
          }
          this._lastRangeBackward = !!t;
          this.fire('change:range', { directChange: true });
        }
        setFocus(e, t) {
          if (this.anchor === null) {
            throw new ss['b'](
              'model-selection-setFocus-no-ranges: Cannot set selection focus if there are no ranges in selection.',
              [this, e]
            );
          }
          const i = Qh._createAt(e, t);
          if (i.compareWith(this.focus) == 'same') {
            return;
          }
          const n = this.anchor;
          if (this._ranges.length) {
            this._popRange();
          }
          if (i.compareWith(n) == 'before') {
            this._pushRange(new ef(i, n));
            this._lastRangeBackward = true;
          } else {
            this._pushRange(new ef(n, i));
            this._lastRangeBackward = false;
          }
          this.fire('change:range', { directChange: true });
        }
        getAttribute(e) {
          return this._attrs.get(e);
        }
        getAttributes() {
          return this._attrs.entries();
        }
        getAttributeKeys() {
          return this._attrs.keys();
        }
        hasAttribute(e) {
          return this._attrs.has(e);
        }
        removeAttribute(e) {
          if (this.hasAttribute(e)) {
            this._attrs.delete(e);
            this.fire('change:attribute', {
              attributeKeys: [e],
              directChange: true,
            });
          }
        }
        setAttribute(e, t) {
          if (this.getAttribute(e) !== t) {
            this._attrs.set(e, t);
            this.fire('change:attribute', {
              attributeKeys: [e],
              directChange: true,
            });
          }
        }
        getSelectedElement() {
          if (this.rangeCount !== 1) {
            return null;
          }
          return this.getFirstRange().getContainedElement();
        }
        is(e) {
          return e === 'selection' || e === 'model:selection';
        }
        *getSelectedBlocks() {
          const e = new WeakSet();
          for (const t of this.getRanges()) {
            const i = df(t.start, e);
            if (i && uf(i, t)) {
              yield i;
            }
            for (const i of t.getWalker()) {
              const n = i.item;
              if (i.type == 'elementEnd' && lf(n, e, t)) {
                yield n;
              }
            }
            const n = df(t.end, e);
            if (n && !t.end.isTouching(Qh._createAt(n, 0)) && uf(n, t)) {
              yield n;
            }
          }
        }
        containsEntireContent(e = this.anchor.root) {
          const t = Qh._createAt(e, 0);
          const i = Qh._createAt(e, 'end');
          return (
            t.isTouching(this.getFirstPosition()) &&
            i.isTouching(this.getLastPosition())
          );
        }
        _pushRange(e) {
          this._checkRange(e);
          this._ranges.push(new ef(e.start, e.end));
        }
        _checkRange(e) {
          for (let t = 0; t < this._ranges.length; t++) {
            if (e.isIntersecting(this._ranges[t])) {
              throw new ss['b'](
                'model-selection-range-intersects: Trying to add a range that intersects with another range in the selection.',
                [this, e],
                { addedRange: e, intersectingRange: this._ranges[t] }
              );
            }
          }
        }
        _removeAllRanges() {
          while (this._ranges.length > 0) {
            this._popRange();
          }
        }
        _popRange() {
          this._ranges.pop();
        }
      }
      ys(af, ds);
      function cf(e, t) {
        if (t.has(e)) {
          return false;
        }
        t.add(e);
        return e.root.document.model.schema.isBlock(e) && e.parent;
      }
      function lf(e, t, i) {
        return cf(e, t) && uf(e, i);
      }
      function df(e, t) {
        const i = e.parent;
        const n = i.root.document.model.schema;
        const o = e.parent.getAncestors({
          parentFirst: true,
          includeSelf: true,
        });
        let r = false;
        const s = o.find((e) => {
          if (r) {
            return false;
          }
          r = n.isLimit(e);
          return !r && cf(e, t);
        });
        o.forEach((e) => t.add(e));
        return s;
      }
      function uf(e, t) {
        const i = hf(e);
        if (!i) {
          return true;
        }
        const n = t.containsRange(ef._createOn(i), true);
        return !n;
      }
      function hf(e) {
        const t = e.root.document.model.schema;
        let i = e.parent;
        while (i) {
          if (t.isBlock(i)) {
            return i;
          }
          i = i.parent;
        }
      }
      class ff extends ef {
        constructor(e, t) {
          super(e, t);
          gf.call(this);
        }
        detach() {
          this.stopListening();
        }
        is(e) {
          return (
            e === 'liveRange' ||
            e === 'model:liveRange' ||
            e == 'range' ||
            e === 'model:range'
          );
        }
        toRange() {
          return new ef(this.start, this.end);
        }
        static fromRange(e) {
          return new ff(e.start, e.end);
        }
      }
      function gf() {
        this.listenTo(
          this.root.document.model,
          'applyOperation',
          (e, t) => {
            const i = t[0];
            if (!i.isDocumentOperation) {
              return;
            }
            mf.call(this, i);
          },
          { priority: 'low' }
        );
      }
      function mf(e) {
        const t = this.getTransformedByOperation(e);
        const i = ef._createFromRanges(t);
        const n = !i.isEqual(this);
        const o = pf(this, e);
        let r = null;
        if (n) {
          if (i.root.rootName == '$graveyard') {
            if (e.type == 'remove') {
              r = e.sourcePosition;
            } else {
              r = e.deletionPosition;
            }
          }
          const t = this.toRange();
          this.start = i.start;
          this.end = i.end;
          this.fire('change:range', t, { deletionPosition: r });
        } else if (o) {
          this.fire('change:content', this.toRange(), { deletionPosition: r });
        }
      }
      function pf(e, t) {
        switch (t.type) {
          case 'insert':
            return e.containsPosition(t.position);
          case 'move':
          case 'remove':
          case 'reinsert':
          case 'merge':
            return (
              e.containsPosition(t.sourcePosition) ||
              e.start.isEqual(t.sourcePosition) ||
              e.containsPosition(t.targetPosition)
            );
          case 'split':
            return (
              e.containsPosition(t.splitPosition) ||
              e.containsPosition(t.insertionPosition)
            );
        }
        return false;
      }
      ys(ff, ds);
      const bf = 'selection:';
      class wf {
        constructor(e) {
          this._selection = new kf(e);
          this._selection.delegate('change:range').to(this);
          this._selection.delegate('change:attribute').to(this);
          this._selection.delegate('change:marker').to(this);
        }
        get isCollapsed() {
          return this._selection.isCollapsed;
        }
        get anchor() {
          return this._selection.anchor;
        }
        get focus() {
          return this._selection.focus;
        }
        get rangeCount() {
          return this._selection.rangeCount;
        }
        get hasOwnRange() {
          return this._selection.hasOwnRange;
        }
        get isBackward() {
          return this._selection.isBackward;
        }
        get isGravityOverridden() {
          return this._selection.isGravityOverridden;
        }
        get markers() {
          return this._selection.markers;
        }
        get _ranges() {
          return this._selection._ranges;
        }
        getRanges() {
          return this._selection.getRanges();
        }
        getFirstPosition() {
          return this._selection.getFirstPosition();
        }
        getLastPosition() {
          return this._selection.getLastPosition();
        }
        getFirstRange() {
          return this._selection.getFirstRange();
        }
        getLastRange() {
          return this._selection.getLastRange();
        }
        getSelectedBlocks() {
          return this._selection.getSelectedBlocks();
        }
        getSelectedElement() {
          return this._selection.getSelectedElement();
        }
        containsEntireContent(e) {
          return this._selection.containsEntireContent(e);
        }
        destroy() {
          this._selection.destroy();
        }
        getAttributeKeys() {
          return this._selection.getAttributeKeys();
        }
        getAttributes() {
          return this._selection.getAttributes();
        }
        getAttribute(e) {
          return this._selection.getAttribute(e);
        }
        hasAttribute(e) {
          return this._selection.hasAttribute(e);
        }
        refresh() {
          this._selection._updateMarkers();
          this._selection._updateAttributes(false);
        }
        is(e) {
          return (
            e === 'selection' ||
            e == 'model:selection' ||
            e == 'documentSelection' ||
            e == 'model:documentSelection'
          );
        }
        _setFocus(e, t) {
          this._selection.setFocus(e, t);
        }
        _setTo(e, t, i) {
          this._selection.setTo(e, t, i);
        }
        _setAttribute(e, t) {
          this._selection.setAttribute(e, t);
        }
        _removeAttribute(e) {
          this._selection.removeAttribute(e);
        }
        _getStoredAttributes() {
          return this._selection._getStoredAttributes();
        }
        _overrideGravity() {
          return this._selection.overrideGravity();
        }
        _restoreGravity(e) {
          this._selection.restoreGravity(e);
        }
        static _getStoreAttributeKey(e) {
          return bf + e;
        }
        static _isStoreAttributeKey(e) {
          return e.startsWith(bf);
        }
      }
      ys(wf, ds);
      class kf extends af {
        constructor(e) {
          super();
          this.markers = new xs({ idProperty: 'name' });
          this._model = e.model;
          this._document = e;
          this._attributePriority = new Map();
          this._selectionRestorePosition = null;
          this._hasChangedRange = false;
          this._overriddenGravityRegister = new Set();
          this.listenTo(
            this._model,
            'applyOperation',
            (e, t) => {
              const i = t[0];
              if (
                !i.isDocumentOperation ||
                i.type == 'marker' ||
                i.type == 'rename' ||
                i.type == 'noop'
              ) {
                return;
              }
              if (this._ranges.length == 0 && this._selectionRestorePosition) {
                this._fixGraveyardSelection(this._selectionRestorePosition);
              }
              this._selectionRestorePosition = null;
              if (this._hasChangedRange) {
                this._hasChangedRange = false;
                this.fire('change:range', { directChange: false });
              }
            },
            { priority: 'lowest' }
          );
          this.on('change:range', () => {
            for (const e of this.getRanges()) {
              if (!this._document._validateSelectionRange(e)) {
                throw new ss['b'](
                  'document-selection-wrong-position: Range from document selection starts or ends at incorrect position.',
                  this,
                  { range: e }
                );
              }
            }
          });
          this.listenTo(this._model.markers, 'update', () =>
            this._updateMarkers()
          );
          this.listenTo(this._document, 'change', (e, t) => {
            vf(this._model, t);
          });
        }
        get isCollapsed() {
          const e = this._ranges.length;
          return e === 0
            ? this._document._getDefaultRange().isCollapsed
            : super.isCollapsed;
        }
        get anchor() {
          return super.anchor || this._document._getDefaultRange().start;
        }
        get focus() {
          return super.focus || this._document._getDefaultRange().end;
        }
        get rangeCount() {
          return this._ranges.length ? this._ranges.length : 1;
        }
        get hasOwnRange() {
          return this._ranges.length > 0;
        }
        get isGravityOverridden() {
          return !!this._overriddenGravityRegister.size;
        }
        destroy() {
          for (let e = 0; e < this._ranges.length; e++) {
            this._ranges[e].detach();
          }
          this.stopListening();
        }
        *getRanges() {
          if (this._ranges.length) {
            yield* super.getRanges();
          } else {
            yield this._document._getDefaultRange();
          }
        }
        getFirstRange() {
          return super.getFirstRange() || this._document._getDefaultRange();
        }
        getLastRange() {
          return super.getLastRange() || this._document._getDefaultRange();
        }
        setTo(e, t, i) {
          super.setTo(e, t, i);
          this._updateAttributes(true);
          this._updateMarkers();
        }
        setFocus(e, t) {
          super.setFocus(e, t);
          this._updateAttributes(true);
          this._updateMarkers();
        }
        setAttribute(e, t) {
          if (this._setAttribute(e, t)) {
            const t = [e];
            this.fire('change:attribute', {
              attributeKeys: t,
              directChange: true,
            });
          }
        }
        removeAttribute(e) {
          if (this._removeAttribute(e)) {
            const t = [e];
            this.fire('change:attribute', {
              attributeKeys: t,
              directChange: true,
            });
          }
        }
        overrideGravity() {
          const e = is();
          this._overriddenGravityRegister.add(e);
          if (this._overriddenGravityRegister.size === 1) {
            this._updateAttributes(true);
          }
          return e;
        }
        restoreGravity(e) {
          if (!this._overriddenGravityRegister.has(e)) {
            throw new ss['b'](
              'document-selection-gravity-wrong-restore: Attempting to restore the selection gravity for an unknown UID.',
              this,
              { uid: e }
            );
          }
          this._overriddenGravityRegister.delete(e);
          if (!this.isGravityOverridden) {
            this._updateAttributes(true);
          }
        }
        _popRange() {
          this._ranges.pop().detach();
        }
        _pushRange(e) {
          const t = this._prepareRange(e);
          if (t) {
            this._ranges.push(t);
          }
        }
        _prepareRange(e) {
          this._checkRange(e);
          if (e.root == this._document.graveyard) {
            return;
          }
          const t = ff.fromRange(e);
          t.on('change:range', (e, i, n) => {
            this._hasChangedRange = true;
            if (t.root == this._document.graveyard) {
              this._selectionRestorePosition = n.deletionPosition;
              const e = this._ranges.indexOf(t);
              this._ranges.splice(e, 1);
              t.detach();
            }
          });
          return t;
        }
        _updateMarkers() {
          const e = [];
          let t = false;
          for (const t of this._model.markers) {
            const i = t.getRange();
            for (const n of this.getRanges()) {
              if (i.containsRange(n, !n.isCollapsed)) {
                e.push(t);
              }
            }
          }
          const i = Array.from(this.markers);
          for (const i of e) {
            if (!this.markers.has(i)) {
              this.markers.add(i);
              t = true;
            }
          }
          for (const i of Array.from(this.markers)) {
            if (!e.includes(i)) {
              this.markers.remove(i);
              t = true;
            }
          }
          if (t) {
            this.fire('change:marker', { oldMarkers: i, directChange: false });
          }
        }
        _updateAttributes(e) {
          const t = Us(this._getSurroundingAttributes());
          const i = Us(this.getAttributes());
          if (e) {
            this._attributePriority = new Map();
            this._attrs = new Map();
          } else {
            for (const [e, t] of this._attributePriority) {
              if (t == 'low') {
                this._attrs.delete(e);
                this._attributePriority.delete(e);
              }
            }
          }
          this._setAttributesTo(t);
          const n = [];
          for (const [e, t] of this.getAttributes()) {
            if (!i.has(e) || i.get(e) !== t) {
              n.push(e);
            }
          }
          for (const [e] of i) {
            if (!this.hasAttribute(e)) {
              n.push(e);
            }
          }
          if (n.length > 0) {
            this.fire('change:attribute', {
              attributeKeys: n,
              directChange: false,
            });
          }
        }
        _setAttribute(e, t, i = true) {
          const n = i ? 'normal' : 'low';
          if (n == 'low' && this._attributePriority.get(e) == 'normal') {
            return false;
          }
          const o = super.getAttribute(e);
          if (o === t) {
            return false;
          }
          this._attrs.set(e, t);
          this._attributePriority.set(e, n);
          return true;
        }
        _removeAttribute(e, t = true) {
          const i = t ? 'normal' : 'low';
          if (i == 'low' && this._attributePriority.get(e) == 'normal') {
            return false;
          }
          this._attributePriority.set(e, i);
          if (!super.hasAttribute(e)) {
            return false;
          }
          this._attrs.delete(e);
          return true;
        }
        _setAttributesTo(e) {
          const t = new Set();
          for (const [t, i] of this.getAttributes()) {
            if (e.get(t) === i) {
              continue;
            }
            this._removeAttribute(t, false);
          }
          for (const [i, n] of e) {
            const e = this._setAttribute(i, n, false);
            if (e) {
              t.add(i);
            }
          }
          return t;
        }
        *_getStoredAttributes() {
          const e = this.getFirstPosition().parent;
          if (this.isCollapsed && e.isEmpty) {
            for (const t of e.getAttributeKeys()) {
              if (t.startsWith(bf)) {
                const i = t.substr(bf.length);
                yield [i, e.getAttribute(t)];
              }
            }
          }
        }
        _getSurroundingAttributes() {
          const e = this.getFirstPosition();
          const t = this._model.schema;
          let i = null;
          if (!this.isCollapsed) {
            const e = this.getFirstRange();
            for (const n of e) {
              if (n.item.is('element') && t.isObject(n.item)) {
                break;
              }
              if (n.type == 'text') {
                i = n.item.getAttributes();
                break;
              }
            }
          } else {
            const n = e.textNode ? e.textNode : e.nodeBefore;
            const o = e.textNode ? e.textNode : e.nodeAfter;
            if (!this.isGravityOverridden) {
              i = _f(n);
            }
            if (!i) {
              i = _f(o);
            }
            if (!this.isGravityOverridden && !i) {
              let e = n;
              while (e && !t.isInline(e) && !i) {
                e = e.previousSibling;
                i = _f(e);
              }
            }
            if (!i) {
              let e = o;
              while (e && !t.isInline(e) && !i) {
                e = e.nextSibling;
                i = _f(e);
              }
            }
            if (!i) {
              i = this._getStoredAttributes();
            }
          }
          return i;
        }
        _fixGraveyardSelection(e) {
          const t = this._model.schema.getNearestSelectionRange(e);
          if (t) {
            this._pushRange(t);
          }
        }
      }
      function _f(e) {
        if (e instanceof qh || e instanceof Uh) {
          return e.getAttributes();
        }
        return null;
      }
      function vf(e, t) {
        const i = e.document.differ;
        for (const n of i.getChanges()) {
          if (n.type != 'insert') {
            continue;
          }
          const i = n.position.parent;
          const o = n.length === i.maxOffset;
          if (o) {
            e.enqueueChange(t, (e) => {
              const t = Array.from(i.getAttributeKeys()).filter((e) =>
                e.startsWith(bf)
              );
              for (const n of t) {
                e.removeAttribute(n, i);
              }
            });
          }
        }
      }
      class yf {
        constructor(e) {
          this._dispatchers = e;
        }
        add(e) {
          for (const t of this._dispatchers) {
            e(t);
          }
          return this;
        }
      }
      var xf = 1,
        Af = 4;
      function Tf(e) {
        return Hr(e, xf | Af);
      }
      var Cf = Tf;
      class Pf extends yf {
        elementToElement(e) {
          return this.add(Gf(e));
        }
        attributeToElement(e) {
          return this.add(Yf(e));
        }
        attributeToAttribute(e) {
          return this.add(Kf(e));
        }
        markerToElement(e) {
          return this.add(Qf(e));
        }
        markerToHighlight(e) {
          return this.add(Zf(e));
        }
        markerToData(e) {
          return this.add(Jf(e));
        }
      }
      function Ef() {
        return (e, t, i) => {
          if (!i.consumable.consume(t.item, 'insert')) {
            return;
          }
          const n = i.writer;
          const o = i.mapper.toViewPosition(t.range.start);
          const r = n.createText(t.item.data);
          n.insert(o, r);
        };
      }
      function Sf() {
        return (e, t, i) => {
          const n = i.mapper.toViewPosition(t.position);
          const o = t.position.getShiftedBy(t.length);
          const r = i.mapper.toViewPosition(o, { isPhantom: true });
          const s = i.writer.createRange(n, r);
          const a = i.writer.remove(s.getTrimmed());
          for (const e of i.writer.createRangeIn(a).getItems()) {
            i.mapper.unbindViewElement(e);
          }
        };
      }
      function Mf(e, t) {
        const i = e.createAttributeElement('span', t.attributes);
        if (t.classes) {
          i._addClass(t.classes);
        }
        if (t.priority) {
          i._priority = t.priority;
        }
        i._id = t.id;
        return i;
      }
      function If() {
        return (e, t, i) => {
          const n = t.selection;
          if (n.isCollapsed) {
            return;
          }
          if (!i.consumable.consume(n, 'selection')) {
            return;
          }
          const o = [];
          for (const e of n.getRanges()) {
            const t = i.mapper.toViewRange(e);
            o.push(t);
          }
          i.writer.setSelection(o, { backward: n.isBackward });
        };
      }
      function Nf() {
        return (e, t, i) => {
          const n = t.selection;
          if (!n.isCollapsed) {
            return;
          }
          if (!i.consumable.consume(n, 'selection')) {
            return;
          }
          const o = i.writer;
          const r = n.getFirstPosition();
          const s = i.mapper.toViewPosition(r);
          const a = o.breakAttributes(s);
          o.setSelection(a);
        };
      }
      function Of() {
        return (e, t, i) => {
          const n = i.writer;
          const o = n.document.selection;
          for (const e of o.getRanges()) {
            if (e.isCollapsed) {
              if (e.end.parent.isAttached()) {
                i.writer.mergeAttributes(e.start);
              }
            }
          }
          n.setSelection(null);
        };
      }
      function zf(e) {
        return (t, i, n) => {
          const o = e(i.attributeOldValue, n);
          const r = e(i.attributeNewValue, n);
          if (!o && !r) {
            return;
          }
          if (!n.consumable.consume(i.item, t.name)) {
            return;
          }
          const s = n.writer;
          const a = s.document.selection;
          if (i.item instanceof af || i.item instanceof wf) {
            s.wrap(a.getFirstRange(), r);
          } else {
            let e = n.mapper.toViewRange(i.range);
            if (i.attributeOldValue !== null && o) {
              e = s.unwrap(e, o);
            }
            if (i.attributeNewValue !== null && r) {
              s.wrap(e, r);
            }
          }
        };
      }
      function Rf(e) {
        return (t, i, n) => {
          const o = e(i.item, n);
          if (!o) {
            return;
          }
          if (!n.consumable.consume(i.item, 'insert')) {
            return;
          }
          const r = n.mapper.toViewPosition(i.range.start);
          n.mapper.bindElements(i.item, o);
          n.writer.insert(r, o);
        };
      }
      function Lf(e) {
        return (t, i, n) => {
          i.isOpening = true;
          const o = e(i, n);
          i.isOpening = false;
          const r = e(i, n);
          if (!o || !r) {
            return;
          }
          const s = i.markerRange;
          if (s.isCollapsed && !n.consumable.consume(s, t.name)) {
            return;
          }
          for (const e of s) {
            if (!n.consumable.consume(e.item, t.name)) {
              return;
            }
          }
          const a = n.mapper;
          const c = n.writer;
          c.insert(a.toViewPosition(s.start), o);
          n.mapper.bindElementToMarker(o, i.markerName);
          if (!s.isCollapsed) {
            c.insert(a.toViewPosition(s.end), r);
            n.mapper.bindElementToMarker(r, i.markerName);
          }
          t.stop();
        };
      }
      function Vf() {
        return (e, t, i) => {
          const n = i.mapper.markerNameToElements(t.markerName);
          if (!n) {
            return;
          }
          for (const e of n) {
            i.mapper.unbindElementFromMarkerName(e, t.markerName);
            i.writer.clear(i.writer.createRangeOn(e), e);
          }
          i.writer.clearClonedElementsGroup(t.markerName);
          e.stop();
        };
      }
      function Df(e) {
        return (t, i, n) => {
          const o = e(i.markerName, n);
          if (!o) {
            return;
          }
          const r = i.markerRange;
          if (!n.consumable.consume(r, t.name)) {
            return;
          }
          jf(r, false, n, i, o);
          jf(r, true, n, i, o);
          t.stop();
        };
      }
      function jf(e, t, i, n, o) {
        const r = t ? e.start : e.end;
        const s = i.schema.checkChild(r, '$text');
        if (s) {
          const e = i.mapper.toViewPosition(r);
          Ff(e, t, i, n, o);
        } else {
          let e;
          let s;
          if ((t && r.nodeAfter) || (!t && !r.nodeBefore)) {
            e = r.nodeAfter;
            s = true;
          } else {
            e = r.nodeBefore;
            s = false;
          }
          const a = i.mapper.toViewElement(e);
          Bf(a, t, s, i, n, o);
        }
      }
      function Bf(e, t, i, n, o, r) {
        const s = `data-${r.group}-${t ? 'start' : 'end'}-${
          i ? 'before' : 'after'
        }`;
        const a = e.hasAttribute(s) ? e.getAttribute(s).split(',') : [];
        a.unshift(r.name);
        n.writer.setAttribute(s, a.join(','), e);
        n.mapper.bindElementToMarker(e, o.markerName);
      }
      function Ff(e, t, i, n, o) {
        const r = `${o.group}-${t ? 'start' : 'end'}`;
        const s = o.name ? { name: o.name } : null;
        const a = i.writer.createUIElement(r, s);
        i.writer.insert(e, a);
        i.mapper.bindElementToMarker(a, n.markerName);
      }
      function Hf(e) {
        return (t, i, n) => {
          const o = e(i.markerName, n);
          if (!o) {
            return;
          }
          const r = n.mapper.markerNameToElements(i.markerName);
          if (!r) {
            return;
          }
          for (const e of r) {
            n.mapper.unbindElementFromMarkerName(e, i.markerName);
            if (e.is('containerElement')) {
              s(`data-${o.group}-start-before`, e);
              s(`data-${o.group}-start-after`, e);
              s(`data-${o.group}-end-before`, e);
              s(`data-${o.group}-end-after`, e);
            } else {
              n.writer.clear(n.writer.createRangeOn(e), e);
            }
          }
          n.writer.clearClonedElementsGroup(i.markerName);
          t.stop();
          function s(e, t) {
            if (t.hasAttribute(e)) {
              const i = new Set(t.getAttribute(e).split(','));
              i.delete(o.name);
              if (i.size == 0) {
                n.writer.removeAttribute(e, t);
              } else {
                n.writer.setAttribute(e, Array.from(i).join(','), t);
              }
            }
          }
        };
      }
      function Uf(e) {
        return (t, i, n) => {
          const o = e(i.attributeOldValue, n);
          const r = e(i.attributeNewValue, n);
          if (!o && !r) {
            return;
          }
          if (!n.consumable.consume(i.item, t.name)) {
            return;
          }
          const s = n.mapper.toViewElement(i.item);
          const a = n.writer;
          if (!s) {
            throw new ss['b'](
              'conversion-attribute-to-attribute-on-text: ' +
                "Trying to convert text node's attribute with attribute-to-attribute converter.",
              [i, n]
            );
          }
          if (i.attributeOldValue !== null && o) {
            if (o.key == 'class') {
              const e = Array.isArray(o.value) ? o.value : [o.value];
              for (const t of e) {
                a.removeClass(t, s);
              }
            } else if (o.key == 'style') {
              const e = Object.keys(o.value);
              for (const t of e) {
                a.removeStyle(t, s);
              }
            } else {
              a.removeAttribute(o.key, s);
            }
          }
          if (i.attributeNewValue !== null && r) {
            if (r.key == 'class') {
              const e = Array.isArray(r.value) ? r.value : [r.value];
              for (const t of e) {
                a.addClass(t, s);
              }
            } else if (r.key == 'style') {
              const e = Object.keys(r.value);
              for (const t of e) {
                a.setStyle(t, r.value[t], s);
              }
            } else {
              a.setAttribute(r.key, r.value, s);
            }
          }
        };
      }
      function qf(e) {
        return (t, i, n) => {
          if (!i.item) {
            return;
          }
          if (
            !(i.item instanceof af || i.item instanceof wf) &&
            !i.item.is('$textProxy')
          ) {
            return;
          }
          const o = ng(e, i, n);
          if (!o) {
            return;
          }
          if (!n.consumable.consume(i.item, t.name)) {
            return;
          }
          const r = n.writer;
          const s = Mf(r, o);
          const a = r.document.selection;
          if (i.item instanceof af || i.item instanceof wf) {
            r.wrap(a.getFirstRange(), s, a);
          } else {
            const e = n.mapper.toViewRange(i.range);
            const t = r.wrap(e, s);
            for (const e of t.getItems()) {
              if (e.is('attributeElement') && e.isSimilar(s)) {
                n.mapper.bindElementToMarker(e, i.markerName);
                break;
              }
            }
          }
        };
      }
      function Wf(e) {
        return (t, i, n) => {
          if (!i.item) {
            return;
          }
          if (!(i.item instanceof $h)) {
            return;
          }
          const o = ng(e, i, n);
          if (!o) {
            return;
          }
          if (!n.consumable.test(i.item, t.name)) {
            return;
          }
          const r = n.mapper.toViewElement(i.item);
          if (r && r.getCustomProperty('addHighlight')) {
            n.consumable.consume(i.item, t.name);
            for (const e of ef._createIn(i.item)) {
              n.consumable.consume(e.item, t.name);
            }
            r.getCustomProperty('addHighlight')(r, o, n.writer);
            n.mapper.bindElementToMarker(r, i.markerName);
          }
        };
      }
      function $f(e) {
        return (t, i, n) => {
          if (i.markerRange.isCollapsed) {
            return;
          }
          const o = ng(e, i, n);
          if (!o) {
            return;
          }
          const r = Mf(n.writer, o);
          const s = n.mapper.markerNameToElements(i.markerName);
          if (!s) {
            return;
          }
          for (const e of s) {
            n.mapper.unbindElementFromMarkerName(e, i.markerName);
            if (e.is('attributeElement')) {
              n.writer.unwrap(n.writer.createRangeOn(e), r);
            } else {
              e.getCustomProperty('removeHighlight')(e, o.id, n.writer);
            }
          }
          n.writer.clearClonedElementsGroup(i.markerName);
          t.stop();
        };
      }
      function Gf(e) {
        e = Cf(e);
        e.view = Xf(e.view, 'container');
        return (t) => {
          t.on('insert:' + e.model, Rf(e.view), {
            priority: e.converterPriority || 'normal',
          });
        };
      }
      function Yf(e) {
        e = Cf(e);
        const t = e.model.key ? e.model.key : e.model;
        let i = 'attribute:' + t;
        if (e.model.name) {
          i += ':' + e.model.name;
        }
        if (e.model.values) {
          for (const t of e.model.values) {
            e.view[t] = Xf(e.view[t], 'attribute');
          }
        } else {
          e.view = Xf(e.view, 'attribute');
        }
        const n = tg(e);
        return (t) => {
          t.on(i, zf(n), { priority: e.converterPriority || 'normal' });
        };
      }
      function Kf(e) {
        e = Cf(e);
        const t = e.model.key ? e.model.key : e.model;
        let i = 'attribute:' + t;
        if (e.model.name) {
          i += ':' + e.model.name;
        }
        if (e.model.values) {
          for (const t of e.model.values) {
            e.view[t] = ig(e.view[t]);
          }
        } else {
          e.view = ig(e.view);
        }
        const n = tg(e);
        return (t) => {
          t.on(i, Uf(n), { priority: e.converterPriority || 'normal' });
        };
      }
      function Qf(e) {
        e = Cf(e);
        e.view = Xf(e.view, 'ui');
        return (t) => {
          t.on('addMarker:' + e.model, Lf(e.view), {
            priority: e.converterPriority || 'normal',
          });
          t.on('removeMarker:' + e.model, Vf(e.view), {
            priority: e.converterPriority || 'normal',
          });
        };
      }
      function Jf(e) {
        e = Cf(e);
        const t = e.model;
        if (!e.view) {
          e.view = (i) => ({ group: t, name: i.substr(e.model.length + 1) });
        }
        return (i) => {
          i.on('addMarker:' + t, Df(e.view), {
            priority: e.converterPriority || 'normal',
          });
          i.on('removeMarker:' + t, Hf(e.view), {
            priority: e.converterPriority || 'normal',
          });
        };
      }
      function Zf(e) {
        return (t) => {
          t.on('addMarker:' + e.model, qf(e.view), {
            priority: e.converterPriority || 'normal',
          });
          t.on('addMarker:' + e.model, Wf(e.view), {
            priority: e.converterPriority || 'normal',
          });
          t.on('removeMarker:' + e.model, $f(e.view), {
            priority: e.converterPriority || 'normal',
          });
        };
      }
      function Xf(e, t) {
        if (typeof e == 'function') {
          return e;
        }
        return (i, n) => eg(e, n, t);
      }
      function eg(e, t, i) {
        if (typeof e == 'string') {
          e = { name: e };
        }
        let n;
        const o = t.writer;
        const r = Object.assign({}, e.attributes);
        if (i == 'container') {
          n = o.createContainerElement(e.name, r);
        } else if (i == 'attribute') {
          const t = { priority: e.priority || kl.DEFAULT_PRIORITY };
          n = o.createAttributeElement(e.name, r, t);
        } else {
          n = o.createUIElement(e.name, r);
        }
        if (e.styles) {
          const t = Object.keys(e.styles);
          for (const i of t) {
            o.setStyle(i, e.styles[i], n);
          }
        }
        if (e.classes) {
          const t = e.classes;
          if (typeof t == 'string') {
            o.addClass(t, n);
          } else {
            for (const e of t) {
              o.addClass(e, n);
            }
          }
        }
        return n;
      }
      function tg(e) {
        if (e.model.values) {
          return (t, i) => {
            const n = e.view[t];
            if (n) {
              return n(t, i);
            }
            return null;
          };
        } else {
          return e.view;
        }
      }
      function ig(e) {
        if (typeof e == 'string') {
          return (t) => ({ key: e, value: t });
        } else if (typeof e == 'object') {
          if (e.value) {
            return () => e;
          } else {
            return (t) => ({ key: e.key, value: t });
          }
        } else {
          return e;
        }
      }
      function ng(e, t, i) {
        const n = typeof e == 'function' ? e(t, i) : e;
        if (!n) {
          return null;
        }
        if (!n.priority) {
          n.priority = 10;
        }
        if (!n.id) {
          n.id = t.markerName;
        }
        return n;
      }
      function og(e) {
        const { schema: t, document: i } = e.model;
        for (const n of i.getRootNames()) {
          const o = i.getRoot(n);
          if (o.isEmpty && !t.checkChild(o, '$text')) {
            if (t.checkChild(o, 'paragraph')) {
              e.insertElement('paragraph', o);
              return true;
            }
          }
        }
        return false;
      }
      function rg(e, t, i) {
        const n = i.createContext(e);
        if (!i.checkChild(n, 'paragraph')) {
          return false;
        }
        if (!i.checkChild(n.push('paragraph'), t)) {
          return false;
        }
        return true;
      }
      function sg(e, t) {
        const i = t.createElement('paragraph');
        t.insert(i, e);
        return t.createPositionAt(i, 0);
      }
      class ag extends yf {
        elementToElement(e) {
          return this.add(ug(e));
        }
        elementToAttribute(e) {
          return this.add(hg(e));
        }
        attributeToAttribute(e) {
          return this.add(fg(e));
        }
        elementToMarker(e) {
          console.warn(
            Object(ss['a'])(
              'upcast-helpers-element-to-marker-deprecated: ' +
                'The UpcastHelpers#elementToMarker() method was deprecated and will be removed in the near future. ' +
                'Please use UpcastHelpers#dataToMarker() instead.'
            )
          );
          return this.add(gg(e));
        }
        dataToMarker(e) {
          return this.add(mg(e));
        }
      }
      function cg() {
        return (e, t, i) => {
          if (
            !t.modelRange &&
            i.consumable.consume(t.viewItem, { name: true })
          ) {
            const { modelRange: e, modelCursor: n } = i.convertChildren(
              t.viewItem,
              t.modelCursor
            );
            t.modelRange = e;
            t.modelCursor = n;
          }
        };
      }
      function lg() {
        return (e, t, { schema: i, consumable: n, writer: o }) => {
          let r = t.modelCursor;
          if (!n.test(t.viewItem)) {
            return;
          }
          if (!i.checkChild(r, '$text')) {
            if (!rg(r, '$text', i)) {
              return;
            }
            r = sg(r, o);
          }
          n.consume(t.viewItem);
          const s = o.createText(t.viewItem.data);
          o.insert(s, r);
          t.modelRange = o.createRange(r, r.getShiftedBy(s.offsetSize));
          t.modelCursor = t.modelRange.end;
        };
      }
      function dg(e, t) {
        return (i, n) => {
          const o = n.newSelection;
          const r = [];
          for (const e of o.getRanges()) {
            r.push(t.toModelRange(e));
          }
          const s = e.createSelection(r, { backward: o.isBackward });
          if (!s.isEqual(e.document.selection)) {
            e.change((e) => {
              e.setSelection(s);
            });
          }
        };
      }
      function ug(e) {
        e = Cf(e);
        const t = wg(e);
        const i = bg(e.view);
        const n = i ? 'element:' + i : 'element';
        return (i) => {
          i.on(n, t, { priority: e.converterPriority || 'normal' });
        };
      }
      function hg(e) {
        e = Cf(e);
        vg(e);
        const t = yg(e, false);
        const i = bg(e.view);
        const n = i ? 'element:' + i : 'element';
        return (i) => {
          i.on(n, t, { priority: e.converterPriority || 'low' });
        };
      }
      function fg(e) {
        e = Cf(e);
        let t = null;
        if (typeof e.view == 'string' || e.view.key) {
          t = _g(e);
        }
        vg(e, t);
        const i = yg(e, true);
        return (t) => {
          t.on('element', i, { priority: e.converterPriority || 'low' });
        };
      }
      function gg(e) {
        e = Cf(e);
        Tg(e);
        return ug(e);
      }
      function mg(e) {
        e = Cf(e);
        if (!e.model) {
          e.model = (t) => (t ? e.view + ':' + t : e.view);
        }
        const t = wg(Cg(e, 'start'));
        const i = wg(Cg(e, 'end'));
        return (n) => {
          n.on('element:' + e.view + '-start', t, {
            priority: e.converterPriority || 'normal',
          });
          n.on('element:' + e.view + '-end', i, {
            priority: e.converterPriority || 'normal',
          });
          const o = os.get('low');
          const r = os.get('highest');
          const s = os.get(e.converterPriority) / r;
          n.on('element', pg(e), { priority: o + s });
        };
      }
      function pg(e) {
        return (t, i, n) => {
          const o = `data-${e.view}`;
          if (!i.modelRange) {
            i = Object.assign(i, n.convertChildren(i.viewItem, i.modelCursor));
          }
          if (
            n.consumable.consume(i.viewItem, { attributes: o + '-end-after' })
          ) {
            r(
              i.modelRange.end,
              i.viewItem.getAttribute(o + '-end-after').split(',')
            );
          }
          if (
            n.consumable.consume(i.viewItem, { attributes: o + '-start-after' })
          ) {
            r(
              i.modelRange.end,
              i.viewItem.getAttribute(o + '-start-after').split(',')
            );
          }
          if (
            n.consumable.consume(i.viewItem, { attributes: o + '-end-before' })
          ) {
            r(
              i.modelRange.start,
              i.viewItem.getAttribute(o + '-end-before').split(',')
            );
          }
          if (
            n.consumable.consume(i.viewItem, {
              attributes: o + '-start-before',
            })
          ) {
            r(
              i.modelRange.start,
              i.viewItem.getAttribute(o + '-start-before').split(',')
            );
          }
          function r(t, o) {
            for (const r of o) {
              const o = e.model(r, n);
              const s = n.writer.createElement('$marker', { 'data-name': o });
              n.writer.insert(s, t);
              if (i.modelCursor.isEqual(t)) {
                i.modelCursor = i.modelCursor.getShiftedBy(1);
              } else {
                i.modelCursor = i.modelCursor._getTransformedByInsertion(t, 1);
              }
              i.modelRange = i.modelRange._getTransformedByInsertion(t, 1)[0];
            }
          }
        };
      }
      function bg(e) {
        if (typeof e == 'string') {
          return e;
        }
        if (typeof e == 'object' && typeof e.name == 'string') {
          return e.name;
        }
        return null;
      }
      function wg(e) {
        const t = new qs(e.view);
        return (i, n, o) => {
          const r = t.match(n.viewItem);
          if (!r) {
            return;
          }
          const s = r.match;
          s.name = true;
          if (!o.consumable.test(n.viewItem, s)) {
            return;
          }
          const a = kg(e.model, n.viewItem, o);
          if (!a) {
            return;
          }
          if (!o.safeInsert(a, n.modelCursor)) {
            return;
          }
          o.consumable.consume(n.viewItem, s);
          o.convertChildren(n.viewItem, a);
          o.updateConversionResult(a, n);
        };
      }
      function kg(e, t, i) {
        if (e instanceof Function) {
          return e(t, i);
        } else {
          return i.writer.createElement(e);
        }
      }
      function _g(e) {
        if (typeof e.view == 'string') {
          e.view = { key: e.view };
        }
        const t = e.view.key;
        let i;
        if (t == 'class' || t == 'style') {
          const n = t == 'class' ? 'classes' : 'styles';
          i = { [n]: e.view.value };
        } else {
          const n =
            typeof e.view.value == 'undefined' ? /[\s\S]*/ : e.view.value;
          i = { attributes: { [t]: n } };
        }
        if (e.view.name) {
          i.name = e.view.name;
        }
        e.view = i;
        return t;
      }
      function vg(e, t = null) {
        const i = t === null ? true : (e) => e.getAttribute(t);
        const n = typeof e.model != 'object' ? e.model : e.model.key;
        const o =
          typeof e.model != 'object' || typeof e.model.value == 'undefined'
            ? i
            : e.model.value;
        e.model = { key: n, value: o };
      }
      function yg(e, t) {
        const i = new qs(e.view);
        return (n, o, r) => {
          const s = i.match(o.viewItem);
          if (!s) {
            return;
          }
          const a = e.model.key;
          const c =
            typeof e.model.value == 'function'
              ? e.model.value(o.viewItem, r)
              : e.model.value;
          if (c === null) {
            return;
          }
          if (xg(e.view, o.viewItem)) {
            s.match.name = true;
          } else {
            delete s.match.name;
          }
          if (!r.consumable.test(o.viewItem, s.match)) {
            return;
          }
          if (!o.modelRange) {
            o = Object.assign(o, r.convertChildren(o.viewItem, o.modelCursor));
          }
          const l = Ag(o.modelRange, { key: a, value: c }, t, r);
          if (l) {
            r.consumable.consume(o.viewItem, s.match);
          }
        };
      }
      function xg(e, t) {
        const i = typeof e == 'function' ? e(t) : e;
        if (typeof i == 'object' && !bg(i)) {
          return false;
        }
        return !i.classes && !i.attributes && !i.styles;
      }
      function Ag(e, t, i, n) {
        let o = false;
        for (const r of Array.from(e.getItems({ shallow: i }))) {
          if (n.schema.checkAttribute(r, t.key)) {
            n.writer.setAttribute(t.key, t.value, r);
            o = true;
          }
        }
        return o;
      }
      function Tg(e) {
        const t = e.model;
        e.model = (e, i) => {
          const n = typeof t == 'string' ? t : t(e, i);
          return i.writer.createElement('$marker', { 'data-name': n });
        };
      }
      function Cg(e, t) {
        const i = {};
        i.view = e.view + '-' + t;
        i.model = (t, i) => {
          const n = t.getAttribute('name');
          const o = e.model(n, i);
          return i.writer.createElement('$marker', { 'data-name': o });
        };
        return i;
      }
      class Pg {
        constructor(e, t) {
          this.model = e;
          this.view = new Fh(t);
          this.mapper = new tf();
          this.downcastDispatcher = new rf({
            mapper: this.mapper,
            schema: e.schema,
          });
          const i = this.model.document;
          const n = i.selection;
          const o = this.model.markers;
          this.listenTo(
            this.model,
            '_beforeChanges',
            () => {
              this.view._disableRendering(true);
            },
            { priority: 'highest' }
          );
          this.listenTo(
            this.model,
            '_afterChanges',
            () => {
              this.view._disableRendering(false);
            },
            { priority: 'lowest' }
          );
          this.listenTo(
            i,
            'change',
            () => {
              this.view.change((e) => {
                this.downcastDispatcher.convertChanges(i.differ, o, e);
                this.downcastDispatcher.convertSelection(n, o, e);
              });
            },
            { priority: 'low' }
          );
          this.listenTo(
            this.view.document,
            'selectionChange',
            dg(this.model, this.mapper)
          );
          this.downcastDispatcher.on('insert:$text', Ef(), {
            priority: 'lowest',
          });
          this.downcastDispatcher.on('remove', Sf(), { priority: 'low' });
          this.downcastDispatcher.on('selection', Of(), { priority: 'low' });
          this.downcastDispatcher.on('selection', If(), { priority: 'low' });
          this.downcastDispatcher.on('selection', Nf(), { priority: 'low' });
          this.view.document.roots
            .bindTo(this.model.document.roots)
            .using((e) => {
              if (e.rootName == '$graveyard') {
                return null;
              }
              const t = new ll(this.view.document, e.name);
              t.rootName = e.rootName;
              this.mapper.bindElements(e, t);
              return t;
            });
        }
        destroy() {
          this.view.destroy();
          this.stopListening();
        }
      }
      ys(Pg, Qc);
      class Eg {
        constructor() {
          this._commands = new Map();
        }
        add(e, t) {
          this._commands.set(e, t);
        }
        get(e) {
          return this._commands.get(e);
        }
        execute(e, ...t) {
          const i = this.get(e);
          if (!i) {
            throw new ss['b'](
              'commandcollection-command-not-found: Command does not exist.',
              this,
              { commandName: e }
            );
          }
          return i.execute(...t);
        }
        *names() {
          yield* this._commands.keys();
        }
        *commands() {
          yield* this._commands.values();
        }
        [Symbol.iterator]() {
          return this._commands[Symbol.iterator]();
        }
        destroy() {
          for (const e of this.commands()) {
            e.destroy();
          }
        }
      }
      class Sg {
        constructor() {
          this._consumables = new Map();
        }
        add(e, t) {
          let i;
          if (e.is('$text') || e.is('documentFragment')) {
            this._consumables.set(e, true);
            return;
          }
          if (!this._consumables.has(e)) {
            i = new Mg(e);
            this._consumables.set(e, i);
          } else {
            i = this._consumables.get(e);
          }
          i.add(t);
        }
        test(e, t) {
          const i = this._consumables.get(e);
          if (i === undefined) {
            return null;
          }
          if (e.is('$text') || e.is('documentFragment')) {
            return i;
          }
          return i.test(t);
        }
        consume(e, t) {
          if (this.test(e, t)) {
            if (e.is('$text') || e.is('documentFragment')) {
              this._consumables.set(e, false);
            } else {
              this._consumables.get(e).consume(t);
            }
            return true;
          }
          return false;
        }
        revert(e, t) {
          const i = this._consumables.get(e);
          if (i !== undefined) {
            if (e.is('$text') || e.is('documentFragment')) {
              this._consumables.set(e, true);
            } else {
              i.revert(t);
            }
          }
        }
        static consumablesFromElement(e) {
          const t = {
            element: e,
            name: true,
            attributes: [],
            classes: [],
            styles: [],
          };
          const i = e.getAttributeKeys();
          for (const e of i) {
            if (e == 'style' || e == 'class') {
              continue;
            }
            t.attributes.push(e);
          }
          const n = e.getClassNames();
          for (const e of n) {
            t.classes.push(e);
          }
          const o = e.getStyleNames();
          for (const e of o) {
            t.styles.push(e);
          }
          return t;
        }
        static createFrom(e, t) {
          if (!t) {
            t = new Sg(e);
          }
          if (e.is('$text')) {
            t.add(e);
            return t;
          }
          if (e.is('element')) {
            t.add(e, Sg.consumablesFromElement(e));
          }
          if (e.is('documentFragment')) {
            t.add(e);
          }
          for (const i of e.getChildren()) {
            t = Sg.createFrom(i, t);
          }
          return t;
        }
      }
      class Mg {
        constructor(e) {
          this.element = e;
          this._canConsumeName = null;
          this._consumables = {
            attributes: new Map(),
            styles: new Map(),
            classes: new Map(),
          };
        }
        add(e) {
          if (e.name) {
            this._canConsumeName = true;
          }
          for (const t in this._consumables) {
            if (t in e) {
              this._add(t, e[t]);
            }
          }
        }
        test(e) {
          if (e.name && !this._canConsumeName) {
            return this._canConsumeName;
          }
          for (const t in this._consumables) {
            if (t in e) {
              const i = this._test(t, e[t]);
              if (i !== true) {
                return i;
              }
            }
          }
          return true;
        }
        consume(e) {
          if (e.name) {
            this._canConsumeName = false;
          }
          for (const t in this._consumables) {
            if (t in e) {
              this._consume(t, e[t]);
            }
          }
        }
        revert(e) {
          if (e.name) {
            this._canConsumeName = true;
          }
          for (const t in this._consumables) {
            if (t in e) {
              this._revert(t, e[t]);
            }
          }
        }
        _add(e, t) {
          const i = Kt(t) ? t : [t];
          const n = this._consumables[e];
          for (const t of i) {
            if (e === 'attributes' && (t === 'class' || t === 'style')) {
              throw new ss['b'](
                'viewconsumable-invalid-attribute: Classes and styles should be handled separately.',
                this
              );
            }
            n.set(t, true);
            if (e === 'styles') {
              for (const e of this.element.document.stylesProcessor.getRelatedStyles(
                t
              )) {
                n.set(e, true);
              }
            }
          }
        }
        _test(e, t) {
          const i = Kt(t) ? t : [t];
          const n = this._consumables[e];
          for (const t of i) {
            if (e === 'attributes' && (t === 'class' || t === 'style')) {
              const e = t == 'class' ? 'classes' : 'styles';
              const i = this._test(e, [...this._consumables[e].keys()]);
              if (i !== true) {
                return i;
              }
            } else {
              const e = n.get(t);
              if (e === undefined) {
                return null;
              }
              if (!e) {
                return false;
              }
            }
          }
          return true;
        }
        _consume(e, t) {
          const i = Kt(t) ? t : [t];
          const n = this._consumables[e];
          for (const t of i) {
            if (e === 'attributes' && (t === 'class' || t === 'style')) {
              const e = t == 'class' ? 'classes' : 'styles';
              this._consume(e, [...this._consumables[e].keys()]);
            } else {
              n.set(t, false);
              if (e == 'styles') {
                for (const e of this.element.document.stylesProcessor.getRelatedStyles(
                  t
                )) {
                  n.set(e, false);
                }
              }
            }
          }
        }
        _revert(e, t) {
          const i = Kt(t) ? t : [t];
          const n = this._consumables[e];
          for (const t of i) {
            if (e === 'attributes' && (t === 'class' || t === 'style')) {
              const e = t == 'class' ? 'classes' : 'styles';
              this._revert(e, [...this._consumables[e].keys()]);
            } else {
              const e = n.get(t);
              if (e === false) {
                n.set(t, true);
              }
            }
          }
        }
      }
      class Ig {
        constructor() {
          this._sourceDefinitions = {};
          this._attributeProperties = {};
          this.decorate('checkChild');
          this.decorate('checkAttribute');
          this.on(
            'checkAttribute',
            (e, t) => {
              t[0] = new Ng(t[0]);
            },
            { priority: 'highest' }
          );
          this.on(
            'checkChild',
            (e, t) => {
              t[0] = new Ng(t[0]);
              t[1] = this.getDefinition(t[1]);
            },
            { priority: 'highest' }
          );
        }
        register(e, t) {
          if (this._sourceDefinitions[e]) {
            throw new ss['b'](
              'schema-cannot-register-item-twice: A single item cannot be registered twice in the schema.',
              this,
              { itemName: e }
            );
          }
          this._sourceDefinitions[e] = [Object.assign({}, t)];
          this._clearCache();
        }
        extend(e, t) {
          if (!this._sourceDefinitions[e]) {
            throw new ss['b'](
              'schema-cannot-extend-missing-item: Cannot extend an item which was not registered yet.',
              this,
              { itemName: e }
            );
          }
          this._sourceDefinitions[e].push(Object.assign({}, t));
          this._clearCache();
        }
        getDefinitions() {
          if (!this._compiledDefinitions) {
            this._compile();
          }
          return this._compiledDefinitions;
        }
        getDefinition(e) {
          let t;
          if (typeof e == 'string') {
            t = e;
          } else if (e.is && (e.is('$text') || e.is('$textProxy'))) {
            t = '$text';
          } else {
            t = e.name;
          }
          return this.getDefinitions()[t];
        }
        isRegistered(e) {
          return !!this.getDefinition(e);
        }
        isBlock(e) {
          const t = this.getDefinition(e);
          return !!(t && t.isBlock);
        }
        isLimit(e) {
          const t = this.getDefinition(e);
          if (!t) {
            return false;
          }
          return !!(t.isLimit || t.isObject);
        }
        isObject(e) {
          const t = this.getDefinition(e);
          if (!t) {
            return false;
          }
          return !!(t.isObject || (t.isLimit && t.isSelectable && t.isContent));
        }
        isInline(e) {
          const t = this.getDefinition(e);
          return !!(t && t.isInline);
        }
        isSelectable(e) {
          const t = this.getDefinition(e);
          if (!t) {
            return false;
          }
          return !!(t.isSelectable || t.isObject);
        }
        isContent(e) {
          const t = this.getDefinition(e);
          if (!t) {
            return false;
          }
          return !!(t.isContent || t.isObject);
        }
        checkChild(e, t) {
          if (!t) {
            return false;
          }
          return this._checkContextMatch(t, e);
        }
        checkAttribute(e, t) {
          const i = this.getDefinition(e.last);
          if (!i) {
            return false;
          }
          return i.allowAttributes.includes(t);
        }
        checkMerge(e, t = null) {
          if (e instanceof Qh) {
            const t = e.nodeBefore;
            const i = e.nodeAfter;
            if (!(t instanceof $h)) {
              throw new ss['b'](
                'schema-check-merge-no-element-before: The node before the merge position must be an element.',
                this
              );
            }
            if (!(i instanceof $h)) {
              throw new ss['b'](
                'schema-check-merge-no-element-after: The node after the merge position must be an element.',
                this
              );
            }
            return this.checkMerge(t, i);
          }
          for (const i of t.getChildren()) {
            if (!this.checkChild(e, i)) {
              return false;
            }
          }
          return true;
        }
        addChildCheck(e) {
          this.on(
            'checkChild',
            (t, [i, n]) => {
              if (!n) {
                return;
              }
              const o = e(i, n);
              if (typeof o == 'boolean') {
                t.stop();
                t.return = o;
              }
            },
            { priority: 'high' }
          );
        }
        addAttributeCheck(e) {
          this.on(
            'checkAttribute',
            (t, [i, n]) => {
              const o = e(i, n);
              if (typeof o == 'boolean') {
                t.stop();
                t.return = o;
              }
            },
            { priority: 'high' }
          );
        }
        setAttributeProperties(e, t) {
          this._attributeProperties[e] = Object.assign(
            this.getAttributeProperties(e),
            t
          );
        }
        getAttributeProperties(e) {
          return this._attributeProperties[e] || {};
        }
        getLimitElement(e) {
          let t;
          if (e instanceof Qh) {
            t = e.parent;
          } else {
            const i = e instanceof ef ? [e] : Array.from(e.getRanges());
            t = i.reduce((e, t) => {
              const i = t.getCommonAncestor();
              if (!e) {
                return i;
              }
              return e.getCommonAncestor(i, { includeSelf: true });
            }, null);
          }
          while (!this.isLimit(t)) {
            if (t.parent) {
              t = t.parent;
            } else {
              break;
            }
          }
          return t;
        }
        checkAttributeInSelection(e, t) {
          if (e.isCollapsed) {
            const i = e.getFirstPosition();
            const n = [...i.getAncestors(), new Uh('', e.getAttributes())];
            return this.checkAttribute(n, t);
          } else {
            const i = e.getRanges();
            for (const e of i) {
              for (const i of e) {
                if (this.checkAttribute(i.item, t)) {
                  return true;
                }
              }
            }
          }
          return false;
        }
        *getValidRanges(e, t) {
          e = Gg(e);
          for (const i of e) {
            yield* this._getValidRangesForRange(i, t);
          }
        }
        getNearestSelectionRange(e, t = 'both') {
          if (this.checkChild(e, '$text')) {
            return new ef(e);
          }
          let i, n;
          const o =
            e
              .getAncestors()
              .reverse()
              .find((e) => this.isLimit(e)) || e.root;
          if (t == 'both' || t == 'backward') {
            i = new Yh({
              boundaries: ef._createIn(o),
              startPosition: e,
              direction: 'backward',
            });
          }
          if (t == 'both' || t == 'forward') {
            n = new Yh({ boundaries: ef._createIn(o), startPosition: e });
          }
          for (const e of $g(i, n)) {
            const t = e.walker == i ? 'elementEnd' : 'elementStart';
            const n = e.value;
            if (n.type == t && this.isObject(n.item)) {
              return ef._createOn(n.item);
            }
            if (this.checkChild(n.nextPosition, '$text')) {
              return new ef(n.nextPosition);
            }
          }
          return null;
        }
        findAllowedParent(e, t) {
          let i = e.parent;
          while (i) {
            if (this.checkChild(i, t)) {
              return i;
            }
            if (this.isLimit(i)) {
              return null;
            }
            i = i.parent;
          }
          return null;
        }
        removeDisallowedAttributes(e, t) {
          for (const i of e) {
            if (i.is('$text')) {
              Yg(this, i, t);
            } else {
              const e = ef._createIn(i);
              const n = e.getPositions();
              for (const e of n) {
                const i = e.nodeBefore || e.parent;
                Yg(this, i, t);
              }
            }
          }
        }
        createContext(e) {
          return new Ng(e);
        }
        _clearCache() {
          this._compiledDefinitions = null;
        }
        _compile() {
          const e = {};
          const t = this._sourceDefinitions;
          const i = Object.keys(t);
          for (const n of i) {
            e[n] = Og(t[n], n);
          }
          for (const t of i) {
            zg(e, t);
          }
          for (const t of i) {
            Rg(e, t);
          }
          for (const t of i) {
            Lg(e, t);
            Vg(e, t);
          }
          for (const t of i) {
            Dg(e, t);
            jg(e, t);
          }
          this._compiledDefinitions = e;
        }
        _checkContextMatch(e, t, i = t.length - 1) {
          const n = t.getItem(i);
          if (e.allowIn.includes(n.name)) {
            if (i == 0) {
              return true;
            } else {
              const e = this.getDefinition(n);
              return this._checkContextMatch(e, t, i - 1);
            }
          } else {
            return false;
          }
        }
        *_getValidRangesForRange(e, t) {
          let i = e.start;
          let n = e.start;
          for (const o of e.getItems({ shallow: true })) {
            if (o.is('element')) {
              yield* this._getValidRangesForRange(ef._createIn(o), t);
            }
            if (!this.checkAttribute(o, t)) {
              if (!i.isEqual(n)) {
                yield new ef(i, n);
              }
              i = Qh._createAfter(o);
            }
            n = Qh._createAfter(o);
          }
          if (!i.isEqual(n)) {
            yield new ef(i, n);
          }
        }
      }
      ys(Ig, Qc);
      class Ng {
        constructor(e) {
          if (e instanceof Ng) {
            return e;
          }
          if (typeof e == 'string') {
            e = [e];
          } else if (!Array.isArray(e)) {
            e = e.getAncestors({ includeSelf: true });
          }
          if (e[0] && typeof e[0] != 'string' && e[0].is('documentFragment')) {
            e.shift();
          }
          this._items = e.map(Wg);
        }
        get length() {
          return this._items.length;
        }
        get last() {
          return this._items[this._items.length - 1];
        }
        [Symbol.iterator]() {
          return this._items[Symbol.iterator]();
        }
        push(e) {
          const t = new Ng([e]);
          t._items = [...this._items, ...t._items];
          return t;
        }
        getItem(e) {
          return this._items[e];
        }
        *getNames() {
          yield* this._items.map((e) => e.name);
        }
        endsWith(e) {
          return Array.from(this.getNames()).join(' ').endsWith(e);
        }
        startsWith(e) {
          return Array.from(this.getNames()).join(' ').startsWith(e);
        }
      }
      function Og(e, t) {
        const i = {
          name: t,
          allowIn: [],
          allowContentOf: [],
          allowWhere: [],
          allowAttributes: [],
          allowAttributesOf: [],
          inheritTypesFrom: [],
        };
        Bg(e, i);
        Fg(e, i, 'allowIn');
        Fg(e, i, 'allowContentOf');
        Fg(e, i, 'allowWhere');
        Fg(e, i, 'allowAttributes');
        Fg(e, i, 'allowAttributesOf');
        Fg(e, i, 'inheritTypesFrom');
        Hg(e, i);
        return i;
      }
      function zg(e, t) {
        for (const i of e[t].allowContentOf) {
          if (e[i]) {
            const n = Ug(e, i);
            n.forEach((e) => {
              e.allowIn.push(t);
            });
          }
        }
        delete e[t].allowContentOf;
      }
      function Rg(e, t) {
        for (const i of e[t].allowWhere) {
          const n = e[i];
          if (n) {
            const i = n.allowIn;
            e[t].allowIn.push(...i);
          }
        }
        delete e[t].allowWhere;
      }
      function Lg(e, t) {
        for (const i of e[t].allowAttributesOf) {
          const n = e[i];
          if (n) {
            const i = n.allowAttributes;
            e[t].allowAttributes.push(...i);
          }
        }
        delete e[t].allowAttributesOf;
      }
      function Vg(e, t) {
        const i = e[t];
        for (const t of i.inheritTypesFrom) {
          const n = e[t];
          if (n) {
            const e = Object.keys(n).filter((e) => e.startsWith('is'));
            for (const t of e) {
              if (!(t in i)) {
                i[t] = n[t];
              }
            }
          }
        }
        delete i.inheritTypesFrom;
      }
      function Dg(e, t) {
        const i = e[t];
        const n = i.allowIn.filter((t) => e[t]);
        i.allowIn = Array.from(new Set(n));
      }
      function jg(e, t) {
        const i = e[t];
        i.allowAttributes = Array.from(new Set(i.allowAttributes));
      }
      function Bg(e, t) {
        for (const i of e) {
          const e = Object.keys(i).filter((e) => e.startsWith('is'));
          for (const n of e) {
            t[n] = i[n];
          }
        }
      }
      function Fg(e, t, i) {
        for (const n of e) {
          if (typeof n[i] == 'string') {
            t[i].push(n[i]);
          } else if (Array.isArray(n[i])) {
            t[i].push(...n[i]);
          }
        }
      }
      function Hg(e, t) {
        for (const i of e) {
          const e = i.inheritAllFrom;
          if (e) {
            t.allowContentOf.push(e);
            t.allowWhere.push(e);
            t.allowAttributesOf.push(e);
            t.inheritTypesFrom.push(e);
          }
        }
      }
      function Ug(e, t) {
        const i = e[t];
        return qg(e).filter((e) => e.allowIn.includes(i.name));
      }
      function qg(e) {
        return Object.keys(e).map((t) => e[t]);
      }
      function Wg(e) {
        if (typeof e == 'string') {
          return { name: e, *getAttributeKeys() {}, getAttribute() {} };
        } else {
          return {
            name: e.is('element') ? e.name : '$text',
            *getAttributeKeys() {
              yield* e.getAttributeKeys();
            },
            getAttribute(t) {
              return e.getAttribute(t);
            },
          };
        }
      }
      function* $g(e, t) {
        let i = false;
        while (!i) {
          i = true;
          if (e) {
            const t = e.next();
            if (!t.done) {
              i = false;
              yield { walker: e, value: t.value };
            }
          }
          if (t) {
            const e = t.next();
            if (!e.done) {
              i = false;
              yield { walker: t, value: e.value };
            }
          }
        }
      }
      function* Gg(e) {
        for (const t of e) {
          yield* t.getMinimalFlatRanges();
        }
      }
      function Yg(e, t, i) {
        for (const n of t.getAttributeKeys()) {
          if (!e.checkAttribute(t, n)) {
            i.removeAttribute(n, t);
          }
        }
      }
      class Kg {
        constructor(e = {}) {
          this._splitParts = new Map();
          this._cursorParents = new Map();
          this._modelCursor = null;
          this.conversionApi = Object.assign({}, e);
          this.conversionApi.convertItem = this._convertItem.bind(this);
          this.conversionApi.convertChildren = this._convertChildren.bind(this);
          this.conversionApi.safeInsert = this._safeInsert.bind(this);
          this.conversionApi.updateConversionResult =
            this._updateConversionResult.bind(this);
          this.conversionApi.splitToAllowedParent =
            this._splitToAllowedParent.bind(this);
          this.conversionApi.getSplitParts = this._getSplitParts.bind(this);
        }
        convert(e, t, i = ['$root']) {
          this.fire('viewCleanup', e);
          this._modelCursor = Jg(i, t);
          this.conversionApi.writer = t;
          this.conversionApi.consumable = Sg.createFrom(e);
          this.conversionApi.store = {};
          const { modelRange: n } = this._convertItem(e, this._modelCursor);
          const o = t.createDocumentFragment();
          if (n) {
            this._removeEmptyElements();
            for (const e of Array.from(
              this._modelCursor.parent.getChildren()
            )) {
              t.append(e, o);
            }
            o.markers = Qg(o, t);
          }
          this._modelCursor = null;
          this._splitParts.clear();
          this._cursorParents.clear();
          this.conversionApi.writer = null;
          this.conversionApi.store = null;
          return o;
        }
        _convertItem(e, t) {
          const i = Object.assign({
            viewItem: e,
            modelCursor: t,
            modelRange: null,
          });
          if (e.is('element')) {
            this.fire('element:' + e.name, i, this.conversionApi);
          } else if (e.is('$text')) {
            this.fire('text', i, this.conversionApi);
          } else {
            this.fire('documentFragment', i, this.conversionApi);
          }
          if (i.modelRange && !(i.modelRange instanceof ef)) {
            throw new ss['b'](
              'view-conversion-dispatcher-incorrect-result: Incorrect conversion result was dropped.',
              this
            );
          }
          return { modelRange: i.modelRange, modelCursor: i.modelCursor };
        }
        _convertChildren(e, t) {
          let i = t.is('position') ? t : Qh._createAt(t, 0);
          const n = new ef(i);
          for (const t of Array.from(e.getChildren())) {
            const e = this._convertItem(t, i);
            if (e.modelRange instanceof ef) {
              n.end = e.modelRange.end;
              i = e.modelCursor;
            }
          }
          return { modelRange: n, modelCursor: i };
        }
        _safeInsert(e, t) {
          const i = this._splitToAllowedParent(e, t);
          if (!i) {
            return false;
          }
          this.conversionApi.writer.insert(e, i.position);
          return true;
        }
        _updateConversionResult(e, t) {
          const i = this._getSplitParts(e);
          const n = this.conversionApi.writer;
          if (!t.modelRange) {
            t.modelRange = n.createRange(
              n.createPositionBefore(e),
              n.createPositionAfter(i[i.length - 1])
            );
          }
          const o = this._cursorParents.get(e);
          if (o) {
            t.modelCursor = n.createPositionAt(o, 0);
          } else {
            t.modelCursor = t.modelRange.end;
          }
        }
        _splitToAllowedParent(e, t) {
          const { schema: i, writer: n } = this.conversionApi;
          let o = i.findAllowedParent(t, e);
          if (o) {
            if (o === t.parent) {
              return { position: t };
            }
            if (this._modelCursor.parent.getAncestors().includes(o)) {
              o = null;
            }
          }
          if (!o) {
            if (!rg(t, e, i)) {
              return null;
            }
            return { position: sg(t, n) };
          }
          const r = this.conversionApi.writer.split(t, o);
          const s = [];
          for (const e of r.range.getWalker()) {
            if (e.type == 'elementEnd') {
              s.push(e.item);
            } else {
              const t = s.pop();
              const i = e.item;
              this._registerSplitPair(t, i);
            }
          }
          const a = r.range.end.parent;
          this._cursorParents.set(e, a);
          return { position: r.position, cursorParent: a };
        }
        _registerSplitPair(e, t) {
          if (!this._splitParts.has(e)) {
            this._splitParts.set(e, [e]);
          }
          const i = this._splitParts.get(e);
          this._splitParts.set(t, i);
          i.push(t);
        }
        _getSplitParts(e) {
          let t;
          if (!this._splitParts.has(e)) {
            t = [e];
          } else {
            t = this._splitParts.get(e);
          }
          return t;
        }
        _removeEmptyElements() {
          let e = false;
          for (const t of this._splitParts.keys()) {
            if (t.isEmpty) {
              this.conversionApi.writer.remove(t);
              this._splitParts.delete(t);
              e = true;
            }
          }
          if (e) {
            this._removeEmptyElements();
          }
        }
      }
      ys(Kg, ds);
      function Qg(e, t) {
        const i = new Set();
        const n = new Map();
        const o = ef._createIn(e).getItems();
        for (const e of o) {
          if (e.name == '$marker') {
            i.add(e);
          }
        }
        for (const e of i) {
          const i = e.getAttribute('data-name');
          const o = t.createPositionBefore(e);
          if (!n.has(i)) {
            n.set(i, new ef(o.clone()));
          } else {
            n.get(i).end = o.clone();
          }
          t.remove(e);
        }
        return n;
      }
      function Jg(e, t) {
        let i;
        for (const n of new Ng(e)) {
          const e = {};
          for (const t of n.getAttributeKeys()) {
            e[t] = n.getAttribute(t);
          }
          const o = t.createElement(n.name, e);
          if (i) {
            t.append(o, i);
          }
          i = Qh._createAt(o, 0);
        }
        return i;
      }
      class Zg {
        constructor(e, t) {
          this.model = e;
          this.stylesProcessor = t;
          this.processor;
          this.mapper = new tf();
          this.downcastDispatcher = new rf({
            mapper: this.mapper,
            schema: e.schema,
          });
          this.downcastDispatcher.on('insert:$text', Ef(), {
            priority: 'lowest',
          });
          this.upcastDispatcher = new Kg({ schema: e.schema });
          this.viewDocument = new bl(t);
          this._viewWriter = new Jl(this.viewDocument);
          this.upcastDispatcher.on('text', lg(), { priority: 'lowest' });
          this.upcastDispatcher.on('element', cg(), { priority: 'lowest' });
          this.upcastDispatcher.on('documentFragment', cg(), {
            priority: 'lowest',
          });
          this.decorate('init');
          this.decorate('set');
          this.on(
            'init',
            () => {
              this.fire('ready');
            },
            { priority: 'lowest' }
          );
          this.on(
            'ready',
            () => {
              this.model.enqueueChange('transparent', og);
            },
            { priority: 'lowest' }
          );
        }
        get(e = {}) {
          const { rootName: t = 'main', trim: i = 'empty' } = e;
          if (!this._checkIfRootsExists([t])) {
            throw new ss['b'](
              'datacontroller-get-non-existent-root: Attempting to get data from a non-existing root.',
              this
            );
          }
          const n = this.model.document.getRoot(t);
          if (
            i === 'empty' &&
            !this.model.hasContent(n, { ignoreWhitespaces: true })
          ) {
            return '';
          }
          return this.stringify(n, e);
        }
        stringify(e, t) {
          const i = this.toView(e, t);
          return this.processor.toData(i);
        }
        toView(e, t) {
          const i = this.viewDocument;
          const n = this._viewWriter;
          this.mapper.clearBindings();
          const o = ef._createIn(e);
          const r = new Kl(i);
          this.mapper.bindElements(e, r);
          this.downcastDispatcher.conversionApi.options = t;
          this.downcastDispatcher.convertInsert(o, n);
          if (!e.is('documentFragment')) {
            const t = Xg(e);
            for (const [e, i] of t) {
              this.downcastDispatcher.convertMarkerAdd(e, i, n);
            }
          }
          delete this.downcastDispatcher.conversionApi.options;
          return r;
        }
        init(e) {
          if (this.model.document.version) {
            throw new ss['b'](
              'datacontroller-init-document-not-empty: Trying to set initial data to not empty document.',
              this
            );
          }
          let t = {};
          if (typeof e === 'string') {
            t.main = e;
          } else {
            t = e;
          }
          if (!this._checkIfRootsExists(Object.keys(t))) {
            throw new ss['b'](
              'datacontroller-init-non-existent-root: Attempting to init data on a non-existing root.',
              this
            );
          }
          this.model.enqueueChange('transparent', (e) => {
            for (const i of Object.keys(t)) {
              const n = this.model.document.getRoot(i);
              e.insert(this.parse(t[i], n), n, 0);
            }
          });
          return Promise.resolve();
        }
        set(e) {
          let t = {};
          if (typeof e === 'string') {
            t.main = e;
          } else {
            t = e;
          }
          if (!this._checkIfRootsExists(Object.keys(t))) {
            throw new ss['b'](
              'datacontroller-set-non-existent-root: Attempting to set data on a non-existing root.',
              this
            );
          }
          this.model.enqueueChange('transparent', (e) => {
            e.setSelection(null);
            e.removeSelectionAttribute(
              this.model.document.selection.getAttributeKeys()
            );
            for (const i of Object.keys(t)) {
              const n = this.model.document.getRoot(i);
              e.remove(e.createRangeIn(n));
              e.insert(this.parse(t[i], n), n, 0);
            }
          });
        }
        parse(e, t = '$root') {
          const i = this.processor.toView(e);
          return this.toModel(i, t);
        }
        toModel(e, t = '$root') {
          return this.model.change((i) =>
            this.upcastDispatcher.convert(e, i, t)
          );
        }
        addStyleProcessorRules(e) {
          e(this.stylesProcessor);
        }
        destroy() {
          this.stopListening();
        }
        _checkIfRootsExists(e) {
          for (const t of e) {
            if (!this.model.document.getRootNames().includes(t)) {
              return false;
            }
          }
          return true;
        }
      }
      ys(Zg, Qc);
      function Xg(e) {
        const t = [];
        const i = e.root.document;
        if (!i) {
          return [];
        }
        const n = ef._createIn(e);
        for (const e of i.model.markers) {
          const i = n.getIntersection(e.getRange());
          if (i) {
            t.push([e.name, i]);
          }
        }
        return t;
      }
      class em {
        constructor(e, t) {
          this._helpers = new Map();
          this._downcast = Array.isArray(e) ? e : [e];
          this._createConversionHelpers({
            name: 'downcast',
            dispatchers: this._downcast,
            isDowncast: true,
          });
          this._upcast = Array.isArray(t) ? t : [t];
          this._createConversionHelpers({
            name: 'upcast',
            dispatchers: this._upcast,
            isDowncast: false,
          });
        }
        addAlias(e, t) {
          const i = this._downcast.includes(t);
          const n = this._upcast.includes(t);
          if (!n && !i) {
            throw new ss['b'](
              'conversion-add-alias-dispatcher-not-registered: ' +
                'Trying to register and alias for a dispatcher that nas not been registered.',
              this
            );
          }
          this._createConversionHelpers({
            name: e,
            dispatchers: [t],
            isDowncast: i,
          });
        }
        for(e) {
          if (!this._helpers.has(e)) {
            throw new ss['b'](
              'conversion-for-unknown-group: Trying to add a converter to an unknown dispatchers group.',
              this
            );
          }
          return this._helpers.get(e);
        }
        elementToElement(e) {
          this.for('downcast').elementToElement(e);
          for (const { model: t, view: i } of tm(e)) {
            this.for('upcast').elementToElement({
              model: t,
              view: i,
              converterPriority: e.converterPriority,
            });
          }
        }
        attributeToElement(e) {
          this.for('downcast').attributeToElement(e);
          for (const { model: t, view: i } of tm(e)) {
            this.for('upcast').elementToAttribute({
              view: i,
              model: t,
              converterPriority: e.converterPriority,
            });
          }
        }
        attributeToAttribute(e) {
          this.for('downcast').attributeToAttribute(e);
          for (const { model: t, view: i } of tm(e)) {
            this.for('upcast').attributeToAttribute({ view: i, model: t });
          }
        }
        _createConversionHelpers({ name: e, dispatchers: t, isDowncast: i }) {
          if (this._helpers.has(e)) {
            throw new ss['b'](
              'conversion-group-exists: Trying to register a group name that has already been registered.',
              this
            );
          }
          const n = i ? new Pf(t) : new ag(t);
          this._helpers.set(e, n);
        }
      }
      function* tm(e) {
        if (e.model.values) {
          for (const t of e.model.values) {
            const i = { key: e.model.key, value: t };
            const n = e.view[t];
            const o = e.upcastAlso ? e.upcastAlso[t] : undefined;
            yield* im(i, n, o);
          }
        } else {
          yield* im(e.model, e.view, e.upcastAlso);
        }
      }
      function* im(e, t, i) {
        yield { model: e, view: t };
        if (i) {
          i = Array.isArray(i) ? i : [i];
          for (const t of i) {
            yield { model: e, view: t };
          }
        }
      }
      class nm {
        constructor(e = 'default') {
          this.operations = [];
          this.type = e;
        }
        get baseVersion() {
          for (const e of this.operations) {
            if (e.baseVersion !== null) {
              return e.baseVersion;
            }
          }
          return null;
        }
        addOperation(e) {
          e.batch = this;
          this.operations.push(e);
          return e;
        }
      }
      class om {
        constructor(e) {
          this.baseVersion = e;
          this.isDocumentOperation = this.baseVersion !== null;
          this.batch = null;
        }
        _validate() {}
        toJSON() {
          const e = Object.assign({}, this);
          e.__className = this.constructor.className;
          delete e.batch;
          delete e.isDocumentOperation;
          return e;
        }
        static get className() {
          return 'Operation';
        }
        static fromJSON(e) {
          return new this(e.baseVersion);
        }
      }
      class rm {
        constructor(e) {
          this.markers = new Map();
          this._children = new Wh();
          if (e) {
            this._insertChild(0, e);
          }
        }
        [Symbol.iterator]() {
          return this.getChildren();
        }
        get childCount() {
          return this._children.length;
        }
        get maxOffset() {
          return this._children.maxOffset;
        }
        get isEmpty() {
          return this.childCount === 0;
        }
        get root() {
          return this;
        }
        get parent() {
          return null;
        }
        is(e) {
          return e === 'documentFragment' || e === 'model:documentFragment';
        }
        getChild(e) {
          return this._children.getNode(e);
        }
        getChildren() {
          return this._children[Symbol.iterator]();
        }
        getChildIndex(e) {
          return this._children.getNodeIndex(e);
        }
        getChildStartOffset(e) {
          return this._children.getNodeStartOffset(e);
        }
        getPath() {
          return [];
        }
        getNodeByPath(e) {
          let t = this;
          for (const i of e) {
            t = t.getChild(t.offsetToIndex(i));
          }
          return t;
        }
        offsetToIndex(e) {
          return this._children.offsetToIndex(e);
        }
        toJSON() {
          const e = [];
          for (const t of this._children) {
            e.push(t.toJSON());
          }
          return e;
        }
        static fromJSON(e) {
          const t = [];
          for (const i of e) {
            if (i.name) {
              t.push($h.fromJSON(i));
            } else {
              t.push(Uh.fromJSON(i));
            }
          }
          return new rm(t);
        }
        _appendChild(e) {
          this._insertChild(this.childCount, e);
        }
        _insertChild(e, t) {
          const i = sm(t);
          for (const e of i) {
            if (e.parent !== null) {
              e._remove();
            }
            e.parent = this;
          }
          this._children._insertNodes(e, i);
        }
        _removeChildren(e, t = 1) {
          const i = this._children._removeNodes(e, t);
          for (const e of i) {
            e.parent = null;
          }
          return i;
        }
      }
      function sm(e) {
        if (typeof e == 'string') {
          return [new Uh(e)];
        }
        if (!vs(e)) {
          e = [e];
        }
        return Array.from(e).map((e) => {
          if (typeof e == 'string') {
            return new Uh(e);
          }
          if (e instanceof qh) {
            return new Uh(e.data, e.getAttributes());
          }
          return e;
        });
      }
      function am(e, t) {
        t = um(t);
        const i = t.reduce((e, t) => e + t.offsetSize, 0);
        const n = e.parent;
        fm(e);
        const o = e.index;
        n._insertChild(o, t);
        hm(n, o + t.length);
        hm(n, o);
        return new ef(e, e.getShiftedBy(i));
      }
      function cm(e) {
        if (!e.isFlat) {
          throw new ss['b'](
            'operation-utils-remove-range-not-flat: ' +
              'Trying to remove a range which starts and ends in different element.',
            this
          );
        }
        const t = e.start.parent;
        fm(e.start);
        fm(e.end);
        const i = t._removeChildren(e.start.index, e.end.index - e.start.index);
        hm(t, e.start.index);
        return i;
      }
      function lm(e, t) {
        if (!e.isFlat) {
          throw new ss['b'](
            'operation-utils-move-range-not-flat: ' +
              'Trying to move a range which starts and ends in different element.',
            this
          );
        }
        const i = cm(e);
        t = t._getTransformedByDeletion(e.start, e.end.offset - e.start.offset);
        return am(t, i);
      }
      function dm(e, t, i) {
        fm(e.start);
        fm(e.end);
        for (const n of e.getItems({ shallow: true })) {
          const e = n.is('$textProxy') ? n.textNode : n;
          if (i !== null) {
            e._setAttribute(t, i);
          } else {
            e._removeAttribute(t);
          }
          hm(e.parent, e.index);
        }
        hm(e.end.parent, e.end.index);
      }
      function um(e) {
        const t = [];
        if (!(e instanceof Array)) {
          e = [e];
        }
        for (let i = 0; i < e.length; i++) {
          if (typeof e[i] == 'string') {
            t.push(new Uh(e[i]));
          } else if (e[i] instanceof qh) {
            t.push(new Uh(e[i].data, e[i].getAttributes()));
          } else if (e[i] instanceof rm || e[i] instanceof Wh) {
            for (const n of e[i]) {
              t.push(n);
            }
          } else if (e[i] instanceof Hh) {
            t.push(e[i]);
          }
        }
        for (let e = 1; e < t.length; e++) {
          const i = t[e];
          const n = t[e - 1];
          if (i instanceof Uh && n instanceof Uh && gm(i, n)) {
            t.splice(e - 1, 2, new Uh(n.data + i.data, n.getAttributes()));
            e--;
          }
        }
        return t;
      }
      function hm(e, t) {
        const i = e.getChild(t - 1);
        const n = e.getChild(t);
        if (i && n && i.is('$text') && n.is('$text') && gm(i, n)) {
          const o = new Uh(i.data + n.data, i.getAttributes());
          e._removeChildren(t - 1, 2);
          e._insertChild(t - 1, o);
        }
      }
      function fm(e) {
        const t = e.textNode;
        const i = e.parent;
        if (t) {
          const n = e.offset - t.startOffset;
          const o = t.index;
          i._removeChildren(o, 1);
          const r = new Uh(t.data.substr(0, n), t.getAttributes());
          const s = new Uh(t.data.substr(n), t.getAttributes());
          i._insertChild(o, [r, s]);
        }
      }
      function gm(e, t) {
        const i = e.getAttributes();
        const n = t.getAttributes();
        for (const e of i) {
          if (e[1] !== t.getAttribute(e[0])) {
            return false;
          }
          n.next();
        }
        return n.next().done;
      }
      function mm(e, t) {
        return Ku(e, t);
      }
      var pm = mm;
      class bm extends om {
        constructor(e, t, i, n, o) {
          super(o);
          this.range = e.clone();
          this.key = t;
          this.oldValue = i === undefined ? null : i;
          this.newValue = n === undefined ? null : n;
        }
        get type() {
          if (this.oldValue === null) {
            return 'addAttribute';
          } else if (this.newValue === null) {
            return 'removeAttribute';
          } else {
            return 'changeAttribute';
          }
        }
        clone() {
          return new bm(
            this.range,
            this.key,
            this.oldValue,
            this.newValue,
            this.baseVersion
          );
        }
        getReversed() {
          return new bm(
            this.range,
            this.key,
            this.newValue,
            this.oldValue,
            this.baseVersion + 1
          );
        }
        toJSON() {
          const e = super.toJSON();
          e.range = this.range.toJSON();
          return e;
        }
        _validate() {
          if (!this.range.isFlat) {
            throw new ss['b'](
              'attribute-operation-range-not-flat: The range to change is not flat.',
              this
            );
          }
          for (const e of this.range.getItems({ shallow: true })) {
            if (
              this.oldValue !== null &&
              !pm(e.getAttribute(this.key), this.oldValue)
            ) {
              throw new ss['b'](
                "attribute-operation-wrong-old-value: Changed node has different attribute value than operation's " +
                  'old attribute value.',
                this,
                { item: e, key: this.key, value: this.oldValue }
              );
            }
            if (
              this.oldValue === null &&
              this.newValue !== null &&
              e.hasAttribute(this.key)
            ) {
              throw new ss['b'](
                'attribute-operation-attribute-exists: The attribute with given key already exists.',
                this,
                { node: e, key: this.key }
              );
            }
          }
        }
        _execute() {
          if (!pm(this.oldValue, this.newValue)) {
            dm(this.range, this.key, this.newValue);
          }
        }
        static get className() {
          return 'AttributeOperation';
        }
        static fromJSON(e, t) {
          return new bm(
            ef.fromJSON(e.range, t),
            e.key,
            e.oldValue,
            e.newValue,
            e.baseVersion
          );
        }
      }
      class wm extends om {
        constructor(e, t) {
          super(null);
          this.sourcePosition = e.clone();
          this.howMany = t;
        }
        get type() {
          return 'detach';
        }
        toJSON() {
          const e = super.toJSON();
          e.sourcePosition = this.sourcePosition.toJSON();
          return e;
        }
        _validate() {
          if (this.sourcePosition.root.document) {
            throw new ss['b'](
              'detach-operation-on-document-node: Cannot detach document node.',
              this
            );
          }
        }
        _execute() {
          cm(ef._createFromPositionAndShift(this.sourcePosition, this.howMany));
        }
        static get className() {
          return 'DetachOperation';
        }
      }
      class km extends om {
        constructor(e, t, i, n) {
          super(n);
          this.sourcePosition = e.clone();
          this.sourcePosition.stickiness = 'toNext';
          this.howMany = t;
          this.targetPosition = i.clone();
          this.targetPosition.stickiness = 'toNone';
        }
        get type() {
          if (this.targetPosition.root.rootName == '$graveyard') {
            return 'remove';
          } else if (this.sourcePosition.root.rootName == '$graveyard') {
            return 'reinsert';
          }
          return 'move';
        }
        clone() {
          return new this.constructor(
            this.sourcePosition,
            this.howMany,
            this.targetPosition,
            this.baseVersion
          );
        }
        getMovedRangeStart() {
          return this.targetPosition._getTransformedByDeletion(
            this.sourcePosition,
            this.howMany
          );
        }
        getReversed() {
          const e = this.sourcePosition._getTransformedByInsertion(
            this.targetPosition,
            this.howMany
          );
          return new this.constructor(
            this.getMovedRangeStart(),
            this.howMany,
            e,
            this.baseVersion + 1
          );
        }
        _validate() {
          const e = this.sourcePosition.parent;
          const t = this.targetPosition.parent;
          const i = this.sourcePosition.offset;
          const n = this.targetPosition.offset;
          if (i + this.howMany > e.maxOffset) {
            throw new ss['b'](
              'move-operation-nodes-do-not-exist: The nodes which should be moved do not exist.',
              this
            );
          } else if (e === t && i < n && n < i + this.howMany) {
            throw new ss['b'](
              'move-operation-range-into-itself: Trying to move a range of nodes to the inside of that range.',
              this
            );
          } else if (this.sourcePosition.root == this.targetPosition.root) {
            if (
              Rs(
                this.sourcePosition.getParentPath(),
                this.targetPosition.getParentPath()
              ) == 'prefix'
            ) {
              const e = this.sourcePosition.path.length - 1;
              if (
                this.targetPosition.path[e] >= i &&
                this.targetPosition.path[e] < i + this.howMany
              ) {
                throw new ss['b'](
                  'move-operation-node-into-itself: Trying to move a range of nodes into one of nodes from that range.',
                  this
                );
              }
            }
          }
        }
        _execute() {
          lm(
            ef._createFromPositionAndShift(this.sourcePosition, this.howMany),
            this.targetPosition
          );
        }
        toJSON() {
          const e = super.toJSON();
          e.sourcePosition = this.sourcePosition.toJSON();
          e.targetPosition = this.targetPosition.toJSON();
          return e;
        }
        static get className() {
          return 'MoveOperation';
        }
        static fromJSON(e, t) {
          const i = Qh.fromJSON(e.sourcePosition, t);
          const n = Qh.fromJSON(e.targetPosition, t);
          return new this(i, e.howMany, n, e.baseVersion);
        }
      }
      class _m extends om {
        constructor(e, t, i) {
          super(i);
          this.position = e.clone();
          this.position.stickiness = 'toNone';
          this.nodes = new Wh(um(t));
          this.shouldReceiveAttributes = false;
        }
        get type() {
          return 'insert';
        }
        get howMany() {
          return this.nodes.maxOffset;
        }
        clone() {
          const e = new Wh([...this.nodes].map((e) => e._clone(true)));
          const t = new _m(this.position, e, this.baseVersion);
          t.shouldReceiveAttributes = this.shouldReceiveAttributes;
          return t;
        }
        getReversed() {
          const e = this.position.root.document.graveyard;
          const t = new Qh(e, [0]);
          return new km(
            this.position,
            this.nodes.maxOffset,
            t,
            this.baseVersion + 1
          );
        }
        _validate() {
          const e = this.position.parent;
          if (!e || e.maxOffset < this.position.offset) {
            throw new ss['b'](
              'insert-operation-position-invalid: Insertion position is invalid.',
              this
            );
          }
        }
        _execute() {
          const e = this.nodes;
          this.nodes = new Wh([...e].map((e) => e._clone(true)));
          am(this.position, e);
        }
        toJSON() {
          const e = super.toJSON();
          e.position = this.position.toJSON();
          e.nodes = this.nodes.toJSON();
          return e;
        }
        static get className() {
          return 'InsertOperation';
        }
        static fromJSON(e, t) {
          const i = [];
          for (const t of e.nodes) {
            if (t.name) {
              i.push($h.fromJSON(t));
            } else {
              i.push(Uh.fromJSON(t));
            }
          }
          const n = new _m(Qh.fromJSON(e.position, t), i, e.baseVersion);
          n.shouldReceiveAttributes = e.shouldReceiveAttributes;
          return n;
        }
      }
      class vm extends om {
        constructor(e, t, i, n, o, r) {
          super(r);
          this.name = e;
          this.oldRange = t ? t.clone() : null;
          this.newRange = i ? i.clone() : null;
          this.affectsData = o;
          this._markers = n;
        }
        get type() {
          return 'marker';
        }
        clone() {
          return new vm(
            this.name,
            this.oldRange,
            this.newRange,
            this._markers,
            this.affectsData,
            this.baseVersion
          );
        }
        getReversed() {
          return new vm(
            this.name,
            this.newRange,
            this.oldRange,
            this._markers,
            this.affectsData,
            this.baseVersion + 1
          );
        }
        _execute() {
          const e = this.newRange ? '_set' : '_remove';
          this._markers[e](this.name, this.newRange, true, this.affectsData);
        }
        toJSON() {
          const e = super.toJSON();
          if (this.oldRange) {
            e.oldRange = this.oldRange.toJSON();
          }
          if (this.newRange) {
            e.newRange = this.newRange.toJSON();
          }
          delete e._markers;
          return e;
        }
        static get className() {
          return 'MarkerOperation';
        }
        static fromJSON(e, t) {
          return new vm(
            e.name,
            e.oldRange ? ef.fromJSON(e.oldRange, t) : null,
            e.newRange ? ef.fromJSON(e.newRange, t) : null,
            t.model.markers,
            e.affectsData,
            e.baseVersion
          );
        }
      }
      class ym extends om {
        constructor(e, t, i, n) {
          super(n);
          this.position = e;
          this.position.stickiness = 'toNext';
          this.oldName = t;
          this.newName = i;
        }
        get type() {
          return 'rename';
        }
        clone() {
          return new ym(
            this.position.clone(),
            this.oldName,
            this.newName,
            this.baseVersion
          );
        }
        getReversed() {
          return new ym(
            this.position.clone(),
            this.newName,
            this.oldName,
            this.baseVersion + 1
          );
        }
        _validate() {
          const e = this.position.nodeAfter;
          if (!(e instanceof $h)) {
            throw new ss['b'](
              'rename-operation-wrong-position: Given position is invalid or node after it is not an instance of Element.',
              this
            );
          } else if (e.name !== this.oldName) {
            throw new ss['b'](
              "rename-operation-wrong-name: Element to change has different name than operation's old name.",
              this
            );
          }
        }
        _execute() {
          const e = this.position.nodeAfter;
          e.name = this.newName;
        }
        toJSON() {
          const e = super.toJSON();
          e.position = this.position.toJSON();
          return e;
        }
        static get className() {
          return 'RenameOperation';
        }
        static fromJSON(e, t) {
          return new ym(
            Qh.fromJSON(e.position, t),
            e.oldName,
            e.newName,
            e.baseVersion
          );
        }
      }
      class xm extends om {
        constructor(e, t, i, n, o) {
          super(o);
          this.root = e;
          this.key = t;
          this.oldValue = i;
          this.newValue = n;
        }
        get type() {
          if (this.oldValue === null) {
            return 'addRootAttribute';
          } else if (this.newValue === null) {
            return 'removeRootAttribute';
          } else {
            return 'changeRootAttribute';
          }
        }
        clone() {
          return new xm(
            this.root,
            this.key,
            this.oldValue,
            this.newValue,
            this.baseVersion
          );
        }
        getReversed() {
          return new xm(
            this.root,
            this.key,
            this.newValue,
            this.oldValue,
            this.baseVersion + 1
          );
        }
        _validate() {
          if (this.root != this.root.root || this.root.is('documentFragment')) {
            throw new ss['b'](
              'rootattribute-operation-not-a-root: The element to change is not a root element.',
              this,
              { root: this.root, key: this.key }
            );
          }
          if (
            this.oldValue !== null &&
            this.root.getAttribute(this.key) !== this.oldValue
          ) {
            throw new ss['b'](
              "rootattribute-operation-wrong-old-value: Changed node has different attribute value than operation's " +
                'old attribute value.',
              this,
              { root: this.root, key: this.key }
            );
          }
          if (
            this.oldValue === null &&
            this.newValue !== null &&
            this.root.hasAttribute(this.key)
          ) {
            throw new ss['b'](
              'rootattribute-operation-attribute-exists: The attribute with given key already exists.',
              this,
              { root: this.root, key: this.key }
            );
          }
        }
        _execute() {
          if (this.newValue !== null) {
            this.root._setAttribute(this.key, this.newValue);
          } else {
            this.root._removeAttribute(this.key);
          }
        }
        toJSON() {
          const e = super.toJSON();
          e.root = this.root.toJSON();
          return e;
        }
        static get className() {
          return 'RootAttributeOperation';
        }
        static fromJSON(e, t) {
          if (!t.getRoot(e.root)) {
            throw new ss['b'](
              'rootattribute-operation-fromjson-no-root: Cannot create RootAttributeOperation. Root with specified name does not exist.',
              this,
              { rootName: e.root }
            );
          }
          return new xm(
            t.getRoot(e.root),
            e.key,
            e.oldValue,
            e.newValue,
            e.baseVersion
          );
        }
      }
      class Am extends om {
        constructor(e, t, i, n, o) {
          super(o);
          this.sourcePosition = e.clone();
          this.sourcePosition.stickiness = 'toPrevious';
          this.howMany = t;
          this.targetPosition = i.clone();
          this.targetPosition.stickiness = 'toNext';
          this.graveyardPosition = n.clone();
        }
        get type() {
          return 'merge';
        }
        get deletionPosition() {
          return new Qh(
            this.sourcePosition.root,
            this.sourcePosition.path.slice(0, -1)
          );
        }
        get movedRange() {
          const e = this.sourcePosition.getShiftedBy(Number.POSITIVE_INFINITY);
          return new ef(this.sourcePosition, e);
        }
        clone() {
          return new this.constructor(
            this.sourcePosition,
            this.howMany,
            this.targetPosition,
            this.graveyardPosition,
            this.baseVersion
          );
        }
        getReversed() {
          const e = this.targetPosition._getTransformedByMergeOperation(this);
          const t = this.sourcePosition.path.slice(0, -1);
          const i = new Qh(
            this.sourcePosition.root,
            t
          )._getTransformedByMergeOperation(this);
          const n = new Tm(
            e,
            this.howMany,
            this.graveyardPosition,
            this.baseVersion + 1
          );
          n.insertionPosition = i;
          return n;
        }
        _validate() {
          const e = this.sourcePosition.parent;
          const t = this.targetPosition.parent;
          if (!e.parent) {
            throw new ss['b'](
              'merge-operation-source-position-invalid: Merge source position is invalid.',
              this
            );
          } else if (!t.parent) {
            throw new ss['b'](
              'merge-operation-target-position-invalid: Merge target position is invalid.',
              this
            );
          } else if (this.howMany != e.maxOffset) {
            throw new ss['b'](
              'merge-operation-how-many-invalid: Merge operation specifies wrong number of nodes to move.',
              this
            );
          }
        }
        _execute() {
          const e = this.sourcePosition.parent;
          const t = ef._createIn(e);
          lm(t, this.targetPosition);
          lm(ef._createOn(e), this.graveyardPosition);
        }
        toJSON() {
          const e = super.toJSON();
          e.sourcePosition = e.sourcePosition.toJSON();
          e.targetPosition = e.targetPosition.toJSON();
          e.graveyardPosition = e.graveyardPosition.toJSON();
          return e;
        }
        static get className() {
          return 'MergeOperation';
        }
        static fromJSON(e, t) {
          const i = Qh.fromJSON(e.sourcePosition, t);
          const n = Qh.fromJSON(e.targetPosition, t);
          const o = Qh.fromJSON(e.graveyardPosition, t);
          return new this(i, e.howMany, n, o, e.baseVersion);
        }
      }
      class Tm extends om {
        constructor(e, t, i, n) {
          super(n);
          this.splitPosition = e.clone();
          this.splitPosition.stickiness = 'toNext';
          this.howMany = t;
          this.insertionPosition = Tm.getInsertionPosition(e);
          this.insertionPosition.stickiness = 'toNone';
          this.graveyardPosition = i ? i.clone() : null;
          if (this.graveyardPosition) {
            this.graveyardPosition.stickiness = 'toNext';
          }
        }
        get type() {
          return 'split';
        }
        get moveTargetPosition() {
          const e = this.insertionPosition.path.slice();
          e.push(0);
          return new Qh(this.insertionPosition.root, e);
        }
        get movedRange() {
          const e = this.splitPosition.getShiftedBy(Number.POSITIVE_INFINITY);
          return new ef(this.splitPosition, e);
        }
        clone() {
          const e = new this.constructor(
            this.splitPosition,
            this.howMany,
            this.graveyardPosition,
            this.baseVersion
          );
          e.insertionPosition = this.insertionPosition;
          return e;
        }
        getReversed() {
          const e = this.splitPosition.root.document.graveyard;
          const t = new Qh(e, [0]);
          return new Am(
            this.moveTargetPosition,
            this.howMany,
            this.splitPosition,
            t,
            this.baseVersion + 1
          );
        }
        _validate() {
          const e = this.splitPosition.parent;
          const t = this.splitPosition.offset;
          if (!e || e.maxOffset < t) {
            throw new ss['b'](
              'split-operation-position-invalid: Split position is invalid.',
              this
            );
          } else if (!e.parent) {
            throw new ss['b'](
              'split-operation-split-in-root: Cannot split root element.',
              this
            );
          } else if (this.howMany != e.maxOffset - this.splitPosition.offset) {
            throw new ss['b'](
              'split-operation-how-many-invalid: Split operation specifies wrong number of nodes to move.',
              this
            );
          } else if (
            this.graveyardPosition &&
            !this.graveyardPosition.nodeAfter
          ) {
            throw new ss['b'](
              'split-operation-graveyard-position-invalid: Graveyard position invalid.',
              this
            );
          }
        }
        _execute() {
          const e = this.splitPosition.parent;
          if (this.graveyardPosition) {
            lm(
              ef._createFromPositionAndShift(this.graveyardPosition, 1),
              this.insertionPosition
            );
          } else {
            const t = e._clone();
            am(this.insertionPosition, t);
          }
          const t = new ef(
            Qh._createAt(e, this.splitPosition.offset),
            Qh._createAt(e, e.maxOffset)
          );
          lm(t, this.moveTargetPosition);
        }
        toJSON() {
          const e = super.toJSON();
          e.splitPosition = this.splitPosition.toJSON();
          e.insertionPosition = this.insertionPosition.toJSON();
          if (this.graveyardPosition) {
            e.graveyardPosition = this.graveyardPosition.toJSON();
          }
          return e;
        }
        static get className() {
          return 'SplitOperation';
        }
        static getInsertionPosition(e) {
          const t = e.path.slice(0, -1);
          t[t.length - 1]++;
          return new Qh(e.root, t);
        }
        static fromJSON(e, t) {
          const i = Qh.fromJSON(e.splitPosition, t);
          const n = Qh.fromJSON(e.insertionPosition, t);
          const o = e.graveyardPosition
            ? Qh.fromJSON(e.graveyardPosition, t)
            : null;
          const r = new this(i, e.howMany, o, e.baseVersion);
          r.insertionPosition = n;
          return r;
        }
      }
      class Cm extends $h {
        constructor(e, t, i = 'main') {
          super(t);
          this._document = e;
          this.rootName = i;
        }
        get document() {
          return this._document;
        }
        is(e, t) {
          if (!t) {
            return (
              e === 'rootElement' ||
              e === 'model:rootElement' ||
              e === 'element' ||
              e === 'model:element' ||
              e === 'node' ||
              e === 'model:node'
            );
          }
          return (
            t === this.name &&
            (e === 'rootElement' ||
              e === 'model:rootElement' ||
              e === 'element' ||
              e === 'model:element')
          );
        }
        toJSON() {
          return this.rootName;
        }
      }
      class Pm {
        constructor(e, t) {
          this.model = e;
          this.batch = t;
        }
        createText(e, t) {
          return new Uh(e, t);
        }
        createElement(e, t) {
          return new $h(e, t);
        }
        createDocumentFragment() {
          return new rm();
        }
        cloneElement(e, t = true) {
          return e._clone(t);
        }
        insert(e, t, i = 0) {
          this._assertWriterUsedCorrectly();
          if (e instanceof Uh && e.data == '') {
            return;
          }
          const n = Qh._createAt(t, i);
          if (e.parent) {
            if (Nm(e.root, n.root)) {
              this.move(ef._createOn(e), n);
              return;
            } else {
              if (e.root.document) {
                throw new ss['b'](
                  'model-writer-insert-forbidden-move: ' +
                    'Cannot move a node from a document to a different tree. ' +
                    'It is forbidden to move a node that was already in a document outside of it.',
                  this
                );
              } else {
                this.remove(e);
              }
            }
          }
          const o = n.root.document ? n.root.document.version : null;
          const r = new _m(n, e, o);
          if (e instanceof Uh) {
            r.shouldReceiveAttributes = true;
          }
          this.batch.addOperation(r);
          this.model.applyOperation(r);
          if (e instanceof rm) {
            for (const [t, i] of e.markers) {
              const e = Qh._createAt(i.root, 0);
              const o = new ef(
                i.start._getCombined(e, n),
                i.end._getCombined(e, n)
              );
              const r = { range: o, usingOperation: true, affectsData: true };
              if (this.model.markers.has(t)) {
                this.updateMarker(t, r);
              } else {
                this.addMarker(t, r);
              }
            }
          }
        }
        insertText(e, t, i, n) {
          if (t instanceof rm || t instanceof $h || t instanceof Qh) {
            this.insert(this.createText(e), t, i);
          } else {
            this.insert(this.createText(e, t), i, n);
          }
        }
        insertElement(e, t, i, n) {
          if (t instanceof rm || t instanceof $h || t instanceof Qh) {
            this.insert(this.createElement(e), t, i);
          } else {
            this.insert(this.createElement(e, t), i, n);
          }
        }
        append(e, t) {
          this.insert(e, t, 'end');
        }
        appendText(e, t, i) {
          if (t instanceof rm || t instanceof $h) {
            this.insert(this.createText(e), t, 'end');
          } else {
            this.insert(this.createText(e, t), i, 'end');
          }
        }
        appendElement(e, t, i) {
          if (t instanceof rm || t instanceof $h) {
            this.insert(this.createElement(e), t, 'end');
          } else {
            this.insert(this.createElement(e, t), i, 'end');
          }
        }
        setAttribute(e, t, i) {
          this._assertWriterUsedCorrectly();
          if (i instanceof ef) {
            const n = i.getMinimalFlatRanges();
            for (const i of n) {
              Em(this, e, t, i);
            }
          } else {
            Sm(this, e, t, i);
          }
        }
        setAttributes(e, t) {
          for (const [i, n] of Us(e)) {
            this.setAttribute(i, n, t);
          }
        }
        removeAttribute(e, t) {
          this._assertWriterUsedCorrectly();
          if (t instanceof ef) {
            const i = t.getMinimalFlatRanges();
            for (const t of i) {
              Em(this, e, null, t);
            }
          } else {
            Sm(this, e, null, t);
          }
        }
        clearAttributes(e) {
          this._assertWriterUsedCorrectly();
          const t = (e) => {
            for (const t of e.getAttributeKeys()) {
              this.removeAttribute(t, e);
            }
          };
          if (!(e instanceof ef)) {
            t(e);
          } else {
            for (const i of e.getItems()) {
              t(i);
            }
          }
        }
        move(e, t, i) {
          this._assertWriterUsedCorrectly();
          if (!(e instanceof ef)) {
            throw new ss['b'](
              'writer-move-invalid-range: Invalid range to move.',
              this
            );
          }
          if (!e.isFlat) {
            throw new ss['b'](
              'writer-move-range-not-flat: Range to move is not flat.',
              this
            );
          }
          const n = Qh._createAt(t, i);
          if (n.isEqual(e.start)) {
            return;
          }
          this._addOperationForAffectedMarkers('move', e);
          if (!Nm(e.root, n.root)) {
            throw new ss['b'](
              'writer-move-different-document: Range is going to be moved between different documents.',
              this
            );
          }
          const o = e.root.document ? e.root.document.version : null;
          const r = new km(e.start, e.end.offset - e.start.offset, n, o);
          this.batch.addOperation(r);
          this.model.applyOperation(r);
        }
        remove(e) {
          this._assertWriterUsedCorrectly();
          const t = e instanceof ef ? e : ef._createOn(e);
          const i = t.getMinimalFlatRanges().reverse();
          for (const e of i) {
            this._addOperationForAffectedMarkers('move', e);
            Im(e.start, e.end.offset - e.start.offset, this.batch, this.model);
          }
        }
        merge(e) {
          this._assertWriterUsedCorrectly();
          const t = e.nodeBefore;
          const i = e.nodeAfter;
          this._addOperationForAffectedMarkers('merge', e);
          if (!(t instanceof $h)) {
            throw new ss['b'](
              'writer-merge-no-element-before: Node before merge position must be an element.',
              this
            );
          }
          if (!(i instanceof $h)) {
            throw new ss['b'](
              'writer-merge-no-element-after: Node after merge position must be an element.',
              this
            );
          }
          if (!e.root.document) {
            this._mergeDetached(e);
          } else {
            this._merge(e);
          }
        }
        createPositionFromPath(e, t, i) {
          return this.model.createPositionFromPath(e, t, i);
        }
        createPositionAt(e, t) {
          return this.model.createPositionAt(e, t);
        }
        createPositionAfter(e) {
          return this.model.createPositionAfter(e);
        }
        createPositionBefore(e) {
          return this.model.createPositionBefore(e);
        }
        createRange(e, t) {
          return this.model.createRange(e, t);
        }
        createRangeIn(e) {
          return this.model.createRangeIn(e);
        }
        createRangeOn(e) {
          return this.model.createRangeOn(e);
        }
        createSelection(e, t, i) {
          return this.model.createSelection(e, t, i);
        }
        _mergeDetached(e) {
          const t = e.nodeBefore;
          const i = e.nodeAfter;
          this.move(ef._createIn(i), Qh._createAt(t, 'end'));
          this.remove(i);
        }
        _merge(e) {
          const t = Qh._createAt(e.nodeBefore, 'end');
          const i = Qh._createAt(e.nodeAfter, 0);
          const n = e.root.document.graveyard;
          const o = new Qh(n, [0]);
          const r = e.root.document.version;
          const s = new Am(i, e.nodeAfter.maxOffset, t, o, r);
          this.batch.addOperation(s);
          this.model.applyOperation(s);
        }
        rename(e, t) {
          this._assertWriterUsedCorrectly();
          if (!(e instanceof $h)) {
            throw new ss['b'](
              'writer-rename-not-element-instance: Trying to rename an object which is not an instance of Element.',
              this
            );
          }
          const i = e.root.document ? e.root.document.version : null;
          const n = new ym(Qh._createBefore(e), e.name, t, i);
          this.batch.addOperation(n);
          this.model.applyOperation(n);
        }
        split(e, t) {
          this._assertWriterUsedCorrectly();
          let i = e.parent;
          if (!i.parent) {
            throw new ss['b'](
              'writer-split-element-no-parent: Element with no parent can not be split.',
              this
            );
          }
          if (!t) {
            t = i.parent;
          }
          if (!e.parent.getAncestors({ includeSelf: true }).includes(t)) {
            throw new ss['b'](
              'writer-split-invalid-limit-element: Limit element is not a position ancestor.',
              this
            );
          }
          let n, o;
          do {
            const t = i.root.document ? i.root.document.version : null;
            const r = i.maxOffset - e.offset;
            const s = new Tm(e, r, null, t);
            this.batch.addOperation(s);
            this.model.applyOperation(s);
            if (!n && !o) {
              n = i;
              o = e.parent.nextSibling;
            }
            e = this.createPositionAfter(e.parent);
            i = e.parent;
          } while (i !== t);
          return {
            position: e,
            range: new ef(Qh._createAt(n, 'end'), Qh._createAt(o, 0)),
          };
        }
        wrap(e, t) {
          this._assertWriterUsedCorrectly();
          if (!e.isFlat) {
            throw new ss['b'](
              'writer-wrap-range-not-flat: Range to wrap is not flat.',
              this
            );
          }
          const i = t instanceof $h ? t : new $h(t);
          if (i.childCount > 0) {
            throw new ss['b'](
              'writer-wrap-element-not-empty: Element to wrap with is not empty.',
              this
            );
          }
          if (i.parent !== null) {
            throw new ss['b'](
              'writer-wrap-element-attached: Element to wrap with is already attached to tree model.',
              this
            );
          }
          this.insert(i, e.start);
          const n = new ef(e.start.getShiftedBy(1), e.end.getShiftedBy(1));
          this.move(n, Qh._createAt(i, 0));
        }
        unwrap(e) {
          this._assertWriterUsedCorrectly();
          if (e.parent === null) {
            throw new ss['b'](
              'writer-unwrap-element-no-parent: Trying to unwrap an element which has no parent.',
              this
            );
          }
          this.move(ef._createIn(e), this.createPositionAfter(e));
          this.remove(e);
        }
        addMarker(e, t) {
          this._assertWriterUsedCorrectly();
          if (!t || typeof t.usingOperation != 'boolean') {
            throw new ss['b'](
              'writer-addMarker-no-usingOperation: The options.usingOperation parameter is required when adding a new marker.',
              this
            );
          }
          const i = t.usingOperation;
          const n = t.range;
          const o = t.affectsData === undefined ? false : t.affectsData;
          if (this.model.markers.has(e)) {
            throw new ss['b'](
              'writer-addMarker-marker-exists: Marker with provided name already exists.',
              this
            );
          }
          if (!n) {
            throw new ss['b'](
              'writer-addMarker-no-range: Range parameter is required when adding a new marker.',
              this
            );
          }
          if (!i) {
            return this.model.markers._set(e, n, i, o);
          }
          Mm(this, e, null, n, o);
          return this.model.markers.get(e);
        }
        updateMarker(e, t) {
          this._assertWriterUsedCorrectly();
          const i = typeof e == 'string' ? e : e.name;
          const n = this.model.markers.get(i);
          if (!n) {
            throw new ss['b'](
              'writer-updateMarker-marker-not-exists: Marker with provided name does not exists.',
              this
            );
          }
          if (!t) {
            this.model.markers._refresh(n);
            return;
          }
          const o = typeof t.usingOperation == 'boolean';
          const r = typeof t.affectsData == 'boolean';
          const s = r ? t.affectsData : n.affectsData;
          if (!o && !t.range && !r) {
            throw new ss['b'](
              'writer-updateMarker-wrong-options: One of the options is required - provide range, usingOperations or affectsData.',
              this
            );
          }
          const a = n.getRange();
          const c = t.range ? t.range : a;
          if (o && t.usingOperation !== n.managedUsingOperations) {
            if (t.usingOperation) {
              Mm(this, i, null, c, s);
            } else {
              Mm(this, i, a, null, s);
              this.model.markers._set(i, c, undefined, s);
            }
            return;
          }
          if (n.managedUsingOperations) {
            Mm(this, i, a, c, s);
          } else {
            this.model.markers._set(i, c, undefined, s);
          }
        }
        removeMarker(e) {
          this._assertWriterUsedCorrectly();
          const t = typeof e == 'string' ? e : e.name;
          if (!this.model.markers.has(t)) {
            throw new ss['b'](
              'writer-removeMarker-no-marker: Trying to remove marker which does not exist.',
              this
            );
          }
          const i = this.model.markers.get(t);
          if (!i.managedUsingOperations) {
            this.model.markers._remove(t);
            return;
          }
          const n = i.getRange();
          Mm(this, t, n, null, i.affectsData);
        }
        setSelection(e, t, i) {
          this._assertWriterUsedCorrectly();
          this.model.document.selection._setTo(e, t, i);
        }
        setSelectionFocus(e, t) {
          this._assertWriterUsedCorrectly();
          this.model.document.selection._setFocus(e, t);
        }
        setSelectionAttribute(e, t) {
          this._assertWriterUsedCorrectly();
          if (typeof e === 'string') {
            this._setSelectionAttribute(e, t);
          } else {
            for (const [t, i] of Us(e)) {
              this._setSelectionAttribute(t, i);
            }
          }
        }
        removeSelectionAttribute(e) {
          this._assertWriterUsedCorrectly();
          if (typeof e === 'string') {
            this._removeSelectionAttribute(e);
          } else {
            for (const t of e) {
              this._removeSelectionAttribute(t);
            }
          }
        }
        overrideSelectionGravity() {
          return this.model.document.selection._overrideGravity();
        }
        restoreSelectionGravity(e) {
          this.model.document.selection._restoreGravity(e);
        }
        _setSelectionAttribute(e, t) {
          const i = this.model.document.selection;
          if (i.isCollapsed && i.anchor.parent.isEmpty) {
            const n = wf._getStoreAttributeKey(e);
            this.setAttribute(n, t, i.anchor.parent);
          }
          i._setAttribute(e, t);
        }
        _removeSelectionAttribute(e) {
          const t = this.model.document.selection;
          if (t.isCollapsed && t.anchor.parent.isEmpty) {
            const i = wf._getStoreAttributeKey(e);
            this.removeAttribute(i, t.anchor.parent);
          }
          t._removeAttribute(e);
        }
        _assertWriterUsedCorrectly() {
          if (this.model._currentWriter !== this) {
            throw new ss['b'](
              'writer-incorrect-use: Trying to use a writer outside the change() block.',
              this
            );
          }
        }
        _addOperationForAffectedMarkers(e, t) {
          for (const i of this.model.markers) {
            if (!i.managedUsingOperations) {
              continue;
            }
            const n = i.getRange();
            let o = false;
            if (e === 'move') {
              o =
                t.containsPosition(n.start) ||
                t.start.isEqual(n.start) ||
                t.containsPosition(n.end) ||
                t.end.isEqual(n.end);
            } else {
              const e = t.nodeBefore;
              const i = t.nodeAfter;
              const r = n.start.parent == e && n.start.isAtEnd;
              const s = n.end.parent == i && n.end.offset == 0;
              const a = n.end.nodeAfter == i;
              const c = n.start.nodeAfter == i;
              o = r || s || a || c;
            }
            if (o) {
              this.updateMarker(i.name, { range: n });
            }
          }
        }
      }
      function Em(e, t, i, n) {
        const o = e.model;
        const r = o.document;
        let s = n.start;
        let a;
        let c;
        let l;
        for (const e of n.getWalker({ shallow: true })) {
          l = e.item.getAttribute(t);
          if (a && c != l) {
            if (c != i) {
              d();
            }
            s = a;
          }
          a = e.nextPosition;
          c = l;
        }
        if (a instanceof Qh && a != s && c != i) {
          d();
        }
        function d() {
          const n = new ef(s, a);
          const l = n.root.document ? r.version : null;
          const d = new bm(n, t, c, i, l);
          e.batch.addOperation(d);
          o.applyOperation(d);
        }
      }
      function Sm(e, t, i, n) {
        const o = e.model;
        const r = o.document;
        const s = n.getAttribute(t);
        let a, c;
        if (s != i) {
          const l = n.root === n;
          if (l) {
            const e = n.document ? r.version : null;
            c = new xm(n, t, s, i, e);
          } else {
            a = new ef(Qh._createBefore(n), e.createPositionAfter(n));
            const o = a.root.document ? r.version : null;
            c = new bm(a, t, s, i, o);
          }
          e.batch.addOperation(c);
          o.applyOperation(c);
        }
      }
      function Mm(e, t, i, n, o) {
        const r = e.model;
        const s = r.document;
        const a = new vm(t, i, n, r.markers, o, s.version);
        e.batch.addOperation(a);
        r.applyOperation(a);
      }
      function Im(e, t, i, n) {
        let o;
        if (e.root.document) {
          const i = n.document;
          const r = new Qh(i.graveyard, [0]);
          o = new km(e, t, r, i.version);
        } else {
          o = new wm(e, t);
        }
        i.addOperation(o);
        n.applyOperation(o);
      }
      function Nm(e, t) {
        if (e === t) {
          return true;
        }
        if (e instanceof Cm && t instanceof Cm) {
          return true;
        }
        return false;
      }
      class Om {
        constructor(e) {
          this._markerCollection = e;
          this._changesInElement = new Map();
          this._elementSnapshots = new Map();
          this._changedMarkers = new Map();
          this._changeCount = 0;
          this._cachedChanges = null;
          this._cachedChangesWithGraveyard = null;
        }
        get isEmpty() {
          return (
            this._changesInElement.size == 0 && this._changedMarkers.size == 0
          );
        }
        refreshItem(e) {
          if (this._isInInsertedElement(e.parent)) {
            return;
          }
          this._markRemove(e.parent, e.startOffset, e.offsetSize);
          this._markInsert(e.parent, e.startOffset, e.offsetSize);
          const t = ef._createOn(e);
          for (const e of this._markerCollection.getMarkersIntersectingRange(
            t
          )) {
            const t = e.getRange();
            this.bufferMarkerChange(e.name, t, t, e.affectsData);
          }
          this._cachedChanges = null;
        }
        bufferOperation(e) {
          switch (e.type) {
            case 'insert': {
              if (this._isInInsertedElement(e.position.parent)) {
                return;
              }
              this._markInsert(
                e.position.parent,
                e.position.offset,
                e.nodes.maxOffset
              );
              break;
            }
            case 'addAttribute':
            case 'removeAttribute':
            case 'changeAttribute': {
              for (const t of e.range.getItems({ shallow: true })) {
                if (this._isInInsertedElement(t.parent)) {
                  continue;
                }
                this._markAttribute(t);
              }
              break;
            }
            case 'remove':
            case 'move':
            case 'reinsert': {
              if (
                e.sourcePosition.isEqual(e.targetPosition) ||
                e.sourcePosition
                  .getShiftedBy(e.howMany)
                  .isEqual(e.targetPosition)
              ) {
                return;
              }
              const t = this._isInInsertedElement(e.sourcePosition.parent);
              const i = this._isInInsertedElement(e.targetPosition.parent);
              if (!t) {
                this._markRemove(
                  e.sourcePosition.parent,
                  e.sourcePosition.offset,
                  e.howMany
                );
              }
              if (!i) {
                this._markInsert(
                  e.targetPosition.parent,
                  e.getMovedRangeStart().offset,
                  e.howMany
                );
              }
              break;
            }
            case 'rename': {
              if (this._isInInsertedElement(e.position.parent)) {
                return;
              }
              this._markRemove(e.position.parent, e.position.offset, 1);
              this._markInsert(e.position.parent, e.position.offset, 1);
              const t = ef._createFromPositionAndShift(e.position, 1);
              for (const e of this._markerCollection.getMarkersIntersectingRange(
                t
              )) {
                const t = e.getRange();
                this.bufferMarkerChange(e.name, t, t, e.affectsData);
              }
              break;
            }
            case 'split': {
              const t = e.splitPosition.parent;
              if (!this._isInInsertedElement(t)) {
                this._markRemove(t, e.splitPosition.offset, e.howMany);
              }
              if (!this._isInInsertedElement(e.insertionPosition.parent)) {
                this._markInsert(
                  e.insertionPosition.parent,
                  e.insertionPosition.offset,
                  1
                );
              }
              if (e.graveyardPosition) {
                this._markRemove(
                  e.graveyardPosition.parent,
                  e.graveyardPosition.offset,
                  1
                );
              }
              break;
            }
            case 'merge': {
              const t = e.sourcePosition.parent;
              if (!this._isInInsertedElement(t.parent)) {
                this._markRemove(t.parent, t.startOffset, 1);
              }
              const i = e.graveyardPosition.parent;
              this._markInsert(i, e.graveyardPosition.offset, 1);
              const n = e.targetPosition.parent;
              if (!this._isInInsertedElement(n)) {
                this._markInsert(n, e.targetPosition.offset, t.maxOffset);
              }
              break;
            }
          }
          this._cachedChanges = null;
        }
        bufferMarkerChange(e, t, i, n) {
          const o = this._changedMarkers.get(e);
          if (!o) {
            this._changedMarkers.set(e, {
              oldRange: t,
              newRange: i,
              affectsData: n,
            });
          } else {
            o.newRange = i;
            o.affectsData = n;
            if (o.oldRange == null && o.newRange == null) {
              this._changedMarkers.delete(e);
            }
          }
        }
        getMarkersToRemove() {
          const e = [];
          for (const [t, i] of this._changedMarkers) {
            if (i.oldRange != null) {
              e.push({ name: t, range: i.oldRange });
            }
          }
          return e;
        }
        getMarkersToAdd() {
          const e = [];
          for (const [t, i] of this._changedMarkers) {
            if (i.newRange != null) {
              e.push({ name: t, range: i.newRange });
            }
          }
          return e;
        }
        getChangedMarkers() {
          return Array.from(this._changedMarkers).map((e) => ({
            name: e[0],
            data: { oldRange: e[1].oldRange, newRange: e[1].newRange },
          }));
        }
        hasDataChanges() {
          for (const [, e] of this._changedMarkers) {
            if (e.affectsData) {
              return true;
            }
          }
          return this._changesInElement.size > 0;
        }
        getChanges(e = { includeChangesInGraveyard: false }) {
          if (this._cachedChanges) {
            if (e.includeChangesInGraveyard) {
              return this._cachedChangesWithGraveyard.slice();
            } else {
              return this._cachedChanges.slice();
            }
          }
          const t = [];
          for (const e of this._changesInElement.keys()) {
            const i = this._changesInElement.get(e).sort((e, t) => {
              if (e.offset === t.offset) {
                if (e.type != t.type) {
                  return e.type == 'remove' ? -1 : 1;
                }
                return 0;
              }
              return e.offset < t.offset ? -1 : 1;
            });
            const n = this._elementSnapshots.get(e);
            const o = zm(e.getChildren());
            const r = Rm(n.length, i);
            let s = 0;
            let a = 0;
            for (const i of r) {
              if (i === 'i') {
                t.push(this._getInsertDiff(e, s, o[s].name));
                s++;
              } else if (i === 'r') {
                t.push(this._getRemoveDiff(e, s, n[a].name));
                a++;
              } else if (i === 'a') {
                const i = o[s].attributes;
                const r = n[a].attributes;
                let c;
                if (o[s].name == '$text') {
                  c = new ef(Qh._createAt(e, s), Qh._createAt(e, s + 1));
                } else {
                  const t = e.offsetToIndex(s);
                  c = new ef(
                    Qh._createAt(e, s),
                    Qh._createAt(e.getChild(t), 0)
                  );
                }
                t.push(...this._getAttributesDiff(c, r, i));
                s++;
                a++;
              } else {
                s++;
                a++;
              }
            }
          }
          t.sort((e, t) => {
            if (e.position.root != t.position.root) {
              return e.position.root.rootName < t.position.root.rootName
                ? -1
                : 1;
            }
            if (e.position.isEqual(t.position)) {
              return e.changeCount - t.changeCount;
            }
            return e.position.isBefore(t.position) ? -1 : 1;
          });
          for (let e = 1; e < t.length; e++) {
            const i = t[e - 1];
            const n = t[e];
            const o =
              i.type == 'remove' &&
              n.type == 'remove' &&
              i.name == '$text' &&
              n.name == '$text' &&
              i.position.isEqual(n.position);
            const r =
              i.type == 'insert' &&
              n.type == 'insert' &&
              i.name == '$text' &&
              n.name == '$text' &&
              i.position.parent == n.position.parent &&
              i.position.offset + i.length == n.position.offset;
            const s =
              i.type == 'attribute' &&
              n.type == 'attribute' &&
              i.position.parent == n.position.parent &&
              i.range.isFlat &&
              n.range.isFlat &&
              i.position.offset + i.length == n.position.offset &&
              i.attributeKey == n.attributeKey &&
              i.attributeOldValue == n.attributeOldValue &&
              i.attributeNewValue == n.attributeNewValue;
            if (o || r || s) {
              t[e - 1].length++;
              if (s) {
                t[e - 1].range.end = t[e - 1].range.end.getShiftedBy(1);
              }
              t.splice(e, 1);
              e--;
            }
          }
          for (const e of t) {
            delete e.changeCount;
            if (e.type == 'attribute') {
              delete e.position;
              delete e.length;
            }
          }
          this._changeCount = 0;
          this._cachedChangesWithGraveyard = t.slice();
          this._cachedChanges = t.slice().filter(Lm);
          if (e.includeChangesInGraveyard) {
            return this._cachedChangesWithGraveyard;
          } else {
            return this._cachedChanges;
          }
        }
        reset() {
          this._changesInElement.clear();
          this._elementSnapshots.clear();
          this._changedMarkers.clear();
          this._cachedChanges = null;
        }
        _markInsert(e, t, i) {
          const n = {
            type: 'insert',
            offset: t,
            howMany: i,
            count: this._changeCount++,
          };
          this._markChange(e, n);
        }
        _markRemove(e, t, i) {
          const n = {
            type: 'remove',
            offset: t,
            howMany: i,
            count: this._changeCount++,
          };
          this._markChange(e, n);
          this._removeAllNestedChanges(e, t, i);
        }
        _markAttribute(e) {
          const t = {
            type: 'attribute',
            offset: e.startOffset,
            howMany: e.offsetSize,
            count: this._changeCount++,
          };
          this._markChange(e.parent, t);
        }
        _markChange(e, t) {
          this._makeSnapshot(e);
          const i = this._getChangesForElement(e);
          this._handleChange(t, i);
          i.push(t);
          for (let e = 0; e < i.length; e++) {
            if (i[e].howMany < 1) {
              i.splice(e, 1);
              e--;
            }
          }
        }
        _getChangesForElement(e) {
          let t;
          if (this._changesInElement.has(e)) {
            t = this._changesInElement.get(e);
          } else {
            t = [];
            this._changesInElement.set(e, t);
          }
          return t;
        }
        _makeSnapshot(e) {
          if (!this._elementSnapshots.has(e)) {
            this._elementSnapshots.set(e, zm(e.getChildren()));
          }
        }
        _handleChange(e, t) {
          e.nodesToHandle = e.howMany;
          for (const i of t) {
            const n = e.offset + e.howMany;
            const o = i.offset + i.howMany;
            if (e.type == 'insert') {
              if (i.type == 'insert') {
                if (e.offset <= i.offset) {
                  i.offset += e.howMany;
                } else if (e.offset < o) {
                  i.howMany += e.nodesToHandle;
                  e.nodesToHandle = 0;
                }
              }
              if (i.type == 'remove') {
                if (e.offset < i.offset) {
                  i.offset += e.howMany;
                }
              }
              if (i.type == 'attribute') {
                if (e.offset <= i.offset) {
                  i.offset += e.howMany;
                } else if (e.offset < o) {
                  const o = i.howMany;
                  i.howMany = e.offset - i.offset;
                  t.unshift({
                    type: 'attribute',
                    offset: n,
                    howMany: o - i.howMany,
                    count: this._changeCount++,
                  });
                }
              }
            }
            if (e.type == 'remove') {
              if (i.type == 'insert') {
                if (n <= i.offset) {
                  i.offset -= e.howMany;
                } else if (n <= o) {
                  if (e.offset < i.offset) {
                    const t = n - i.offset;
                    i.offset = e.offset;
                    i.howMany -= t;
                    e.nodesToHandle -= t;
                  } else {
                    i.howMany -= e.nodesToHandle;
                    e.nodesToHandle = 0;
                  }
                } else {
                  if (e.offset <= i.offset) {
                    e.nodesToHandle -= i.howMany;
                    i.howMany = 0;
                  } else if (e.offset < o) {
                    const t = o - e.offset;
                    i.howMany -= t;
                    e.nodesToHandle -= t;
                  }
                }
              }
              if (i.type == 'remove') {
                if (n <= i.offset) {
                  i.offset -= e.howMany;
                } else if (e.offset < i.offset) {
                  e.nodesToHandle += i.howMany;
                  i.howMany = 0;
                }
              }
              if (i.type == 'attribute') {
                if (n <= i.offset) {
                  i.offset -= e.howMany;
                } else if (e.offset < i.offset) {
                  const t = n - i.offset;
                  i.offset = e.offset;
                  i.howMany -= t;
                } else if (e.offset < o) {
                  if (n <= o) {
                    const n = i.howMany;
                    i.howMany = e.offset - i.offset;
                    const o = n - i.howMany - e.nodesToHandle;
                    t.unshift({
                      type: 'attribute',
                      offset: e.offset,
                      howMany: o,
                      count: this._changeCount++,
                    });
                  } else {
                    i.howMany -= o - e.offset;
                  }
                }
              }
            }
            if (e.type == 'attribute') {
              if (i.type == 'insert') {
                if (e.offset < i.offset && n > i.offset) {
                  if (n > o) {
                    const e = {
                      type: 'attribute',
                      offset: o,
                      howMany: n - o,
                      count: this._changeCount++,
                    };
                    this._handleChange(e, t);
                    t.push(e);
                  }
                  e.nodesToHandle = i.offset - e.offset;
                  e.howMany = e.nodesToHandle;
                } else if (e.offset >= i.offset && e.offset < o) {
                  if (n > o) {
                    e.nodesToHandle = n - o;
                    e.offset = o;
                  } else {
                    e.nodesToHandle = 0;
                  }
                }
              }
              if (i.type == 'remove') {
                if (e.offset < i.offset && n > i.offset) {
                  const o = {
                    type: 'attribute',
                    offset: i.offset,
                    howMany: n - i.offset,
                    count: this._changeCount++,
                  };
                  this._handleChange(o, t);
                  t.push(o);
                  e.nodesToHandle = i.offset - e.offset;
                  e.howMany = e.nodesToHandle;
                }
              }
              if (i.type == 'attribute') {
                if (e.offset >= i.offset && n <= o) {
                  e.nodesToHandle = 0;
                  e.howMany = 0;
                  e.offset = 0;
                } else if (e.offset <= i.offset && n >= o) {
                  i.howMany = 0;
                }
              }
            }
          }
          e.howMany = e.nodesToHandle;
          delete e.nodesToHandle;
        }
        _getInsertDiff(e, t, i) {
          return {
            type: 'insert',
            position: Qh._createAt(e, t),
            name: i,
            length: 1,
            changeCount: this._changeCount++,
          };
        }
        _getRemoveDiff(e, t, i) {
          return {
            type: 'remove',
            position: Qh._createAt(e, t),
            name: i,
            length: 1,
            changeCount: this._changeCount++,
          };
        }
        _getAttributesDiff(e, t, i) {
          const n = [];
          i = new Map(i);
          for (const [o, r] of t) {
            const t = i.has(o) ? i.get(o) : null;
            if (t !== r) {
              n.push({
                type: 'attribute',
                position: e.start,
                range: e.clone(),
                length: 1,
                attributeKey: o,
                attributeOldValue: r,
                attributeNewValue: t,
                changeCount: this._changeCount++,
              });
            }
            i.delete(o);
          }
          for (const [t, o] of i) {
            n.push({
              type: 'attribute',
              position: e.start,
              range: e.clone(),
              length: 1,
              attributeKey: t,
              attributeOldValue: null,
              attributeNewValue: o,
              changeCount: this._changeCount++,
            });
          }
          return n;
        }
        _isInInsertedElement(e) {
          const t = e.parent;
          if (!t) {
            return false;
          }
          const i = this._changesInElement.get(t);
          const n = e.startOffset;
          if (i) {
            for (const e of i) {
              if (
                e.type == 'insert' &&
                n >= e.offset &&
                n < e.offset + e.howMany
              ) {
                return true;
              }
            }
          }
          return this._isInInsertedElement(t);
        }
        _removeAllNestedChanges(e, t, i) {
          const n = new ef(Qh._createAt(e, t), Qh._createAt(e, t + i));
          for (const e of n.getItems({ shallow: true })) {
            if (e.is('element')) {
              this._elementSnapshots.delete(e);
              this._changesInElement.delete(e);
              this._removeAllNestedChanges(e, 0, e.maxOffset);
            }
          }
        }
      }
      function zm(e) {
        const t = [];
        for (const i of e) {
          if (i.is('$text')) {
            for (let e = 0; e < i.data.length; e++) {
              t.push({ name: '$text', attributes: new Map(i.getAttributes()) });
            }
          } else {
            t.push({ name: i.name, attributes: new Map(i.getAttributes()) });
          }
        }
        return t;
      }
      function Rm(e, t) {
        const i = [];
        let n = 0;
        let o = 0;
        for (const e of t) {
          if (e.offset > n) {
            for (let t = 0; t < e.offset - n; t++) {
              i.push('e');
            }
            o += e.offset - n;
          }
          if (e.type == 'insert') {
            for (let t = 0; t < e.howMany; t++) {
              i.push('i');
            }
            n = e.offset + e.howMany;
          } else if (e.type == 'remove') {
            for (let t = 0; t < e.howMany; t++) {
              i.push('r');
            }
            n = e.offset;
            o += e.howMany;
          } else {
            i.push(...'a'.repeat(e.howMany).split(''));
            n = e.offset + e.howMany;
            o += e.howMany;
          }
        }
        if (o < e) {
          for (let t = 0; t < e - o - n; t++) {
            i.push('e');
          }
        }
        return i;
      }
      function Lm(e) {
        const t = e.position && e.position.root.rootName == '$graveyard';
        const i = e.range && e.range.root.rootName == '$graveyard';
        return !t && !i;
      }
      class Vm {
        constructor() {
          this._operations = [];
          this._undoPairs = new Map();
          this._undoneOperations = new Set();
        }
        addOperation(e) {
          if (this._operations.includes(e)) {
            return;
          }
          this._operations.push(e);
        }
        getOperations(e = 0, t = Number.POSITIVE_INFINITY) {
          if (e < 0) {
            return [];
          }
          return this._operations.slice(e, t);
        }
        getOperation(e) {
          return this._operations[e];
        }
        setOperationAsUndone(e, t) {
          this._undoPairs.set(t, e);
          this._undoneOperations.add(e);
        }
        isUndoingOperation(e) {
          return this._undoPairs.has(e);
        }
        isUndoneOperation(e) {
          return this._undoneOperations.has(e);
        }
        getUndoneOperation(e) {
          return this._undoPairs.get(e);
        }
      }
      function Dm(e) {
        return (
          !!e &&
          e.length == 1 &&
          /[\u0300-\u036f\u1ab0-\u1aff\u1dc0-\u1dff\u20d0-\u20ff\ufe20-\ufe2f]/.test(
            e
          )
        );
      }
      function jm(e) {
        return !!e && e.length == 1 && /[\ud800-\udbff]/.test(e);
      }
      function Bm(e) {
        return !!e && e.length == 1 && /[\udc00-\udfff]/.test(e);
      }
      function Fm(e, t) {
        return jm(e.charAt(t - 1)) && Bm(e.charAt(t));
      }
      function Hm(e, t) {
        return Dm(e.charAt(t));
      }
      const Um = '$graveyard';
      class qm {
        constructor(e) {
          this.model = e;
          this.version = 0;
          this.history = new Vm(this);
          this.selection = new wf(this);
          this.roots = new xs({ idProperty: 'rootName' });
          this.differ = new Om(e.markers);
          this._postFixers = new Set();
          this._hasSelectionChangedFromTheLastChangeBlock = false;
          this.createRoot('$root', Um);
          this.listenTo(
            e,
            'applyOperation',
            (e, t) => {
              const i = t[0];
              if (i.isDocumentOperation && i.baseVersion !== this.version) {
                throw new ss['b'](
                  'model-document-applyOperation-wrong-version: Only operations with matching versions can be applied.',
                  this,
                  { operation: i }
                );
              }
            },
            { priority: 'highest' }
          );
          this.listenTo(
            e,
            'applyOperation',
            (e, t) => {
              const i = t[0];
              if (i.isDocumentOperation) {
                this.differ.bufferOperation(i);
              }
            },
            { priority: 'high' }
          );
          this.listenTo(
            e,
            'applyOperation',
            (e, t) => {
              const i = t[0];
              if (i.isDocumentOperation) {
                this.version++;
                this.history.addOperation(i);
              }
            },
            { priority: 'low' }
          );
          this.listenTo(this.selection, 'change', () => {
            this._hasSelectionChangedFromTheLastChangeBlock = true;
          });
          this.listenTo(e.markers, 'update', (e, t, i, n) => {
            this.differ.bufferMarkerChange(t.name, i, n, t.affectsData);
            if (i === null) {
              t.on('change', (e, i) => {
                this.differ.bufferMarkerChange(
                  t.name,
                  i,
                  t.getRange(),
                  t.affectsData
                );
              });
            }
          });
        }
        get graveyard() {
          return this.getRoot(Um);
        }
        createRoot(e = '$root', t = 'main') {
          if (this.roots.get(t)) {
            throw new ss['b'](
              'model-document-createRoot-name-exists: Root with specified name already exists.',
              this,
              { name: t }
            );
          }
          const i = new Cm(this, e, t);
          this.roots.add(i);
          return i;
        }
        destroy() {
          this.selection.destroy();
          this.stopListening();
        }
        getRoot(e = 'main') {
          return this.roots.get(e);
        }
        getRootNames() {
          return Array.from(this.roots, (e) => e.rootName).filter(
            (e) => e != Um
          );
        }
        registerPostFixer(e) {
          this._postFixers.add(e);
        }
        toJSON() {
          const e = Ds(this);
          e.selection = '[engine.model.DocumentSelection]';
          e.model = '[engine.model.Model]';
          return e;
        }
        _handleChangeBlock(e) {
          if (this._hasDocumentChangedFromTheLastChangeBlock()) {
            this._callPostFixers(e);
            this.selection.refresh();
            if (this.differ.hasDataChanges()) {
              this.fire('change:data', e.batch);
            } else {
              this.fire('change', e.batch);
            }
            this.selection.refresh();
            this.differ.reset();
          }
          this._hasSelectionChangedFromTheLastChangeBlock = false;
        }
        _hasDocumentChangedFromTheLastChangeBlock() {
          return (
            !this.differ.isEmpty ||
            this._hasSelectionChangedFromTheLastChangeBlock
          );
        }
        _getDefaultRoot() {
          for (const e of this.roots) {
            if (e !== this.graveyard) {
              return e;
            }
          }
          return this.graveyard;
        }
        _getDefaultRange() {
          const e = this._getDefaultRoot();
          const t = this.model;
          const i = t.schema;
          const n = t.createPositionFromPath(e, [0]);
          const o = i.getNearestSelectionRange(n);
          return o || t.createRange(n);
        }
        _validateSelectionRange(e) {
          return Wm(e.start) && Wm(e.end);
        }
        _callPostFixers(e) {
          let t = false;
          do {
            for (const i of this._postFixers) {
              this.selection.refresh();
              t = i(e);
              if (t) {
                break;
              }
            }
          } while (t);
        }
      }
      ys(qm, ds);
      function Wm(e) {
        const t = e.textNode;
        if (t) {
          const i = t.data;
          const n = e.offset - t.startOffset;
          return !Fm(i, n) && !Hm(i, n);
        }
        return true;
      }
      class $m {
        constructor() {
          this._markers = new Map();
        }
        [Symbol.iterator]() {
          return this._markers.values();
        }
        has(e) {
          return this._markers.has(e);
        }
        get(e) {
          return this._markers.get(e) || null;
        }
        _set(e, t, i = false, n = false) {
          const o = e instanceof Gm ? e.name : e;
          if (o.includes(',')) {
            throw new ss['b'](
              'markercollection-incorrect-marker-name: Marker name cannot contain the "," character.',
              this
            );
          }
          const r = this._markers.get(o);
          if (r) {
            const e = r.getRange();
            let s = false;
            if (!e.isEqual(t)) {
              r._attachLiveRange(ff.fromRange(t));
              s = true;
            }
            if (i != r.managedUsingOperations) {
              r._managedUsingOperations = i;
              s = true;
            }
            if (typeof n === 'boolean' && n != r.affectsData) {
              r._affectsData = n;
              s = true;
            }
            if (s) {
              this.fire('update:' + o, r, e, t);
            }
            return r;
          }
          const s = ff.fromRange(t);
          const a = new Gm(o, s, i, n);
          this._markers.set(o, a);
          this.fire('update:' + o, a, null, t);
          return a;
        }
        _remove(e) {
          const t = e instanceof Gm ? e.name : e;
          const i = this._markers.get(t);
          if (i) {
            this._markers.delete(t);
            this.fire('update:' + t, i, i.getRange(), null);
            this._destroyMarker(i);
            return true;
          }
          return false;
        }
        _refresh(e) {
          const t = e instanceof Gm ? e.name : e;
          const i = this._markers.get(t);
          if (!i) {
            throw new ss['b'](
              'markercollection-refresh-marker-not-exists: Marker with provided name does not exists.',
              this
            );
          }
          const n = i.getRange();
          this.fire(
            'update:' + t,
            i,
            n,
            n,
            i.managedUsingOperations,
            i.affectsData
          );
        }
        *getMarkersAtPosition(e) {
          for (const t of this) {
            if (t.getRange().containsPosition(e)) {
              yield t;
            }
          }
        }
        *getMarkersIntersectingRange(e) {
          for (const t of this) {
            if (t.getRange().getIntersection(e) !== null) {
              yield t;
            }
          }
        }
        destroy() {
          for (const e of this._markers.values()) {
            this._destroyMarker(e);
          }
          this._markers = null;
          this.stopListening();
        }
        *getMarkersGroup(e) {
          for (const t of this._markers.values()) {
            if (t.name.startsWith(e + ':')) {
              yield t;
            }
          }
        }
        _destroyMarker(e) {
          e.stopListening();
          e._detachLiveRange();
        }
      }
      ys($m, ds);
      class Gm {
        constructor(e, t, i, n) {
          this.name = e;
          this._liveRange = this._attachLiveRange(t);
          this._managedUsingOperations = i;
          this._affectsData = n;
        }
        get managedUsingOperations() {
          if (!this._liveRange) {
            throw new ss['b'](
              'marker-destroyed: Cannot use a destroyed marker instance.',
              this
            );
          }
          return this._managedUsingOperations;
        }
        get affectsData() {
          if (!this._liveRange) {
            throw new ss['b'](
              'marker-destroyed: Cannot use a destroyed marker instance.',
              this
            );
          }
          return this._affectsData;
        }
        getStart() {
          if (!this._liveRange) {
            throw new ss['b'](
              'marker-destroyed: Cannot use a destroyed marker instance.',
              this
            );
          }
          return this._liveRange.start.clone();
        }
        getEnd() {
          if (!this._liveRange) {
            throw new ss['b'](
              'marker-destroyed: Cannot use a destroyed marker instance.',
              this
            );
          }
          return this._liveRange.end.clone();
        }
        getRange() {
          if (!this._liveRange) {
            throw new ss['b'](
              'marker-destroyed: Cannot use a destroyed marker instance.',
              this
            );
          }
          return this._liveRange.toRange();
        }
        is(e) {
          return e === 'marker' || e === 'model:marker';
        }
        _attachLiveRange(e) {
          if (this._liveRange) {
            this._detachLiveRange();
          }
          e.delegate('change:range').to(this);
          e.delegate('change:content').to(this);
          this._liveRange = e;
          return e;
        }
        _detachLiveRange() {
          this._liveRange.stopDelegating('change:range', this);
          this._liveRange.stopDelegating('change:content', this);
          this._liveRange.detach();
          this._liveRange = null;
        }
      }
      ys(Gm, ds);
      class Ym extends om {
        get type() {
          return 'noop';
        }
        clone() {
          return new Ym(this.baseVersion);
        }
        getReversed() {
          return new Ym(this.baseVersion + 1);
        }
        _execute() {}
        static get className() {
          return 'NoOperation';
        }
      }
      const Km = {};
      Km[bm.className] = bm;
      Km[_m.className] = _m;
      Km[vm.className] = vm;
      Km[km.className] = km;
      Km[Ym.className] = Ym;
      Km[om.className] = om;
      Km[ym.className] = ym;
      Km[xm.className] = xm;
      Km[Tm.className] = Tm;
      Km[Am.className] = Am;
      class Qm {
        static fromJSON(e, t) {
          return Km[e.__className].fromJSON(e, t);
        }
      }
      class Jm extends Qh {
        constructor(e, t, i = 'toNone') {
          super(e, t, i);
          if (!this.root.is('rootElement')) {
            throw new ss['b'](
              "model-liveposition-root-not-rootelement: LivePosition's root has to be an instance of RootElement.",
              e
            );
          }
          Zm.call(this);
        }
        detach() {
          this.stopListening();
        }
        is(e) {
          return (
            e === 'livePosition' ||
            e === 'model:livePosition' ||
            e == 'position' ||
            e === 'model:position'
          );
        }
        toPosition() {
          return new Qh(this.root, this.path.slice(), this.stickiness);
        }
        static fromPosition(e, t) {
          return new this(e.root, e.path.slice(), t ? t : e.stickiness);
        }
      }
      function Zm() {
        this.listenTo(
          this.root.document.model,
          'applyOperation',
          (e, t) => {
            const i = t[0];
            if (!i.isDocumentOperation) {
              return;
            }
            Xm.call(this, i);
          },
          { priority: 'low' }
        );
      }
      function Xm(e) {
        const t = this.getTransformedByOperation(e);
        if (!this.isEqual(t)) {
          const e = this.toPosition();
          this.path = t.path;
          this.root = t.root;
          this.fire('change', e);
        }
      }
      ys(Jm, ds);
      function ep(e, t, i, n) {
        return e.change((o) => {
          let r;
          if (!i) {
            r = e.document.selection;
          } else if (i instanceof af || i instanceof wf) {
            r = i;
          } else {
            r = o.createSelection(i, n);
          }
          if (!r.isCollapsed) {
            e.deleteContent(r, { doNotAutoparagraph: true });
          }
          const s = new tp(e, o, r.anchor);
          let a;
          if (t.is('documentFragment')) {
            a = t.getChildren();
          } else {
            a = [t];
          }
          s.handleNodes(a, { isFirst: true, isLast: true });
          const c = s.getSelectionRange();
          if (c) {
            if (r instanceof wf) {
              o.setSelection(c);
            } else {
              r.setTo(c);
            }
          } else {
          }
          const l = s.getAffectedRange() || e.createRange(r.anchor);
          s.destroy();
          return l;
        });
      }
      class tp {
        constructor(e, t, i) {
          this.model = e;
          this.writer = t;
          this.position = i;
          this.canMergeWith = new Set([this.position.parent]);
          this.schema = e.schema;
          this._filterAttributesOf = [];
          this._affectedStart = null;
          this._affectedEnd = null;
        }
        handleNodes(e, t) {
          e = Array.from(e);
          for (let i = 0; i < e.length; i++) {
            const n = e[i];
            this._handleNode(n, {
              isFirst: i === 0 && t.isFirst,
              isLast: i === e.length - 1 && t.isLast,
            });
          }
          this.schema.removeDisallowedAttributes(
            this._filterAttributesOf,
            this.writer
          );
          this._filterAttributesOf = [];
        }
        getSelectionRange() {
          if (this.nodeToSelect) {
            return ef._createOn(this.nodeToSelect);
          }
          return this.model.schema.getNearestSelectionRange(this.position);
        }
        getAffectedRange() {
          if (!this._affectedStart) {
            return null;
          }
          return new ef(this._affectedStart, this._affectedEnd);
        }
        destroy() {
          if (this._affectedStart) {
            this._affectedStart.detach();
          }
          if (this._affectedEnd) {
            this._affectedEnd.detach();
          }
        }
        _handleNode(e, t) {
          if (this.schema.isObject(e)) {
            this._handleObject(e, t);
            return;
          }
          const i = this._checkAndSplitToAllowedPosition(e, t);
          if (!i) {
            this._handleDisallowedNode(e, t);
            return;
          }
          this._insert(e);
          this._mergeSiblingsOf(e, t);
        }
        _handleObject(e, t) {
          if (this._checkAndSplitToAllowedPosition(e)) {
            this._insert(e);
          } else {
            this._tryAutoparagraphing(e, t);
          }
        }
        _handleDisallowedNode(e, t) {
          if (e.is('element')) {
            this.handleNodes(e.getChildren(), t);
          } else {
            this._tryAutoparagraphing(e, t);
          }
        }
        _insert(e) {
          if (!this.schema.checkChild(this.position, e)) {
            throw new ss['b'](
              'insertcontent-wrong-position: Given node cannot be inserted on the given position.',
              this,
              { node: e, position: this.position }
            );
          }
          const t = Jm.fromPosition(this.position, 'toNext');
          this._setAffectedBoundaries(this.position);
          this.writer.insert(e, this.position);
          this.position = t.toPosition();
          t.detach();
          if (
            this.schema.isObject(e) &&
            !this.schema.checkChild(this.position, '$text')
          ) {
            this.nodeToSelect = e;
          } else {
            this.nodeToSelect = null;
          }
          this._filterAttributesOf.push(e);
        }
        _setAffectedBoundaries(e) {
          if (!this._affectedStart) {
            this._affectedStart = Jm.fromPosition(e, 'toPrevious');
          }
          if (!this._affectedEnd || this._affectedEnd.isBefore(e)) {
            if (this._affectedEnd) {
              this._affectedEnd.detach();
            }
            this._affectedEnd = Jm.fromPosition(e, 'toNext');
          }
        }
        _mergeSiblingsOf(e, t) {
          if (!(e instanceof $h)) {
            return;
          }
          const i = this._canMergeLeft(e, t);
          const n = this._canMergeRight(e, t);
          const o = Jm._createBefore(e);
          o.stickiness = 'toNext';
          const r = Jm._createAfter(e);
          r.stickiness = 'toNext';
          if (i) {
            const e = Jm.fromPosition(this.position);
            e.stickiness = 'toNext';
            if (this._affectedStart.isEqual(o)) {
              this._affectedStart.detach();
              this._affectedStart = Jm._createAt(
                o.nodeBefore,
                'end',
                'toPrevious'
              );
            }
            this.writer.merge(o);
            if (o.isEqual(this._affectedEnd) && t.isLast) {
              this._affectedEnd.detach();
              this._affectedEnd = Jm._createAt(o.nodeBefore, 'end', 'toNext');
            }
            this.position = e.toPosition();
            e.detach();
          }
          if (n) {
            if (!this.position.isEqual(r)) {
              throw new ss['b'](
                'insertcontent-invalid-insertion-position: ' +
                  'An internal error occurred during insertContent().',
                this
              );
            }
            this.position = Qh._createAt(r.nodeBefore, 'end');
            const e = Jm.fromPosition(this.position, 'toPrevious');
            if (this._affectedEnd.isEqual(r)) {
              this._affectedEnd.detach();
              this._affectedEnd = Jm._createAt(r.nodeBefore, 'end', 'toNext');
            }
            this.writer.merge(r);
            if (r.getShiftedBy(-1).isEqual(this._affectedStart) && t.isFirst) {
              this._affectedStart.detach();
              this._affectedStart = Jm._createAt(r.nodeBefore, 0, 'toPrevious');
            }
            this.position = e.toPosition();
            e.detach();
          }
          if (i || n) {
            this._filterAttributesOf.push(this.position.parent);
          }
          o.detach();
          r.detach();
        }
        _canMergeLeft(e, t) {
          const i = e.previousSibling;
          return (
            t.isFirst &&
            i instanceof $h &&
            this.canMergeWith.has(i) &&
            this.model.schema.checkMerge(i, e)
          );
        }
        _canMergeRight(e, t) {
          const i = e.nextSibling;
          return (
            t.isLast &&
            i instanceof $h &&
            this.canMergeWith.has(i) &&
            this.model.schema.checkMerge(e, i)
          );
        }
        _tryAutoparagraphing(e, t) {
          const i = this.writer.createElement('paragraph');
          if (
            this._getAllowedIn(i, this.position.parent) &&
            this.schema.checkChild(i, e)
          ) {
            i._appendChild(e);
            this._handleNode(i, t);
          }
        }
        _checkAndSplitToAllowedPosition(e) {
          const t = this._getAllowedIn(e, this.position.parent);
          if (!t) {
            return false;
          }
          while (t != this.position.parent) {
            if (this.schema.isLimit(this.position.parent)) {
              return false;
            }
            if (this.position.isAtStart) {
              const e = this.position.parent;
              this.position = this.writer.createPositionBefore(e);
              if (e.isEmpty && e.parent === t) {
                this.writer.remove(e);
              }
            } else if (this.position.isAtEnd) {
              this.position = this.writer.createPositionAfter(
                this.position.parent
              );
            } else {
              const e = this.writer.createPositionAfter(this.position.parent);
              this._setAffectedBoundaries(this.position);
              this.writer.split(this.position);
              this.position = e;
              this.canMergeWith.add(this.position.nodeAfter);
            }
          }
          return true;
        }
        _getAllowedIn(e, t) {
          if (this.schema.checkChild(t, e)) {
            return t;
          }
          if (t.parent) {
            return this._getAllowedIn(e, t.parent);
          }
          return null;
        }
      }
      function ip(e, t, i = {}) {
        if (t.isCollapsed) {
          return;
        }
        const n = t.getFirstRange();
        if (n.root.rootName == '$graveyard') {
          return;
        }
        const o = e.schema;
        e.change((e) => {
          if (!i.doNotResetEntireContent && mp(o, t)) {
            gp(e, t, o);
            return;
          }
          const [r, s] = np(n);
          if (!n.start.isTouching(n.end)) {
            e.remove(n);
          }
          if (!i.leaveUnmerged) {
            rp(e, r, s);
            o.removeDisallowedAttributes(r.parent.getChildren(), e);
          }
          pp(e, t, r);
          if (!i.doNotAutoparagraph && up(o, r)) {
            fp(e, r, t);
          }
          r.detach();
          s.detach();
        });
      }
      function np(e) {
        const t = e.root.document.model;
        const i = e.start;
        let n = e.end;
        if (t.hasContent(e, { ignoreMarkers: true })) {
          const i = op(n);
          if (i && n.isTouching(t.createPositionAt(i, 0))) {
            const i = t.createSelection(e);
            t.modifySelection(i, { direction: 'backward' });
            n = i.getLastPosition();
          }
        }
        return [Jm.fromPosition(i, 'toPrevious'), Jm.fromPosition(n, 'toNext')];
      }
      function op(e) {
        const t = e.parent;
        const i = t.root.document.model.schema;
        const n = t.getAncestors({ parentFirst: true, includeSelf: true });
        for (const e of n) {
          if (i.isLimit(e)) {
            return null;
          }
          if (i.isBlock(e)) {
            return e;
          }
        }
      }
      function rp(e, t, i) {
        const n = e.model;
        if (!lp(e.model.schema, t, i)) {
          return;
        }
        const [o, r] = dp(t, i);
        if (
          !n.hasContent(o, { ignoreMarkers: true }) &&
          n.hasContent(r, { ignoreMarkers: true })
        ) {
          ap(e, t, i, o.parent);
        } else {
          sp(e, t, i, o.parent);
        }
      }
      function sp(e, t, i, n) {
        const o = t.parent;
        const r = i.parent;
        if (o == n || r == n) {
          return;
        }
        t = e.createPositionAfter(o);
        i = e.createPositionBefore(r);
        if (!i.isEqual(t)) {
          e.insert(r, t);
        }
        e.merge(t);
        while (i.parent.isEmpty) {
          const t = i.parent;
          i = e.createPositionBefore(t);
          e.remove(t);
        }
        if (!lp(e.model.schema, t, i)) {
          return;
        }
        sp(e, t, i, n);
      }
      function ap(e, t, i, n) {
        const o = t.parent;
        const r = i.parent;
        if (o == n || r == n) {
          return;
        }
        t = e.createPositionAfter(o);
        i = e.createPositionBefore(r);
        if (!i.isEqual(t)) {
          e.insert(o, i);
        }
        while (t.parent.isEmpty) {
          const i = t.parent;
          t = e.createPositionBefore(i);
          e.remove(i);
        }
        i = e.createPositionBefore(r);
        cp(e, i);
        if (!lp(e.model.schema, t, i)) {
          return;
        }
        ap(e, t, i, n);
      }
      function cp(e, t) {
        const i = t.nodeBefore;
        const n = t.nodeAfter;
        if (i.name != n.name) {
          e.rename(i, n.name);
        }
        e.clearAttributes(i);
        e.setAttributes(Object.fromEntries(n.getAttributes()), i);
        e.merge(t);
      }
      function lp(e, t, i) {
        const n = t.parent;
        const o = i.parent;
        if (n == o) {
          return false;
        }
        if (e.isLimit(n) || e.isLimit(o)) {
          return false;
        }
        return hp(t, i, e);
      }
      function dp(e, t) {
        const i = e.getAncestors();
        const n = t.getAncestors();
        let o = 0;
        while (i[o] && i[o] == n[o]) {
          o++;
        }
        return [i[o], n[o]];
      }
      function up(e, t) {
        const i = e.checkChild(t, '$text');
        const n = e.checkChild(t, 'paragraph');
        return !i && n;
      }
      function hp(e, t, i) {
        const n = new ef(e, t);
        for (const e of n.getWalker()) {
          if (i.isLimit(e.item)) {
            return false;
          }
        }
        return true;
      }
      function fp(e, t, i) {
        const n = e.createElement('paragraph');
        e.insert(n, t);
        pp(e, i, e.createPositionAt(n, 0));
      }
      function gp(e, t) {
        const i = e.model.schema.getLimitElement(t);
        e.remove(e.createRangeIn(i));
        fp(e, e.createPositionAt(i, 0), t);
      }
      function mp(e, t) {
        const i = e.getLimitElement(t);
        if (!t.containsEntireContent(i)) {
          return false;
        }
        const n = t.getFirstRange();
        if (n.start.parent == n.end.parent) {
          return false;
        }
        return e.checkChild(i, 'paragraph');
      }
      function pp(e, t, i) {
        if (t instanceof wf) {
          e.setSelection(i);
        } else {
          t.setTo(i);
        }
      }
      const bp = ' ,.?!:;"-()';
      function wp(e, t, i = {}) {
        const n = e.schema;
        const o = i.direction != 'backward';
        const r = i.unit ? i.unit : 'character';
        const s = t.focus;
        const a = new Yh({
          boundaries: yp(s, o),
          singleCharacters: true,
          direction: o ? 'forward' : 'backward',
        });
        const c = { walker: a, schema: n, isForward: o, unit: r };
        let l;
        while ((l = a.next())) {
          if (l.done) {
            return;
          }
          const i = kp(c, l.value);
          if (i) {
            if (t instanceof wf) {
              e.change((e) => {
                e.setSelectionFocus(i);
              });
            } else {
              t.setFocus(i);
            }
            return;
          }
        }
      }
      function kp(e, t) {
        const { isForward: i, walker: n, unit: o, schema: r } = e;
        const { type: s, item: a, nextPosition: c } = t;
        if (s == 'text') {
          if (e.unit === 'word') {
            return vp(n, i);
          }
          return _p(n, o, i);
        }
        if (s == (i ? 'elementStart' : 'elementEnd')) {
          if (r.isSelectable(a)) {
            return Qh._createAt(a, i ? 'after' : 'before');
          }
          if (r.checkChild(c, '$text')) {
            return c;
          }
        } else {
          if (r.isLimit(a)) {
            n.skip(() => true);
            return;
          }
          if (r.checkChild(c, '$text')) {
            return c;
          }
        }
      }
      function _p(e, t) {
        const i = e.position.textNode;
        if (i) {
          const n = i.data;
          let o = e.position.offset - i.startOffset;
          while (Fm(n, o) || (t == 'character' && Hm(n, o))) {
            e.next();
            o = e.position.offset - i.startOffset;
          }
        }
        return e.position;
      }
      function vp(e, t) {
        let i = e.position.textNode;
        if (i) {
          let n = e.position.offset - i.startOffset;
          while (!xp(i.data, n, t) && !Ap(i, n, t)) {
            e.next();
            const o = t ? e.position.nodeAfter : e.position.nodeBefore;
            if (o && o.is('$text')) {
              const n = o.data.charAt(t ? 0 : o.data.length - 1);
              if (!bp.includes(n)) {
                e.next();
                i = e.position.textNode;
              }
            }
            n = e.position.offset - i.startOffset;
          }
        }
        return e.position;
      }
      function yp(e, t) {
        const i = e.root;
        const n = Qh._createAt(i, t ? 'end' : 0);
        if (t) {
          return new ef(e, n);
        } else {
          return new ef(n, e);
        }
      }
      function xp(e, t, i) {
        const n = t + (i ? 0 : -1);
        return bp.includes(e.charAt(n));
      }
      function Ap(e, t, i) {
        return t === (i ? e.endOffset : 0);
      }
      function Tp(e, t) {
        return e.change((e) => {
          const i = e.createDocumentFragment();
          const n = t.getFirstRange();
          if (!n || n.isCollapsed) {
            return i;
          }
          const o = n.start.root;
          const r = n.start.getCommonPath(n.end);
          const s = o.getNodeByPath(r);
          let a;
          if (n.start.parent == n.end.parent) {
            a = n;
          } else {
            a = e.createRange(
              e.createPositionAt(s, n.start.path[r.length]),
              e.createPositionAt(s, n.end.path[r.length] + 1)
            );
          }
          const c = a.end.offset - a.start.offset;
          for (const t of a.getItems({ shallow: true })) {
            if (t.is('$textProxy')) {
              e.appendText(t.data, t.getAttributes(), i);
            } else {
              e.append(e.cloneElement(t, true), i);
            }
          }
          if (a != n) {
            const t = n._getTransformedByMove(
              a.start,
              e.createPositionAt(i, 0),
              c
            )[0];
            const o = e.createRange(e.createPositionAt(i, 0), t.start);
            const r = e.createRange(t.end, e.createPositionAt(i, 'end'));
            Cp(r, e);
            Cp(o, e);
          }
          return i;
        });
      }
      function Cp(e, t) {
        const i = [];
        Array.from(e.getItems({ direction: 'backward' }))
          .map((e) => t.createRangeOn(e))
          .filter((t) => {
            const i =
              (t.start.isAfter(e.start) || t.start.isEqual(e.start)) &&
              (t.end.isBefore(e.end) || t.end.isEqual(e.end));
            return i;
          })
          .forEach((e) => {
            i.push(e.start.parent);
            t.remove(e);
          });
        i.forEach((e) => {
          let i = e;
          while (i.parent && i.isEmpty) {
            const e = t.createRangeOn(i);
            i = i.parent;
            t.remove(e);
          }
        });
      }
      function Pp(e) {
        e.document.registerPostFixer((t) => Ep(t, e));
      }
      function Ep(e, t) {
        const i = t.document.selection;
        const n = t.schema;
        const o = [];
        let r = false;
        for (const e of i.getRanges()) {
          const t = Sp(e, n);
          if (t && !t.isEqual(e)) {
            o.push(t);
            r = true;
          } else {
            o.push(e);
          }
        }
        if (r) {
          e.setSelection(zp(o), { backward: i.isBackward });
        }
      }
      function Sp(e, t) {
        if (e.isCollapsed) {
          return Mp(e, t);
        }
        return Ip(e, t);
      }
      function Mp(e, t) {
        const i = e.start;
        const n = t.getNearestSelectionRange(i);
        if (!n) {
          return null;
        }
        if (!n.isCollapsed) {
          return n;
        }
        const o = n.start;
        if (i.isEqual(o)) {
          return null;
        }
        return new ef(o);
      }
      function Ip(e, t) {
        const { start: i, end: n } = e;
        const o = t.checkChild(i, '$text');
        const r = t.checkChild(n, '$text');
        const s = t.getLimitElement(i);
        const a = t.getLimitElement(n);
        if (s === a) {
          if (o && r) {
            return null;
          }
          if (Op(i, n, t)) {
            const e = i.nodeAfter && t.isSelectable(i.nodeAfter);
            const o = e ? null : t.getNearestSelectionRange(i, 'forward');
            const r = n.nodeBefore && t.isSelectable(n.nodeBefore);
            const s = r ? null : t.getNearestSelectionRange(n, 'backward');
            const a = o ? o.start : i;
            const c = s ? s.start : n;
            return new ef(a, c);
          }
        }
        const c = s && !s.is('rootElement');
        const l = a && !a.is('rootElement');
        if (c || l) {
          const e =
            i.nodeAfter &&
            n.nodeBefore &&
            i.nodeAfter.parent === n.nodeBefore.parent;
          const o = c && (!e || !Rp(i.nodeAfter, t));
          const r = l && (!e || !Rp(n.nodeBefore, t));
          let d = i;
          let u = n;
          if (o) {
            d = Qh._createBefore(Np(s, t));
          }
          if (r) {
            u = Qh._createAfter(Np(a, t));
          }
          return new ef(d, u);
        }
        return null;
      }
      function Np(e, t) {
        let i = e;
        let n = i;
        while (t.isLimit(n) && n.parent) {
          i = n;
          n = n.parent;
        }
        return i;
      }
      function Op(e, t, i) {
        const n =
          (e.nodeAfter && !i.isLimit(e.nodeAfter)) || i.checkChild(e, '$text');
        const o =
          (t.nodeBefore && !i.isLimit(t.nodeBefore)) ||
          i.checkChild(t, '$text');
        return n || o;
      }
      function zp(e) {
        const t = [];
        t.push(e.shift());
        for (const i of e) {
          const e = t.pop();
          if (i.isIntersecting(e)) {
            const n = e.start.isAfter(i.start) ? i.start : e.start;
            const o = e.end.isAfter(i.end) ? e.end : i.end;
            const r = new ef(n, o);
            t.push(r);
          } else {
            t.push(e);
            t.push(i);
          }
        }
        return t;
      }
      function Rp(e, t) {
        return e && t.isSelectable(e);
      }
      class Lp {
        constructor() {
          this.markers = new $m();
          this.document = new qm(this);
          this.schema = new Ig();
          this._pendingChanges = [];
          this._currentWriter = null;
          [
            'insertContent',
            'deleteContent',
            'modifySelection',
            'getSelectedContent',
            'applyOperation',
          ].forEach((e) => this.decorate(e));
          this.on(
            'applyOperation',
            (e, t) => {
              const i = t[0];
              i._validate();
            },
            { priority: 'highest' }
          );
          this.schema.register('$root', { isLimit: true });
          this.schema.register('$block', { allowIn: '$root', isBlock: true });
          this.schema.register('$text', {
            allowIn: '$block',
            isInline: true,
            isContent: true,
          });
          this.schema.register('$clipboardHolder', {
            allowContentOf: '$root',
            isLimit: true,
          });
          this.schema.extend('$text', { allowIn: '$clipboardHolder' });
          this.schema.register('$marker');
          this.schema.addChildCheck((e, t) => {
            if (t.name === '$marker') {
              return true;
            }
          });
          Pp(this);
          this.document.registerPostFixer(og);
        }
        change(e) {
          try {
            if (this._pendingChanges.length === 0) {
              this._pendingChanges.push({ batch: new nm(), callback: e });
              return this._runPendingChanges()[0];
            } else {
              return e(this._currentWriter);
            }
          } catch (e) {
            ss['b'].rethrowUnexpectedError(e, this);
          }
        }
        enqueueChange(e, t) {
          try {
            if (typeof e === 'string') {
              e = new nm(e);
            } else if (typeof e == 'function') {
              t = e;
              e = new nm();
            }
            this._pendingChanges.push({ batch: e, callback: t });
            if (this._pendingChanges.length == 1) {
              this._runPendingChanges();
            }
          } catch (e) {
            ss['b'].rethrowUnexpectedError(e, this);
          }
        }
        applyOperation(e) {
          e._execute();
        }
        insertContent(e, t, i) {
          return ep(this, e, t, i);
        }
        deleteContent(e, t) {
          ip(this, e, t);
        }
        modifySelection(e, t) {
          wp(this, e, t);
        }
        getSelectedContent(e) {
          return Tp(this, e);
        }
        hasContent(e, t = {}) {
          const i = e instanceof $h ? ef._createIn(e) : e;
          if (i.isCollapsed) {
            return false;
          }
          const { ignoreWhitespaces: n = false, ignoreMarkers: o = false } = t;
          if (!o) {
            for (const e of this.markers.getMarkersIntersectingRange(i)) {
              if (e.affectsData) {
                return true;
              }
            }
          }
          for (const e of i.getItems()) {
            if (this.schema.isContent(e)) {
              if (e.is('$textProxy')) {
                if (!n) {
                  return true;
                } else if (e.data.search(/\S/) !== -1) {
                  return true;
                }
              } else {
                return true;
              }
            }
          }
          return false;
        }
        createPositionFromPath(e, t, i) {
          return new Qh(e, t, i);
        }
        createPositionAt(e, t) {
          return Qh._createAt(e, t);
        }
        createPositionAfter(e) {
          return Qh._createAfter(e);
        }
        createPositionBefore(e) {
          return Qh._createBefore(e);
        }
        createRange(e, t) {
          return new ef(e, t);
        }
        createRangeIn(e) {
          return ef._createIn(e);
        }
        createRangeOn(e) {
          return ef._createOn(e);
        }
        createSelection(e, t, i) {
          return new af(e, t, i);
        }
        createBatch(e) {
          return new nm(e);
        }
        createOperationFromJSON(e) {
          return Qm.fromJSON(e, this.document);
        }
        destroy() {
          this.document.destroy();
          this.stopListening();
        }
        _runPendingChanges() {
          const e = [];
          this.fire('_beforeChanges');
          while (this._pendingChanges.length) {
            const t = this._pendingChanges[0].batch;
            this._currentWriter = new Pm(this, t);
            const i = this._pendingChanges[0].callback(this._currentWriter);
            e.push(i);
            this.document._handleChangeBlock(this._currentWriter);
            this._pendingChanges.shift();
            this._currentWriter = null;
          }
          this.fire('_afterChanges');
          return e;
        }
      }
      ys(Lp, Qc);
      class Vp {
        constructor() {
          this._listener = Object.create(Kd);
        }
        listenTo(e) {
          this._listener.listenTo(e, 'keydown', (e, t) => {
            this._listener.fire('_keydown:' + Rl(t), t);
          });
        }
        set(e, t, i = {}) {
          const n = Ll(e);
          const o = i.priority;
          this._listener.listenTo(
            this._listener,
            '_keydown:' + n,
            (e, i) => {
              t(i, () => {
                i.preventDefault();
                i.stopPropagation();
                e.stop();
              });
              e.return = true;
            },
            { priority: o }
          );
        }
        press(e) {
          return !!this._listener.fire('_keydown:' + Rl(e), e);
        }
        destroy() {
          this._listener.stopListening();
        }
      }
      class Dp extends Vp {
        constructor(e) {
          super();
          this.editor = e;
        }
        set(e, t, i = {}) {
          if (typeof t == 'string') {
            const e = t;
            t = (t, i) => {
              this.editor.execute(e);
              i();
            };
          }
          super.set(e, t, i);
        }
      }
      class jp {
        constructor(e = {}) {
          this._context = e.context || new zs({ language: e.language });
          this._context._addEditor(this, !e.context);
          const t = Array.from(this.constructor.builtinPlugins || []);
          this.config = new Kr(e, this.constructor.defaultConfig);
          this.config.define('plugins', t);
          this.config.define(this._context._getEditorConfig());
          this.plugins = new As(this, t, this._context.plugins);
          this.locale = this._context.locale;
          this.t = this.locale.t;
          this.commands = new Eg();
          this.set('state', 'initializing');
          this.once('ready', () => (this.state = 'ready'), {
            priority: 'high',
          });
          this.once('destroy', () => (this.state = 'destroyed'), {
            priority: 'high',
          });
          this.set('isReadOnly', false);
          this.model = new Lp();
          const i = new zc();
          this.data = new Zg(this.model, i);
          this.editing = new Pg(this.model, i);
          this.editing.view.document.bind('isReadOnly').to(this);
          this.conversion = new em(
            [this.editing.downcastDispatcher, this.data.downcastDispatcher],
            this.data.upcastDispatcher
          );
          this.conversion.addAlias(
            'dataDowncast',
            this.data.downcastDispatcher
          );
          this.conversion.addAlias(
            'editingDowncast',
            this.editing.downcastDispatcher
          );
          this.keystrokes = new Dp(this);
          this.keystrokes.listenTo(this.editing.view.document);
        }
        initPlugins() {
          const e = this.config;
          const t = e.get('plugins');
          const i = e.get('removePlugins') || [];
          const n = e.get('extraPlugins') || [];
          return this.plugins.init(t.concat(n), i);
        }
        destroy() {
          let e = Promise.resolve();
          if (this.state == 'initializing') {
            e = new Promise((e) => this.once('ready', e));
          }
          return e
            .then(() => {
              this.fire('destroy');
              this.stopListening();
              this.commands.destroy();
            })
            .then(() => this.plugins.destroy())
            .then(() => {
              this.model.destroy();
              this.data.destroy();
              this.editing.destroy();
              this.keystrokes.destroy();
            })
            .then(() => this._context._removeEditor(this));
        }
        execute(...e) {
          try {
            return this.commands.execute(...e);
          } catch (e) {
            ss['b'].rethrowUnexpectedError(e, this);
          }
        }
      }
      ys(jp, Qc);
      const Bp = {
        setData(e) {
          this.data.set(e);
        },
        getData(e) {
          return this.data.get(e);
        },
      };
      var Fp = Bp;
      function Hp(e, t) {
        if (e instanceof HTMLTextAreaElement) {
          e.value = t;
        }
        e.innerHTML = t;
      }
      const Up = {
        updateSourceElement() {
          if (!this.sourceElement) {
            throw new ss['b'](
              'editor-missing-sourceelement: Cannot update the source element of a detached editor.',
              this
            );
          }
          Hp(this.sourceElement, this.data.get());
        },
      };
      var qp = Up;
      function Wp(e) {
        if (!ge(e.updateSourceElement)) {
          throw new ss['b'](
            'attachtoform-missing-elementapi-interface: Editor passed to attachToForm() must implement ElementApi.',
            e
          );
        }
        const t = e.sourceElement;
        if (t && t.tagName.toLowerCase() === 'textarea' && t.form) {
          let i;
          const n = t.form;
          const o = () => e.updateSourceElement();
          if (ge(n.submit)) {
            i = n.submit;
            n.submit = () => {
              o();
              i.apply(n);
            };
          }
          n.addEventListener('submit', o);
          e.on('destroy', () => {
            n.removeEventListener('submit', o);
            if (i) {
              n.submit = i;
            }
          });
        }
      }
      class $p {
        getHtml(e) {
          const t = document.implementation.createHTMLDocument('');
          const i = t.createElement('div');
          i.appendChild(e);
          return i.innerHTML;
        }
      }
      class Gp {
        constructor(e) {
          this._domParser = new DOMParser();
          this._domConverter = new Hd(e, { blockFillerMode: 'nbsp' });
          this._htmlWriter = new $p();
        }
        toData(e) {
          const t = this._domConverter.viewToDom(e, document);
          return this._htmlWriter.getHtml(t);
        }
        toView(e) {
          const t = this._toDom(e);
          return this._domConverter.domToView(t);
        }
        _toDom(e) {
          const t = this._domParser.parseFromString(e, 'text/html');
          const i = t.createDocumentFragment();
          const n = t.body.childNodes;
          while (n.length > 0) {
            i.appendChild(n[0]);
          }
          return i;
        }
      }
      class Yp {
        constructor(e) {
          this.editor = e;
          this._components = new Map();
        }
        *names() {
          for (const e of this._components.values()) {
            yield e.originalName;
          }
        }
        add(e, t) {
          this._components.set(Kp(e), { callback: t, originalName: e });
        }
        create(e) {
          if (!this.has(e)) {
            throw new ss['b'](
              'componentfactory-item-missing: The required component is not registered in the factory.',
              this,
              { name: e }
            );
          }
          return this._components.get(Kp(e)).callback(this.editor.locale);
        }
        has(e) {
          return this._components.has(Kp(e));
        }
      }
      function Kp(e) {
        return String(e).toLowerCase();
      }
      class Qp {
        constructor() {
          this.set('isFocused', false);
          this.set('focusedElement', null);
          this._elements = new Set();
          this._nextEventLoopTimeout = null;
        }
        add(e) {
          if (this._elements.has(e)) {
            throw new ss['b'](
              'focusTracker-add-element-already-exist: This element is already tracked by FocusTracker.',
              this
            );
          }
          this.listenTo(e, 'focus', () => this._focus(e), { useCapture: true });
          this.listenTo(e, 'blur', () => this._blur(), { useCapture: true });
          this._elements.add(e);
        }
        remove(e) {
          if (e === this.focusedElement) {
            this._blur(e);
          }
          if (this._elements.has(e)) {
            this.stopListening(e);
            this._elements.delete(e);
          }
        }
        destroy() {
          this.stopListening();
        }
        _focus(e) {
          clearTimeout(this._nextEventLoopTimeout);
          this.focusedElement = e;
          this.isFocused = true;
        }
        _blur() {
          clearTimeout(this._nextEventLoopTimeout);
          this._nextEventLoopTimeout = setTimeout(() => {
            this.focusedElement = null;
            this.isFocused = false;
          }, 0);
        }
      }
      ys(Qp, Kd);
      ys(Qp, Qc);
      class Jp {
        constructor(e) {
          this.editor = e;
          this.componentFactory = new Yp(e);
          this.focusTracker = new Qp();
          this._editableElementsMap = new Map();
          this.listenTo(e.editing.view.document, 'layoutChanged', () =>
            this.update()
          );
        }
        get element() {
          return null;
        }
        update() {
          this.fire('update');
        }
        destroy() {
          this.stopListening();
          this.focusTracker.destroy();
          for (const e of this._editableElementsMap.values()) {
            e.ckeditorInstance = null;
          }
          this._editableElementsMap = new Map();
        }
        setEditableElement(e, t) {
          this._editableElementsMap.set(e, t);
          if (!t.ckeditorInstance) {
            t.ckeditorInstance = this.editor;
          }
        }
        getEditableElement(e = 'main') {
          return this._editableElementsMap.get(e);
        }
        getEditableElementsNames() {
          return this._editableElementsMap.keys();
        }
        get _editableElements() {
          console.warn(
            'editor-ui-deprecated-editable-elements: ' +
              'The EditorUI#_editableElements property has been deprecated and will be removed in the near future.',
            { editorUI: this }
          );
          return this._editableElementsMap;
        }
      }
      ys(Jp, ds);
      function Zp({
        origin: e,
        originKeystrokeHandler: t,
        originFocusTracker: i,
        toolbar: n,
        beforeFocus: o,
        afterBlur: r,
      }) {
        i.add(n.element);
        t.set('Alt+F10', (e, t) => {
          if (i.isFocused && !n.focusTracker.isFocused) {
            if (o) {
              o();
            }
            n.focus();
            t();
          }
        });
        n.keystrokes.set('Esc', (t, i) => {
          if (n.focusTracker.isFocused) {
            e.focus();
            if (r) {
              r();
            }
            i();
          }
        });
      }
      function Xp(e) {
        if (Array.isArray(e)) {
          return { items: e };
        }
        if (!e) {
          return { items: [] };
        }
        return Object.assign({ items: [] }, e);
      }
      var eb = i(14);
      const tb = new WeakMap();
      function ib(e) {
        const { view: t, element: i, text: n, isDirectHost: o = true } = e;
        const r = t.document;
        if (!tb.has(r)) {
          tb.set(r, new Map());
          r.registerPostFixer((e) => ab(r, e));
        }
        tb.get(r).set(i, { text: n, isDirectHost: o });
        t.change((e) => ab(r, e));
      }
      function nb(e, t) {
        const i = t.document;
        e.change((e) => {
          if (!tb.has(i)) {
            return;
          }
          const n = tb.get(i);
          const o = n.get(t);
          e.removeAttribute('data-placeholder', o.hostElement);
          rb(e, o.hostElement);
          n.delete(t);
        });
      }
      function ob(e, t) {
        if (!t.hasClass('ck-placeholder')) {
          e.addClass('ck-placeholder', t);
          return true;
        }
        return false;
      }
      function rb(e, t) {
        if (t.hasClass('ck-placeholder')) {
          e.removeClass('ck-placeholder', t);
          return true;
        }
        return false;
      }
      function sb(e) {
        if (!e.isAttached()) {
          return false;
        }
        const t = !Array.from(e.getChildren()).some((e) => !e.is('uiElement'));
        const i = e.document;
        if (!i.isFocused && t) {
          return true;
        }
        const n = i.selection;
        const o = n.anchor;
        if (t && o && o.parent !== e) {
          return true;
        }
        return false;
      }
      function ab(e, t) {
        const i = tb.get(e);
        let n = false;
        for (const [e, o] of i) {
          if (cb(t, e, o)) {
            n = true;
          }
        }
        return n;
      }
      function cb(e, t, i) {
        const { text: n, isDirectHost: o } = i;
        const r = o ? t : lb(t);
        let s = false;
        if (!r) {
          return false;
        }
        i.hostElement = r;
        if (r.getAttribute('data-placeholder') !== n) {
          e.setAttribute('data-placeholder', n, r);
          s = true;
        }
        if (sb(r)) {
          if (ob(e, r)) {
            s = true;
          }
        } else if (rb(e, r)) {
          s = true;
        }
        return s;
      }
      function lb(e) {
        if (e.childCount === 1) {
          const t = e.getChild(0);
          if (t.is('element') && !t.is('uiElement')) {
            return t;
          }
        }
        return null;
      }
      class db {
        constructor() {
          this._replacedElements = [];
        }
        replace(e, t) {
          this._replacedElements.push({ element: e, newElement: t });
          e.style.display = 'none';
          if (t) {
            e.parentNode.insertBefore(t, e.nextSibling);
          }
        }
        restore() {
          this._replacedElements.forEach(({ element: e, newElement: t }) => {
            e.style.display = '';
            if (t) {
              t.remove();
            }
          });
          this._replacedElements = [];
        }
      }
      class ub extends Jp {
        constructor(e, t) {
          super(e);
          this.view = t;
          this._toolbarConfig = Xp(e.config.get('toolbar'));
          this._elementReplacer = new db();
        }
        get element() {
          return this.view.element;
        }
        init(e) {
          const t = this.editor;
          const i = this.view;
          const n = t.editing.view;
          const o = i.editable;
          const r = n.document.getRoot();
          o.name = r.rootName;
          i.render();
          const s = o.element;
          this.setEditableElement(o.name, s);
          this.focusTracker.add(s);
          i.editable.bind('isFocused').to(this.focusTracker);
          n.attachDomRoot(s);
          if (e) {
            this._elementReplacer.replace(e, this.element);
          }
          this._initPlaceholder();
          this._initToolbar();
          this.fire('ready');
        }
        destroy() {
          const e = this.view;
          const t = this.editor.editing.view;
          this._elementReplacer.restore();
          t.detachDomRoot(e.editable.name);
          e.destroy();
          super.destroy();
        }
        _initToolbar() {
          const e = this.editor;
          const t = this.view;
          const i = e.editing.view;
          t.stickyPanel.bind('isActive').to(this.focusTracker, 'isFocused');
          t.stickyPanel.limiterElement = t.element;
          if (this._toolbarConfig.viewportTopOffset) {
            t.stickyPanel.viewportTopOffset =
              this._toolbarConfig.viewportTopOffset;
          }
          t.toolbar.fillFromConfig(
            this._toolbarConfig.items,
            this.componentFactory
          );
          Zp({
            origin: i,
            originFocusTracker: this.focusTracker,
            originKeystrokeHandler: e.keystrokes,
            toolbar: t.toolbar,
          });
        }
        _initPlaceholder() {
          const e = this.editor;
          const t = e.editing.view;
          const i = t.document.getRoot();
          const n = e.sourceElement;
          const o =
            e.config.get('placeholder') ||
            (n &&
              n.tagName.toLowerCase() === 'textarea' &&
              n.getAttribute('placeholder'));
          if (o) {
            ib({ view: t, element: i, text: o, isDirectHost: false });
          }
        }
      }
      class hb extends xs {
        constructor(e = []) {
          super(e, { idProperty: 'viewUid' });
          this.on('add', (e, t, i) => {
            this._renderViewIntoCollectionParent(t, i);
          });
          this.on('remove', (e, t) => {
            if (t.element && this._parentElement) {
              t.element.remove();
            }
          });
          this._parentElement = null;
        }
        destroy() {
          this.map((e) => e.destroy());
        }
        setParent(e) {
          this._parentElement = e;
          for (const e of this) {
            this._renderViewIntoCollectionParent(e);
          }
        }
        delegate(...e) {
          if (!e.length || !fb(e)) {
            throw new ss['b'](
              'ui-viewcollection-delegate-wrong-events: All event names must be strings.',
              this
            );
          }
          return {
            to: (t) => {
              for (const i of this) {
                for (const n of e) {
                  i.delegate(n).to(t);
                }
              }
              this.on('add', (i, n) => {
                for (const i of e) {
                  n.delegate(i).to(t);
                }
              });
              this.on('remove', (i, n) => {
                for (const i of e) {
                  n.stopDelegating(i, t);
                }
              });
            },
          };
        }
        _renderViewIntoCollectionParent(e, t) {
          if (!e.isRendered) {
            e.render();
          }
          if (e.element && this._parentElement) {
            this._parentElement.insertBefore(
              e.element,
              this._parentElement.children[t]
            );
          }
        }
      }
      function fb(e) {
        return e.every((e) => typeof e == 'string');
      }
      const gb = 'http://www.w3.org/1999/xhtml';
      class mb {
        constructor(e) {
          Object.assign(this, Cb(Tb(e)));
          this._isRendered = false;
          this._revertData = null;
        }
        render() {
          const e = this._renderNode({ intoFragment: true });
          this._isRendered = true;
          return e;
        }
        apply(e) {
          this._revertData = jb();
          this._renderNode({
            node: e,
            isApplying: true,
            revertData: this._revertData,
          });
          return e;
        }
        revert(e) {
          if (!this._revertData) {
            throw new ss['b'](
              'ui-template-revert-not-applied: Attempting to revert a template which has not been applied yet.',
              [this, e]
            );
          }
          this._revertTemplateFromNode(e, this._revertData);
        }
        *getViews() {
          function* e(t) {
            if (t.children) {
              for (const i of t.children) {
                if (Lb(i)) {
                  yield i;
                } else if (Vb(i)) {
                  yield* e(i);
                }
              }
            }
          }
          yield* e(this);
        }
        static bind(e, t) {
          return {
            to(i, n) {
              return new bb({
                eventNameOrFunction: i,
                attribute: i,
                observable: e,
                emitter: t,
                callback: n,
              });
            },
            if(i, n, o) {
              return new wb({
                observable: e,
                emitter: t,
                attribute: i,
                valueIfTrue: n,
                callback: o,
              });
            },
          };
        }
        static extend(e, t) {
          if (e._isRendered) {
            throw new ss['b'](
              'template-extend-render: Attempting to extend a template which has already been rendered.',
              [this, e]
            );
          }
          zb(e, Cb(Tb(t)));
        }
        _renderNode(e) {
          let t;
          if (e.node) {
            t = this.tag && this.text;
          } else {
            t = this.tag ? this.text : !this.text;
          }
          if (t) {
            throw new ss['b'](
              'ui-template-wrong-syntax: Node definition must have either "tag" or "text" when rendering a new Node.',
              this
            );
          }
          if (this.text) {
            return this._renderText(e);
          } else {
            return this._renderElement(e);
          }
        }
        _renderElement(e) {
          let t = e.node;
          if (!t) {
            t = e.node = document.createElementNS(this.ns || gb, this.tag);
          }
          this._renderAttributes(e);
          this._renderElementChildren(e);
          this._setUpListeners(e);
          return t;
        }
        _renderText(e) {
          let t = e.node;
          if (t) {
            e.revertData.text = t.textContent;
          } else {
            t = e.node = document.createTextNode('');
          }
          if (kb(this.text)) {
            this._bindToObservable({
              schema: this.text,
              updater: yb(t),
              data: e,
            });
          } else {
            t.textContent = this.text.join('');
          }
          return t;
        }
        _renderAttributes(e) {
          let t, i, n, o;
          if (!this.attributes) {
            return;
          }
          const r = e.node;
          const s = e.revertData;
          for (t in this.attributes) {
            n = r.getAttribute(t);
            i = this.attributes[t];
            if (s) {
              s.attributes[t] = n;
            }
            o = ce(i[0]) && i[0].ns ? i[0].ns : null;
            if (kb(i)) {
              const a = o ? i[0].value : i;
              if (s && Bb(t)) {
                a.unshift(n);
              }
              this._bindToObservable({
                schema: a,
                updater: xb(r, t, o),
                data: e,
              });
            } else if (t == 'style' && typeof i[0] !== 'string') {
              this._renderStyleAttribute(i[0], e);
            } else {
              if (s && n && Bb(t)) {
                i.unshift(n);
              }
              i = i
                .map((e) => (e ? e.value || e : e))
                .reduce((e, t) => e.concat(t), [])
                .reduce(Nb, '');
              if (!Rb(i)) {
                r.setAttributeNS(o, t, i);
              }
            }
          }
        }
        _renderStyleAttribute(e, t) {
          const i = t.node;
          for (const n in e) {
            const o = e[n];
            if (kb(o)) {
              this._bindToObservable({
                schema: [o],
                updater: Ab(i, n),
                data: t,
              });
            } else {
              i.style[n] = o;
            }
          }
        }
        _renderElementChildren(e) {
          const t = e.node;
          const i = e.intoFragment ? document.createDocumentFragment() : t;
          const n = e.isApplying;
          let o = 0;
          for (const r of this.children) {
            if (Db(r)) {
              if (!n) {
                r.setParent(t);
                for (const e of r) {
                  i.appendChild(e.element);
                }
              }
            } else if (Lb(r)) {
              if (!n) {
                if (!r.isRendered) {
                  r.render();
                }
                i.appendChild(r.element);
              }
            } else if (Ed(r)) {
              i.appendChild(r);
            } else {
              if (n) {
                const t = e.revertData;
                const n = jb();
                t.children.push(n);
                r._renderNode({
                  node: i.childNodes[o++],
                  isApplying: true,
                  revertData: n,
                });
              } else {
                i.appendChild(r.render());
              }
            }
          }
          if (e.intoFragment) {
            t.appendChild(i);
          }
        }
        _setUpListeners(e) {
          if (!this.eventListeners) {
            return;
          }
          for (const t in this.eventListeners) {
            const i = this.eventListeners[t].map((i) => {
              const [n, o] = t.split('@');
              return i.activateDomEventListener(n, o, e);
            });
            if (e.revertData) {
              e.revertData.bindings.push(i);
            }
          }
        }
        _bindToObservable({ schema: e, updater: t, data: i }) {
          const n = i.revertData;
          vb(e, t, i);
          const o = e
            .filter((e) => !Rb(e))
            .filter((e) => e.observable)
            .map((n) => n.activateAttributeListener(e, t, i));
          if (n) {
            n.bindings.push(o);
          }
        }
        _revertTemplateFromNode(e, t) {
          for (const e of t.bindings) {
            for (const t of e) {
              t();
            }
          }
          if (t.text) {
            e.textContent = t.text;
            return;
          }
          for (const i in t.attributes) {
            const n = t.attributes[i];
            if (n === null) {
              e.removeAttribute(i);
            } else {
              e.setAttribute(i, n);
            }
          }
          for (let i = 0; i < t.children.length; ++i) {
            this._revertTemplateFromNode(e.childNodes[i], t.children[i]);
          }
        }
      }
      ys(mb, ds);
      class pb {
        constructor(e) {
          Object.assign(this, e);
        }
        getValue(e) {
          const t = this.observable[this.attribute];
          return this.callback ? this.callback(t, e) : t;
        }
        activateAttributeListener(e, t, i) {
          const n = () => vb(e, t, i);
          this.emitter.listenTo(this.observable, 'change:' + this.attribute, n);
          return () => {
            this.emitter.stopListening(
              this.observable,
              'change:' + this.attribute,
              n
            );
          };
        }
      }
      class bb extends pb {
        activateDomEventListener(e, t, i) {
          const n = (e, i) => {
            if (!t || i.target.matches(t)) {
              if (typeof this.eventNameOrFunction == 'function') {
                this.eventNameOrFunction(i);
              } else {
                this.observable.fire(this.eventNameOrFunction, i);
              }
            }
          };
          this.emitter.listenTo(i.node, e, n);
          return () => {
            this.emitter.stopListening(i.node, e, n);
          };
        }
      }
      class wb extends pb {
        getValue(e) {
          const t = super.getValue(e);
          return Rb(t) ? false : this.valueIfTrue || true;
        }
      }
      function kb(e) {
        if (!e) {
          return false;
        }
        if (e.value) {
          e = e.value;
        }
        if (Array.isArray(e)) {
          return e.some(kb);
        } else if (e instanceof pb) {
          return true;
        }
        return false;
      }
      function _b(e, t) {
        return e.map((e) => {
          if (e instanceof pb) {
            return e.getValue(t);
          }
          return e;
        });
      }
      function vb(e, t, { node: i }) {
        let n = _b(e, i);
        if (e.length == 1 && e[0] instanceof wb) {
          n = n[0];
        } else {
          n = n.reduce(Nb, '');
        }
        if (Rb(n)) {
          t.remove();
        } else {
          t.set(n);
        }
      }
      function yb(e) {
        return {
          set(t) {
            e.textContent = t;
          },
          remove() {
            e.textContent = '';
          },
        };
      }
      function xb(e, t, i) {
        return {
          set(n) {
            e.setAttributeNS(i, t, n);
          },
          remove() {
            e.removeAttributeNS(i, t);
          },
        };
      }
      function Ab(e, t) {
        return {
          set(i) {
            e.style[t] = i;
          },
          remove() {
            e.style[t] = null;
          },
        };
      }
      function Tb(e) {
        const t = $r(e, (e) => {
          if (e && (e instanceof pb || Vb(e) || Lb(e) || Db(e))) {
            return e;
          }
        });
        return t;
      }
      function Cb(e) {
        if (typeof e == 'string') {
          e = Sb(e);
        } else if (e.text) {
          Mb(e);
        }
        if (e.on) {
          e.eventListeners = Eb(e.on);
          delete e.on;
        }
        if (!e.text) {
          if (e.attributes) {
            Pb(e.attributes);
          }
          const t = [];
          if (e.children) {
            if (Db(e.children)) {
              t.push(e.children);
            } else {
              for (const i of e.children) {
                if (Vb(i) || Lb(i) || Ed(i)) {
                  t.push(i);
                } else {
                  t.push(new mb(i));
                }
              }
            }
          }
          e.children = t;
        }
        return e;
      }
      function Pb(e) {
        for (const t in e) {
          if (e[t].value) {
            e[t].value = [].concat(e[t].value);
          }
          Ib(e, t);
        }
      }
      function Eb(e) {
        for (const t in e) {
          Ib(e, t);
        }
        return e;
      }
      function Sb(e) {
        return { text: [e] };
      }
      function Mb(e) {
        if (!Array.isArray(e.text)) {
          e.text = [e.text];
        }
      }
      function Ib(e, t) {
        if (!Array.isArray(e[t])) {
          e[t] = [e[t]];
        }
      }
      function Nb(e, t) {
        if (Rb(t)) {
          return e;
        } else if (Rb(e)) {
          return t;
        } else {
          return `${e} ${t}`;
        }
      }
      function Ob(e, t) {
        for (const i in t) {
          if (e[i]) {
            e[i].push(...t[i]);
          } else {
            e[i] = t[i];
          }
        }
      }
      function zb(e, t) {
        if (t.attributes) {
          if (!e.attributes) {
            e.attributes = {};
          }
          Ob(e.attributes, t.attributes);
        }
        if (t.eventListeners) {
          if (!e.eventListeners) {
            e.eventListeners = {};
          }
          Ob(e.eventListeners, t.eventListeners);
        }
        if (t.text) {
          e.text.push(...t.text);
        }
        if (t.children && t.children.length) {
          if (e.children.length != t.children.length) {
            throw new ss['b'](
              'ui-template-extend-children-mismatch: The number of children in extended definition does not match.',
              e
            );
          }
          let i = 0;
          for (const n of t.children) {
            zb(e.children[i++], n);
          }
        }
      }
      function Rb(e) {
        return !e && e !== 0;
      }
      function Lb(e) {
        return e instanceof Hb;
      }
      function Vb(e) {
        return e instanceof mb;
      }
      function Db(e) {
        return e instanceof hb;
      }
      function jb() {
        return { children: [], bindings: [], attributes: {} };
      }
      function Bb(e) {
        return e == 'class' || e == 'style';
      }
      var Fb = i(16);
      class Hb {
        constructor(e) {
          this.element = null;
          this.isRendered = false;
          this.locale = e;
          this.t = e && e.t;
          this._viewCollections = new xs();
          this._unboundChildren = this.createCollection();
          this._viewCollections.on('add', (t, i) => {
            i.locale = e;
          });
          this.decorate('render');
        }
        get bindTemplate() {
          if (this._bindTemplate) {
            return this._bindTemplate;
          }
          return (this._bindTemplate = mb.bind(this, this));
        }
        createCollection(e) {
          const t = new hb(e);
          this._viewCollections.add(t);
          return t;
        }
        registerChild(e) {
          if (!vs(e)) {
            e = [e];
          }
          for (const t of e) {
            this._unboundChildren.add(t);
          }
        }
        deregisterChild(e) {
          if (!vs(e)) {
            e = [e];
          }
          for (const t of e) {
            this._unboundChildren.remove(t);
          }
        }
        setTemplate(e) {
          this.template = new mb(e);
        }
        extendTemplate(e) {
          mb.extend(this.template, e);
        }
        render() {
          if (this.isRendered) {
            throw new ss['b'](
              'ui-view-render-already-rendered: This View has already been rendered.',
              this
            );
          }
          if (this.template) {
            this.element = this.template.render();
            this.registerChild(this.template.getViews());
          }
          this.isRendered = true;
        }
        destroy() {
          this.stopListening();
          this._viewCollections.map((e) => e.destroy());
          if (this.template && this.template._revertData) {
            this.template.revert(this.element);
          }
        }
      }
      ys(Hb, Kd);
      ys(Hb, Qc);
      var Ub = '[object String]';
      function qb(e) {
        return typeof e == 'string' || (!Kt(e) && C(e) && _(e) == Ub);
      }
      var Wb = qb;
      function $b(e, t, i = {}, n = []) {
        const o = i && i.xmlns;
        const r = o ? e.createElementNS(o, t) : e.createElement(t);
        for (const e in i) {
          r.setAttribute(e, i[e]);
        }
        if (Wb(n) || !vs(n)) {
          n = [n];
        }
        for (let t of n) {
          if (Wb(t)) {
            t = e.createTextNode(t);
          }
          r.appendChild(t);
        }
        return r;
      }
      class Gb extends hb {
        constructor(e, t = []) {
          super(t);
          this.locale = e;
        }
        attachToDom() {
          this._bodyCollectionContainer = new mb({
            tag: 'div',
            attributes: {
              class: ['ck', 'ck-reset_all', 'ck-body', 'ck-rounded-corners'],
              dir: this.locale.uiLanguageDirection,
            },
            children: this,
          }).render();
          let e = document.querySelector('.ck-body-wrapper');
          if (!e) {
            e = $b(document, 'div', { class: 'ck-body-wrapper' });
            document.body.appendChild(e);
          }
          e.appendChild(this._bodyCollectionContainer);
        }
        detachFromDom() {
          super.destroy();
          if (this._bodyCollectionContainer) {
            this._bodyCollectionContainer.remove();
          }
          const e = document.querySelector('.ck-body-wrapper');
          if (e && e.childElementCount == 0) {
            e.remove();
          }
        }
      }
      var Yb = i(18);
      class Kb extends Hb {
        constructor(e) {
          super(e);
          this.body = new Gb(e);
        }
        render() {
          super.render();
          this.body.attachToDom();
        }
        destroy() {
          this.body.detachFromDom();
          return super.destroy();
        }
      }
      var Qb = i(20);
      class Jb extends Hb {
        constructor(e) {
          super(e);
          this.set('text');
          this.set('for');
          this.id = `ck-editor__label_${is()}`;
          const t = this.bindTemplate;
          this.setTemplate({
            tag: 'label',
            attributes: {
              class: ['ck', 'ck-label'],
              id: this.id,
              for: t.to('for'),
            },
            children: [{ text: t.to('text') }],
          });
        }
      }
      class Zb extends Kb {
        constructor(e) {
          super(e);
          this.top = this.createCollection();
          this.main = this.createCollection();
          this._voiceLabelView = this._createVoiceLabel();
          this.setTemplate({
            tag: 'div',
            attributes: {
              class: ['ck', 'ck-reset', 'ck-editor', 'ck-rounded-corners'],
              role: 'application',
              dir: e.uiLanguageDirection,
              lang: e.uiLanguage,
              'aria-labelledby': this._voiceLabelView.id,
            },
            children: [
              this._voiceLabelView,
              {
                tag: 'div',
                attributes: {
                  class: ['ck', 'ck-editor__top', 'ck-reset_all'],
                  role: 'presentation',
                },
                children: this.top,
              },
              {
                tag: 'div',
                attributes: {
                  class: ['ck', 'ck-editor__main'],
                  role: 'presentation',
                },
                children: this.main,
              },
            ],
          });
        }
        _createVoiceLabel() {
          const e = this.t;
          const t = new Jb();
          t.text = e('Rich Text Editor');
          t.extendTemplate({ attributes: { class: 'ck-voice-label' } });
          return t;
        }
      }
      class Xb extends Hb {
        constructor(e, t, i) {
          super(e);
          this.setTemplate({
            tag: 'div',
            attributes: {
              class: [
                'ck',
                'ck-content',
                'ck-editor__editable',
                'ck-rounded-corners',
              ],
              lang: e.contentLanguage,
              dir: e.contentLanguageDirection,
            },
          });
          this.name = null;
          this.set('isFocused', false);
          this._editableElement = i;
          this._hasExternalElement = !!this._editableElement;
          this._editingView = t;
        }
        render() {
          super.render();
          if (this._hasExternalElement) {
            this.template.apply((this.element = this._editableElement));
          } else {
            this._editableElement = this.element;
          }
          this.on('change:isFocused', () => this._updateIsFocusedClasses());
          this._updateIsFocusedClasses();
        }
        destroy() {
          if (this._hasExternalElement) {
            this.template.revert(this._editableElement);
          }
          super.destroy();
        }
        _updateIsFocusedClasses() {
          const e = this._editingView;
          if (e.isRenderingInProgress) {
            i(this);
          } else {
            t(this);
          }
          function t(t) {
            e.change((i) => {
              const n = e.document.getRoot(t.name);
              i.addClass(t.isFocused ? 'ck-focused' : 'ck-blurred', n);
              i.removeClass(t.isFocused ? 'ck-blurred' : 'ck-focused', n);
            });
          }
          function i(n) {
            e.once('change:isRenderingInProgress', (e, o, r) => {
              if (!r) {
                t(n);
              } else {
                i(n);
              }
            });
          }
        }
      }
      class ew extends Xb {
        constructor(e, t, i) {
          super(e, t, i);
          this.extendTemplate({
            attributes: {
              role: 'textbox',
              class: 'ck-editor__editable_inline',
            },
          });
        }
        render() {
          super.render();
          const e = this._editingView;
          const t = this.t;
          e.change((i) => {
            const n = e.document.getRoot(this.name);
            i.setAttribute(
              'aria-label',
              t('Rich Text Editor, %0', [this.name]),
              n
            );
          });
        }
      }
      function tw(e) {
        return (t) => t + e;
      }
      var iw = i(22);
      const nw = tw('px');
      class ow extends Hb {
        constructor(e) {
          super(e);
          const t = this.bindTemplate;
          this.set('isActive', false);
          this.set('isSticky', false);
          this.set('limiterElement', null);
          this.set('limiterBottomOffset', 50);
          this.set('viewportTopOffset', 0);
          this.set('_marginLeft', null);
          this.set('_isStickyToTheLimiter', false);
          this.set('_hasViewportTopOffset', false);
          this.content = this.createCollection();
          this._contentPanelPlaceholder = new mb({
            tag: 'div',
            attributes: {
              class: ['ck', 'ck-sticky-panel__placeholder'],
              style: {
                display: t.to('isSticky', (e) => (e ? 'block' : 'none')),
                height: t.to('isSticky', (e) =>
                  e ? nw(this._panelRect.height) : null
                ),
              },
            },
          }).render();
          this._contentPanel = new mb({
            tag: 'div',
            attributes: {
              class: [
                'ck',
                'ck-sticky-panel__content',
                t.if('isSticky', 'ck-sticky-panel__content_sticky'),
                t.if(
                  '_isStickyToTheLimiter',
                  'ck-sticky-panel__content_sticky_bottom-limit'
                ),
              ],
              style: {
                width: t.to('isSticky', (e) =>
                  e
                    ? nw(
                        this._contentPanelPlaceholder.getBoundingClientRect()
                          .width
                      )
                    : null
                ),
                top: t.to('_hasViewportTopOffset', (e) =>
                  e ? nw(this.viewportTopOffset) : null
                ),
                bottom: t.to('_isStickyToTheLimiter', (e) =>
                  e ? nw(this.limiterBottomOffset) : null
                ),
                marginLeft: t.to('_marginLeft'),
              },
            },
            children: this.content,
          }).render();
          this.setTemplate({
            tag: 'div',
            attributes: { class: ['ck', 'ck-sticky-panel'] },
            children: [this._contentPanelPlaceholder, this._contentPanel],
          });
        }
        render() {
          super.render();
          this._checkIfShouldBeSticky();
          this.listenTo(Vd.window, 'scroll', () => {
            this._checkIfShouldBeSticky();
          });
          this.listenTo(this, 'change:isActive', () => {
            this._checkIfShouldBeSticky();
          });
        }
        _checkIfShouldBeSticky() {
          const e = (this._panelRect =
            this._contentPanel.getBoundingClientRect());
          let t;
          if (!this.limiterElement) {
            this.isSticky = false;
          } else {
            t = this._limiterRect = this.limiterElement.getBoundingClientRect();
            this.isSticky =
              this.isActive &&
              t.top < this.viewportTopOffset &&
              this._panelRect.height + this.limiterBottomOffset < t.height;
          }
          if (this.isSticky) {
            this._isStickyToTheLimiter =
              t.bottom <
              e.height + this.limiterBottomOffset + this.viewportTopOffset;
            this._hasViewportTopOffset =
              !this._isStickyToTheLimiter && !!this.viewportTopOffset;
            this._marginLeft = this._isStickyToTheLimiter
              ? null
              : nw(-Vd.window.scrollX);
          } else {
            this._isStickyToTheLimiter = false;
            this._hasViewportTopOffset = false;
            this._marginLeft = null;
          }
        }
      }
      class rw {
        constructor(e) {
          Object.assign(this, e);
          if (e.actions && e.keystrokeHandler) {
            for (const t in e.actions) {
              let i = e.actions[t];
              if (typeof i == 'string') {
                i = [i];
              }
              for (const n of i) {
                e.keystrokeHandler.set(n, (e, i) => {
                  this[t]();
                  i();
                });
              }
            }
          }
        }
        get first() {
          return this.focusables.find(sw) || null;
        }
        get last() {
          return this.focusables.filter(sw).slice(-1)[0] || null;
        }
        get next() {
          return this._getFocusableItem(1);
        }
        get previous() {
          return this._getFocusableItem(-1);
        }
        get current() {
          let e = null;
          if (this.focusTracker.focusedElement === null) {
            return null;
          }
          this.focusables.find((t, i) => {
            const n = t.element === this.focusTracker.focusedElement;
            if (n) {
              e = i;
            }
            return n;
          });
          return e;
        }
        focusFirst() {
          this._focus(this.first);
        }
        focusLast() {
          this._focus(this.last);
        }
        focusNext() {
          this._focus(this.next);
        }
        focusPrevious() {
          this._focus(this.previous);
        }
        _focus(e) {
          if (e) {
            e.focus();
          }
        }
        _getFocusableItem(e) {
          const t = this.current;
          const i = this.focusables.length;
          if (!i) {
            return null;
          }
          if (t === null) {
            return this[e === 1 ? 'first' : 'last'];
          }
          let n = (t + i + e) % i;
          do {
            const t = this.focusables.get(n);
            if (sw(t)) {
              return t;
            }
            n = (n + i + e) % i;
          } while (n !== t);
          return null;
        }
      }
      function sw(e) {
        return !!(
          e.focus && Vd.window.getComputedStyle(e.element).display != 'none'
        );
      }
      class aw extends Hb {
        constructor(e) {
          super(e);
          this.setTemplate({
            tag: 'span',
            attributes: { class: ['ck', 'ck-toolbar__separator'] },
          });
        }
      }
      const cw = 100;
      class lw {
        constructor(e, t) {
          if (!lw._observerInstance) {
            lw._createObserver();
          }
          this._element = e;
          this._callback = t;
          lw._addElementCallback(e, t);
          lw._observerInstance.observe(e);
        }
        destroy() {
          lw._deleteElementCallback(this._element, this._callback);
        }
        static _addElementCallback(e, t) {
          if (!lw._elementCallbacks) {
            lw._elementCallbacks = new Map();
          }
          let i = lw._elementCallbacks.get(e);
          if (!i) {
            i = new Set();
            lw._elementCallbacks.set(e, i);
          }
          i.add(t);
        }
        static _deleteElementCallback(e, t) {
          const i = lw._getElementCallbacks(e);
          if (i) {
            i.delete(t);
            if (!i.size) {
              lw._elementCallbacks.delete(e);
              lw._observerInstance.unobserve(e);
            }
          }
          if (lw._elementCallbacks && !lw._elementCallbacks.size) {
            lw._observerInstance = null;
            lw._elementCallbacks = null;
          }
        }
        static _getElementCallbacks(e) {
          if (!lw._elementCallbacks) {
            return null;
          }
          return lw._elementCallbacks.get(e);
        }
        static _createObserver() {
          let e;
          if (typeof Vd.window.ResizeObserver === 'function') {
            e = Vd.window.ResizeObserver;
          } else {
            e = dw;
          }
          lw._observerInstance = new e((e) => {
            for (const t of e) {
              const e = lw._getElementCallbacks(t.target);
              if (e) {
                for (const i of e) {
                  i(t);
                }
              }
            }
          });
        }
      }
      lw._observerInstance = null;
      lw._elementCallbacks = null;
      class dw {
        constructor(e) {
          this._callback = e;
          this._elements = new Set();
          this._previousRects = new Map();
          this._periodicCheckTimeout = null;
        }
        observe(e) {
          this._elements.add(e);
          this._checkElementRectsAndExecuteCallback();
          if (this._elements.size === 1) {
            this._startPeriodicCheck();
          }
        }
        unobserve(e) {
          this._elements.delete(e);
          this._previousRects.delete(e);
          if (!this._elements.size) {
            this._stopPeriodicCheck();
          }
        }
        _startPeriodicCheck() {
          const e = () => {
            this._checkElementRectsAndExecuteCallback();
            this._periodicCheckTimeout = setTimeout(e, cw);
          };
          this.listenTo(Vd.window, 'resize', () => {
            this._checkElementRectsAndExecuteCallback();
          });
          this._periodicCheckTimeout = setTimeout(e, cw);
        }
        _stopPeriodicCheck() {
          clearTimeout(this._periodicCheckTimeout);
          this.stopListening();
          this._previousRects.clear();
        }
        _checkElementRectsAndExecuteCallback() {
          const e = [];
          for (const t of this._elements) {
            if (this._hasRectChanged(t)) {
              e.push({ target: t, contentRect: this._previousRects.get(t) });
            }
          }
          if (e.length) {
            this._callback(e);
          }
        }
        _hasRectChanged(e) {
          if (!e.ownerDocument.body.contains(e)) {
            return false;
          }
          const t = new Ch(e);
          const i = this._previousRects.get(e);
          const n = !i || !i.isEqual(t);
          this._previousRects.set(e, t);
          return n;
        }
      }
      ys(dw, Kd);
      function uw(e) {
        return e.bindTemplate.to((t) => {
          if (t.target === e.element) {
            t.preventDefault();
          }
        });
      }
      class hw extends Hb {
        constructor(e) {
          super(e);
          const t = this.bindTemplate;
          this.set('isVisible', false);
          this.set('position', 'se');
          this.children = this.createCollection();
          this.setTemplate({
            tag: 'div',
            attributes: {
              class: [
                'ck',
                'ck-reset',
                'ck-dropdown__panel',
                t.to('position', (e) => `ck-dropdown__panel_${e}`),
                t.if('isVisible', 'ck-dropdown__panel-visible'),
              ],
            },
            children: this.children,
            on: { selectstart: t.to((e) => e.preventDefault()) },
          });
        }
        focus() {
          if (this.children.length) {
            this.children.first.focus();
          }
        }
        focusLast() {
          if (this.children.length) {
            const e = this.children.last;
            if (typeof e.focusLast === 'function') {
              e.focusLast();
            } else {
              e.focus();
            }
          }
        }
      }
      var fw = i(24);
      function gw(e) {
        if (!e || !e.parentNode) {
          return null;
        }
        if (e.offsetParent === Vd.document.body) {
          return null;
        }
        return e.offsetParent;
      }
      function mw({
        element: e,
        target: t,
        positions: i,
        limiter: n,
        fitInViewport: o,
      }) {
        if (ge(t)) {
          t = t();
        }
        if (ge(n)) {
          n = n();
        }
        const r = gw(e);
        const s = new Ch(e);
        const a = new Ch(t);
        let c;
        let l;
        if (!n && !o) {
          [l, c] = pw(i[0], a, s);
        } else {
          const e = n && new Ch(n).getVisible();
          const t = o && new Ch(Vd.window);
          const r = bw(i, {
            targetRect: a,
            elementRect: s,
            limiterRect: e,
            viewportRect: t,
          });
          [l, c] = r || pw(i[0], a, s);
        }
        let d = vw(c);
        if (r) {
          d = _w(d, r);
        }
        return { left: d.left, top: d.top, name: l };
      }
      function pw(e, t, i) {
        const n = e(t, i);
        if (!n) {
          return null;
        }
        const { left: o, top: r, name: s } = n;
        return [s, i.clone().moveTo(o, r)];
      }
      function bw(e, t) {
        const { elementRect: i, viewportRect: n } = t;
        const o = i.getArea();
        const r = ww(e, t);
        if (n) {
          const e = r.filter(({ viewportIntersectArea: e }) => e === o);
          const t = kw(e, o);
          if (t) {
            return t;
          }
        }
        return kw(r, o);
      }
      function ww(
        e,
        { targetRect: t, elementRect: i, limiterRect: n, viewportRect: o }
      ) {
        const r = [];
        const s = i.getArea();
        for (const a of e) {
          const e = pw(a, t, i);
          if (!e) {
            continue;
          }
          const [c, l] = e;
          let d = 0;
          let u = 0;
          if (n) {
            if (o) {
              const e = n.getIntersection(o);
              if (e) {
                d = e.getIntersectionArea(l);
              }
            } else {
              d = n.getIntersectionArea(l);
            }
          }
          if (o) {
            u = o.getIntersectionArea(l);
          }
          const h = {
            positionName: c,
            positionRect: l,
            limiterIntersectArea: d,
            viewportIntersectArea: u,
          };
          if (d === s) {
            return [h];
          }
          r.push(h);
        }
        return r;
      }
      function kw(e, t) {
        let i = 0;
        let n;
        let o;
        for (const {
          positionName: r,
          positionRect: s,
          limiterIntersectArea: a,
          viewportIntersectArea: c,
        } of e) {
          if (a === t) {
            return [r, s];
          }
          const e = c ** 2 + a ** 2;
          if (e > i) {
            i = e;
            n = s;
            o = r;
          }
        }
        return n ? [o, n] : null;
      }
      function _w({ left: e, top: t }, i) {
        const n = vw(new Ch(i));
        const o = Ah(i);
        e -= n.left;
        t -= n.top;
        e += i.scrollLeft;
        t += i.scrollTop;
        e -= o.left;
        t -= o.top;
        return { left: e, top: t };
      }
      function vw({ left: e, top: t }) {
        const { scrollX: i, scrollY: n } = Vd.window;
        return { left: e + i, top: t + n };
      }
      class yw extends Hb {
        constructor(e, t, i) {
          super(e);
          const n = this.bindTemplate;
          this.buttonView = t;
          this.panelView = i;
          this.set('isOpen', false);
          this.set('isEnabled', true);
          this.set('class');
          this.set('id');
          this.set('panelPosition', 'auto');
          this.keystrokes = new Vp();
          this.setTemplate({
            tag: 'div',
            attributes: {
              class: [
                'ck',
                'ck-dropdown',
                n.to('class'),
                n.if('isEnabled', 'ck-disabled', (e) => !e),
              ],
              id: n.to('id'),
              'aria-describedby': n.to('ariaDescribedById'),
            },
            children: [t, i],
          });
          t.extendTemplate({ attributes: { class: ['ck-dropdown__button'] } });
        }
        render() {
          super.render();
          this.listenTo(this.buttonView, 'open', () => {
            this.isOpen = !this.isOpen;
          });
          this.panelView.bind('isVisible').to(this, 'isOpen');
          this.on('change:isOpen', () => {
            if (!this.isOpen) {
              return;
            }
            if (this.panelPosition === 'auto') {
              this.panelView.position = yw._getOptimalPosition({
                element: this.panelView.element,
                target: this.buttonView.element,
                fitInViewport: true,
                positions: this._panelPositions,
              }).name;
            } else {
              this.panelView.position = this.panelPosition;
            }
          });
          this.keystrokes.listenTo(this.element);
          const e = (e, t) => {
            if (this.isOpen) {
              this.buttonView.focus();
              this.isOpen = false;
              t();
            }
          };
          this.keystrokes.set('arrowdown', (e, t) => {
            if (this.buttonView.isEnabled && !this.isOpen) {
              this.isOpen = true;
              t();
            }
          });
          this.keystrokes.set('arrowright', (e, t) => {
            if (this.isOpen) {
              t();
            }
          });
          this.keystrokes.set('arrowleft', e);
          this.keystrokes.set('esc', e);
        }
        focus() {
          this.buttonView.focus();
        }
        get _panelPositions() {
          const {
            southEast: e,
            southWest: t,
            northEast: i,
            northWest: n,
          } = yw.defaultPanelPositions;
          if (this.locale.uiLanguageDirection === 'ltr') {
            return [e, t, i, n];
          } else {
            return [t, e, n, i];
          }
        }
      }
      yw.defaultPanelPositions = {
        southEast: (e) => ({ top: e.bottom, left: e.left, name: 'se' }),
        southWest: (e, t) => ({
          top: e.bottom,
          left: e.left - t.width + e.width,
          name: 'sw',
        }),
        northEast: (e, t) => ({
          top: e.top - t.height,
          left: e.left,
          name: 'ne',
        }),
        northWest: (e, t) => ({
          top: e.bottom - t.height,
          left: e.left - t.width + e.width,
          name: 'nw',
        }),
      };
      yw._getOptimalPosition = mw;
      var xw = i(26);
      class Aw extends Hb {
        constructor() {
          super();
          const e = this.bindTemplate;
          this.set('content', '');
          this.set('viewBox', '0 0 20 20');
          this.set('fillColor', '');
          this.setTemplate({
            tag: 'svg',
            ns: 'http://www.w3.org/2000/svg',
            attributes: { class: ['ck', 'ck-icon'], viewBox: e.to('viewBox') },
          });
        }
        render() {
          super.render();
          this._updateXMLContent();
          this._colorFillPaths();
          this.on('change:content', () => {
            this._updateXMLContent();
            this._colorFillPaths();
          });
          this.on('change:fillColor', () => {
            this._colorFillPaths();
          });
        }
        _updateXMLContent() {
          if (this.content) {
            const e = new DOMParser().parseFromString(
              this.content.trim(),
              'image/svg+xml'
            );
            const t = e.querySelector('svg');
            const i = t.getAttribute('viewBox');
            if (i) {
              this.viewBox = i;
            }
            this.element.innerHTML = '';
            while (t.childNodes.length > 0) {
              this.element.appendChild(t.childNodes[0]);
            }
          }
        }
        _colorFillPaths() {
          if (this.fillColor) {
            this.element.querySelectorAll('.ck-icon__fill').forEach((e) => {
              e.style.fill = this.fillColor;
            });
          }
        }
      }
      var Tw = i(28);
      class Cw extends Hb {
        constructor(e) {
          super(e);
          this.set('text', '');
          this.set('position', 's');
          const t = this.bindTemplate;
          this.setTemplate({
            tag: 'span',
            attributes: {
              class: [
                'ck',
                'ck-tooltip',
                t.to('position', (e) => 'ck-tooltip_' + e),
                t.if('text', 'ck-hidden', (e) => !e.trim()),
              ],
            },
            children: [
              {
                tag: 'span',
                attributes: { class: ['ck', 'ck-tooltip__text'] },
                children: [{ text: t.to('text') }],
              },
            ],
          });
        }
      }
      var Pw = i(30);
      class Ew extends Hb {
        constructor(e) {
          super(e);
          const t = this.bindTemplate;
          const i = is();
          this.set('class');
          this.set('labelStyle');
          this.set('icon');
          this.set('isEnabled', true);
          this.set('isOn', false);
          this.set('isVisible', true);
          this.set('isToggleable', false);
          this.set('keystroke');
          this.set('label');
          this.set('tabindex', -1);
          this.set('tooltip');
          this.set('tooltipPosition', 's');
          this.set('type', 'button');
          this.set('withText', false);
          this.set('withKeystroke', false);
          this.children = this.createCollection();
          this.tooltipView = this._createTooltipView();
          this.labelView = this._createLabelView(i);
          this.iconView = new Aw();
          this.iconView.extendTemplate({
            attributes: { class: 'ck-button__icon' },
          });
          this.keystrokeView = this._createKeystrokeView();
          this.bind('_tooltipString').to(
            this,
            'tooltip',
            this,
            'label',
            this,
            'keystroke',
            this._getTooltipString.bind(this)
          );
          this.setTemplate({
            tag: 'button',
            attributes: {
              class: [
                'ck',
                'ck-button',
                t.to('class'),
                t.if('isEnabled', 'ck-disabled', (e) => !e),
                t.if('isVisible', 'ck-hidden', (e) => !e),
                t.to('isOn', (e) => (e ? 'ck-on' : 'ck-off')),
                t.if('withText', 'ck-button_with-text'),
                t.if('withKeystroke', 'ck-button_with-keystroke'),
              ],
              type: t.to('type', (e) => (e ? e : 'button')),
              tabindex: t.to('tabindex'),
              'aria-labelledby': `ck-editor__aria-label_${i}`,
              'aria-disabled': t.if('isEnabled', true, (e) => !e),
              'aria-pressed': t.to('isOn', (e) =>
                this.isToggleable ? String(e) : false
              ),
            },
            children: this.children,
            on: {
              mousedown: t.to((e) => {
                e.preventDefault();
              }),
              click: t.to((e) => {
                if (this.isEnabled) {
                  this.fire('execute');
                } else {
                  e.preventDefault();
                }
              }),
            },
          });
        }
        render() {
          super.render();
          if (this.icon) {
            this.iconView.bind('content').to(this, 'icon');
            this.children.add(this.iconView);
          }
          this.children.add(this.tooltipView);
          this.children.add(this.labelView);
          if (this.withKeystroke) {
            this.children.add(this.keystrokeView);
          }
        }
        focus() {
          this.element.focus();
        }
        _createTooltipView() {
          const e = new Cw();
          e.bind('text').to(this, '_tooltipString');
          e.bind('position').to(this, 'tooltipPosition');
          return e;
        }
        _createLabelView(e) {
          const t = new Hb();
          const i = this.bindTemplate;
          t.setTemplate({
            tag: 'span',
            attributes: {
              class: ['ck', 'ck-button__label'],
              style: i.to('labelStyle'),
              id: `ck-editor__aria-label_${e}`,
            },
            children: [{ text: this.bindTemplate.to('label') }],
          });
          return t;
        }
        _createKeystrokeView() {
          const e = new Hb();
          e.setTemplate({
            tag: 'span',
            attributes: { class: ['ck', 'ck-button__keystroke'] },
            children: [
              { text: this.bindTemplate.to('keystroke', (e) => Vl(e)) },
            ],
          });
          return e;
        }
        _getTooltipString(e, t, i) {
          if (e) {
            if (typeof e == 'string') {
              return e;
            } else {
              if (i) {
                i = Vl(i);
              }
              if (e instanceof Function) {
                return e(t, i);
              } else {
                return `${t}${i ? ` (${i})` : ''}`;
              }
            }
          }
          return '';
        }
      }
      var Sw =
        '<svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><path d="M.941 4.523a.75.75 0 1 1 1.06-1.06l3.006 3.005 3.005-3.005a.75.75 0 1 1 1.06 1.06l-3.549 3.55a.75.75 0 0 1-1.168-.136L.941 4.523z"/></svg>';
      class Mw extends Ew {
        constructor(e) {
          super(e);
          this.arrowView = this._createArrowView();
          this.extendTemplate({ attributes: { 'aria-haspopup': true } });
          this.delegate('execute').to(this, 'open');
        }
        render() {
          super.render();
          this.children.add(this.arrowView);
        }
        _createArrowView() {
          const e = new Aw();
          e.content = Sw;
          e.extendTemplate({ attributes: { class: 'ck-dropdown__arrow' } });
          return e;
        }
      }
      var Iw = i(32);
      class Nw extends Hb {
        constructor() {
          super();
          this.items = this.createCollection();
          this.focusTracker = new Qp();
          this.keystrokes = new Vp();
          this._focusCycler = new rw({
            focusables: this.items,
            focusTracker: this.focusTracker,
            keystrokeHandler: this.keystrokes,
            actions: { focusPrevious: 'arrowup', focusNext: 'arrowdown' },
          });
          this.setTemplate({
            tag: 'ul',
            attributes: { class: ['ck', 'ck-reset', 'ck-list'] },
            children: this.items,
          });
        }
        render() {
          super.render();
          for (const e of this.items) {
            this.focusTracker.add(e.element);
          }
          this.items.on('add', (e, t) => {
            this.focusTracker.add(t.element);
          });
          this.items.on('remove', (e, t) => {
            this.focusTracker.remove(t.element);
          });
          this.keystrokes.listenTo(this.element);
        }
        focus() {
          this._focusCycler.focusFirst();
        }
        focusLast() {
          this._focusCycler.focusLast();
        }
      }
      class Ow extends Hb {
        constructor(e) {
          super(e);
          this.children = this.createCollection();
          this.setTemplate({
            tag: 'li',
            attributes: { class: ['ck', 'ck-list__item'] },
            children: this.children,
          });
        }
        focus() {
          this.children.first.focus();
        }
      }
      class zw extends Hb {
        constructor(e) {
          super(e);
          this.setTemplate({
            tag: 'li',
            attributes: { class: ['ck', 'ck-list__separator'] },
          });
        }
      }
      var Rw = i(34);
      class Lw extends Ew {
        constructor(e) {
          super(e);
          this.isToggleable = true;
          this.toggleSwitchView = this._createToggleView();
          this.extendTemplate({ attributes: { class: 'ck-switchbutton' } });
        }
        render() {
          super.render();
          this.children.add(this.toggleSwitchView);
        }
        _createToggleView() {
          const e = new Hb();
          e.setTemplate({
            tag: 'span',
            attributes: { class: ['ck', 'ck-button__toggle'] },
            children: [
              {
                tag: 'span',
                attributes: { class: ['ck', 'ck-button__toggle__inner'] },
              },
            ],
          });
          return e;
        }
      }
      function Vw({
        emitter: e,
        activator: t,
        callback: i,
        contextElements: n,
      }) {
        e.listenTo(document, 'mousedown', (e, o) => {
          if (!t()) {
            return;
          }
          const r = typeof o.composedPath == 'function' ? o.composedPath() : [];
          for (const e of n) {
            if (e.contains(o.target) || r.includes(e)) {
              return;
            }
          }
          i();
        });
      }
      var Dw = i(36);
      var jw = i(38);
      function Bw(e, t = Mw) {
        const i = new t(e);
        const n = new hw(e);
        const o = new yw(e, i, n);
        i.bind('isEnabled').to(o);
        if (i instanceof Mw) {
          i.bind('isOn').to(o, 'isOpen');
        } else {
          i.arrowView.bind('isOn').to(o, 'isOpen');
        }
        Uw(o);
        return o;
      }
      function Fw(e, t) {
        const i = e.locale;
        const n = i.t;
        const o = (e.toolbarView = new Kw(i));
        o.set('ariaLabel', n('Dropdown toolbar'));
        e.extendTemplate({ attributes: { class: ['ck-toolbar-dropdown'] } });
        t.map((e) => o.items.add(e));
        e.panelView.children.add(o);
        o.items.delegate('execute').to(e);
      }
      function Hw(e, t) {
        const i = e.locale;
        const n = (e.listView = new Nw(i));
        n.items.bindTo(t).using(({ type: e, model: t }) => {
          if (e === 'separator') {
            return new zw(i);
          } else if (e === 'button' || e === 'switchbutton') {
            const n = new Ow(i);
            let o;
            if (e === 'button') {
              o = new Ew(i);
            } else {
              o = new Lw(i);
            }
            o.bind(...Object.keys(t)).to(t);
            o.delegate('execute').to(n);
            n.children.add(o);
            return n;
          }
        });
        e.panelView.children.add(n);
        n.items.delegate('execute').to(e);
      }
      function Uw(e) {
        qw(e);
        Ww(e);
        $w(e);
      }
      function qw(e) {
        e.on('render', () => {
          Vw({
            emitter: e,
            activator: () => e.isOpen,
            callback: () => {
              e.isOpen = false;
            },
            contextElements: [e.element],
          });
        });
      }
      function Ww(e) {
        e.on('execute', (t) => {
          if (t.source instanceof Lw) {
            return;
          }
          e.isOpen = false;
        });
      }
      function $w(e) {
        e.keystrokes.set('arrowdown', (t, i) => {
          if (e.isOpen) {
            e.panelView.focus();
            i();
          }
        });
        e.keystrokes.set('arrowup', (t, i) => {
          if (e.isOpen) {
            e.panelView.focusLast();
            i();
          }
        });
      }
      var Gw =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><circle cx="9.5" cy="4.5" r="1.5"/><circle cx="9.5" cy="10.5" r="1.5"/><circle cx="9.5" cy="16.5" r="1.5"/></svg>';
      var Yw = i(40);
      class Kw extends Hb {
        constructor(e, t) {
          super(e);
          const i = this.bindTemplate;
          const n = this.t;
          this.options = t || {};
          this.set('ariaLabel', n('Editor toolbar'));
          this.set('maxWidth', 'auto');
          this.items = this.createCollection();
          this.focusTracker = new Qp();
          this.keystrokes = new Vp();
          this.set('class');
          this.set('isCompact', false);
          this.itemsView = new Qw(e);
          this.children = this.createCollection();
          this.children.add(this.itemsView);
          this.focusables = this.createCollection();
          this._focusCycler = new rw({
            focusables: this.focusables,
            focusTracker: this.focusTracker,
            keystrokeHandler: this.keystrokes,
            actions: {
              focusPrevious: ['arrowleft', 'arrowup'],
              focusNext: ['arrowright', 'arrowdown'],
            },
          });
          this.setTemplate({
            tag: 'div',
            attributes: {
              class: [
                'ck',
                'ck-toolbar',
                i.to('class'),
                i.if('isCompact', 'ck-toolbar_compact'),
              ],
              role: 'toolbar',
              'aria-label': i.to('ariaLabel'),
              style: { maxWidth: i.to('maxWidth') },
            },
            children: this.children,
            on: { mousedown: uw(this) },
          });
          this._behavior = this.options.shouldGroupWhenFull
            ? new Zw(this)
            : new Jw(this);
        }
        render() {
          super.render();
          for (const e of this.items) {
            this.focusTracker.add(e.element);
          }
          this.items.on('add', (e, t) => {
            this.focusTracker.add(t.element);
          });
          this.items.on('remove', (e, t) => {
            this.focusTracker.remove(t.element);
          });
          this.keystrokes.listenTo(this.element);
          this._behavior.render(this);
        }
        destroy() {
          this._behavior.destroy();
          return super.destroy();
        }
        focus() {
          this._focusCycler.focusFirst();
        }
        focusLast() {
          this._focusCycler.focusLast();
        }
        fillFromConfig(e, t) {
          this.items.addMany(
            e
              .map((e) => {
                if (e == '|') {
                  return new aw();
                } else if (t.has(e)) {
                  return t.create(e);
                } else {
                  console.warn(
                    Object(ss['a'])(
                      'toolbarview-item-unavailable: The requested toolbar item is unavailable.'
                    ),
                    { name: e }
                  );
                }
              })
              .filter((e) => e !== undefined)
          );
        }
      }
      class Qw extends Hb {
        constructor(e) {
          super(e);
          this.children = this.createCollection();
          this.setTemplate({
            tag: 'div',
            attributes: { class: ['ck', 'ck-toolbar__items'] },
            children: this.children,
          });
        }
      }
      class Jw {
        constructor(e) {
          const t = e.bindTemplate;
          e.set('isVertical', false);
          e.itemsView.children.bindTo(e.items).using((e) => e);
          e.focusables.bindTo(e.items).using((e) => e);
          e.extendTemplate({
            attributes: { class: [t.if('isVertical', 'ck-toolbar_vertical')] },
          });
        }
        render() {}
        destroy() {}
      }
      class Zw {
        constructor(e) {
          this.view = e;
          this.viewChildren = e.children;
          this.viewFocusables = e.focusables;
          this.viewItemsView = e.itemsView;
          this.viewFocusTracker = e.focusTracker;
          this.viewLocale = e.locale;
          this.ungroupedItems = e.createCollection();
          this.groupedItems = e.createCollection();
          this.groupedItemsDropdown = this._createGroupedItemsDropdown();
          this.resizeObserver = null;
          this.cachedPadding = null;
          this.shouldUpdateGroupingOnNextResize = false;
          e.itemsView.children.bindTo(this.ungroupedItems).using((e) => e);
          this.ungroupedItems.on(
            'add',
            this._updateFocusCycleableItems.bind(this)
          );
          this.ungroupedItems.on(
            'remove',
            this._updateFocusCycleableItems.bind(this)
          );
          e.children.on('add', this._updateFocusCycleableItems.bind(this));
          e.children.on('remove', this._updateFocusCycleableItems.bind(this));
          e.items.on('change', (e, t) => {
            const i = t.index;
            for (const e of t.removed) {
              if (i >= this.ungroupedItems.length) {
                this.groupedItems.remove(e);
              } else {
                this.ungroupedItems.remove(e);
              }
            }
            for (let e = i; e < i + t.added.length; e++) {
              const n = t.added[e - i];
              if (e > this.ungroupedItems.length) {
                this.groupedItems.add(n, e - this.ungroupedItems.length);
              } else {
                this.ungroupedItems.add(n, e);
              }
            }
            this._updateGrouping();
          });
          e.extendTemplate({ attributes: { class: ['ck-toolbar_grouping'] } });
        }
        render(e) {
          this.viewElement = e.element;
          this._enableGroupingOnResize();
          this._enableGroupingOnMaxWidthChange(e);
        }
        destroy() {
          this.groupedItemsDropdown.destroy();
          this.resizeObserver.destroy();
        }
        _updateGrouping() {
          if (!this.viewElement.ownerDocument.body.contains(this.viewElement)) {
            return;
          }
          if (!this.viewElement.offsetParent) {
            this.shouldUpdateGroupingOnNextResize = true;
            return;
          }
          const e = this.groupedItems.length;
          let t;
          while (this._areItemsOverflowing) {
            this._groupLastItem();
            t = true;
          }
          if (!t && this.groupedItems.length) {
            while (this.groupedItems.length && !this._areItemsOverflowing) {
              this._ungroupFirstItem();
            }
            if (this._areItemsOverflowing) {
              this._groupLastItem();
            }
          }
          if (this.groupedItems.length !== e) {
            this.view.fire('groupedItemsUpdate');
          }
        }
        get _areItemsOverflowing() {
          if (!this.ungroupedItems.length) {
            return false;
          }
          const e = this.viewElement;
          const t = this.viewLocale.uiLanguageDirection;
          const i = new Ch(e.lastChild);
          const n = new Ch(e);
          if (!this.cachedPadding) {
            const i = Vd.window.getComputedStyle(e);
            const n = t === 'ltr' ? 'paddingRight' : 'paddingLeft';
            this.cachedPadding = Number.parseInt(i[n]);
          }
          if (t === 'ltr') {
            return i.right > n.right - this.cachedPadding;
          } else {
            return i.left < n.left + this.cachedPadding;
          }
        }
        _enableGroupingOnResize() {
          let e;
          this.resizeObserver = new lw(this.viewElement, (t) => {
            if (
              !e ||
              e !== t.contentRect.width ||
              this.shouldUpdateGroupingOnNextResize
            ) {
              this.shouldUpdateGroupingOnNextResize = false;
              this._updateGrouping();
              e = t.contentRect.width;
            }
          });
          this._updateGrouping();
        }
        _enableGroupingOnMaxWidthChange(e) {
          e.on('change:maxWidth', () => {
            this._updateGrouping();
          });
        }
        _groupLastItem() {
          if (!this.groupedItems.length) {
            this.viewChildren.add(new aw());
            this.viewChildren.add(this.groupedItemsDropdown);
            this.viewFocusTracker.add(this.groupedItemsDropdown.element);
          }
          this.groupedItems.add(
            this.ungroupedItems.remove(this.ungroupedItems.last),
            0
          );
        }
        _ungroupFirstItem() {
          this.ungroupedItems.add(
            this.groupedItems.remove(this.groupedItems.first)
          );
          if (!this.groupedItems.length) {
            this.viewChildren.remove(this.groupedItemsDropdown);
            this.viewChildren.remove(this.viewChildren.last);
            this.viewFocusTracker.remove(this.groupedItemsDropdown.element);
          }
        }
        _createGroupedItemsDropdown() {
          const e = this.viewLocale;
          const t = e.t;
          const i = Bw(e);
          i.class = 'ck-toolbar__grouped-dropdown';
          i.panelPosition = e.uiLanguageDirection === 'ltr' ? 'sw' : 'se';
          Fw(i, []);
          i.buttonView.set({
            label: t('Show more items'),
            tooltip: true,
            icon: Gw,
          });
          i.toolbarView.items.bindTo(this.groupedItems).using((e) => e);
          return i;
        }
        _updateFocusCycleableItems() {
          this.viewFocusables.clear();
          this.ungroupedItems.map((e) => {
            this.viewFocusables.add(e);
          });
          if (this.groupedItems.length) {
            this.viewFocusables.add(this.groupedItemsDropdown);
          }
        }
      }
      var Xw = i(42);
      class ek extends Zb {
        constructor(e, t, i = {}) {
          super(e);
          this.stickyPanel = new ow(e);
          this.toolbar = new Kw(e, {
            shouldGroupWhenFull: i.shouldToolbarGroupWhenFull,
          });
          this.editable = new ew(e, t);
        }
        render() {
          super.render();
          this.stickyPanel.content.add(this.toolbar);
          this.top.add(this.stickyPanel);
          this.main.add(this.editable);
        }
      }
      function tk(e) {
        if (e instanceof HTMLTextAreaElement) {
          return e.value;
        }
        return e.innerHTML;
      }
      class ik extends jp {
        constructor(e, t) {
          super(t);
          if (Yr(e)) {
            this.sourceElement = e;
          }
          this.data.processor = new Gp(this.data.viewDocument);
          this.model.document.createRoot();
          const i = !this.config.get('toolbar.shouldNotGroupWhenFull');
          const n = new ek(this.locale, this.editing.view, {
            shouldToolbarGroupWhenFull: i,
          });
          this.ui = new ub(this, n);
          Wp(this);
        }
        destroy() {
          if (this.sourceElement) {
            this.updateSourceElement();
          }
          this.ui.destroy();
          return super.destroy();
        }
        static create(e, t = {}) {
          return new Promise((i) => {
            const n = new this(e, t);
            i(
              n
                .initPlugins()
                .then(() => n.ui.init(Yr(e) ? e : null))
                .then(() => {
                  if (!Yr(e) && t.initialData) {
                    throw new ss['b'](
                      'editor-create-initial-data: ' +
                        'The config.initialData option cannot be used together with initial data passed in Editor.create().',
                      null
                    );
                  }
                  const i = t.initialData || nk(e);
                  return n.data.init(i);
                })
                .then(() => n.fire('ready'))
                .then(() => n)
            );
          });
        }
      }
      ys(ik, Fp);
      ys(ik, qp);
      function nk(e) {
        return Yr(e) ? tk(e) : e;
      }
      class ok {
        constructor(e) {
          this.editor = e;
          this.set('isEnabled', true);
          this._disableStack = new Set();
        }
        forceDisabled(e) {
          this._disableStack.add(e);
          if (this._disableStack.size == 1) {
            this.on('set:isEnabled', rk, { priority: 'highest' });
            this.isEnabled = false;
          }
        }
        clearForceDisabled(e) {
          this._disableStack.delete(e);
          if (this._disableStack.size == 0) {
            this.off('set:isEnabled', rk);
            this.isEnabled = true;
          }
        }
        destroy() {
          this.stopListening();
        }
        static get isContextPlugin() {
          return false;
        }
      }
      ys(ok, Qc);
      function rk(e) {
        e.return = false;
        e.stop();
      }
      class sk {
        constructor(e) {
          this.editor = e;
          this.set('value', undefined);
          this.set('isEnabled', false);
          this._disableStack = new Set();
          this.decorate('execute');
          this.listenTo(this.editor.model.document, 'change', () => {
            this.refresh();
          });
          this.on(
            'execute',
            (e) => {
              if (!this.isEnabled) {
                e.stop();
              }
            },
            { priority: 'high' }
          );
          this.listenTo(e, 'change:isReadOnly', (e, t, i) => {
            if (i) {
              this.forceDisabled('readOnlyMode');
            } else {
              this.clearForceDisabled('readOnlyMode');
            }
          });
        }
        refresh() {
          this.isEnabled = true;
        }
        forceDisabled(e) {
          this._disableStack.add(e);
          if (this._disableStack.size == 1) {
            this.on('set:isEnabled', ak, { priority: 'highest' });
            this.isEnabled = false;
          }
        }
        clearForceDisabled(e) {
          this._disableStack.delete(e);
          if (this._disableStack.size == 0) {
            this.off('set:isEnabled', ak);
            this.refresh();
          }
        }
        execute() {}
        destroy() {
          this.stopListening();
        }
      }
      ys(sk, Qc);
      function ak(e) {
        e.return = false;
        e.stop();
      }
      function ck(e) {
        const t = e.next();
        if (t.done) {
          return null;
        }
        return t.value;
      }
      const lk = ['left', 'right', 'center', 'justify'];
      function dk(e) {
        return lk.includes(e);
      }
      function uk(e, t) {
        if (t.contentLanguageDirection == 'rtl') {
          return e === 'right';
        } else {
          return e === 'left';
        }
      }
      const hk = 'alignment';
      class fk extends sk {
        refresh() {
          const e = this.editor;
          const t = e.locale;
          const i = ck(
            this.editor.model.document.selection.getSelectedBlocks()
          );
          this.isEnabled = !!i && this._canBeAligned(i);
          if (this.isEnabled && i.hasAttribute('alignment')) {
            this.value = i.getAttribute('alignment');
          } else {
            this.value =
              t.contentLanguageDirection === 'rtl' ? 'right' : 'left';
          }
        }
        execute(e = {}) {
          const t = this.editor;
          const i = t.locale;
          const n = t.model;
          const o = n.document;
          const r = e.value;
          n.change((e) => {
            const t = Array.from(o.selection.getSelectedBlocks()).filter((e) =>
              this._canBeAligned(e)
            );
            const n = t[0].getAttribute('alignment');
            const s = uk(r, i) || n === r || !r;
            if (s) {
              gk(t, e);
            } else {
              mk(t, e, r);
            }
          });
        }
        _canBeAligned(e) {
          return this.editor.model.schema.checkAttribute(e, hk);
        }
      }
      function gk(e, t) {
        for (const i of e) {
          t.removeAttribute(hk, i);
        }
      }
      function mk(e, t, i) {
        for (const n of e) {
          t.setAttribute(hk, i, n);
        }
      }
      class pk extends ok {
        static get pluginName() {
          return 'AlignmentEditing';
        }
        constructor(e) {
          super(e);
          e.config.define('alignment', { options: [...lk] });
        }
        init() {
          const e = this.editor;
          const t = e.locale;
          const i = e.model.schema;
          const n = e.config.get('alignment.options').filter(dk);
          i.extend('$block', { allowAttributes: 'alignment' });
          e.model.schema.setAttributeProperties('alignment', {
            isFormatting: true,
          });
          const o = bk(n.filter((e) => !uk(e, t)));
          e.conversion.attributeToAttribute(o);
          e.commands.add('alignment', new fk(e));
        }
      }
      function bk(e) {
        const t = { model: { key: 'alignment', values: e.slice() }, view: {} };
        for (const i of e) {
          t.view[i] = { key: 'style', value: { 'text-align': i } };
        }
        return t;
      }
      var wk =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75z"/></svg>';
      var kk =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M18 3.75a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75zm0 8a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75zm0 4a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75zm0-8a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75z"/></svg>';
      var _k =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm2.286 4c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75z"/></svg>';
      var vk =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75z"/></svg>';
      const yk = new Map([
        ['left', wk],
        ['right', kk],
        ['center', _k],
        ['justify', vk],
      ]);
      class xk extends ok {
        get localizedOptionTitles() {
          const e = this.editor.t;
          return {
            left: e('Align left'),
            right: e('Align right'),
            center: e('Align center'),
            justify: e('Justify'),
          };
        }
        static get pluginName() {
          return 'AlignmentUI';
        }
        init() {
          const e = this.editor;
          const t = e.ui.componentFactory;
          const i = e.t;
          const n = e.config.get('alignment.options');
          n.filter(dk).forEach((e) => this._addButton(e));
          t.add('alignment', (e) => {
            const o = Bw(e);
            const r = n.map((e) => t.create(`alignment:${e}`));
            Fw(o, r);
            o.buttonView.set({ label: i('Text alignment'), tooltip: true });
            o.toolbarView.isVertical = true;
            o.toolbarView.ariaLabel = i('Text alignment toolbar');
            o.extendTemplate({
              attributes: { class: 'ck-alignment-dropdown' },
            });
            const s = e.contentLanguageDirection === 'rtl' ? kk : wk;
            o.buttonView.bind('icon').toMany(r, 'isOn', (...e) => {
              const t = e.findIndex((e) => e);
              if (t < 0) {
                return s;
              }
              return r[t].icon;
            });
            o.bind('isEnabled').toMany(r, 'isEnabled', (...e) =>
              e.some((e) => e)
            );
            return o;
          });
        }
        _addButton(e) {
          const t = this.editor;
          t.ui.componentFactory.add(`alignment:${e}`, (i) => {
            const n = t.commands.get('alignment');
            const o = new Ew(i);
            o.set({
              label: this.localizedOptionTitles[e],
              icon: yk.get(e),
              tooltip: true,
              isToggleable: true,
            });
            o.bind('isEnabled').to(n);
            o.bind('isOn').to(n, 'value', (t) => t === e);
            this.listenTo(o, 'execute', () => {
              t.execute('alignment', { value: e });
              t.editing.view.focus();
            });
            return o;
          });
        }
      }
      class Ak extends ok {
        static get requires() {
          return [pk, xk];
        }
        static get pluginName() {
          return 'Alignment';
        }
      }
      function Tk(e, t, i, n) {
        let o;
        let r = null;
        if (typeof n == 'function') {
          o = n;
        } else {
          r = e.commands.get(n);
          o = () => {
            e.execute(n);
          };
        }
        e.model.document.on('change:data', (n, s) => {
          if ((r && !r.isEnabled) || !t.isEnabled) {
            return;
          }
          const a = ck(e.model.document.selection.getRanges());
          if (!a.isCollapsed) {
            return;
          }
          if (s.type == 'transparent') {
            return;
          }
          const c = Array.from(e.model.document.differ.getChanges());
          const l = c[0];
          if (
            c.length != 1 ||
            l.type !== 'insert' ||
            l.name != '$text' ||
            l.length != 1
          ) {
            return;
          }
          const d = l.position.parent;
          if (d.is('element', 'codeBlock')) {
            return;
          }
          if (r && r.value === true) {
            return;
          }
          const u = d.getChild(0);
          const h = e.model.createRangeOn(u);
          if (!h.containsRange(a) && !a.end.isEqual(h.end)) {
            return;
          }
          const f = i.exec(u.data.substr(0, a.end.offset));
          if (!f) {
            return;
          }
          e.model.enqueueChange((e) => {
            const t = e.createPositionAt(d, 0);
            const i = e.createPositionAt(d, f[0].length);
            const n = new ff(t, i);
            const r = o({ match: f });
            if (r !== false) {
              e.remove(n);
            }
            n.detach();
          });
        });
      }
      function Ck(e, t, i, n) {
        let o;
        let r;
        if (i instanceof RegExp) {
          o = i;
        } else {
          r = i;
        }
        r =
          r ||
          ((e) => {
            let t;
            const i = [];
            const n = [];
            while ((t = o.exec(e)) !== null) {
              if (t && t.length < 4) {
                break;
              }
              let { index: e, 1: o, 2: r, 3: s } = t;
              const a = o + r + s;
              e += t[0].length - a.length;
              const c = [e, e + o.length];
              const l = [
                e + o.length + r.length,
                e + o.length + r.length + s.length,
              ];
              i.push(c);
              i.push(l);
              n.push([e + o.length, e + o.length + r.length]);
            }
            return { remove: i, format: n };
          });
        e.model.document.on('change:data', (i, o) => {
          if (o.type == 'transparent' || !t.isEnabled) {
            return;
          }
          const s = e.model;
          const a = s.document.selection;
          if (!a.isCollapsed) {
            return;
          }
          const c = Array.from(s.document.differ.getChanges());
          const l = c[0];
          if (
            c.length != 1 ||
            l.type !== 'insert' ||
            l.name != '$text' ||
            l.length != 1
          ) {
            return;
          }
          const d = a.focus;
          const u = d.parent;
          const { text: h, range: f } = Ek(
            s.createRange(s.createPositionAt(u, 0), d),
            s
          );
          const g = r(h);
          const m = Pk(f.start, g.format, s);
          const p = Pk(f.start, g.remove, s);
          if (!(m.length && p.length)) {
            return;
          }
          s.enqueueChange((e) => {
            const t = n(e, m);
            if (t === false) {
              return;
            }
            for (const t of p.reverse()) {
              e.remove(t);
            }
          });
        });
      }
      function Pk(e, t, i) {
        return t
          .filter((e) => e[0] !== undefined && e[1] !== undefined)
          .map((t) =>
            i.createRange(e.getShiftedBy(t[0]), e.getShiftedBy(t[1]))
          );
      }
      function Ek(e, t) {
        let i = e.start;
        const n = Array.from(e.getItems()).reduce((e, n) => {
          if (
            !(n.is('$text') || n.is('$textProxy')) ||
            n.getAttribute('code')
          ) {
            i = t.createPositionAfter(n);
            return '';
          }
          return e + n.data;
        }, '');
        return { text: n, range: t.createRange(i, e.end) };
      }
      class Sk extends ok {
        static get pluginName() {
          return 'Autoformat';
        }
        afterInit() {
          this._addListAutoformats();
          this._addBasicStylesAutoformats();
          this._addHeadingAutoformats();
          this._addBlockQuoteAutoformats();
          this._addCodeBlockAutoformats();
        }
        _addListAutoformats() {
          const e = this.editor.commands;
          if (e.get('bulletedList')) {
            Tk(this.editor, this, /^[*-]\s$/, 'bulletedList');
          }
          if (e.get('numberedList')) {
            Tk(this.editor, this, /^1[.|)]\s$/, 'numberedList');
          }
        }
        _addBasicStylesAutoformats() {
          const e = this.editor.commands;
          if (e.get('bold')) {
            const e = Mk(this.editor, 'bold');
            Ck(this.editor, this, /(\*\*)([^*]+)(\*\*)$/g, e);
            Ck(this.editor, this, /(__)([^_]+)(__)$/g, e);
          }
          if (e.get('italic')) {
            const e = Mk(this.editor, 'italic');
            Ck(this.editor, this, /(?:^|[^*])(\*)([^*_]+)(\*)$/g, e);
            Ck(this.editor, this, /(?:^|[^_])(_)([^_]+)(_)$/g, e);
          }
          if (e.get('code')) {
            const e = Mk(this.editor, 'code');
            Ck(this.editor, this, /(`)([^`]+)(`)$/g, e);
          }
          if (e.get('strikethrough')) {
            const e = Mk(this.editor, 'strikethrough');
            Ck(this.editor, this, /(~~)([^~]+)(~~)$/g, e);
          }
        }
        _addHeadingAutoformats() {
          const e = this.editor.commands.get('heading');
          if (e) {
            e.modelElements
              .filter((e) => e.match(/^heading[1-6]$/))
              .forEach((t) => {
                const i = t[7];
                const n = new RegExp(`^(#{${i}})\\s$`);
                Tk(this.editor, this, n, () => {
                  if (!e.isEnabled || e.value === t) {
                    return false;
                  }
                  this.editor.execute('heading', { value: t });
                });
              });
          }
        }
        _addBlockQuoteAutoformats() {
          if (this.editor.commands.get('blockQuote')) {
            Tk(this.editor, this, /^>\s$/, 'blockQuote');
          }
        }
        _addCodeBlockAutoformats() {
          if (this.editor.commands.get('codeBlock')) {
            Tk(this.editor, this, /^```$/, 'codeBlock');
          }
        }
      }
      function Mk(e, t) {
        return (i, n) => {
          const o = e.commands.get(t);
          if (!o.isEnabled) {
            return false;
          }
          const r = e.model.schema.getValidRanges(n, t);
          for (const e of r) {
            i.setAttribute(t, true, e);
          }
          i.removeSelectionAttribute(t);
        };
      }
      function Ik(e, t) {
        let i = e.start;
        const n = Array.from(e.getItems()).reduce((e, n) => {
          if (!(n.is('$text') || n.is('$textProxy'))) {
            i = t.createPositionAfter(n);
            return '';
          }
          return e + n.data;
        }, '');
        return { text: n, range: t.createRange(i, e.end) };
      }
      class Nk {
        constructor(e, t) {
          this.model = e;
          this.testCallback = t;
          this.hasMatch = false;
          this.set('isEnabled', true);
          this.on('change:isEnabled', () => {
            if (this.isEnabled) {
              this._startListening();
            } else {
              this.stopListening(e.document.selection);
              this.stopListening(e.document);
            }
          });
          this._startListening();
        }
        _startListening() {
          const e = this.model;
          const t = e.document;
          this.listenTo(
            t.selection,
            'change:range',
            (e, { directChange: i }) => {
              if (!i) {
                return;
              }
              if (!t.selection.isCollapsed) {
                if (this.hasMatch) {
                  this.fire('unmatched');
                  this.hasMatch = false;
                }
                return;
              }
              this._evaluateTextBeforeSelection('selection');
            }
          );
          this.listenTo(t, 'change:data', (e, t) => {
            if (t.type == 'transparent') {
              return;
            }
            this._evaluateTextBeforeSelection('data', { batch: t });
          });
        }
        _evaluateTextBeforeSelection(e, t = {}) {
          const i = this.model;
          const n = i.document;
          const o = n.selection;
          const r = i.createRange(
            i.createPositionAt(o.focus.parent, 0),
            o.focus
          );
          const { text: s, range: a } = Ik(r, i);
          const c = this.testCallback(s);
          if (!c && this.hasMatch) {
            this.fire('unmatched');
          }
          this.hasMatch = !!c;
          if (c) {
            const i = Object.assign(t, { text: s, range: a });
            if (typeof c == 'object') {
              Object.assign(i, c);
            }
            this.fire(`matched:${e}`, i);
          }
        }
      }
      ys(Nk, Qc);
      const Ok = 4;
      const zk = new RegExp(
        '(^|\\s)' +
          '(' +
          '(' +
          '(?:(?:(?:https?|ftp):)?\\/\\/)' +
          '(?:\\S+(?::\\S*)?@)?' +
          '(?:' +
          '(?![-_])(?:[-\\w\\u00a1-\\uffff]{0,63}[^-_]\\.)+' +
          '(?:[a-z\\u00a1-\\uffff]{2,})' +
          ')' +
          '(?::\\d{2,5})?' +
          '(?:[/?#]\\S*)?' +
          ')' +
          '|' +
          '(' +
          '(www.|(\\S+@))' +
          '((?![-_])(?:[-\\w\\u00a1-\\uffff]{0,63}[^-_]\\.))+' +
          '(?:[a-z\\u00a1-\\uffff]{2,})' +
          ')' +
          ')$',
        'i'
      );
      const Rk = 2;
      const Lk =
        /^[\S]+@((?![-_])(?:[-\w\u00a1-\uffff]{0,63}[^-_]\.))+(?:[a-z\u00a1-\uffff]{2,})$/i;
      class Vk extends ok {
        static get pluginName() {
          return 'AutoLink';
        }
        init() {
          const e = this.editor;
          const t = e.model.document.selection;
          t.on('change:range', () => {
            this.isEnabled = !t.anchor.parent.is('element', 'codeBlock');
          });
          this._enableTypingHandling();
        }
        afterInit() {
          this._enableEnterHandling();
          this._enableShiftEnterHandling();
        }
        _enableTypingHandling() {
          const e = this.editor;
          const t = new Nk(e.model, (e) => {
            if (!Dk(e)) {
              return;
            }
            const t = jk(e.substr(0, e.length - 1));
            if (t) {
              return { url: t };
            }
          });
          const i = e.plugins.get('Input');
          t.on('matched:data', (t, n) => {
            const { batch: o, range: r, url: s } = n;
            if (!i.isInput(o)) {
              return;
            }
            const a = r.end.getShiftedBy(-1);
            const c = a.getShiftedBy(-s.length);
            const l = e.model.createRange(c, a);
            this._applyAutoLink(s, l);
          });
          t.bind('isEnabled').to(this);
        }
        _enableEnterHandling() {
          const e = this.editor;
          const t = e.model;
          const i = e.commands.get('enter');
          if (!i) {
            return;
          }
          i.on('execute', () => {
            const e = t.document.selection.getFirstPosition();
            const i = t.createRange(
              t.createPositionAt(e.parent.previousSibling, 0),
              t.createPositionAt(e.parent.previousSibling, 'end')
            );
            this._checkAndApplyAutoLinkOnRange(i);
          });
        }
        _enableShiftEnterHandling() {
          const e = this.editor;
          const t = e.model;
          const i = e.commands.get('shiftEnter');
          if (!i) {
            return;
          }
          i.on('execute', () => {
            const e = t.document.selection.getFirstPosition();
            const i = t.createRange(
              t.createPositionAt(e.parent, 0),
              e.getShiftedBy(-1)
            );
            this._checkAndApplyAutoLinkOnRange(i);
          });
        }
        _checkAndApplyAutoLinkOnRange(e) {
          const t = this.editor.model;
          const { text: i, range: n } = Ik(e, t);
          const o = jk(i);
          if (o) {
            const e = t.createRange(n.end.getShiftedBy(-o.length), n.end);
            this._applyAutoLink(o, e);
          }
        }
        _applyAutoLink(e, t) {
          const i = this.editor.model;
          if (!this.isEnabled || !Fk(t, i)) {
            return;
          }
          i.enqueueChange((i) => {
            const n = Bk(e) ? `mailto:${e}` : e;
            i.setAttribute('linkHref', n, t);
          });
        }
      }
      function Dk(e) {
        return (
          e.length > Ok && e[e.length - 1] === ' ' && e[e.length - 2] !== ' '
        );
      }
      function jk(e) {
        const t = zk.exec(e);
        return t ? t[Rk] : null;
      }
      function Bk(e) {
        return Lk.exec(e);
      }
      function Fk(e, t) {
        return t.schema.checkAttributeInSelection(
          t.createSelection(e),
          'linkHref'
        );
      }
      class Hk {
        constructor(e) {
          this.context = e;
        }
        destroy() {
          this.stopListening();
        }
        static get isContextPlugin() {
          return true;
        }
      }
      ys(Hk, Qc);
      class Uk extends Hk {
        static get pluginName() {
          return 'PendingActions';
        }
        init() {
          this.set('hasAny', false);
          this._actions = new xs({ idProperty: '_id' });
          this._actions.delegate('add', 'remove').to(this);
        }
        add(e) {
          if (typeof e !== 'string') {
            throw new ss['b'](
              'pendingactions-add-invalid-message: The message must be a string.',
              this
            );
          }
          const t = Object.create(Qc);
          t.set('message', e);
          this._actions.add(t);
          this.hasAny = true;
          return t;
        }
        remove(e) {
          this._actions.remove(e);
          this.hasAny = !!this._actions.length;
        }
        get first() {
          return this._actions.get(0);
        }
        [Symbol.iterator]() {
          return this._actions[Symbol.iterator]();
        }
      }
      class qk extends ok {
        static get pluginName() {
          return 'Autosave';
        }
        static get requires() {
          return [Uk];
        }
        constructor(e) {
          super(e);
          const t = e.config.get('autosave') || {};
          const i = t.waitingTime || 1e3;
          this.set('state', 'synchronized');
          this._debouncedSave = ph(this._save.bind(this), i);
          this._lastDocumentVersion = e.model.document.version;
          this._domEmitter = Object.create(Kd);
          this._config = t;
        }
        init() {
          const e = this.editor;
          const t = e.model.document;
          const i = e.t;
          this._pendingActions = e.plugins.get(Uk);
          this.listenTo(t, 'change:data', () => {
            if (!this._saveCallbacks.length) {
              return;
            }
            if (this.state == 'synchronized') {
              this._action = this._pendingActions.add(i('Saving changes'));
              this.state = 'waiting';
              this._debouncedSave();
            } else if (this.state == 'waiting') {
              this._debouncedSave();
            }
          });
          this.listenTo(e, 'destroy', () => this._flush(), {
            priority: 'highest',
          });
          this._domEmitter.listenTo(window, 'beforeunload', (e, t) => {
            if (this._pendingActions.hasAny) {
              t.returnValue = this._pendingActions.first.message;
            }
          });
        }
        destroy() {
          this._domEmitter.stopListening();
          super.destroy();
        }
        _flush() {
          this._debouncedSave.flush();
        }
        _save() {
          const e = this.editor.model.document.version;
          if (
            e < this._lastDocumentVersion ||
            this.editor.state === 'initializing'
          ) {
            this._debouncedSave.cancel();
            return;
          }
          this._lastDocumentVersion = e;
          this.state = 'saving';
          Promise.resolve()
            .then(() =>
              Promise.all(this._saveCallbacks.map((e) => e(this.editor)))
            )
            .catch((e) => {
              this.state = 'error';
              this.state = 'saving';
              this._debouncedSave();
              throw e;
            })
            .then(() => {
              if (
                this.editor.model.document.version > this._lastDocumentVersion
              ) {
                this.state = 'waiting';
                this._debouncedSave();
              } else {
                this.state = 'synchronized';
                this._pendingActions.remove(this._action);
                this._action = null;
              }
            });
        }
        get _saveCallbacks() {
          const e = [];
          if (this.adapter && this.adapter.save) {
            e.push(this.adapter.save);
          }
          if (this._config.save) {
            e.push(this._config.save);
          }
          return e;
        }
      }
      ys(qk, Qc);
      class Wk extends sk {
        refresh() {
          this.value = this._getValue();
          this.isEnabled = this._checkEnabled();
        }
        execute(e = {}) {
          const t = this.editor.model;
          const i = t.schema;
          const n = t.document.selection;
          const o = Array.from(n.getSelectedBlocks());
          const r = e.forceValue === undefined ? !this.value : e.forceValue;
          t.change((e) => {
            if (!r) {
              this._removeQuote(e, o.filter($k));
            } else {
              const t = o.filter((e) => $k(e) || Yk(i, e));
              this._applyQuote(e, t);
            }
          });
        }
        _getValue() {
          const e = this.editor.model.document.selection;
          const t = ck(e.getSelectedBlocks());
          return !!(t && $k(t));
        }
        _checkEnabled() {
          if (this.value) {
            return true;
          }
          const e = this.editor.model.document.selection;
          const t = this.editor.model.schema;
          const i = ck(e.getSelectedBlocks());
          if (!i) {
            return false;
          }
          return Yk(t, i);
        }
        _removeQuote(e, t) {
          Gk(e, t)
            .reverse()
            .forEach((t) => {
              if (t.start.isAtStart && t.end.isAtEnd) {
                e.unwrap(t.start.parent);
                return;
              }
              if (t.start.isAtStart) {
                const i = e.createPositionBefore(t.start.parent);
                e.move(t, i);
                return;
              }
              if (!t.end.isAtEnd) {
                e.split(t.end);
              }
              const i = e.createPositionAfter(t.end.parent);
              e.move(t, i);
            });
        }
        _applyQuote(e, t) {
          const i = [];
          Gk(e, t)
            .reverse()
            .forEach((t) => {
              let n = $k(t.start);
              if (!n) {
                n = e.createElement('blockQuote');
                e.wrap(t, n);
              }
              i.push(n);
            });
          i.reverse().reduce((t, i) => {
            if (t.nextSibling == i) {
              e.merge(e.createPositionAfter(t));
              return t;
            }
            return i;
          });
        }
      }
      function $k(e) {
        return e.parent.name == 'blockQuote' ? e.parent : null;
      }
      function Gk(e, t) {
        let i;
        let n = 0;
        const o = [];
        while (n < t.length) {
          const r = t[n];
          const s = t[n + 1];
          if (!i) {
            i = e.createPositionBefore(r);
          }
          if (!s || r.nextSibling != s) {
            o.push(e.createRange(i, e.createPositionAfter(r)));
            i = null;
          }
          n++;
        }
        return o;
      }
      function Yk(e, t) {
        const i = e.checkChild(t.parent, 'blockQuote');
        const n = e.checkChild(['$root', 'blockQuote'], t);
        return i && n;
      }
      class Kk extends ok {
        static get pluginName() {
          return 'BlockQuoteEditing';
        }
        init() {
          const e = this.editor;
          const t = e.model.schema;
          e.commands.add('blockQuote', new Wk(e));
          t.register('blockQuote', {
            allowWhere: '$block',
            allowContentOf: '$root',
          });
          t.addChildCheck((e, t) => {
            if (e.endsWith('blockQuote') && t.name == 'blockQuote') {
              return false;
            }
          });
          e.conversion.elementToElement({
            model: 'blockQuote',
            view: 'blockquote',
          });
          e.model.document.registerPostFixer((i) => {
            const n = e.model.document.differ.getChanges();
            for (const e of n) {
              if (e.type == 'insert') {
                const n = e.position.nodeAfter;
                if (!n) {
                  continue;
                }
                if (n.is('element', 'blockQuote') && n.isEmpty) {
                  i.remove(n);
                  return true;
                } else if (
                  n.is('element', 'blockQuote') &&
                  !t.checkChild(e.position, n)
                ) {
                  i.unwrap(n);
                  return true;
                } else if (n.is('element')) {
                  const e = i.createRangeIn(n);
                  for (const n of e.getItems()) {
                    if (
                      n.is('element', 'blockQuote') &&
                      !t.checkChild(i.createPositionBefore(n), n)
                    ) {
                      i.unwrap(n);
                      return true;
                    }
                  }
                }
              } else if (e.type == 'remove') {
                const t = e.position.parent;
                if (t.is('element', 'blockQuote') && t.isEmpty) {
                  i.remove(t);
                  return true;
                }
              }
            }
            return false;
          });
        }
        afterInit() {
          const e = this.editor;
          const t = e.commands.get('blockQuote');
          this.listenTo(this.editor.editing.view.document, 'enter', (e, i) => {
            const n = this.editor.model.document;
            const o = n.selection.getLastPosition().parent;
            if (n.selection.isCollapsed && o.isEmpty && t.value) {
              this.editor.execute('blockQuote');
              this.editor.editing.view.scrollToTheSelection();
              i.preventDefault();
              e.stop();
            }
          });
        }
      }
      var Qk =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 10.423a6.5 6.5 0 0 1 6.056-6.408l.038.67C6.448 5.423 5.354 7.663 5.22 10H9c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574zm8 0a6.5 6.5 0 0 1 6.056-6.408l.038.67c-2.646.739-3.74 2.979-3.873 5.315H17c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574z"/></svg>';
      var Jk = i(44);
      class Zk extends ok {
        init() {
          const e = this.editor;
          const t = e.t;
          e.ui.componentFactory.add('blockQuote', (i) => {
            const n = e.commands.get('blockQuote');
            const o = new Ew(i);
            o.set({
              label: t('Block quote'),
              icon: Qk,
              tooltip: true,
              isToggleable: true,
            });
            o.bind('isOn', 'isEnabled').to(n, 'value', 'isEnabled');
            this.listenTo(o, 'execute', () => {
              e.execute('blockQuote');
              e.editing.view.focus();
            });
            return o;
          });
        }
      }
      class Xk extends ok {
        static get requires() {
          return [Kk, Zk];
        }
        static get pluginName() {
          return 'BlockQuote';
        }
      }
      class e_ extends sk {
        constructor(e, t) {
          super(e);
          this.attributeKey = t;
        }
        refresh() {
          const e = this.editor.model;
          const t = e.document;
          this.value = this._getValueFromFirstAllowedNode();
          this.isEnabled = e.schema.checkAttributeInSelection(
            t.selection,
            this.attributeKey
          );
        }
        execute(e = {}) {
          const t = this.editor.model;
          const i = t.document;
          const n = i.selection;
          const o = e.forceValue === undefined ? !this.value : e.forceValue;
          t.change((e) => {
            if (n.isCollapsed) {
              if (o) {
                e.setSelectionAttribute(this.attributeKey, true);
              } else {
                e.removeSelectionAttribute(this.attributeKey);
              }
            } else {
              const i = t.schema.getValidRanges(
                n.getRanges(),
                this.attributeKey
              );
              for (const t of i) {
                if (o) {
                  e.setAttribute(this.attributeKey, o, t);
                } else {
                  e.removeAttribute(this.attributeKey, t);
                }
              }
            }
          });
        }
        _getValueFromFirstAllowedNode() {
          const e = this.editor.model;
          const t = e.schema;
          const i = e.document.selection;
          if (i.isCollapsed) {
            return i.hasAttribute(this.attributeKey);
          }
          for (const e of i.getRanges()) {
            for (const i of e.getItems()) {
              if (t.checkAttribute(i, this.attributeKey)) {
                return i.hasAttribute(this.attributeKey);
              }
            }
          }
          return false;
        }
      }
      const t_ = 'bold';
      class i_ extends ok {
        static get pluginName() {
          return 'BoldEditing';
        }
        init() {
          const e = this.editor;
          e.model.schema.extend('$text', { allowAttributes: t_ });
          e.model.schema.setAttributeProperties(t_, {
            isFormatting: true,
            copyOnEnter: true,
          });
          e.conversion.attributeToElement({
            model: t_,
            view: 'strong',
            upcastAlso: [
              'b',
              (e) => {
                const t = e.getStyle('font-weight');
                if (!t) {
                  return null;
                }
                if (t == 'bold' || Number(t) >= 600) {
                  return { name: true, styles: ['font-weight'] };
                }
              },
            ],
          });
          e.commands.add(t_, new e_(e, t_));
          e.keystrokes.set('CTRL+B', t_);
        }
      }
      var n_ =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.187 17H5.773c-.637 0-1.092-.138-1.364-.415-.273-.277-.409-.718-.409-1.323V4.738c0-.617.14-1.062.419-1.332.279-.27.73-.406 1.354-.406h4.68c.69 0 1.288.041 1.793.124.506.083.96.242 1.36.478.341.197.644.447.906.75a3.262 3.262 0 0 1 .808 2.162c0 1.401-.722 2.426-2.167 3.075C15.05 10.175 16 11.315 16 13.01a3.756 3.756 0 0 1-2.296 3.504 6.1 6.1 0 0 1-1.517.377c-.571.073-1.238.11-2 .11zm-.217-6.217H7v4.087h3.069c1.977 0 2.965-.69 2.965-2.072 0-.707-.256-1.22-.768-1.537-.512-.319-1.277-.478-2.296-.478zM7 5.13v3.619h2.606c.729 0 1.292-.067 1.69-.2a1.6 1.6 0 0 0 .91-.765c.165-.267.247-.566.247-.897 0-.707-.26-1.176-.778-1.409-.519-.232-1.31-.348-2.375-.348H7z"/></svg>';
      const o_ = 'bold';
      class r_ extends ok {
        init() {
          const e = this.editor;
          const t = e.t;
          e.ui.componentFactory.add(o_, (i) => {
            const n = e.commands.get(o_);
            const o = new Ew(i);
            o.set({
              label: t('Bold'),
              icon: n_,
              keystroke: 'CTRL+B',
              tooltip: true,
              isToggleable: true,
            });
            o.bind('isOn', 'isEnabled').to(n, 'value', 'isEnabled');
            this.listenTo(o, 'execute', () => {
              e.execute(o_);
              e.editing.view.focus();
            });
            return o;
          });
        }
      }
      class s_ extends ok {
        static get requires() {
          return [i_, r_];
        }
        static get pluginName() {
          return 'Bold';
        }
      }
      var a_ =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.627 16.5zm5.873-.196zm0-7.001V8h-13v8.5h4.341c.191.54.457 1.044.785 1.5H2a1.5 1.5 0 0 1-1.5-1.5v-13A1.5 1.5 0 0 1 2 2h4.5a1.5 1.5 0 0 1 1.06.44L9.122 4H16a1.5 1.5 0 0 1 1.5 1.5v1A1.5 1.5 0 0 1 19 8v2.531a6.027 6.027 0 0 0-1.5-1.228zM16 6.5v-1H8.5l-2-2H2v13h1V8a1.5 1.5 0 0 1 1.5-1.5H16z"/><path d="M14.5 19.5a5 5 0 1 1 0-10 5 5 0 0 1 0 10zM15 14v-2h-1v2h-2v1h2v2h1v-2h2v-1h-2z"/></svg>';
      class c_ extends ok {
        static get pluginName() {
          return 'CKFinderUI';
        }
        init() {
          const e = this.editor;
          const t = e.ui.componentFactory;
          const i = e.t;
          t.add('ckfinder', (t) => {
            const n = e.commands.get('ckfinder');
            const o = new Ew(t);
            o.set({
              label: i('Insert image or file'),
              icon: a_,
              tooltip: true,
            });
            o.bind('isEnabled').to(n);
            o.on('execute', () => {
              e.execute('ckfinder');
              e.editing.view.focus();
            });
            return o;
          });
        }
      }
      class l_ extends Zd {
        observe(e) {
          this.listenTo(
            e,
            'load',
            (e, t) => {
              const i = t.target;
              if (i.tagName == 'IMG') {
                this._fireEvents(t);
              }
            },
            { useCapture: true }
          );
        }
        _fireEvents(e) {
          if (this.isEnabled) {
            this.document.fire('layoutChanged');
            this.document.fire('imageLoaded', e);
          }
        }
      }
      class d_ {
        constructor() {
          this._stack = [];
        }
        add(e, t) {
          const i = this._stack;
          const n = i[0];
          this._insertDescriptor(e);
          const o = i[0];
          if (n !== o && !u_(n, o)) {
            this.fire('change:top', {
              oldDescriptor: n,
              newDescriptor: o,
              writer: t,
            });
          }
        }
        remove(e, t) {
          const i = this._stack;
          const n = i[0];
          this._removeDescriptor(e);
          const o = i[0];
          if (n !== o && !u_(n, o)) {
            this.fire('change:top', {
              oldDescriptor: n,
              newDescriptor: o,
              writer: t,
            });
          }
        }
        _insertDescriptor(e) {
          const t = this._stack;
          const i = t.findIndex((t) => t.id === e.id);
          if (u_(e, t[i])) {
            return;
          }
          if (i > -1) {
            t.splice(i, 1);
          }
          let n = 0;
          while (t[n] && h_(t[n], e)) {
            n++;
          }
          t.splice(n, 0, e);
        }
        _removeDescriptor(e) {
          const t = this._stack;
          const i = t.findIndex((t) => t.id === e);
          if (i > -1) {
            t.splice(i, 1);
          }
        }
      }
      ys(d_, ds);
      function u_(e, t) {
        return (
          e && t && e.priority == t.priority && f_(e.classes) == f_(t.classes)
        );
      }
      function h_(e, t) {
        if (e.priority > t.priority) {
          return true;
        } else if (e.priority < t.priority) {
          return false;
        }
        return f_(e.classes) > f_(t.classes);
      }
      function f_(e) {
        return Array.isArray(e) ? e.sort().join(',') : e;
      }
      var g_ = i(46);
      const m_ = tw('px');
      const p_ = Vd.document.body;
      class b_ extends Hb {
        constructor(e) {
          super(e);
          const t = this.bindTemplate;
          this.set('top', 0);
          this.set('left', 0);
          this.set('position', 'arrow_nw');
          this.set('isVisible', false);
          this.set('withArrow', true);
          this.set('class');
          this.content = this.createCollection();
          this.setTemplate({
            tag: 'div',
            attributes: {
              class: [
                'ck',
                'ck-balloon-panel',
                t.to('position', (e) => `ck-balloon-panel_${e}`),
                t.if('isVisible', 'ck-balloon-panel_visible'),
                t.if('withArrow', 'ck-balloon-panel_with-arrow'),
                t.to('class'),
              ],
              style: { top: t.to('top', m_), left: t.to('left', m_) },
            },
            children: this.content,
          });
        }
        show() {
          this.isVisible = true;
        }
        hide() {
          this.isVisible = false;
        }
        attachTo(e) {
          this.show();
          const t = b_.defaultPositions;
          const i = Object.assign(
            {},
            {
              element: this.element,
              positions: [
                t.southArrowNorth,
                t.southArrowNorthMiddleWest,
                t.southArrowNorthMiddleEast,
                t.southArrowNorthWest,
                t.southArrowNorthEast,
                t.northArrowSouth,
                t.northArrowSouthMiddleWest,
                t.northArrowSouthMiddleEast,
                t.northArrowSouthWest,
                t.northArrowSouthEast,
              ],
              limiter: p_,
              fitInViewport: true,
            },
            e
          );
          const n = b_._getOptimalPosition(i);
          const o = parseInt(n.left);
          const r = parseInt(n.top);
          const s = n.name;
          Object.assign(this, { top: r, left: o, position: s });
        }
        pin(e) {
          this.unpin();
          this._pinWhenIsVisibleCallback = () => {
            if (this.isVisible) {
              this._startPinning(e);
            } else {
              this._stopPinning();
            }
          };
          this._startPinning(e);
          this.listenTo(
            this,
            'change:isVisible',
            this._pinWhenIsVisibleCallback
          );
        }
        unpin() {
          if (this._pinWhenIsVisibleCallback) {
            this._stopPinning();
            this.stopListening(
              this,
              'change:isVisible',
              this._pinWhenIsVisibleCallback
            );
            this._pinWhenIsVisibleCallback = null;
            this.hide();
          }
        }
        _startPinning(e) {
          this.attachTo(e);
          const t = w_(e.target);
          const i = e.limiter ? w_(e.limiter) : p_;
          this.listenTo(
            Vd.document,
            'scroll',
            (n, o) => {
              const r = o.target;
              const s = t && r.contains(t);
              const a = i && r.contains(i);
              if (s || a || !t || !i) {
                this.attachTo(e);
              }
            },
            { useCapture: true }
          );
          this.listenTo(Vd.window, 'resize', () => {
            this.attachTo(e);
          });
        }
        _stopPinning() {
          this.stopListening(Vd.document, 'scroll');
          this.stopListening(Vd.window, 'resize');
        }
      }
      function w_(e) {
        if (Yr(e)) {
          return e;
        }
        if (xh(e)) {
          return e.commonAncestorContainer;
        }
        if (typeof e == 'function') {
          return w_(e());
        }
        return null;
      }
      b_.arrowHorizontalOffset = 25;
      b_.arrowVerticalOffset = 10;
      b_._getOptimalPosition = mw;
      b_.defaultPositions = {
        northWestArrowSouthWest: (e, t) => ({
          top: k_(e, t),
          left: e.left - b_.arrowHorizontalOffset,
          name: 'arrow_sw',
        }),
        northWestArrowSouthMiddleWest: (e, t) => ({
          top: k_(e, t),
          left: e.left - t.width * 0.25 - b_.arrowHorizontalOffset,
          name: 'arrow_smw',
        }),
        northWestArrowSouth: (e, t) => ({
          top: k_(e, t),
          left: e.left - t.width / 2,
          name: 'arrow_s',
        }),
        northWestArrowSouthMiddleEast: (e, t) => ({
          top: k_(e, t),
          left: e.left - t.width * 0.75 + b_.arrowHorizontalOffset,
          name: 'arrow_sme',
        }),
        northWestArrowSouthEast: (e, t) => ({
          top: k_(e, t),
          left: e.left - t.width + b_.arrowHorizontalOffset,
          name: 'arrow_se',
        }),
        northArrowSouthWest: (e, t) => ({
          top: k_(e, t),
          left: e.left + e.width / 2 - b_.arrowHorizontalOffset,
          name: 'arrow_sw',
        }),
        northArrowSouthMiddleWest: (e, t) => ({
          top: k_(e, t),
          left:
            e.left + e.width / 2 - t.width * 0.25 - b_.arrowHorizontalOffset,
          name: 'arrow_smw',
        }),
        northArrowSouth: (e, t) => ({
          top: k_(e, t),
          left: e.left + e.width / 2 - t.width / 2,
          name: 'arrow_s',
        }),
        northArrowSouthMiddleEast: (e, t) => ({
          top: k_(e, t),
          left:
            e.left + e.width / 2 - t.width * 0.75 + b_.arrowHorizontalOffset,
          name: 'arrow_sme',
        }),
        northArrowSouthEast: (e, t) => ({
          top: k_(e, t),
          left: e.left + e.width / 2 - t.width + b_.arrowHorizontalOffset,
          name: 'arrow_se',
        }),
        northEastArrowSouthWest: (e, t) => ({
          top: k_(e, t),
          left: e.right - b_.arrowHorizontalOffset,
          name: 'arrow_sw',
        }),
        northEastArrowSouthMiddleWest: (e, t) => ({
          top: k_(e, t),
          left: e.right - t.width * 0.25 - b_.arrowHorizontalOffset,
          name: 'arrow_smw',
        }),
        northEastArrowSouth: (e, t) => ({
          top: k_(e, t),
          left: e.right - t.width / 2,
          name: 'arrow_s',
        }),
        northEastArrowSouthMiddleEast: (e, t) => ({
          top: k_(e, t),
          left: e.right - t.width * 0.75 + b_.arrowHorizontalOffset,
          name: 'arrow_sme',
        }),
        northEastArrowSouthEast: (e, t) => ({
          top: k_(e, t),
          left: e.right - t.width + b_.arrowHorizontalOffset,
          name: 'arrow_se',
        }),
        southWestArrowNorthWest: (e, t) => ({
          top: __(e, t),
          left: e.left - b_.arrowHorizontalOffset,
          name: 'arrow_nw',
        }),
        southWestArrowNorthMiddleWest: (e, t) => ({
          top: __(e, t),
          left: e.left - t.width * 0.25 - b_.arrowHorizontalOffset,
          name: 'arrow_nmw',
        }),
        southWestArrowNorth: (e, t) => ({
          top: __(e, t),
          left: e.left - t.width / 2,
          name: 'arrow_n',
        }),
        southWestArrowNorthMiddleEast: (e, t) => ({
          top: __(e, t),
          left: e.left - t.width * 0.75 + b_.arrowHorizontalOffset,
          name: 'arrow_nme',
        }),
        southWestArrowNorthEast: (e, t) => ({
          top: __(e, t),
          left: e.left - t.width + b_.arrowHorizontalOffset,
          name: 'arrow_ne',
        }),
        southArrowNorthWest: (e, t) => ({
          top: __(e, t),
          left: e.left + e.width / 2 - b_.arrowHorizontalOffset,
          name: 'arrow_nw',
        }),
        southArrowNorthMiddleWest: (e, t) => ({
          top: __(e, t),
          left:
            e.left + e.width / 2 - t.width * 0.25 - b_.arrowHorizontalOffset,
          name: 'arrow_nmw',
        }),
        southArrowNorth: (e, t) => ({
          top: __(e, t),
          left: e.left + e.width / 2 - t.width / 2,
          name: 'arrow_n',
        }),
        southArrowNorthMiddleEast: (e, t) => ({
          top: __(e, t),
          left:
            e.left + e.width / 2 - t.width * 0.75 + b_.arrowHorizontalOffset,
          name: 'arrow_nme',
        }),
        southArrowNorthEast: (e, t) => ({
          top: __(e, t),
          left: e.left + e.width / 2 - t.width + b_.arrowHorizontalOffset,
          name: 'arrow_ne',
        }),
        southEastArrowNorthWest: (e, t) => ({
          top: __(e, t),
          left: e.right - b_.arrowHorizontalOffset,
          name: 'arrow_nw',
        }),
        southEastArrowNorthMiddleWest: (e, t) => ({
          top: __(e, t),
          left: e.right - t.width * 0.25 - b_.arrowHorizontalOffset,
          name: 'arrow_nmw',
        }),
        southEastArrowNorth: (e, t) => ({
          top: __(e, t),
          left: e.right - t.width / 2,
          name: 'arrow_n',
        }),
        southEastArrowNorthMiddleEast: (e, t) => ({
          top: __(e, t),
          left: e.right - t.width * 0.75 + b_.arrowHorizontalOffset,
          name: 'arrow_nme',
        }),
        southEastArrowNorthEast: (e, t) => ({
          top: __(e, t),
          left: e.right - t.width + b_.arrowHorizontalOffset,
          name: 'arrow_ne',
        }),
      };
      function k_(e, t) {
        return e.top - t.height - b_.arrowVerticalOffset;
      }
      function __(e) {
        return e.bottom + b_.arrowVerticalOffset;
      }
      var v_ =
        '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M4 0v1H1v3H0V.5A.5.5 0 0 1 .5 0H4zm8 0h3.5a.5.5 0 0 1 .5.5V4h-1V1h-3V0zM4 16H.5a.5.5 0 0 1-.5-.5V12h1v3h3v1zm8 0v-1h3v-3h1v3.5a.5.5 0 0 1-.5.5H12z"/><path fill-opacity=".256" d="M1 1h14v14H1z"/><g class="ck-icon__selected-indicator"><path d="M7 0h2v1H7V0zM0 7h1v2H0V7zm15 0h1v2h-1V7zm-8 8h2v1H7v-1z"/><path fill-opacity=".254" d="M1 1h14v14H1z"/></g></svg>';
      const y_ = 'widget-type-around';
      function x_(e, t, i) {
        return e && M_(e) && !i.isInline(t);
      }
      function A_(e) {
        return e.closest('.ck-widget__type-around__button');
      }
      function T_(e) {
        return e.classList.contains('ck-widget__type-around__button_before')
          ? 'before'
          : 'after';
      }
      function C_(e, t) {
        const i = e.closest('.ck-widget');
        return t.mapDomToView(i);
      }
      function P_(e) {
        return e.getAttribute(y_);
      }
      const E_ = 'ck-widget';
      const S_ = 'ck-widget_selected';
      function M_(e) {
        if (!e.is('element')) {
          return false;
        }
        return !!e.getCustomProperty('widget');
      }
      function I_(e, t, i = {}) {
        if (!e.is('containerElement')) {
          throw new ss['b'](
            'widget-to-widget-wrong-element-type: The element passed to toWidget() must be a container element instance.',
            null,
            { element: e }
          );
        }
        t.setAttribute('contenteditable', 'false', e);
        t.addClass(E_, e);
        t.setCustomProperty('widget', true, e);
        e.getFillerOffset = j_;
        if (i.label) {
          O_(e, i.label, t);
        }
        if (i.hasSelectionHandle) {
          B_(e, t);
        }
        N_(
          e,
          t,
          (e, t, i) => i.addClass(n(t.classes), e),
          (e, t, i) => i.removeClass(n(t.classes), e)
        );
        return e;
        function n(e) {
          return Array.isArray(e) ? e : [e];
        }
      }
      function N_(e, t, i, n) {
        const o = new d_();
        o.on('change:top', (t, o) => {
          if (o.oldDescriptor) {
            n(e, o.oldDescriptor, o.writer);
          }
          if (o.newDescriptor) {
            i(e, o.newDescriptor, o.writer);
          }
        });
        t.setCustomProperty('addHighlight', (e, t, i) => o.add(t, i), e);
        t.setCustomProperty('removeHighlight', (e, t, i) => o.remove(t, i), e);
      }
      function O_(e, t, i) {
        i.setCustomProperty('widgetLabel', t, e);
      }
      function z_(e) {
        const t = e.getCustomProperty('widgetLabel');
        if (!t) {
          return '';
        }
        return typeof t == 'function' ? t() : t;
      }
      function R_(e, t) {
        t.addClass(['ck-editor__editable', 'ck-editor__nested-editable'], e);
        t.setAttribute('contenteditable', e.isReadOnly ? 'false' : 'true', e);
        e.on('change:isReadOnly', (i, n, o) => {
          t.setAttribute('contenteditable', o ? 'false' : 'true', e);
        });
        e.on('change:isFocused', (i, n, o) => {
          if (o) {
            t.addClass('ck-editor__nested-editable_focused', e);
          } else {
            t.removeClass('ck-editor__nested-editable_focused', e);
          }
        });
        return e;
      }
      function L_(e, t) {
        const i = e.getSelectedElement();
        if (i) {
          const n = P_(e);
          if (n) {
            return t.createPositionAt(i, n);
          }
          if (t.schema.isBlock(i)) {
            return t.createPositionAfter(i);
          }
        }
        const n = e.getSelectedBlocks().next().value;
        if (n) {
          if (n.isEmpty) {
            return t.createPositionAt(n, 0);
          }
          const i = t.createPositionAfter(n);
          if (e.focus.isTouching(i)) {
            return i;
          }
          return t.createPositionBefore(n);
        }
        return e.focus;
      }
      function V_(e, t) {
        return (i, n) => {
          const { mapper: o, viewPosition: r } = n;
          const s = o.findMappedViewAncestor(r);
          if (!t(s)) {
            return;
          }
          const a = o.toModelElement(s);
          n.modelPosition = e.createPositionAt(
            a,
            r.isAtStart ? 'before' : 'after'
          );
        };
      }
      function D_(e, t) {
        const i = new Ch(Vd.window);
        const n = i.getIntersection(e);
        const o = t.height + b_.arrowVerticalOffset;
        if (e.top - o > i.top || e.bottom + o < i.bottom) {
          return null;
        }
        const r = n || e;
        const s = r.left + r.width / 2 - t.width / 2;
        return {
          top: Math.max(e.top, 0) + b_.arrowVerticalOffset,
          left: s,
          name: 'arrow_n',
        };
      }
      function j_() {
        return null;
      }
      function B_(e, t) {
        const i = t.createUIElement(
          'div',
          { class: 'ck ck-widget__selection-handle' },
          function (e) {
            const t = this.toDomElement(e);
            const i = new Aw();
            i.set('content', v_);
            i.render();
            t.appendChild(i.element);
            return t;
          }
        );
        t.insert(t.createPositionAt(e, 0), i);
        t.addClass(['ck-widget_with-selection-handle'], e);
      }
      function F_(e, t, i) {
        t.setCustomProperty('image', true, e);
        return I_(e, t, { label: n });
        function n() {
          const t = G_(e);
          const n = t.getAttribute('alt');
          return n ? `${n} ${i}` : i;
        }
      }
      function H_(e) {
        return !!e.getCustomProperty('image') && M_(e);
      }
      function U_(e) {
        const t = e.getSelectedElement();
        if (t && H_(t)) {
          return t;
        }
        return null;
      }
      function q_(e) {
        return !!e && e.is('element', 'image');
      }
      function W_(e, t, i = {}) {
        const n = e.createElement('image', i);
        const o = L_(t.document.selection, t);
        t.insertContent(n, o);
        if (n.parent) {
          e.setSelection(n, 'on');
        }
      }
      function $_(e) {
        const t = e.schema;
        const i = e.document.selection;
        return Y_(i, t, e) && !K_(i, t) && Q_(i);
      }
      function G_(e) {
        const t = [];
        for (const i of e.getChildren()) {
          t.push(i);
          if (i.is('element')) {
            t.push(...i.getChildren());
          }
        }
        return t.find((e) => e.is('element', 'img'));
      }
      function Y_(e, t, i) {
        const n = J_(e, i);
        return t.checkChild(n, 'image');
      }
      function K_(e, t) {
        const i = e.getSelectedElement();
        return i && t.isObject(i);
      }
      function Q_(e) {
        return [...e.focus.getAncestors()].every(
          (e) => !e.is('element', 'image')
        );
      }
      function J_(e, t) {
        const i = L_(e, t);
        const n = i.parent;
        if (n.isEmpty && !n.is('element', '$root')) {
          return n.parent;
        }
        return n;
      }
      function Z_() {
        return (t) => {
          t.on('element:figure', e);
        };
        function e(e, t, i) {
          if (
            !i.consumable.test(t.viewItem, { name: true, classes: 'image' })
          ) {
            return;
          }
          const n = G_(t.viewItem);
          if (
            !n ||
            !n.hasAttribute('src') ||
            !i.consumable.test(n, { name: true })
          ) {
            return;
          }
          const o = i.convertItem(n, t.modelCursor);
          const r = ck(o.modelRange.getItems());
          if (!r) {
            return;
          }
          i.convertChildren(t.viewItem, r);
          i.updateConversionResult(r, t);
        }
      }
      function X_() {
        return (t) => {
          t.on('attribute:srcset:image', e);
        };
        function e(e, t, i) {
          if (!i.consumable.consume(t.item, e.name)) {
            return;
          }
          const n = i.writer;
          const o = i.mapper.toViewElement(t.item);
          const r = G_(o);
          if (t.attributeNewValue === null) {
            const e = t.attributeOldValue;
            if (e.data) {
              n.removeAttribute('srcset', r);
              n.removeAttribute('sizes', r);
              if (e.width) {
                n.removeAttribute('width', r);
              }
            }
          } else {
            const e = t.attributeNewValue;
            if (e.data) {
              n.setAttribute('srcset', e.data, r);
              n.setAttribute('sizes', '100vw', r);
              if (e.width) {
                n.setAttribute('width', e.width, r);
              }
            }
          }
        }
      }
      function ev(e) {
        return (i) => {
          i.on(`attribute:${e}:image`, t);
        };
        function t(e, t, i) {
          if (!i.consumable.consume(t.item, e.name)) {
            return;
          }
          const n = i.writer;
          const o = i.mapper.toViewElement(t.item);
          const r = G_(o);
          n.setAttribute(t.attributeKey, t.attributeNewValue || '', r);
        }
      }
      class tv extends sk {
        refresh() {
          this.isEnabled = $_(this.editor.model);
        }
        execute(e) {
          const t = this.editor.model;
          t.change((i) => {
            const n = Array.isArray(e.source) ? e.source : [e.source];
            for (const e of n) {
              W_(i, t, { src: e });
            }
          });
        }
      }
      class iv extends ok {
        static get pluginName() {
          return 'ImageEditing';
        }
        init() {
          const e = this.editor;
          const t = e.model.schema;
          const i = e.t;
          const n = e.conversion;
          e.editing.view.addObserver(l_);
          t.register('image', {
            isObject: true,
            isBlock: true,
            allowWhere: '$block',
            allowAttributes: ['alt', 'src', 'srcset'],
          });
          n.for('dataDowncast').elementToElement({
            model: 'image',
            view: (e, { writer: t }) => nv(t),
          });
          n.for('editingDowncast').elementToElement({
            model: 'image',
            view: (e, { writer: t }) => F_(nv(t), t, i('image widget')),
          });
          n.for('downcast').add(ev('src')).add(ev('alt')).add(X_());
          n.for('upcast')
            .elementToElement({
              view: { name: 'img', attributes: { src: true } },
              model: (e, { writer: t }) =>
                t.createElement('image', { src: e.getAttribute('src') }),
            })
            .attributeToAttribute({
              view: { name: 'img', key: 'alt' },
              model: 'alt',
            })
            .attributeToAttribute({
              view: { name: 'img', key: 'srcset' },
              model: {
                key: 'srcset',
                value: (e) => {
                  const t = { data: e.getAttribute('srcset') };
                  if (e.hasAttribute('width')) {
                    t.width = e.getAttribute('width');
                  }
                  return t;
                },
              },
            })
            .add(Z_());
          e.commands.add('imageInsert', new tv(e));
        }
      }
      function nv(e) {
        const t = e.createEmptyElement('img');
        const i = e.createContainerElement('figure', { class: 'image' });
        e.insert(e.createPositionAt(i, 0), t);
        return i;
      }
      class ov extends eh {
        constructor(e) {
          super(e);
          this.domEventType = 'mousedown';
        }
        onDomEvent(e) {
          this.fire(e.type, e);
        }
      }
      class rv extends ok {
        static get pluginName() {
          return 'TwoStepCaretMovement';
        }
        constructor(e) {
          super(e);
          this.attributes = new Set();
          this._overrideUid = null;
        }
        init() {
          const e = this.editor;
          const t = e.model;
          const i = e.editing.view;
          const n = e.locale;
          const o = t.document.selection;
          this.listenTo(
            i.document,
            'keydown',
            (e, t) => {
              if (!o.isCollapsed) {
                return;
              }
              if (t.shiftKey || t.altKey || t.ctrlKey) {
                return;
              }
              const i = t.keyCode == zl.arrowright;
              const r = t.keyCode == zl.arrowleft;
              if (!i && !r) {
                return;
              }
              const s = n.contentLanguageDirection;
              let a = false;
              if ((s === 'ltr' && i) || (s === 'rtl' && r)) {
                a = this._handleForwardMovement(t);
              } else {
                a = this._handleBackwardMovement(t);
              }
              if (a === true) {
                e.stop();
              }
            },
            { priority: os.get('high') + 1 }
          );
          this._isNextGravityRestorationSkipped = false;
          this.listenTo(o, 'change:range', (e, t) => {
            if (this._isNextGravityRestorationSkipped) {
              this._isNextGravityRestorationSkipped = false;
              return;
            }
            if (!this._isGravityOverridden) {
              return;
            }
            if (!t.directChange && dv(o.getFirstPosition(), this.attributes)) {
              return;
            }
            this._restoreGravity();
          });
        }
        registerAttribute(e) {
          this.attributes.add(e);
        }
        _handleForwardMovement(e) {
          const t = this.attributes;
          const i = this.editor.model;
          const n = i.document.selection;
          const o = n.getFirstPosition();
          if (this._isGravityOverridden) {
            return false;
          }
          if (o.isAtStart && sv(n, t)) {
            return false;
          }
          if (dv(o, t)) {
            cv(e);
            this._overrideGravity();
            return true;
          }
        }
        _handleBackwardMovement(e) {
          const t = this.attributes;
          const i = this.editor.model;
          const n = i.document.selection;
          const o = n.getFirstPosition();
          if (this._isGravityOverridden) {
            cv(e);
            this._restoreGravity();
            av(i, t, o);
            return true;
          } else {
            if (o.isAtStart) {
              if (sv(n, t)) {
                cv(e);
                av(i, t, o);
                return true;
              }
              return false;
            }
            if (lv(o, t)) {
              if (o.isAtEnd && !sv(n, t) && dv(o, t)) {
                cv(e);
                av(i, t, o);
                return true;
              }
              this._isNextGravityRestorationSkipped = true;
              this._overrideGravity();
              return false;
            }
          }
        }
        get _isGravityOverridden() {
          return !!this._overrideUid;
        }
        _overrideGravity() {
          this._overrideUid = this.editor.model.change((e) =>
            e.overrideSelectionGravity()
          );
        }
        _restoreGravity() {
          this.editor.model.change((e) => {
            e.restoreSelectionGravity(this._overrideUid);
            this._overrideUid = null;
          });
        }
      }
      function sv(e, t) {
        for (const i of t) {
          if (e.hasAttribute(i)) {
            return true;
          }
        }
        return false;
      }
      function av(e, t, i) {
        const n = i.nodeBefore;
        e.change((e) => {
          if (n) {
            e.setSelectionAttribute(n.getAttributes());
          } else {
            e.removeSelectionAttribute(t);
          }
        });
      }
      function cv(e) {
        e.preventDefault();
      }
      function lv(e, t) {
        const i = e.getShiftedBy(-1);
        return dv(i, t);
      }
      function dv(e, t) {
        const { nodeBefore: i, nodeAfter: n } = e;
        for (const e of t) {
          const t = i ? i.getAttribute(e) : undefined;
          const o = n ? n.getAttribute(e) : undefined;
          if (o !== t) {
            return true;
          }
        }
        return false;
      }
      function uv(e, t, i, n) {
        return n.createRange(hv(e, t, i, true, n), hv(e, t, i, false, n));
      }
      function hv(e, t, i, n, o) {
        let r = e.textNode || (n ? e.nodeBefore : e.nodeAfter);
        let s = null;
        while (r && r.getAttribute(t) == i) {
          s = r;
          r = n ? r.previousSibling : r.nextSibling;
        }
        return s ? o.createPositionAt(s, n ? 'before' : 'after') : e;
      }
      function fv(e, t, i, n) {
        const o = e.editing.view;
        const r = new Set();
        o.document.registerPostFixer((o) => {
          const s = e.model.document.selection;
          let a = false;
          if (s.hasAttribute(t)) {
            const c = uv(s.getFirstPosition(), t, s.getAttribute(t), e.model);
            const l = e.editing.mapper.toViewRange(c);
            for (const e of l.getItems()) {
              if (e.is('element', i) && !e.hasClass(n)) {
                o.addClass(n, e);
                r.add(e);
                a = true;
              }
            }
          }
          return a;
        });
        e.conversion.for('editingDowncast').add((e) => {
          e.on('insert', t, { priority: 'highest' });
          e.on('remove', t, { priority: 'highest' });
          e.on('attribute', t, { priority: 'highest' });
          e.on('selection', t, { priority: 'highest' });
          function t() {
            o.change((e) => {
              for (const t of r.values()) {
                e.removeClass(n, t);
                r.delete(t);
              }
            });
          }
        });
      }
      class gv {
        constructor(e, t = 20) {
          this.model = e;
          this.size = 0;
          this.limit = t;
          this.isLocked = false;
          this._changeCallback = (e, t) => {
            if (t.type != 'transparent' && t !== this._batch) {
              this._reset(true);
            }
          };
          this._selectionChangeCallback = () => {
            this._reset();
          };
          this.model.document.on('change', this._changeCallback);
          this.model.document.selection.on(
            'change:range',
            this._selectionChangeCallback
          );
          this.model.document.selection.on(
            'change:attribute',
            this._selectionChangeCallback
          );
        }
        get batch() {
          if (!this._batch) {
            this._batch = this.model.createBatch();
          }
          return this._batch;
        }
        input(e) {
          this.size += e;
          if (this.size >= this.limit) {
            this._reset(true);
          }
        }
        lock() {
          this.isLocked = true;
        }
        unlock() {
          this.isLocked = false;
        }
        destroy() {
          this.model.document.off('change', this._changeCallback);
          this.model.document.selection.off(
            'change:range',
            this._selectionChangeCallback
          );
          this.model.document.selection.off(
            'change:attribute',
            this._selectionChangeCallback
          );
        }
        _reset(e) {
          if (!this.isLocked || e) {
            this._batch = null;
            this.size = 0;
          }
        }
      }
      class mv extends sk {
        constructor(e, t) {
          super(e);
          this._buffer = new gv(e.model, t);
          this._batches = new WeakSet();
        }
        get buffer() {
          return this._buffer;
        }
        destroy() {
          super.destroy();
          this._buffer.destroy();
        }
        execute(e = {}) {
          const t = this.editor.model;
          const i = t.document;
          const n = e.text || '';
          const o = n.length;
          const r = e.range ? t.createSelection(e.range) : i.selection;
          const s = e.resultRange;
          t.enqueueChange(this._buffer.batch, (e) => {
            this._buffer.lock();
            this._batches.add(this._buffer.batch);
            t.deleteContent(r);
            if (n) {
              t.insertContent(e.createText(n, i.selection.getAttributes()), r);
            }
            if (s) {
              e.setSelection(s);
            } else if (!r.is('documentSelection')) {
              e.setSelection(r);
            }
            this._buffer.unlock();
            this._buffer.input(o);
          });
        }
      }
      function pv(e) {
        let t = null;
        const i = e.model;
        const n = e.editing.view;
        const o = e.commands.get('input');
        if (Cl.isAndroid) {
          n.document.on('beforeinput', (e, t) => r(t), { priority: 'lowest' });
        } else {
          n.document.on('keydown', (e, t) => r(t), { priority: 'lowest' });
        }
        n.document.on('compositionstart', s, { priority: 'lowest' });
        n.document.on(
          'compositionend',
          () => {
            t = i.createSelection(i.document.selection);
          },
          { priority: 'lowest' }
        );
        function r(e) {
          const r = i.document;
          const s = n.document.isComposing;
          const c = t && t.isEqual(r.selection);
          t = null;
          if (!o.isEnabled) {
            return;
          }
          if (wv(e) || r.selection.isCollapsed) {
            return;
          }
          if (s && e.keyCode === 229) {
            return;
          }
          if (!s && e.keyCode === 229 && c) {
            return;
          }
          a();
        }
        function s() {
          const e = i.document;
          const t =
            e.selection.rangeCount === 1
              ? e.selection.getFirstRange().isFlat
              : true;
          if (e.selection.isCollapsed || t) {
            return;
          }
          a();
        }
        function a() {
          const e = o.buffer;
          e.lock();
          const t = e.batch;
          o._batches.add(t);
          i.enqueueChange(t, () => {
            i.deleteContent(i.document.selection);
          });
          e.unlock();
        }
      }
      const bv = [
        Rl('arrowUp'),
        Rl('arrowRight'),
        Rl('arrowDown'),
        Rl('arrowLeft'),
        9,
        16,
        17,
        18,
        19,
        20,
        27,
        33,
        34,
        35,
        36,
        45,
        91,
        93,
        144,
        145,
        173,
        174,
        175,
        176,
        177,
        178,
        179,
        255,
      ];
      for (let e = 112; e <= 135; e++) {
        bv.push(e);
      }
      function wv(e) {
        if (e.ctrlKey) {
          return true;
        }
        return bv.includes(e.keyCode);
      }
      function kv(e, t) {
        const i = [];
        let n = 0;
        let o;
        e.forEach((e) => {
          if (e == 'equal') {
            r();
            n++;
          } else if (e == 'insert') {
            if (s('insert')) {
              o.values.push(t[n]);
            } else {
              r();
              o = { type: 'insert', index: n, values: [t[n]] };
            }
            n++;
          } else {
            if (s('delete')) {
              o.howMany++;
            } else {
              r();
              o = { type: 'delete', index: n, howMany: 1 };
            }
          }
        });
        r();
        return i;
        function r() {
          if (o) {
            i.push(o);
            o = null;
          }
        }
        function s(e) {
          return o && o.type == e;
        }
      }
      function _v(e) {
        if (e.length == 0) {
          return false;
        }
        for (const t of e) {
          if (t.type === 'children' && !vv(t)) {
            return true;
          }
        }
        return false;
      }
      function vv(e) {
        if (e.newChildren.length - e.oldChildren.length != 1) {
          return;
        }
        const t = Td(e.oldChildren, e.newChildren, yv);
        const i = kv(t, e.newChildren);
        if (i.length > 1) {
          return;
        }
        const n = i[0];
        if (!(!!n.values[0] && n.values[0].is('$text'))) {
          return;
        }
        return n;
      }
      function yv(e, t) {
        if (!!e && e.is('$text') && !!t && t.is('$text')) {
          return e.data === t.data;
        } else {
          return e === t;
        }
      }
      function xv(e) {
        e.editing.view.document.on('mutations', (t, i, n) => {
          new Av(e).handle(i, n);
        });
      }
      class Av {
        constructor(e) {
          this.editor = e;
          this.editing = this.editor.editing;
        }
        handle(e, t) {
          if (_v(e)) {
            this._handleContainerChildrenMutations(e, t);
          } else {
            for (const i of e) {
              this._handleTextMutation(i, t);
              this._handleTextNodeInsertion(i);
            }
          }
        }
        _handleContainerChildrenMutations(e, t) {
          const i = Tv(e);
          if (!i) {
            return;
          }
          const n = this.editor.editing.view.domConverter;
          const o = n.mapViewToDom(i);
          const r = new Hd(this.editor.editing.view.document);
          const s = this.editor.data.toModel(r.domToView(o)).getChild(0);
          const a = this.editor.editing.mapper.toModelElement(i);
          if (!a) {
            return;
          }
          const c = Array.from(s.getChildren());
          const l = Array.from(a.getChildren());
          const d = c[c.length - 1];
          const u = l[l.length - 1];
          const h = d && d.is('element', 'softBreak');
          const f = u && !u.is('element', 'softBreak');
          if (h && f) {
            c.pop();
          }
          const g = this.editor.model.schema;
          if (!Cv(c, g) || !Cv(l, g)) {
            return;
          }
          const m = c
            .map((e) => (e.is('$text') ? e.data : '@'))
            .join('')
            .replace(/\u00A0/g, ' ');
          const p = l
            .map((e) => (e.is('$text') ? e.data : '@'))
            .join('')
            .replace(/\u00A0/g, ' ');
          if (p === m) {
            return;
          }
          const b = Td(p, m);
          const { firstChangeAt: w, insertions: k, deletions: _ } = Pv(b);
          let v = null;
          if (t) {
            v = this.editing.mapper.toModelRange(t.getFirstRange());
          }
          const y = m.substr(w, k);
          const x = this.editor.model.createRange(
            this.editor.model.createPositionAt(a, w),
            this.editor.model.createPositionAt(a, w + _)
          );
          this.editor.execute('input', { text: y, range: x, resultRange: v });
        }
        _handleTextMutation(e, t) {
          if (e.type != 'text') {
            return;
          }
          const i = e.newText.replace(/\u00A0/g, ' ');
          const n = e.oldText.replace(/\u00A0/g, ' ');
          if (n === i) {
            return;
          }
          const o = Td(n, i);
          const { firstChangeAt: r, insertions: s, deletions: a } = Pv(o);
          let c = null;
          if (t) {
            c = this.editing.mapper.toModelRange(t.getFirstRange());
          }
          const l = this.editing.view.createPositionAt(e.node, r);
          const d = this.editing.mapper.toModelPosition(l);
          const u = this.editor.model.createRange(d, d.getShiftedBy(a));
          const h = i.substr(r, s);
          this.editor.execute('input', { text: h, range: u, resultRange: c });
        }
        _handleTextNodeInsertion(e) {
          if (e.type != 'children') {
            return;
          }
          const t = vv(e);
          const i = this.editing.view.createPositionAt(e.node, t.index);
          const n = this.editing.mapper.toModelPosition(i);
          const o = t.values[0].data;
          this.editor.execute('input', {
            text: o.replace(/\u00A0/g, ' '),
            range: this.editor.model.createRange(n),
          });
        }
      }
      function Tv(e) {
        const t = e
          .map((e) => e.node)
          .reduce((e, t) => e.getCommonAncestor(t, { includeSelf: true }));
        if (!t) {
          return;
        }
        return t
          .getAncestors({ includeSelf: true, parentFirst: true })
          .find((e) => e.is('containerElement') || e.is('rootElement'));
      }
      function Cv(e, t) {
        return e.every((e) => t.isInline(e));
      }
      function Pv(e) {
        let t = null;
        let i = null;
        for (let n = 0; n < e.length; n++) {
          const o = e[n];
          if (o != 'equal') {
            t = t === null ? n : t;
            i = n;
          }
        }
        let n = 0;
        let o = 0;
        for (let r = t; r <= i; r++) {
          if (e[r] != 'insert') {
            n++;
          }
          if (e[r] != 'delete') {
            o++;
          }
        }
        return { insertions: o, deletions: n, firstChangeAt: t };
      }
      class Ev extends ok {
        static get pluginName() {
          return 'Input';
        }
        init() {
          const e = this.editor;
          const t = new mv(e, e.config.get('typing.undoStep') || 20);
          e.commands.add('input', t);
          pv(e);
          xv(e);
        }
        isInput(e) {
          const t = this.editor.commands.get('input');
          return t._batches.has(e);
        }
      }
      class Sv {
        constructor(e) {
          this.files = Mv(e);
          this._native = e;
        }
        get types() {
          return this._native.types;
        }
        getData(e) {
          return this._native.getData(e);
        }
        setData(e, t) {
          this._native.setData(e, t);
        }
      }
      function Mv(e) {
        const t = e.files ? Array.from(e.files) : [];
        const i = e.items ? Array.from(e.items) : [];
        if (t.length) {
          return t;
        }
        return i.filter((e) => e.kind === 'file').map((e) => e.getAsFile());
      }
      class Iv extends eh {
        constructor(e) {
          super(e);
          const t = this.document;
          this.domEventType = ['paste', 'copy', 'cut', 'drop', 'dragover'];
          this.listenTo(t, 'paste', i, { priority: 'low' });
          this.listenTo(t, 'drop', i, { priority: 'low' });
          function i(e, i) {
            i.preventDefault();
            const n = i.dropRange
              ? [i.dropRange]
              : Array.from(t.selection.getRanges());
            const o = new es(t, 'clipboardInput');
            t.fire(o, { dataTransfer: i.dataTransfer, targetRanges: n });
            if (o.stop.called) {
              i.stopPropagation();
            }
          }
        }
        onDomEvent(e) {
          const t = {
            dataTransfer: new Sv(
              e.clipboardData ? e.clipboardData : e.dataTransfer
            ),
          };
          if (e.type == 'drop') {
            t.dropRange = Nv(this.view, e);
          }
          this.fire(e.type, e, t);
        }
      }
      function Nv(e, t) {
        const i = t.target.ownerDocument;
        const n = t.clientX;
        const o = t.clientY;
        let r;
        if (i.caretRangeFromPoint && i.caretRangeFromPoint(n, o)) {
          r = i.caretRangeFromPoint(n, o);
        } else if (t.rangeParent) {
          r = i.createRange();
          r.setStart(t.rangeParent, t.rangeOffset);
          r.collapse(true);
        }
        if (r) {
          return e.domConverter.domRangeToView(r);
        } else {
          return e.document.selection.getFirstRange();
        }
      }
      function Ov(e) {
        e = e
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/\n/g, '</p><p>')
          .replace(/^\s/, '&nbsp;')
          .replace(/\s$/, '&nbsp;')
          .replace(/\s\s/g, ' &nbsp;');
        if (e.indexOf('</p><p>') > -1) {
          e = `<p>${e}</p>`;
        }
        return e;
      }
      function zv(e) {
        return e.replace(
          /<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g,
          (e, t) => {
            if (t.length == 1) {
              return ' ';
            }
            return t;
          }
        );
      }
      const Rv = ['figcaption', 'li'];
      function Lv(e) {
        let t = '';
        if (e.is('$text') || e.is('$textProxy')) {
          t = e.data;
        } else if (e.is('element', 'img') && e.hasAttribute('alt')) {
          t = e.getAttribute('alt');
        } else {
          let i = null;
          for (const n of e.getChildren()) {
            const e = Lv(n);
            if (i && (i.is('containerElement') || n.is('containerElement'))) {
              if (Rv.includes(i.name) || Rv.includes(n.name)) {
                t += '\n';
              } else {
                t += '\n\n';
              }
            }
            t += e;
            i = n;
          }
        }
        return t;
      }
      class Vv extends ok {
        static get pluginName() {
          return 'Clipboard';
        }
        init() {
          const e = this.editor;
          const t = e.model.document;
          const i = e.editing.view;
          const n = i.document;
          this._htmlDataProcessor = new Gp(n);
          i.addObserver(Iv);
          this.listenTo(
            n,
            'clipboardInput',
            (t) => {
              if (e.isReadOnly) {
                t.stop();
              }
            },
            { priority: 'highest' }
          );
          this.listenTo(
            n,
            'clipboardInput',
            (e, t) => {
              const n = t.dataTransfer;
              let o = '';
              if (n.getData('text/html')) {
                o = zv(n.getData('text/html'));
              } else if (n.getData('text/plain')) {
                o = Ov(n.getData('text/plain'));
              }
              o = this._htmlDataProcessor.toView(o);
              const r = new es(this, 'inputTransformation');
              this.fire(r, { content: o, dataTransfer: n });
              if (r.stop.called) {
                e.stop();
              }
              i.scrollToTheSelection();
            },
            { priority: 'low' }
          );
          this.listenTo(
            this,
            'inputTransformation',
            (e, i) => {
              if (!i.content.isEmpty) {
                const n = this.editor.data;
                const o = this.editor.model;
                const r = n.toModel(i.content, '$clipboardHolder');
                if (r.childCount == 0) {
                  return;
                }
                if (Dv(r)) {
                  const e = r.getChild(0);
                  o.change((i) => {
                    i.setAttributes(t.selection.getAttributes(), e);
                  });
                }
                o.insertContent(r);
                e.stop();
              }
            },
            { priority: 'low' }
          );
          function o(i, o) {
            const r = o.dataTransfer;
            o.preventDefault();
            const s = e.data.toView(e.model.getSelectedContent(t.selection));
            n.fire('clipboardOutput', {
              dataTransfer: r,
              content: s,
              method: i.name,
            });
          }
          this.listenTo(n, 'copy', o, { priority: 'low' });
          this.listenTo(
            n,
            'cut',
            (t, i) => {
              if (e.isReadOnly) {
                i.preventDefault();
              } else {
                o(t, i);
              }
            },
            { priority: 'low' }
          );
          this.listenTo(
            n,
            'clipboardOutput',
            (i, n) => {
              if (!n.content.isEmpty) {
                n.dataTransfer.setData(
                  'text/html',
                  this._htmlDataProcessor.toData(n.content)
                );
                n.dataTransfer.setData('text/plain', Lv(n.content));
              }
              if (n.method == 'cut') {
                e.model.deleteContent(t.selection);
              }
            },
            { priority: 'low' }
          );
        }
      }
      function Dv(e) {
        if (e.childCount > 1) {
          return false;
        }
        const t = e.getChild(0);
        return [...t.getAttributeKeys()].length == 0;
      }
      class jv {
        constructor() {
          this._definitions = new Set();
        }
        get length() {
          return this._definitions.size;
        }
        add(e) {
          if (Array.isArray(e)) {
            e.forEach((e) => this._definitions.add(e));
          } else {
            this._definitions.add(e);
          }
        }
        getDispatcher() {
          return (e) => {
            e.on(
              'attribute:linkHref',
              (e, t, i) => {
                if (!i.consumable.test(t.item, 'attribute:linkHref')) {
                  return;
                }
                const n = i.writer;
                const o = n.document.selection;
                for (const e of this._definitions) {
                  const r = n.createAttributeElement('a', e.attributes, {
                    priority: 5,
                  });
                  n.setCustomProperty('link', true, r);
                  if (e.callback(t.attributeNewValue)) {
                    if (t.item.is('selection')) {
                      n.wrap(o.getFirstRange(), r);
                    } else {
                      n.wrap(i.mapper.toViewRange(t.range), r);
                    }
                  } else {
                    n.unwrap(i.mapper.toViewRange(t.range), r);
                  }
                }
              },
              { priority: 'high' }
            );
          };
        }
        getDispatcherForLinkedImage() {
          return (e) => {
            e.on('attribute:linkHref:image', (e, t, i) => {
              const n = i.mapper.toViewElement(t.item);
              const o = Array.from(n.getChildren()).find((e) => e.name === 'a');
              for (const e of this._definitions) {
                const n = Us(e.attributes);
                if (e.callback(t.attributeNewValue)) {
                  for (const [e, t] of n) {
                    if (e === 'class') {
                      i.writer.addClass(t, o);
                    } else {
                      i.writer.setAttribute(e, t, o);
                    }
                  }
                } else {
                  for (const [e, t] of n) {
                    if (e === 'class') {
                      i.writer.removeClass(t, o);
                    } else {
                      i.writer.removeAttribute(e, o);
                    }
                  }
                }
              }
            });
          };
        }
      }
      function Bv(e, t, i) {
        var n = e.length;
        i = i === undefined ? n : i;
        return !t && i >= n ? e : Na(e, t, i);
      }
      var Fv = Bv;
      var Hv = '\\ud800-\\udfff',
        Uv = '\\u0300-\\u036f',
        qv = '\\ufe20-\\ufe2f',
        Wv = '\\u20d0-\\u20ff',
        $v = Uv + qv + Wv,
        Gv = '\\ufe0e\\ufe0f';
      var Yv = '\\u200d';
      var Kv = RegExp('[' + Yv + Hv + $v + Gv + ']');
      function Qv(e) {
        return Kv.test(e);
      }
      var Jv = Qv;
      function Zv(e) {
        return e.split('');
      }
      var Xv = Zv;
      var ey = '\\ud800-\\udfff',
        ty = '\\u0300-\\u036f',
        iy = '\\ufe20-\\ufe2f',
        ny = '\\u20d0-\\u20ff',
        oy = ty + iy + ny,
        ry = '\\ufe0e\\ufe0f';
      var sy = '[' + ey + ']',
        ay = '[' + oy + ']',
        cy = '\\ud83c[\\udffb-\\udfff]',
        ly = '(?:' + ay + '|' + cy + ')',
        dy = '[^' + ey + ']',
        uy = '(?:\\ud83c[\\udde6-\\uddff]){2}',
        hy = '[\\ud800-\\udbff][\\udc00-\\udfff]',
        fy = '\\u200d';
      var gy = ly + '?',
        my = '[' + ry + ']?',
        py = '(?:' + fy + '(?:' + [dy, uy, hy].join('|') + ')' + my + gy + ')*',
        by = my + gy + py,
        wy = '(?:' + [dy + ay + '?', ay, uy, hy, sy].join('|') + ')';
      var ky = RegExp(cy + '(?=' + cy + ')|' + wy + by, 'g');
      function _y(e) {
        return e.match(ky) || [];
      }
      var vy = _y;
      function yy(e) {
        return Jv(e) ? vy(e) : Xv(e);
      }
      var xy = yy;
      function Ay(e) {
        return function (t) {
          t = va(t);
          var i = Jv(t) ? xy(t) : undefined;
          var n = i ? i[0] : t.charAt(0);
          var o = i ? Fv(i, 1).join('') : t.slice(1);
          return n[e]() + o;
        };
      }
      var Ty = Ay;
      var Cy = Ty('toUpperCase');
      var Py = Cy;
      const Ey = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g;
      const Sy =
        /^(?:(?:https?|ftps?|mailto):|[^a-z]|[a-z+.-]+(?:[^a-z+.:-]|$))/i;
      const My = 'Ctrl+K';
      function Iy(e) {
        return e.is('attributeElement') && !!e.getCustomProperty('link');
      }
      function Ny(e, { writer: t }) {
        const i = t.createAttributeElement('a', { href: e }, { priority: 5 });
        t.setCustomProperty('link', true, i);
        return i;
      }
      function Oy(e) {
        e = String(e);
        return zy(e) ? e : '#';
      }
      function zy(e) {
        const t = e.replace(Ey, '');
        return t.match(Sy);
      }
      function Ry(e, t) {
        const i = {
          'Open in a new tab': e('Open in a new tab'),
          Downloadable: e('Downloadable'),
        };
        t.forEach((e) => {
          if (e.label && i[e.label]) {
            e.label = i[e.label];
          }
          return e;
        });
        return t;
      }
      function Ly(e) {
        const t = [];
        if (e) {
          for (const [i, n] of Object.entries(e)) {
            const e = Object.assign({}, n, { id: `link${Py(i)}` });
            t.push(e);
          }
        }
        return t;
      }
      function Vy(e, t) {
        if (!e) {
          return false;
        }
        return (
          e.is('element', 'image') && t.checkAttribute('image', 'linkHref')
        );
      }
      class Dy extends sk {
        constructor(e) {
          super(e);
          this.manualDecorators = new xs();
          this.automaticDecorators = new jv();
        }
        restoreManualDecoratorStates() {
          for (const e of this.manualDecorators) {
            e.value = this._getDecoratorStateFromModel(e.id);
          }
        }
        refresh() {
          const e = this.editor.model;
          const t = e.document;
          const i = ck(t.selection.getSelectedBlocks());
          if (Vy(i, e.schema)) {
            this.value = i.getAttribute('linkHref');
            this.isEnabled = e.schema.checkAttribute(i, 'linkHref');
          } else {
            this.value = t.selection.getAttribute('linkHref');
            this.isEnabled = e.schema.checkAttributeInSelection(
              t.selection,
              'linkHref'
            );
          }
          for (const e of this.manualDecorators) {
            e.value = this._getDecoratorStateFromModel(e.id);
          }
        }
        execute(e, t = {}) {
          const i = this.editor.model;
          const n = i.document.selection;
          const o = [];
          const r = [];
          for (const e in t) {
            if (t[e]) {
              o.push(e);
            } else {
              r.push(e);
            }
          }
          i.change((t) => {
            if (n.isCollapsed) {
              const s = n.getFirstPosition();
              if (n.hasAttribute('linkHref')) {
                const a = uv(s, 'linkHref', n.getAttribute('linkHref'), i);
                t.setAttribute('linkHref', e, a);
                o.forEach((e) => {
                  t.setAttribute(e, true, a);
                });
                r.forEach((e) => {
                  t.removeAttribute(e, a);
                });
                t.setSelection(t.createPositionAfter(a.end.nodeBefore));
              } else if (e !== '') {
                const r = Us(n.getAttributes());
                r.set('linkHref', e);
                o.forEach((e) => {
                  r.set(e, true);
                });
                const a = t.createText(e, r);
                i.insertContent(a, s);
                t.setSelection(t.createPositionAfter(a));
              }
              ['linkHref', ...o, ...r].forEach((e) => {
                t.removeSelectionAttribute(e);
              });
            } else {
              const s = i.schema.getValidRanges(n.getRanges(), 'linkHref');
              const a = [];
              for (const e of n.getSelectedBlocks()) {
                if (i.schema.checkAttribute(e, 'linkHref')) {
                  a.push(t.createRangeOn(e));
                }
              }
              const c = a.slice();
              for (const e of s) {
                if (this._isRangeToUpdate(e, a)) {
                  c.push(e);
                }
              }
              for (const i of c) {
                t.setAttribute('linkHref', e, i);
                o.forEach((e) => {
                  t.setAttribute(e, true, i);
                });
                r.forEach((e) => {
                  t.removeAttribute(e, i);
                });
              }
            }
          });
        }
        _getDecoratorStateFromModel(e) {
          const t = this.editor.model;
          const i = t.document;
          const n = ck(i.selection.getSelectedBlocks());
          if (Vy(n, t.schema)) {
            return n.getAttribute(e);
          }
          return i.selection.getAttribute(e);
        }
        _isRangeToUpdate(e, t) {
          for (const i of t) {
            if (i.containsRange(e)) {
              return false;
            }
          }
          return true;
        }
      }
      class jy extends sk {
        refresh() {
          const e = this.editor.model;
          const t = e.document;
          const i = ck(t.selection.getSelectedBlocks());
          if (Vy(i, e.schema)) {
            this.isEnabled = e.schema.checkAttribute(i, 'linkHref');
          } else {
            this.isEnabled = e.schema.checkAttributeInSelection(
              t.selection,
              'linkHref'
            );
          }
        }
        execute() {
          const e = this.editor;
          const t = this.editor.model;
          const i = t.document.selection;
          const n = e.commands.get('link');
          t.change((e) => {
            const o = i.isCollapsed
              ? [
                  uv(
                    i.getFirstPosition(),
                    'linkHref',
                    i.getAttribute('linkHref'),
                    t
                  ),
                ]
              : i.getRanges();
            for (const t of o) {
              e.removeAttribute('linkHref', t);
              if (n) {
                for (const i of n.manualDecorators) {
                  e.removeAttribute(i.id, t);
                }
              }
            }
          });
        }
      }
      class By {
        constructor({ id: e, label: t, attributes: i, defaultValue: n }) {
          this.id = e;
          this.set('value');
          this.defaultValue = n;
          this.label = t;
          this.attributes = i;
        }
      }
      ys(By, Qc);
      var Fy = i(48);
      const Hy = 'ck-link_selected';
      const Uy = 'automatic';
      const qy = 'manual';
      const Wy = /^(https?:)?\/\//;
      class $y extends ok {
        static get pluginName() {
          return 'LinkEditing';
        }
        static get requires() {
          return [rv, Ev, Vv];
        }
        constructor(e) {
          super(e);
          e.config.define('link', { addTargetToExternalLinks: false });
        }
        init() {
          const e = this.editor;
          e.model.schema.extend('$text', { allowAttributes: 'linkHref' });
          e.conversion
            .for('dataDowncast')
            .attributeToElement({ model: 'linkHref', view: Ny });
          e.conversion.for('editingDowncast').attributeToElement({
            model: 'linkHref',
            view: (e, t) => Ny(Oy(e), t),
          });
          e.conversion.for('upcast').elementToAttribute({
            view: { name: 'a', attributes: { href: true } },
            model: { key: 'linkHref', value: (e) => e.getAttribute('href') },
          });
          e.commands.add('link', new Dy(e));
          e.commands.add('unlink', new jy(e));
          const t = Ry(e.t, Ly(e.config.get('link.decorators')));
          this._enableAutomaticDecorators(t.filter((e) => e.mode === Uy));
          this._enableManualDecorators(t.filter((e) => e.mode === qy));
          const i = e.plugins.get(rv);
          i.registerAttribute('linkHref');
          fv(e, 'linkHref', 'a', Hy);
          this._enableInsertContentSelectionAttributesFixer();
          this._enableClickingAfterLink();
          this._enableTypingOverLink();
          this._handleDeleteContentAfterLink();
        }
        _enableAutomaticDecorators(e) {
          const t = this.editor;
          const i = t.commands.get('link');
          const n = i.automaticDecorators;
          if (t.config.get('link.addTargetToExternalLinks')) {
            n.add({
              id: 'linkIsExternal',
              mode: Uy,
              callback: (e) => Wy.test(e),
              attributes: { target: '_blank', rel: 'noopener noreferrer' },
            });
          }
          n.add(e);
          if (n.length) {
            t.conversion.for('downcast').add(n.getDispatcher());
          }
        }
        _enableManualDecorators(e) {
          if (!e.length) {
            return;
          }
          const t = this.editor;
          const i = t.commands.get('link');
          const n = i.manualDecorators;
          e.forEach((e) => {
            t.model.schema.extend('$text', { allowAttributes: e.id });
            n.add(new By(e));
            t.conversion.for('downcast').attributeToElement({
              model: e.id,
              view: (t, { writer: i }) => {
                if (t) {
                  const t = n.get(e.id).attributes;
                  const o = i.createAttributeElement('a', t, { priority: 5 });
                  i.setCustomProperty('link', true, o);
                  return o;
                }
              },
            });
            t.conversion.for('upcast').elementToAttribute({
              view: { name: 'a', attributes: n.get(e.id).attributes },
              model: { key: e.id },
            });
          });
        }
        _enableInsertContentSelectionAttributesFixer() {
          const e = this.editor;
          const t = e.model;
          const i = t.document.selection;
          const n = e.commands.get('link');
          this.listenTo(
            t,
            'insertContent',
            () => {
              const e = i.anchor.nodeBefore;
              const o = i.anchor.nodeAfter;
              if (!i.hasAttribute('linkHref')) {
                return;
              }
              if (!e) {
                return;
              }
              if (!e.hasAttribute('linkHref')) {
                return;
              }
              if (o && o.hasAttribute('linkHref')) {
                return;
              }
              t.change((e) => {
                Gy(e, n.manualDecorators);
              });
            },
            { priority: 'low' }
          );
        }
        _enableClickingAfterLink() {
          const e = this.editor;
          const t = e.commands.get('link');
          e.editing.view.addObserver(ov);
          let i = false;
          this.listenTo(e.editing.view.document, 'mousedown', () => {
            i = true;
          });
          this.listenTo(e.editing.view.document, 'selectionChange', () => {
            if (!i) {
              return;
            }
            i = false;
            const n = e.model.document.selection;
            if (!n.isCollapsed) {
              return;
            }
            if (!n.hasAttribute('linkHref')) {
              return;
            }
            const o = n.getFirstPosition();
            const r = uv(o, 'linkHref', n.getAttribute('linkHref'), e.model);
            if (o.isTouching(r.start) || o.isTouching(r.end)) {
              e.model.change((e) => {
                Gy(e, t.manualDecorators);
              });
            }
          });
        }
        _enableTypingOverLink() {
          const e = this.editor;
          const t = e.editing.view;
          let i;
          let n;
          this.listenTo(
            t.document,
            'delete',
            () => {
              n = true;
            },
            { priority: 'high' }
          );
          this.listenTo(
            e.model,
            'deleteContent',
            () => {
              const t = e.model.document.selection;
              if (t.isCollapsed) {
                return;
              }
              if (n) {
                n = false;
                return;
              }
              if (!Ky(e)) {
                return;
              }
              if (Yy(e.model)) {
                i = t.getAttributes();
              }
            },
            { priority: 'high' }
          );
          this.listenTo(
            e.model,
            'insertContent',
            (t, [o]) => {
              n = false;
              if (!Ky(e)) {
                return;
              }
              if (!i) {
                return;
              }
              e.model.change((e) => {
                for (const [t, n] of i) {
                  e.setAttribute(t, n, o);
                }
              });
              i = null;
            },
            { priority: 'high' }
          );
        }
        _handleDeleteContentAfterLink() {
          const e = this.editor;
          const t = e.model;
          const i = t.document.selection;
          const n = e.editing.view;
          const o = e.commands.get('link');
          let r = false;
          let s = false;
          this.listenTo(
            n.document,
            'delete',
            (e, t) => {
              s = t.domEvent.keyCode === zl.backspace;
            },
            { priority: 'high' }
          );
          this.listenTo(
            t,
            'deleteContent',
            () => {
              r = false;
              const e = i.getFirstPosition();
              const n = i.getAttribute('linkHref');
              if (!n) {
                return;
              }
              const o = uv(e, 'linkHref', n, t);
              r = o.containsPosition(e) || o.end.isEqual(e);
            },
            { priority: 'high' }
          );
          this.listenTo(
            t,
            'deleteContent',
            () => {
              if (!s) {
                return;
              }
              s = false;
              if (r) {
                return;
              }
              e.model.enqueueChange((e) => {
                Gy(e, o.manualDecorators);
              });
            },
            { priority: 'low' }
          );
        }
      }
      function Gy(e, t) {
        e.removeSelectionAttribute('linkHref');
        for (const i of t) {
          e.removeSelectionAttribute(i.id);
        }
      }
      function Yy(e) {
        const t = e.document.selection;
        const i = t.getFirstPosition();
        const n = t.getLastPosition();
        const o = i.nodeAfter;
        if (!o) {
          return false;
        }
        if (!o.is('$text')) {
          return false;
        }
        if (!o.hasAttribute('linkHref')) {
          return false;
        }
        const r = n.textNode || n.nodeBefore;
        if (o === r) {
          return true;
        }
        const s = uv(i, 'linkHref', o.getAttribute('linkHref'), e);
        return s.containsRange(e.createRange(i, n), true);
      }
      function Ky(e) {
        const t = e.plugins.get('Input');
        return t.isInput(e.model.change((e) => e.batch));
      }
      class Qy extends Hk {
        static get pluginName() {
          return 'Notification';
        }
        init() {
          this.on(
            'show:warning',
            (e, t) => {
              window.alert(t.message);
            },
            { priority: 'lowest' }
          );
        }
        showSuccess(e, t = {}) {
          this._showNotification({
            message: e,
            type: 'success',
            namespace: t.namespace,
            title: t.title,
          });
        }
        showInfo(e, t = {}) {
          this._showNotification({
            message: e,
            type: 'info',
            namespace: t.namespace,
            title: t.title,
          });
        }
        showWarning(e, t = {}) {
          this._showNotification({
            message: e,
            type: 'warning',
            namespace: t.namespace,
            title: t.title,
          });
        }
        _showNotification(e) {
          const t = `show:${e.type}` + (e.namespace ? `:${e.namespace}` : '');
          this.fire(t, {
            message: e.message,
            type: e.type,
            title: e.title || '',
          });
        }
      }
      class Jy extends sk {
        constructor(e) {
          super(e);
          this.stopListening(this.editor.model.document, 'change');
          this.listenTo(
            this.editor.model.document,
            'change',
            () => this.refresh(),
            { priority: 'low' }
          );
        }
        refresh() {
          const e = this.editor.commands.get('imageInsert');
          const t = this.editor.commands.get('link');
          this.isEnabled = e.isEnabled || t.isEnabled;
        }
        execute() {
          const e = this.editor;
          const t = this.editor.config.get('ckfinder.openerMethod') || 'modal';
          if (t != 'popup' && t != 'modal') {
            throw new ss['b'](
              'ckfinder-unknown-openerMethod: The openerMethod config option must by "popup" or "modal".',
              e
            );
          }
          const i = this.editor.config.get('ckfinder.options') || {};
          i.chooseFiles = true;
          const n = i.onInit;
          if (!i.language) {
            i.language = e.locale.uiLanguage;
          }
          i.onInit = (t) => {
            if (n) {
              n(t);
            }
            t.on('files:choose', (i) => {
              const n = i.data.files.toArray();
              const o = n.filter((e) => !e.isImage());
              const r = n.filter((e) => e.isImage());
              for (const t of o) {
                e.execute('link', t.getUrl());
              }
              const s = [];
              for (const e of r) {
                const i = e.getUrl();
                s.push(i ? i : t.request('file:getProxyUrl', { file: e }));
              }
              if (s.length) {
                Zy(e, s);
              }
            });
            t.on('file:choose:resizedImage', (t) => {
              const i = t.data.resizedUrl;
              if (!i) {
                const t = e.plugins.get('Notification');
                const i = e.locale.t;
                t.showWarning(i('Could not obtain resized image URL.'), {
                  title: i('Selecting resized image failed'),
                  namespace: 'ckfinder',
                });
                return;
              }
              Zy(e, [i]);
            });
          };
          window.CKFinder[t](i);
        }
      }
      function Zy(e, t) {
        const i = e.commands.get('imageInsert');
        if (!i.isEnabled) {
          const t = e.plugins.get('Notification');
          const i = e.locale.t;
          t.showWarning(i('Could not insert image at the current position.'), {
            title: i('Inserting image failed'),
            namespace: 'ckfinder',
          });
          return;
        }
        e.execute('imageInsert', { source: t });
      }
      class Xy extends ok {
        static get pluginName() {
          return 'CKFinderEditing';
        }
        static get requires() {
          return [Qy, iv, $y];
        }
        init() {
          const e = this.editor;
          e.commands.add('ckfinder', new Jy(e));
        }
      }
      class ex {
        constructor() {
          const e = new window.FileReader();
          this._reader = e;
          this._data = undefined;
          this.set('loaded', 0);
          e.onprogress = (e) => {
            this.loaded = e.loaded;
          };
        }
        get error() {
          return this._reader.error;
        }
        get data() {
          return this._data;
        }
        read(e) {
          const t = this._reader;
          this.total = e.size;
          return new Promise((i, n) => {
            t.onload = () => {
              const e = t.result;
              this._data = e;
              i(e);
            };
            t.onerror = () => {
              n('error');
            };
            t.onabort = () => {
              n('aborted');
            };
            this._reader.readAsDataURL(e);
          });
        }
        abort() {
          this._reader.abort();
        }
      }
      ys(ex, Qc);
      class tx extends ok {
        static get pluginName() {
          return 'FileRepository';
        }
        static get requires() {
          return [Uk];
        }
        init() {
          this.loaders = new xs();
          this.loaders.on('add', () => this._updatePendingAction());
          this.loaders.on('remove', () => this._updatePendingAction());
          this._loadersMap = new Map();
          this._pendingAction = null;
          this.set('uploaded', 0);
          this.set('uploadTotal', null);
          this.bind('uploadedPercent').to(
            this,
            'uploaded',
            this,
            'uploadTotal',
            (e, t) => (t ? (e / t) * 100 : 0)
          );
        }
        getLoader(e) {
          return this._loadersMap.get(e) || null;
        }
        createLoader(e) {
          if (!this.createUploadAdapter) {
            console.warn(
              Object(ss['a'])(
                'filerepository-no-upload-adapter: Upload adapter is not defined.'
              )
            );
            return null;
          }
          const t = new ix(Promise.resolve(e), this.createUploadAdapter);
          this.loaders.add(t);
          this._loadersMap.set(e, t);
          if (e instanceof Promise) {
            t.file
              .then((e) => {
                this._loadersMap.set(e, t);
              })
              .catch(() => {});
          }
          t.on('change:uploaded', () => {
            let e = 0;
            for (const t of this.loaders) {
              e += t.uploaded;
            }
            this.uploaded = e;
          });
          t.on('change:uploadTotal', () => {
            let e = 0;
            for (const t of this.loaders) {
              if (t.uploadTotal) {
                e += t.uploadTotal;
              }
            }
            this.uploadTotal = e;
          });
          return t;
        }
        destroyLoader(e) {
          const t = e instanceof ix ? e : this.getLoader(e);
          t._destroy();
          this.loaders.remove(t);
          this._loadersMap.forEach((e, i) => {
            if (e === t) {
              this._loadersMap.delete(i);
            }
          });
        }
        _updatePendingAction() {
          const e = this.editor.plugins.get(Uk);
          if (this.loaders.length) {
            if (!this._pendingAction) {
              const t = this.editor.t;
              const i = (e) => `${t('Upload in progress')} ${parseInt(e)}%.`;
              this._pendingAction = e.add(i(this.uploadedPercent));
              this._pendingAction
                .bind('message')
                .to(this, 'uploadedPercent', i);
            }
          } else {
            e.remove(this._pendingAction);
            this._pendingAction = null;
          }
        }
      }
      ys(tx, Qc);
      class ix {
        constructor(e, t) {
          this.id = is();
          this._filePromiseWrapper = this._createFilePromiseWrapper(e);
          this._adapter = t(this);
          this._reader = new ex();
          this.set('status', 'idle');
          this.set('uploaded', 0);
          this.set('uploadTotal', null);
          this.bind('uploadedPercent').to(
            this,
            'uploaded',
            this,
            'uploadTotal',
            (e, t) => (t ? (e / t) * 100 : 0)
          );
          this.set('uploadResponse', null);
        }
        get file() {
          if (!this._filePromiseWrapper) {
            return Promise.resolve(null);
          } else {
            return this._filePromiseWrapper.promise.then((e) =>
              this._filePromiseWrapper ? e : null
            );
          }
        }
        get data() {
          return this._reader.data;
        }
        read() {
          if (this.status != 'idle') {
            throw new ss['b'](
              'filerepository-read-wrong-status: You cannot call read if the status is different than idle.',
              this
            );
          }
          this.status = 'reading';
          return this.file
            .then((e) => this._reader.read(e))
            .then((e) => {
              if (this.status !== 'reading') {
                throw this.status;
              }
              this.status = 'idle';
              return e;
            })
            .catch((e) => {
              if (e === 'aborted') {
                this.status = 'aborted';
                throw 'aborted';
              }
              this.status = 'error';
              throw this._reader.error ? this._reader.error : e;
            });
        }
        upload() {
          if (this.status != 'idle') {
            throw new ss['b'](
              'filerepository-upload-wrong-status: You cannot call upload if the status is different than idle.',
              this
            );
          }
          this.status = 'uploading';
          return this.file
            .then(() => this._adapter.upload())
            .then((e) => {
              this.uploadResponse = e;
              this.status = 'idle';
              return e;
            })
            .catch((e) => {
              if (this.status === 'aborted') {
                throw 'aborted';
              }
              this.status = 'error';
              throw e;
            });
        }
        abort() {
          const e = this.status;
          this.status = 'aborted';
          if (!this._filePromiseWrapper.isFulfilled) {
            this._filePromiseWrapper.promise.catch(() => {});
            this._filePromiseWrapper.rejecter('aborted');
          } else if (e == 'reading') {
            this._reader.abort();
          } else if (e == 'uploading' && this._adapter.abort) {
            this._adapter.abort();
          }
          this._destroy();
        }
        _destroy() {
          this._filePromiseWrapper = undefined;
          this._reader = undefined;
          this._adapter = undefined;
          this.uploadResponse = undefined;
        }
        _createFilePromiseWrapper(e) {
          const t = {};
          t.promise = new Promise((i, n) => {
            t.rejecter = n;
            t.isFulfilled = false;
            e.then((e) => {
              t.isFulfilled = true;
              i(e);
            }).catch((e) => {
              t.isFulfilled = true;
              n(e);
            });
          });
          return t;
        }
      }
      ys(ix, Qc);
      const nx = 'ckCsrfToken';
      const ox = 40;
      const rx = 'abcdefghijklmnopqrstuvwxyz0123456789';
      function sx() {
        let e = ax(nx);
        if (!e || e.length != ox) {
          e = lx(ox);
          cx(nx, e);
        }
        return e;
      }
      function ax(e) {
        e = e.toLowerCase();
        const t = document.cookie.split(';');
        for (const i of t) {
          const t = i.split('=');
          const n = decodeURIComponent(t[0].trim().toLowerCase());
          if (n === e) {
            return decodeURIComponent(t[1]);
          }
        }
        return null;
      }
      function cx(e, t) {
        document.cookie =
          encodeURIComponent(e) + '=' + encodeURIComponent(t) + ';path=/';
      }
      function lx(e) {
        let t = '';
        const i = new Uint8Array(e);
        window.crypto.getRandomValues(i);
        for (let e = 0; e < i.length; e++) {
          const n = rx.charAt(i[e] % rx.length);
          t += Math.random() > 0.5 ? n.toUpperCase() : n;
        }
        return t;
      }
      class dx extends ok {
        static get requires() {
          return [tx];
        }
        static get pluginName() {
          return 'CKFinderUploadAdapter';
        }
        init() {
          const e = this.editor.config.get('ckfinder.uploadUrl');
          if (!e) {
            return;
          }
          this.editor.plugins.get(tx).createUploadAdapter = (t) =>
            new ux(t, e, this.editor.t);
        }
      }
      class ux {
        constructor(e, t, i) {
          this.loader = e;
          this.url = t;
          this.t = i;
        }
        upload() {
          return this.loader.file.then(
            (e) =>
              new Promise((t, i) => {
                this._initRequest();
                this._initListeners(t, i, e);
                this._sendRequest(e);
              })
          );
        }
        abort() {
          if (this.xhr) {
            this.xhr.abort();
          }
        }
        _initRequest() {
          const e = (this.xhr = new XMLHttpRequest());
          e.open('POST', this.url, true);
          e.responseType = 'json';
        }
        _initListeners(e, t, i) {
          const n = this.xhr;
          const o = this.loader;
          const r = this.t;
          const s = r('Cannot upload file:') + ` ${i.name}.`;
          n.addEventListener('error', () => t(s));
          n.addEventListener('abort', () => t());
          n.addEventListener('load', () => {
            const i = n.response;
            if (!i || !i.uploaded) {
              return t(i && i.error && i.error.message ? i.error.message : s);
            }
            e({ default: i.url });
          });
          if (n.upload) {
            n.upload.addEventListener('progress', (e) => {
              if (e.lengthComputable) {
                o.uploadTotal = e.total;
                o.uploaded = e.loaded;
              }
            });
          }
        }
        _sendRequest(e) {
          const t = new FormData();
          t.append('upload', e);
          t.append('ckCsrfToken', sx());
          this.xhr.send(t);
        }
      }
      class hx extends ok {
        static get pluginName() {
          return 'CKFinder';
        }
        static get requires() {
          return [Xy, c_, dx];
        }
      }
      const fx = 'code';
      const gx = 'ck-code_selected';
      class mx extends ok {
        static get pluginName() {
          return 'CodeEditing';
        }
        static get requires() {
          return [rv];
        }
        init() {
          const e = this.editor;
          e.model.schema.extend('$text', { allowAttributes: fx });
          e.model.schema.setAttributeProperties(fx, {
            isFormatting: true,
            copyOnEnter: true,
          });
          e.conversion.attributeToElement({
            model: fx,
            view: 'code',
            upcastAlso: { styles: { 'word-wrap': 'break-word' } },
          });
          e.commands.add(fx, new e_(e, fx));
          e.plugins.get(rv).registerAttribute(fx);
          fv(e, fx, 'code', gx);
        }
      }
      var px =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M12.5 5.7l5.2 3.9v1.3l-5.6 4c-.1.2-.3.2-.5.2-.3-.1-.6-.7-.6-1l.3-.4 4.7-3.5L11.5 7l-.2-.2c-.1-.3-.1-.6 0-.8.2-.2.5-.4.8-.4a.8.8 0 0 1 .4.1zm-5.2 0L2 9.6v1.3l5.6 4c.1.2.3.2.5.2.3-.1.7-.7.6-1 0-.1 0-.3-.2-.4l-5-3.5L8.2 7l.2-.2c.1-.3.1-.6 0-.8-.2-.2-.5-.4-.8-.4a.8.8 0 0 0-.3.1z"/></svg>';
      var bx = i(11);
      const wx = 'code';
      class kx extends ok {
        init() {
          const e = this.editor;
          const t = e.t;
          e.ui.componentFactory.add(wx, (i) => {
            const n = e.commands.get(wx);
            const o = new Ew(i);
            o.set({
              label: t('Code'),
              icon: px,
              tooltip: true,
              isToggleable: true,
            });
            o.bind('isOn', 'isEnabled').to(n, 'value', 'isEnabled');
            this.listenTo(o, 'execute', () => {
              e.execute(wx);
              e.editing.view.focus();
            });
            return o;
          });
        }
      }
      class _x extends ok {
        static get requires() {
          return [mx, kx];
        }
        static get pluginName() {
          return 'Code';
        }
      }
      function* vx(e, t) {
        for (const i of t) {
          if (i && e.getAttributeProperties(i[0]).copyOnEnter) {
            yield i;
          }
        }
      }
      class yx extends sk {
        execute() {
          const e = this.editor.model;
          const t = e.document;
          e.change((i) => {
            xx(this.editor.model, i, t.selection, e.schema);
            this.fire('afterExecute', { writer: i });
          });
        }
      }
      function xx(e, t, i, n) {
        const o = i.isCollapsed;
        const r = i.getFirstRange();
        const s = r.start.parent;
        const a = r.end.parent;
        if (n.isLimit(s) || n.isLimit(a)) {
          if (!o && s == a) {
            e.deleteContent(i);
          }
          return;
        }
        if (o) {
          const e = vx(t.model.schema, i.getAttributes());
          Ax(t, r.start);
          t.setSelectionAttribute(e);
        } else {
          const n = !(r.start.isAtStart && r.end.isAtEnd);
          const o = s == a;
          e.deleteContent(i, { leaveUnmerged: n });
          if (n) {
            if (o) {
              Ax(t, i.focus);
            } else {
              t.setSelection(a, 0);
            }
          }
        }
      }
      function Ax(e, t) {
        e.split(t);
        e.setSelection(t.parent.nextSibling, 0);
      }
      class Tx extends Zd {
        constructor(e) {
          super(e);
          const t = this.document;
          t.on('keydown', (e, i) => {
            if (this.isEnabled && i.keyCode == zl.enter) {
              let n;
              t.once('enter', (e) => (n = e), { priority: 'highest' });
              t.fire('enter', new Xu(t, i.domEvent, { isSoft: i.shiftKey }));
              if (n && n.stop.called) {
                e.stop();
              }
            }
          });
        }
        observe() {}
      }
      class Cx extends ok {
        static get pluginName() {
          return 'Enter';
        }
        init() {
          const e = this.editor;
          const t = e.editing.view;
          const i = t.document;
          t.addObserver(Tx);
          e.commands.add('enter', new yx(e));
          this.listenTo(
            i,
            'enter',
            (i, n) => {
              n.preventDefault();
              if (n.isSoft) {
                return;
              }
              e.execute('enter');
              t.scrollToTheSelection();
            },
            { priority: 'low' }
          );
        }
      }
      class Px extends sk {
        execute() {
          const e = this.editor.model;
          const t = e.document;
          e.change((i) => {
            Sx(e, i, t.selection);
            this.fire('afterExecute', { writer: i });
          });
        }
        refresh() {
          const e = this.editor.model;
          const t = e.document;
          this.isEnabled = Ex(e.schema, t.selection);
        }
      }
      function Ex(e, t) {
        if (t.rangeCount > 1) {
          return false;
        }
        const i = t.anchor;
        if (!i || !e.checkChild(i, 'softBreak')) {
          return false;
        }
        const n = t.getFirstRange();
        const o = n.start.parent;
        const r = n.end.parent;
        if ((Ix(o, e) || Ix(r, e)) && o !== r) {
          return false;
        }
        return true;
      }
      function Sx(e, t, i) {
        const n = i.isCollapsed;
        const o = i.getFirstRange();
        const r = o.start.parent;
        const s = o.end.parent;
        const a = r == s;
        if (n) {
          const n = vx(e.schema, i.getAttributes());
          Mx(e, t, o.end);
          t.removeSelectionAttribute(i.getAttributeKeys());
          t.setSelectionAttribute(n);
        } else {
          const n = !(o.start.isAtStart && o.end.isAtEnd);
          e.deleteContent(i, { leaveUnmerged: n });
          if (a) {
            Mx(e, t, i.focus);
          } else {
            if (n) {
              t.setSelection(s, 0);
            }
          }
        }
      }
      function Mx(e, t, i) {
        const n = t.createElement('softBreak');
        e.insertContent(n, i);
        t.setSelection(n, 'after');
      }
      function Ix(e, t) {
        if (e.is('rootElement')) {
          return false;
        }
        return t.isLimit(e) || Ix(e.parent, t);
      }
      class Nx extends ok {
        static get pluginName() {
          return 'ShiftEnter';
        }
        init() {
          const e = this.editor;
          const t = e.model.schema;
          const i = e.conversion;
          const n = e.editing.view;
          const o = n.document;
          t.register('softBreak', { allowWhere: '$text', isInline: true });
          i.for('upcast').elementToElement({ model: 'softBreak', view: 'br' });
          i.for('downcast').elementToElement({
            model: 'softBreak',
            view: (e, { writer: t }) => t.createEmptyElement('br'),
          });
          n.addObserver(Tx);
          e.commands.add('shiftEnter', new Px(e));
          this.listenTo(
            o,
            'enter',
            (t, i) => {
              i.preventDefault();
              if (!i.isSoft) {
                return;
              }
              e.execute('shiftEnter');
              n.scrollToTheSelection();
            },
            { priority: 'low' }
          );
        }
      }
      class Ox extends sk {
        execute() {
          const e = this.editor.model;
          const t = e.document.selection;
          let i = e.schema.getLimitElement(t);
          if (t.containsEntireContent(i) || !zx(e.schema, i)) {
            do {
              i = i.parent;
              if (!i) {
                return;
              }
            } while (!zx(e.schema, i));
          }
          e.change((e) => {
            e.setSelection(i, 'in');
          });
        }
      }
      function zx(e, t) {
        return (
          e.isLimit(t) &&
          (e.checkChild(t, '$text') || e.checkChild(t, 'paragraph'))
        );
      }
      const Rx = Ll('Ctrl+A');
      class Lx extends ok {
        static get pluginName() {
          return 'SelectAllEditing';
        }
        init() {
          const e = this.editor;
          const t = e.editing.view;
          const i = t.document;
          e.commands.add('selectAll', new Ox(e));
          this.listenTo(i, 'keydown', (t, i) => {
            if (Rl(i) === Rx) {
              e.execute('selectAll');
              i.preventDefault();
            }
          });
        }
      }
      var Vx =
        '<svg width="20" height="20" xmlns="http://www.w3.org/2000/svg"><path d="M.75 15.5a.75.75 0 0 1 .75.75V18l.008.09A.5.5 0 0 0 2 18.5h1.75a.75.75 0 1 1 0 1.5H1.5l-.144-.007a1.5 1.5 0 0 1-1.35-1.349L0 18.5v-2.25a.75.75 0 0 1 .75-.75zm18.5 0a.75.75 0 0 1 .75.75v2.25l-.007.144a1.5 1.5 0 0 1-1.349 1.35L18.5 20h-2.25a.75.75 0 1 1 0-1.5H18a.5.5 0 0 0 .492-.41L18.5 18v-1.75a.75.75 0 0 1 .75-.75zm-10.45 3c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2h1.6zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2h1.6zm.45-5.5a.75.75 0 1 1 0 1.5h-8.5a.75.75 0 1 1 0-1.5h8.5zM1.3 11c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h1.1zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h1.1zm-4.55-2a.75.75 0 1 1 0 1.5H4.75a.75.75 0 1 1 0-1.5h10.5zM1.3 7c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2h1.1zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2h1.1zm-4.55-2a.75.75 0 1 1 0 1.5h-2.5a.75.75 0 1 1 0-1.5h2.5zm-5 0a.75.75 0 1 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5h5.5zm-6.5-5a.75.75 0 0 1 0 1.5H2a.5.5 0 0 0-.492.41L1.5 2v1.75a.75.75 0 0 1-1.5 0V1.5l.007-.144A1.5 1.5 0 0 1 1.356.006L1.5 0h2.25zM18.5 0l.144.007a1.5 1.5 0 0 1 1.35 1.349L20 1.5v2.25a.75.75 0 1 1-1.5 0V2l-.008-.09A.5.5 0 0 0 18 1.5h-1.75a.75.75 0 1 1 0-1.5h2.25zM8.8 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2h1.6zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2h1.6z"/></svg>';
      class Dx extends ok {
        static get pluginName() {
          return 'SelectAllUI';
        }
        init() {
          const e = this.editor;
          e.ui.componentFactory.add('selectAll', (t) => {
            const i = e.commands.get('selectAll');
            const n = new Ew(t);
            const o = t.t;
            n.set({
              label: o('Select all'),
              icon: Vx,
              keystroke: 'Ctrl+A',
              tooltip: true,
            });
            n.bind('isOn', 'isEnabled').to(i, 'value', 'isEnabled');
            this.listenTo(n, 'execute', () => {
              e.execute('selectAll');
              e.editing.view.focus();
            });
            return n;
          });
        }
      }
      class jx extends ok {
        static get requires() {
          return [Lx, Dx];
        }
        static get pluginName() {
          return 'SelectAll';
        }
      }
      class Bx extends sk {
        constructor(e, t) {
          super(e);
          this.direction = t;
          this._buffer = new gv(e.model, e.config.get('typing.undoStep'));
        }
        get buffer() {
          return this._buffer;
        }
        execute(e = {}) {
          const t = this.editor.model;
          const i = t.document;
          t.enqueueChange(this._buffer.batch, (n) => {
            this._buffer.lock();
            const o = n.createSelection(e.selection || i.selection);
            const r = o.isCollapsed;
            if (o.isCollapsed) {
              t.modifySelection(o, { direction: this.direction, unit: e.unit });
            }
            if (
              this._shouldEntireContentBeReplacedWithParagraph(e.sequence || 1)
            ) {
              this._replaceEntireContentWithParagraph(n);
              return;
            }
            if (o.isCollapsed) {
              return;
            }
            let s = 0;
            o.getFirstRange()
              .getMinimalFlatRanges()
              .forEach((e) => {
                s += gl(
                  e.getWalker({
                    singleCharacters: true,
                    ignoreElementEnd: true,
                    shallow: true,
                  })
                );
              });
            t.deleteContent(o, {
              doNotResetEntireContent: r,
              direction: this.direction,
            });
            this._buffer.input(s);
            n.setSelection(o);
            this._buffer.unlock();
          });
        }
        _shouldEntireContentBeReplacedWithParagraph(e) {
          if (e > 1) {
            return false;
          }
          const t = this.editor.model;
          const i = t.document;
          const n = i.selection;
          const o = t.schema.getLimitElement(n);
          const r = n.isCollapsed && n.containsEntireContent(o);
          if (!r) {
            return false;
          }
          if (!t.schema.checkChild(o, 'paragraph')) {
            return false;
          }
          const s = o.getChild(0);
          if (s && s.name === 'paragraph') {
            return false;
          }
          return true;
        }
        _replaceEntireContentWithParagraph(e) {
          const t = this.editor.model;
          const i = t.document;
          const n = i.selection;
          const o = t.schema.getLimitElement(n);
          const r = e.createElement('paragraph');
          e.remove(e.createRangeIn(o));
          e.insert(r, o);
          e.setSelection(r, 0);
        }
      }
      class Fx extends Zd {
        constructor(e) {
          super(e);
          const t = e.document;
          let i = 0;
          t.on('keyup', (e, t) => {
            if (t.keyCode == zl.delete || t.keyCode == zl.backspace) {
              i = 0;
            }
          });
          t.on('keydown', (e, t) => {
            const o = {};
            if (t.keyCode == zl.delete) {
              o.direction = 'forward';
              o.unit = 'character';
            } else if (t.keyCode == zl.backspace) {
              o.direction = 'backward';
              o.unit = 'codePoint';
            } else {
              return;
            }
            const r = Cl.isMac ? t.altKey : t.ctrlKey;
            o.unit = r ? 'word' : o.unit;
            o.sequence = ++i;
            n(e, t.domEvent, o);
          });
          if (Cl.isAndroid) {
            t.on('beforeinput', (t, i) => {
              if (i.domEvent.inputType != 'deleteContentBackward') {
                return;
              }
              const o = {
                unit: 'codepoint',
                direction: 'backward',
                sequence: 1,
              };
              const r = i.domTarget.ownerDocument.defaultView.getSelection();
              if (
                r.anchorNode == r.focusNode &&
                r.anchorOffset + 1 != r.focusOffset
              ) {
                o.selectionToRemove = e.domConverter.domSelectionToView(r);
              }
              n(t, i.domEvent, o);
            });
          }
          function n(e, i, n) {
            let o;
            t.once('delete', (e) => (o = e), {
              priority: Number.POSITIVE_INFINITY,
            });
            t.fire('delete', new Xu(t, i, n));
            if (o && o.stop.called) {
              e.stop();
            }
          }
        }
        observe() {}
      }
      class Hx extends ok {
        static get pluginName() {
          return 'Delete';
        }
        init() {
          const e = this.editor;
          const t = e.editing.view;
          const i = t.document;
          t.addObserver(Fx);
          e.commands.add('forwardDelete', new Bx(e, 'forward'));
          e.commands.add('delete', new Bx(e, 'backward'));
          this.listenTo(i, 'delete', (i, n) => {
            const o = { unit: n.unit, sequence: n.sequence };
            if (n.selectionToRemove) {
              const t = e.model.createSelection();
              const i = [];
              for (const t of n.selectionToRemove.getRanges()) {
                i.push(e.editing.mapper.toModelRange(t));
              }
              t.setTo(i);
              o.selection = t;
            }
            e.execute(n.direction == 'forward' ? 'forwardDelete' : 'delete', o);
            n.preventDefault();
            t.scrollToTheSelection();
          });
          if (Cl.isAndroid) {
            let e = null;
            this.listenTo(
              i,
              'delete',
              (t, i) => {
                const n = i.domTarget.ownerDocument.defaultView.getSelection();
                e = {
                  anchorNode: n.anchorNode,
                  anchorOffset: n.anchorOffset,
                  focusNode: n.focusNode,
                  focusOffset: n.focusOffset,
                };
              },
              { priority: 'lowest' }
            );
            this.listenTo(i, 'keyup', (t, i) => {
              if (e) {
                const t = i.domTarget.ownerDocument.defaultView.getSelection();
                t.collapse(e.anchorNode, e.anchorOffset);
                t.extend(e.focusNode, e.focusOffset);
                e = null;
              }
            });
          }
        }
      }
      class Ux extends ok {
        static get requires() {
          return [Ev, Hx];
        }
        static get pluginName() {
          return 'Typing';
        }
      }
      const qx = new Map();
      function Wx(e, t, i) {
        let n = qx.get(e);
        if (!n) {
          n = new Map();
          qx.set(e, n);
        }
        n.set(t, i);
      }
      function $x(e, t) {
        const i = qx.get(e);
        if (i && i.has(t)) {
          return i.get(t);
        }
        return Gx;
      }
      function Gx(e) {
        return [e];
      }
      function Yx(e, t, i = {}) {
        const n = $x(e.constructor, t.constructor);
        try {
          e = e.clone();
          return n(e, t, i);
        } catch (e) {
          throw e;
        }
      }
      function Kx(e, t, i) {
        e = e.slice();
        t = t.slice();
        const n = new Qx(i.document, i.useRelations, i.forceWeakRemove);
        n.setOriginalOperations(e);
        n.setOriginalOperations(t);
        const o = n.originalOperations;
        if (e.length == 0 || t.length == 0) {
          return { operationsA: e, operationsB: t, originalOperations: o };
        }
        const r = new WeakMap();
        for (const t of e) {
          r.set(t, 0);
        }
        const s = {
          nextBaseVersionA: e[e.length - 1].baseVersion + 1,
          nextBaseVersionB: t[t.length - 1].baseVersion + 1,
          originalOperationsACount: e.length,
          originalOperationsBCount: t.length,
        };
        let a = 0;
        while (a < e.length) {
          const i = e[a];
          const o = r.get(i);
          if (o == t.length) {
            a++;
            continue;
          }
          const s = t[o];
          const c = Yx(i, s, n.getContext(i, s, true));
          const l = Yx(s, i, n.getContext(s, i, false));
          n.updateRelation(i, s);
          n.setOriginalOperations(c, i);
          n.setOriginalOperations(l, s);
          for (const e of c) {
            r.set(e, o + l.length);
          }
          e.splice(a, 1, ...c);
          t.splice(o, 1, ...l);
        }
        if (i.padWithNoOps) {
          const i = e.length - s.originalOperationsACount;
          const n = t.length - s.originalOperationsBCount;
          Zx(e, n - i);
          Zx(t, i - n);
        }
        Jx(e, s.nextBaseVersionB);
        Jx(t, s.nextBaseVersionA);
        return { operationsA: e, operationsB: t, originalOperations: o };
      }
      class Qx {
        constructor(e, t, i = false) {
          this.originalOperations = new Map();
          this._history = e.history;
          this._useRelations = t;
          this._forceWeakRemove = !!i;
          this._relations = new Map();
        }
        setOriginalOperations(e, t = null) {
          const i = t ? this.originalOperations.get(t) : null;
          for (const t of e) {
            this.originalOperations.set(t, i || t);
          }
        }
        updateRelation(e, t) {
          switch (e.constructor) {
            case km: {
              switch (t.constructor) {
                case Am: {
                  if (
                    e.targetPosition.isEqual(t.sourcePosition) ||
                    t.movedRange.containsPosition(e.targetPosition)
                  ) {
                    this._setRelation(e, t, 'insertAtSource');
                  } else if (e.targetPosition.isEqual(t.deletionPosition)) {
                    this._setRelation(e, t, 'insertBetween');
                  } else if (e.targetPosition.isAfter(t.sourcePosition)) {
                    this._setRelation(e, t, 'moveTargetAfter');
                  }
                  break;
                }
                case km: {
                  if (
                    e.targetPosition.isEqual(t.sourcePosition) ||
                    e.targetPosition.isBefore(t.sourcePosition)
                  ) {
                    this._setRelation(e, t, 'insertBefore');
                  } else {
                    this._setRelation(e, t, 'insertAfter');
                  }
                  break;
                }
              }
              break;
            }
            case Tm: {
              switch (t.constructor) {
                case Am: {
                  if (e.splitPosition.isBefore(t.sourcePosition)) {
                    this._setRelation(e, t, 'splitBefore');
                  }
                  break;
                }
                case km: {
                  if (
                    e.splitPosition.isEqual(t.sourcePosition) ||
                    e.splitPosition.isBefore(t.sourcePosition)
                  ) {
                    this._setRelation(e, t, 'splitBefore');
                  }
                  break;
                }
              }
              break;
            }
            case Am: {
              switch (t.constructor) {
                case Am: {
                  if (!e.targetPosition.isEqual(t.sourcePosition)) {
                    this._setRelation(e, t, 'mergeTargetNotMoved');
                  }
                  if (e.sourcePosition.isEqual(t.targetPosition)) {
                    this._setRelation(e, t, 'mergeSourceNotMoved');
                  }
                  if (e.sourcePosition.isEqual(t.sourcePosition)) {
                    this._setRelation(e, t, 'mergeSameElement');
                  }
                  break;
                }
                case Tm: {
                  if (e.sourcePosition.isEqual(t.splitPosition)) {
                    this._setRelation(e, t, 'splitAtSource');
                  }
                }
              }
              break;
            }
            case vm: {
              const i = e.newRange;
              if (!i) {
                return;
              }
              switch (t.constructor) {
                case km: {
                  const n = ef._createFromPositionAndShift(
                    t.sourcePosition,
                    t.howMany
                  );
                  const o =
                    n.containsPosition(i.start) || n.start.isEqual(i.start);
                  const r = n.containsPosition(i.end) || n.end.isEqual(i.end);
                  if ((o || r) && !n.containsRange(i)) {
                    this._setRelation(e, t, {
                      side: o ? 'left' : 'right',
                      path: o ? i.start.path.slice() : i.end.path.slice(),
                    });
                  }
                  break;
                }
                case Am: {
                  const n = i.start.isEqual(t.targetPosition);
                  const o = i.start.isEqual(t.deletionPosition);
                  const r = i.end.isEqual(t.deletionPosition);
                  const s = i.end.isEqual(t.sourcePosition);
                  if (n || o || r || s) {
                    this._setRelation(e, t, {
                      wasInLeftElement: n,
                      wasStartBeforeMergedElement: o,
                      wasEndBeforeMergedElement: r,
                      wasInRightElement: s,
                    });
                  }
                  break;
                }
              }
              break;
            }
          }
        }
        getContext(e, t, i) {
          return {
            aIsStrong: i,
            aWasUndone: this._wasUndone(e),
            bWasUndone: this._wasUndone(t),
            abRelation: this._useRelations ? this._getRelation(e, t) : null,
            baRelation: this._useRelations ? this._getRelation(t, e) : null,
            forceWeakRemove: this._forceWeakRemove,
          };
        }
        _wasUndone(e) {
          const t = this.originalOperations.get(e);
          return t.wasUndone || this._history.isUndoneOperation(t);
        }
        _getRelation(e, t) {
          const i = this.originalOperations.get(t);
          const n = this._history.getUndoneOperation(i);
          if (!n) {
            return null;
          }
          const o = this.originalOperations.get(e);
          const r = this._relations.get(o);
          if (r) {
            return r.get(n) || null;
          }
          return null;
        }
        _setRelation(e, t, i) {
          const n = this.originalOperations.get(e);
          const o = this.originalOperations.get(t);
          let r = this._relations.get(n);
          if (!r) {
            r = new Map();
            this._relations.set(n, r);
          }
          r.set(o, i);
        }
      }
      function Jx(e, t) {
        for (const i of e) {
          i.baseVersion = t++;
        }
      }
      function Zx(e, t) {
        for (let i = 0; i < t; i++) {
          e.push(new Ym(0));
        }
      }
      Wx(bm, bm, (e, t, i) => {
        if (e.key === t.key && e.range.start.hasSameParentAs(t.range.start)) {
          const n = e.range
            .getDifference(t.range)
            .map((t) => new bm(t, e.key, e.oldValue, e.newValue, 0));
          const o = e.range.getIntersection(t.range);
          if (o) {
            if (i.aIsStrong) {
              n.push(new bm(o, t.key, t.newValue, e.newValue, 0));
            }
          }
          if (n.length == 0) {
            return [new Ym(0)];
          }
          return n;
        } else {
          return [e];
        }
      });
      Wx(bm, _m, (e, t) => {
        if (
          e.range.start.hasSameParentAs(t.position) &&
          e.range.containsPosition(t.position)
        ) {
          const i = e.range._getTransformedByInsertion(
            t.position,
            t.howMany,
            !t.shouldReceiveAttributes
          );
          const n = i.map(
            (t) => new bm(t, e.key, e.oldValue, e.newValue, e.baseVersion)
          );
          if (t.shouldReceiveAttributes) {
            const i = Xx(t, e.key, e.oldValue);
            if (i) {
              n.unshift(i);
            }
          }
          return n;
        }
        e.range = e.range._getTransformedByInsertion(
          t.position,
          t.howMany,
          false
        )[0];
        return [e];
      });
      function Xx(e, t, i) {
        const n = e.nodes;
        const o = n.getNode(0).getAttribute(t);
        if (o == i) {
          return null;
        }
        const r = new ef(e.position, e.position.getShiftedBy(e.howMany));
        return new bm(r, t, o, i, 0);
      }
      Wx(bm, Am, (e, t) => {
        const i = [];
        if (e.range.start.hasSameParentAs(t.deletionPosition)) {
          if (
            e.range.containsPosition(t.deletionPosition) ||
            e.range.start.isEqual(t.deletionPosition)
          ) {
            i.push(ef._createFromPositionAndShift(t.graveyardPosition, 1));
          }
        }
        const n = e.range._getTransformedByMergeOperation(t);
        if (!n.isCollapsed) {
          i.push(n);
        }
        return i.map(
          (t) => new bm(t, e.key, e.oldValue, e.newValue, e.baseVersion)
        );
      });
      Wx(bm, km, (e, t) => {
        const i = eA(e.range, t);
        return i.map(
          (t) => new bm(t, e.key, e.oldValue, e.newValue, e.baseVersion)
        );
      });
      function eA(e, t) {
        const i = ef._createFromPositionAndShift(t.sourcePosition, t.howMany);
        let n = null;
        let o = [];
        if (i.containsRange(e, true)) {
          n = e;
        } else if (e.start.hasSameParentAs(i.start)) {
          o = e.getDifference(i);
          n = e.getIntersection(i);
        } else {
          o = [e];
        }
        const r = [];
        for (let e of o) {
          e = e._getTransformedByDeletion(t.sourcePosition, t.howMany);
          const i = t.getMovedRangeStart();
          const n = e.start.hasSameParentAs(i);
          e = e._getTransformedByInsertion(i, t.howMany, n);
          r.push(...e);
        }
        if (n) {
          r.push(
            n._getTransformedByMove(
              t.sourcePosition,
              t.targetPosition,
              t.howMany,
              false
            )[0]
          );
        }
        return r;
      }
      Wx(bm, Tm, (e, t) => {
        if (e.range.end.isEqual(t.insertionPosition)) {
          if (!t.graveyardPosition) {
            e.range.end.offset++;
          }
          return [e];
        }
        if (
          e.range.start.hasSameParentAs(t.splitPosition) &&
          e.range.containsPosition(t.splitPosition)
        ) {
          const i = e.clone();
          i.range = new ef(
            t.moveTargetPosition.clone(),
            e.range.end._getCombined(t.splitPosition, t.moveTargetPosition)
          );
          e.range.end = t.splitPosition.clone();
          e.range.end.stickiness = 'toPrevious';
          return [e, i];
        }
        e.range = e.range._getTransformedBySplitOperation(t);
        return [e];
      });
      Wx(_m, bm, (e, t) => {
        const i = [e];
        if (
          e.shouldReceiveAttributes &&
          e.position.hasSameParentAs(t.range.start) &&
          t.range.containsPosition(e.position)
        ) {
          const n = Xx(e, t.key, t.newValue);
          if (n) {
            i.push(n);
          }
        }
        return i;
      });
      Wx(_m, _m, (e, t, i) => {
        if (e.position.isEqual(t.position) && i.aIsStrong) {
          return [e];
        }
        e.position = e.position._getTransformedByInsertOperation(t);
        return [e];
      });
      Wx(_m, km, (e, t) => {
        e.position = e.position._getTransformedByMoveOperation(t);
        return [e];
      });
      Wx(_m, Tm, (e, t) => {
        e.position = e.position._getTransformedBySplitOperation(t);
        return [e];
      });
      Wx(_m, Am, (e, t) => {
        e.position = e.position._getTransformedByMergeOperation(t);
        return [e];
      });
      Wx(vm, _m, (e, t) => {
        if (e.oldRange) {
          e.oldRange = e.oldRange._getTransformedByInsertOperation(t)[0];
        }
        if (e.newRange) {
          e.newRange = e.newRange._getTransformedByInsertOperation(t)[0];
        }
        return [e];
      });
      Wx(vm, vm, (e, t, i) => {
        if (e.name == t.name) {
          if (i.aIsStrong) {
            e.oldRange = t.newRange ? t.newRange.clone() : null;
          } else {
            return [new Ym(0)];
          }
        }
        return [e];
      });
      Wx(vm, Am, (e, t) => {
        if (e.oldRange) {
          e.oldRange = e.oldRange._getTransformedByMergeOperation(t);
        }
        if (e.newRange) {
          e.newRange = e.newRange._getTransformedByMergeOperation(t);
        }
        return [e];
      });
      Wx(vm, km, (e, t, i) => {
        if (e.oldRange) {
          e.oldRange = ef._createFromRanges(
            e.oldRange._getTransformedByMoveOperation(t)
          );
        }
        if (e.newRange) {
          if (i.abRelation) {
            const n = ef._createFromRanges(
              e.newRange._getTransformedByMoveOperation(t)
            );
            if (
              i.abRelation.side == 'left' &&
              t.targetPosition.isEqual(e.newRange.start)
            ) {
              e.newRange.start.path = i.abRelation.path;
              e.newRange.end = n.end;
              return [e];
            } else if (
              i.abRelation.side == 'right' &&
              t.targetPosition.isEqual(e.newRange.end)
            ) {
              e.newRange.start = n.start;
              e.newRange.end.path = i.abRelation.path;
              return [e];
            }
          }
          e.newRange = ef._createFromRanges(
            e.newRange._getTransformedByMoveOperation(t)
          );
        }
        return [e];
      });
      Wx(vm, Tm, (e, t, i) => {
        if (e.oldRange) {
          e.oldRange = e.oldRange._getTransformedBySplitOperation(t);
        }
        if (e.newRange) {
          if (i.abRelation) {
            const n = e.newRange._getTransformedBySplitOperation(t);
            if (
              e.newRange.start.isEqual(t.splitPosition) &&
              i.abRelation.wasStartBeforeMergedElement
            ) {
              e.newRange.start = Qh._createAt(t.insertionPosition);
            } else if (
              e.newRange.start.isEqual(t.splitPosition) &&
              !i.abRelation.wasInLeftElement
            ) {
              e.newRange.start = Qh._createAt(t.moveTargetPosition);
            }
            if (
              e.newRange.end.isEqual(t.splitPosition) &&
              i.abRelation.wasInRightElement
            ) {
              e.newRange.end = Qh._createAt(t.moveTargetPosition);
            } else if (
              e.newRange.end.isEqual(t.splitPosition) &&
              i.abRelation.wasEndBeforeMergedElement
            ) {
              e.newRange.end = Qh._createAt(t.insertionPosition);
            } else {
              e.newRange.end = n.end;
            }
            return [e];
          }
          e.newRange = e.newRange._getTransformedBySplitOperation(t);
        }
        return [e];
      });
      Wx(Am, _m, (e, t) => {
        if (e.sourcePosition.hasSameParentAs(t.position)) {
          e.howMany += t.howMany;
        }
        e.sourcePosition = e.sourcePosition._getTransformedByInsertOperation(t);
        e.targetPosition = e.targetPosition._getTransformedByInsertOperation(t);
        return [e];
      });
      Wx(Am, Am, (e, t, i) => {
        if (
          e.sourcePosition.isEqual(t.sourcePosition) &&
          e.targetPosition.isEqual(t.targetPosition)
        ) {
          if (!i.bWasUndone) {
            return [new Ym(0)];
          } else {
            const i = t.graveyardPosition.path.slice();
            i.push(0);
            e.sourcePosition = new Qh(t.graveyardPosition.root, i);
            e.howMany = 0;
            return [e];
          }
        }
        if (
          e.sourcePosition.isEqual(t.sourcePosition) &&
          !e.targetPosition.isEqual(t.targetPosition) &&
          !i.bWasUndone &&
          i.abRelation != 'splitAtSource'
        ) {
          const n = e.targetPosition.root.rootName == '$graveyard';
          const o = t.targetPosition.root.rootName == '$graveyard';
          const r = n && !o;
          const s = o && !n;
          const a = s || (!r && i.aIsStrong);
          if (a) {
            const i = t.targetPosition._getTransformedByMergeOperation(t);
            const n = e.targetPosition._getTransformedByMergeOperation(t);
            return [new km(i, e.howMany, n, 0)];
          } else {
            return [new Ym(0)];
          }
        }
        if (e.sourcePosition.hasSameParentAs(t.targetPosition)) {
          e.howMany += t.howMany;
        }
        e.sourcePosition = e.sourcePosition._getTransformedByMergeOperation(t);
        e.targetPosition = e.targetPosition._getTransformedByMergeOperation(t);
        if (!e.graveyardPosition.isEqual(t.graveyardPosition) || !i.aIsStrong) {
          e.graveyardPosition =
            e.graveyardPosition._getTransformedByMergeOperation(t);
        }
        return [e];
      });
      Wx(Am, km, (e, t, i) => {
        const n = ef._createFromPositionAndShift(t.sourcePosition, t.howMany);
        if (t.type == 'remove' && !i.bWasUndone && !i.forceWeakRemove) {
          if (
            e.deletionPosition.hasSameParentAs(t.sourcePosition) &&
            n.containsPosition(e.sourcePosition)
          ) {
            return [new Ym(0)];
          }
        }
        if (e.sourcePosition.hasSameParentAs(t.targetPosition)) {
          e.howMany += t.howMany;
        }
        if (e.sourcePosition.hasSameParentAs(t.sourcePosition)) {
          e.howMany -= t.howMany;
        }
        e.sourcePosition = e.sourcePosition._getTransformedByMoveOperation(t);
        e.targetPosition = e.targetPosition._getTransformedByMoveOperation(t);
        if (!e.graveyardPosition.isEqual(t.targetPosition)) {
          e.graveyardPosition =
            e.graveyardPosition._getTransformedByMoveOperation(t);
        }
        return [e];
      });
      Wx(Am, Tm, (e, t, i) => {
        if (t.graveyardPosition) {
          e.graveyardPosition = e.graveyardPosition._getTransformedByDeletion(
            t.graveyardPosition,
            1
          );
          if (e.deletionPosition.isEqual(t.graveyardPosition)) {
            e.howMany = t.howMany;
          }
        }
        if (e.targetPosition.isEqual(t.splitPosition)) {
          const n = t.howMany != 0;
          const o =
            t.graveyardPosition &&
            e.deletionPosition.isEqual(t.graveyardPosition);
          if (n || o || i.abRelation == 'mergeTargetNotMoved') {
            e.sourcePosition =
              e.sourcePosition._getTransformedBySplitOperation(t);
            return [e];
          }
        }
        if (e.sourcePosition.isEqual(t.splitPosition)) {
          if (i.abRelation == 'mergeSourceNotMoved') {
            e.howMany = 0;
            e.targetPosition =
              e.targetPosition._getTransformedBySplitOperation(t);
            return [e];
          }
          if (
            i.abRelation == 'mergeSameElement' ||
            e.sourcePosition.offset > 0
          ) {
            e.sourcePosition = t.moveTargetPosition.clone();
            e.targetPosition =
              e.targetPosition._getTransformedBySplitOperation(t);
            return [e];
          }
        }
        if (e.sourcePosition.hasSameParentAs(t.splitPosition)) {
          e.howMany = t.splitPosition.offset;
        }
        e.sourcePosition = e.sourcePosition._getTransformedBySplitOperation(t);
        e.targetPosition = e.targetPosition._getTransformedBySplitOperation(t);
        return [e];
      });
      Wx(km, _m, (e, t) => {
        const i = ef._createFromPositionAndShift(e.sourcePosition, e.howMany);
        const n = i._getTransformedByInsertOperation(t, false)[0];
        e.sourcePosition = n.start;
        e.howMany = n.end.offset - n.start.offset;
        if (!e.targetPosition.isEqual(t.position)) {
          e.targetPosition =
            e.targetPosition._getTransformedByInsertOperation(t);
        }
        return [e];
      });
      Wx(km, km, (e, t, i) => {
        const n = ef._createFromPositionAndShift(e.sourcePosition, e.howMany);
        const o = ef._createFromPositionAndShift(t.sourcePosition, t.howMany);
        let r = i.aIsStrong;
        let s = !i.aIsStrong;
        if (i.abRelation == 'insertBefore' || i.baRelation == 'insertAfter') {
          s = true;
        } else if (
          i.abRelation == 'insertAfter' ||
          i.baRelation == 'insertBefore'
        ) {
          s = false;
        }
        let a;
        if (e.targetPosition.isEqual(t.targetPosition) && s) {
          a = e.targetPosition._getTransformedByDeletion(
            t.sourcePosition,
            t.howMany
          );
        } else {
          a = e.targetPosition._getTransformedByMove(
            t.sourcePosition,
            t.targetPosition,
            t.howMany
          );
        }
        if (tA(e, t) && tA(t, e)) {
          return [t.getReversed()];
        }
        const c = n.containsPosition(t.targetPosition);
        if (c && n.containsRange(o, true)) {
          n.start = n.start._getTransformedByMove(
            t.sourcePosition,
            t.targetPosition,
            t.howMany
          );
          n.end = n.end._getTransformedByMove(
            t.sourcePosition,
            t.targetPosition,
            t.howMany
          );
          return iA([n], a);
        }
        const l = o.containsPosition(e.targetPosition);
        if (l && o.containsRange(n, true)) {
          n.start = n.start._getCombined(
            t.sourcePosition,
            t.getMovedRangeStart()
          );
          n.end = n.end._getCombined(t.sourcePosition, t.getMovedRangeStart());
          return iA([n], a);
        }
        const d = Rs(
          e.sourcePosition.getParentPath(),
          t.sourcePosition.getParentPath()
        );
        if (d == 'prefix' || d == 'extension') {
          n.start = n.start._getTransformedByMove(
            t.sourcePosition,
            t.targetPosition,
            t.howMany
          );
          n.end = n.end._getTransformedByMove(
            t.sourcePosition,
            t.targetPosition,
            t.howMany
          );
          return iA([n], a);
        }
        if (
          e.type == 'remove' &&
          t.type != 'remove' &&
          !i.aWasUndone &&
          !i.forceWeakRemove
        ) {
          r = true;
        } else if (
          e.type != 'remove' &&
          t.type == 'remove' &&
          !i.bWasUndone &&
          !i.forceWeakRemove
        ) {
          r = false;
        }
        const u = [];
        const h = n.getDifference(o);
        for (const e of h) {
          e.start = e.start._getTransformedByDeletion(
            t.sourcePosition,
            t.howMany
          );
          e.end = e.end._getTransformedByDeletion(t.sourcePosition, t.howMany);
          const i =
            Rs(
              e.start.getParentPath(),
              t.getMovedRangeStart().getParentPath()
            ) == 'same';
          const n = e._getTransformedByInsertion(
            t.getMovedRangeStart(),
            t.howMany,
            i
          );
          u.push(...n);
        }
        const f = n.getIntersection(o);
        if (f !== null && r) {
          f.start = f.start._getCombined(
            t.sourcePosition,
            t.getMovedRangeStart()
          );
          f.end = f.end._getCombined(t.sourcePosition, t.getMovedRangeStart());
          if (u.length === 0) {
            u.push(f);
          } else if (u.length == 1) {
            if (o.start.isBefore(n.start) || o.start.isEqual(n.start)) {
              u.unshift(f);
            } else {
              u.push(f);
            }
          } else {
            u.splice(1, 0, f);
          }
        }
        if (u.length === 0) {
          return [new Ym(e.baseVersion)];
        }
        return iA(u, a);
      });
      Wx(km, Tm, (e, t, i) => {
        let n = e.targetPosition.clone();
        if (
          !e.targetPosition.isEqual(t.insertionPosition) ||
          !t.graveyardPosition ||
          i.abRelation == 'moveTargetAfter'
        ) {
          n = e.targetPosition._getTransformedBySplitOperation(t);
        }
        const o = ef._createFromPositionAndShift(e.sourcePosition, e.howMany);
        if (o.end.isEqual(t.insertionPosition)) {
          if (!t.graveyardPosition) {
            e.howMany++;
          }
          e.targetPosition = n;
          return [e];
        }
        if (
          o.start.hasSameParentAs(t.splitPosition) &&
          o.containsPosition(t.splitPosition)
        ) {
          let e = new ef(t.splitPosition, o.end);
          e = e._getTransformedBySplitOperation(t);
          const i = [new ef(o.start, t.splitPosition), e];
          return iA(i, n);
        }
        if (
          e.targetPosition.isEqual(t.splitPosition) &&
          i.abRelation == 'insertAtSource'
        ) {
          n = t.moveTargetPosition;
        }
        if (
          e.targetPosition.isEqual(t.insertionPosition) &&
          i.abRelation == 'insertBetween'
        ) {
          n = e.targetPosition;
        }
        const r = o._getTransformedBySplitOperation(t);
        const s = [r];
        if (t.graveyardPosition) {
          const n =
            o.start.isEqual(t.graveyardPosition) ||
            o.containsPosition(t.graveyardPosition);
          if (e.howMany > 1 && n && !i.aWasUndone) {
            s.push(ef._createFromPositionAndShift(t.insertionPosition, 1));
          }
        }
        return iA(s, n);
      });
      Wx(km, Am, (e, t, i) => {
        const n = ef._createFromPositionAndShift(e.sourcePosition, e.howMany);
        if (
          t.deletionPosition.hasSameParentAs(e.sourcePosition) &&
          n.containsPosition(t.sourcePosition)
        ) {
          if (e.type == 'remove' && !i.forceWeakRemove) {
            if (!i.aWasUndone) {
              const i = [];
              let n = t.graveyardPosition.clone();
              let o = t.targetPosition._getTransformedByMergeOperation(t);
              if (e.howMany > 1) {
                i.push(
                  new km(e.sourcePosition, e.howMany - 1, e.targetPosition, 0)
                );
                n = n._getTransformedByMove(
                  e.sourcePosition,
                  e.targetPosition,
                  e.howMany - 1
                );
                o = o._getTransformedByMove(
                  e.sourcePosition,
                  e.targetPosition,
                  e.howMany - 1
                );
              }
              const r = t.deletionPosition._getCombined(
                e.sourcePosition,
                e.targetPosition
              );
              const s = new km(n, 1, r, 0);
              const a = s.getMovedRangeStart().path.slice();
              a.push(0);
              const c = new Qh(s.targetPosition.root, a);
              o = o._getTransformedByMove(n, r, 1);
              const l = new km(o, t.howMany, c, 0);
              i.push(s);
              i.push(l);
              return i;
            }
          } else {
            if (e.howMany == 1) {
              if (!i.bWasUndone) {
                return [new Ym(0)];
              } else {
                e.sourcePosition = t.graveyardPosition.clone();
                e.targetPosition =
                  e.targetPosition._getTransformedByMergeOperation(t);
                return [e];
              }
            }
          }
        }
        const o = ef._createFromPositionAndShift(e.sourcePosition, e.howMany);
        const r = o._getTransformedByMergeOperation(t);
        e.sourcePosition = r.start;
        e.howMany = r.end.offset - r.start.offset;
        e.targetPosition = e.targetPosition._getTransformedByMergeOperation(t);
        return [e];
      });
      Wx(ym, _m, (e, t) => {
        e.position = e.position._getTransformedByInsertOperation(t);
        return [e];
      });
      Wx(ym, Am, (e, t) => {
        if (e.position.isEqual(t.deletionPosition)) {
          e.position = t.graveyardPosition.clone();
          e.position.stickiness = 'toNext';
          return [e];
        }
        e.position = e.position._getTransformedByMergeOperation(t);
        return [e];
      });
      Wx(ym, km, (e, t) => {
        e.position = e.position._getTransformedByMoveOperation(t);
        return [e];
      });
      Wx(ym, ym, (e, t, i) => {
        if (e.position.isEqual(t.position)) {
          if (i.aIsStrong) {
            e.oldName = t.newName;
          } else {
            return [new Ym(0)];
          }
        }
        return [e];
      });
      Wx(ym, Tm, (e, t) => {
        const i = e.position.path;
        const n = t.splitPosition.getParentPath();
        if (Rs(i, n) == 'same' && !t.graveyardPosition) {
          const t = new ym(e.position.getShiftedBy(1), e.oldName, e.newName, 0);
          return [e, t];
        }
        e.position = e.position._getTransformedBySplitOperation(t);
        return [e];
      });
      Wx(xm, xm, (e, t, i) => {
        if (e.root === t.root && e.key === t.key) {
          if (!i.aIsStrong || e.newValue === t.newValue) {
            return [new Ym(0)];
          } else {
            e.oldValue = t.newValue;
          }
        }
        return [e];
      });
      Wx(Tm, _m, (e, t) => {
        if (
          e.splitPosition.hasSameParentAs(t.position) &&
          e.splitPosition.offset < t.position.offset
        ) {
          e.howMany += t.howMany;
        }
        e.splitPosition = e.splitPosition._getTransformedByInsertOperation(t);
        e.insertionPosition = Tm.getInsertionPosition(e.splitPosition);
        return [e];
      });
      Wx(Tm, Am, (e, t, i) => {
        if (
          !e.graveyardPosition &&
          !i.bWasUndone &&
          e.splitPosition.hasSameParentAs(t.sourcePosition)
        ) {
          const i = t.graveyardPosition.path.slice();
          i.push(0);
          const n = new Qh(t.graveyardPosition.root, i);
          const o = Tm.getInsertionPosition(
            new Qh(t.graveyardPosition.root, i)
          );
          const r = new Tm(n, 0, null, 0);
          r.insertionPosition = o;
          e.splitPosition = e.splitPosition._getTransformedByMergeOperation(t);
          e.insertionPosition = Tm.getInsertionPosition(e.splitPosition);
          e.graveyardPosition = r.insertionPosition.clone();
          e.graveyardPosition.stickiness = 'toNext';
          return [r, e];
        }
        if (
          e.splitPosition.hasSameParentAs(t.deletionPosition) &&
          !e.splitPosition.isAfter(t.deletionPosition)
        ) {
          e.howMany--;
        }
        if (e.splitPosition.hasSameParentAs(t.targetPosition)) {
          e.howMany += t.howMany;
        }
        e.splitPosition = e.splitPosition._getTransformedByMergeOperation(t);
        e.insertionPosition = Tm.getInsertionPosition(e.splitPosition);
        if (e.graveyardPosition) {
          e.graveyardPosition =
            e.graveyardPosition._getTransformedByMergeOperation(t);
        }
        return [e];
      });
      Wx(Tm, km, (e, t, i) => {
        const n = ef._createFromPositionAndShift(t.sourcePosition, t.howMany);
        if (e.graveyardPosition) {
          const o =
            n.start.isEqual(e.graveyardPosition) ||
            n.containsPosition(e.graveyardPosition);
          if (!i.bWasUndone && o) {
            const i = e.splitPosition._getTransformedByMoveOperation(t);
            const n = e.graveyardPosition._getTransformedByMoveOperation(t);
            const o = n.path.slice();
            o.push(0);
            const r = new Qh(n.root, o);
            const s = new km(i, e.howMany, r, 0);
            return [s];
          }
          e.graveyardPosition =
            e.graveyardPosition._getTransformedByMoveOperation(t);
        }
        if (
          e.splitPosition.hasSameParentAs(t.sourcePosition) &&
          n.containsPosition(e.splitPosition)
        ) {
          const i =
            t.howMany - (e.splitPosition.offset - t.sourcePosition.offset);
          e.howMany -= i;
          if (
            e.splitPosition.hasSameParentAs(t.targetPosition) &&
            e.splitPosition.offset < t.targetPosition.offset
          ) {
            e.howMany += t.howMany;
          }
          e.splitPosition = t.sourcePosition.clone();
          e.insertionPosition = Tm.getInsertionPosition(e.splitPosition);
          return [e];
        }
        const o = e.splitPosition.isEqual(t.targetPosition);
        if (
          o &&
          (i.baRelation == 'insertAtSource' || i.abRelation == 'splitBefore')
        ) {
          e.howMany += t.howMany;
          e.splitPosition = e.splitPosition._getTransformedByDeletion(
            t.sourcePosition,
            t.howMany
          );
          e.insertionPosition = Tm.getInsertionPosition(e.splitPosition);
          return [e];
        }
        if (!t.sourcePosition.isEqual(t.targetPosition)) {
          if (
            e.splitPosition.hasSameParentAs(t.sourcePosition) &&
            e.splitPosition.offset <= t.sourcePosition.offset
          ) {
            e.howMany -= t.howMany;
          }
          if (
            e.splitPosition.hasSameParentAs(t.targetPosition) &&
            e.splitPosition.offset < t.targetPosition.offset
          ) {
            e.howMany += t.howMany;
          }
        }
        e.splitPosition.stickiness = 'toNone';
        e.splitPosition = e.splitPosition._getTransformedByMoveOperation(t);
        e.splitPosition.stickiness = 'toNext';
        if (e.graveyardPosition) {
          e.insertionPosition =
            e.insertionPosition._getTransformedByMoveOperation(t);
        } else {
          e.insertionPosition = Tm.getInsertionPosition(e.splitPosition);
        }
        return [e];
      });
      Wx(Tm, Tm, (e, t, i) => {
        if (e.splitPosition.isEqual(t.splitPosition)) {
          if (!e.graveyardPosition && !t.graveyardPosition) {
            return [new Ym(0)];
          }
          if (
            e.graveyardPosition &&
            t.graveyardPosition &&
            e.graveyardPosition.isEqual(t.graveyardPosition)
          ) {
            return [new Ym(0)];
          }
          if (i.abRelation == 'splitBefore') {
            e.howMany = 0;
            e.graveyardPosition =
              e.graveyardPosition._getTransformedBySplitOperation(t);
            return [e];
          }
        }
        if (
          e.graveyardPosition &&
          t.graveyardPosition &&
          e.graveyardPosition.isEqual(t.graveyardPosition)
        ) {
          const n = e.splitPosition.root.rootName == '$graveyard';
          const o = t.splitPosition.root.rootName == '$graveyard';
          const r = n && !o;
          const s = o && !n;
          const a = s || (!r && i.aIsStrong);
          if (a) {
            const i = [];
            if (t.howMany) {
              i.push(
                new km(t.moveTargetPosition, t.howMany, t.splitPosition, 0)
              );
            }
            if (e.howMany) {
              i.push(
                new km(e.splitPosition, e.howMany, e.moveTargetPosition, 0)
              );
            }
            return i;
          } else {
            return [new Ym(0)];
          }
        }
        if (e.graveyardPosition) {
          e.graveyardPosition =
            e.graveyardPosition._getTransformedBySplitOperation(t);
        }
        if (
          e.splitPosition.isEqual(t.insertionPosition) &&
          i.abRelation == 'splitBefore'
        ) {
          e.howMany++;
          return [e];
        }
        if (
          t.splitPosition.isEqual(e.insertionPosition) &&
          i.baRelation == 'splitBefore'
        ) {
          const i = t.insertionPosition.path.slice();
          i.push(0);
          const n = new Qh(t.insertionPosition.root, i);
          const o = new km(e.insertionPosition, 1, n, 0);
          return [e, o];
        }
        if (
          e.splitPosition.hasSameParentAs(t.splitPosition) &&
          e.splitPosition.offset < t.splitPosition.offset
        ) {
          e.howMany -= t.howMany;
        }
        e.splitPosition = e.splitPosition._getTransformedBySplitOperation(t);
        e.insertionPosition = Tm.getInsertionPosition(e.splitPosition);
        return [e];
      });
      function tA(e, t) {
        return (
          e.targetPosition._getTransformedByDeletion(
            t.sourcePosition,
            t.howMany
          ) === null
        );
      }
      function iA(e, t) {
        const i = [];
        for (let n = 0; n < e.length; n++) {
          const o = e[n];
          const r = new km(o.start, o.end.offset - o.start.offset, t, 0);
          i.push(r);
          for (let t = n + 1; t < e.length; t++) {
            e[t] = e[t]._getTransformedByMove(
              r.sourcePosition,
              r.targetPosition,
              r.howMany
            )[0];
          }
          t = t._getTransformedByMove(
            r.sourcePosition,
            r.targetPosition,
            r.howMany
          );
        }
        return i;
      }
      class nA extends sk {
        constructor(e) {
          super(e);
          this._stack = [];
          this._createdBatches = new WeakSet();
          this.refresh();
          this.listenTo(e.data, 'set', () => this.clearStack());
        }
        refresh() {
          this.isEnabled = this._stack.length > 0;
        }
        addBatch(e) {
          const t = this.editor.model.document.selection;
          const i = {
            ranges: t.hasOwnRange ? Array.from(t.getRanges()) : [],
            isBackward: t.isBackward,
          };
          this._stack.push({ batch: e, selection: i });
          this.refresh();
        }
        clearStack() {
          this._stack = [];
          this.refresh();
        }
        _restoreSelection(e, t, i) {
          const n = this.editor.model;
          const o = n.document;
          const r = [];
          const s = e.map((e) => e.getTransformedByOperations(i));
          const a = s.flat();
          for (const e of s) {
            const t = e.filter((e) => !rA(e, a));
            oA(t);
            const i = t.find((e) => e.root != o.graveyard);
            if (i) {
              r.push(i);
            }
          }
          if (r.length) {
            n.change((e) => {
              e.setSelection(r, { backward: t });
            });
          }
        }
        _undo(e, t) {
          const i = this.editor.model;
          const n = i.document;
          this._createdBatches.add(t);
          const o = e.operations.slice().filter((e) => e.isDocumentOperation);
          o.reverse();
          for (const e of o) {
            const o = e.baseVersion + 1;
            const r = Array.from(n.history.getOperations(o));
            const s = Kx([e.getReversed()], r, {
              useRelations: true,
              document: this.editor.model.document,
              padWithNoOps: false,
              forceWeakRemove: true,
            });
            const a = s.operationsA;
            for (const o of a) {
              t.addOperation(o);
              i.applyOperation(o);
              n.history.setOperationAsUndone(e, o);
            }
          }
        }
      }
      function oA(e) {
        e.sort((e, t) => (e.start.isBefore(t.start) ? -1 : 1));
        for (let t = 1; t < e.length; t++) {
          const i = e[t - 1];
          const n = i.getJoined(e[t], true);
          if (n) {
            t--;
            e.splice(t, 2, n);
          }
        }
      }
      function rA(e, t) {
        return t.some((t) => t !== e && t.containsRange(e, true));
      }
      class sA extends nA {
        execute(e = null) {
          const t = e
            ? this._stack.findIndex((t) => t.batch == e)
            : this._stack.length - 1;
          const i = this._stack.splice(t, 1)[0];
          const n = this.editor.model.createBatch('transparent');
          this.editor.model.enqueueChange(n, () => {
            this._undo(i.batch, n);
            const e = this.editor.model.document.history.getOperations(
              i.batch.baseVersion
            );
            this._restoreSelection(
              i.selection.ranges,
              i.selection.isBackward,
              e
            );
            this.fire('revert', i.batch, n);
          });
          this.refresh();
        }
      }
      class aA extends nA {
        execute() {
          const e = this._stack.pop();
          const t = this.editor.model.createBatch('transparent');
          this.editor.model.enqueueChange(t, () => {
            const i = e.batch.operations[e.batch.operations.length - 1];
            const n = i.baseVersion + 1;
            const o = this.editor.model.document.history.getOperations(n);
            this._restoreSelection(
              e.selection.ranges,
              e.selection.isBackward,
              o
            );
            this._undo(e.batch, t);
          });
          this.refresh();
        }
      }
      class cA extends ok {
        static get pluginName() {
          return 'UndoEditing';
        }
        constructor(e) {
          super(e);
          this._batchRegistry = new WeakSet();
        }
        init() {
          const e = this.editor;
          this._undoCommand = new sA(e);
          this._redoCommand = new aA(e);
          e.commands.add('undo', this._undoCommand);
          e.commands.add('redo', this._redoCommand);
          this.listenTo(
            e.model,
            'applyOperation',
            (e, t) => {
              const i = t[0];
              if (!i.isDocumentOperation) {
                return;
              }
              const n = i.batch;
              const o = this._redoCommand._createdBatches.has(n);
              const r = this._undoCommand._createdBatches.has(n);
              const s = this._batchRegistry.has(n);
              if (s || (n.type == 'transparent' && !o && !r)) {
                return;
              } else {
                if (o) {
                  this._undoCommand.addBatch(n);
                } else if (!r) {
                  this._undoCommand.addBatch(n);
                  this._redoCommand.clearStack();
                }
              }
              this._batchRegistry.add(n);
            },
            { priority: 'highest' }
          );
          this.listenTo(this._undoCommand, 'revert', (e, t, i) => {
            this._redoCommand.addBatch(i);
          });
          e.keystrokes.set('CTRL+Z', 'undo');
          e.keystrokes.set('CTRL+Y', 'redo');
          e.keystrokes.set('CTRL+SHIFT+Z', 'redo');
        }
      }
      var lA =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5.042 9.367l2.189 1.837a.75.75 0 0 1-.965 1.149l-3.788-3.18a.747.747 0 0 1-.21-.284.75.75 0 0 1 .17-.945L6.23 4.762a.75.75 0 1 1 .964 1.15L4.863 7.866h8.917A.75.75 0 0 1 14 7.9a4 4 0 1 1-1.477 7.718l.344-1.489a2.5 2.5 0 1 0 1.094-4.73l.008-.032H5.042z"/></svg>';
      var dA =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M14.958 9.367l-2.189 1.837a.75.75 0 0 0 .965 1.149l3.788-3.18a.747.747 0 0 0 .21-.284.75.75 0 0 0-.17-.945L13.77 4.762a.75.75 0 1 0-.964 1.15l2.331 1.955H6.22A.75.75 0 0 0 6 7.9a4 4 0 1 0 1.477 7.718l-.344-1.489A2.5 2.5 0 1 1 6.039 9.4l-.008-.032h8.927z"/></svg>';
      class uA extends ok {
        init() {
          const e = this.editor;
          const t = e.locale;
          const i = e.t;
          const n = t.uiLanguageDirection == 'ltr' ? lA : dA;
          const o = t.uiLanguageDirection == 'ltr' ? dA : lA;
          this._addButton('undo', i('Undo'), 'CTRL+Z', n);
          this._addButton('redo', i('Redo'), 'CTRL+Y', o);
        }
        _addButton(e, t, i, n) {
          const o = this.editor;
          o.ui.componentFactory.add(e, (r) => {
            const s = o.commands.get(e);
            const a = new Ew(r);
            a.set({ label: t, icon: n, keystroke: i, tooltip: true });
            a.bind('isEnabled').to(s, 'isEnabled');
            this.listenTo(a, 'execute', () => {
              o.execute(e);
              o.editing.view.focus();
            });
            return a;
          });
        }
      }
      class hA extends ok {
        static get requires() {
          return [cA, uA];
        }
        static get pluginName() {
          return 'Undo';
        }
      }
      class fA extends ok {
        static get requires() {
          return [Vv, Cx, jx, Nx, Ux, hA];
        }
        static get pluginName() {
          return 'Essentials';
        }
      }
      class gA extends sk {
        constructor(e, t) {
          super(e);
          this.attributeKey = t;
        }
        refresh() {
          const e = this.editor.model;
          const t = e.document;
          this.value = t.selection.getAttribute(this.attributeKey);
          this.isEnabled = e.schema.checkAttributeInSelection(
            t.selection,
            this.attributeKey
          );
        }
        execute(e = {}) {
          const t = this.editor.model;
          const i = t.document;
          const n = i.selection;
          const o = e.value;
          t.change((e) => {
            if (n.isCollapsed) {
              if (o) {
                e.setSelectionAttribute(this.attributeKey, o);
              } else {
                e.removeSelectionAttribute(this.attributeKey);
              }
            } else {
              const i = t.schema.getValidRanges(
                n.getRanges(),
                this.attributeKey
              );
              for (const t of i) {
                if (o) {
                  e.setAttribute(this.attributeKey, o, t);
                } else {
                  e.removeAttribute(this.attributeKey, t);
                }
              }
            }
          });
        }
      }
      var mA =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path class="ck-icon__fill" d="M16.935 5.328a2 2 0 0 1 0 2.829l-7.778 7.778a2 2 0 0 1-2.829 0L3.5 13.107a1.999 1.999 0 1 1 2.828-2.829l.707.707a1 1 0 0 0 1.414 0l5.658-5.657a2 2 0 0 1 2.828 0z"/><path d="M14.814 6.035L8.448 12.4a1 1 0 0 1-1.414 0l-1.413-1.415A1 1 0 1 0 4.207 12.4l2.829 2.829a1 1 0 0 0 1.414 0l7.778-7.778a1 1 0 1 0-1.414-1.415z"/></svg>';
      class pA extends Ew {
        constructor(e) {
          super(e);
          const t = this.bindTemplate;
          this.set('color');
          this.set('hasBorder');
          this.icon = mA;
          this.extendTemplate({
            attributes: {
              style: { backgroundColor: t.to('color') },
              class: [
                'ck',
                'ck-color-grid__tile',
                t.if('hasBorder', 'ck-color-table__color-tile_bordered'),
              ],
            },
          });
        }
        render() {
          super.render();
          this.iconView.fillColor = 'hsl(0, 0%, 100%)';
        }
      }
      var bA = i(51);
      class wA extends Hb {
        constructor(e, t) {
          super(e);
          const i = (t && t.colorDefinitions) || [];
          const n = {};
          if (t && t.columns) {
            n.gridTemplateColumns = `repeat( ${t.columns}, 1fr)`;
          }
          this.set('selectedColor');
          this.items = this.createCollection();
          this.focusTracker = new Qp();
          this.keystrokes = new Vp();
          this._focusCycler = new rw({
            focusables: this.items,
            focusTracker: this.focusTracker,
            keystrokeHandler: this.keystrokes,
            actions: { focusPrevious: 'arrowleft', focusNext: 'arrowright' },
          });
          this.items.on('add', (e, t) => {
            t.isOn = t.color === this.selectedColor;
          });
          i.forEach((e) => {
            const t = new pA();
            t.set({
              color: e.color,
              label: e.label,
              tooltip: true,
              hasBorder: e.options.hasBorder,
            });
            t.on('execute', () => {
              this.fire('execute', {
                value: e.color,
                hasBorder: e.options.hasBorder,
                label: e.label,
              });
            });
            this.items.add(t);
          });
          this.setTemplate({
            tag: 'div',
            children: this.items,
            attributes: { class: ['ck', 'ck-color-grid'], style: n },
          });
          this.on('change:selectedColor', (e, t, i) => {
            for (const e of this.items) {
              e.isOn = e.color === i;
            }
          });
        }
        focus() {
          if (this.items.length) {
            this.items.first.focus();
          }
        }
        focusLast() {
          if (this.items.length) {
            this.items.last.focus();
          }
        }
        render() {
          super.render();
          for (const e of this.items) {
            this.focusTracker.add(e.element);
          }
          this.items.on('add', (e, t) => {
            this.focusTracker.add(t.element);
          });
          this.items.on('remove', (e, t) => {
            this.focusTracker.remove(t.element);
          });
          this.keystrokes.listenTo(this.element);
        }
      }
      class kA extends xs {
        constructor(e) {
          super(e);
          this.set('isEmpty', true);
          this.on('change', () => {
            this.set('isEmpty', this.length === 0);
          });
        }
        add(e, t) {
          if (this.find((t) => t.color === e.color)) {
            return;
          }
          super.add(e, t);
        }
        hasColor(e) {
          return !!this.find((t) => t.color === e);
        }
      }
      ys(kA, Qc);
      var _A =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8.636 9.531l-2.758 3.94a.5.5 0 0 0 .122.696l3.224 2.284h1.314l2.636-3.736L8.636 9.53zm.288 8.451L5.14 15.396a2 2 0 0 1-.491-2.786l6.673-9.53a2 2 0 0 1 2.785-.49l3.742 2.62a2 2 0 0 1 .491 2.785l-7.269 10.053-2.147-.066z"/><path d="M4 18h5.523v-1H4zm-2 0h1v-1H2z"/></svg>';
      var vA = i(53);
      class yA extends Hb {
        constructor(
          e,
          {
            colors: t,
            columns: i,
            removeButtonLabel: n,
            documentColorsLabel: o,
            documentColorsCount: r,
          }
        ) {
          super(e);
          this.items = this.createCollection();
          this.colorDefinitions = t;
          this.focusTracker = new Qp();
          this.keystrokes = new Vp();
          this.set('selectedColor');
          this.removeButtonLabel = n;
          this.columns = i;
          this.documentColors = new kA();
          this.documentColorsCount = r;
          this._focusCycler = new rw({
            focusables: this.items,
            focusTracker: this.focusTracker,
            keystrokeHandler: this.keystrokes,
            actions: { focusPrevious: 'arrowup', focusNext: 'arrowdown' },
          });
          this._documentColorsLabel = o;
          this.setTemplate({
            tag: 'div',
            attributes: { class: ['ck', 'ck-color-table'] },
            children: this.items,
          });
          this.items.add(this._removeColorButton());
        }
        updateDocumentColors(e, t) {
          const i = e.document;
          const n = this.documentColorsCount;
          this.documentColors.clear();
          for (const o of i.getRootNames()) {
            const r = i.getRoot(o);
            const s = e.createRangeIn(r);
            for (const e of s.getItems()) {
              if (e.is('$textProxy') && e.hasAttribute(t)) {
                this._addColorToDocumentColors(e.getAttribute(t));
                if (this.documentColors.length >= n) {
                  return;
                }
              }
            }
          }
        }
        updateSelectedColors() {
          const e = this.documentColorsGrid;
          const t = this.staticColorsGrid;
          const i = this.selectedColor;
          t.selectedColor = i;
          if (e) {
            e.selectedColor = i;
          }
        }
        render() {
          super.render();
          for (const e of this.items) {
            this.focusTracker.add(e.element);
          }
          this.keystrokes.listenTo(this.element);
        }
        appendGrids() {
          if (this.staticColorsGrid) {
            return;
          }
          this.staticColorsGrid = this._createStaticColorsGrid();
          this.items.add(this.staticColorsGrid);
          if (this.documentColorsCount) {
            const e = mb.bind(this.documentColors, this.documentColors);
            const t = new Jb(this.locale);
            t.text = this._documentColorsLabel;
            t.extendTemplate({
              attributes: {
                class: [
                  'ck',
                  'ck-color-grid__label',
                  e.if('isEmpty', 'ck-hidden'),
                ],
              },
            });
            this.items.add(t);
            this.documentColorsGrid = this._createDocumentColorsGrid();
            this.items.add(this.documentColorsGrid);
          }
        }
        focus() {
          this._focusCycler.focusFirst();
        }
        focusLast() {
          this._focusCycler.focusLast();
        }
        _removeColorButton() {
          const e = new Ew();
          e.set({
            withText: true,
            icon: _A,
            tooltip: true,
            label: this.removeButtonLabel,
          });
          e.class = 'ck-color-table__remove-color';
          e.on('execute', () => {
            this.fire('execute', { value: null });
          });
          return e;
        }
        _createStaticColorsGrid() {
          const e = new wA(this.locale, {
            colorDefinitions: this.colorDefinitions,
            columns: this.columns,
          });
          e.delegate('execute').to(this);
          return e;
        }
        _createDocumentColorsGrid() {
          const e = mb.bind(this.documentColors, this.documentColors);
          const t = new wA(this.locale, { columns: this.columns });
          t.delegate('execute').to(this);
          t.extendTemplate({
            attributes: { class: e.if('isEmpty', 'ck-hidden') },
          });
          t.items.bindTo(this.documentColors).using((e) => {
            const t = new pA();
            t.set({
              color: e.color,
              hasBorder: e.options && e.options.hasBorder,
            });
            if (e.label) {
              t.set({ label: e.label, tooltip: true });
            }
            t.on('execute', () => {
              this.fire('execute', { value: e.color });
            });
            return t;
          });
          this.documentColors.on('change:isEmpty', (e, i, n) => {
            if (n) {
              t.selectedColor = null;
            }
          });
          return t;
        }
        _addColorToDocumentColors(e) {
          const t = this.colorDefinitions.find((t) => t.color === e);
          if (!t) {
            this.documentColors.add({
              color: e,
              label: e,
              options: { hasBorder: false },
            });
          } else {
            this.documentColors.add(Object.assign({}, t));
          }
        }
      }
      const xA = 'fontSize';
      const AA = 'fontFamily';
      const TA = 'fontColor';
      const CA = 'fontBackgroundColor';
      function PA(e, t) {
        const i = { model: { key: e, values: [] }, view: {}, upcastAlso: {} };
        for (const e of t) {
          i.model.values.push(e.model);
          i.view[e.model] = e.view;
          if (e.upcastAlso) {
            i.upcastAlso[e.model] = e.upcastAlso;
          }
        }
        return i;
      }
      function EA(e) {
        return (t) => IA(t.getStyle(e));
      }
      function SA(e) {
        return (t, { writer: i }) =>
          i.createAttributeElement(
            'span',
            { style: `${e}:${t}` },
            { priority: 7 }
          );
      }
      function MA({
        dropdownView: e,
        colors: t,
        columns: i,
        removeButtonLabel: n,
        documentColorsLabel: o,
        documentColorsCount: r,
      }) {
        const s = e.locale;
        const a = new yA(s, {
          colors: t,
          columns: i,
          removeButtonLabel: n,
          documentColorsLabel: o,
          documentColorsCount: r,
        });
        e.colorTableView = a;
        e.panelView.children.add(a);
        a.delegate('execute').to(e, 'execute');
        return a;
      }
      function IA(e) {
        return e.replace(/\s/g, '');
      }
      class NA extends gA {
        constructor(e) {
          super(e, CA);
        }
      }
      const OA = /^#([0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i;
      const zA = /^rgb\([ ]?([0-9]{1,3}[ %]?,[ ]?){2,3}[0-9]{1,3}[ %]?\)$/i;
      const RA =
        /^rgba\([ ]?([0-9]{1,3}[ %]?,[ ]?){3}(1|[0-9]+%|[0]?\.?[0-9]+)\)$/i;
      const LA =
        /^hsl\([ ]?([0-9]{1,3}[ %]?[,]?[ ]*){3}(1|[0-9]+%|[0]?\.?[0-9]+)?\)$/i;
      const VA =
        /^hsla\([ ]?([0-9]{1,3}[ %]?,[ ]?){2,3}(1|[0-9]+%|[0]?\.?[0-9]+)\)$/i;
      const DA = new Set([
        'black',
        'silver',
        'gray',
        'white',
        'maroon',
        'red',
        'purple',
        'fuchsia',
        'green',
        'lime',
        'olive',
        'yellow',
        'navy',
        'blue',
        'teal',
        'aqua',
        'orange',
        'aliceblue',
        'antiquewhite',
        'aquamarine',
        'azure',
        'beige',
        'bisque',
        'blanchedalmond',
        'blueviolet',
        'brown',
        'burlywood',
        'cadetblue',
        'chartreuse',
        'chocolate',
        'coral',
        'cornflowerblue',
        'cornsilk',
        'crimson',
        'cyan',
        'darkblue',
        'darkcyan',
        'darkgoldenrod',
        'darkgray',
        'darkgreen',
        'darkgrey',
        'darkkhaki',
        'darkmagenta',
        'darkolivegreen',
        'darkorange',
        'darkorchid',
        'darkred',
        'darksalmon',
        'darkseagreen',
        'darkslateblue',
        'darkslategray',
        'darkslategrey',
        'darkturquoise',
        'darkviolet',
        'deeppink',
        'deepskyblue',
        'dimgray',
        'dimgrey',
        'dodgerblue',
        'firebrick',
        'floralwhite',
        'forestgreen',
        'gainsboro',
        'ghostwhite',
        'gold',
        'goldenrod',
        'greenyellow',
        'grey',
        'honeydew',
        'hotpink',
        'indianred',
        'indigo',
        'ivory',
        'khaki',
        'lavender',
        'lavenderblush',
        'lawngreen',
        'lemonchiffon',
        'lightblue',
        'lightcoral',
        'lightcyan',
        'lightgoldenrodyellow',
        'lightgray',
        'lightgreen',
        'lightgrey',
        'lightpink',
        'lightsalmon',
        'lightseagreen',
        'lightskyblue',
        'lightslategray',
        'lightslategrey',
        'lightsteelblue',
        'lightyellow',
        'limegreen',
        'linen',
        'magenta',
        'mediumaquamarine',
        'mediumblue',
        'mediumorchid',
        'mediumpurple',
        'mediumseagreen',
        'mediumslateblue',
        'mediumspringgreen',
        'mediumturquoise',
        'mediumvioletred',
        'midnightblue',
        'mintcream',
        'mistyrose',
        'moccasin',
        'navajowhite',
        'oldlace',
        'olivedrab',
        'orangered',
        'orchid',
        'palegoldenrod',
        'palegreen',
        'paleturquoise',
        'palevioletred',
        'papayawhip',
        'peachpuff',
        'peru',
        'pink',
        'plum',
        'powderblue',
        'rosybrown',
        'royalblue',
        'saddlebrown',
        'salmon',
        'sandybrown',
        'seagreen',
        'seashell',
        'sienna',
        'skyblue',
        'slateblue',
        'slategray',
        'slategrey',
        'snow',
        'springgreen',
        'steelblue',
        'tan',
        'thistle',
        'tomato',
        'turquoise',
        'violet',
        'wheat',
        'whitesmoke',
        'yellowgreen',
        'rebeccapurple',
        'currentcolor',
        'transparent',
      ]);
      function jA(e) {
        if (e.startsWith('#')) {
          return OA.test(e);
        }
        if (e.startsWith('rgb')) {
          return zA.test(e) || RA.test(e);
        }
        if (e.startsWith('hsl')) {
          return LA.test(e) || VA.test(e);
        }
        return DA.has(e.toLowerCase());
      }
      const BA = [
        'none',
        'hidden',
        'dotted',
        'dashed',
        'solid',
        'double',
        'groove',
        'ridge',
        'inset',
        'outset',
      ];
      function FA(e) {
        return BA.includes(e);
      }
      const HA =
        /^([+-]?[0-9]*[.]?[0-9]+(px|cm|mm|in|pc|pt|ch|em|ex|rem|vh|vw|vmin|vmax)|0)$/;
      function UA(e) {
        return HA.test(e);
      }
      const qA = /^[+-]?[0-9]*[.]?[0-9]+%$/;
      function WA(e) {
        return qA.test(e);
      }
      const $A = [
        'repeat-x',
        'repeat-y',
        'repeat',
        'space',
        'round',
        'no-repeat',
      ];
      function GA(e) {
        return $A.includes(e);
      }
      const YA = ['center', 'top', 'bottom', 'left', 'right'];
      function KA(e) {
        return YA.includes(e);
      }
      const QA = ['fixed', 'scroll', 'local'];
      function JA(e) {
        return QA.includes(e);
      }
      const ZA = /^url\(/;
      function XA(e) {
        return ZA.test(e);
      }
      function eT(e = '') {
        if (e === '') {
          return {
            top: undefined,
            right: undefined,
            bottom: undefined,
            left: undefined,
          };
        }
        const t = oT(e);
        const i = t[0];
        const n = t[2] || i;
        const o = t[1] || i;
        const r = t[3] || o;
        return { top: i, bottom: n, right: o, left: r };
      }
      function tT(e) {
        return (t) => {
          const { top: i, right: n, bottom: o, left: r } = t;
          const s = [];
          if (![i, n, r, o].every((e) => !!e)) {
            if (i) {
              s.push([e + '-top', i]);
            }
            if (n) {
              s.push([e + '-right', n]);
            }
            if (o) {
              s.push([e + '-bottom', o]);
            }
            if (r) {
              s.push([e + '-left', r]);
            }
          } else {
            s.push([e, iT(t)]);
          }
          return s;
        };
      }
      function iT({ top: e, right: t, bottom: i, left: n }) {
        const o = [];
        if (n !== t) {
          o.push(e, t, i, n);
        } else if (i !== e) {
          o.push(e, t, i);
        } else if (t !== e) {
          o.push(e, t);
        } else {
          o.push(e);
        }
        return o.join(' ');
      }
      function nT(e) {
        return (t) => ({ path: e, value: eT(t) });
      }
      function oT(e) {
        return e
          .replace(/, /g, ',')
          .split(' ')
          .map((e) => e.replace(/,/g, ', '));
      }
      function rT(e) {
        e.setNormalizer('background', sT);
        e.setNormalizer('background-color', (e) => ({
          path: 'background.color',
          value: e,
        }));
        e.setReducer('background', (e) => {
          const t = [];
          t.push(['background-color', e.color]);
          return t;
        });
      }
      function sT(e) {
        const t = {};
        const i = oT(e);
        for (const e of i) {
          if (GA(e)) {
            t.repeat = t.repeat || [];
            t.repeat.push(e);
          } else if (KA(e)) {
            t.position = t.position || [];
            t.position.push(e);
          } else if (JA(e)) {
            t.attachment = e;
          } else if (jA(e)) {
            t.color = e;
          } else if (XA(e)) {
            t.image = e;
          }
        }
        return { path: 'background', value: t };
      }
      class aT extends ok {
        static get pluginName() {
          return 'FontBackgroundColorEditing';
        }
        constructor(e) {
          super(e);
          e.config.define(CA, {
            colors: [
              { color: 'hsl(0, 0%, 0%)', label: 'Black' },
              { color: 'hsl(0, 0%, 30%)', label: 'Dim grey' },
              { color: 'hsl(0, 0%, 60%)', label: 'Grey' },
              { color: 'hsl(0, 0%, 90%)', label: 'Light grey' },
              { color: 'hsl(0, 0%, 100%)', label: 'White', hasBorder: true },
              { color: 'hsl(0, 75%, 60%)', label: 'Red' },
              { color: 'hsl(30, 75%, 60%)', label: 'Orange' },
              { color: 'hsl(60, 75%, 60%)', label: 'Yellow' },
              { color: 'hsl(90, 75%, 60%)', label: 'Light green' },
              { color: 'hsl(120, 75%, 60%)', label: 'Green' },
              { color: 'hsl(150, 75%, 60%)', label: 'Aquamarine' },
              { color: 'hsl(180, 75%, 60%)', label: 'Turquoise' },
              { color: 'hsl(210, 75%, 60%)', label: 'Light blue' },
              { color: 'hsl(240, 75%, 60%)', label: 'Blue' },
              { color: 'hsl(270, 75%, 60%)', label: 'Purple' },
            ],
            columns: 5,
          });
          e.data.addStyleProcessorRules(rT);
          e.conversion.for('upcast').elementToAttribute({
            view: { name: 'span', styles: { 'background-color': /[\s\S]+/ } },
            model: { key: CA, value: EA('background-color') },
          });
          e.conversion
            .for('downcast')
            .attributeToElement({ model: CA, view: SA('background-color') });
          e.commands.add(CA, new NA(e));
          e.model.schema.extend('$text', { allowAttributes: CA });
          e.model.schema.setAttributeProperties(CA, {
            isFormatting: true,
            copyOnEnter: true,
          });
        }
      }
      function cT(e, t) {
        const i = e.t;
        const n = {
          Black: i('Black'),
          'Dim grey': i('Dim grey'),
          Grey: i('Grey'),
          'Light grey': i('Light grey'),
          White: i('White'),
          Red: i('Red'),
          Orange: i('Orange'),
          Yellow: i('Yellow'),
          'Light green': i('Light green'),
          Green: i('Green'),
          Aquamarine: i('Aquamarine'),
          Turquoise: i('Turquoise'),
          'Light blue': i('Light blue'),
          Blue: i('Blue'),
          Purple: i('Purple'),
        };
        return t.map((e) => {
          const t = n[e.label];
          if (t && t != e.label) {
            e.label = t;
          }
          return e;
        });
      }
      function lT(e) {
        return e.map(dT).filter((e) => !!e);
      }
      function dT(e) {
        if (typeof e === 'string') {
          return {
            model: e,
            label: e,
            hasBorder: false,
            view: { name: 'span', styles: { color: e } },
          };
        } else {
          return {
            model: e.color,
            label: e.label || e.color,
            hasBorder: e.hasBorder === undefined ? false : e.hasBorder,
            view: { name: 'span', styles: { color: `${e.color}` } },
          };
        }
      }
      class uT extends ok {
        constructor(
          e,
          { commandName: t, icon: i, componentName: n, dropdownLabel: o }
        ) {
          super(e);
          this.commandName = t;
          this.componentName = n;
          this.icon = i;
          this.dropdownLabel = o;
          this.columns = e.config.get(`${this.componentName}.columns`);
          this.colorTableView;
        }
        init() {
          const e = this.editor;
          const t = e.locale;
          const i = t.t;
          const n = e.commands.get(this.commandName);
          const o = lT(e.config.get(this.componentName).colors);
          const r = cT(t, o);
          const s = e.config.get(`${this.componentName}.documentColors`);
          e.ui.componentFactory.add(this.componentName, (t) => {
            const o = Bw(t);
            this.colorTableView = MA({
              dropdownView: o,
              colors: r.map((e) => ({
                label: e.label,
                color: e.model,
                options: { hasBorder: e.hasBorder },
              })),
              columns: this.columns,
              removeButtonLabel: i('Remove color'),
              documentColorsLabel: s !== 0 ? i('Document colors') : undefined,
              documentColorsCount: s === undefined ? this.columns : s,
            });
            this.colorTableView.bind('selectedColor').to(n, 'value');
            o.buttonView.set({
              label: this.dropdownLabel,
              icon: this.icon,
              tooltip: true,
            });
            o.extendTemplate({ attributes: { class: 'ck-color-ui-dropdown' } });
            o.bind('isEnabled').to(n);
            o.on('execute', (t, i) => {
              e.execute(this.commandName, i);
              e.editing.view.focus();
            });
            o.on('change:isOpen', (t, i, n) => {
              o.colorTableView.appendGrids();
              if (n) {
                if (s !== 0) {
                  this.colorTableView.updateDocumentColors(
                    e.model,
                    this.componentName
                  );
                }
                this.colorTableView.updateSelectedColors();
              }
            });
            return o;
          });
        }
      }
      var hT =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M4 2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm8.38 9.262H7.62L10 5.506l2.38 5.756zm.532 1.285L14.34 16h1.426L10.804 4H9.196L4.234 16H5.66l1.428-3.453h5.824z"/></svg>';
      class fT extends uT {
        constructor(e) {
          const t = e.locale.t;
          super(e, {
            commandName: CA,
            componentName: CA,
            icon: hT,
            dropdownLabel: t('Font Background Color'),
          });
        }
        static get pluginName() {
          return 'FontBackgroundColorUI';
        }
      }
      class gT extends ok {
        static get requires() {
          return [aT, fT];
        }
        static get pluginName() {
          return 'FontBackgroundColor';
        }
      }
      class mT extends gA {
        constructor(e) {
          super(e, TA);
        }
      }
      class pT extends ok {
        static get pluginName() {
          return 'FontColorEditing';
        }
        constructor(e) {
          super(e);
          e.config.define(TA, {
            colors: [
              { color: 'hsl(0, 0%, 0%)', label: 'Black' },
              { color: 'hsl(0, 0%, 30%)', label: 'Dim grey' },
              { color: 'hsl(0, 0%, 60%)', label: 'Grey' },
              { color: 'hsl(0, 0%, 90%)', label: 'Light grey' },
              { color: 'hsl(0, 0%, 100%)', label: 'White', hasBorder: true },
              { color: 'hsl(0, 75%, 60%)', label: 'Red' },
              { color: 'hsl(30, 75%, 60%)', label: 'Orange' },
              { color: 'hsl(60, 75%, 60%)', label: 'Yellow' },
              { color: 'hsl(90, 75%, 60%)', label: 'Light green' },
              { color: 'hsl(120, 75%, 60%)', label: 'Green' },
              { color: 'hsl(150, 75%, 60%)', label: 'Aquamarine' },
              { color: 'hsl(180, 75%, 60%)', label: 'Turquoise' },
              { color: 'hsl(210, 75%, 60%)', label: 'Light blue' },
              { color: 'hsl(240, 75%, 60%)', label: 'Blue' },
              { color: 'hsl(270, 75%, 60%)', label: 'Purple' },
            ],
            columns: 5,
          });
          e.conversion.for('upcast').elementToAttribute({
            view: { name: 'span', styles: { color: /[\s\S]+/ } },
            model: { key: TA, value: EA('color') },
          });
          e.conversion
            .for('downcast')
            .attributeToElement({ model: TA, view: SA('color') });
          e.commands.add(TA, new mT(e));
          e.model.schema.extend('$text', { allowAttributes: TA });
          e.model.schema.setAttributeProperties(TA, {
            isFormatting: true,
            copyOnEnter: true,
          });
        }
      }
      var bT =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M12.4 10.3L10 4.5l-2.4 5.8h4.8zm.5 1.2H7.1L5.7 15H4.2l5-12h1.6l5 12h-1.5L13 11.5zm3.1 7H4a1 1 0 0 1 0-2h12a1 1 0 0 1 0 2z"/></svg>';
      class wT extends uT {
        constructor(e) {
          const t = e.locale.t;
          super(e, {
            commandName: TA,
            componentName: TA,
            icon: bT,
            dropdownLabel: t('Font Color'),
          });
        }
        static get pluginName() {
          return 'FontColorUI';
        }
      }
      class kT extends ok {
        static get requires() {
          return [pT, wT];
        }
        static get pluginName() {
          return 'FontColor';
        }
      }
      class _T extends gA {
        constructor(e) {
          super(e, xA);
        }
      }
      function vT(e) {
        return e.map((e) => xT(e)).filter((e) => !!e);
      }
      const yT = {
        get tiny() {
          return {
            title: 'Tiny',
            model: 'tiny',
            view: { name: 'span', classes: 'text-tiny', priority: 7 },
          };
        },
        get small() {
          return {
            title: 'Small',
            model: 'small',
            view: { name: 'span', classes: 'text-small', priority: 7 },
          };
        },
        get big() {
          return {
            title: 'Big',
            model: 'big',
            view: { name: 'span', classes: 'text-big', priority: 7 },
          };
        },
        get huge() {
          return {
            title: 'Huge',
            model: 'huge',
            view: { name: 'span', classes: 'text-huge', priority: 7 },
          };
        },
      };
      function xT(e) {
        if (PT(e)) {
          return TT(e);
        }
        const t = CT(e);
        if (t) {
          return TT(t);
        }
        if (e === 'default') {
          return { model: undefined, title: 'Default' };
        }
        if (ET(e)) {
          return;
        }
        return AT(e);
      }
      function AT(e) {
        if (typeof e === 'number' || typeof e === 'string') {
          e = { title: String(e), model: `${parseFloat(e)}px` };
        }
        e.view = { name: 'span', styles: { 'font-size': e.model } };
        return TT(e);
      }
      function TT(e) {
        if (!e.view.priority) {
          e.view.priority = 7;
        }
        return e;
      }
      function CT(e) {
        return yT[e] || yT[e.model];
      }
      function PT(e) {
        return typeof e === 'object' && e.title && e.model && e.view;
      }
      function ET(e) {
        let t;
        if (typeof e === 'object') {
          if (!e.model) {
            throw new ss['b'](
              'font-size-invalid-definition: Provided font size definition is invalid.',
              null,
              e
            );
          } else {
            t = parseFloat(e.model);
          }
        } else {
          t = parseFloat(e);
        }
        return isNaN(t);
      }
      class ST extends ok {
        static get pluginName() {
          return 'FontSizeEditing';
        }
        constructor(e) {
          super(e);
          e.config.define(xA, {
            options: ['tiny', 'small', 'default', 'big', 'huge'],
            supportAllValues: false,
          });
        }
        init() {
          const e = this.editor;
          e.model.schema.extend('$text', { allowAttributes: xA });
          e.model.schema.setAttributeProperties(xA, {
            isFormatting: true,
            copyOnEnter: true,
          });
          const t = e.config.get('fontSize.supportAllValues');
          const i = vT(this.editor.config.get('fontSize.options')).filter(
            (e) => e.model
          );
          const n = PA(xA, i);
          if (t) {
            this._prepareAnyValueConverters(n);
          } else {
            e.conversion.attributeToElement(n);
          }
          e.commands.add(xA, new _T(e));
        }
        _prepareAnyValueConverters(e) {
          const t = this.editor;
          const i = e.model.values.filter(
            (e) => !String(e).match(/[\d.]+[\w%]+/)
          );
          if (i.length) {
            throw new ss['b'](
              'font-size-invalid-use-of-named-presets: ' +
                'If config.fontSize.supportAllValues is set to true, you need to use numerical values as font size options.',
              null,
              { presets: i }
            );
          }
          t.conversion.for('downcast').attributeToElement({
            model: xA,
            view: (e, { writer: t }) => {
              if (!e) {
                return;
              }
              return t.createAttributeElement(
                'span',
                { style: 'font-size:' + e },
                { priority: 7 }
              );
            },
          });
          t.conversion.for('upcast').attributeToAttribute({
            model: { key: xA, value: (e) => e.getStyle('font-size') },
            view: { name: 'span' },
          });
        }
      }
      class MT {
        constructor(e, t) {
          if (t) {
            Wc(this, t);
          }
          if (e) {
            this.set(e);
          }
        }
      }
      ys(MT, Qc);
      var IT =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.816 11.5L7.038 4.785 4.261 11.5h5.555zm.62 1.5H3.641l-1.666 4.028H.312l5.789-14h1.875l5.789 14h-1.663L10.436 13zm7.55 2.279l.779-.779.707.707-2.265 2.265-2.193-2.265.707-.707.765.765V4.825c0-.042 0-.083.002-.123l-.77.77-.707-.707L17.207 2.5l2.265 2.265-.707.707-.782-.782c.002.043.003.089.003.135v10.454z"/></svg>';
      var NT = i(55);
      class OT extends ok {
        init() {
          const e = this.editor;
          const t = e.t;
          const i = this._getLocalizedOptions();
          const n = e.commands.get(xA);
          e.ui.componentFactory.add(xA, (o) => {
            const r = Bw(o);
            Hw(r, zT(i, n));
            r.buttonView.set({
              label: t('Font Size'),
              icon: IT,
              tooltip: true,
            });
            r.extendTemplate({
              attributes: { class: ['ck-font-size-dropdown'] },
            });
            r.bind('isEnabled').to(n);
            this.listenTo(r, 'execute', (t) => {
              e.execute(t.source.commandName, { value: t.source.commandParam });
              e.editing.view.focus();
            });
            return r;
          });
        }
        _getLocalizedOptions() {
          const e = this.editor;
          const t = e.t;
          const i = {
            Default: t('Default'),
            Tiny: t('Tiny'),
            Small: t('Small'),
            Big: t('Big'),
            Huge: t('Huge'),
          };
          const n = vT(e.config.get(xA).options);
          return n.map((e) => {
            const t = i[e.title];
            if (t && t != e.title) {
              e = Object.assign({}, e, { title: t });
            }
            return e;
          });
        }
      }
      function zT(e, t) {
        const i = new xs();
        for (const n of e) {
          const e = {
            type: 'button',
            model: new MT({
              commandName: xA,
              commandParam: n.model,
              label: n.title,
              class: 'ck-fontsize-option',
              withText: true,
            }),
          };
          if (n.view && n.view.styles) {
            e.model.set(
              'labelStyle',
              `font-size:${n.view.styles['font-size']}`
            );
          }
          if (n.view && n.view.classes) {
            e.model.set('class', `${e.model.class} ${n.view.classes}`);
          }
          e.model.bind('isOn').to(t, 'value', (e) => e === n.model);
          i.add(e);
        }
        return i;
      }
      class RT extends ok {
        static get requires() {
          return [ST, OT];
        }
        static get pluginName() {
          return 'FontSize';
        }
      }
      class LT extends sk {
        refresh() {
          const e = this.editor.model;
          const t = e.document;
          const i = ck(t.selection.getSelectedBlocks());
          this.value = !!i && i.is('element', 'paragraph');
          this.isEnabled = !!i && VT(i, e.schema);
        }
        execute(e = {}) {
          const t = this.editor.model;
          const i = t.document;
          t.change((n) => {
            const o = (e.selection || i.selection).getSelectedBlocks();
            for (const e of o) {
              if (!e.is('element', 'paragraph') && VT(e, t.schema)) {
                n.rename(e, 'paragraph');
              }
            }
          });
        }
      }
      function VT(e, t) {
        return t.checkChild(e.parent, 'paragraph') && !t.isObject(e);
      }
      class DT extends sk {
        execute(e) {
          const t = this.editor.model;
          let i = e.position;
          t.change((e) => {
            const n = e.createElement('paragraph');
            if (!t.schema.checkChild(i.parent, n)) {
              const o = t.schema.findAllowedParent(i, n);
              if (!o) {
                return;
              }
              i = e.split(i, o).position;
            }
            t.insertContent(n, i);
            e.setSelection(n, 'in');
          });
        }
      }
      class jT extends ok {
        static get pluginName() {
          return 'Paragraph';
        }
        init() {
          const e = this.editor;
          const t = e.model;
          e.commands.add('paragraph', new LT(e));
          e.commands.add('insertParagraph', new DT(e));
          t.schema.register('paragraph', { inheritAllFrom: '$block' });
          e.conversion.elementToElement({ model: 'paragraph', view: 'p' });
          e.conversion.for('upcast').elementToElement({
            model: (e, { writer: t }) => {
              if (!jT.paragraphLikeElements.has(e.name)) {
                return null;
              }
              if (e.isEmpty) {
                return null;
              }
              return t.createElement('paragraph');
            },
            view: /.+/,
            converterPriority: 'low',
          });
        }
      }
      jT.paragraphLikeElements = new Set([
        'blockquote',
        'dd',
        'div',
        'dt',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'li',
        'p',
        'td',
        'th',
      ]);
      class BT extends sk {
        constructor(e, t) {
          super(e);
          this.modelElements = t;
        }
        refresh() {
          const e = ck(
            this.editor.model.document.selection.getSelectedBlocks()
          );
          this.value = !!e && this.modelElements.includes(e.name) && e.name;
          this.isEnabled =
            !!e &&
            this.modelElements.some((t) => FT(e, t, this.editor.model.schema));
        }
        execute(e) {
          const t = this.editor.model;
          const i = t.document;
          const n = e.value;
          t.change((e) => {
            const o = Array.from(i.selection.getSelectedBlocks()).filter((e) =>
              FT(e, n, t.schema)
            );
            for (const t of o) {
              if (!t.is('element', n)) {
                e.rename(t, n);
              }
            }
          });
        }
      }
      function FT(e, t, i) {
        return i.checkChild(e.parent, t) && !i.isObject(e);
      }
      const HT = 'paragraph';
      class UT extends ok {
        static get pluginName() {
          return 'HeadingEditing';
        }
        constructor(e) {
          super(e);
          e.config.define('heading', {
            options: [
              {
                model: 'paragraph',
                title: 'Paragraph',
                class: 'ck-heading_paragraph',
              },
              {
                model: 'heading1',
                view: 'h2',
                title: 'Heading 1',
                class: 'ck-heading_heading1',
              },
              {
                model: 'heading2',
                view: 'h3',
                title: 'Heading 2',
                class: 'ck-heading_heading2',
              },
              {
                model: 'heading3',
                view: 'h4',
                title: 'Heading 3',
                class: 'ck-heading_heading3',
              },
            ],
          });
        }
        static get requires() {
          return [jT];
        }
        init() {
          const e = this.editor;
          const t = e.config.get('heading.options');
          const i = [];
          for (const n of t) {
            if (n.model !== HT) {
              e.model.schema.register(n.model, { inheritAllFrom: '$block' });
              e.conversion.elementToElement(n);
              i.push(n.model);
            }
          }
          this._addDefaultH1Conversion(e);
          e.commands.add('heading', new BT(e, i));
        }
        afterInit() {
          const e = this.editor;
          const t = e.commands.get('enter');
          const i = e.config.get('heading.options');
          if (t) {
            this.listenTo(t, 'afterExecute', (t, n) => {
              const o = e.model.document.selection.getFirstPosition().parent;
              const r = i.some((e) => o.is('element', e.model));
              if (r && !o.is('element', HT) && o.childCount === 0) {
                n.writer.rename(o, HT);
              }
            });
          }
        }
        _addDefaultH1Conversion(e) {
          e.conversion.for('upcast').elementToElement({
            model: 'heading1',
            view: 'h1',
            converterPriority: os.get('low') + 1,
          });
        }
      }
      function qT(e) {
        const t = e.t;
        const i = {
          Paragraph: t('Paragraph'),
          'Heading 1': t('Heading 1'),
          'Heading 2': t('Heading 2'),
          'Heading 3': t('Heading 3'),
          'Heading 4': t('Heading 4'),
          'Heading 5': t('Heading 5'),
          'Heading 6': t('Heading 6'),
        };
        return e.config.get('heading.options').map((e) => {
          const t = i[e.title];
          if (t && t != e.title) {
            e.title = t;
          }
          return e;
        });
      }
      var WT = i(12);
      class $T extends ok {
        init() {
          const e = this.editor;
          const t = e.t;
          const i = qT(e);
          const n = t('Choose heading');
          const o = t('Heading');
          e.ui.componentFactory.add('heading', (t) => {
            const r = {};
            const s = new xs();
            const a = e.commands.get('heading');
            const c = e.commands.get('paragraph');
            const l = [a];
            for (const e of i) {
              const t = {
                type: 'button',
                model: new MT({
                  label: e.title,
                  class: e.class,
                  withText: true,
                }),
              };
              if (e.model === 'paragraph') {
                t.model.bind('isOn').to(c, 'value');
                t.model.set('commandName', 'paragraph');
                l.push(c);
              } else {
                t.model.bind('isOn').to(a, 'value', (t) => t === e.model);
                t.model.set({ commandName: 'heading', commandValue: e.model });
              }
              s.add(t);
              r[e.model] = e.title;
            }
            const d = Bw(t);
            Hw(d, s);
            d.buttonView.set({ isOn: false, withText: true, tooltip: o });
            d.extendTemplate({
              attributes: { class: ['ck-heading-dropdown'] },
            });
            d.bind('isEnabled').toMany(l, 'isEnabled', (...e) =>
              e.some((e) => e)
            );
            d.buttonView.bind('label').to(a, 'value', c, 'value', (e, t) => {
              const i = e || (t && 'paragraph');
              return r[i] ? r[i] : n;
            });
            this.listenTo(d, 'execute', (t) => {
              e.execute(
                t.source.commandName,
                t.source.commandValue
                  ? { value: t.source.commandValue }
                  : undefined
              );
              e.editing.view.focus();
            });
            return d;
          });
        }
      }
      class GT extends ok {
        static get requires() {
          return [UT, $T];
        }
        static get pluginName() {
          return 'Heading';
        }
      }
      class YT extends sk {
        refresh() {
          const e = this.editor.model;
          const t = e.document;
          this.value = t.selection.getAttribute('highlight');
          this.isEnabled = e.schema.checkAttributeInSelection(
            t.selection,
            'highlight'
          );
        }
        execute(e = {}) {
          const t = this.editor.model;
          const i = t.document;
          const n = i.selection;
          const o = e.value;
          t.change((e) => {
            const i = t.schema.getValidRanges(n.getRanges(), 'highlight');
            if (n.isCollapsed) {
              const t = n.getFirstPosition();
              if (n.hasAttribute('highlight')) {
                const i = (e) =>
                  e.item.hasAttribute('highlight') &&
                  e.item.getAttribute('highlight') === this.value;
                const n = t.getLastMatchingPosition(i, {
                  direction: 'backward',
                });
                const r = t.getLastMatchingPosition(i);
                const s = e.createRange(n, r);
                if (!o || this.value === o) {
                  e.removeAttribute('highlight', s);
                  e.removeSelectionAttribute('highlight');
                } else {
                  e.setAttribute('highlight', o, s);
                  e.setSelectionAttribute('highlight', o);
                }
              } else if (o) {
                e.setSelectionAttribute('highlight', o);
              }
            } else {
              for (const t of i) {
                if (o) {
                  e.setAttribute('highlight', o, t);
                } else {
                  e.removeAttribute('highlight', t);
                }
              }
            }
          });
        }
      }
      class KT extends ok {
        static get pluginName() {
          return 'HighlightEditing';
        }
        constructor(e) {
          super(e);
          e.config.define('highlight', {
            options: [
              {
                model: 'yellowMarker',
                class: 'marker-yellow',
                title: 'Yellow marker',
                color: 'var(--ck-highlight-marker-yellow)',
                type: 'marker',
              },
              {
                model: 'greenMarker',
                class: 'marker-green',
                title: 'Green marker',
                color: 'var(--ck-highlight-marker-green)',
                type: 'marker',
              },
              {
                model: 'pinkMarker',
                class: 'marker-pink',
                title: 'Pink marker',
                color: 'var(--ck-highlight-marker-pink)',
                type: 'marker',
              },
              {
                model: 'blueMarker',
                class: 'marker-blue',
                title: 'Blue marker',
                color: 'var(--ck-highlight-marker-blue)',
                type: 'marker',
              },
              {
                model: 'redPen',
                class: 'pen-red',
                title: 'Red pen',
                color: 'var(--ck-highlight-pen-red)',
                type: 'pen',
              },
              {
                model: 'greenPen',
                class: 'pen-green',
                title: 'Green pen',
                color: 'var(--ck-highlight-pen-green)',
                type: 'pen',
              },
            ],
          });
        }
        init() {
          const e = this.editor;
          e.model.schema.extend('$text', { allowAttributes: 'highlight' });
          const t = e.config.get('highlight.options');
          e.conversion.attributeToElement(QT(t));
          e.commands.add('highlight', new YT(e));
        }
      }
      function QT(e) {
        const t = { model: { key: 'highlight', values: [] }, view: {} };
        for (const i of e) {
          t.model.values.push(i.model);
          t.view[i.model] = { name: 'mark', classes: i.class };
        }
        return t;
      }
      var JT =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path class="ck-icon__fill" d="M10.798 1.59L3.002 12.875l1.895 1.852 2.521 1.402 6.997-12.194z"/><path d="M2.556 16.727l.234-.348c-.297-.151-.462-.293-.498-.426-.036-.137.002-.416.115-.837.094-.25.15-.449.169-.595a4.495 4.495 0 0 0 0-.725c-.209-.621-.303-1.041-.284-1.26.02-.218.178-.506.475-.862l6.77-9.414c.539-.91 1.605-.85 3.199.18 1.594 1.032 2.188 1.928 1.784 2.686l-5.877 10.36c-.158.412-.333.673-.526.782-.193.108-.604.179-1.232.21-.362.131-.608.237-.738.318-.13.081-.305.238-.526.47-.293.265-.504.397-.632.397-.096 0-.27-.075-.524-.226l-.31.41-1.6-1.12zm-.279.415l1.575 1.103-.392.515H1.19l1.087-1.618zm8.1-13.656l-4.953 6.9L8.75 12.57l4.247-7.574c.175-.25-.188-.647-1.092-1.192-.903-.546-1.412-.652-1.528-.32zM8.244 18.5L9.59 17h9.406v1.5H8.245z"/></svg>';
      var ZT =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path class="ck-icon__fill" d="M10.126 2.268L2.002 13.874l1.895 1.852 2.521 1.402L14.47 5.481l-1.543-2.568-2.801-.645z"/><path d="M4.5 18.088l-2.645-1.852-.04-2.95-.006-.005.006-.008v-.025l.011.008L8.73 2.97c.165-.233.356-.417.567-.557l-1.212.308L4.604 7.9l-.83-.558 3.694-5.495 2.708-.69 1.65 1.145.046.018.85-1.216 2.16 1.512-.856 1.222c.828.967 1.144 2.141.432 3.158L7.55 17.286l.006.005-3.055.797H4.5zm-.634.166l-1.976.516-.026-1.918 2.002 1.402zM9.968 3.817l-.006-.004-6.123 9.184 3.277 2.294 6.108-9.162.005.003c.317-.452-.16-1.332-1.064-1.966-.891-.624-1.865-.776-2.197-.349zM8.245 18.5L9.59 17h9.406v1.5H8.245z"/></svg>';
      var XT = i(58);
      class eC extends Hb {
        constructor(e) {
          super(e);
          const t = this.bindTemplate;
          this.set('icon');
          this.set('isEnabled', true);
          this.set('isOn', false);
          this.set('isToggleable', false);
          this.set('isVisible', true);
          this.set('keystroke');
          this.set('label');
          this.set('tabindex', -1);
          this.set('tooltip');
          this.set('tooltipPosition', 's');
          this.set('type', 'button');
          this.set('withText', false);
          this.children = this.createCollection();
          this.actionView = this._createActionView();
          this.arrowView = this._createArrowView();
          this.keystrokes = new Vp();
          this.focusTracker = new Qp();
          this.setTemplate({
            tag: 'div',
            attributes: {
              class: [
                'ck',
                'ck-splitbutton',
                t.if('isVisible', 'ck-hidden', (e) => !e),
                this.arrowView.bindTemplate.if('isOn', 'ck-splitbutton_open'),
              ],
            },
            children: this.children,
          });
        }
        render() {
          super.render();
          this.children.add(this.actionView);
          this.children.add(this.arrowView);
          this.focusTracker.add(this.actionView.element);
          this.focusTracker.add(this.arrowView.element);
          this.keystrokes.listenTo(this.element);
          this.keystrokes.set('arrowright', (e, t) => {
            if (this.focusTracker.focusedElement === this.actionView.element) {
              this.arrowView.focus();
              t();
            }
          });
          this.keystrokes.set('arrowleft', (e, t) => {
            if (this.focusTracker.focusedElement === this.arrowView.element) {
              this.actionView.focus();
              t();
            }
          });
        }
        focus() {
          this.actionView.focus();
        }
        _createActionView() {
          const e = new Ew();
          e.bind(
            'icon',
            'isEnabled',
            'isOn',
            'isToggleable',
            'keystroke',
            'label',
            'tabindex',
            'tooltip',
            'tooltipPosition',
            'type',
            'withText'
          ).to(this);
          e.extendTemplate({ attributes: { class: 'ck-splitbutton__action' } });
          e.delegate('execute').to(this);
          return e;
        }
        _createArrowView() {
          const e = new Ew();
          const t = e.bindTemplate;
          e.icon = Sw;
          e.extendTemplate({
            attributes: {
              class: 'ck-splitbutton__arrow',
              'aria-haspopup': true,
              'aria-expanded': t.to('isOn', (e) => String(e)),
            },
          });
          e.bind('isEnabled').to(this);
          e.delegate('execute').to(this, 'open');
          return e;
        }
      }
      var tC = i(60);
      class iC extends ok {
        get localizedOptionTitles() {
          const e = this.editor.t;
          return {
            'Yellow marker': e('Yellow marker'),
            'Green marker': e('Green marker'),
            'Pink marker': e('Pink marker'),
            'Blue marker': e('Blue marker'),
            'Red pen': e('Red pen'),
            'Green pen': e('Green pen'),
          };
        }
        static get pluginName() {
          return 'HighlightUI';
        }
        init() {
          const e = this.editor.config.get('highlight.options');
          for (const t of e) {
            this._addHighlighterButton(t);
          }
          this._addRemoveHighlightButton();
          this._addDropdown(e);
        }
        _addRemoveHighlightButton() {
          const e = this.editor.t;
          this._addButton('removeHighlight', e('Remove highlight'), _A);
        }
        _addHighlighterButton(e) {
          const t = this.editor.commands.get('highlight');
          this._addButton(
            'highlight:' + e.model,
            e.title,
            oC(e.type),
            e.model,
            i
          );
          function i(i) {
            i.bind('isEnabled').to(t, 'isEnabled');
            i.bind('isOn').to(t, 'value', (t) => t === e.model);
            i.iconView.fillColor = e.color;
            i.isToggleable = true;
          }
        }
        _addButton(e, t, i, n, o = () => {}) {
          const r = this.editor;
          r.ui.componentFactory.add(e, (e) => {
            const s = new Ew(e);
            const a = this.localizedOptionTitles[t]
              ? this.localizedOptionTitles[t]
              : t;
            s.set({ label: a, icon: i, tooltip: true });
            s.on('execute', () => {
              r.execute('highlight', { value: n });
              r.editing.view.focus();
            });
            o(s);
            return s;
          });
        }
        _addDropdown(e) {
          const t = this.editor;
          const i = t.t;
          const n = t.ui.componentFactory;
          const o = e[0];
          const r = e.reduce((e, t) => {
            e[t.model] = t;
            return e;
          }, {});
          n.add('highlight', (s) => {
            const a = t.commands.get('highlight');
            const c = Bw(s, eC);
            const l = c.buttonView;
            l.set({
              tooltip: i('Highlight'),
              lastExecuted: o.model,
              commandValue: o.model,
              isToggleable: true,
            });
            l.bind('icon').to(a, 'value', (e) => oC(u(e, 'type')));
            l.bind('color').to(a, 'value', (e) => u(e, 'color'));
            l.bind('commandValue').to(a, 'value', (e) => u(e, 'model'));
            l.bind('isOn').to(a, 'value', (e) => !!e);
            l.delegate('execute').to(c);
            const d = e.map((e) => {
              const t = n.create('highlight:' + e.model);
              this.listenTo(t, 'execute', () =>
                c.buttonView.set({ lastExecuted: e.model })
              );
              return t;
            });
            c.bind('isEnabled').toMany(d, 'isEnabled', (...e) =>
              e.some((e) => e)
            );
            d.push(new aw());
            d.push(n.create('removeHighlight'));
            Fw(c, d);
            nC(c);
            c.toolbarView.ariaLabel = i('Text highlight toolbar');
            l.on('execute', () => {
              t.execute('highlight', { value: l.commandValue });
              t.editing.view.focus();
            });
            function u(e, t) {
              const i = !e || e === l.lastExecuted ? l.lastExecuted : e;
              return r[i][t];
            }
            return c;
          });
        }
      }
      function nC(e) {
        const t = e.buttonView.actionView;
        t.iconView.bind('fillColor').to(e.buttonView, 'color');
      }
      function oC(e) {
        return e === 'marker' ? JT : ZT;
      }
      class rC extends ok {
        static get requires() {
          return [KT, iC];
        }
        static get pluginName() {
          return 'Highlight';
        }
      }
      class sC extends sk {
        refresh() {
          this.isEnabled = aC(this.editor.model);
        }
        execute() {
          const e = this.editor.model;
          e.change((t) => {
            const i = t.createElement('horizontalLine');
            e.insertContent(i);
            let n = i.nextSibling;
            const o = n && e.schema.checkChild(n, '$text');
            if (!o && e.schema.checkChild(i.parent, 'paragraph')) {
              n = t.createElement('paragraph');
              e.insertContent(n, t.createPositionAfter(i));
            }
            if (n) {
              t.setSelection(n, 0);
            }
          });
        }
      }
      function aC(e) {
        const t = e.schema;
        const i = e.document.selection;
        return cC(i, t, e) && !lC(i, t);
      }
      function cC(e, t, i) {
        const n = dC(e, i);
        return t.checkChild(n, 'horizontalLine');
      }
      function lC(e, t) {
        const i = e.getSelectedElement();
        return i && t.isObject(i);
      }
      function dC(e, t) {
        const i = L_(e, t);
        const n = i.parent;
        if (n.isEmpty && !n.is('element', '$root')) {
          return n.parent;
        }
        return n;
      }
      var uC = i(62);
      class hC extends ok {
        static get pluginName() {
          return 'HorizontalLineEditing';
        }
        init() {
          const e = this.editor;
          const t = e.model.schema;
          const i = e.t;
          const n = e.conversion;
          t.register('horizontalLine', {
            isObject: true,
            allowWhere: '$block',
          });
          n.for('dataDowncast').elementToElement({
            model: 'horizontalLine',
            view: (e, { writer: t }) => t.createEmptyElement('hr'),
          });
          n.for('editingDowncast').elementToElement({
            model: 'horizontalLine',
            view: (e, { writer: t }) => {
              const n = i('Horizontal line');
              const o = t.createContainerElement('div');
              const r = t.createEmptyElement('hr');
              t.addClass('ck-horizontal-line', o);
              t.setCustomProperty('hr', true, o);
              t.insert(t.createPositionAt(o, 0), r);
              return fC(o, t, n);
            },
          });
          n.for('upcast').elementToElement({
            view: 'hr',
            model: 'horizontalLine',
          });
          e.commands.add('horizontalLine', new sC(e));
        }
      }
      function fC(e, t, i) {
        t.setCustomProperty('horizontalLine', true, e);
        return I_(e, t, { label: i });
      }
      var gC =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 9h16v2H2z"/></svg>';
      class mC extends ok {
        init() {
          const e = this.editor;
          const t = e.t;
          e.ui.componentFactory.add('horizontalLine', (i) => {
            const n = e.commands.get('horizontalLine');
            const o = new Ew(i);
            o.set({ label: t('Horizontal line'), icon: gC, tooltip: true });
            o.bind('isEnabled').to(n, 'isEnabled');
            this.listenTo(o, 'execute', () => {
              e.execute('horizontalLine');
              e.editing.view.focus();
            });
            return o;
          });
        }
      }
      class pC extends ok {
        static get requires() {
          return [hC, mC];
        }
        static get pluginName() {
          return 'HorizontalLine';
        }
      }
      var bC =
        '<svg viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg"><polyline points="8.05541992 0.263427734 8.05541992 4.23461914 1.28417969 4.23461914" transform="translate(1,0)"></polyline><line x1="0" y1="4.21581031" x2="2" y2="2.17810059" transform="translate(1, 0)"></line><line x1="0" y1="6.21581031" x2="2" y2="4.17810059" transform="translate(2, 5.196955) scale(1, -1) translate(-1, -5.196955)"></line></svg>\n';
      var wC = i(64);
      const kC = ['before', 'after'];
      const _C = new DOMParser().parseFromString(
        bC,
        'image/svg+xml'
      ).firstChild;
      const vC = 'ck-widget__type-around_disabled';
      class yC extends ok {
        static get pluginName() {
          return 'WidgetTypeAround';
        }
        constructor(e) {
          super(e);
          this._currentFakeCaretModelElement = null;
        }
        init() {
          const e = this.editor;
          const t = e.editing.view;
          this.on('change:isEnabled', (i, n, o) => {
            t.change((e) => {
              for (const i of t.document.roots) {
                if (o) {
                  e.removeClass(vC, i);
                } else {
                  e.addClass(vC, i);
                }
              }
            });
            if (!o) {
              e.model.change((e) => {
                e.removeSelectionAttribute(y_);
              });
            }
          });
          this._enableTypeAroundUIInjection();
          this._enableInsertingParagraphsOnButtonClick();
          this._enableInsertingParagraphsOnEnterKeypress();
          this._enableInsertingParagraphsOnTypingKeystroke();
          this._enableTypeAroundFakeCaretActivationUsingKeyboardArrows();
          this._enableDeleteIntegration();
          this._enableInsertContentIntegration();
        }
        destroy() {
          this._currentFakeCaretModelElement = null;
        }
        _insertParagraph(e, t) {
          const i = this.editor;
          const n = i.editing.view;
          i.execute('insertParagraph', {
            position: i.model.createPositionAt(e, t),
          });
          n.focus();
          n.scrollToTheSelection();
        }
        _listenToIfEnabled(e, t, i, n) {
          this.listenTo(
            e,
            t,
            (...e) => {
              if (this.isEnabled) {
                i(...e);
              }
            },
            n
          );
        }
        _insertParagraphAccordingToFakeCaretPosition() {
          const e = this.editor;
          const t = e.model;
          const i = t.document.selection;
          const n = P_(i);
          if (!n) {
            return false;
          }
          const o = i.getSelectedElement();
          this._insertParagraph(o, n);
          return true;
        }
        _enableTypeAroundUIInjection() {
          const e = this.editor;
          const t = e.model.schema;
          const i = e.locale.t;
          const n = {
            before: i('Insert paragraph before block'),
            after: i('Insert paragraph after block'),
          };
          e.editing.downcastDispatcher.on(
            'insert',
            (e, i, o) => {
              const r = o.mapper.toViewElement(i.item);
              if (x_(r, i.item, t)) {
                xC(o.writer, n, r);
              }
            },
            { priority: 'low' }
          );
        }
        _enableTypeAroundFakeCaretActivationUsingKeyboardArrows() {
          const e = this.editor;
          const t = e.model;
          const i = t.document.selection;
          const n = t.schema;
          const o = e.editing.view;
          this._listenToIfEnabled(
            o.document,
            'keydown',
            (e, t) => {
              if (Dl(t.keyCode)) {
                this._handleArrowKeyPress(e, t);
              }
            },
            { priority: os.get('high') + 10 }
          );
          this._listenToIfEnabled(i, 'change:range', (t, i) => {
            if (!i.directChange) {
              return;
            }
            e.model.change((e) => {
              e.removeSelectionAttribute(y_);
            });
          });
          this._listenToIfEnabled(t.document, 'change:data', () => {
            const t = i.getSelectedElement();
            if (t) {
              const i = e.editing.mapper.toViewElement(t);
              if (x_(i, t, n)) {
                return;
              }
            }
            e.model.change((e) => {
              e.removeSelectionAttribute(y_);
            });
          });
          this._listenToIfEnabled(
            e.editing.downcastDispatcher,
            'selection',
            (e, t, i) => {
              const o = i.writer;
              if (this._currentFakeCaretModelElement) {
                const e = i.mapper.toViewElement(
                  this._currentFakeCaretModelElement
                );
                if (e) {
                  o.removeClass(kC.map(r), e);
                  this._currentFakeCaretModelElement = null;
                }
              }
              const s = t.selection.getSelectedElement();
              if (!s) {
                return;
              }
              const a = i.mapper.toViewElement(s);
              if (!x_(a, s, n)) {
                return;
              }
              const c = P_(t.selection);
              if (!c) {
                return;
              }
              o.addClass(r(c), a);
              this._currentFakeCaretModelElement = s;
            }
          );
          this._listenToIfEnabled(
            e.ui.focusTracker,
            'change:isFocused',
            (t, i, n) => {
              if (!n) {
                e.model.change((e) => {
                  e.removeSelectionAttribute(y_);
                });
              }
            }
          );
          function r(e) {
            return `ck-widget_type-around_show-fake-caret_${e}`;
          }
        }
        _handleArrowKeyPress(e, t) {
          const i = this.editor;
          const n = i.model;
          const o = n.document.selection;
          const r = n.schema;
          const s = i.editing.view;
          const a = t.keyCode;
          const c = Bl(a, i.locale.contentLanguageDirection);
          const l = s.document.selection.getSelectedElement();
          const d = i.editing.mapper.toModelElement(l);
          let u;
          if (x_(l, d, r)) {
            u = this._handleArrowKeyPressOnSelectedWidget(c);
          } else if (o.isCollapsed) {
            u = this._handleArrowKeyPressWhenSelectionNextToAWidget(c);
          }
          if (u) {
            t.preventDefault();
            e.stop();
          }
        }
        _handleArrowKeyPressOnSelectedWidget(e) {
          const t = this.editor;
          const i = t.model;
          const n = i.document.selection;
          const o = P_(n);
          return i.change((t) => {
            if (o) {
              const i = o === (e ? 'after' : 'before');
              if (!i) {
                t.removeSelectionAttribute(y_);
                return true;
              }
            } else {
              t.setSelectionAttribute(y_, e ? 'after' : 'before');
              return true;
            }
            return false;
          });
        }
        _handleArrowKeyPressWhenSelectionNextToAWidget(e) {
          const t = this.editor;
          const i = t.model;
          const n = i.schema;
          const o = t.plugins.get('Widget');
          const r = o._getObjectElementNextToSelection(e);
          const s = t.editing.mapper.toViewElement(r);
          if (x_(s, r, n)) {
            i.change((t) => {
              o._setSelectionOverElement(r);
              t.setSelectionAttribute(y_, e ? 'before' : 'after');
            });
            return true;
          }
          return false;
        }
        _enableInsertingParagraphsOnButtonClick() {
          const e = this.editor;
          const t = e.editing.view;
          this._listenToIfEnabled(t.document, 'mousedown', (i, n) => {
            const o = A_(n.domTarget);
            if (!o) {
              return;
            }
            const r = T_(o);
            const s = C_(o, t.domConverter);
            const a = e.editing.mapper.toModelElement(s);
            this._insertParagraph(a, r);
            n.preventDefault();
            i.stop();
          });
        }
        _enableInsertingParagraphsOnEnterKeypress() {
          const e = this.editor;
          const t = e.editing.view;
          this._listenToIfEnabled(t.document, 'enter', (i, n) => {
            const o = t.document.selection.getSelectedElement();
            const r = e.editing.mapper.toModelElement(o);
            const s = e.model.schema;
            let a;
            if (this._insertParagraphAccordingToFakeCaretPosition()) {
              a = true;
            } else if (x_(o, r, s)) {
              this._insertParagraph(r, n.isSoft ? 'before' : 'after');
              a = true;
            }
            if (a) {
              n.preventDefault();
              i.stop();
            }
          });
        }
        _enableInsertingParagraphsOnTypingKeystroke() {
          const e = this.editor;
          const t = e.editing.view;
          const i = [zl.enter, zl.delete, zl.backspace];
          this._listenToIfEnabled(
            t.document,
            'keydown',
            (e, t) => {
              if (!i.includes(t.keyCode) && !wv(t)) {
                this._insertParagraphAccordingToFakeCaretPosition();
              }
            },
            { priority: os.get('high') + 1 }
          );
        }
        _enableDeleteIntegration() {
          const e = this.editor;
          const t = e.editing.view;
          const i = e.model;
          const n = i.schema;
          this._listenToIfEnabled(
            t.document,
            'delete',
            (t, o) => {
              const r = P_(i.document.selection);
              if (!r) {
                return;
              }
              const s = o.direction;
              const a = i.document.selection.getSelectedElement();
              const c = r === 'before';
              const l = s == 'forward';
              const d = c === l;
              if (d) {
                e.execute('delete', { selection: i.createSelection(a, 'on') });
              } else {
                const t = n.getNearestSelectionRange(
                  i.createPositionAt(a, r),
                  s
                );
                if (t) {
                  if (!t.isCollapsed) {
                    i.change((i) => {
                      i.setSelection(t);
                      e.execute(l ? 'forwardDelete' : 'delete');
                    });
                  } else {
                    const o = i.createSelection(t.start);
                    i.modifySelection(o, { direction: s });
                    if (!o.focus.isEqual(t.start)) {
                      i.change((i) => {
                        i.setSelection(t);
                        e.execute(l ? 'forwardDelete' : 'delete');
                      });
                    } else {
                      const e = CC(n, t.start.parent);
                      i.deleteContent(i.createSelection(e, 'on'), {
                        doNotAutoparagraph: true,
                      });
                    }
                  }
                }
              }
              o.preventDefault();
              t.stop();
            },
            { priority: os.get('high') + 1 }
          );
        }
        _enableInsertContentIntegration() {
          const e = this.editor;
          const t = this.editor.model;
          const i = t.document.selection;
          this._listenToIfEnabled(
            e.model,
            'insertContent',
            (e, [n, o]) => {
              if (o && !o.is('documentSelection')) {
                return;
              }
              const r = P_(i);
              if (!r) {
                return;
              }
              e.stop();
              return t.change((e) => {
                const o = i.getSelectedElement();
                const s = t.createPositionAt(o, r);
                const a = e.createSelection(s);
                const c = t.insertContent(n, a);
                e.setSelection(a);
                return c;
              });
            },
            { priority: 'high' }
          );
        }
      }
      function xC(e, t, i) {
        const n = e.createUIElement(
          'div',
          { class: 'ck ck-reset_all ck-widget__type-around' },
          function (e) {
            const i = this.toDomElement(e);
            AC(i, t);
            TC(i);
            return i;
          }
        );
        e.insert(e.createPositionAt(i, 'end'), n);
      }
      function AC(e, t) {
        for (const i of kC) {
          const n = new mb({
            tag: 'div',
            attributes: {
              class: [
                'ck',
                'ck-widget__type-around__button',
                `ck-widget__type-around__button_${i}`,
              ],
              title: t[i],
            },
            children: [e.ownerDocument.importNode(_C, true)],
          });
          e.appendChild(n.render());
        }
      }
      function TC(e) {
        const t = new mb({
          tag: 'div',
          attributes: { class: ['ck', 'ck-widget__type-around__fake-caret'] },
        });
        e.appendChild(t.render());
      }
      function CC(e, t) {
        let i = t;
        for (const n of t.getAncestors({ parentFirst: true })) {
          if (n.childCount > 1 || e.isLimit(n)) {
            break;
          }
          i = n;
        }
        return i;
      }
      var PC = i(66);
      function EC(e) {
        const t = e.model;
        return (i, n) => {
          const o = n.keyCode == zl.arrowup;
          const r = n.keyCode == zl.arrowdown;
          const s = n.shiftKey;
          const a = t.document.selection;
          if (!o && !r) {
            return;
          }
          const c = r;
          if (s && OC(a, c)) {
            return;
          }
          const l = SC(e, a, c);
          if (!l || l.isCollapsed) {
            return;
          }
          if (NC(e, l, c)) {
            t.change((e) => {
              const i = c ? l.end : l.start;
              if (s) {
                const n = t.createSelection(a.anchor);
                n.setFocus(i);
                e.setSelection(n);
              } else {
                e.setSelection(i);
              }
            });
            i.stop();
            n.preventDefault();
            n.stopPropagation();
          }
        };
      }
      function SC(e, t, i) {
        const n = e.model;
        if (i) {
          const e = t.isCollapsed ? t.focus : t.getLastPosition();
          const i = MC(n, e, 'forward');
          if (!i) {
            return null;
          }
          const o = n.createRange(e, i);
          const r = IC(n.schema, o, 'backward');
          if (r && e.isBefore(r)) {
            return n.createRange(e, r);
          }
          return null;
        } else {
          const e = t.isCollapsed ? t.focus : t.getFirstPosition();
          const i = MC(n, e, 'backward');
          if (!i) {
            return null;
          }
          const o = n.createRange(i, e);
          const r = IC(n.schema, o, 'forward');
          if (r && e.isAfter(r)) {
            return n.createRange(r, e);
          }
          return null;
        }
      }
      function MC(e, t, i) {
        const n = e.schema;
        const o = e.createRangeIn(t.root);
        const r = i == 'forward' ? 'elementStart' : 'elementEnd';
        for (const { previousPosition: e, item: s, type: a } of o.getWalker({
          startPosition: t,
          direction: i,
        })) {
          if (n.isLimit(s) && !n.isInline(s)) {
            return e;
          }
          if (a == r && n.isBlock(s)) {
            return null;
          }
        }
        return null;
      }
      function IC(e, t, i) {
        const n = i == 'backward' ? t.end : t.start;
        if (e.checkChild(n, '$text')) {
          return n;
        }
        for (const { nextPosition: n } of t.getWalker({ direction: i })) {
          if (e.checkChild(n, '$text')) {
            return n;
          }
        }
      }
      function NC(e, t, i) {
        const n = e.model;
        const o = e.view.domConverter;
        if (i) {
          const e = n.createSelection(t.start);
          n.modifySelection(e);
          if (!e.focus.isAtEnd && !t.start.isEqual(e.focus)) {
            t = n.createRange(e.focus, t.end);
          }
        }
        const r = e.mapper.toViewRange(t);
        const s = o.viewRangeToDom(r);
        const a = Ch.getDomRangeRects(s);
        let c;
        for (const e of a) {
          if (c === undefined) {
            c = Math.round(e.bottom);
            continue;
          }
          if (Math.round(e.top) >= c) {
            return false;
          }
          c = Math.max(c, Math.round(e.bottom));
        }
        return true;
      }
      function OC(e, t) {
        return !e.isCollapsed && e.isBackward == t;
      }
      class zC extends ok {
        static get pluginName() {
          return 'Widget';
        }
        static get requires() {
          return [yC];
        }
        init() {
          const e = this.editor.editing.view;
          const t = e.document;
          this._previouslySelected = new Set();
          this.editor.editing.downcastDispatcher.on(
            'selection',
            (e, t, i) => {
              this._clearPreviouslySelectedWidgets(i.writer);
              const n = i.writer;
              const o = n.document.selection;
              const r = o.getSelectedElement();
              let s = null;
              for (const e of o.getRanges()) {
                for (const t of e) {
                  const e = t.item;
                  if (M_(e) && !LC(e, s)) {
                    n.addClass(S_, e);
                    this._previouslySelected.add(e);
                    s = e;
                    if (e == r) {
                      n.setSelection(o.getRanges(), {
                        fake: true,
                        label: z_(r),
                      });
                    }
                  }
                }
              }
            },
            { priority: 'low' }
          );
          e.addObserver(ov);
          this.listenTo(t, 'mousedown', (...e) => this._onMousedown(...e));
          this.listenTo(
            t,
            'keydown',
            (...e) => {
              this._handleSelectionChangeOnArrowKeyPress(...e);
            },
            { priority: 'high' }
          );
          this.listenTo(
            t,
            'keydown',
            (...e) => {
              this._preventDefaultOnArrowKeyPress(...e);
            },
            { priority: os.get('high') - 20 }
          );
          this.listenTo(t, 'keydown', EC(this.editor.editing));
          this.listenTo(
            t,
            'delete',
            (e, t) => {
              if (this._handleDelete(t.direction == 'forward')) {
                t.preventDefault();
                e.stop();
              }
            },
            { priority: 'high' }
          );
        }
        _onMousedown(e, t) {
          const i = this.editor;
          const n = i.editing.view;
          const o = n.document;
          let r = t.target;
          if (RC(r)) {
            if ((Cl.isSafari || Cl.isGecko) && t.domEvent.detail >= 3) {
              const e = i.editing.mapper;
              const n = r.is('attributeElement')
                ? r.findAncestor((e) => !e.is('attributeElement'))
                : r;
              const o = e.toModelElement(n);
              t.preventDefault();
              this.editor.model.change((e) => {
                e.setSelection(o, 'in');
              });
            }
            return;
          }
          if (!M_(r)) {
            r = r.findAncestor(M_);
            if (!r) {
              return;
            }
          }
          t.preventDefault();
          if (!o.isFocused) {
            n.focus();
          }
          const s = i.editing.mapper.toModelElement(r);
          this._setSelectionOverElement(s);
        }
        _handleSelectionChangeOnArrowKeyPress(e, t) {
          const i = t.keyCode;
          if (!Dl(i)) {
            return;
          }
          const n = this.editor.model;
          const o = n.schema;
          const r = n.document.selection;
          const s = r.getSelectedElement();
          const a = Bl(i, this.editor.locale.contentLanguageDirection);
          if (s && o.isObject(s)) {
            const i = a ? r.getLastPosition() : r.getFirstPosition();
            const s = o.getNearestSelectionRange(i, a ? 'forward' : 'backward');
            if (s) {
              n.change((e) => {
                e.setSelection(s);
              });
              t.preventDefault();
              e.stop();
            }
            return;
          }
          if (!r.isCollapsed) {
            return;
          }
          const c = this._getObjectElementNextToSelection(a);
          if (c && o.isObject(c)) {
            this._setSelectionOverElement(c);
            t.preventDefault();
            e.stop();
          }
        }
        _preventDefaultOnArrowKeyPress(e, t) {
          const i = t.keyCode;
          if (!Dl(i)) {
            return;
          }
          const n = this.editor.model;
          const o = n.schema;
          const r = n.document.selection.getSelectedElement();
          if (r && o.isObject(r)) {
            t.preventDefault();
            e.stop();
          }
        }
        _handleDelete(e) {
          if (this.editor.isReadOnly) {
            return;
          }
          const t = this.editor.model.document;
          const i = t.selection;
          if (!i.isCollapsed) {
            return;
          }
          const n = this._getObjectElementNextToSelection(e);
          if (n) {
            this.editor.model.change((e) => {
              let t = i.anchor.parent;
              while (t.isEmpty) {
                const i = t;
                t = i.parent;
                e.remove(i);
              }
              this._setSelectionOverElement(n);
            });
            return true;
          }
        }
        _setSelectionOverElement(e) {
          this.editor.model.change((t) => {
            t.setSelection(t.createRangeOn(e));
          });
        }
        _getObjectElementNextToSelection(e) {
          const t = this.editor.model;
          const i = t.schema;
          const n = t.document.selection;
          const o = t.createSelection(n);
          t.modifySelection(o, { direction: e ? 'forward' : 'backward' });
          const r = e ? o.focus.nodeBefore : o.focus.nodeAfter;
          if (!!r && i.isObject(r)) {
            return r;
          }
          return null;
        }
        _clearPreviouslySelectedWidgets(e) {
          for (const t of this._previouslySelected) {
            e.removeClass(S_, t);
          }
          this._previouslySelected.clear();
        }
      }
      function RC(e) {
        while (e) {
          if (e.is('editableElement') && !e.is('rootElement')) {
            return true;
          }
          if (M_(e)) {
            return false;
          }
          e = e.parent;
        }
        return false;
      }
      function LC(e, t) {
        if (!t) {
          return false;
        }
        return Array.from(e.getAncestors()).includes(t);
      }
      class VC extends sk {
        refresh() {
          const e = this.editor.model.document.selection.getSelectedElement();
          this.isEnabled = q_(e);
          if (q_(e) && e.hasAttribute('alt')) {
            this.value = e.getAttribute('alt');
          } else {
            this.value = false;
          }
        }
        execute(e) {
          const t = this.editor.model;
          const i = t.document.selection.getSelectedElement();
          t.change((t) => {
            t.setAttribute('alt', e.newValue, i);
          });
        }
      }
      class DC extends ok {
        static get pluginName() {
          return 'ImageTextAlternativeEditing';
        }
        init() {
          this.editor.commands.add('imageTextAlternative', new VC(this.editor));
        }
      }
      var jC = i(68);
      class BC extends Hb {
        constructor(e, t) {
          super(e);
          const i = `ck-labeled-field-view-${is()}`;
          const n = `ck-labeled-field-view-status-${is()}`;
          this.fieldView = t(this, i, n);
          this.set('label');
          this.set('isEnabled', true);
          this.set('errorText', null);
          this.set('infoText', null);
          this.set('class');
          this.labelView = this._createLabelView(i);
          this.statusView = this._createStatusView(n);
          this.bind('_statusText').to(
            this,
            'errorText',
            this,
            'infoText',
            (e, t) => e || t
          );
          const o = this.bindTemplate;
          this.setTemplate({
            tag: 'div',
            attributes: {
              class: [
                'ck',
                'ck-labeled-field-view',
                o.to('class'),
                o.if('isEnabled', 'ck-disabled', (e) => !e),
              ],
            },
            children: [this.labelView, this.fieldView, this.statusView],
          });
        }
        _createLabelView(e) {
          const t = new Jb(this.locale);
          t.for = e;
          t.bind('text').to(this, 'label');
          return t;
        }
        _createStatusView(e) {
          const t = new Hb(this.locale);
          const i = this.bindTemplate;
          t.setTemplate({
            tag: 'div',
            attributes: {
              class: [
                'ck',
                'ck-labeled-field-view__status',
                i.if('errorText', 'ck-labeled-field-view__status_error'),
                i.if('_statusText', 'ck-hidden', (e) => !e),
              ],
              id: e,
              role: i.if('errorText', 'alert'),
            },
            children: [{ text: i.to('_statusText') }],
          });
          return t;
        }
        focus() {
          this.fieldView.focus();
        }
      }
      var FC = i(70);
      class HC extends Hb {
        constructor(e) {
          super(e);
          this.set('value');
          this.set('id');
          this.set('placeholder');
          this.set('isReadOnly', false);
          this.set('hasError', false);
          this.set('ariaDescribedById');
          const t = this.bindTemplate;
          this.setTemplate({
            tag: 'input',
            attributes: {
              type: 'text',
              class: [
                'ck',
                'ck-input',
                'ck-input-text',
                t.if('hasError', 'ck-error'),
              ],
              id: t.to('id'),
              placeholder: t.to('placeholder'),
              readonly: t.to('isReadOnly'),
              'aria-invalid': t.if('hasError', true),
              'aria-describedby': t.to('ariaDescribedById'),
            },
            on: { input: t.to('input') },
          });
        }
        render() {
          super.render();
          const e = (e) => {
            this.element.value = !e && e !== 0 ? '' : e;
          };
          e(this.value);
          this.on('change:value', (t, i, n) => {
            e(n);
          });
        }
        select() {
          this.element.select();
        }
        focus() {
          this.element.focus();
        }
      }
      function UC(e, t, i) {
        const n = new HC(e.locale);
        n.set({ id: t, ariaDescribedById: i });
        n.bind('isReadOnly').to(e, 'isEnabled', (e) => !e);
        n.bind('hasError').to(e, 'errorText', (e) => !!e);
        n.on('input', () => {
          e.errorText = null;
        });
        return n;
      }
      function qC(e, t, i) {
        const n = Bw(e.locale);
        n.set({ id: t, ariaDescribedById: i });
        n.bind('isEnabled').to(e);
        return n;
      }
      function WC({ view: e }) {
        e.listenTo(
          e.element,
          'submit',
          (t, i) => {
            i.preventDefault();
            e.fire('submit');
          },
          { useCapture: true }
        );
      }
      var $C =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.972 16.615a.997.997 0 0 1-.744-.292l-4.596-4.596a1 1 0 1 1 1.414-1.414l3.926 3.926 9.937-9.937a1 1 0 0 1 1.414 1.415L7.717 16.323a.997.997 0 0 1-.745.292z"/></svg>';
      var GC =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.591 10.177l4.243 4.242a1 1 0 0 1-1.415 1.415l-4.242-4.243-4.243 4.243a1 1 0 0 1-1.414-1.415l4.243-4.242L4.52 5.934A1 1 0 0 1 5.934 4.52l4.243 4.243 4.242-4.243a1 1 0 1 1 1.415 1.414l-4.243 4.243z"/></svg>';
      var YC = i(72);
      class KC extends Hb {
        constructor(e) {
          super(e);
          const t = this.locale.t;
          this.focusTracker = new Qp();
          this.keystrokes = new Vp();
          this.labeledInput = this._createLabeledInputView();
          this.saveButtonView = this._createButton(
            t('Save'),
            $C,
            'ck-button-save'
          );
          this.saveButtonView.type = 'submit';
          this.cancelButtonView = this._createButton(
            t('Cancel'),
            GC,
            'ck-button-cancel',
            'cancel'
          );
          this._focusables = new hb();
          this._focusCycler = new rw({
            focusables: this._focusables,
            focusTracker: this.focusTracker,
            keystrokeHandler: this.keystrokes,
            actions: { focusPrevious: 'shift + tab', focusNext: 'tab' },
          });
          this.setTemplate({
            tag: 'form',
            attributes: {
              class: ['ck', 'ck-text-alternative-form'],
              tabindex: '-1',
            },
            children: [
              this.labeledInput,
              this.saveButtonView,
              this.cancelButtonView,
            ],
          });
        }
        render() {
          super.render();
          this.keystrokes.listenTo(this.element);
          WC({ view: this });
          [
            this.labeledInput,
            this.saveButtonView,
            this.cancelButtonView,
          ].forEach((e) => {
            this._focusables.add(e);
            this.focusTracker.add(e.element);
          });
        }
        _createButton(e, t, i, n) {
          const o = new Ew(this.locale);
          o.set({ label: e, icon: t, tooltip: true });
          o.extendTemplate({ attributes: { class: i } });
          if (n) {
            o.delegate('execute').to(this, n);
          }
          return o;
        }
        _createLabeledInputView() {
          const e = this.locale.t;
          const t = new BC(this.locale, UC);
          t.label = e('Text alternative');
          t.fieldView.placeholder = e('Text alternative');
          return t;
        }
      }
      var QC =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.463 5.187a.888.888 0 1 1 1.254 1.255L9.16 10l3.557 3.557a.888.888 0 1 1-1.254 1.255L7.26 10.61a.888.888 0 0 1 .16-1.382l4.043-4.042z"/></svg>';
      var JC =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8.537 14.813a.888.888 0 1 1-1.254-1.255L10.84 10 7.283 6.442a.888.888 0 1 1 1.254-1.255L12.74 9.39a.888.888 0 0 1-.16 1.382l-4.043 4.042z"/></svg>';
      var ZC = i(74);
      var XC = i(76);
      const eP = tw('px');
      class tP extends ok {
        static get pluginName() {
          return 'ContextualBalloon';
        }
        constructor(e) {
          super(e);
          this.positionLimiter = () => {
            const e = this.editor.editing.view;
            const t = e.document;
            const i = t.selection.editableElement;
            if (i) {
              return e.domConverter.mapViewToDom(i.root);
            }
            return null;
          };
          this.set('visibleView', null);
          this.view = new b_(e.locale);
          e.ui.view.body.add(this.view);
          e.ui.focusTracker.add(this.view.element);
          this._viewToStack = new Map();
          this._idToStack = new Map();
          this.set('_numberOfStacks', 0);
          this.set('_singleViewMode', false);
          this._rotatorView = this._createRotatorView();
          this._fakePanelsView = this._createFakePanelsView();
        }
        hasView(e) {
          return Array.from(this._viewToStack.keys()).includes(e);
        }
        add(e) {
          if (this.hasView(e.view)) {
            throw new ss['b'](
              'contextualballoon-add-view-exist: Cannot add configuration of the same view twice.',
              [this, e]
            );
          }
          const t = e.stackId || 'main';
          if (!this._idToStack.has(t)) {
            this._idToStack.set(t, new Map([[e.view, e]]));
            this._viewToStack.set(e.view, this._idToStack.get(t));
            this._numberOfStacks = this._idToStack.size;
            if (!this._visibleStack || e.singleViewMode) {
              this.showStack(t);
            }
            return;
          }
          const i = this._idToStack.get(t);
          if (e.singleViewMode) {
            this.showStack(t);
          }
          i.set(e.view, e);
          this._viewToStack.set(e.view, i);
          if (i === this._visibleStack) {
            this._showView(e);
          }
        }
        remove(e) {
          if (!this.hasView(e)) {
            throw new ss['b'](
              'contextualballoon-remove-view-not-exist: Cannot remove the configuration of a non-existent view.',
              [this, e]
            );
          }
          const t = this._viewToStack.get(e);
          if (this._singleViewMode && this.visibleView === e) {
            this._singleViewMode = false;
          }
          if (this.visibleView === e) {
            if (t.size === 1) {
              if (this._idToStack.size > 1) {
                this._showNextStack();
              } else {
                this.view.hide();
                this.visibleView = null;
                this._rotatorView.hideView();
              }
            } else {
              this._showView(Array.from(t.values())[t.size - 2]);
            }
          }
          if (t.size === 1) {
            this._idToStack.delete(this._getStackId(t));
            this._numberOfStacks = this._idToStack.size;
          } else {
            t.delete(e);
          }
          this._viewToStack.delete(e);
        }
        updatePosition(e) {
          if (e) {
            this._visibleStack.get(this.visibleView).position = e;
          }
          this.view.pin(this._getBalloonPosition());
          this._fakePanelsView.updatePosition();
        }
        showStack(e) {
          this.visibleStack = e;
          const t = this._idToStack.get(e);
          if (!t) {
            throw new ss['b'](
              'contextualballoon-showstack-stack-not-exist: Cannot show a stack that does not exist.',
              this
            );
          }
          if (this._visibleStack === t) {
            return;
          }
          this._showView(Array.from(t.values()).pop());
        }
        get _visibleStack() {
          return this._viewToStack.get(this.visibleView);
        }
        _getStackId(e) {
          const t = Array.from(this._idToStack.entries()).find(
            (t) => t[1] === e
          );
          return t[0];
        }
        _showNextStack() {
          const e = Array.from(this._idToStack.values());
          let t = e.indexOf(this._visibleStack) + 1;
          if (!e[t]) {
            t = 0;
          }
          this.showStack(this._getStackId(e[t]));
        }
        _showPrevStack() {
          const e = Array.from(this._idToStack.values());
          let t = e.indexOf(this._visibleStack) - 1;
          if (!e[t]) {
            t = e.length - 1;
          }
          this.showStack(this._getStackId(e[t]));
        }
        _createRotatorView() {
          const e = new iP(this.editor.locale);
          const t = this.editor.locale.t;
          this.view.content.add(e);
          e.bind('isNavigationVisible').to(
            this,
            '_numberOfStacks',
            this,
            '_singleViewMode',
            (e, t) => !t && e > 1
          );
          e.on('change:isNavigationVisible', () => this.updatePosition(), {
            priority: 'low',
          });
          e.bind('counter').to(
            this,
            'visibleView',
            this,
            '_numberOfStacks',
            (e, i) => {
              if (i < 2) {
                return '';
              }
              const n =
                Array.from(this._idToStack.values()).indexOf(
                  this._visibleStack
                ) + 1;
              return t('%0 of %1', [n, i]);
            }
          );
          e.buttonNextView.on('execute', () => {
            if (e.focusTracker.isFocused) {
              this.editor.editing.view.focus();
            }
            this._showNextStack();
          });
          e.buttonPrevView.on('execute', () => {
            if (e.focusTracker.isFocused) {
              this.editor.editing.view.focus();
            }
            this._showPrevStack();
          });
          return e;
        }
        _createFakePanelsView() {
          const e = new nP(this.editor.locale, this.view);
          e.bind('numberOfPanels').to(
            this,
            '_numberOfStacks',
            this,
            '_singleViewMode',
            (e, t) => {
              const i = !t && e >= 2;
              return i ? Math.min(e - 1, 2) : 0;
            }
          );
          e.listenTo(this.view, 'change:top', () => e.updatePosition());
          e.listenTo(this.view, 'change:left', () => e.updatePosition());
          this.editor.ui.view.body.add(e);
          return e;
        }
        _showView({
          view: e,
          balloonClassName: t = '',
          withArrow: i = true,
          singleViewMode: n = false,
        }) {
          this.view.class = t;
          this.view.withArrow = i;
          this._rotatorView.showView(e);
          this.visibleView = e;
          this.view.pin(this._getBalloonPosition());
          this._fakePanelsView.updatePosition();
          if (n) {
            this._singleViewMode = true;
          }
        }
        _getBalloonPosition() {
          let e = Array.from(this._visibleStack.values()).pop().position;
          if (e && !e.limiter) {
            e = Object.assign({}, e, { limiter: this.positionLimiter });
          }
          return e;
        }
      }
      class iP extends Hb {
        constructor(e) {
          super(e);
          const t = e.t;
          const i = this.bindTemplate;
          this.set('isNavigationVisible', true);
          this.focusTracker = new Qp();
          this.buttonPrevView = this._createButtonView(t('Previous'), QC);
          this.buttonNextView = this._createButtonView(t('Next'), JC);
          this.content = this.createCollection();
          this.setTemplate({
            tag: 'div',
            attributes: {
              class: ['ck', 'ck-balloon-rotator'],
              'z-index': '-1',
            },
            children: [
              {
                tag: 'div',
                attributes: {
                  class: [
                    'ck-balloon-rotator__navigation',
                    i.to('isNavigationVisible', (e) => (e ? '' : 'ck-hidden')),
                  ],
                },
                children: [
                  this.buttonPrevView,
                  {
                    tag: 'span',
                    attributes: { class: ['ck-balloon-rotator__counter'] },
                    children: [{ text: i.to('counter') }],
                  },
                  this.buttonNextView,
                ],
              },
              {
                tag: 'div',
                attributes: { class: 'ck-balloon-rotator__content' },
                children: this.content,
              },
            ],
          });
        }
        render() {
          super.render();
          this.focusTracker.add(this.element);
        }
        showView(e) {
          this.hideView();
          this.content.add(e);
        }
        hideView() {
          this.content.clear();
        }
        _createButtonView(e, t) {
          const i = new Ew(this.locale);
          i.set({ label: e, icon: t, tooltip: true });
          return i;
        }
      }
      class nP extends Hb {
        constructor(e, t) {
          super(e);
          const i = this.bindTemplate;
          this.set('top', 0);
          this.set('left', 0);
          this.set('height', 0);
          this.set('width', 0);
          this.set('numberOfPanels', 0);
          this.content = this.createCollection();
          this._balloonPanelView = t;
          this.setTemplate({
            tag: 'div',
            attributes: {
              class: [
                'ck-fake-panel',
                i.to('numberOfPanels', (e) => (e ? '' : 'ck-hidden')),
              ],
              style: {
                top: i.to('top', eP),
                left: i.to('left', eP),
                width: i.to('width', eP),
                height: i.to('height', eP),
              },
            },
            children: this.content,
          });
          this.on('change:numberOfPanels', (e, t, i, n) => {
            if (i > n) {
              this._addPanels(i - n);
            } else {
              this._removePanels(n - i);
            }
            this.updatePosition();
          });
        }
        _addPanels(e) {
          while (e--) {
            const e = new Hb();
            e.setTemplate({ tag: 'div' });
            this.content.add(e);
            this.registerChild(e);
          }
        }
        _removePanels(e) {
          while (e--) {
            const e = this.content.last;
            this.content.remove(e);
            this.deregisterChild(e);
            e.destroy();
          }
        }
        updatePosition() {
          if (this.numberOfPanels) {
            const { top: e, left: t } = this._balloonPanelView;
            const { width: i, height: n } = new Ch(
              this._balloonPanelView.element
            );
            Object.assign(this, { top: e, left: t, width: i, height: n });
          }
        }
      }
      var oP =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5.085 6.22L2.943 4.078a.75.75 0 1 1 1.06-1.06l2.592 2.59A11.094 11.094 0 0 1 10 5.068c4.738 0 8.578 3.101 8.578 5.083 0 1.197-1.401 2.803-3.555 3.887l1.714 1.713a.75.75 0 0 1-.09 1.138.488.488 0 0 1-.15.084.75.75 0 0 1-.821-.16L6.17 7.304c-.258.11-.51.233-.757.365l6.239 6.24-.006.005.78.78c-.388.094-.78.166-1.174.215l-1.11-1.11h.011L4.55 8.197a7.2 7.2 0 0 0-.665.514l-.112.098 4.897 4.897-.005.006 1.276 1.276a10.164 10.164 0 0 1-1.477-.117l-.479-.479-.009.009-4.863-4.863-.022.031a2.563 2.563 0 0 0-.124.2c-.043.077-.08.158-.108.241a.534.534 0 0 0-.028.133.29.29 0 0 0 .008.072.927.927 0 0 0 .082.226c.067.133.145.26.234.379l3.242 3.365.025.01.59.623c-3.265-.918-5.59-3.155-5.59-4.668 0-1.194 1.448-2.838 3.663-3.93zm7.07.531a4.632 4.632 0 0 1 1.108 5.992l.345.344.046-.018a9.313 9.313 0 0 0 2-1.112c.256-.187.5-.392.727-.613.137-.134.27-.277.392-.431.072-.091.141-.185.203-.286.057-.093.107-.19.148-.292a.72.72 0 0 0 .036-.12.29.29 0 0 0 .008-.072.492.492 0 0 0-.028-.133.999.999 0 0 0-.036-.096 2.165 2.165 0 0 0-.071-.145 2.917 2.917 0 0 0-.125-.2 3.592 3.592 0 0 0-.263-.335 5.444 5.444 0 0 0-.53-.523 7.955 7.955 0 0 0-1.054-.768 9.766 9.766 0 0 0-1.879-.891c-.337-.118-.68-.219-1.027-.301zm-2.85.21l-.069.002a.508.508 0 0 0-.254.097.496.496 0 0 0-.104.679.498.498 0 0 0 .326.199l.045.005c.091.003.181.003.272.012a2.45 2.45 0 0 1 2.017 1.513c.024.061.043.125.069.185a.494.494 0 0 0 .45.287h.008a.496.496 0 0 0 .35-.158.482.482 0 0 0 .13-.335.638.638 0 0 0-.048-.219 3.379 3.379 0 0 0-.36-.723 3.438 3.438 0 0 0-2.791-1.543l-.028-.001h-.013z"/></svg>';
      function rP(e) {
        const t = e.plugins.get('ContextualBalloon');
        if (U_(e.editing.view.document.selection)) {
          const i = sP(e);
          t.updatePosition(i);
        }
      }
      function sP(e) {
        const t = e.editing.view;
        const i = b_.defaultPositions;
        return {
          target: t.domConverter.viewToDom(
            t.document.selection.getSelectedElement()
          ),
          positions: [
            i.northArrowSouth,
            i.northArrowSouthWest,
            i.northArrowSouthEast,
            i.southArrowNorth,
            i.southArrowNorthWest,
            i.southArrowNorthEast,
          ],
        };
      }
      class aP extends ok {
        static get requires() {
          return [tP];
        }
        static get pluginName() {
          return 'ImageTextAlternativeUI';
        }
        init() {
          this._createButton();
          this._createForm();
        }
        destroy() {
          super.destroy();
          this._form.destroy();
        }
        _createButton() {
          const e = this.editor;
          const t = e.t;
          e.ui.componentFactory.add('imageTextAlternative', (i) => {
            const n = e.commands.get('imageTextAlternative');
            const o = new Ew(i);
            o.set({
              label: t('Change image text alternative'),
              icon: oP,
              tooltip: true,
            });
            o.bind('isEnabled').to(n, 'isEnabled');
            this.listenTo(o, 'execute', () => {
              this._showForm();
            });
            return o;
          });
        }
        _createForm() {
          const e = this.editor;
          const t = e.editing.view;
          const i = t.document;
          this._balloon = this.editor.plugins.get('ContextualBalloon');
          this._form = new KC(e.locale);
          this._form.render();
          this.listenTo(this._form, 'submit', () => {
            e.execute('imageTextAlternative', {
              newValue: this._form.labeledInput.fieldView.element.value,
            });
            this._hideForm(true);
          });
          this.listenTo(this._form, 'cancel', () => {
            this._hideForm(true);
          });
          this._form.keystrokes.set('Esc', (e, t) => {
            this._hideForm(true);
            t();
          });
          this.listenTo(e.ui, 'update', () => {
            if (!U_(i.selection)) {
              this._hideForm(true);
            } else if (this._isVisible) {
              rP(e);
            }
          });
          Vw({
            emitter: this._form,
            activator: () => this._isVisible,
            contextElements: [this._balloon.view.element],
            callback: () => this._hideForm(),
          });
        }
        _showForm() {
          if (this._isVisible) {
            return;
          }
          const e = this.editor;
          const t = e.commands.get('imageTextAlternative');
          const i = this._form.labeledInput;
          if (!this._isInBalloon) {
            this._balloon.add({ view: this._form, position: sP(e) });
          }
          i.fieldView.value = i.fieldView.element.value = t.value || '';
          this._form.labeledInput.fieldView.select();
        }
        _hideForm(e) {
          if (!this._isInBalloon) {
            return;
          }
          if (this._form.focusTracker.isFocused) {
            this._form.saveButtonView.focus();
          }
          this._balloon.remove(this._form);
          if (e) {
            this.editor.editing.view.focus();
          }
        }
        get _isVisible() {
          return this._balloon.visibleView === this._form;
        }
        get _isInBalloon() {
          return this._balloon.hasView(this._form);
        }
      }
      class cP extends ok {
        static get requires() {
          return [DC, aP];
        }
        static get pluginName() {
          return 'ImageTextAlternative';
        }
      }
      var lP = i(78);
      class dP extends ok {
        static get requires() {
          return [iv, zC, cP];
        }
        static get pluginName() {
          return 'Image';
        }
      }
      function uP(e, t) {
        return (i) => {
          const n = i.createEditableElement('figcaption');
          i.setCustomProperty('imageCaption', true, n);
          ib({ view: e, element: n, text: t });
          return R_(n, i);
        };
      }
      function hP(e) {
        return !!e.getCustomProperty('imageCaption');
      }
      function fP(e) {
        for (const t of e.getChildren()) {
          if (!!t && t.is('element', 'caption')) {
            return t;
          }
        }
        return null;
      }
      function gP(e) {
        const t = e.parent;
        if (
          e.name == 'figcaption' &&
          t &&
          t.name == 'figure' &&
          t.hasClass('image')
        ) {
          return { name: true };
        }
        return null;
      }
      class mP extends ok {
        static get pluginName() {
          return 'ImageCaptionEditing';
        }
        init() {
          const e = this.editor;
          const t = e.editing.view;
          const i = e.model.schema;
          const n = e.data;
          const o = e.editing;
          const r = e.t;
          i.register('caption', {
            allowIn: 'image',
            allowContentOf: '$block',
            isLimit: true,
          });
          e.model.document.registerPostFixer((e) =>
            this._insertMissingModelCaptionElement(e)
          );
          e.conversion
            .for('upcast')
            .elementToElement({ view: gP, model: 'caption' });
          const s = (e) => e.createContainerElement('figcaption');
          n.downcastDispatcher.on('insert:caption', pP(s, false));
          const a = uP(t, r('Enter image caption'));
          o.downcastDispatcher.on('insert:caption', pP(a));
          o.downcastDispatcher.on(
            'insert',
            this._fixCaptionVisibility((e) => e.item),
            { priority: 'high' }
          );
          o.downcastDispatcher.on(
            'remove',
            this._fixCaptionVisibility((e) => e.position.parent),
            { priority: 'high' }
          );
          t.document.registerPostFixer((e) => this._updateCaptionVisibility(e));
        }
        _updateCaptionVisibility(e) {
          const t = this.editor.editing.mapper;
          const i = this._lastSelectedCaption;
          let n;
          const o = this.editor.model.document.selection;
          const r = o.getSelectedElement();
          if (r && r.is('element', 'image')) {
            const e = fP(r);
            n = t.toViewElement(e);
          }
          const s = o.getFirstPosition();
          const a = wP(s.parent);
          if (a) {
            n = t.toViewElement(a);
          }
          if (n) {
            if (i) {
              if (i === n) {
                return _P(n, e);
              } else {
                kP(i, e);
                this._lastSelectedCaption = n;
                return _P(n, e);
              }
            } else {
              this._lastSelectedCaption = n;
              return _P(n, e);
            }
          } else {
            if (i) {
              const t = kP(i, e);
              this._lastSelectedCaption = null;
              return t;
            } else {
              return false;
            }
          }
        }
        _fixCaptionVisibility(e) {
          return (t, i, n) => {
            const o = e(i);
            const r = wP(o);
            const s = this.editor.editing.mapper;
            const a = n.writer;
            if (r) {
              const e = s.toViewElement(r);
              if (e) {
                if (r.childCount) {
                  a.removeClass('ck-hidden', e);
                } else {
                  a.addClass('ck-hidden', e);
                }
              }
            }
          };
        }
        _insertMissingModelCaptionElement(e) {
          const t = this.editor.model;
          const i = t.document.differ.getChanges();
          const n = [];
          for (const e of i) {
            if (e.type == 'insert' && e.name != '$text') {
              const i = e.position.nodeAfter;
              if (i.is('element', 'image') && !fP(i)) {
                n.push(i);
              }
              if (!i.is('element', 'image') && i.childCount) {
                for (const e of t.createRangeIn(i).getItems()) {
                  if (e.is('element', 'image') && !fP(e)) {
                    n.push(e);
                  }
                }
              }
            }
          }
          for (const t of n) {
            e.appendElement('caption', t);
          }
          return !!n.length;
        }
      }
      function pP(e, t = true) {
        return (i, n, o) => {
          const r = n.item;
          if (!r.childCount && !t) {
            return;
          }
          if (q_(r.parent)) {
            if (!o.consumable.consume(n.item, 'insert')) {
              return;
            }
            const t = o.mapper.toViewElement(n.range.start.parent);
            const i = e(o.writer);
            const s = o.writer;
            if (!r.childCount) {
              s.addClass('ck-hidden', i);
            }
            bP(i, n.item, t, o);
          }
        };
      }
      function bP(e, t, i, n) {
        const o = n.writer.createPositionAt(i, 'end');
        n.writer.insert(o, e);
        n.mapper.bindElements(t, e);
      }
      function wP(e) {
        const t = e.getAncestors({ includeSelf: true });
        const i = t.find((e) => e.name == 'caption');
        if (i && i.parent && i.parent.name == 'image') {
          return i;
        }
        return null;
      }
      function kP(e, t) {
        if (!e.childCount && !e.hasClass('ck-hidden')) {
          t.addClass('ck-hidden', e);
          return true;
        }
        return false;
      }
      function _P(e, t) {
        if (e.hasClass('ck-hidden')) {
          t.removeClass('ck-hidden', e);
          return true;
        }
        return false;
      }
      var vP = i(80);
      class yP extends ok {
        static get requires() {
          return [mP];
        }
        static get pluginName() {
          return 'ImageCaption';
        }
      }
      class xP extends sk {
        refresh() {
          const e = this.editor.model.document.selection.getSelectedElement();
          this.isEnabled = q_(e);
          if (!e || !e.hasAttribute('width')) {
            this.value = null;
          } else {
            this.value = { width: e.getAttribute('width'), height: null };
          }
        }
        execute(e) {
          const t = this.editor.model;
          const i = t.document.selection.getSelectedElement();
          this.value = { width: e.width, height: null };
          if (i) {
            t.change((t) => {
              t.setAttribute('width', e.width, i);
            });
          }
        }
      }
      class AP extends ok {
        static get pluginName() {
          return 'ImageResizeEditing';
        }
        constructor(e) {
          super(e);
          e.config.define('image', {
            resizeUnit: '%',
            resizeOptions: [
              { name: 'imageResize:original', value: null, icon: 'original' },
              { name: 'imageResize:25', value: '25', icon: 'small' },
              { name: 'imageResize:50', value: '50', icon: 'medium' },
              { name: 'imageResize:75', value: '75', icon: 'large' },
            ],
          });
        }
        init() {
          const e = this.editor;
          const t = new xP(e);
          this._registerSchema();
          this._registerConverters();
          e.commands.add('imageResize', t);
        }
        _registerSchema() {
          this.editor.model.schema.extend('image', {
            allowAttributes: 'width',
          });
          this.editor.model.schema.setAttributeProperties('width', {
            isFormatting: true,
          });
        }
        _registerConverters() {
          const e = this.editor;
          e.conversion.for('downcast').add((e) =>
            e.on('attribute:width:image', (e, t, i) => {
              if (!i.consumable.consume(t.item, e.name)) {
                return;
              }
              const n = i.writer;
              const o = i.mapper.toViewElement(t.item);
              if (t.attributeNewValue !== null) {
                n.setStyle('width', t.attributeNewValue, o);
                n.addClass('image_resized', o);
              } else {
                n.removeStyle('width', o);
                n.removeClass('image_resized', o);
              }
            })
          );
          e.conversion.for('upcast').attributeToAttribute({
            view: { name: 'figure', styles: { width: /.+/ } },
            model: { key: 'width', value: (e) => e.getStyle('width') },
          });
        }
      }
      var TP =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M7 10H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm0 1.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h5z"/></svg>';
      var CP =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M10 8H2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm0 1.5a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 .5-.5h8z"/></svg>';
      var PP =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M13 6H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm0 1.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V8a.5.5 0 0 1 .5-.5h11z"/></svg>';
      var EP =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M18.095 2H1.905C.853 2 0 2.895 0 4v12c0 1.105.853 2 1.905 2h16.19C19.147 18 20 17.105 20 16V4c0-1.105-.853-2-1.905-2zm0 1.5c.263 0 .476.224.476.5v12c0 .276-.213.5-.476.5H1.905a.489.489 0 0 1-.476-.5V4c0-.276.213-.5.476-.5h16.19z"/></svg>';
      const SP = { small: TP, medium: CP, large: PP, original: EP };
      class MP extends ok {
        static get requires() {
          return [AP];
        }
        static get pluginName() {
          return 'ImageResizeButtons';
        }
        constructor(e) {
          super(e);
          this._resizeUnit = e.config.get('image.resizeUnit');
        }
        init() {
          const e = this.editor;
          const t = e.config.get('image.resizeOptions');
          const i = e.commands.get('imageResize');
          this.bind('isEnabled').to(i);
          for (const e of t) {
            this._registerImageResizeButton(e);
          }
          this._registerImageResizeDropdown(t);
        }
        _registerImageResizeButton(e) {
          const t = this.editor;
          const { name: i, value: n, icon: o } = e;
          const r = n ? n + this._resizeUnit : null;
          t.ui.componentFactory.add(i, (n) => {
            const s = new Ew(n);
            const a = t.commands.get('imageResize');
            const c = this._getOptionLabelValue(e, true);
            if (!SP[o]) {
              throw new ss['b'](
                'imageresizebuttons-missing-icon: ' +
                  'The resize option "' +
                  i +
                  '" misses the "icon" property ' +
                  "or the property value doesn't match any of the available icons.",
                t,
                e
              );
            }
            s.set({ label: c, icon: SP[o], tooltip: c, isToggleable: true });
            s.bind('isEnabled').to(this);
            s.bind('isOn').to(a, 'value', IP(r));
            this.listenTo(s, 'execute', () => {
              t.execute('imageResize', { width: r });
            });
            return s;
          });
        }
        _registerImageResizeDropdown(e) {
          const t = this.editor;
          const i = t.t;
          const n = e.find((e) => !e.value);
          t.ui.componentFactory.add('imageResize', (o) => {
            const r = t.commands.get('imageResize');
            const s = Bw(o, Mw);
            const a = s.buttonView;
            a.set({
              tooltip: i('Resize image'),
              commandValue: n.value,
              icon: CP,
              isToggleable: true,
              label: this._getOptionLabelValue(n),
              withText: true,
              class: 'ck-resize-image-button',
            });
            a.bind('label').to(r, 'value', (e) => {
              if (e && e.width) {
                return e.width;
              } else {
                return this._getOptionLabelValue(n);
              }
            });
            s.bind('isOn').to(r);
            s.bind('isEnabled').to(this);
            Hw(s, this._getResizeDropdownListItemDefinitions(e, r));
            s.listView.ariaLabel = i('Image resize list');
            this.listenTo(s, 'execute', (e) => {
              t.execute(e.source.commandName, { width: e.source.commandValue });
              t.editing.view.focus();
            });
            return s;
          });
        }
        _getOptionLabelValue(e, t) {
          const i = this.editor.t;
          if (e.label) {
            return e.label;
          } else if (t) {
            if (e.value) {
              return i('Resize image to %0', e.value + this._resizeUnit);
            } else {
              return i('Resize image to the original size');
            }
          } else {
            if (e.value) {
              return e.value + this._resizeUnit;
            } else {
              return i('Original');
            }
          }
        }
        _getResizeDropdownListItemDefinitions(e, t) {
          const i = new xs();
          e.map((e) => {
            const n = e.value ? e.value + this._resizeUnit : null;
            const o = {
              type: 'button',
              model: new MT({
                commandName: 'imageResize',
                commandValue: n,
                label: this._getOptionLabelValue(e),
                withText: true,
                icon: null,
              }),
            };
            o.model.bind('isOn').to(t, 'value', IP(n));
            i.add(o);
          });
          return i;
        }
      }
      function IP(e) {
        return (t) => {
          if (e === null && t === e) {
            return true;
          }
          return t && t.width === e;
        };
      }
      class NP {
        constructor(e) {
          this.set('activeHandlePosition', null);
          this.set('proposedWidthPercents', null);
          this.set('proposedWidth', null);
          this.set('proposedHeight', null);
          this.set('proposedHandleHostWidth', null);
          this.set('proposedHandleHostHeight', null);
          this._options = e;
          this._referenceCoordinates = null;
        }
        begin(e, t, i) {
          const n = new Ch(t);
          this.activeHandlePosition = LP(e);
          this._referenceCoordinates = zP(t, VP(this.activeHandlePosition));
          this.originalWidth = n.width;
          this.originalHeight = n.height;
          this.aspectRatio = n.width / n.height;
          const o = i.style.width;
          if (o && o.match(/^\d+\.?\d*%$/)) {
            this.originalWidthPercents = parseFloat(o);
          } else {
            this.originalWidthPercents = OP(i, n);
          }
        }
        update(e) {
          this.proposedWidth = e.width;
          this.proposedHeight = e.height;
          this.proposedWidthPercents = e.widthPercents;
          this.proposedHandleHostWidth = e.handleHostWidth;
          this.proposedHandleHostHeight = e.handleHostHeight;
        }
      }
      ys(NP, Qc);
      function OP(e, t) {
        const i = e.parentElement;
        const n = parseFloat(
          i.ownerDocument.defaultView.getComputedStyle(i).width
        );
        return (t.width / n) * 100;
      }
      function zP(e, t) {
        const i = new Ch(e);
        const n = t.split('-');
        const o = {
          x: n[1] == 'right' ? i.right : i.left,
          y: n[0] == 'bottom' ? i.bottom : i.top,
        };
        o.x += e.ownerDocument.defaultView.scrollX;
        o.y += e.ownerDocument.defaultView.scrollY;
        return o;
      }
      function RP(e) {
        return `ck-widget__resizer__handle-${e}`;
      }
      function LP(e) {
        const t = ['top-left', 'top-right', 'bottom-right', 'bottom-left'];
        for (const i of t) {
          if (e.classList.contains(RP(i))) {
            return i;
          }
        }
      }
      function VP(e) {
        const t = e.split('-');
        const i = {
          top: 'bottom',
          bottom: 'top',
          left: 'right',
          right: 'left',
        };
        return `${i[t[0]]}-${i[t[1]]}`;
      }
      class DP {
        constructor(e) {
          this._options = e;
          this._domResizerWrapper = null;
          this._viewResizerWrapper = null;
          this.set('isEnabled', true);
          this.decorate('begin');
          this.decorate('cancel');
          this.decorate('commit');
          this.decorate('updateSize');
          this.on(
            'commit',
            (e) => {
              if (
                !this.state.proposedWidth &&
                !this.state.proposedWidthPercents
              ) {
                this._cleanup();
                e.stop();
              }
            },
            { priority: 'high' }
          );
          this.on('change:isEnabled', () => {
            if (this.isEnabled) {
              this.redraw();
            }
          });
        }
        attach() {
          const e = this;
          const t = this._options.viewElement;
          const i = this._options.editor.editing.view;
          i.change((i) => {
            const n = i.createUIElement(
              'div',
              { class: 'ck ck-reset_all ck-widget__resizer' },
              function (t) {
                const i = this.toDomElement(t);
                e._appendHandles(i);
                e._appendSizeUI(i);
                e._domResizerWrapper = i;
                e.on('change:isEnabled', (e, t, n) => {
                  i.style.display = n ? '' : 'none';
                });
                i.style.display = e.isEnabled ? '' : 'none';
                return i;
              }
            );
            i.insert(i.createPositionAt(t, 'end'), n);
            i.addClass('ck-widget_with-resizer', t);
            this._viewResizerWrapper = n;
          });
        }
        begin(e) {
          this.state = new NP(this._options);
          this._sizeUI.bindToState(this._options, this.state);
          this._initialViewWidth = this._options.viewElement.getStyle('width');
          this.state.begin(e, this._getHandleHost(), this._getResizeHost());
        }
        updateSize(e) {
          const t = this._proposeNewSize(e);
          const i = this._options.editor.editing.view;
          i.change((e) => {
            const i = this._options.unit || '%';
            const n = (i === '%' ? t.widthPercents : t.width) + i;
            e.setStyle('width', n, this._options.viewElement);
          });
          const n = this._getHandleHost();
          const o = new Ch(n);
          t.handleHostWidth = Math.round(o.width);
          t.handleHostHeight = Math.round(o.height);
          const r = new Ch(n);
          t.width = Math.round(r.width);
          t.height = Math.round(r.height);
          this.redraw(o);
          this.state.update(t);
        }
        commit() {
          const e = this._options.unit || '%';
          const t =
            (e === '%'
              ? this.state.proposedWidthPercents
              : this.state.proposedWidth) + e;
          this._options.editor.editing.view.change(() => {
            this._cleanup();
            this._options.onCommit(t);
          });
        }
        cancel() {
          this._cleanup();
        }
        destroy() {
          this.cancel();
        }
        redraw(e) {
          const t = this._domResizerWrapper;
          if (!HP(t)) {
            return;
          }
          const i = t.parentElement;
          const n = this._getHandleHost();
          const o = this._viewResizerWrapper;
          const r = [
            o.getStyle('width'),
            o.getStyle('height'),
            o.getStyle('left'),
            o.getStyle('top'),
          ];
          let s;
          if (i.isSameNode(n)) {
            const t = e || new Ch(n);
            s = [t.width + 'px', t.height + 'px', undefined, undefined];
          } else {
            s = [
              n.offsetWidth + 'px',
              n.offsetHeight + 'px',
              n.offsetLeft + 'px',
              n.offsetTop + 'px',
            ];
          }
          if (Rs(r, s) !== 'same') {
            this._options.editor.editing.view.change((e) => {
              e.setStyle(
                { width: s[0], height: s[1], left: s[2], top: s[3] },
                o
              );
            });
          }
        }
        containsHandle(e) {
          return this._domResizerWrapper.contains(e);
        }
        static isResizeHandle(e) {
          return e.classList.contains('ck-widget__resizer__handle');
        }
        _cleanup() {
          this._sizeUI.dismiss();
          this._sizeUI.isVisible = false;
          const e = this._options.editor.editing.view;
          e.change((e) => {
            e.setStyle(
              'width',
              this._initialViewWidth,
              this._options.viewElement
            );
          });
        }
        _proposeNewSize(e) {
          const t = this.state;
          const i = FP(e);
          const n = this._options.isCentered
            ? this._options.isCentered(this)
            : true;
          const o = {
            x: t._referenceCoordinates.x - (i.x + t.originalWidth),
            y: i.y - t.originalHeight - t._referenceCoordinates.y,
          };
          if (n && t.activeHandlePosition.endsWith('-right')) {
            o.x = i.x - (t._referenceCoordinates.x + t.originalWidth);
          }
          if (n) {
            o.x *= 2;
          }
          const r = {
            width: Math.abs(t.originalWidth + o.x),
            height: Math.abs(t.originalHeight + o.y),
          };
          r.dominant = r.width / t.aspectRatio > r.height ? 'width' : 'height';
          r.max = r[r.dominant];
          const s = { width: r.width, height: r.height };
          if (r.dominant == 'width') {
            s.height = s.width / t.aspectRatio;
          } else {
            s.width = s.height * t.aspectRatio;
          }
          return {
            width: Math.round(s.width),
            height: Math.round(s.height),
            widthPercents: Math.min(
              Math.round(
                (t.originalWidthPercents / t.originalWidth) * s.width * 100
              ) / 100,
              100
            ),
          };
        }
        _getResizeHost() {
          const e = this._domResizerWrapper.parentElement;
          return this._options.getResizeHost(e);
        }
        _getHandleHost() {
          const e = this._domResizerWrapper.parentElement;
          return this._options.getHandleHost(e);
        }
        _appendHandles(e) {
          const t = ['top-left', 'top-right', 'bottom-right', 'bottom-left'];
          for (const i of t) {
            e.appendChild(
              new mb({
                tag: 'div',
                attributes: { class: `ck-widget__resizer__handle ${BP(i)}` },
              }).render()
            );
          }
        }
        _appendSizeUI(e) {
          const t = new jP();
          t.render();
          this._sizeUI = t;
          e.appendChild(t.element);
        }
      }
      ys(DP, Qc);
      class jP extends Hb {
        constructor() {
          super();
          const e = this.bindTemplate;
          this.setTemplate({
            tag: 'div',
            attributes: {
              class: [
                'ck',
                'ck-size-view',
                e.to('activeHandlePosition', (e) =>
                  e ? `ck-orientation-${e}` : ''
                ),
              ],
              style: { display: e.if('isVisible', 'none', (e) => !e) },
            },
            children: [{ text: e.to('label') }],
          });
        }
        bindToState(e, t) {
          this.bind('isVisible').to(
            t,
            'proposedWidth',
            t,
            'proposedHeight',
            (e, t) => e !== null && t !== null
          );
          this.bind('label').to(
            t,
            'proposedHandleHostWidth',
            t,
            'proposedHandleHostHeight',
            t,
            'proposedWidthPercents',
            (t, i, n) => {
              if (e.unit === 'px') {
                return `${t}×${i}`;
              } else {
                return `${n}%`;
              }
            }
          );
          this.bind('activeHandlePosition').to(t);
        }
        dismiss() {
          this.unbind();
          this.isVisible = false;
        }
      }
      function BP(e) {
        return `ck-widget__resizer__handle-${e}`;
      }
      function FP(e) {
        return { x: e.pageX, y: e.pageY };
      }
      function HP(e) {
        return e && e.ownerDocument && e.ownerDocument.contains(e);
      }
      var UP = 'Expected a function';
      function qP(e, t, i) {
        var n = true,
          o = true;
        if (typeof e != 'function') {
          throw new TypeError(UP);
        }
        if (ce(i)) {
          n = 'leading' in i ? !!i.leading : n;
          o = 'trailing' in i ? !!i.trailing : o;
        }
        return ph(e, t, { leading: n, maxWait: t, trailing: o });
      }
      var WP = qP;
      var $P = i(82);
      class GP extends ok {
        static get pluginName() {
          return 'WidgetResize';
        }
        init() {
          this.set('_visibleResizer', null);
          this.set('_activeResizer', null);
          this._resizers = new Map();
          const e = Vd.window.document;
          this.editor.model.schema.setAttributeProperties('width', {
            isFormatting: true,
          });
          this.editor.editing.view.addObserver(ov);
          this._observer = Object.create(Kd);
          this.listenTo(
            this.editor.editing.view.document,
            'mousedown',
            this._mouseDownListener.bind(this),
            { priority: 'high' }
          );
          this._observer.listenTo(
            e,
            'mousemove',
            this._mouseMoveListener.bind(this)
          );
          this._observer.listenTo(
            e,
            'mouseup',
            this._mouseUpListener.bind(this)
          );
          const t = () => {
            if (this._visibleResizer) {
              this._visibleResizer.redraw();
            }
          };
          const i = WP(t, 200);
          this.on('change:_visibleResizer', t);
          this.editor.ui.on('update', i);
          this._observer.listenTo(Vd.window, 'resize', i);
          const n = this.editor.editing.view.document.selection;
          n.on('change', () => {
            const e = n.getSelectedElement();
            this._visibleResizer = this._getResizerByViewElement(e) || null;
          });
        }
        destroy() {
          this._observer.stopListening();
          for (const e of this._resizers.values()) {
            e.destroy();
          }
        }
        attachTo(e) {
          const t = new DP(e);
          const i = this.editor.plugins;
          t.attach();
          if (i.has('WidgetToolbarRepository')) {
            const e = i.get('WidgetToolbarRepository');
            t.on(
              'begin',
              () => {
                e.forceDisabled('resize');
              },
              { priority: 'lowest' }
            );
            t.on(
              'cancel',
              () => {
                e.clearForceDisabled('resize');
              },
              { priority: 'highest' }
            );
            t.on(
              'commit',
              () => {
                e.clearForceDisabled('resize');
              },
              { priority: 'highest' }
            );
          }
          this._resizers.set(e.viewElement, t);
          return t;
        }
        _getResizerByHandle(e) {
          for (const t of this._resizers.values()) {
            if (t.containsHandle(e)) {
              return t;
            }
          }
        }
        _getResizerByViewElement(e) {
          return this._resizers.get(e);
        }
        _mouseDownListener(e, t) {
          const i = t.domTarget;
          if (!DP.isResizeHandle(i)) {
            return;
          }
          this._activeResizer = this._getResizerByHandle(i);
          if (this._activeResizer) {
            this._activeResizer.begin(i);
            e.stop();
            t.preventDefault();
          }
        }
        _mouseMoveListener(e, t) {
          if (this._activeResizer) {
            this._activeResizer.updateSize(t);
          }
        }
        _mouseUpListener() {
          if (this._activeResizer) {
            this._activeResizer.commit();
            this._activeResizer = null;
          }
        }
      }
      ys(GP, Qc);
      class YP extends ok {
        static get requires() {
          return [GP];
        }
        static get pluginName() {
          return 'ImageResizeHandles';
        }
        init() {
          const e = this.editor;
          const t = e.commands.get('imageResize');
          this.bind('isEnabled').to(t);
          e.editing.downcastDispatcher.on(
            'insert:image',
            (t, i, n) => {
              const o = n.mapper.toViewElement(i.item);
              const r = e.plugins.get(GP).attachTo({
                unit: e.config.get('image.resizeUnit'),
                modelElement: i.item,
                viewElement: o,
                editor: e,
                getHandleHost(e) {
                  return e.querySelector('img');
                },
                getResizeHost(e) {
                  return e;
                },
                isCentered() {
                  const e = i.item.getAttribute('imageStyle');
                  return !e || e == 'full' || e == 'alignCenter';
                },
                onCommit(t) {
                  e.execute('imageResize', { width: t });
                },
              });
              r.on('updateSize', () => {
                if (!o.hasClass('image_resized')) {
                  e.editing.view.change((e) => {
                    e.addClass('image_resized', o);
                  });
                }
              });
              r.bind('isEnabled').to(this);
            },
            { priority: 'low' }
          );
        }
      }
      var KP = i(84);
      class QP extends ok {
        static get requires() {
          return [AP, YP, MP];
        }
        static get pluginName() {
          return 'ImageResize';
        }
      }
      class JP extends sk {
        constructor(e, t) {
          super(e);
          this.defaultStyle = false;
          this.styles = t.reduce((e, t) => {
            e[t.name] = t;
            if (t.isDefault) {
              this.defaultStyle = t.name;
            }
            return e;
          }, {});
        }
        refresh() {
          const e = this.editor.model.document.selection.getSelectedElement();
          this.isEnabled = q_(e);
          if (!e) {
            this.value = false;
          } else if (e.hasAttribute('imageStyle')) {
            const t = e.getAttribute('imageStyle');
            this.value = this.styles[t] ? t : false;
          } else {
            this.value = this.defaultStyle;
          }
        }
        execute(e) {
          const t = e.value;
          const i = this.editor.model;
          const n = i.document.selection.getSelectedElement();
          i.change((e) => {
            if (this.styles[t].isDefault) {
              e.removeAttribute('imageStyle', n);
            } else {
              e.setAttribute('imageStyle', t, n);
            }
          });
        }
      }
      function ZP(e) {
        return (t, i, n) => {
          if (!n.consumable.consume(i.item, t.name)) {
            return;
          }
          const o = eE(i.attributeNewValue, e);
          const r = eE(i.attributeOldValue, e);
          const s = n.mapper.toViewElement(i.item);
          const a = n.writer;
          if (r) {
            a.removeClass(r.className, s);
          }
          if (o) {
            a.addClass(o.className, s);
          }
        };
      }
      function XP(e) {
        const t = e.filter((e) => !e.isDefault);
        return (e, i, n) => {
          if (!i.modelRange) {
            return;
          }
          const o = i.viewItem;
          const r = ck(i.modelRange.getItems());
          if (!n.schema.checkAttribute(r, 'imageStyle')) {
            return;
          }
          for (const e of t) {
            if (n.consumable.consume(o, { classes: e.className })) {
              n.writer.setAttribute('imageStyle', e.name, r);
            }
          }
        };
      }
      function eE(e, t) {
        for (const i of t) {
          if (i.name === e) {
            return i;
          }
        }
      }
      var tE =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 4.5V3h16v1.5zm2.5 3V12h11V7.5h-11zM4.061 6H15.94c.586 0 1.061.407 1.061.91v5.68c0 .503-.475.91-1.061.91H4.06c-.585 0-1.06-.407-1.06-.91V6.91C3 6.406 3.475 6 4.061 6zM2 16.5V15h16v1.5z"/></svg>';
      var iE =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" clip-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="1.414"><path d="M18 4.5V3H2v1.5h16zm0 3V6h-5.674v1.5H18zm0 3V9h-5.674v1.5H18zm0 3V12h-5.674v1.5H18zm-8.5-6V12h-6V7.5h6zm.818-1.5H2.682C2.305 6 2 6.407 2 6.91v5.68c0 .503.305.91.682.91h7.636c.377 0 .682-.407.682-.91V6.91c0-.503-.305-.91-.682-.91zM18 16.5V15H2v1.5h16z"/></svg>';
      var nE =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 4.5V3h16v1.5zm4.5 3V12h7V7.5h-7zM5.758 6h8.484c.419 0 .758.407.758.91v5.681c0 .502-.34.909-.758.909H5.758c-.419 0-.758-.407-.758-.91V6.91c0-.503.34-.91.758-.91zM2 16.5V15h16v1.5z"/></svg>';
      var oE =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 4.5V3h16v1.5zm0 3V6h5.674v1.5zm0 3V9h5.674v1.5zm0 3V12h5.674v1.5zm8.5-6V12h6V7.5h-6zM9.682 6h7.636c.377 0 .682.407.682.91v5.68c0 .503-.305.91-.682.91H9.682c-.377 0-.682-.407-.682-.91V6.91c0-.503.305-.91.682-.91zM2 16.5V15h16v1.5z"/></svg>';
      const rE = {
        full: {
          name: 'full',
          title: 'Full size image',
          icon: tE,
          isDefault: true,
        },
        side: {
          name: 'side',
          title: 'Side image',
          icon: oE,
          className: 'image-style-side',
        },
        alignLeft: {
          name: 'alignLeft',
          title: 'Left aligned image',
          icon: iE,
          className: 'image-style-align-left',
        },
        alignCenter: {
          name: 'alignCenter',
          title: 'Centered image',
          icon: nE,
          className: 'image-style-align-center',
        },
        alignRight: {
          name: 'alignRight',
          title: 'Right aligned image',
          icon: oE,
          className: 'image-style-align-right',
        },
      };
      const sE = { full: tE, left: iE, right: oE, center: nE };
      function aE(e = []) {
        return e.map(cE);
      }
      function cE(e) {
        if (typeof e == 'string') {
          const t = e;
          if (rE[t]) {
            e = Object.assign({}, rE[t]);
          } else {
            console.warn(
              Object(ss['a'])(
                'image-style-not-found: There is no such image style of given name.'
              ),
              { name: t }
            );
            e = { name: t };
          }
        } else if (rE[e.name]) {
          const t = rE[e.name];
          const i = Object.assign({}, e);
          for (const n in t) {
            if (!Object.prototype.hasOwnProperty.call(e, n)) {
              i[n] = t[n];
            }
          }
          e = i;
        }
        if (typeof e.icon == 'string' && sE[e.icon]) {
          e.icon = sE[e.icon];
        }
        return e;
      }
      class lE extends ok {
        static get pluginName() {
          return 'ImageStyleEditing';
        }
        init() {
          const e = this.editor;
          const t = e.model.schema;
          const i = e.data;
          const n = e.editing;
          e.config.define('image.styles', ['full', 'side']);
          const o = aE(e.config.get('image.styles'));
          t.extend('image', { allowAttributes: 'imageStyle' });
          const r = ZP(o);
          n.downcastDispatcher.on('attribute:imageStyle:image', r);
          i.downcastDispatcher.on('attribute:imageStyle:image', r);
          i.upcastDispatcher.on('element:figure', XP(o), { priority: 'low' });
          e.commands.add('imageStyle', new JP(e, o));
        }
      }
      var dE = i(86);
      class uE extends ok {
        static get pluginName() {
          return 'ImageStyleUI';
        }
        get localizedDefaultStylesTitles() {
          const e = this.editor.t;
          return {
            'Full size image': e('Full size image'),
            'Side image': e('Side image'),
            'Left aligned image': e('Left aligned image'),
            'Centered image': e('Centered image'),
            'Right aligned image': e('Right aligned image'),
          };
        }
        init() {
          const e = this.editor;
          const t = e.config.get('image.styles');
          const i = hE(aE(t), this.localizedDefaultStylesTitles);
          for (const e of i) {
            this._createButton(e);
          }
        }
        _createButton(e) {
          const t = this.editor;
          const i = `imageStyle:${e.name}`;
          t.ui.componentFactory.add(i, (i) => {
            const n = t.commands.get('imageStyle');
            const o = new Ew(i);
            o.set({
              label: e.title,
              icon: e.icon,
              tooltip: true,
              isToggleable: true,
            });
            o.bind('isEnabled').to(n, 'isEnabled');
            o.bind('isOn').to(n, 'value', (t) => t === e.name);
            this.listenTo(o, 'execute', () => {
              t.execute('imageStyle', { value: e.name });
              t.editing.view.focus();
            });
            return o;
          });
        }
      }
      function hE(e, t) {
        for (const i of e) {
          if (t[i.title]) {
            i.title = t[i.title];
          }
        }
        return e;
      }
      class fE extends ok {
        static get requires() {
          return [lE, uE];
        }
        static get pluginName() {
          return 'ImageStyle';
        }
      }
      class gE extends ok {
        static get requires() {
          return [tP];
        }
        static get pluginName() {
          return 'WidgetToolbarRepository';
        }
        init() {
          const e = this.editor;
          if (e.plugins.has('BalloonToolbar')) {
            const t = e.plugins.get('BalloonToolbar');
            this.listenTo(
              t,
              'show',
              (t) => {
                if (bE(e.editing.view.document.selection)) {
                  t.stop();
                }
              },
              { priority: 'high' }
            );
          }
          this._toolbarDefinitions = new Map();
          this._balloon = this.editor.plugins.get('ContextualBalloon');
          this.on('change:isEnabled', () => {
            this._updateToolbarsVisibility();
          });
          this.listenTo(e.ui, 'update', () => {
            this._updateToolbarsVisibility();
          });
          this.listenTo(
            e.ui.focusTracker,
            'change:isFocused',
            () => {
              this._updateToolbarsVisibility();
            },
            { priority: 'low' }
          );
        }
        destroy() {
          super.destroy();
          for (const e of this._toolbarDefinitions.values()) {
            e.view.destroy();
          }
        }
        register(
          e,
          {
            ariaLabel: t,
            items: i,
            getRelatedElement: n,
            balloonClassName: o = 'ck-toolbar-container',
          }
        ) {
          if (!i.length) {
            console.warn(
              Object(ss['a'])(
                'widget-toolbar-no-items: Trying to register a toolbar without items.'
              ),
              { toolbarId: e }
            );
            return;
          }
          const r = this.editor;
          const s = r.t;
          const a = new Kw(r.locale);
          a.ariaLabel = t || s('Widget toolbar');
          if (this._toolbarDefinitions.has(e)) {
            throw new ss['b'](
              'widget-toolbar-duplicated: Toolbar with the given id was already added.',
              this,
              { toolbarId: e }
            );
          }
          a.fillFromConfig(i, r.ui.componentFactory);
          this._toolbarDefinitions.set(e, {
            view: a,
            getRelatedElement: n,
            balloonClassName: o,
          });
        }
        _updateToolbarsVisibility() {
          let e = 0;
          let t = null;
          let i = null;
          for (const n of this._toolbarDefinitions.values()) {
            const o = n.getRelatedElement(
              this.editor.editing.view.document.selection
            );
            if (!this.isEnabled || !o) {
              if (this._isToolbarInBalloon(n)) {
                this._hideToolbar(n);
              }
            } else if (!this.editor.ui.focusTracker.isFocused) {
              if (this._isToolbarVisible(n)) {
                this._hideToolbar(n);
              }
            } else {
              const r = o.getAncestors().length;
              if (r > e) {
                e = r;
                t = o;
                i = n;
              }
            }
          }
          if (i) {
            this._showToolbar(i, t);
          }
        }
        _hideToolbar(e) {
          this._balloon.remove(e.view);
          this.stopListening(this._balloon, 'change:visibleView');
        }
        _showToolbar(e, t) {
          if (this._isToolbarVisible(e)) {
            mE(this.editor, t);
          } else if (!this._isToolbarInBalloon(e)) {
            this._balloon.add({
              view: e.view,
              position: pE(this.editor, t),
              balloonClassName: e.balloonClassName,
            });
            this.listenTo(this._balloon, 'change:visibleView', () => {
              for (const e of this._toolbarDefinitions.values()) {
                if (this._isToolbarVisible(e)) {
                  const t = e.getRelatedElement(
                    this.editor.editing.view.document.selection
                  );
                  mE(this.editor, t);
                }
              }
            });
          }
        }
        _isToolbarVisible(e) {
          return this._balloon.visibleView === e.view;
        }
        _isToolbarInBalloon(e) {
          return this._balloon.hasView(e.view);
        }
      }
      function mE(e, t) {
        const i = e.plugins.get('ContextualBalloon');
        const n = pE(e, t);
        i.updatePosition(n);
      }
      function pE(e, t) {
        const i = e.editing.view;
        const n = b_.defaultPositions;
        return {
          target: i.domConverter.mapViewToDom(t),
          positions: [
            n.northArrowSouth,
            n.northArrowSouthWest,
            n.northArrowSouthEast,
            n.southArrowNorth,
            n.southArrowNorthWest,
            n.southArrowNorthEast,
            D_,
          ],
        };
      }
      function bE(e) {
        const t = e.getSelectedElement();
        return !!(t && M_(t));
      }
      class wE extends ok {
        static get requires() {
          return [gE];
        }
        static get pluginName() {
          return 'ImageToolbar';
        }
        afterInit() {
          const e = this.editor;
          const t = e.t;
          const i = e.plugins.get(gE);
          i.register('image', {
            ariaLabel: t('Image toolbar'),
            items: e.config.get('image.toolbar') || [],
            getRelatedElement: U_,
          });
        }
      }
      var kE = i(88);
      class _E extends Hb {
        constructor(e, t = {}) {
          super(e);
          const i = this.bindTemplate;
          this.set('class', t.class || null);
          this.children = this.createCollection();
          if (t.children) {
            t.children.forEach((e) => this.children.add(e));
          }
          this.set('_role', null);
          this.set('_ariaLabelledBy', null);
          if (t.labelView) {
            this.set({ _role: 'group', _ariaLabelledBy: t.labelView.id });
          }
          this.setTemplate({
            tag: 'div',
            attributes: {
              class: ['ck', 'ck-form__row', i.to('class')],
              role: i.to('_role'),
              'aria-labelledby': i.to('_ariaLabelledBy'),
            },
            children: this.children,
          });
        }
      }
      var vE =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.91 10.54c.26-.23.64-.21.88.03l3.36 3.14 2.23-2.06a.64.64 0 0 1 .87 0l2.52 2.97V4.5H3.2v10.12l3.71-4.08zm10.27-7.51c.6 0 1.09.47 1.09 1.05v11.84c0 .59-.49 1.06-1.09 1.06H2.79c-.6 0-1.09-.47-1.09-1.06V4.08c0-.58.49-1.05 1.1-1.05h14.38zm-5.22 5.56a1.96 1.96 0 1 1 3.4-1.96 1.96 1.96 0 0 1-3.4 1.96z"/></svg>';
      var yE = i(90);
      class xE extends Hb {
        constructor(e, t) {
          super(e);
          const { insertButtonView: i, cancelButtonView: n } =
            this._createActionButtons(e);
          this.insertButtonView = i;
          this.cancelButtonView = n;
          this.dropdownView = this._createDropdownView(e);
          this.set('imageURLInputValue', '');
          this.focusTracker = new Qp();
          this.keystrokes = new Vp();
          this._focusables = new hb();
          this._focusCycler = new rw({
            focusables: this._focusables,
            focusTracker: this.focusTracker,
            keystrokeHandler: this.keystrokes,
            actions: { focusPrevious: 'shift + tab', focusNext: 'tab' },
          });
          this.set('_integrations', new xs());
          if (t) {
            for (const [e, i] of Object.entries(t)) {
              if (e === 'insertImageViaUrl') {
                i.fieldView
                  .bind('value')
                  .to(this, 'imageURLInputValue', (e) => e || '');
                i.fieldView.on('input', () => {
                  this.imageURLInputValue = i.fieldView.element.value;
                });
              }
              this._integrations.add(i);
            }
          }
          this.setTemplate({
            tag: 'form',
            attributes: {
              class: ['ck', 'ck-image-upload-form'],
              tabindex: '-1',
            },
            children: [
              ...this._integrations,
              new _E(e, {
                children: [this.insertButtonView, this.cancelButtonView],
                class: 'ck-image-upload-form__action-row',
              }),
            ],
          });
        }
        render() {
          super.render();
          WC({ view: this });
          const e = [
            ...this._integrations,
            this.insertButtonView,
            this.cancelButtonView,
          ];
          e.forEach((e) => {
            this._focusables.add(e);
            this.focusTracker.add(e.element);
          });
          this.keystrokes.listenTo(this.element);
          const t = (e) => e.stopPropagation();
          this.keystrokes.set('arrowright', t);
          this.keystrokes.set('arrowleft', t);
          this.keystrokes.set('arrowup', t);
          this.keystrokes.set('arrowdown', t);
          this.listenTo(
            e[0].element,
            'selectstart',
            (e, t) => {
              t.stopPropagation();
            },
            { priority: 'high' }
          );
        }
        _createDropdownView(e) {
          const t = e.t;
          const i = Bw(e, eC);
          const n = i.buttonView;
          const o = i.panelView;
          n.set({ label: t('Insert image'), icon: vE, tooltip: true });
          o.extendTemplate({ attributes: { class: 'ck-image-upload__panel' } });
          return i;
        }
        _createActionButtons(e) {
          const t = e.t;
          const i = new Ew(e);
          const n = new Ew(e);
          i.set({
            label: t('Insert'),
            icon: $C,
            class: 'ck-button-save',
            type: 'submit',
            withText: true,
            isEnabled: this.imageURLInputValue,
          });
          n.set({
            label: t('Cancel'),
            icon: GC,
            class: 'ck-button-cancel',
            withText: true,
          });
          i.bind('isEnabled').to(this, 'imageURLInputValue');
          i.delegate('execute').to(this, 'submit');
          n.delegate('execute').to(this, 'cancel');
          return { insertButtonView: i, cancelButtonView: n };
        }
        focus() {
          this._focusCycler.focusFirst();
        }
      }
      class AE extends Hb {
        constructor(e) {
          super(e);
          this.buttonView = new Ew(e);
          this._fileInputView = new TE(e);
          this._fileInputView.bind('acceptedType').to(this);
          this._fileInputView.bind('allowMultipleFiles').to(this);
          this._fileInputView.delegate('done').to(this);
          this.setTemplate({
            tag: 'span',
            attributes: { class: 'ck-file-dialog-button' },
            children: [this.buttonView, this._fileInputView],
          });
          this.buttonView.on('execute', () => {
            this._fileInputView.open();
          });
        }
        focus() {
          this.buttonView.focus();
        }
      }
      class TE extends Hb {
        constructor(e) {
          super(e);
          this.set('acceptedType');
          this.set('allowMultipleFiles', false);
          const t = this.bindTemplate;
          this.setTemplate({
            tag: 'input',
            attributes: {
              class: ['ck-hidden'],
              type: 'file',
              tabindex: '-1',
              accept: t.to('acceptedType'),
              multiple: t.to('allowMultipleFiles'),
            },
            on: {
              change: t.to(() => {
                if (
                  this.element &&
                  this.element.files &&
                  this.element.files.length
                ) {
                  this.fire('done', this.element.files);
                }
                this.element.value = '';
              }),
            },
          });
        }
        open() {
          this.element.click();
        }
      }
      function CE(e) {
        const t = e.map((e) => e.replace('+', '\\+'));
        return new RegExp(`^image\\/(${t.join('|')})$`);
      }
      function PE(e) {
        return new Promise((t, i) => {
          const n = e.getAttribute('src');
          fetch(n)
            .then((e) => e.blob())
            .then((e) => {
              const i = SE(e, n);
              const o = i.replace('image/', '');
              const r = `image.${o}`;
              const s = new File([e], r, { type: i });
              t(s);
            })
            .catch(i);
        });
      }
      function EE(e) {
        if (!e.is('element', 'img') || !e.getAttribute('src')) {
          return false;
        }
        return (
          e.getAttribute('src').match(/^data:image\/\w+;base64,/g) ||
          e.getAttribute('src').match(/^blob:/g)
        );
      }
      function SE(e, t) {
        if (e.type) {
          return e.type;
        } else if (t.match(/data:(image\/\w+);base64/)) {
          return t.match(/data:(image\/\w+);base64/)[1].toLowerCase();
        } else {
          return 'image/jpeg';
        }
      }
      function ME(e) {
        const t = e.config.get('image.upload.panel.items');
        const i = e.plugins.get('ImageUploadUI');
        const n = { insertImageViaUrl: IE(e.locale) };
        if (!t) {
          return n;
        }
        if (
          t.find((e) => e === 'openCKFinder') &&
          e.ui.componentFactory.has('ckfinder')
        ) {
          const t = e.ui.componentFactory.create('ckfinder');
          t.set({ withText: true, class: 'ck-image-upload__ck-finder-button' });
          t.delegate('execute').to(i, 'cancel');
          n.openCKFinder = t;
        }
        return t.reduce((t, i) => {
          if (n[i]) {
            t[i] = n[i];
          } else if (e.ui.componentFactory.has(i)) {
            t[i] = e.ui.componentFactory.create(i);
          }
          return t;
        }, {});
      }
      function IE(e) {
        const t = e.t;
        const i = new BC(e, UC);
        i.set({ label: t('Insert image via URL') });
        i.fieldView.placeholder = 'https://example.com/src/image.png';
        i.infoText = t('Paste the image source URL.');
        return i;
      }
      class NE extends ok {
        static get pluginName() {
          return 'ImageUploadUI';
        }
        init() {
          const e = this.editor;
          const t = !!e.config.get('image.upload.panel.items');
          e.ui.componentFactory.add('imageUpload', (e) => {
            if (t) {
              return this._createDropdownView(e);
            } else {
              return this._createFileDialogButtonView(e);
            }
          });
        }
        _setUpDropdown(e, t, i) {
          const n = this.editor;
          const o = n.t;
          const r = t.insertButtonView;
          e.bind('isEnabled').to(i);
          e.on('change:isOpen', () => {
            const i = n.model.document.selection.getSelectedElement();
            if (e.isOpen) {
              t.focus();
              if (q_(i)) {
                t.imageURLInputValue = i.getAttribute('src');
                r.label = o('Update');
              } else {
                t.imageURLInputValue = '';
                r.label = o('Insert');
              }
            }
          });
          t.delegate('submit', 'cancel').to(e);
          this.delegate('cancel').to(e);
          e.on('submit', () => {
            a();
            s();
          });
          e.on('cancel', () => {
            a();
          });
          function s() {
            const e = n.model.document.selection.getSelectedElement();
            if (q_(e)) {
              n.model.change((i) => {
                i.setAttribute('src', t.imageURLInputValue, e);
                i.removeAttribute('srcset', e);
                i.removeAttribute('sizes', e);
              });
            } else {
              n.execute('imageInsert', { source: t.imageURLInputValue });
            }
          }
          function a() {
            n.editing.view.focus();
            e.isOpen = false;
          }
          return e;
        }
        _createDropdownView(e) {
          const t = this.editor;
          const i = new xE(e, ME(t));
          const n = t.commands.get('imageUpload');
          const o = i.dropdownView;
          const r = o.panelView;
          const s = o.buttonView;
          s.actionView = this._createFileDialogButtonView(e);
          r.children.add(i);
          return this._setUpDropdown(o, i, n);
        }
        _createFileDialogButtonView(e) {
          const t = this.editor;
          const i = e.t;
          const n = t.config.get('image.upload.types');
          const o = new AE(e);
          const r = CE(n);
          const s = t.commands.get('imageUpload');
          o.set({
            acceptedType: n.map((e) => `image/${e}`).join(','),
            allowMultipleFiles: true,
          });
          o.buttonView.set({
            label: i('Insert image'),
            icon: vE,
            tooltip: true,
          });
          o.buttonView.bind('isEnabled').to(s);
          o.on('done', (e, i) => {
            const n = Array.from(i).filter((e) => r.test(e.type));
            if (n.length) {
              t.execute('imageUpload', { file: n });
            }
          });
          return o;
        }
      }
      var OE =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 700 250"><rect rx="4"/></svg>';
      var zE = i(92);
      var RE = i(94);
      var LE = i(96);
      class VE extends ok {
        constructor(e) {
          super(e);
          this.placeholder =
            'data:image/svg+xml;utf8,' + encodeURIComponent(OE);
        }
        init() {
          const e = this.editor;
          e.editing.downcastDispatcher.on(
            'attribute:uploadStatus:image',
            (...e) => this.uploadStatusChange(...e)
          );
        }
        uploadStatusChange(e, t, i) {
          const n = this.editor;
          const o = t.item;
          const r = o.getAttribute('uploadId');
          if (!i.consumable.consume(t.item, e.name)) {
            return;
          }
          const s = n.plugins.get(tx);
          const a = r ? t.attributeNewValue : null;
          const c = this.placeholder;
          const l = n.editing.mapper.toViewElement(o);
          const d = i.writer;
          if (a == 'reading') {
            DE(l, d);
            BE(c, l, d);
            return;
          }
          if (a == 'uploading') {
            const e = s.loaders.get(r);
            DE(l, d);
            if (!e) {
              BE(c, l, d);
            } else {
              FE(l, d);
              HE(l, d, e, n.editing.view);
              KE(l, d, e);
            }
            return;
          }
          if (a == 'complete' && s.loaders.get(r)) {
            qE(l, d, n.editing.view);
          }
          UE(l, d);
          FE(l, d);
          jE(l, d);
        }
      }
      function DE(e, t) {
        if (!e.hasClass('ck-appear')) {
          t.addClass('ck-appear', e);
        }
      }
      function jE(e, t) {
        t.removeClass('ck-appear', e);
      }
      function BE(e, t, i) {
        if (!t.hasClass('ck-image-upload-placeholder')) {
          i.addClass('ck-image-upload-placeholder', t);
        }
        const n = G_(t);
        if (n.getAttribute('src') !== e) {
          i.setAttribute('src', e, n);
        }
        if (!GE(t, 'placeholder')) {
          i.insert(i.createPositionAfter(n), $E(i));
        }
      }
      function FE(e, t) {
        if (e.hasClass('ck-image-upload-placeholder')) {
          t.removeClass('ck-image-upload-placeholder', e);
        }
        YE(e, t, 'placeholder');
      }
      function HE(e, t, i, n) {
        const o = WE(t);
        t.insert(t.createPositionAt(e, 'end'), o);
        i.on('change:uploadedPercent', (e, t, i) => {
          n.change((e) => {
            e.setStyle('width', i + '%', o);
          });
        });
      }
      function UE(e, t) {
        YE(e, t, 'progressBar');
      }
      function qE(e, t, i) {
        const n = t.createUIElement('div', {
          class: 'ck-image-upload-complete-icon',
        });
        t.insert(t.createPositionAt(e, 'end'), n);
        setTimeout(() => {
          i.change((e) => e.remove(e.createRangeOn(n)));
        }, 3e3);
      }
      function WE(e) {
        const t = e.createUIElement('div', { class: 'ck-progress-bar' });
        e.setCustomProperty('progressBar', true, t);
        return t;
      }
      function $E(e) {
        const t = e.createUIElement('div', {
          class: 'ck-upload-placeholder-loader',
        });
        e.setCustomProperty('placeholder', true, t);
        return t;
      }
      function GE(e, t) {
        for (const i of e.getChildren()) {
          if (i.getCustomProperty(t)) {
            return i;
          }
        }
      }
      function YE(e, t, i) {
        const n = GE(e, i);
        if (n) {
          t.remove(t.createRangeOn(n));
        }
      }
      function KE(e, t, i) {
        if (i.data) {
          const n = G_(e);
          t.setAttribute('src', i.data, n);
        }
      }
      class QE {
        constructor(e) {
          this.document = e;
        }
        createDocumentFragment(e) {
          return new Kl(this.document, e);
        }
        createElement(e, t, i) {
          return new Dc(this.document, e, t, i);
        }
        createText(e) {
          return new Bs(this.document, e);
        }
        clone(e, t = false) {
          return e._clone(t);
        }
        appendChild(e, t) {
          return t._appendChild(e);
        }
        insertChild(e, t, i) {
          return i._insertChild(e, t);
        }
        removeChildren(e, t, i) {
          return i._removeChildren(e, t);
        }
        remove(e) {
          const t = e.parent;
          if (t) {
            return this.removeChildren(t.getChildIndex(e), 1, t);
          }
          return [];
        }
        replace(e, t) {
          const i = e.parent;
          if (i) {
            const n = i.getChildIndex(e);
            this.removeChildren(n, 1, i);
            this.insertChild(n, t, i);
            return true;
          }
          return false;
        }
        unwrapElement(e) {
          const t = e.parent;
          if (t) {
            const i = t.getChildIndex(e);
            this.remove(e);
            this.insertChild(i, e.getChildren(), t);
          }
        }
        rename(e, t) {
          const i = new Dc(
            this.document,
            e,
            t.getAttributes(),
            t.getChildren()
          );
          return this.replace(t, i) ? i : null;
        }
        setAttribute(e, t, i) {
          i._setAttribute(e, t);
        }
        removeAttribute(e, t) {
          t._removeAttribute(e);
        }
        addClass(e, t) {
          t._addClass(e);
        }
        removeClass(e, t) {
          t._removeClass(e);
        }
        setStyle(e, t, i) {
          if (z(e) && i === undefined) {
            i = t;
          }
          i._setStyle(e, t);
        }
        removeStyle(e, t) {
          t._removeStyle(e);
        }
        setCustomProperty(e, t, i) {
          i._setCustomProperty(e, t);
        }
        removeCustomProperty(e, t) {
          return t._removeCustomProperty(e);
        }
        createPositionAt(e, t) {
          return ul._createAt(e, t);
        }
        createPositionAfter(e) {
          return ul._createAfter(e);
        }
        createPositionBefore(e) {
          return ul._createBefore(e);
        }
        createRange(e, t) {
          return new hl(e, t);
        }
        createRangeOn(e) {
          return hl._createOn(e);
        }
        createRangeIn(e) {
          return hl._createIn(e);
        }
        createSelection(e, t, i) {
          return new ml(e, t, i);
        }
      }
      class JE extends sk {
        refresh() {
          const e = this.editor.model.document.selection.getSelectedElement();
          const t = (e && e.name === 'image') || false;
          this.isEnabled = $_(this.editor.model) || t;
        }
        execute(e) {
          const t = this.editor;
          const i = t.model;
          const n = t.plugins.get(tx);
          i.change((t) => {
            const o = Array.isArray(e.file) ? e.file : [e.file];
            for (const e of o) {
              ZE(t, i, n, e);
            }
          });
        }
      }
      function ZE(e, t, i, n) {
        const o = i.createLoader(n);
        if (!o) {
          return;
        }
        W_(e, t, { uploadId: o.id });
      }
      class XE extends ok {
        static get requires() {
          return [tx, Qy, Vv];
        }
        static get pluginName() {
          return 'ImageUploadEditing';
        }
        constructor(e) {
          super(e);
          e.config.define('image', {
            upload: { types: ['jpeg', 'png', 'gif', 'bmp', 'webp', 'tiff'] },
          });
        }
        init() {
          const e = this.editor;
          const t = e.model.document;
          const i = e.model.schema;
          const n = e.conversion;
          const o = e.plugins.get(tx);
          const r = CE(e.config.get('image.upload.types'));
          i.extend('image', { allowAttributes: ['uploadId', 'uploadStatus'] });
          e.commands.add('imageUpload', new JE(e));
          n.for('upcast').attributeToAttribute({
            view: { name: 'img', key: 'uploadId' },
            model: 'uploadId',
          });
          this.listenTo(e.editing.view.document, 'clipboardInput', (t, i) => {
            if (eS(i.dataTransfer)) {
              return;
            }
            const n = Array.from(i.dataTransfer.files).filter((e) => {
              if (!e) {
                return false;
              }
              return r.test(e.type);
            });
            const o = i.targetRanges.map((t) =>
              e.editing.mapper.toModelRange(t)
            );
            e.model.change((i) => {
              i.setSelection(o);
              if (n.length) {
                t.stop();
                e.model.enqueueChange('default', () => {
                  e.execute('imageUpload', { file: n });
                });
              }
            });
          });
          this.listenTo(e.plugins.get(Vv), 'inputTransformation', (t, i) => {
            const n = Array.from(e.editing.view.createRangeIn(i.content))
              .filter(
                (e) => EE(e.item) && !e.item.getAttribute('uploadProcessed')
              )
              .map((e) => ({ promise: PE(e.item), imageElement: e.item }));
            if (!n.length) {
              return;
            }
            const r = new QE(e.editing.view.document);
            for (const e of n) {
              r.setAttribute('uploadProcessed', true, e.imageElement);
              const t = o.createLoader(e.promise);
              if (t) {
                r.setAttribute('src', '', e.imageElement);
                r.setAttribute('uploadId', t.id, e.imageElement);
              }
            }
          });
          e.editing.view.document.on('dragover', (e, t) => {
            t.preventDefault();
          });
          t.on('change', () => {
            const i = t.differ.getChanges({ includeChangesInGraveyard: true });
            for (const t of i) {
              if (t.type == 'insert' && t.name != '$text') {
                const i = t.position.nodeAfter;
                const n = t.position.root.rootName == '$graveyard';
                for (const t of tS(e, i)) {
                  const e = t.getAttribute('uploadId');
                  if (!e) {
                    continue;
                  }
                  const i = o.loaders.get(e);
                  if (!i) {
                    continue;
                  }
                  if (n) {
                    i.abort();
                  } else if (i.status == 'idle') {
                    this._readAndUpload(i, t);
                  }
                }
              }
            }
          });
        }
        _readAndUpload(e, t) {
          const i = this.editor;
          const n = i.model;
          const o = i.locale.t;
          const r = i.plugins.get(tx);
          const s = i.plugins.get(Qy);
          n.enqueueChange('transparent', (e) => {
            e.setAttribute('uploadStatus', 'reading', t);
          });
          return e
            .read()
            .then(() => {
              const o = e.upload();
              if (Cl.isSafari) {
                const e = i.editing.mapper.toViewElement(t);
                const n = G_(e);
                i.editing.view.once('render', () => {
                  if (!n.parent) {
                    return;
                  }
                  const e = i.editing.view.domConverter.mapViewToDom(n.parent);
                  if (!e) {
                    return;
                  }
                  const t = e.style.display;
                  e.style.display = 'none';
                  e._ckHack = e.offsetHeight;
                  e.style.display = t;
                });
              }
              n.enqueueChange('transparent', (e) => {
                e.setAttribute('uploadStatus', 'uploading', t);
              });
              return o;
            })
            .then((e) => {
              n.enqueueChange('transparent', (i) => {
                i.setAttributes(
                  { uploadStatus: 'complete', src: e.default },
                  t
                );
                this._parseAndSetSrcsetAttributeOnImage(e, t, i);
              });
              a();
            })
            .catch((i) => {
              if (e.status !== 'error' && e.status !== 'aborted') {
                throw i;
              }
              if (e.status == 'error' && i) {
                s.showWarning(i, {
                  title: o('Upload failed'),
                  namespace: 'upload',
                });
              }
              a();
              n.enqueueChange('transparent', (e) => {
                e.remove(t);
              });
            });
          function a() {
            n.enqueueChange('transparent', (e) => {
              e.removeAttribute('uploadId', t);
              e.removeAttribute('uploadStatus', t);
            });
            r.destroyLoader(e);
          }
        }
        _parseAndSetSrcsetAttributeOnImage(e, t, i) {
          let n = 0;
          const o = Object.keys(e)
            .filter((e) => {
              const t = parseInt(e, 10);
              if (!isNaN(t)) {
                n = Math.max(n, t);
                return true;
              }
            })
            .map((t) => `${e[t]} ${t}w`)
            .join(', ');
          if (o != '') {
            i.setAttribute('srcset', { data: o, width: n }, t);
          }
        }
      }
      function eS(e) {
        return (
          Array.from(e.types).includes('text/html') &&
          e.getData('text/html') !== ''
        );
      }
      function tS(e, t) {
        return Array.from(e.model.createRangeOn(t))
          .filter((e) => e.item.is('element', 'image'))
          .map((e) => e.item);
      }
      class iS extends ok {
        static get pluginName() {
          return 'ImageUpload';
        }
        static get requires() {
          return [XE, NE, VE];
        }
      }
      class nS extends sk {
        constructor(e) {
          super(e);
          this._childCommands = [];
        }
        refresh() {}
        execute(...e) {
          const t = this._getFirstEnabledCommand();
          return t.execute(e);
        }
        registerChildCommand(e) {
          this._childCommands.push(e);
          e.on('change:isEnabled', () => this._checkEnabled());
          this._checkEnabled();
        }
        _checkEnabled() {
          this.isEnabled = !!this._getFirstEnabledCommand();
        }
        _getFirstEnabledCommand() {
          return this._childCommands.find((e) => e.isEnabled);
        }
      }
      class oS extends ok {
        static get pluginName() {
          return 'IndentEditing';
        }
        init() {
          const e = this.editor;
          e.commands.add('indent', new nS(e));
          e.commands.add('outdent', new nS(e));
        }
      }
      var rS =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5zM1.632 6.95L5.02 9.358a.4.4 0 0 1-.013.661l-3.39 2.207A.4.4 0 0 1 1 11.892V7.275a.4.4 0 0 1 .632-.326z"/></svg>';
      var sS =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5zm1.618-9.55L.98 9.358a.4.4 0 0 0 .013.661l3.39 2.207A.4.4 0 0 0 5 11.892V7.275a.4.4 0 0 0-.632-.326z"/></svg>';
      class aS extends ok {
        static get pluginName() {
          return 'IndentUI';
        }
        init() {
          const e = this.editor;
          const t = e.locale;
          const i = e.t;
          const n = t.uiLanguageDirection == 'ltr' ? rS : sS;
          const o = t.uiLanguageDirection == 'ltr' ? sS : rS;
          this._defineButton('indent', i('Increase indent'), n);
          this._defineButton('outdent', i('Decrease indent'), o);
        }
        _defineButton(e, t, i) {
          const n = this.editor;
          n.ui.componentFactory.add(e, (o) => {
            const r = n.commands.get(e);
            const s = new Ew(o);
            s.set({ label: t, icon: i, tooltip: true });
            s.bind('isOn', 'isEnabled').to(r, 'value', 'isEnabled');
            this.listenTo(s, 'execute', () => {
              n.execute(e);
              n.editing.view.focus();
            });
            return s;
          });
        }
      }
      class cS extends ok {
        static get pluginName() {
          return 'Indent';
        }
        static get requires() {
          return [oS, aS];
        }
      }
      const lS = 'italic';
      class dS extends ok {
        static get pluginName() {
          return 'ItalicEditing';
        }
        init() {
          const e = this.editor;
          e.model.schema.extend('$text', { allowAttributes: lS });
          e.model.schema.setAttributeProperties(lS, {
            isFormatting: true,
            copyOnEnter: true,
          });
          e.conversion.attributeToElement({
            model: lS,
            view: 'i',
            upcastAlso: ['em', { styles: { 'font-style': 'italic' } }],
          });
          e.commands.add(lS, new e_(e, lS));
          e.keystrokes.set('CTRL+I', lS);
        }
      }
      var uS =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.586 14.633l.021.004c-.036.335.095.655.393.962.082.083.173.15.274.201h1.474a.6.6 0 1 1 0 1.2H5.304a.6.6 0 0 1 0-1.2h1.15c.474-.07.809-.182 1.005-.334.157-.122.291-.32.404-.597l2.416-9.55a1.053 1.053 0 0 0-.281-.823 1.12 1.12 0 0 0-.442-.296H8.15a.6.6 0 0 1 0-1.2h6.443a.6.6 0 1 1 0 1.2h-1.195c-.376.056-.65.155-.823.296-.215.175-.423.439-.623.79l-2.366 9.347z"/></svg>';
      const hS = 'italic';
      class fS extends ok {
        init() {
          const e = this.editor;
          const t = e.t;
          e.ui.componentFactory.add(hS, (i) => {
            const n = e.commands.get(hS);
            const o = new Ew(i);
            o.set({
              label: t('Italic'),
              icon: uS,
              keystroke: 'CTRL+I',
              tooltip: true,
              isToggleable: true,
            });
            o.bind('isOn', 'isEnabled').to(n, 'value', 'isEnabled');
            this.listenTo(o, 'execute', () => {
              e.execute(hS);
              e.editing.view.focus();
            });
            return o;
          });
        }
      }
      class gS extends ok {
        static get requires() {
          return [dS, fS];
        }
        static get pluginName() {
          return 'Italic';
        }
      }
      class mS extends eh {
        constructor(e) {
          super(e);
          this.domEventType = 'click';
        }
        onDomEvent(e) {
          this.fire(e.type, e);
        }
      }
      var pS = i(98);
      class bS extends Hb {
        constructor(e, t, i) {
          super(e);
          const n = e.t;
          this.focusTracker = new Qp();
          this.keystrokes = new Vp();
          this.urlInputView = this._createUrlInput(i);
          this.saveButtonView = this._createButton(
            n('Save'),
            $C,
            'ck-button-save'
          );
          this.saveButtonView.type = 'submit';
          this.cancelButtonView = this._createButton(
            n('Cancel'),
            GC,
            'ck-button-cancel',
            'cancel'
          );
          this._manualDecoratorSwitches =
            this._createManualDecoratorSwitches(t);
          this.children = this._createFormChildren(t.manualDecorators);
          this._focusables = new hb();
          this._focusCycler = new rw({
            focusables: this._focusables,
            focusTracker: this.focusTracker,
            keystrokeHandler: this.keystrokes,
            actions: { focusPrevious: 'shift + tab', focusNext: 'tab' },
          });
          const o = ['ck', 'ck-link-form'];
          if (t.manualDecorators.length) {
            o.push('ck-link-form_layout-vertical');
          }
          this.setTemplate({
            tag: 'form',
            attributes: { class: o, tabindex: '-1' },
            children: this.children,
          });
        }
        getDecoratorSwitchesState() {
          return Array.from(this._manualDecoratorSwitches).reduce((e, t) => {
            e[t.name] = t.isOn;
            return e;
          }, {});
        }
        render() {
          super.render();
          WC({ view: this });
          const e = [
            this.urlInputView,
            ...this._manualDecoratorSwitches,
            this.saveButtonView,
            this.cancelButtonView,
          ];
          e.forEach((e) => {
            this._focusables.add(e);
            this.focusTracker.add(e.element);
          });
          this.keystrokes.listenTo(this.element);
        }
        focus() {
          this._focusCycler.focusFirst();
        }
        _createUrlInput(e = 'https://') {
          const t = this.locale.t;
          const i = new BC(this.locale, UC);
          i.label = t('Link URL');
          i.fieldView.placeholder = e + 'example.com';
          return i;
        }
        _createButton(e, t, i, n) {
          const o = new Ew(this.locale);
          o.set({ label: e, icon: t, tooltip: true });
          o.extendTemplate({ attributes: { class: i } });
          if (n) {
            o.delegate('execute').to(this, n);
          }
          return o;
        }
        _createManualDecoratorSwitches(e) {
          const t = this.createCollection();
          for (const i of e.manualDecorators) {
            const n = new Lw(this.locale);
            n.set({ name: i.id, label: i.label, withText: true });
            n.bind('isOn').toMany([i, e], 'value', (e, t) =>
              t === undefined && e === undefined ? i.defaultValue : e
            );
            n.on('execute', () => {
              i.set('value', !n.isOn);
            });
            t.add(n);
          }
          return t;
        }
        _createFormChildren(e) {
          const t = this.createCollection();
          t.add(this.urlInputView);
          if (e.length) {
            const e = new Hb();
            e.setTemplate({
              tag: 'ul',
              children: this._manualDecoratorSwitches.map((e) => ({
                tag: 'li',
                children: [e],
                attributes: { class: ['ck', 'ck-list__item'] },
              })),
              attributes: { class: ['ck', 'ck-reset', 'ck-list'] },
            });
            t.add(e);
          }
          t.add(this.saveButtonView);
          t.add(this.cancelButtonView);
          return t;
        }
      }
      var wS =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.077 15l.991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184zm4.919 10.562l-1.414 1.414a.75.75 0 1 1-1.06-1.06l1.414-1.415-1.415-1.414a.75.75 0 0 1 1.061-1.06l1.414 1.414 1.414-1.415a.75.75 0 0 1 1.061 1.061l-1.414 1.414 1.414 1.415a.75.75 0 0 1-1.06 1.06l-1.415-1.414z"/></svg>';
      var kS =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7.3 17.37l-.061.088a1.518 1.518 0 0 1-.934.535l-4.178.663-.806-4.153a1.495 1.495 0 0 1 .187-1.058l.056-.086L8.77 2.639c.958-1.351 2.803-1.076 4.296-.03 1.497 1.047 2.387 2.693 1.433 4.055L7.3 17.37zM9.14 4.728l-5.545 8.346 3.277 2.294 5.544-8.346L9.14 4.728zM6.07 16.512l-3.276-2.295.53 2.73 2.746-.435zM9.994 3.506L13.271 5.8c.316-.452-.16-1.333-1.065-1.966-.905-.634-1.895-.78-2.212-.328zM8 18.5L9.375 17H19v1.5H8z"/></svg>';
      var _S = i(100);
      class vS extends Hb {
        constructor(e) {
          super(e);
          const t = e.t;
          this.focusTracker = new Qp();
          this.keystrokes = new Vp();
          this.previewButtonView = this._createPreviewButton();
          this.unlinkButtonView = this._createButton(t('Unlink'), wS, 'unlink');
          this.editButtonView = this._createButton(t('Edit link'), kS, 'edit');
          this.set('href');
          this._focusables = new hb();
          this._focusCycler = new rw({
            focusables: this._focusables,
            focusTracker: this.focusTracker,
            keystrokeHandler: this.keystrokes,
            actions: { focusPrevious: 'shift + tab', focusNext: 'tab' },
          });
          this.setTemplate({
            tag: 'div',
            attributes: { class: ['ck', 'ck-link-actions'], tabindex: '-1' },
            children: [
              this.previewButtonView,
              this.editButtonView,
              this.unlinkButtonView,
            ],
          });
        }
        render() {
          super.render();
          const e = [
            this.previewButtonView,
            this.editButtonView,
            this.unlinkButtonView,
          ];
          e.forEach((e) => {
            this._focusables.add(e);
            this.focusTracker.add(e.element);
          });
          this.keystrokes.listenTo(this.element);
        }
        focus() {
          this._focusCycler.focusFirst();
        }
        _createButton(e, t, i) {
          const n = new Ew(this.locale);
          n.set({ label: e, icon: t, tooltip: true });
          n.delegate('execute').to(this, i);
          return n;
        }
        _createPreviewButton() {
          const e = new Ew(this.locale);
          const t = this.bindTemplate;
          const i = this.t;
          e.set({ withText: true, tooltip: i('Open link in new tab') });
          e.extendTemplate({
            attributes: {
              class: ['ck', 'ck-link-actions__preview'],
              href: t.to('href', (e) => e && Oy(e)),
              target: '_blank',
              rel: 'noopener noreferrer',
            },
          });
          e.bind('label').to(
            this,
            'href',
            (e) => e || i('This link has no URL')
          );
          e.bind('isEnabled').to(this, 'href', (e) => !!e);
          e.template.tag = 'a';
          e.template.eventListeners = {};
          return e;
        }
      }
      var yS =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.077 15l.991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184z"/></svg>';
      const xS = /^((\w+:(\/{2,})?)|(\W))/i;
      const AS = /[\w-]+@[\w-]+\.+[\w-]+/i;
      const TS = 'link-ui';
      class CS extends ok {
        static get requires() {
          return [tP];
        }
        static get pluginName() {
          return 'LinkUI';
        }
        init() {
          const e = this.editor;
          e.editing.view.addObserver(mS);
          this.actionsView = this._createActionsView();
          this.formView = this._createFormView();
          this._balloon = e.plugins.get(tP);
          this._createToolbarLinkButton();
          this._enableUserBalloonInteractions();
          e.conversion.for('editingDowncast').markerToHighlight({
            model: TS,
            view: { classes: ['ck-fake-link-selection'] },
          });
          e.conversion.for('editingDowncast').markerToElement({
            model: TS,
            view: {
              name: 'span',
              classes: [
                'ck-fake-link-selection',
                'ck-fake-link-selection_collapsed',
              ],
            },
          });
        }
        destroy() {
          super.destroy();
          this.formView.destroy();
        }
        _createActionsView() {
          const e = this.editor;
          const t = new vS(e.locale);
          const i = e.commands.get('link');
          const n = e.commands.get('unlink');
          t.bind('href').to(i, 'value');
          t.editButtonView.bind('isEnabled').to(i);
          t.unlinkButtonView.bind('isEnabled').to(n);
          this.listenTo(t, 'edit', () => {
            this._addFormView();
          });
          this.listenTo(t, 'unlink', () => {
            e.execute('unlink');
            this._hideUI();
          });
          t.keystrokes.set('Esc', (e, t) => {
            this._hideUI();
            t();
          });
          t.keystrokes.set(My, (e, t) => {
            this._addFormView();
            t();
          });
          return t;
        }
        _createFormView() {
          const e = this.editor;
          const t = e.commands.get('link');
          const i = e.config.get('link.defaultProtocol');
          const n = new bS(e.locale, t, i);
          n.urlInputView.fieldView.bind('value').to(t, 'value');
          n.urlInputView.bind('isReadOnly').to(t, 'isEnabled', (e) => !e);
          n.saveButtonView.bind('isEnabled').to(t);
          this.listenTo(n, 'submit', () => {
            const { value: t } = n.urlInputView.fieldView.element;
            const o = !!i && !xS.test(t);
            const r = AS.test(t);
            const s = r ? 'mailto:' : i;
            const a = t && o ? s + t : t;
            e.execute('link', a, n.getDecoratorSwitchesState());
            this._closeFormView();
          });
          this.listenTo(n, 'cancel', () => {
            this._closeFormView();
          });
          n.keystrokes.set('Esc', (e, t) => {
            this._closeFormView();
            t();
          });
          return n;
        }
        _createToolbarLinkButton() {
          const e = this.editor;
          const t = e.commands.get('link');
          const i = e.t;
          e.keystrokes.set(My, (e, t) => {
            t();
            this._showUI(true);
          });
          e.ui.componentFactory.add('link', (e) => {
            const n = new Ew(e);
            n.isEnabled = true;
            n.label = i('Link');
            n.icon = yS;
            n.keystroke = My;
            n.tooltip = true;
            n.isToggleable = true;
            n.bind('isEnabled').to(t, 'isEnabled');
            n.bind('isOn').to(t, 'value', (e) => !!e);
            this.listenTo(n, 'execute', () => this._showUI(true));
            return n;
          });
        }
        _enableUserBalloonInteractions() {
          const e = this.editor.editing.view.document;
          this.listenTo(e, 'click', () => {
            const e = this._getSelectedLinkElement();
            if (e) {
              this._showUI();
            }
          });
          this.editor.keystrokes.set(
            'Tab',
            (e, t) => {
              if (
                this._areActionsVisible &&
                !this.actionsView.focusTracker.isFocused
              ) {
                this.actionsView.focus();
                t();
              }
            },
            { priority: 'high' }
          );
          this.editor.keystrokes.set('Esc', (e, t) => {
            if (this._isUIVisible) {
              this._hideUI();
              t();
            }
          });
          Vw({
            emitter: this.formView,
            activator: () => this._isUIInPanel,
            contextElements: [this._balloon.view.element],
            callback: () => this._hideUI(),
          });
        }
        _addActionsView() {
          if (this._areActionsInPanel) {
            return;
          }
          this._balloon.add({
            view: this.actionsView,
            position: this._getBalloonPositionData(),
          });
        }
        _addFormView() {
          if (this._isFormInPanel) {
            return;
          }
          const e = this.editor;
          const t = e.commands.get('link');
          this._balloon.add({
            view: this.formView,
            position: this._getBalloonPositionData(),
          });
          if (this._balloon.visibleView === this.formView) {
            this.formView.urlInputView.fieldView.select();
          }
          this.formView.urlInputView.fieldView.element.value = t.value || '';
        }
        _closeFormView() {
          const e = this.editor.commands.get('link');
          e.restoreManualDecoratorStates();
          if (e.value !== undefined) {
            this._removeFormView();
          } else {
            this._hideUI();
          }
        }
        _removeFormView() {
          if (this._isFormInPanel) {
            this.formView.saveButtonView.focus();
            this._balloon.remove(this.formView);
            this.editor.editing.view.focus();
            this._hideFakeVisualSelection();
          }
        }
        _showUI(e = false) {
          if (!this._getSelectedLinkElement()) {
            this._showFakeVisualSelection();
            this._addActionsView();
            if (e) {
              this._balloon.showStack('main');
            }
            this._addFormView();
          } else {
            if (this._areActionsVisible) {
              this._addFormView();
            } else {
              this._addActionsView();
            }
            if (e) {
              this._balloon.showStack('main');
            }
          }
          this._startUpdatingUI();
        }
        _hideUI() {
          if (!this._isUIInPanel) {
            return;
          }
          const e = this.editor;
          this.stopListening(e.ui, 'update');
          this.stopListening(this._balloon, 'change:visibleView');
          e.editing.view.focus();
          this._removeFormView();
          this._balloon.remove(this.actionsView);
          this._hideFakeVisualSelection();
        }
        _startUpdatingUI() {
          const e = this.editor;
          const t = e.editing.view.document;
          let i = this._getSelectedLinkElement();
          let n = r();
          const o = () => {
            const e = this._getSelectedLinkElement();
            const t = r();
            if ((i && !e) || (!i && t !== n)) {
              this._hideUI();
            } else if (this._isUIVisible) {
              this._balloon.updatePosition(this._getBalloonPositionData());
            }
            i = e;
            n = t;
          };
          function r() {
            return t.selection.focus
              .getAncestors()
              .reverse()
              .find((e) => e.is('element'));
          }
          this.listenTo(e.ui, 'update', o);
          this.listenTo(this._balloon, 'change:visibleView', o);
        }
        get _isFormInPanel() {
          return this._balloon.hasView(this.formView);
        }
        get _areActionsInPanel() {
          return this._balloon.hasView(this.actionsView);
        }
        get _areActionsVisible() {
          return this._balloon.visibleView === this.actionsView;
        }
        get _isUIInPanel() {
          return this._isFormInPanel || this._areActionsInPanel;
        }
        get _isUIVisible() {
          const e = this._balloon.visibleView;
          return e == this.formView || this._areActionsVisible;
        }
        _getBalloonPositionData() {
          const e = this.editor.editing.view;
          const t = this.editor.model;
          const i = e.document;
          const n = this._getSelectedLinkElement();
          const o = t.markers.has(TS)
            ? this.editor.editing.mapper.toViewRange(
                t.markers.get(TS).getRange()
              )
            : i.selection.getFirstRange();
          const r = n
            ? e.domConverter.mapViewToDom(n)
            : e.domConverter.viewRangeToDom(o);
          return { target: r };
        }
        _getSelectedLinkElement() {
          const e = this.editor.editing.view;
          const t = e.document.selection;
          if (t.isCollapsed) {
            return PS(t.getFirstPosition());
          } else {
            const i = t.getFirstRange().getTrimmed();
            const n = PS(i.start);
            const o = PS(i.end);
            if (!n || n != o) {
              return null;
            }
            if (e.createRangeIn(n).getTrimmed().isEqual(i)) {
              return n;
            } else {
              return null;
            }
          }
        }
        _showFakeVisualSelection() {
          const e = this.editor.model;
          e.change((t) => {
            if (e.markers.has(TS)) {
              t.updateMarker(TS, {
                range: e.document.selection.getFirstRange(),
              });
            } else {
              t.addMarker(TS, {
                usingOperation: false,
                affectsData: false,
                range: e.document.selection.getFirstRange(),
              });
            }
          });
        }
        _hideFakeVisualSelection() {
          const e = this.editor.model;
          if (e.markers.has(TS)) {
            e.change((e) => {
              e.removeMarker(TS);
            });
          }
        }
      }
      function PS(e) {
        return e.getAncestors().find((e) => Iy(e));
      }
      class ES extends ok {
        static get requires() {
          return [$y, CS];
        }
        static get pluginName() {
          return 'Link';
        }
      }
      class SS extends sk {
        constructor(e, t) {
          super(e);
          this.type = t;
        }
        refresh() {
          this.value = this._getValue();
          this.isEnabled = this._checkEnabled();
        }
        execute() {
          const e = this.editor.model;
          const t = e.document;
          const i = Array.from(t.selection.getSelectedBlocks()).filter((t) =>
            IS(t, e.schema)
          );
          const n = this.value === true;
          e.change((e) => {
            if (n) {
              let t = i[i.length - 1].nextSibling;
              let n = Number.POSITIVE_INFINITY;
              let o = [];
              while (
                t &&
                t.name == 'listItem' &&
                t.getAttribute('listIndent') !== 0
              ) {
                const e = t.getAttribute('listIndent');
                if (e < n) {
                  n = e;
                }
                const i = e - n;
                o.push({ element: t, listIndent: i });
                t = t.nextSibling;
              }
              o = o.reverse();
              for (const t of o) {
                e.setAttribute('listIndent', t.listIndent, t.element);
              }
            }
            if (!n) {
              let e = Number.POSITIVE_INFINITY;
              for (const t of i) {
                if (
                  t.is('element', 'listItem') &&
                  t.getAttribute('listIndent') < e
                ) {
                  e = t.getAttribute('listIndent');
                }
              }
              e = e === 0 ? 1 : e;
              MS(i, true, e);
              MS(i, false, e);
            }
            for (const t of i.reverse()) {
              if (n && t.name == 'listItem') {
                e.rename(t, 'paragraph');
              } else if (!n && t.name != 'listItem') {
                e.setAttributes({ listType: this.type, listIndent: 0 }, t);
                e.rename(t, 'listItem');
              } else if (
                !n &&
                t.name == 'listItem' &&
                t.getAttribute('listType') != this.type
              ) {
                e.setAttribute('listType', this.type, t);
              }
            }
            this.fire('_executeCleanup', i);
          });
        }
        _getValue() {
          const e = ck(
            this.editor.model.document.selection.getSelectedBlocks()
          );
          return (
            !!e &&
            e.is('element', 'listItem') &&
            e.getAttribute('listType') == this.type
          );
        }
        _checkEnabled() {
          if (this.value) {
            return true;
          }
          const e = this.editor.model.document.selection;
          const t = this.editor.model.schema;
          const i = ck(e.getSelectedBlocks());
          if (!i) {
            return false;
          }
          return IS(i, t);
        }
      }
      function MS(e, t, i) {
        const n = t ? e[0] : e[e.length - 1];
        if (n.is('element', 'listItem')) {
          let o = n[t ? 'previousSibling' : 'nextSibling'];
          let r = n.getAttribute('listIndent');
          while (
            o &&
            o.is('element', 'listItem') &&
            o.getAttribute('listIndent') >= i
          ) {
            if (r > o.getAttribute('listIndent')) {
              r = o.getAttribute('listIndent');
            }
            if (o.getAttribute('listIndent') == r) {
              e[t ? 'unshift' : 'push'](o);
            }
            o = o[t ? 'previousSibling' : 'nextSibling'];
          }
        }
      }
      function IS(e, t) {
        return t.checkChild(e.parent, 'listItem') && !t.isObject(e);
      }
      class NS extends sk {
        constructor(e, t) {
          super(e);
          this._indentBy = t == 'forward' ? 1 : -1;
        }
        refresh() {
          this.isEnabled = this._checkEnabled();
        }
        execute() {
          const e = this.editor.model;
          const t = e.document;
          let i = Array.from(t.selection.getSelectedBlocks());
          e.change((e) => {
            const t = i[i.length - 1];
            let n = t.nextSibling;
            while (
              n &&
              n.name == 'listItem' &&
              n.getAttribute('listIndent') > t.getAttribute('listIndent')
            ) {
              i.push(n);
              n = n.nextSibling;
            }
            if (this._indentBy < 0) {
              i = i.reverse();
            }
            for (const t of i) {
              const i = t.getAttribute('listIndent') + this._indentBy;
              if (i < 0) {
                e.rename(t, 'paragraph');
              } else {
                e.setAttribute('listIndent', i, t);
              }
            }
            this.fire('_executeCleanup', i);
          });
        }
        _checkEnabled() {
          const e = ck(
            this.editor.model.document.selection.getSelectedBlocks()
          );
          if (!e || !e.is('element', 'listItem')) {
            return false;
          }
          if (this._indentBy > 0) {
            const t = e.getAttribute('listIndent');
            const i = e.getAttribute('listType');
            let n = e.previousSibling;
            while (
              n &&
              n.is('element', 'listItem') &&
              n.getAttribute('listIndent') >= t
            ) {
              if (n.getAttribute('listIndent') == t) {
                return n.getAttribute('listType') == i;
              }
              n = n.previousSibling;
            }
            return false;
          }
          return true;
        }
      }
      function OS(e) {
        const t = e.createContainerElement('li');
        t.getFillerOffset = FS;
        return t;
      }
      function zS(e, t) {
        const i = t.mapper;
        const n = t.writer;
        const o = e.getAttribute('listType') == 'numbered' ? 'ol' : 'ul';
        const r = OS(n);
        const s = n.createContainerElement(o, null);
        n.insert(n.createPositionAt(s, 0), r);
        i.bindElements(e, r);
        return r;
      }
      function RS(e, t, i, n) {
        const o = t.parent;
        const r = i.mapper;
        const s = i.writer;
        let a = r.toViewPosition(n.createPositionBefore(e));
        const c = DS(e.previousSibling, {
          sameIndent: true,
          smallerIndent: true,
          listIndent: e.getAttribute('listIndent'),
        });
        const l = e.previousSibling;
        if (c && c.getAttribute('listIndent') == e.getAttribute('listIndent')) {
          const e = r.toViewElement(c);
          a = s.breakContainer(s.createPositionAfter(e));
        } else {
          if (l && l.name == 'listItem') {
            a = r.toViewPosition(n.createPositionAt(l, 'end'));
            const e = r.findMappedViewAncestor(a);
            const t = BS(e);
            if (t) {
              a = s.createPositionBefore(t);
            } else {
              a = s.createPositionAt(e, 'end');
            }
          } else {
            a = r.toViewPosition(n.createPositionBefore(e));
          }
        }
        a = VS(a);
        s.insert(a, o);
        if (l && l.name == 'listItem') {
          const e = r.toViewElement(l);
          const i = s.createRange(s.createPositionAt(e, 0), a);
          const n = i.getWalker({ ignoreElementEnd: true });
          for (const e of n) {
            if (e.item.is('element', 'li')) {
              const i = s.breakContainer(s.createPositionBefore(e.item));
              const o = e.item.parent;
              const r = s.createPositionAt(t, 'end');
              LS(s, r.nodeBefore, r.nodeAfter);
              s.move(s.createRangeOn(o), r);
              n.position = i;
            }
          }
        } else {
          const i = o.nextSibling;
          if (i && (i.is('element', 'ul') || i.is('element', 'ol'))) {
            let n = null;
            for (const t of i.getChildren()) {
              const i = r.toModelElement(t);
              if (
                i &&
                i.getAttribute('listIndent') > e.getAttribute('listIndent')
              ) {
                n = t;
              } else {
                break;
              }
            }
            if (n) {
              s.breakContainer(s.createPositionAfter(n));
              s.move(s.createRangeOn(n.parent), s.createPositionAt(t, 'end'));
            }
          }
        }
        LS(s, o, o.nextSibling);
        LS(s, o.previousSibling, o);
      }
      function LS(e, t, i) {
        if (!t || !i || (t.name != 'ul' && t.name != 'ol')) {
          return null;
        }
        if (
          t.name != i.name ||
          t.getAttribute('class') !== i.getAttribute('class')
        ) {
          return null;
        }
        return e.mergeContainers(e.createPositionAfter(t));
      }
      function VS(e) {
        return e.getLastMatchingPosition((e) => e.item.is('uiElement'));
      }
      function DS(e, t) {
        const i = !!t.sameIndent;
        const n = !!t.smallerIndent;
        const o = t.listIndent;
        let r = e;
        while (r && r.name == 'listItem') {
          const e = r.getAttribute('listIndent');
          if ((i && o == e) || (n && o > e)) {
            return r;
          }
          r = r.previousSibling;
        }
        return null;
      }
      function jS(e, t, i, n) {
        e.ui.componentFactory.add(t, (o) => {
          const r = e.commands.get(t);
          const s = new Ew(o);
          s.set({ label: i, icon: n, tooltip: true, isToggleable: true });
          s.bind('isOn', 'isEnabled').to(r, 'value', 'isEnabled');
          s.on('execute', () => {
            e.execute(t);
            e.editing.view.focus();
          });
          return s;
        });
      }
      function BS(e) {
        for (const t of e.getChildren()) {
          if (t.name == 'ul' || t.name == 'ol') {
            return t;
          }
        }
        return null;
      }
      function FS() {
        const e =
          !this.isEmpty &&
          (this.getChild(0).name == 'ul' || this.getChild(0).name == 'ol');
        if (this.isEmpty || e) {
          return 0;
        }
        return Uc.call(this);
      }
      function HS(e) {
        return (t, i, n) => {
          const o = n.consumable;
          if (
            !o.test(i.item, 'insert') ||
            !o.test(i.item, 'attribute:listType') ||
            !o.test(i.item, 'attribute:listIndent')
          ) {
            return;
          }
          o.consume(i.item, 'insert');
          o.consume(i.item, 'attribute:listType');
          o.consume(i.item, 'attribute:listIndent');
          const r = i.item;
          const s = zS(r, n);
          RS(r, s, n, e);
        };
      }
      function US(e) {
        return (t, i, n) => {
          const o = n.mapper.toViewPosition(i.position);
          const r = o.getLastMatchingPosition(
            (e) => !e.item.is('element', 'li')
          );
          const s = r.nodeAfter;
          const a = n.writer;
          a.breakContainer(a.createPositionBefore(s));
          a.breakContainer(a.createPositionAfter(s));
          const c = s.parent;
          const l = c.previousSibling;
          const d = a.createRangeOn(c);
          const u = a.remove(d);
          if (l && l.nextSibling) {
            LS(a, l, l.nextSibling);
          }
          const h = n.mapper.toModelElement(s);
          oM(h.getAttribute('listIndent') + 1, i.position, d.start, s, n, e);
          for (const e of a.createRangeIn(u).getItems()) {
            n.mapper.unbindViewElement(e);
          }
          t.stop();
        };
      }
      function qS(e, t, i) {
        if (!i.consumable.consume(t.item, 'attribute:listType')) {
          return;
        }
        const n = i.mapper.toViewElement(t.item);
        const o = i.writer;
        o.breakContainer(o.createPositionBefore(n));
        o.breakContainer(o.createPositionAfter(n));
        const r = n.parent;
        const s = t.attributeNewValue == 'numbered' ? 'ol' : 'ul';
        o.rename(s, r);
      }
      function WS(e, t, i) {
        const n = i.mapper.toViewElement(t.item);
        const o = n.parent;
        const r = i.writer;
        LS(r, o, o.nextSibling);
        LS(r, o.previousSibling, o);
        for (const e of t.item.getChildren()) {
          i.consumable.consume(e, 'insert');
        }
      }
      function $S(e) {
        return (t, i, n) => {
          if (!n.consumable.consume(i.item, 'attribute:listIndent')) {
            return;
          }
          const o = n.mapper.toViewElement(i.item);
          const r = n.writer;
          r.breakContainer(r.createPositionBefore(o));
          r.breakContainer(r.createPositionAfter(o));
          const s = o.parent;
          const a = s.previousSibling;
          const c = r.createRangeOn(s);
          r.remove(c);
          if (a && a.nextSibling) {
            LS(r, a, a.nextSibling);
          }
          oM(i.attributeOldValue + 1, i.range.start, c.start, o, n, e);
          RS(i.item, o, n, e);
          for (const e of i.item.getChildren()) {
            n.consumable.consume(e, 'insert');
          }
        };
      }
      function GS(e, t, i) {
        if (t.item.name != 'listItem') {
          let e = i.mapper.toViewPosition(t.range.start);
          const n = i.writer;
          const o = [];
          while (e.parent.name == 'ul' || e.parent.name == 'ol') {
            e = n.breakContainer(e);
            if (e.parent.name != 'li') {
              break;
            }
            const t = e;
            const i = n.createPositionAt(e.parent, 'end');
            if (!t.isEqual(i)) {
              const e = n.remove(n.createRange(t, i));
              o.push(e);
            }
            e = n.createPositionAfter(e.parent);
          }
          if (o.length > 0) {
            for (let t = 0; t < o.length; t++) {
              const i = e.nodeBefore;
              const r = n.insert(e, o[t]);
              e = r.end;
              if (t > 0) {
                const t = LS(n, i, i.nextSibling);
                if (t && t.parent == i) {
                  e.offset--;
                }
              }
            }
            LS(n, e.nodeBefore, e.nodeAfter);
          }
        }
      }
      function YS(e, t, i) {
        const n = i.mapper.toViewPosition(t.position);
        const o = n.nodeBefore;
        const r = n.nodeAfter;
        LS(i.writer, o, r);
      }
      function KS(e, t, i) {
        if (i.consumable.consume(t.viewItem, { name: true })) {
          const e = i.writer;
          const n = e.createElement('listItem');
          const o = sM(t.viewItem);
          e.setAttribute('listIndent', o, n);
          const r =
            t.viewItem.parent && t.viewItem.parent.name == 'ol'
              ? 'numbered'
              : 'bulleted';
          e.setAttribute('listType', r, n);
          if (!i.safeInsert(n, t.modelCursor)) {
            return;
          }
          const s = iM(n, t.viewItem.getChildren(), i);
          t.modelRange = e.createRange(t.modelCursor, s);
          i.updateConversionResult(n, t);
        }
      }
      function QS(e, t, i) {
        if (i.consumable.test(t.viewItem, { name: true })) {
          const e = Array.from(t.viewItem.getChildren());
          for (const t of e) {
            const e = !(t.is('element', 'li') || rM(t));
            if (e) {
              t._remove();
            }
          }
        }
      }
      function JS(e, t, i) {
        if (i.consumable.test(t.viewItem, { name: true })) {
          if (t.viewItem.childCount === 0) {
            return;
          }
          const e = [...t.viewItem.getChildren()];
          let i = false;
          let n = true;
          for (const t of e) {
            if (i && !rM(t)) {
              t._remove();
            }
            if (t.is('$text')) {
              if (n) {
                t._data = t.data.replace(/^\s+/, '');
              }
              if (!t.nextSibling || rM(t.nextSibling)) {
                t._data = t.data.replace(/\s+$/, '');
              }
            } else if (rM(t)) {
              i = true;
            }
            n = false;
          }
        }
      }
      function ZS(e) {
        return (t, i) => {
          if (i.isPhantom) {
            return;
          }
          const n = i.modelPosition.nodeBefore;
          if (n && n.is('element', 'listItem')) {
            const t = i.mapper.toViewElement(n);
            const o = t.getAncestors().find(rM);
            const r = e.createPositionAt(t, 0).getWalker();
            for (const e of r) {
              if (e.type == 'elementStart' && e.item.is('element', 'li')) {
                i.viewPosition = e.previousPosition;
                break;
              } else if (e.type == 'elementEnd' && e.item == o) {
                i.viewPosition = e.nextPosition;
                break;
              }
            }
          }
        };
      }
      function XS(e) {
        return (t, i) => {
          const n = i.viewPosition;
          const o = n.parent;
          const r = i.mapper;
          if (o.name == 'ul' || o.name == 'ol') {
            if (!n.isAtEnd) {
              const t = r.toModelElement(n.nodeAfter);
              i.modelPosition = e.createPositionBefore(t);
            } else {
              const t = r.toModelElement(n.nodeBefore);
              const o = r.getModelLength(n.nodeBefore);
              i.modelPosition = e.createPositionBefore(t).getShiftedBy(o);
            }
            t.stop();
          } else if (
            o.name == 'li' &&
            n.nodeBefore &&
            (n.nodeBefore.name == 'ul' || n.nodeBefore.name == 'ol')
          ) {
            const s = r.toModelElement(o);
            let a = 1;
            let c = n.nodeBefore;
            while (c && rM(c)) {
              a += r.getModelLength(c);
              c = c.previousSibling;
            }
            i.modelPosition = e.createPositionBefore(s).getShiftedBy(a);
            t.stop();
          }
        };
      }
      function eM(e, t) {
        const i = e.document.differ.getChanges();
        const n = new Map();
        let o = false;
        for (const n of i) {
          if (n.type == 'insert' && n.name == 'listItem') {
            r(n.position);
          } else if (n.type == 'insert' && n.name != 'listItem') {
            if (n.name != '$text') {
              const i = n.position.nodeAfter;
              if (i.hasAttribute('listIndent')) {
                t.removeAttribute('listIndent', i);
                o = true;
              }
              if (i.hasAttribute('listType')) {
                t.removeAttribute('listType', i);
                o = true;
              }
              if (i.hasAttribute('listStyle')) {
                t.removeAttribute('listStyle', i);
                o = true;
              }
              for (const t of Array.from(e.createRangeIn(i)).filter((e) =>
                e.item.is('element', 'listItem')
              )) {
                r(t.previousPosition);
              }
            }
            const i = n.position.getShiftedBy(n.length);
            r(i);
          } else if (n.type == 'remove' && n.name == 'listItem') {
            r(n.position);
          } else if (n.type == 'attribute' && n.attributeKey == 'listIndent') {
            r(n.range.start);
          } else if (n.type == 'attribute' && n.attributeKey == 'listType') {
            r(n.range.start);
          }
        }
        for (const e of n.values()) {
          s(e);
          a(e);
        }
        return o;
        function r(e) {
          const t = e.nodeBefore;
          if (!t || !t.is('element', 'listItem')) {
            const t = e.nodeAfter;
            if (t && t.is('element', 'listItem')) {
              n.set(t, t);
            }
          } else {
            let e = t;
            if (n.has(e)) {
              return;
            }
            for (
              let t = e.previousSibling;
              t && t.is('element', 'listItem');
              t = e.previousSibling
            ) {
              e = t;
              if (n.has(e)) {
                return;
              }
            }
            n.set(t, e);
          }
        }
        function s(e) {
          let i = 0;
          let n = null;
          while (e && e.is('element', 'listItem')) {
            const r = e.getAttribute('listIndent');
            if (r > i) {
              let s;
              if (n === null) {
                n = r - i;
                s = i;
              } else {
                if (n > r) {
                  n = r;
                }
                s = r - n;
              }
              t.setAttribute('listIndent', s, e);
              o = true;
            } else {
              n = null;
              i = e.getAttribute('listIndent') + 1;
            }
            e = e.nextSibling;
          }
        }
        function a(e) {
          let i = [];
          let n = null;
          while (e && e.is('element', 'listItem')) {
            const r = e.getAttribute('listIndent');
            if (n && n.getAttribute('listIndent') > r) {
              i = i.slice(0, r + 1);
            }
            if (r != 0) {
              if (i[r]) {
                const n = i[r];
                if (e.getAttribute('listType') != n) {
                  t.setAttribute('listType', n, e);
                  o = true;
                }
              } else {
                i[r] = e.getAttribute('listType');
              }
            }
            n = e;
            e = e.nextSibling;
          }
        }
      }
      function tM(e, [t, i]) {
        let n = t.is('documentFragment') ? t.getChild(0) : t;
        let o;
        if (!i) {
          o = this.document.selection;
        } else {
          o = this.createSelection(i);
        }
        if (n && n.is('element', 'listItem')) {
          const e = o.getFirstPosition();
          let t = null;
          if (e.parent.is('element', 'listItem')) {
            t = e.parent;
          } else if (e.nodeBefore && e.nodeBefore.is('element', 'listItem')) {
            t = e.nodeBefore;
          }
          if (t) {
            const e = t.getAttribute('listIndent');
            if (e > 0) {
              while (n && n.is('element', 'listItem')) {
                n._setAttribute('listIndent', n.getAttribute('listIndent') + e);
                n = n.nextSibling;
              }
            }
          }
        }
      }
      function iM(e, t, i) {
        const { writer: n, schema: o } = i;
        let r = n.createPositionAfter(e);
        for (const s of t) {
          if (s.name == 'ul' || s.name == 'ol') {
            r = i.convertItem(s, r).modelCursor;
          } else {
            const t = i.convertItem(s, n.createPositionAt(e, 'end'));
            const a = t.modelRange.start.nodeAfter;
            const c = a && a.is('element') && !o.checkChild(e, a.name);
            if (c) {
              if (t.modelCursor.parent.is('element', 'listItem')) {
                e = t.modelCursor.parent;
              } else {
                e = nM(t.modelCursor);
              }
              r = n.createPositionAfter(e);
            }
          }
        }
        return r;
      }
      function nM(e) {
        const t = new Yh({ startPosition: e });
        let i;
        do {
          i = t.next();
        } while (!i.value.item.is('element', 'listItem'));
        return i.value.item;
      }
      function oM(e, t, i, n, o, r) {
        const s = DS(t.nodeBefore, {
          sameIndent: true,
          smallerIndent: true,
          listIndent: e,
          foo: 'b',
        });
        const a = o.mapper;
        const c = o.writer;
        const l = s ? s.getAttribute('listIndent') : null;
        let d;
        if (!s) {
          d = i;
        } else if (l == e) {
          const e = a.toViewElement(s).parent;
          d = c.createPositionAfter(e);
        } else {
          const e = r.createPositionAt(s, 'end');
          d = a.toViewPosition(e);
        }
        d = VS(d);
        for (const e of [...n.getChildren()]) {
          if (rM(e)) {
            d = c.move(c.createRangeOn(e), d).end;
            LS(c, e, e.nextSibling);
            LS(c, e.previousSibling, e);
          }
        }
      }
      function rM(e) {
        return e.is('element', 'ol') || e.is('element', 'ul');
      }
      function sM(e) {
        let t = 0;
        let i = e.parent;
        while (i) {
          if (i.is('element', 'li')) {
            t++;
          } else {
            const e = i.previousSibling;
            if (e && e.is('element', 'li')) {
              t++;
            }
          }
          i = i.parent;
        }
        return t;
      }
      class aM extends ok {
        static get pluginName() {
          return 'ListEditing';
        }
        static get requires() {
          return [jT];
        }
        init() {
          const e = this.editor;
          e.model.schema.register('listItem', {
            inheritAllFrom: '$block',
            allowAttributes: ['listType', 'listIndent'],
          });
          const t = e.data;
          const i = e.editing;
          e.model.document.registerPostFixer((t) => eM(e.model, t));
          i.mapper.registerViewToModelLength('li', cM);
          t.mapper.registerViewToModelLength('li', cM);
          i.mapper.on('modelToViewPosition', ZS(i.view));
          i.mapper.on('viewToModelPosition', XS(e.model));
          t.mapper.on('modelToViewPosition', ZS(i.view));
          e.conversion.for('editingDowncast').add((t) => {
            t.on('insert', GS, { priority: 'high' });
            t.on('insert:listItem', HS(e.model));
            t.on('attribute:listType:listItem', qS, { priority: 'high' });
            t.on('attribute:listType:listItem', WS, { priority: 'low' });
            t.on('attribute:listIndent:listItem', $S(e.model));
            t.on('remove:listItem', US(e.model));
            t.on('remove', YS, { priority: 'low' });
          });
          e.conversion.for('dataDowncast').add((t) => {
            t.on('insert', GS, { priority: 'high' });
            t.on('insert:listItem', HS(e.model));
          });
          e.conversion.for('upcast').add((e) => {
            e.on('element:ul', QS, { priority: 'high' });
            e.on('element:ol', QS, { priority: 'high' });
            e.on('element:li', JS, { priority: 'high' });
            e.on('element:li', KS);
          });
          e.model.on('insertContent', tM, { priority: 'high' });
          e.commands.add('numberedList', new SS(e, 'numbered'));
          e.commands.add('bulletedList', new SS(e, 'bulleted'));
          e.commands.add('indentList', new NS(e, 'forward'));
          e.commands.add('outdentList', new NS(e, 'backward'));
          const n = i.view.document;
          this.listenTo(n, 'enter', (e, t) => {
            const i = this.editor.model.document;
            const n = i.selection.getLastPosition().parent;
            if (i.selection.isCollapsed && n.name == 'listItem' && n.isEmpty) {
              this.editor.execute('outdentList');
              t.preventDefault();
              e.stop();
            }
          });
          this.listenTo(
            n,
            'delete',
            (e, t) => {
              if (t.direction !== 'backward') {
                return;
              }
              const i = this.editor.model.document.selection;
              if (!i.isCollapsed) {
                return;
              }
              const n = i.getFirstPosition();
              if (!n.isAtStart) {
                return;
              }
              const o = n.parent;
              if (o.name !== 'listItem') {
                return;
              }
              const r =
                o.previousSibling && o.previousSibling.name === 'listItem';
              if (r) {
                return;
              }
              this.editor.execute('outdentList');
              t.preventDefault();
              e.stop();
            },
            { priority: 'high' }
          );
          const o = (e) => (t, i) => {
            const n = this.editor.commands.get(e);
            if (n.isEnabled) {
              this.editor.execute(e);
              i();
            }
          };
          e.keystrokes.set('Tab', o('indentList'));
          e.keystrokes.set('Shift+Tab', o('outdentList'));
        }
        afterInit() {
          const e = this.editor.commands;
          const t = e.get('indent');
          const i = e.get('outdent');
          if (t) {
            t.registerChildCommand(e.get('indentList'));
          }
          if (i) {
            i.registerChildCommand(e.get('outdentList'));
          }
        }
      }
      function cM(e) {
        let t = 1;
        for (const i of e.getChildren()) {
          if (i.name == 'ul' || i.name == 'ol') {
            for (const e of i.getChildren()) {
              t += cM(e);
            }
          }
        }
        return t;
      }
      var lM =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM3.5 3v5H2V3.7H1v-1h2.5V3zM.343 17.857l2.59-3.257H2.92a.6.6 0 1 0-1.04 0H.302a2 2 0 1 1 3.995 0h-.001c-.048.405-.16.734-.333.988-.175.254-.59.692-1.244 1.312H4.3v1h-4l.043-.043zM7 14.75a.75.75 0 0 1 .75-.75h9.5a.75.75 0 1 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75z"/></svg>';
      var dM =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0C1 4.784 1.777 4 2.75 4c.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75C1.784 7.5 1 6.723 1 5.75zm6 9c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0c0-.966.777-1.75 1.75-1.75.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75-.966 0-1.75-.777-1.75-1.75z"/></svg>';
      class uM extends ok {
        init() {
          const e = this.editor.t;
          jS(this.editor, 'numberedList', e('Numbered List'), lM);
          jS(this.editor, 'bulletedList', e('Bulleted List'), dM);
        }
      }
      class hM extends ok {
        static get requires() {
          return [aM, uM];
        }
        static get pluginName() {
          return 'List';
        }
      }
      class fM extends sk {
        constructor(e, t) {
          super(e);
          this._defaultType = t;
        }
        refresh() {
          this.value = this._getValue();
          this.isEnabled = this._checkEnabled();
        }
        execute(e = {}) {
          const t = this.editor.model;
          const i = t.document;
          let n = [...i.selection.getSelectedBlocks()]
            .filter((e) => e.is('element', 'listItem'))
            .map((e) => {
              const i = t.change((t) => t.createPositionAt(e, 0));
              return [...gM(i, 'backward'), ...gM(i, 'forward')];
            })
            .flat();
          n = [...new Set(n)];
          if (!n.length) {
            return;
          }
          t.change((t) => {
            for (const i of n) {
              t.setAttribute('listStyle', e.type || this._defaultType, i);
            }
          });
        }
        _getValue() {
          const e =
            this.editor.model.document.selection.getFirstPosition().parent;
          if (e && e.is('element', 'listItem')) {
            return e.getAttribute('listStyle');
          }
          return null;
        }
        _checkEnabled() {
          const e = this.editor;
          const t = e.commands.get('numberedList');
          const i = e.commands.get('bulletedList');
          return t.isEnabled || i.isEnabled;
        }
      }
      function gM(e, t) {
        const i = [];
        const n = e.parent;
        const o = {
          ignoreElementEnd: true,
          startPosition: e,
          shallow: true,
          direction: t,
        };
        const r = n.getAttribute('listIndent');
        const s = [...new Yh(o)]
          .filter((e) => e.item.is('element'))
          .map((e) => e.item);
        for (const e of s) {
          if (!e.is('element', 'listItem')) {
            break;
          }
          if (e.getAttribute('listIndent') < r) {
            break;
          }
          if (e.getAttribute('listIndent') > r) {
            continue;
          }
          if (e.getAttribute('listType') !== n.getAttribute('listType')) {
            break;
          }
          if (e.getAttribute('listStyle') !== n.getAttribute('listStyle')) {
            break;
          }
          if (t === 'backward') {
            i.unshift(e);
          } else {
            i.push(e);
          }
        }
        return i;
      }
      const mM = 'default';
      class pM extends ok {
        static get requires() {
          return [aM];
        }
        static get pluginName() {
          return 'ListStyleEditing';
        }
        init() {
          const e = this.editor;
          const t = e.model;
          t.schema.extend('listItem', { allowAttributes: ['listStyle'] });
          e.commands.add('listStyle', new fM(e, mM));
          this.listenTo(e.commands.get('indentList'), '_executeCleanup', kM(e));
          this.listenTo(
            e.commands.get('outdentList'),
            '_executeCleanup',
            _M(e)
          );
          this.listenTo(
            e.commands.get('bulletedList'),
            '_executeCleanup',
            xM(e)
          );
          this.listenTo(
            e.commands.get('numberedList'),
            '_executeCleanup',
            xM(e)
          );
          t.document.registerPostFixer(vM(e));
          e.conversion.for('upcast').add(bM());
          e.conversion.for('downcast').add(wM());
        }
        afterInit() {
          const e = this.editor;
          if (e.commands.get('todoList')) {
            e.model.document.registerPostFixer(yM(e));
          }
        }
      }
      function bM() {
        return (e) => {
          e.on(
            'element:li',
            (e, t, i) => {
              const n = t.viewItem.parent;
              const o = n.getStyle('list-style-type') || mM;
              const r = t.modelRange.start.nodeAfter;
              i.writer.setAttribute('listStyle', o, r);
            },
            { priority: 'low' }
          );
        };
      }
      function wM() {
        return (i) => {
          i.on(
            'attribute:listStyle:listItem',
            (i, n, o) => {
              const r = o.writer;
              const s = n.item;
              const a = n.attributeNewValue;
              const c = DS(s.previousSibling, {
                sameIndent: true,
                listIndent: s.getAttribute('listIndent'),
                direction: 'backward',
              });
              const l = o.mapper.toViewElement(s);
              if (!c) {
                t(r, a, l.parent);
              } else if (!e(c, s)) {
                r.breakContainer(r.createPositionBefore(l));
                r.breakContainer(r.createPositionAfter(l));
                t(r, a, l.parent);
              }
            },
            { priority: 'low' }
          );
        };
        function e(e, t) {
          return (
            e.getAttribute('listType') === t.getAttribute('listType') &&
            e.getAttribute('listIndent') === t.getAttribute('listIndent') &&
            e.getAttribute('listStyle') === t.getAttribute('listStyle')
          );
        }
        function t(e, t, i) {
          if (t && t !== mM) {
            e.setStyle('list-style-type', t, i);
          } else {
            e.removeStyle('list-style-type', i);
          }
        }
      }
      function kM(e) {
        return (t, i) => {
          let n;
          const o = i[0];
          const r = o.getAttribute('listIndent');
          const s = i.filter((e) => e.getAttribute('listIndent') === r);
          if (o.previousSibling.getAttribute('listIndent') + 1 === r) {
            n = mM;
          } else {
            const e = DS(o.previousSibling, {
              sameIndent: true,
              direction: 'backward',
              listIndent: r,
            });
            n = e.getAttribute('listStyle');
          }
          e.model.change((e) => {
            for (const t of s) {
              e.setAttribute('listStyle', n, t);
            }
          });
        };
      }
      function _M(e) {
        return (t, i) => {
          i = i.reverse().filter((e) => e.is('element', 'listItem'));
          if (!i.length) {
            return;
          }
          const n = i[0].getAttribute('listIndent');
          const o = i[0].getAttribute('listType');
          let r = i[0].previousSibling;
          if (r.is('element', 'listItem')) {
            while (r.getAttribute('listIndent') !== n) {
              r = r.previousSibling;
            }
          } else {
            r = null;
          }
          if (!r) {
            r = i[i.length - 1].nextSibling;
          }
          if (!r || !r.is('element', 'listItem')) {
            return;
          }
          if (r.getAttribute('listType') !== o) {
            return;
          }
          e.model.change((e) => {
            const t = i.filter((e) => e.getAttribute('listIndent') === n);
            for (const i of t) {
              e.setAttribute('listStyle', r.getAttribute('listStyle'), i);
            }
          });
        };
      }
      function vM(e) {
        return (i) => {
          let n = false;
          let o = [];
          for (const t of e.model.document.differ.getChanges()) {
            if (t.type == 'insert' && t.name == 'listItem') {
              o.push(t.position.nodeAfter);
            }
          }
          o = o.filter((e) => e.getAttribute('listType') !== 'todo');
          if (!o.length) {
            return n;
          }
          let r = o[o.length - 1].nextSibling;
          if (!r || !r.is('element', 'listItem')) {
            r = o[o.length - 1].previousSibling;
            if (r) {
              const e = o[0].getAttribute('listIndent');
              while (
                r.is('element', 'listItem') &&
                r.getAttribute('listIndent') !== e
              ) {
                r = r.previousSibling;
              }
            }
          }
          for (const e of o) {
            if (!e.hasAttribute('listStyle')) {
              if (t(r)) {
                i.setAttribute('listStyle', r.getAttribute('listStyle'), e);
              } else {
                i.setAttribute('listStyle', mM, e);
              }
              n = true;
            }
          }
          return n;
        };
        function t(e) {
          if (!e) {
            return false;
          }
          const t = e.getAttribute('listStyle');
          if (!t) {
            return false;
          }
          if (t === mM) {
            return false;
          }
          return true;
        }
      }
      function yM(e) {
        return (i) => {
          let n = [];
          for (const i of e.model.document.differ.getChanges()) {
            const e = t(i);
            if (
              e &&
              e.is('element', 'listItem') &&
              e.getAttribute('listType') === 'todo'
            ) {
              n.push(e);
            }
          }
          n = n.filter((e) => e.hasAttribute('listStyle'));
          if (!n.length) {
            return false;
          }
          for (const e of n) {
            i.removeAttribute('listStyle', e);
          }
          return true;
        };
        function t(e) {
          if (e.type === 'attribute') {
            return e.range.start.nodeAfter;
          }
          if (e.type === 'insert') {
            return e.position.nodeAfter;
          }
          return null;
        }
      }
      function xM(e) {
        return (t, i) => {
          i = i.filter((e) => e.is('element', 'listItem'));
          e.model.change((e) => {
            for (const t of i) {
              e.removeAttribute('listStyle', t);
            }
          });
        };
      }
      var AM =
        '<svg viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><g><path d="M35 29a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17z" fill-opacity=".163"/><path d="M11 27a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0-9a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0-9a3 3 0 1 1 0 6 3 3 0 0 1 0-6z"/></g></svg>\n';
      var TM =
        '<svg viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><g><path d="M35 29a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17z" fill-opacity=".163"/><path d="M11 27a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0 1a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm0-10a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0 1a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm0-10a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0 1a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"/></g></svg>\n';
      var CM =
        '<svg viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><g><path d="M35 29a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17z" fill-opacity=".163"/><path d="M14 27v6H8v-6h6zm0-9v6H8v-6h6zm0-9v6H8V9h6z"/></g></svg>\n';
      var PM =
        '<svg viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><g><path d="M35 29a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17z" fill-opacity=".163"/><path d="M10.29 15V8.531H9.286c-.14.393-.4.736-.778 1.03-.378.295-.728.495-1.05.6v1.121a4.257 4.257 0 001.595-.936V15h1.235zm3.343 0v-1.235h-1.235V15h1.235zM11.3 24v-1.147H8.848c.064-.111.148-.226.252-.343.104-.117.351-.354.74-.712.39-.357.66-.631.81-.821.225-.288.39-.562.494-.824.104-.263.156-.539.156-.829 0-.51-.182-.936-.545-1.279-.363-.342-.863-.514-1.499-.514-.58 0-1.063.148-1.45.444-.387.296-.617.784-.69 1.463l1.23.124c.024-.36.112-.619.264-.774.153-.155.358-.233.616-.233.26 0 .465.074.613.222.148.148.222.36.222.635 0 .25-.085.501-.255.756-.126.185-.468.536-1.024 1.055-.692.641-1.155 1.156-1.389 1.544-.234.389-.375.8-.422 1.233H11.3zm2.333 0v-1.235h-1.235V24h1.235zM9.204 34.11c.615 0 1.129-.2 1.542-.598.413-.398.62-.88.62-1.446 0-.39-.11-.722-.332-.997a1.5 1.5 0 00-.886-.532c.619-.337.928-.788.928-1.353 0-.399-.151-.756-.453-1.073-.366-.386-.852-.58-1.459-.58-.354 0-.674.067-.96.2a1.617 1.617 0 00-.668.55c-.16.232-.28.544-.358.933l1.138.194c.032-.282.123-.495.272-.642.15-.146.33-.22.54-.22.215 0 .386.065.515.194s.193.302.193.518c0 .255-.087.46-.263.613-.176.154-.43.227-.765.218l-.136 1.006c.22-.061.409-.092.567-.092.24 0 .444.09.61.272.168.182.251.428.251.739 0 .328-.087.589-.261.782a.833.833 0 01-.644.29.841.841 0 01-.607-.242c-.167-.16-.27-.394-.307-.698l-1.196.145c.062.542.285.98.668 1.316.384.335.868.503 1.45.503zm4.43-.11v-1.235h-1.236V34h1.235z"/></g></svg>\n';
      var EM =
        '<svg viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><g><path d="M35 29a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17z" fill-opacity=".163"/><path d="M5.714 15.11c.624 0 1.11-.22 1.46-.66.421-.533.632-1.408.632-2.627 0-1.222-.21-2.096-.629-2.624-.351-.445-.839-.668-1.463-.668-.624 0-1.11.22-1.459.66-.422.533-.633 1.406-.633 2.619 0 1.236.192 2.095.576 2.577.384.482.89.723 1.516.723zm0-1.024a.614.614 0 01-.398-.14c-.115-.094-.211-.283-.287-.565-.077-.283-.115-.802-.115-1.558s.043-1.294.128-1.613c.064-.246.155-.417.272-.512a.617.617 0 01.4-.143c.15 0 .282.048.398.143.116.095.211.284.288.567.076.283.114.802.114 1.558s-.043 1.292-.128 1.608c-.064.246-.155.417-.272.512a.617.617 0 01-.4.143zm6.078.914V8.531H10.79c-.14.393-.4.736-.778 1.03-.378.295-.728.495-1.05.6v1.121a4.257 4.257 0 001.595-.936V15h1.235zm3.344 0v-1.235h-1.235V15h1.235zM5.714 24.11c.624 0 1.11-.22 1.46-.66.421-.533.632-1.408.632-2.627 0-1.222-.21-2.096-.629-2.624-.351-.445-.839-.668-1.463-.668-.624 0-1.11.22-1.459.66-.422.533-.633 1.406-.633 2.619 0 1.236.192 2.095.576 2.577.384.482.89.723 1.516.723zm0-1.024a.614.614 0 01-.398-.14c-.115-.094-.211-.283-.287-.565-.077-.283-.115-.802-.115-1.558s.043-1.294.128-1.613c.064-.246.155-.417.272-.512a.617.617 0 01.4-.143c.15 0 .282.048.398.143.116.095.211.284.288.567.076.283.114.802.114 1.558s-.043 1.292-.128 1.608c-.064.246-.155.417-.272.512a.617.617 0 01-.4.143zm7.088.914v-1.147H10.35c.065-.111.149-.226.253-.343.104-.117.35-.354.74-.712.39-.357.66-.631.81-.821.225-.288.39-.562.493-.824.104-.263.156-.539.156-.829 0-.51-.181-.936-.544-1.279-.364-.342-.863-.514-1.499-.514-.58 0-1.063.148-1.45.444-.387.296-.617.784-.69 1.463l1.23.124c.024-.36.112-.619.264-.774.152-.155.357-.233.615-.233.261 0 .465.074.613.222.148.148.222.36.222.635 0 .25-.085.501-.255.756-.126.185-.467.536-1.024 1.055-.691.641-1.154 1.156-1.388 1.544-.235.389-.375.8-.422 1.233h4.328zm2.334 0v-1.235h-1.235V24h1.235zM5.714 34.11c.624 0 1.11-.22 1.46-.66.421-.533.632-1.408.632-2.627 0-1.222-.21-2.096-.629-2.624-.351-.445-.839-.668-1.463-.668-.624 0-1.11.22-1.459.66-.422.533-.633 1.406-.633 2.619 0 1.236.192 2.095.576 2.577.384.482.89.723 1.516.723zm0-1.024a.614.614 0 01-.398-.14c-.115-.094-.211-.283-.287-.565-.077-.283-.115-.802-.115-1.558s.043-1.294.128-1.613c.064-.246.155-.417.272-.512a.617.617 0 01.4-.143c.15 0 .282.048.398.143.116.095.211.284.288.567.076.283.114.802.114 1.558s-.043 1.292-.128 1.608c-.064.246-.155.417-.272.512a.617.617 0 01-.4.143zm4.992 1.024c.616 0 1.13-.2 1.543-.598.413-.398.62-.88.62-1.446 0-.39-.111-.722-.332-.997a1.5 1.5 0 00-.886-.532c.618-.337.927-.788.927-1.353 0-.399-.15-.756-.452-1.073-.366-.386-.853-.58-1.46-.58-.354 0-.674.067-.96.2a1.617 1.617 0 00-.667.55c-.16.232-.28.544-.359.933l1.139.194c.032-.282.123-.495.272-.642.15-.146.33-.22.54-.22.214 0 .386.065.515.194s.193.302.193.518c0 .255-.088.46-.264.613-.175.154-.43.227-.764.218l-.136 1.006c.22-.061.408-.092.566-.092.24 0 .444.09.611.272.167.182.25.428.25.739 0 .328-.086.589-.26.782a.833.833 0 01-.644.29.841.841 0 01-.607-.242c-.167-.16-.27-.394-.308-.698l-1.195.145c.062.542.284.98.668 1.316.384.335.867.503 1.45.503zm4.43-.11v-1.235h-1.235V34h1.235z"/></g></svg>\n';
      var SM =
        '<svg viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><g><path d="M35 29a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17z" fill-opacity=".163"/><path d="M11.88 8.7V7.558h-1.234V8.7h1.234zm0 5.3V9.333h-1.234V14h1.234zm2.5 0v-1.235h-1.234V14h1.235zM9.63 18.7v-1.142H8.395V18.7H9.63zm0 5.3v-4.667H8.395V24H9.63zm2.5-5.3v-1.142h-1.234V18.7h1.235zm0 5.3v-4.667h-1.234V24h1.235zm2.501 0v-1.235h-1.235V24h1.235zM7.38 28.7v-1.142H6.145V28.7H7.38zm0 5.3v-4.667H6.145V34H7.38zm2.5-5.3v-1.142H8.646V28.7H9.88zm0 5.3v-4.667H8.646V34H9.88zm2.5-5.3v-1.142h-1.234V28.7h1.235zm0 5.3v-4.667h-1.234V34h1.235zm2.501 0v-1.235h-1.235V34h1.235z"/></g></svg>\n';
      var MM =
        '<svg viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><g><path d="M35 29a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17z" fill-opacity=".163"/><path d="M11.916 15V8.558h-1.301V15h1.3zm2.465 0v-1.235h-1.235V15h1.235zM9.665 25v-6.442h-1.3V25h1.3zm2.5 0v-6.442h-1.3V25h1.3zm2.466 0v-1.235h-1.235V25h1.235zM7.415 34v-6.442h-1.3V34h1.3zm2.5 0v-6.442h-1.3V34h1.3zm2.501 0v-6.442h-1.3V34h1.3zm2.465 0v-1.235h-1.235V34h1.235z"/></g></svg>\n';
      var IM =
        '<svg viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><g><path d="M35 29a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17z" fill-opacity=".163"/><path d="M9.62 14.105c.272 0 .528-.05.768-.153s.466-.257.677-.462c.009.024.023.072.044.145.047.161.086.283.119.365h1.221a2.649 2.649 0 01-.222-.626c-.04-.195-.059-.498-.059-.908l.013-1.441c0-.536-.055-.905-.165-1.105-.11-.201-.3-.367-.569-.497-.27-.13-.68-.195-1.23-.195-.607 0-1.064.108-1.371.325-.308.217-.525.55-.65 1.002l1.12.202c.076-.217.176-.369.299-.455.123-.086.294-.13.514-.13.325 0 .546.05.663.152.118.101.176.27.176.508v.123c-.222.093-.622.194-1.2.303-.427.082-.755.178-.982.288-.227.11-.403.268-.53.474a1.327 1.327 0 00-.188.706c0 .398.138.728.415.988.277.261.656.391 1.136.391zm.368-.87a.675.675 0 01-.492-.189.606.606 0 01-.193-.448c0-.176.08-.32.241-.435.106-.07.33-.142.673-.215.343-.073.593-.136.751-.19v.247c0 .296-.016.496-.048.602a.773.773 0 01-.295.409 1.07 1.07 0 01-.637.22zm4.645.765v-1.235h-1.235V14h1.235zM10.2 25.105c.542 0 1.003-.215 1.382-.646.38-.43.57-1.044.57-1.84 0-.771-.187-1.362-.559-1.774a1.82 1.82 0 00-1.41-.617c-.522 0-.973.216-1.354.65v-2.32H7.594V25h1.147v-.686c.188.261.411.458.67.592.26.133.523.2.79.2zm-.299-.975c-.354 0-.638-.164-.852-.492-.153-.232-.229-.59-.229-1.073 0-.468.098-.818.295-1.048a.93.93 0 01.738-.345c.302 0 .55.118.743.354.193.236.29.62.29 1.154 0 .5-.096.868-.288 1.1-.192.233-.424.35-.697.35zm4.478.87v-1.235h-1.234V25h1.234zM10.362 34.105c.6 0 1.08-.142 1.437-.426.357-.284.599-.704.725-1.261l-1.213-.207c-.061.326-.167.555-.316.688a.832.832 0 01-.576.2.916.916 0 01-.75-.343c-.185-.228-.278-.62-.278-1.173 0-.498.091-.853.274-1.066.183-.212.429-.318.736-.318.232 0 .42.061.565.184.145.123.238.306.28.55l1.216-.22c-.146-.501-.387-.874-.722-1.119-.336-.244-.788-.366-1.356-.366-.695 0-1.245.214-1.653.643-.407.43-.61 1.03-.61 1.8 0 .762.202 1.358.608 1.788.406.431.95.646 1.633.646zM14.633 34v-1.235h-1.235V34h1.235z"/></g></svg>\n';
      var NM =
        '<svg viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><g><path d="M35 29a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17zm0-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h17z" fill-opacity=".163"/><path d="M7.88 15l.532-1.463h2.575L11.549 15h1.415l-2.58-6.442H9.01L6.5 15h1.38zm2.69-2.549H8.811l.87-2.39.887 2.39zM14.88 15v-1.235h-1.234V15h1.234zM9.352 25c.83-.006 1.352-.02 1.569-.044.346-.038.636-.14.872-.305.236-.166.422-.387.558-.664.137-.277.205-.562.205-.855 0-.372-.106-.695-.317-.97-.21-.276-.512-.471-.905-.585.278-.126.499-.315.661-.567a1.5 1.5 0 00.244-.83c0-.28-.066-.53-.197-.754a1.654 1.654 0 00-.495-.539 1.676 1.676 0 00-.672-.266c-.25-.042-.63-.063-1.14-.063H7.158V25h2.193zm.142-3.88H8.46v-1.49h.747c.612 0 .983.007 1.112.022.217.026.38.102.49.226.11.125.165.287.165.486a.68.68 0 01-.192.503.86.86 0 01-.525.23 11.47 11.47 0 01-.944.023h.18zm.17 2.795H8.46v-1.723h1.05c.592 0 .977.03 1.154.092.177.062.313.16.406.295a.84.84 0 01.14.492c0 .228-.06.41-.181.547a.806.806 0 01-.473.257c-.126.026-.423.04-.892.04zM14.88 25v-1.235h-1.234V25h1.234zM9.862 34.11c.691 0 1.262-.17 1.711-.512.45-.341.772-.864.965-1.567l-1.261-.4c-.109.472-.287.818-.536 1.037-.25.22-.547.33-.892.33-.47 0-.85-.173-1.143-.519-.293-.345-.44-.925-.44-1.74 0-.767.15-1.322.447-1.665.297-.343.684-.514 1.162-.514.346 0 .64.096.881.29.242.193.4.457.477.79l1.288-.307c-.147-.516-.367-.911-.66-1.187-.492-.465-1.132-.698-1.92-.698-.902 0-1.63.296-2.184.89-.554.593-.83 1.426-.83 2.498 0 1.014.275 1.813.825 2.397.551.585 1.254.877 2.11.877zM14.88 34v-1.235h-1.234V34h1.234z"/></g></svg>\n';
      var OM = i(102);
      class zM extends ok {
        static get pluginName() {
          return 'ListStyleUI';
        }
        init() {
          const e = this.editor;
          const t = e.locale.t;
          e.ui.componentFactory.add(
            'bulletedList',
            RM({
              editor: e,
              parentCommandName: 'bulletedList',
              buttonLabel: t('Bulleted List'),
              buttonIcon: dM,
              toolbarAriaLabel: t('Bulleted list styles toolbar'),
              styleDefinitions: [
                {
                  label: t('Toggle the disc list style'),
                  tooltip: t('Disc'),
                  type: 'disc',
                  icon: AM,
                },
                {
                  label: t('Toggle the circle list style'),
                  tooltip: t('Circle'),
                  type: 'circle',
                  icon: TM,
                },
                {
                  label: t('Toggle the square list style'),
                  tooltip: t('Square'),
                  type: 'square',
                  icon: CM,
                },
              ],
            })
          );
          e.ui.componentFactory.add(
            'numberedList',
            RM({
              editor: e,
              parentCommandName: 'numberedList',
              buttonLabel: t('Numbered List'),
              buttonIcon: lM,
              toolbarAriaLabel: t('Numbered list styles toolbar'),
              styleDefinitions: [
                {
                  label: t('Toggle the decimal list style'),
                  tooltip: t('Decimal'),
                  type: 'decimal',
                  icon: PM,
                },
                {
                  label: t('Toggle the decimal with leading zero list style'),
                  tooltip: t('Decimal with leading zero'),
                  type: 'decimal-leading-zero',
                  icon: EM,
                },
                {
                  label: t('Toggle the lower–roman list style'),
                  tooltip: t('Lower–roman'),
                  type: 'lower-roman',
                  icon: SM,
                },
                {
                  label: t('Toggle the upper–roman list style'),
                  tooltip: t('Upper-roman'),
                  type: 'upper-roman',
                  icon: MM,
                },
                {
                  label: t('Toggle the lower–latin list style'),
                  tooltip: t('Lower-latin'),
                  type: 'lower-latin',
                  icon: IM,
                },
                {
                  label: t('Toggle the upper–latin list style'),
                  tooltip: t('Upper-latin'),
                  type: 'upper-latin',
                  icon: NM,
                },
              ],
            })
          );
        }
      }
      function RM({
        editor: e,
        parentCommandName: t,
        buttonLabel: i,
        buttonIcon: n,
        toolbarAriaLabel: o,
        styleDefinitions: r,
      }) {
        const s = e.commands.get(t);
        const a = e.commands.get('listStyle');
        return (c) => {
          const l = Bw(c, eC);
          const d = l.buttonView;
          const u = LM({
            editor: e,
            parentCommandName: t,
            listStyleCommand: a,
          });
          Fw(l, r.map(u));
          l.bind('isEnabled').to(s);
          l.toolbarView.ariaLabel = o;
          l.class = 'ck-list-styles-dropdown';
          d.on('execute', () => {
            e.execute(t);
            e.editing.view.focus();
          });
          d.set({ label: i, icon: n, tooltip: true, isToggleable: true });
          d.bind('isOn').to(s, 'value', (e) => !!e);
          return l;
        };
      }
      function LM({ editor: e, listStyleCommand: t, parentCommandName: i }) {
        const n = e.locale;
        const o = e.commands.get(i);
        return ({ label: r, type: s, icon: a, tooltip: c }) => {
          const l = new Ew(n);
          l.set({ label: r, icon: a, tooltip: c });
          t.on('change:value', () => {
            l.isOn = t.value === s;
          });
          l.on('execute', () => {
            if (o.value) {
              if (t.value !== s) {
                e.execute('listStyle', { type: s });
              } else {
                e.execute('listStyle', { type: t._defaultType });
              }
            } else {
              e.model.change(() => {
                e.execute(i);
                e.execute('listStyle', { type: s });
              });
            }
            e.editing.view.focus();
          });
          return l;
        };
      }
      class VM extends ok {
        static get requires() {
          return [pM, zM];
        }
        static get pluginName() {
          return 'ListStyle';
        }
      }
      function DM(e, t) {
        return (e) => {
          e.on('attribute:url:media', i);
        };
        function i(i, n, o) {
          if (!o.consumable.consume(n.item, i.name)) {
            return;
          }
          const r = n.attributeNewValue;
          const s = o.writer;
          const a = o.mapper.toViewElement(n.item);
          const c = [...a.getChildren()].find((e) =>
            e.getCustomProperty('media-content')
          );
          s.remove(c);
          const l = e.getMediaViewElement(s, r, t);
          s.insert(s.createPositionAt(a, 0), l);
        }
      }
      function jM(e, t, i) {
        t.setCustomProperty('media', true, e);
        return I_(e, t, { label: i });
      }
      function BM(e) {
        const t = e.getSelectedElement();
        if (t && FM(t)) {
          return t;
        }
        return null;
      }
      function FM(e) {
        return !!e.getCustomProperty('media') && M_(e);
      }
      function HM(e, t, i, n) {
        const o = e.createContainerElement('figure', { class: 'media' });
        e.insert(e.createPositionAt(o, 0), t.getMediaViewElement(e, i, n));
        return o;
      }
      function UM(e) {
        const t = e.getSelectedElement();
        if (t && t.is('element', 'media')) {
          return t;
        }
        return null;
      }
      function qM(e, t, i) {
        e.change((n) => {
          const o = n.createElement('media', { url: t });
          e.insertContent(o, i);
          n.setSelection(o, 'on');
        });
      }
      class WM extends sk {
        refresh() {
          const e = this.editor.model;
          const t = e.document.selection;
          const i = e.schema;
          const n = t.getFirstPosition();
          const o = UM(t);
          let r = n.parent;
          if (r != r.root) {
            r = r.parent;
          }
          this.value = o ? o.getAttribute('url') : null;
          this.isEnabled = i.checkChild(r, 'media');
        }
        execute(e) {
          const t = this.editor.model;
          const i = t.document.selection;
          const n = UM(i);
          if (n) {
            t.change((t) => {
              t.setAttribute('url', e, n);
            });
          } else {
            const n = L_(i, t);
            qM(t, e, n);
          }
        }
      }
      var $M =
        '<svg viewBox="0 0 64 42" xmlns="http://www.w3.org/2000/svg"><path d="M47.426 17V3.713L63.102 0v19.389h-.001l.001.272c0 1.595-2.032 3.43-4.538 4.098-2.506.668-4.538-.083-4.538-1.678 0-1.594 2.032-3.43 4.538-4.098.914-.244 2.032-.565 2.888-.603V4.516L49.076 7.447v9.556A1.014 1.014 0 0 0 49 17h-1.574zM29.5 17h-8.343a7.073 7.073 0 1 0-4.657 4.06v3.781H3.3a2.803 2.803 0 0 1-2.8-2.804V8.63a2.803 2.803 0 0 1 2.8-2.805h4.082L8.58 2.768A1.994 1.994 0 0 1 10.435 1.5h8.985c.773 0 1.477.448 1.805 1.149l1.488 3.177H26.7c1.546 0 2.8 1.256 2.8 2.805V17zm-11.637 0H17.5a1 1 0 0 0-1 1v.05A4.244 4.244 0 1 1 17.863 17zm29.684 2c.97 0 .953-.048.953.889v20.743c0 .953.016.905-.953.905H19.453c-.97 0-.953.048-.953-.905V19.89c0-.937-.016-.889.97-.889h28.077zm-4.701 19.338V22.183H24.154v16.155h18.692zM20.6 21.375v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616V37.53H20.6zm24.233-16.155v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615V37.53h-1.615zM29.485 25.283a.4.4 0 0 1 .593-.35l9.05 4.977a.4.4 0 0 1 0 .701l-9.05 4.978a.4.4 0 0 1-.593-.35v-9.956z"/></svg>';
      const GM = '0 0 64 42';
      class YM {
        constructor(e, t) {
          const i = t.providers;
          const n = t.extraProviders || [];
          const o = new Set(t.removeProviders);
          const r = i.concat(n).filter((e) => {
            const t = e.name;
            if (!t) {
              console.warn(
                Object(ss['a'])(
                  'media-embed-no-provider-name: The configured media provider has no name and cannot be used.'
                ),
                { provider: e }
              );
              return false;
            }
            return !o.has(t);
          });
          this.locale = e;
          this.providerDefinitions = r;
        }
        hasMedia(e) {
          return !!this._getMedia(e);
        }
        getMediaViewElement(e, t, i) {
          return this._getMedia(t).getViewElement(e, i);
        }
        _getMedia(e) {
          if (!e) {
            return new KM(this.locale);
          }
          e = e.trim();
          for (const t of this.providerDefinitions) {
            const i = t.html;
            let n = t.url;
            if (!Array.isArray(n)) {
              n = [n];
            }
            for (const t of n) {
              const n = this._getUrlMatches(e, t);
              if (n) {
                return new KM(this.locale, e, n, i);
              }
            }
          }
          return null;
        }
        _getUrlMatches(e, t) {
          let i = e.match(t);
          if (i) {
            return i;
          }
          let n = e.replace(/^https?:\/\//, '');
          i = n.match(t);
          if (i) {
            return i;
          }
          n = n.replace(/^www\./, '');
          i = n.match(t);
          if (i) {
            return i;
          }
          return null;
        }
      }
      class KM {
        constructor(e, t, i, n) {
          this.url = this._getValidUrl(t);
          this._t = e.t;
          this._match = i;
          this._previewRenderer = n;
        }
        getViewElement(e, t) {
          const i = {};
          let n;
          if (
            t.renderForEditingView ||
            (t.renderMediaPreview && this.url && this._previewRenderer)
          ) {
            if (this.url) {
              i['data-oembed-url'] = this.url;
            }
            if (t.renderForEditingView) {
              i.class = 'ck-media__wrapper';
            }
            const o = this._getPreviewHtml(t);
            n = e.createRawElement('div', i, function (e) {
              e.innerHTML = o;
            });
          } else {
            if (this.url) {
              i.url = this.url;
            }
            n = e.createEmptyElement('oembed', i);
          }
          e.setCustomProperty('media-content', true, n);
          return n;
        }
        _getPreviewHtml(e) {
          if (this._previewRenderer) {
            return this._previewRenderer(this._match);
          } else {
            if (this.url && e.renderForEditingView) {
              return this._getPlaceholderHtml();
            }
            return '';
          }
        }
        _getPlaceholderHtml() {
          const e = new Cw();
          const t = new Aw();
          e.text = this._t('Open media in new tab');
          t.content = $M;
          t.viewBox = GM;
          const i = new mb({
            tag: 'div',
            attributes: { class: 'ck ck-reset_all ck-media__placeholder' },
            children: [
              {
                tag: 'div',
                attributes: { class: 'ck-media__placeholder__icon' },
                children: [t],
              },
              {
                tag: 'a',
                attributes: {
                  class: 'ck-media__placeholder__url',
                  target: '_blank',
                  rel: 'noopener noreferrer',
                  href: this.url,
                },
                children: [
                  {
                    tag: 'span',
                    attributes: { class: 'ck-media__placeholder__url__text' },
                    children: [this.url],
                  },
                  e,
                ],
              },
            ],
          }).render();
          return i.outerHTML;
        }
        _getValidUrl(e) {
          if (!e) {
            return null;
          }
          if (e.match(/^https?/)) {
            return e;
          }
          return 'https://' + e;
        }
      }
      var QM = i(104);
      class JM extends ok {
        static get pluginName() {
          return 'MediaEmbedEditing';
        }
        constructor(e) {
          super(e);
          e.config.define('mediaEmbed', {
            providers: [
              {
                name: 'dailymotion',
                url: /^dailymotion\.com\/video\/(\w+)/,
                html: (e) => {
                  const t = e[1];
                  return (
                    '<div style="position: relative; padding-bottom: 100%; height: 0; ">' +
                    `<iframe src="https://www.dailymotion.com/embed/video/${t}" ` +
                    'style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" ' +
                    'frameborder="0" width="480" height="270" allowfullscreen allow="autoplay">' +
                    '</iframe>' +
                    '</div>'
                  );
                },
              },
              {
                name: 'spotify',
                url: [
                  /^open\.spotify\.com\/(artist\/\w+)/,
                  /^open\.spotify\.com\/(album\/\w+)/,
                  /^open\.spotify\.com\/(track\/\w+)/,
                ],
                html: (e) => {
                  const t = e[1];
                  return (
                    '<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 126%;">' +
                    `<iframe src="https://open.spotify.com/embed/${t}" ` +
                    'style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" ' +
                    'frameborder="0" allowtransparency="true" allow="encrypted-media">' +
                    '</iframe>' +
                    '</div>'
                  );
                },
              },
              {
                name: 'youtube',
                url: [
                  /^(?:m\.)?youtube\.com\/watch\?v=([\w-]+)/,
                  /^(?:m\.)?youtube\.com\/v\/([\w-]+)/,
                  /^youtube\.com\/embed\/([\w-]+)/,
                  /^youtu\.be\/([\w-]+)/,
                ],
                html: (e) => {
                  const t = e[1];
                  return (
                    '<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;">' +
                    `<iframe src="https://www.youtube.com/embed/${t}" ` +
                    'style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" ' +
                    'frameborder="0" allow="autoplay; encrypted-media" allowfullscreen>' +
                    '</iframe>' +
                    '</div>'
                  );
                },
              },
              {
                name: 'vimeo',
                url: [
                  /^vimeo\.com\/(\d+)/,
                  /^vimeo\.com\/[^/]+\/[^/]+\/video\/(\d+)/,
                  /^vimeo\.com\/album\/[^/]+\/video\/(\d+)/,
                  /^vimeo\.com\/channels\/[^/]+\/(\d+)/,
                  /^vimeo\.com\/groups\/[^/]+\/videos\/(\d+)/,
                  /^vimeo\.com\/ondemand\/[^/]+\/(\d+)/,
                  /^player\.vimeo\.com\/video\/(\d+)/,
                ],
                html: (e) => {
                  const t = e[1];
                  return (
                    '<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;">' +
                    `<iframe src="https://player.vimeo.com/video/${t}" ` +
                    'style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" ' +
                    'frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen>' +
                    '</iframe>' +
                    '</div>'
                  );
                },
              },
              { name: 'instagram', url: /^instagram\.com\/p\/(\w+)/ },
              { name: 'twitter', url: /^twitter\.com/ },
              { name: 'googleMaps', url: /^google\.com\/maps/ },
              { name: 'flickr', url: /^flickr\.com/ },
              { name: 'facebook', url: /^facebook\.com/ },
            ],
          });
          this.registry = new YM(e.locale, e.config.get('mediaEmbed'));
        }
        init() {
          const e = this.editor;
          const t = e.model.schema;
          const i = e.t;
          const n = e.conversion;
          const o = e.config.get('mediaEmbed.previewsInData');
          const r = this.registry;
          e.commands.add('mediaEmbed', new WM(e));
          t.register('media', {
            isObject: true,
            isBlock: true,
            allowWhere: '$block',
            allowAttributes: ['url'],
          });
          n.for('dataDowncast').elementToElement({
            model: 'media',
            view: (e, { writer: t }) => {
              const i = e.getAttribute('url');
              return HM(t, r, i, { renderMediaPreview: i && o });
            },
          });
          n.for('dataDowncast').add(DM(r, { renderMediaPreview: o }));
          n.for('editingDowncast').elementToElement({
            model: 'media',
            view: (e, { writer: t }) => {
              const n = e.getAttribute('url');
              const o = HM(t, r, n, { renderForEditingView: true });
              return jM(o, t, i('media widget'));
            },
          });
          n.for('editingDowncast').add(DM(r, { renderForEditingView: true }));
          n.for('upcast')
            .elementToElement({
              view: { name: 'oembed', attributes: { url: true } },
              model: (e, { writer: t }) => {
                const i = e.getAttribute('url');
                if (r.hasMedia(i)) {
                  return t.createElement('media', { url: i });
                }
              },
            })
            .elementToElement({
              view: { name: 'div', attributes: { 'data-oembed-url': true } },
              model: (e, { writer: t }) => {
                const i = e.getAttribute('data-oembed-url');
                if (r.hasMedia(i)) {
                  return t.createElement('media', { url: i });
                }
              },
            });
        }
      }
      const ZM =
        /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=]+$/;
      class XM extends ok {
        static get requires() {
          return [Vv, hA];
        }
        static get pluginName() {
          return 'AutoMediaEmbed';
        }
        constructor(e) {
          super(e);
          this._timeoutId = null;
          this._positionToInsert = null;
        }
        init() {
          const e = this.editor;
          const t = e.model.document;
          this.listenTo(e.plugins.get(Vv), 'inputTransformation', () => {
            const e = t.selection.getFirstRange();
            const i = Jm.fromPosition(e.start);
            i.stickiness = 'toPrevious';
            const n = Jm.fromPosition(e.end);
            n.stickiness = 'toNext';
            t.once(
              'change:data',
              () => {
                this._embedMediaBetweenPositions(i, n);
                i.detach();
                n.detach();
              },
              { priority: 'high' }
            );
          });
          e.commands.get('undo').on(
            'execute',
            () => {
              if (this._timeoutId) {
                Vd.window.clearTimeout(this._timeoutId);
                this._positionToInsert.detach();
                this._timeoutId = null;
                this._positionToInsert = null;
              }
            },
            { priority: 'high' }
          );
        }
        _embedMediaBetweenPositions(e, t) {
          const i = this.editor;
          const n = i.plugins.get(JM).registry;
          const o = new ff(e, t);
          const r = o.getWalker({ ignoreElementEnd: true });
          let s = '';
          for (const e of r) {
            if (e.item.is('$textProxy')) {
              s += e.item.data;
            }
          }
          s = s.trim();
          if (!s.match(ZM)) {
            o.detach();
            return;
          }
          if (!n.hasMedia(s)) {
            o.detach();
            return;
          }
          const a = i.commands.get('mediaEmbed');
          if (!a.isEnabled) {
            o.detach();
            return;
          }
          this._positionToInsert = Jm.fromPosition(e);
          this._timeoutId = Vd.window.setTimeout(() => {
            i.model.change((e) => {
              this._timeoutId = null;
              e.remove(o);
              o.detach();
              let t;
              if (this._positionToInsert.root.rootName !== '$graveyard') {
                t = this._positionToInsert;
              }
              qM(i.model, s, t);
              this._positionToInsert.detach();
              this._positionToInsert = null;
            });
          }, 100);
        }
      }
      var eI = i(106);
      class tI extends Hb {
        constructor(e, t) {
          super(t);
          const i = t.t;
          this.focusTracker = new Qp();
          this.keystrokes = new Vp();
          this.urlInputView = this._createUrlInput();
          this.saveButtonView = this._createButton(
            i('Save'),
            $C,
            'ck-button-save'
          );
          this.saveButtonView.type = 'submit';
          this.cancelButtonView = this._createButton(
            i('Cancel'),
            GC,
            'ck-button-cancel',
            'cancel'
          );
          this._focusables = new hb();
          this._focusCycler = new rw({
            focusables: this._focusables,
            focusTracker: this.focusTracker,
            keystrokeHandler: this.keystrokes,
            actions: { focusPrevious: 'shift + tab', focusNext: 'tab' },
          });
          this._validators = e;
          this.setTemplate({
            tag: 'form',
            attributes: { class: ['ck', 'ck-media-form'], tabindex: '-1' },
            children: [
              this.urlInputView,
              this.saveButtonView,
              this.cancelButtonView,
            ],
          });
        }
        render() {
          super.render();
          WC({ view: this });
          const e = [
            this.urlInputView,
            this.saveButtonView,
            this.cancelButtonView,
          ];
          e.forEach((e) => {
            this._focusables.add(e);
            this.focusTracker.add(e.element);
          });
          this.keystrokes.listenTo(this.element);
          const t = (e) => e.stopPropagation();
          this.keystrokes.set('arrowright', t);
          this.keystrokes.set('arrowleft', t);
          this.keystrokes.set('arrowup', t);
          this.keystrokes.set('arrowdown', t);
          this.listenTo(
            this.urlInputView.element,
            'selectstart',
            (e, t) => {
              t.stopPropagation();
            },
            { priority: 'high' }
          );
        }
        focus() {
          this._focusCycler.focusFirst();
        }
        get url() {
          return this.urlInputView.fieldView.element.value.trim();
        }
        set url(e) {
          this.urlInputView.fieldView.element.value = e.trim();
        }
        isValid() {
          this.resetFormStatus();
          for (const e of this._validators) {
            const t = e(this);
            if (t) {
              this.urlInputView.errorText = t;
              return false;
            }
          }
          return true;
        }
        resetFormStatus() {
          this.urlInputView.errorText = null;
          this.urlInputView.infoText = this._urlInputViewInfoDefault;
        }
        _createUrlInput() {
          const e = this.locale.t;
          const t = new BC(this.locale, UC);
          const i = t.fieldView;
          this._urlInputViewInfoDefault = e(
            'Paste the media URL in the input.'
          );
          this._urlInputViewInfoTip = e(
            'Tip: Paste the URL into the content to embed faster.'
          );
          t.label = e('Media URL');
          t.infoText = this._urlInputViewInfoDefault;
          i.placeholder = 'https://example.com';
          i.on('input', () => {
            t.infoText = i.element.value
              ? this._urlInputViewInfoTip
              : this._urlInputViewInfoDefault;
          });
          return t;
        }
        _createButton(e, t, i, n) {
          const o = new Ew(this.locale);
          o.set({ label: e, icon: t, tooltip: true });
          o.extendTemplate({ attributes: { class: i } });
          if (n) {
            o.delegate('execute').to(this, n);
          }
          return o;
        }
      }
      var iI =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M18.68 3.03c.6 0 .59-.03.59.55v12.84c0 .59.01.56-.59.56H1.29c-.6 0-.59.03-.59-.56V3.58c0-.58-.01-.55.6-.55h17.38zM15.77 15V5H4.2v10h11.57zM2 4v1h1V4H2zm0 2v1h1V6H2zm0 2v1h1V8H2zm0 2v1h1v-1H2zm0 2v1h1v-1H2zm0 2v1h1v-1H2zM17 4v1h1V4h-1zm0 2v1h1V6h-1zm0 2v1h1V8h-1zm0 2v1h1v-1h-1zm0 2v1h1v-1h-1zm0 2v1h1v-1h-1zM7.5 7.177a.4.4 0 0 1 .593-.351l5.133 2.824a.4.4 0 0 1 0 .7l-5.133 2.824a.4.4 0 0 1-.593-.35V7.176v.001z"/></svg>';
      class nI extends ok {
        static get requires() {
          return [JM];
        }
        static get pluginName() {
          return 'MediaEmbedUI';
        }
        init() {
          const e = this.editor;
          const t = e.commands.get('mediaEmbed');
          const i = e.plugins.get(JM).registry;
          e.ui.componentFactory.add('mediaEmbed', (n) => {
            const o = Bw(n);
            const r = new tI(oI(e.t, i), e.locale);
            this._setUpDropdown(o, r, t, e);
            this._setUpForm(o, r, t);
            return o;
          });
        }
        _setUpDropdown(e, t, i) {
          const n = this.editor;
          const o = n.t;
          const r = e.buttonView;
          e.bind('isEnabled').to(i);
          e.panelView.children.add(t);
          r.set({ label: o('Insert media'), icon: iI, tooltip: true });
          r.on(
            'open',
            () => {
              t.url = i.value || '';
              t.urlInputView.fieldView.select();
              t.focus();
            },
            { priority: 'low' }
          );
          e.on('submit', () => {
            if (t.isValid()) {
              n.execute('mediaEmbed', t.url);
              s();
            }
          });
          e.on('change:isOpen', () => t.resetFormStatus());
          e.on('cancel', () => s());
          function s() {
            n.editing.view.focus();
            e.isOpen = false;
          }
        }
        _setUpForm(e, t, i) {
          t.delegate('submit', 'cancel').to(e);
          t.urlInputView.bind('value').to(i, 'value');
          t.urlInputView.bind('isReadOnly').to(i, 'isEnabled', (e) => !e);
          t.saveButtonView.bind('isEnabled').to(i);
        }
      }
      function oI(e, t) {
        return [
          (t) => {
            if (!t.url.length) {
              return e('The URL must not be empty.');
            }
          },
          (i) => {
            if (!t.hasMedia(i.url)) {
              return e('This media URL is not supported.');
            }
          },
        ];
      }
      var rI = i(108);
      class sI extends ok {
        static get requires() {
          return [JM, nI, XM, zC];
        }
        static get pluginName() {
          return 'MediaEmbed';
        }
      }
      class aI extends ok {
        static get requires() {
          return [gE];
        }
        static get pluginName() {
          return 'MediaEmbedToolbar';
        }
        afterInit() {
          const e = this.editor;
          const t = e.t;
          const i = e.plugins.get(gE);
          i.register('mediaEmbed', {
            ariaLabel: t('Media toolbar'),
            items: e.config.get('mediaEmbed.toolbar') || [],
            getRelatedElement: BM,
          });
        }
      }
      class cI extends sk {
        refresh() {
          const e = this.editor.model;
          const t = e.document;
          this.isEnabled = e.schema.checkAttributeInSelection(
            t.selection,
            'mention'
          );
        }
        execute(e) {
          const t = this.editor.model;
          const i = t.document;
          const n = i.selection;
          const o =
            typeof e.mention == 'string' ? { id: e.mention } : e.mention;
          const r = o.id;
          const s = e.range || n.getFirstRange();
          const a = e.text || r;
          const c = dI({ _text: a, id: r }, o);
          if (e.marker.length != 1) {
            throw new ss['b'](
              'mentioncommand-incorrect-marker: The marker must be a single character.',
              this
            );
          }
          if (r.charAt(0) != e.marker) {
            throw new ss['b'](
              'mentioncommand-incorrect-id: The item id must start with the marker character.',
              this
            );
          }
          t.change((e) => {
            const i = Us(n.getAttributes());
            const o = new Map(i.entries());
            o.set('mention', c);
            t.insertContent(e.createText(a, o), s);
            t.insertContent(
              e.createText(' ', i),
              s.start.getShiftedBy(a.length)
            );
          });
        }
      }
      class lI extends ok {
        static get pluginName() {
          return 'MentionEditing';
        }
        init() {
          const e = this.editor;
          const t = e.model;
          const i = t.document;
          t.schema.extend('$text', { allowAttributes: 'mention' });
          e.conversion.for('upcast').elementToAttribute({
            view: { name: 'span', key: 'data-mention', classes: 'mention' },
            model: { key: 'mention', value: uI },
          });
          e.conversion
            .for('downcast')
            .attributeToElement({ model: 'mention', view: fI });
          e.conversion.for('downcast').add(hI);
          i.registerPostFixer((e) => pI(e, i, t.schema));
          i.registerPostFixer((e) => bI(e, i));
          i.registerPostFixer((e) => gI(e, i));
          e.commands.add('mention', new cI(e));
        }
      }
      function dI(e, t) {
        return Object.assign({ uid: is() }, e, t || {});
      }
      function uI(e, t) {
        const i = e.getAttribute('data-mention');
        const n = e.getChild(0);
        if (!n) {
          return;
        }
        const o = { id: i, _text: n.data };
        return dI(o, t);
      }
      function hI(e) {
        e.on(
          'attribute:mention',
          (e, t, i) => {
            const n = t.attributeNewValue;
            if (!t.item.is('$textProxy') || !n) {
              return;
            }
            const o = t.range.start;
            const r = o.textNode || o.nodeAfter;
            if (r.data != n._text) {
              i.consumable.consume(t.item, e.name);
            }
          },
          { priority: 'highest' }
        );
      }
      function fI(e, { writer: t }) {
        if (!e) {
          return;
        }
        const i = { class: 'mention', 'data-mention': e.id };
        const n = { id: e.uid, priority: 20 };
        return t.createAttributeElement('span', i, n);
      }
      function gI(e, t) {
        const i = t.selection;
        const n = i.focus;
        if (i.isCollapsed && i.hasAttribute('mention') && mI(n)) {
          e.removeSelectionAttribute('mention');
          return true;
        }
      }
      function mI(e) {
        const t = e.isAtStart;
        const i = e.nodeBefore && e.nodeBefore.is('$text');
        return i || t;
      }
      function pI(e, t, i) {
        const n = t.differ.getChanges();
        let o = false;
        for (const t of n) {
          const n = t.position;
          if (t.name == '$text') {
            const t = n.textNode && n.textNode.nextSibling;
            o = kI(n.textNode, e) || o;
            o = kI(t, e) || o;
            o = kI(n.nodeBefore, e) || o;
            o = kI(n.nodeAfter, e) || o;
          }
          if (t.name != '$text' && t.type == 'insert') {
            const t = n.nodeAfter;
            for (const i of e.createRangeIn(t).getItems()) {
              o = kI(i, e) || o;
            }
          }
          if (t.type == 'insert' && i.isInline(t.name)) {
            const t = n.nodeAfter && n.nodeAfter.nextSibling;
            o = kI(n.nodeBefore, e) || o;
            o = kI(t, e) || o;
          }
        }
        return o;
      }
      function bI(e, t) {
        const i = t.differ.getChanges();
        let n = false;
        for (const t of i) {
          if (t.type === 'attribute' && t.attributeKey != 'mention') {
            const i = t.range.start.nodeBefore;
            const o = t.range.end.nodeAfter;
            for (const r of [i, o]) {
              if (
                wI(r) &&
                r.getAttribute(t.attributeKey) != t.attributeNewValue
              ) {
                e.setAttribute(t.attributeKey, t.attributeNewValue, r);
                n = true;
              }
            }
          }
        }
        return n;
      }
      function wI(e) {
        if (
          !e ||
          !(e.is('$text') || e.is('$textProxy')) ||
          !e.hasAttribute('mention')
        ) {
          return false;
        }
        const t = e.data;
        const i = e.getAttribute('mention');
        const n = i._text;
        return t != n;
      }
      function kI(e, t) {
        if (wI(e)) {
          t.removeAttribute('mention', e);
          return true;
        }
        return false;
      }
      var _I = i(110);
      class vI extends Nw {
        constructor(e) {
          super(e);
          this.extendTemplate({
            attributes: { class: ['ck-mentions'], tabindex: '-1' },
          });
        }
        selectFirst() {
          this.select(0);
        }
        selectNext() {
          const e = this.selected;
          const t = this.items.getIndex(e);
          this.select(t + 1);
        }
        selectPrevious() {
          const e = this.selected;
          const t = this.items.getIndex(e);
          this.select(t - 1);
        }
        select(e) {
          let t = 0;
          if (e > 0 && e < this.items.length) {
            t = e;
          } else if (e < 0) {
            t = this.items.length - 1;
          }
          const i = this.items.get(t);
          if (this.selected === i) {
            return;
          }
          if (this.selected) {
            this.selected.removeHighlight();
          }
          i.highlight();
          this.selected = i;
          if (!this._isItemVisibleInScrolledArea(i)) {
            this.element.scrollTop = i.element.offsetTop;
          }
        }
        executeSelected() {
          this.selected.fire('execute');
        }
        _isItemVisibleInScrolledArea(e) {
          return new Ch(this.element).contains(new Ch(e.element));
        }
      }
      class yI extends Hb {
        constructor(e, t) {
          super(e);
          this.template = false;
          this.domElement = t;
          this.domElement.classList.add('ck-button');
          this.set('isOn', false);
          this.on('change:isOn', (e, t, i) => {
            if (i) {
              this.domElement.classList.add('ck-on');
              this.domElement.classList.remove('ck-off');
            } else {
              this.domElement.classList.add('ck-off');
              this.domElement.classList.remove('ck-on');
            }
          });
          this.listenTo(this.domElement, 'click', () => {
            this.fire('execute');
          });
        }
        render() {
          super.render();
          this.element = this.domElement;
        }
      }
      class xI extends Ow {
        highlight() {
          const e = this.children.first;
          e.isOn = true;
        }
        removeHighlight() {
          const e = this.children.first;
          e.isOn = false;
        }
      }
      const AI = 3;
      const TI = [zl.arrowup, zl.arrowdown, zl.enter, zl.tab, zl.esc];
      class CI extends ok {
        static get pluginName() {
          return 'MentionUI';
        }
        static get requires() {
          return [tP];
        }
        constructor(e) {
          super(e);
          this._mentionsView = this._createMentionView();
          this._mentionsConfigurations = new Map();
          this._requestFeedDebounced = ph(this._requestFeed, 100);
          e.config.define('mention', { feeds: [] });
        }
        init() {
          const e = this.editor;
          this._balloon = e.plugins.get(tP);
          e.editing.view.document.on(
            'keydown',
            (e, t) => {
              if (NI(t.keyCode) && this._isUIVisible) {
                t.preventDefault();
                e.stop();
                if (t.keyCode == zl.arrowdown) {
                  this._mentionsView.selectNext();
                }
                if (t.keyCode == zl.arrowup) {
                  this._mentionsView.selectPrevious();
                }
                if (t.keyCode == zl.enter || t.keyCode == zl.tab) {
                  this._mentionsView.executeSelected();
                }
                if (t.keyCode == zl.esc) {
                  this._hideUIAndRemoveMarker();
                }
              }
            },
            { priority: 'highest' }
          );
          Vw({
            emitter: this._mentionsView,
            activator: () => this._isUIVisible,
            contextElements: [this._balloon.view.element],
            callback: () => this._hideUIAndRemoveMarker(),
          });
          const t = e.config.get('mention.feeds');
          for (const e of t) {
            const t = e.feed;
            const i = e.marker;
            if (!zI(i)) {
              throw new ss['b'](
                'mentionconfig-incorrect-marker: The marker must be provided and it must be a single character.',
                null
              );
            }
            const n = e.minimumCharacters || 0;
            const o = typeof t == 'function' ? t.bind(this.editor) : II(t);
            const r = this._setupTextWatcherForFeed(i, n);
            const s = e.itemRenderer;
            const a = {
              watcher: r,
              marker: i,
              feedCallback: o,
              itemRenderer: s,
            };
            this._mentionsConfigurations.set(i, a);
          }
          this.on('requestFeed:response', (e, t) =>
            this._handleFeedResponse(t)
          );
          this.on('requestFeed:error', () => this._hideUIAndRemoveMarker());
        }
        destroy() {
          super.destroy();
          this._mentionsView.destroy();
        }
        get _isUIVisible() {
          return this._balloon.visibleView === this._mentionsView;
        }
        _createMentionView() {
          const e = this.editor.locale;
          const t = new vI(e);
          this._items = new xs();
          t.items.bindTo(this._items).using((i) => {
            const { item: n, marker: o } = i;
            const r = new xI(e);
            const s = this._renderItem(n, o);
            s.delegate('execute').to(r);
            r.children.add(s);
            r.item = n;
            r.marker = o;
            r.on('execute', () => {
              t.fire('execute', { item: n, marker: o });
            });
            return r;
          });
          t.on('execute', (e, t) => {
            const i = this.editor;
            const n = i.model;
            const o = t.item;
            const r = t.marker;
            const s = i.model.markers.get('mention');
            const a = n.createPositionAt(n.document.selection.focus);
            const c = n.createPositionAt(s.getStart());
            const l = n.createRange(c, a);
            this._hideUIAndRemoveMarker();
            i.execute('mention', {
              mention: o,
              text: o.text,
              marker: r,
              range: l,
            });
            i.editing.view.focus();
          });
          return t;
        }
        _getItemRenderer(e) {
          const { itemRenderer: t } = this._mentionsConfigurations.get(e);
          return t;
        }
        _requestFeed(e, t) {
          this._lastRequested = t;
          const { feedCallback: i } = this._mentionsConfigurations.get(e);
          const n = i(t);
          const o = n instanceof Promise;
          if (!o) {
            this.fire('requestFeed:response', {
              feed: n,
              marker: e,
              feedText: t,
            });
            return;
          }
          n.then((i) => {
            if (this._lastRequested == t) {
              this.fire('requestFeed:response', {
                feed: i,
                marker: e,
                feedText: t,
              });
            } else {
              this.fire('requestFeed:discarded', {
                feed: i,
                marker: e,
                feedText: t,
              });
            }
          }).catch((e) => {
            this.fire('requestFeed:error', { error: e });
            console.warn(
              Object(ss['a'])(
                'mention-feed-callback-error: Could not obtain mention autocomplete feed.'
              )
            );
          });
        }
        _setupTextWatcherForFeed(e, t) {
          const i = this.editor;
          const n = new Nk(i.model, SI(e, t));
          n.on('matched', (t, n) => {
            const o = i.model.document.selection;
            const r = o.focus;
            if (OI(r)) {
              this._hideUIAndRemoveMarker();
              return;
            }
            const s = MI(e, n.text);
            const a = e.length + s.length;
            const c = r.getShiftedBy(-a);
            const l = r.getShiftedBy(-s.length);
            const d = i.model.createRange(c, l);
            if (RI(i)) {
              const e = i.model.markers.get('mention');
              i.model.change((t) => {
                t.updateMarker(e, { range: d });
              });
            } else {
              i.model.change((e) => {
                e.addMarker('mention', {
                  range: d,
                  usingOperation: false,
                  affectsData: false,
                });
              });
            }
            this._requestFeedDebounced(e, s);
          });
          n.on('unmatched', () => {
            this._hideUIAndRemoveMarker();
          });
          const o = i.commands.get('mention');
          n.bind('isEnabled').to(o);
          return n;
        }
        _handleFeedResponse(e) {
          const { feed: t, marker: i } = e;
          if (!RI(this.editor)) {
            return;
          }
          this._items.clear();
          for (const e of t) {
            const t = typeof e != 'object' ? { id: e, text: e } : e;
            this._items.add({ item: t, marker: i });
          }
          const n = this.editor.model.markers.get('mention');
          if (this._items.length) {
            this._showOrUpdateUI(n);
          } else {
            this._hideUIAndRemoveMarker();
          }
        }
        _showOrUpdateUI(e) {
          if (this._isUIVisible) {
            this._balloon.updatePosition(
              this._getBalloonPanelPositionData(e, this._mentionsView.position)
            );
          } else {
            this._balloon.add({
              view: this._mentionsView,
              position: this._getBalloonPanelPositionData(
                e,
                this._mentionsView.position
              ),
              withArrow: false,
              singleViewMode: true,
            });
          }
          this._mentionsView.position = this._balloon.view.position;
          this._mentionsView.selectFirst();
        }
        _hideUIAndRemoveMarker() {
          if (this._balloon.hasView(this._mentionsView)) {
            this._balloon.remove(this._mentionsView);
          }
          if (RI(this.editor)) {
            this.editor.model.change((e) => e.removeMarker('mention'));
          }
          this._mentionsView.position = undefined;
        }
        _renderItem(e, t) {
          const i = this.editor;
          let n;
          let o = e.id;
          const r = this._getItemRenderer(t);
          if (r) {
            const t = r(e);
            if (typeof t != 'string') {
              n = new yI(i.locale, t);
            } else {
              o = t;
            }
          }
          if (!n) {
            const e = new Ew(i.locale);
            e.label = o;
            e.withText = true;
            n = e;
          }
          return n;
        }
        _getBalloonPanelPositionData(e, t) {
          const i = this.editor;
          const n = i.editing;
          const o = n.view.domConverter;
          const r = n.mapper;
          return {
            target: () => {
              let t = e.getRange();
              if (t.start.root.rootName == '$graveyard') {
                t = i.model.document.selection.getFirstRange();
              }
              const n = r.toViewRange(t);
              const s = Ch.getDomRangeRects(o.viewRangeToDom(n));
              return s.pop();
            },
            limiter: () => {
              const e = this.editor.editing.view;
              const t = e.document;
              const i = t.selection.editableElement;
              if (i) {
                return e.domConverter.mapViewToDom(i.root);
              }
              return null;
            },
            positions: PI(t),
          };
        }
      }
      function PI(e) {
        const t = {
          caret_se: (e) => ({
            top: e.bottom + AI,
            left: e.right,
            name: 'caret_se',
          }),
          caret_ne: (e, t) => ({
            top: e.top - t.height - AI,
            left: e.right,
            name: 'caret_ne',
          }),
          caret_sw: (e, t) => ({
            top: e.bottom + AI,
            left: e.right - t.width,
            name: 'caret_sw',
          }),
          caret_nw: (e, t) => ({
            top: e.top - t.height - AI,
            left: e.right - t.width,
            name: 'caret_nw',
          }),
        };
        if (Object.prototype.hasOwnProperty.call(t, e)) {
          return [t[e]];
        }
        return [t.caret_se, t.caret_sw, t.caret_ne, t.caret_nw];
      }
      function EI(e, t) {
        const i = t == 0 ? '*' : `{${t},}`;
        const n = Cl.features.isRegExpUnicodePropertySupported
          ? '\\p{Ps}\\p{Pi}"\''
          : '\\(\\[{"\'';
        const o = '\\S';
        const r = `(?:^|[ ${n}])([${e}])([${o}]${i})$`;
        return new RegExp(r, 'u');
      }
      function SI(e, t) {
        const i = EI(e, t);
        return (e) => i.test(e);
      }
      function MI(e, t) {
        const i = EI(e, 0);
        const n = t.match(i);
        return n[2];
      }
      function II(e) {
        return (t) => {
          const i = e
            .filter((e) => {
              const i = typeof e == 'string' ? e : String(e.id);
              return i.toLowerCase().includes(t.toLowerCase());
            })
            .slice(0, 10);
          return i;
        };
      }
      function NI(e) {
        return TI.includes(e);
      }
      function OI(e) {
        const t = e.textNode && e.textNode.hasAttribute('mention');
        const i = e.nodeBefore;
        return t || (i && i.is('$text') && i.hasAttribute('mention'));
      }
      function zI(e) {
        return e && e.length == 1;
      }
      function RI(e) {
        return e.model.markers.has('mention');
      }
      var LI = i(112);
      class VI extends ok {
        toMentionAttribute(e, t) {
          return uI(e, t);
        }
        static get pluginName() {
          return 'Mention';
        }
        static get requires() {
          return [lI, CI];
        }
      }
      var DI = i(114);
      class jI extends Hb {
        constructor(e, t = {}) {
          super(e);
          const i = this.bindTemplate;
          this.set('label', t.label || '');
          this.set('class', t.class || null);
          this.children = this.createCollection();
          this.setTemplate({
            tag: 'div',
            attributes: { class: ['ck', 'ck-form__header', i.to('class')] },
            children: this.children,
          });
          const n = new Hb(e);
          n.setTemplate({
            tag: 'span',
            attributes: { class: ['ck', 'ck-form__header__label'] },
            children: [{ text: i.to('label') }],
          });
          this.children.add(n);
        }
      }
      class BI extends jI {
        constructor(e, t) {
          super(e);
          const i = e.t;
          this.set('class', 'ck-special-characters-navigation');
          this.groupDropdownView = this._createGroupDropdown(t);
          this.groupDropdownView.panelPosition =
            e.uiLanguageDirection === 'rtl' ? 'se' : 'sw';
          this.label = i('Special characters');
          this.children.add(this.groupDropdownView);
        }
        get currentGroupName() {
          return this.groupDropdownView.value;
        }
        _createGroupDropdown(e) {
          const t = this.locale;
          const i = t.t;
          const n = Bw(t);
          const o = this._getCharacterGroupListItemDefinitions(n, e);
          n.set('value', o.first.model.label);
          n.buttonView.bind('label').to(n, 'value');
          n.buttonView.set({
            isOn: false,
            withText: true,
            tooltip: i('Character categories'),
            class: ['ck-dropdown__button_label-width_auto'],
          });
          n.on('execute', (e) => {
            n.value = e.source.label;
          });
          n.delegate('execute').to(this);
          Hw(n, o);
          return n;
        }
        _getCharacterGroupListItemDefinitions(e, t) {
          const i = new xs();
          for (const n of t) {
            const t = {
              type: 'button',
              model: new MT({ label: n, withText: true }),
            };
            t.model.bind('isOn').to(e, 'value', (e) => e === t.model.label);
            i.add(t);
          }
          return i;
        }
      }
      var FI = i(116);
      class HI extends Hb {
        constructor(e) {
          super(e);
          this.tiles = this.createCollection();
          this.setTemplate({
            tag: 'div',
            children: [
              {
                tag: 'div',
                attributes: { class: ['ck', 'ck-character-grid__tiles'] },
                children: this.tiles,
              },
            ],
            attributes: { class: ['ck', 'ck-character-grid'] },
          });
        }
        createTile(e, t) {
          const i = new Ew(this.locale);
          i.set({ label: e, withText: true, class: 'ck-character-grid__tile' });
          i.extendTemplate({
            attributes: { title: t },
            on: { mouseover: i.bindTemplate.to('mouseover') },
          });
          i.on('mouseover', () => {
            this.fire('tileHover', { name: t, character: e });
          });
          i.on('execute', () => {
            this.fire('execute', { name: t, character: e });
          });
          return i;
        }
      }
      var UI = i(118);
      class qI extends Hb {
        constructor(e) {
          super(e);
          const t = this.bindTemplate;
          this.set('character', null);
          this.set('name', null);
          this.bind('code').to(this, 'character', WI);
          this.setTemplate({
            tag: 'div',
            children: [
              {
                tag: 'span',
                attributes: { class: ['ck-character-info__name'] },
                children: [{ text: t.to('name', (e) => (e ? e : '​')) }],
              },
              {
                tag: 'span',
                attributes: { class: ['ck-character-info__code'] },
                children: [{ text: t.to('code') }],
              },
            ],
            attributes: { class: ['ck', 'ck-character-info'] },
          });
        }
      }
      function WI(e) {
        if (e === null) {
          return '';
        }
        const t = e.codePointAt(0).toString(16);
        return 'U+' + ('0000' + t).slice(-4);
      }
      var $I =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10 2.5a7.47 7.47 0 0 1 4.231 1.31 7.268 7.268 0 0 1 2.703 3.454 7.128 7.128 0 0 1 .199 4.353c-.39 1.436-1.475 2.72-2.633 3.677h2.013c0-.226.092-.443.254-.603a.876.876 0 0 1 1.229 0c.163.16.254.377.254.603v.853c0 .209-.078.41-.22.567a.873.873 0 0 1-.547.28l-.101.006h-4.695a.517.517 0 0 1-.516-.518v-1.265c0-.21.128-.398.317-.489a5.601 5.601 0 0 0 2.492-2.371 5.459 5.459 0 0 0 .552-3.693 5.53 5.53 0 0 0-1.955-3.2A5.71 5.71 0 0 0 10 4.206 5.708 5.708 0 0 0 6.419 5.46 5.527 5.527 0 0 0 4.46 8.663a5.457 5.457 0 0 0 .554 3.695 5.6 5.6 0 0 0 2.497 2.37.55.55 0 0 1 .317.49v1.264c0 .286-.23.518-.516.518H2.618a.877.877 0 0 1-.614-.25.845.845 0 0 1-.254-.603v-.853c0-.226.091-.443.254-.603a.876.876 0 0 1 1.228 0c.163.16.255.377.255.603h1.925c-1.158-.958-2.155-2.241-2.545-3.678a7.128 7.128 0 0 1 .199-4.352 7.268 7.268 0 0 1 2.703-3.455A7.475 7.475 0 0 1 10 2.5z"/></svg>';
      var GI = i(120);
      const YI = 'All';
      class KI extends ok {
        static get requires() {
          return [Ux];
        }
        static get pluginName() {
          return 'SpecialCharacters';
        }
        constructor(e) {
          super(e);
          this._characters = new Map();
          this._groups = new Map();
        }
        init() {
          const e = this.editor;
          const t = e.t;
          const i = e.commands.get('input');
          e.ui.componentFactory.add('specialCharacters', (n) => {
            const o = Bw(n);
            let r;
            o.buttonView.set({
              label: t('Special characters'),
              icon: $I,
              tooltip: true,
            });
            o.bind('isEnabled').to(i);
            o.on('execute', (t, i) => {
              e.execute('input', { text: i.character });
              e.editing.view.focus();
            });
            o.on('change:isOpen', () => {
              if (!r) {
                r = this._createDropdownPanelContent(n, o);
                o.panelView.children.add(r.navigationView);
                o.panelView.children.add(r.gridView);
                o.panelView.children.add(r.infoView);
              }
              r.infoView.set({ character: null, name: null });
            });
            return o;
          });
        }
        addItems(e, t) {
          if (e === YI) {
            throw new ss['b'](
              `special-character-invalid-group-name: The name "${YI}" is reserved and cannot be used.`
            );
          }
          const i = this._getGroup(e);
          for (const e of t) {
            i.add(e.title);
            this._characters.set(e.title, e.character);
          }
        }
        getGroups() {
          return this._groups.keys();
        }
        getCharactersForGroup(e) {
          if (e === YI) {
            return new Set(this._characters.keys());
          }
          return this._groups.get(e);
        }
        getCharacter(e) {
          return this._characters.get(e);
        }
        _getGroup(e) {
          if (!this._groups.has(e)) {
            this._groups.set(e, new Set());
          }
          return this._groups.get(e);
        }
        _updateGrid(e, t) {
          t.tiles.clear();
          const i = this.getCharactersForGroup(e);
          for (const e of i) {
            const i = this.getCharacter(e);
            t.tiles.add(t.createTile(i, e));
          }
        }
        _createDropdownPanelContent(e, t) {
          const i = [...this.getGroups()];
          i.unshift(YI);
          const n = new BI(e, i);
          const o = new HI(e);
          const r = new qI(e);
          o.delegate('execute').to(t);
          o.on('tileHover', (e, t) => {
            r.set(t);
          });
          n.on('execute', () => {
            this._updateGrid(n.currentGroupName, o);
          });
          this._updateGrid(n.currentGroupName, o);
          return { navigationView: n, gridView: o, infoView: r };
        }
      }
      class QI extends ok {
        init() {
          const e = this.editor;
          const t = e.t;
          e.plugins.get('SpecialCharacters').addItems('Currency', [
            { character: '$', title: t('Dollar sign') },
            { character: '€', title: t('Euro sign') },
            { character: '¥', title: t('Yen sign') },
            { character: '£', title: t('Pound sign') },
            { character: '¢', title: t('Cent sign') },
            { character: '₠', title: t('Euro-currency sign') },
            { character: '₡', title: t('Colon sign') },
            { character: '₢', title: t('Cruzeiro sign') },
            { character: '₣', title: t('French franc sign') },
            { character: '₤', title: t('Lira sign') },
            { character: '¤', title: t('Currency sign') },
            { character: '₿', title: t('Bitcoin sign') },
            { character: '₥', title: t('Mill sign') },
            { character: '₦', title: t('Naira sign') },
            { character: '₧', title: t('Peseta sign') },
            { character: '₨', title: t('Rupee sign') },
            { character: '₩', title: t('Won sign') },
            { character: '₪', title: t('New sheqel sign') },
            { character: '₫', title: t('Dong sign') },
            { character: '₭', title: t('Kip sign') },
            { character: '₮', title: t('Tugrik sign') },
            { character: '₯', title: t('Drachma sign') },
            { character: '₰', title: t('German penny sign') },
            { character: '₱', title: t('Peso sign') },
            { character: '₲', title: t('Guarani sign') },
            { character: '₳', title: t('Austral sign') },
            { character: '₴', title: t('Hryvnia sign') },
            { character: '₵', title: t('Cedi sign') },
            { character: '₶', title: t('Livre tournois sign') },
            { character: '₷', title: t('Spesmilo sign') },
            { character: '₸', title: t('Tenge sign') },
            { character: '₹', title: t('Indian rupee sign') },
            { character: '₺', title: t('Turkish lira sign') },
            { character: '₻', title: t('Nordic mark sign') },
            { character: '₼', title: t('Manat sign') },
            { character: '₽', title: t('Ruble sign') },
          ]);
        }
      }
      const JI = 'strikethrough';
      class ZI extends ok {
        static get pluginName() {
          return 'StrikethroughEditing';
        }
        init() {
          const e = this.editor;
          e.model.schema.extend('$text', { allowAttributes: JI });
          e.model.schema.setAttributeProperties(JI, {
            isFormatting: true,
            copyOnEnter: true,
          });
          e.conversion.attributeToElement({
            model: JI,
            view: 's',
            upcastAlso: [
              'del',
              'strike',
              { styles: { 'text-decoration': 'line-through' } },
            ],
          });
          e.commands.add(JI, new e_(e, JI));
          e.keystrokes.set('CTRL+SHIFT+X', 'strikethrough');
        }
      }
      var XI =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 16.4c-.8-.4-1.5-.9-2.2-1.5a.6.6 0 0 1-.2-.5l.3-.6h1c1 1.2 2.1 1.7 3.7 1.7 1 0 1.8-.3 2.3-.6.6-.4.6-1.2.6-1.3.2-1.2-.9-2.1-.9-2.1h2.1c.3.7.4 1.2.4 1.7v.8l-.6 1.2c-.6.8-1.1 1-1.6 1.2a6 6 0 0 1-2.4.6c-1 0-1.8-.3-2.5-.6zM6.8 9L6 8.3c-.4-.5-.5-.8-.5-1.6 0-.7.1-1.3.5-1.8.4-.6 1-1 1.6-1.3a6.3 6.3 0 0 1 4.7 0 4 4 0 0 1 1.7 1l.3.7c0 .1.2.4-.2.7-.4.2-.9.1-1 0a3 3 0 0 0-1.2-1c-.4-.2-1-.3-2-.4-.7 0-1.4.2-2 .6-.8.6-1 .8-1 1.5 0 .8.5 1 1.2 1.5.6.4 1.1.7 1.9 1H6.8z"/><path d="M3 10.5V9h14v1.5z"/></svg>';
      const eN = 'strikethrough';
      class tN extends ok {
        init() {
          const e = this.editor;
          const t = e.t;
          e.ui.componentFactory.add(eN, (i) => {
            const n = e.commands.get(eN);
            const o = new Ew(i);
            o.set({
              label: t('Strikethrough'),
              icon: XI,
              keystroke: 'CTRL+SHIFT+X',
              tooltip: true,
              isToggleable: true,
            });
            o.bind('isOn', 'isEnabled').to(n, 'value', 'isEnabled');
            this.listenTo(o, 'execute', () => {
              e.execute(eN);
              e.editing.view.focus();
            });
            return o;
          });
        }
      }
      class iN extends ok {
        static get requires() {
          return [ZI, tN];
        }
        static get pluginName() {
          return 'Strikethrough';
        }
      }
      const nN = 'subscript';
      class oN extends ok {
        static get pluginName() {
          return 'SubscriptEditing';
        }
        init() {
          const e = this.editor;
          e.model.schema.extend('$text', { allowAttributes: nN });
          e.model.schema.setAttributeProperties(nN, {
            isFormatting: true,
            copyOnEnter: true,
          });
          e.conversion.attributeToElement({
            model: nN,
            view: 'sub',
            upcastAlso: [{ styles: { 'vertical-align': 'sub' } }],
          });
          e.commands.add(nN, new e_(e, nN));
        }
      }
      var rN =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7.03 10.349l3.818-3.819a.8.8 0 1 1 1.132 1.132L8.16 11.48l3.819 3.818a.8.8 0 1 1-1.132 1.132L7.03 12.61l-3.818 3.82a.8.8 0 1 1-1.132-1.132L5.9 11.48 2.08 7.662A.8.8 0 1 1 3.212 6.53l3.818 3.82zm8.147 7.829h2.549c.254 0 .447.05.58.152a.49.49 0 0 1 .201.413.54.54 0 0 1-.159.393c-.105.108-.266.162-.48.162h-3.594c-.245 0-.435-.066-.572-.197a.621.621 0 0 1-.205-.463c0-.114.044-.265.132-.453a1.62 1.62 0 0 1 .288-.444c.433-.436.824-.81 1.172-1.122.348-.312.597-.517.747-.615.267-.183.49-.368.667-.553.177-.185.312-.375.405-.57.093-.194.139-.384.139-.57a1.008 1.008 0 0 0-.554-.917 1.197 1.197 0 0 0-.56-.133c-.426 0-.761.182-1.005.546a2.332 2.332 0 0 0-.164.39 1.609 1.609 0 0 1-.258.488c-.096.114-.237.17-.423.17a.558.558 0 0 1-.405-.156.568.568 0 0 1-.161-.427c0-.218.05-.446.151-.683.101-.238.252-.453.452-.646s.454-.349.762-.467a2.998 2.998 0 0 1 1.081-.178c.498 0 .923.076 1.274.228a1.916 1.916 0 0 1 1.004 1.032 1.984 1.984 0 0 1-.156 1.794c-.2.32-.405.572-.613.754-.208.182-.558.468-1.048.857-.49.39-.826.691-1.008.906a2.703 2.703 0 0 0-.24.309z"/></svg>';
      const sN = 'subscript';
      class aN extends ok {
        init() {
          const e = this.editor;
          const t = e.t;
          e.ui.componentFactory.add(sN, (i) => {
            const n = e.commands.get(sN);
            const o = new Ew(i);
            o.set({
              label: t('Subscript'),
              icon: rN,
              tooltip: true,
              isToggleable: true,
            });
            o.bind('isOn', 'isEnabled').to(n, 'value', 'isEnabled');
            this.listenTo(o, 'execute', () => {
              e.execute(sN);
              e.editing.view.focus();
            });
            return o;
          });
        }
      }
      class cN extends ok {
        static get requires() {
          return [oN, aN];
        }
        static get pluginName() {
          return 'Subscript';
        }
      }
      const lN = 'superscript';
      class dN extends ok {
        static get pluginName() {
          return 'SuperscriptEditing';
        }
        init() {
          const e = this.editor;
          e.model.schema.extend('$text', { allowAttributes: lN });
          e.model.schema.setAttributeProperties(lN, {
            isFormatting: true,
            copyOnEnter: true,
          });
          e.conversion.attributeToElement({
            model: lN,
            view: 'sup',
            upcastAlso: [{ styles: { 'vertical-align': 'super' } }],
          });
          e.commands.add(lN, new e_(e, lN));
        }
      }
      var uN =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M15.677 8.678h2.549c.254 0 .447.05.58.152a.49.49 0 0 1 .201.413.54.54 0 0 1-.159.393c-.105.108-.266.162-.48.162h-3.594c-.245 0-.435-.066-.572-.197a.621.621 0 0 1-.205-.463c0-.114.044-.265.132-.453a1.62 1.62 0 0 1 .288-.444c.433-.436.824-.81 1.172-1.122.348-.312.597-.517.747-.615.267-.183.49-.368.667-.553.177-.185.312-.375.405-.57.093-.194.139-.384.139-.57a1.008 1.008 0 0 0-.554-.917 1.197 1.197 0 0 0-.56-.133c-.426 0-.761.182-1.005.546a2.332 2.332 0 0 0-.164.39 1.609 1.609 0 0 1-.258.488c-.096.114-.237.17-.423.17a.558.558 0 0 1-.405-.156.568.568 0 0 1-.161-.427c0-.218.05-.446.151-.683.101-.238.252-.453.452-.646s.454-.349.762-.467a2.998 2.998 0 0 1 1.081-.178c.498 0 .923.076 1.274.228a1.916 1.916 0 0 1 1.004 1.032 1.984 1.984 0 0 1-.156 1.794c-.2.32-.405.572-.613.754-.208.182-.558.468-1.048.857-.49.39-.826.691-1.008.906a2.703 2.703 0 0 0-.24.309zM7.03 10.349l3.818-3.819a.8.8 0 1 1 1.132 1.132L8.16 11.48l3.819 3.818a.8.8 0 1 1-1.132 1.132L7.03 12.61l-3.818 3.82a.8.8 0 1 1-1.132-1.132L5.9 11.48 2.08 7.662A.8.8 0 1 1 3.212 6.53l3.818 3.82z"/></svg>';
      const hN = 'superscript';
      class fN extends ok {
        init() {
          const e = this.editor;
          const t = e.t;
          e.ui.componentFactory.add(hN, (i) => {
            const n = e.commands.get(hN);
            const o = new Ew(i);
            o.set({
              label: t('Superscript'),
              icon: uN,
              tooltip: true,
              isToggleable: true,
            });
            o.bind('isOn', 'isEnabled').to(n, 'value', 'isEnabled');
            this.listenTo(o, 'execute', () => {
              e.execute(hN);
              e.editing.view.focus();
            });
            return o;
          });
        }
      }
      class gN extends ok {
        static get requires() {
          return [dN, fN];
        }
        static get pluginName() {
          return 'Superscript';
        }
      }
      var mN = /[\\^$.*+?()[\]{}|]/g,
        pN = RegExp(mN.source);
      function bN(e) {
        e = va(e);
        return e && pN.test(e) ? e.replace(mN, '\\$&') : e;
      }
      var wN = bN;
      const kN = {
        copyright: { from: '(c)', to: '©' },
        registeredTrademark: { from: '(r)', to: '®' },
        trademark: { from: '(tm)', to: '™' },
        oneHalf: { from: '1/2', to: '½' },
        oneThird: { from: '1/3', to: '⅓' },
        twoThirds: { from: '2/3', to: '⅔' },
        oneForth: { from: '1/4', to: '¼' },
        threeQuarters: { from: '3/4', to: '¾' },
        lessThanOrEqual: { from: '<=', to: '≤' },
        greaterThanOrEqual: { from: '>=', to: '≥' },
        notEqual: { from: '!=', to: '≠' },
        arrowLeft: { from: '<-', to: '←' },
        arrowRight: { from: '->', to: '→' },
        horizontalEllipsis: { from: '...', to: '…' },
        enDash: { from: /(^| )(--)( )$/, to: [null, '–', null] },
        emDash: { from: /(^| )(---)( )$/, to: [null, '—', null] },
        quotesPrimary: { from: CN('"'), to: [null, '“', null, '”'] },
        quotesSecondary: { from: CN("'"), to: [null, '‘', null, '’'] },
        quotesPrimaryEnGb: { from: CN("'"), to: [null, '‘', null, '’'] },
        quotesSecondaryEnGb: { from: CN('"'), to: [null, '“', null, '”'] },
        quotesPrimaryPl: { from: CN('"'), to: [null, '„', null, '”'] },
        quotesSecondaryPl: { from: CN("'"), to: [null, '‚', null, '’'] },
      };
      const _N = {
        symbols: ['copyright', 'registeredTrademark', 'trademark'],
        mathematical: [
          'oneHalf',
          'oneThird',
          'twoThirds',
          'oneForth',
          'threeQuarters',
          'lessThanOrEqual',
          'greaterThanOrEqual',
          'notEqual',
          'arrowLeft',
          'arrowRight',
        ],
        typography: ['horizontalEllipsis', 'enDash', 'emDash'],
        quotes: ['quotesPrimary', 'quotesSecondary'],
      };
      const vN = ['symbols', 'mathematical', 'typography', 'quotes'];
      class yN extends ok {
        static get pluginName() {
          return 'TextTransformation';
        }
        constructor(e) {
          super(e);
          e.config.define('typing', { transformations: { include: vN } });
        }
        init() {
          const e = this.editor.model;
          const t = e.document.selection;
          t.on('change:range', () => {
            this.isEnabled = !t.anchor.parent.is('element', 'codeBlock');
          });
          this._enableTransformationWatchers();
        }
        _enableTransformationWatchers() {
          const e = this.editor;
          const t = e.model;
          const i = e.plugins.get('Input');
          const n = PN(e.config.get('typing.transformations'));
          const o = (e) => {
            for (const t of n) {
              const i = t.from;
              const n = i.test(e);
              if (n) {
                return { normalizedTransformation: t };
              }
            }
          };
          const r = (e, n) => {
            if (!i.isInput(n.batch)) {
              return;
            }
            const { from: o, to: r } = n.normalizedTransformation;
            const s = o.exec(n.text);
            const a = r(s.slice(1));
            const c = n.range;
            let l = s.index;
            t.enqueueChange((e) => {
              for (let i = 1; i < s.length; i++) {
                const n = s[i];
                const o = a[i - 1];
                if (o == null) {
                  l += n.length;
                  continue;
                }
                const r = c.start.getShiftedBy(l);
                const d = t.createRange(r, r.getShiftedBy(n.length));
                const u = TN(r);
                t.insertContent(e.createText(o, u), d);
                l += o.length;
              }
            });
          };
          const s = new Nk(e.model, o);
          s.on('matched:data', r);
          s.bind('isEnabled').to(this);
        }
      }
      function xN(e) {
        if (typeof e == 'string') {
          return new RegExp(`(${wN(e)})$`);
        }
        return e;
      }
      function AN(e) {
        if (typeof e == 'string') {
          return () => [e];
        } else if (e instanceof Array) {
          return () => e;
        }
        return e;
      }
      function TN(e) {
        const t = e.textNode ? e.textNode : e.nodeAfter;
        return t.getAttributes();
      }
      function CN(e) {
        return new RegExp(`(^|\\s)(${e})([^${e}]*)(${e})$`);
      }
      function PN(e) {
        const t = e.extra || [];
        const i = e.remove || [];
        const n = (e) => !i.includes(e);
        const o = e.include.concat(t).filter(n);
        return EN(o)
          .filter(n)
          .map((e) => kN[e] || e)
          .map((e) => ({ from: xN(e.from), to: AN(e.to) }));
      }
      function EN(e) {
        const t = new Set();
        for (const i of e) {
          if (_N[i]) {
            for (const e of _N[i]) {
              t.add(e);
            }
          } else {
            t.add(i);
          }
        }
        return Array.from(t);
      }
      const SN = 'underline';
      class MN extends ok {
        static get pluginName() {
          return 'UnderlineEditing';
        }
        init() {
          const e = this.editor;
          e.model.schema.extend('$text', { allowAttributes: SN });
          e.model.schema.setAttributeProperties(SN, {
            isFormatting: true,
            copyOnEnter: true,
          });
          e.conversion.attributeToElement({
            model: SN,
            view: 'u',
            upcastAlso: { styles: { 'text-decoration': 'underline' } },
          });
          e.commands.add(SN, new e_(e, SN));
          e.keystrokes.set('CTRL+U', 'underline');
        }
      }
      var IN =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 18v-1.5h14V18zm2.2-8V3.6c0-.4.4-.6.8-.6.3 0 .7.2.7.6v6.2c0 2 1.3 2.8 3.2 2.8 1.9 0 3.4-.9 3.4-2.9V3.6c0-.3.4-.5.8-.5.3 0 .7.2.7.5V10c0 2.7-2.2 4-4.9 4-2.6 0-4.7-1.2-4.7-4z"/></svg>';
      const NN = 'underline';
      class ON extends ok {
        init() {
          const e = this.editor;
          const t = e.t;
          e.ui.componentFactory.add(NN, (i) => {
            const n = e.commands.get(NN);
            const o = new Ew(i);
            o.set({
              label: t('Underline'),
              icon: IN,
              keystroke: 'CTRL+U',
              tooltip: true,
              isToggleable: true,
            });
            o.bind('isOn', 'isEnabled').to(n, 'value', 'isEnabled');
            this.listenTo(o, 'execute', () => {
              e.execute(NN);
              e.editing.view.focus();
            });
            return o;
          });
        }
      }
      class zN extends ok {
        static get requires() {
          return [MN, ON];
        }
        static get pluginName() {
          return 'Underline';
        }
      }
      function RN(e) {
        if (e.is('$text') || e.is('$textProxy')) {
          return e.data;
        }
        let t = '';
        let i = null;
        for (const n of e.getChildren()) {
          const e = RN(n);
          if (i && i.is('element')) {
            t += '\n';
          }
          t += e;
          i = n;
        }
        return t;
      }
      class LN extends ok {
        constructor(e) {
          super(e);
          this.set('characters', 0);
          this.set('words', 0);
          Object.defineProperties(this, {
            characters: {
              get() {
                return (this.characters = this._getCharacters());
              },
            },
            words: {
              get() {
                return (this.words = this._getWords());
              },
            },
          });
          this.set('_wordsLabel');
          this.set('_charactersLabel');
          this._config = e.config.get('wordCount') || {};
          this._outputView;
          this._wordsMatchRegExp = Cl.features.isRegExpUnicodePropertySupported
            ? new RegExp('[\\p{L}\\p{N}\\p{M}\\p{Pd}\\p{Pc}]+', 'gu')
            : /[_\-a-zA-Z0-9À-ž]+/gu;
        }
        static get pluginName() {
          return 'WordCount';
        }
        init() {
          const e = this.editor;
          e.model.document.on(
            'change:data',
            WP(this._refreshStats.bind(this), 250)
          );
          if (typeof this._config.onUpdate == 'function') {
            this.on('update', (e, t) => {
              this._config.onUpdate(t);
            });
          }
          if (Yr(this._config.container)) {
            this._config.container.appendChild(this.wordCountContainer);
          }
        }
        destroy() {
          if (this._outputView) {
            this._outputView.element.remove();
            this._outputView.destroy();
          }
          super.destroy();
        }
        get wordCountContainer() {
          const e = this.editor;
          const t = e.t;
          const i = e.config.get('wordCount.displayWords');
          const n = e.config.get('wordCount.displayCharacters');
          const o = mb.bind(this, this);
          const r = [];
          if (!this._outputView) {
            this._outputView = new Hb();
            if (i || i === undefined) {
              this.bind('_wordsLabel').to(this, 'words', (e) =>
                t('Words: %0', [e])
              );
              r.push({
                tag: 'div',
                children: [{ text: [o.to('_wordsLabel')] }],
                attributes: { class: 'ck-word-count__words' },
              });
            }
            if (n || n === undefined) {
              this.bind('_charactersLabel').to(this, 'characters', (e) =>
                t('Characters: %0', [e])
              );
              r.push({
                tag: 'div',
                children: [{ text: [o.to('_charactersLabel')] }],
                attributes: { class: 'ck-word-count__characters' },
              });
            }
            this._outputView.setTemplate({
              tag: 'div',
              attributes: { class: ['ck', 'ck-word-count'] },
              children: r,
            });
            this._outputView.render();
          }
          return this._outputView.element;
        }
        _getCharacters() {
          const e = RN(this.editor.model.document.getRoot());
          return e.replace(/\n/g, '').length;
        }
        _getWords() {
          const e = RN(this.editor.model.document.getRoot());
          const t = e.match(this._wordsMatchRegExp) || [];
          return t.length;
        }
        _refreshStats() {
          const e = (this.words = this._getWords());
          const t = (this.characters = this._getCharacters());
          this.fire('update', { words: e, characters: t });
        }
      }
      function VN(e, t = new Set()) {
        const i = [e];
        const n = new Set();
        while (i.length > 0) {
          const e = i.shift();
          if (n.has(e) || DN(e) || t.has(e)) {
            continue;
          }
          n.add(e);
          if (e[Symbol.iterator]) {
            try {
              for (const t of e) {
                i.push(t);
              }
            } catch (e) {}
          } else {
            for (const t in e) {
              if (t === 'defaultValue') {
                continue;
              }
              i.push(e[t]);
            }
          }
        }
        return n;
      }
      function DN(e) {
        const t = Object.prototype.toString.call(e);
        const i = typeof e;
        return (
          i === 'number' ||
          i === 'boolean' ||
          i === 'string' ||
          i === 'symbol' ||
          i === 'function' ||
          t === '[object Date]' ||
          t === '[object RegExp]' ||
          t === '[object Module]' ||
          e === undefined ||
          e === null ||
          e instanceof EventTarget ||
          e instanceof Event
        );
      }
      function jN(e, t, i = new Set()) {
        if (e === t && FN(e)) {
          return true;
        }
        const n = VN(e, i);
        const o = VN(t, i);
        for (const e of n) {
          if (o.has(e)) {
            return true;
          }
        }
        return false;
      }
      function BN(e, t, i) {
        const { subNodes: n, prevNodeMap: o } = VN(e, i.subNodes);
        const { subNodes: r, prevNodeMap: s } = VN(t, i.subNodes);
        for (const i of n) {
          if (r.has(i)) {
            const n = [];
            n.push(i);
            let r = o.get(i);
            while (r && r !== e) {
              n.push(r);
              r = o.get(r);
            }
            r = s.get(i);
            while (r && r !== t) {
              n.unshift(r);
              r = s.get(r);
            }
            console.log('--------');
            console.log({ target1: e });
            console.log({ sharedNode: i });
            console.log({ target2: t });
            console.log({ connection: n });
            return true;
          }
        }
        return false;
      }
      function FN(e) {
        return typeof e === 'object' && e !== null;
      }
      class HN {
        constructor(e) {
          this.crashes = [];
          this.state = 'initializing';
          this._crashNumberLimit =
            typeof e.crashNumberLimit === 'number' ? e.crashNumberLimit : 3;
          this._now = Date.now;
          this._minimumNonErrorTimePeriod =
            typeof e.minimumNonErrorTimePeriod === 'number'
              ? e.minimumNonErrorTimePeriod
              : 5e3;
          this._boundErrorHandler = (e) => {
            const t = e.error || e.reason;
            if (t instanceof Error) {
              this._handleError(t, e);
            }
          };
          this._listeners = {};
          if (!this._restart) {
            throw new Error(
              'The Watchdog class was split into the abstract `Watchdog` class and the `EditorWatchdog` class. ' +
                'Please, use `EditorWatchdog` if you have used the `Watchdog` class previously.'
            );
          }
        }
        setCreator(e) {
          this._creator = e;
        }
        setDestructor(e) {
          this._destructor = e;
        }
        destroy() {
          this._stopErrorHandling();
          this._listeners = {};
        }
        on(e, t) {
          if (!this._listeners[e]) {
            this._listeners[e] = [];
          }
          this._listeners[e].push(t);
        }
        off(e, t) {
          this._listeners[e] = this._listeners[e].filter((e) => e !== t);
        }
        _fire(e, ...t) {
          const i = this._listeners[e] || [];
          for (const e of i) {
            e.apply(this, [null, ...t]);
          }
        }
        _startErrorHandling() {
          window.addEventListener('error', this._boundErrorHandler);
          window.addEventListener(
            'unhandledrejection',
            this._boundErrorHandler
          );
        }
        _stopErrorHandling() {
          window.removeEventListener('error', this._boundErrorHandler);
          window.removeEventListener(
            'unhandledrejection',
            this._boundErrorHandler
          );
        }
        _handleError(e, t) {
          if (this._shouldReactToError(e)) {
            this.crashes.push({
              message: e.message,
              stack: e.stack,
              filename: t.filename,
              lineno: t.lineno,
              colno: t.colno,
              date: this._now(),
            });
            const i = this._shouldRestart();
            this.state = 'crashed';
            this._fire('stateChange');
            this._fire('error', { error: e, causesRestart: i });
            if (i) {
              this._restart();
            } else {
              this.state = 'crashedPermanently';
              this._fire('stateChange');
            }
          }
        }
        _shouldReactToError(e) {
          return (
            e.is &&
            e.is('CKEditorError') &&
            e.context !== undefined &&
            e.context !== null &&
            this.state === 'ready' &&
            this._isErrorComingFromThisItem(e)
          );
        }
        _shouldRestart() {
          if (this.crashes.length <= this._crashNumberLimit) {
            return true;
          }
          const e = this.crashes[this.crashes.length - 1].date;
          const t =
            this.crashes[this.crashes.length - 1 - this._crashNumberLimit].date;
          const i = (e - t) / this._crashNumberLimit;
          return i > this._minimumNonErrorTimePeriod;
        }
      }
      class UN extends HN {
        constructor(e, t = {}) {
          super(t);
          this._editor = null;
          this._throttledSave = WP(
            this._save.bind(this),
            typeof t.saveInterval === 'number' ? t.saveInterval : 5e3
          );
          this._creator = (t, i) => e.create(t, i);
          this._destructor = (e) => e.destroy();
        }
        get editor() {
          return this._editor;
        }
        get _item() {
          return this._editor;
        }
        _restart() {
          return Promise.resolve()
            .then(() => {
              this.state = 'initializing';
              this._fire('stateChange');
              return this._destroy();
            })
            .catch((e) => {
              console.error(
                'An error happened during the editor destroying.',
                e
              );
            })
            .then(() => {
              if (typeof this._elementOrData === 'string') {
                return this.create(
                  this._data,
                  this._config,
                  this._config.context
                );
              } else {
                const e = Object.assign({}, this._config, {
                  initialData: this._data,
                });
                return this.create(this._elementOrData, e, e.context);
              }
            })
            .then(() => {
              this._fire('restart');
            });
        }
        create(e = this._elementOrData, t = this._config, i) {
          return Promise.resolve()
            .then(() => {
              super._startErrorHandling();
              this._elementOrData = e;
              this._config = this._cloneEditorConfiguration(t) || {};
              this._config.context = i;
              return this._creator(e, this._config);
            })
            .then((e) => {
              this._editor = e;
              e.model.document.on('change:data', this._throttledSave);
              this._lastDocumentVersion = e.model.document.version;
              this._data = this._getData();
              this.state = 'ready';
              this._fire('stateChange');
            });
        }
        destroy() {
          return Promise.resolve().then(() => {
            this.state = 'destroyed';
            this._fire('stateChange');
            super.destroy();
            return this._destroy();
          });
        }
        _destroy() {
          return Promise.resolve().then(() => {
            this._stopErrorHandling();
            this._throttledSave.flush();
            const e = this._editor;
            this._editor = null;
            return this._destructor(e);
          });
        }
        _save() {
          const e = this._editor.model.document.version;
          if (e === this._lastDocumentVersion) {
            return;
          }
          try {
            this._data = this._getData();
            this._lastDocumentVersion = e;
          } catch (e) {
            console.error(
              e,
              'An error happened during restoring editor data. ' +
                'Editor will be restored from the previously saved data.'
            );
          }
        }
        _setExcludedProperties(e) {
          this._excludedProps = e;
        }
        _getData() {
          const e = {};
          for (const t of this._editor.model.document.getRootNames()) {
            e[t] = this._editor.data.get({ rootName: t });
          }
          return e;
        }
        _isErrorComingFromThisItem(e) {
          return jN(this._editor, e.context, this._excludedProps);
        }
        _cloneEditorConfiguration(e) {
          return $r(e, (e, t) => {
            if (Yr(e)) {
              return e;
            }
            if (t === 'context') {
              return e;
            }
          });
        }
      }
      class qN extends ik {}
      qN.builtinPlugins = [
        Ak,
        Sk,
        Vk,
        qk,
        Xk,
        s_,
        hx,
        dx,
        _x,
        fA,
        gT,
        kT,
        RT,
        GT,
        rC,
        pC,
        dP,
        yP,
        QP,
        fE,
        wE,
        iS,
        cS,
        gS,
        ES,
        hM,
        VM,
        sI,
        aI,
        VI,
        jT,
        KI,
        QI,
        iN,
        cN,
        gN,
        yN,
        zN,
        LN,
      ];
      var WN = (t['default'] = { Editor: qN, Watchdog: UN });
    },
  ])['default'];
});
//# sourceMappingURL=ckeditor.js.map
